function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire028f"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire028f"] = parcelRequire;
}
parcelRequire.register("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRequire.register("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRequire.register("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRequire.register("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRequire.register("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));




var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;




var $acw62 = parcelRequire("acw62");
//Change the name in MovieList


var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $0522fa2e4977c358$var$_excluded = [
    "as",
    "disabled"
];
function $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0522fa2e4977c358$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
function $0522fa2e4977c358$export$a0ee72f2c720a5c3({ tagName: tagName , disabled: disabled , href: href , target: target , rel: rel , role: role , onClick: onClick , tabIndex: tabIndex = 0 , type: type  }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = "a";
        else tagName = "button";
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === "button") return [
        {
            type: type || "button",
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === "a" && $0522fa2e4977c358$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === " ") {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === "a") {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = "#");
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : "button",
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === "a" ? target : undefined,
            "aria-disabled": !disabled ? undefined : disabled,
            rel: tagName === "a" ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $0522fa2e4977c358$var$Button = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { as: asProp , disabled: disabled  } = _ref, props = $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(_ref, $0522fa2e4977c358$var$_excluded);
    const [buttonProps, { tagName: Component  }] = $0522fa2e4977c358$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$0522fa2e4977c358$var$Button.displayName = "Button";
var $0522fa2e4977c358$export$2e2bcd8739ae039 = $0522fa2e4977c358$var$Button;



var $acw62 = parcelRequire("acw62");

const $626bd95fa485b758$export$666ad80b5007f835 = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
const $626bd95fa485b758$export$ff817e17bad2e091 = "xs";
const $626bd95fa485b758$var$ThemeContext = /*#__PURE__*/ $acw62.createContext({
    prefixes: {},
    breakpoints: $626bd95fa485b758$export$666ad80b5007f835,
    minBreakpoint: $626bd95fa485b758$export$ff817e17bad2e091
});
const { Consumer: $626bd95fa485b758$export$b631efc24e9d5e2f , Provider: $626bd95fa485b758$var$Provider  } = $626bd95fa485b758$var$ThemeContext;
function $626bd95fa485b758$var$ThemeProvider({ prefixes: prefixes = {} , breakpoints: breakpoints = $626bd95fa485b758$export$666ad80b5007f835 , minBreakpoint: minBreakpoint = $626bd95fa485b758$export$ff817e17bad2e091 , dir: dir , children: children  }) {
    const contextValue = (0, $acw62.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($626bd95fa485b758$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $626bd95fa485b758$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes  } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $626bd95fa485b758$export$8970c8db816a5863() {
    const { breakpoints: breakpoints  } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return breakpoints;
}
function $626bd95fa485b758$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint  } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return minBreakpoint;
}
function $626bd95fa485b758$export$35e511eefa30ac5a() {
    const { dir: dir  } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return dir === "rtl";
}
function $626bd95fa485b758$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix , forwardRefAs: forwardRefAs = isClassy ? "ref" : "innerRef"  } = opts;
    const Wrapped = /*#__PURE__*/ $acw62.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $626bd95fa485b758$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $626bd95fa485b758$export$2e2bcd8739ae039 = $626bd95fa485b758$var$ThemeProvider;



const $4ed343d4b409b2f2$var$Button = /*#__PURE__*/ $acw62.forwardRef(({ as: as , bsPrefix: bsPrefix , variant: variant = "primary" , size: size , active: active = false , disabled: disabled = false , className: className , ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "btn");
    const [buttonProps, { tagName: tagName  }] = (0, $0522fa2e4977c358$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, active && "active", variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && "disabled")
    });
});
$4ed343d4b409b2f2$var$Button.displayName = "Button";
var $4ed343d4b409b2f2$export$2e2bcd8739ae039 = $4ed343d4b409b2f2$var$Button;



var $acw62 = parcelRequire("acw62");


var $8839e0a7e6f8b9c7$var$rHyphen = /-(.)/g;
function $8839e0a7e6f8b9c7$export$2e2bcd8739ae039(string) {
    return string.replace($8839e0a7e6f8b9c7$var$rHyphen, function(_, chr) {
        return chr.toUpperCase();
    });
}



var $acw62 = parcelRequire("acw62");


const $140532fd91d84ddb$var$pascalCase = (str)=>str[0].toUpperCase() + (0, $8839e0a7e6f8b9c7$export$2e2bcd8739ae039)(str).slice(1);
function $140532fd91d84ddb$export$2e2bcd8739ae039(prefix, { displayName: displayName = $140532fd91d84ddb$var$pascalCase(prefix) , Component: Component , defaultProps: defaultProps  } = {}) {
    const BsComponent = /*#__PURE__*/ $acw62.forwardRef(({ className: className , bsPrefix: bsPrefix , as: Tag = Component || "div" , ...props }, ref)=>{
        const componentProps = {
            ...defaultProps,
            ...props
        };
        const resolvedPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, prefix);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Tag, {
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, resolvedPrefix),
            ...componentProps
        });
    });
    BsComponent.displayName = displayName;
    return BsComponent;
}



var $acw62 = parcelRequire("acw62");


var $31af5e1d0c3b3c37$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ $acw62.forwardRef((p, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(p.className, className)
        }));




var $acw62 = parcelRequire("acw62");


const $d7330f2b9423c4ea$var$CardImg = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix , className: className , variant: variant , as: Component = "img" , ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card-img");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$d7330f2b9423c4ea$var$CardImg.displayName = "CardImg";
var $d7330f2b9423c4ea$export$2e2bcd8739ae039 = $d7330f2b9423c4ea$var$CardImg;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $5eb077b72b2eb187$var$context = /*#__PURE__*/ $acw62.createContext(null);
$5eb077b72b2eb187$var$context.displayName = "CardHeaderContext";
var $5eb077b72b2eb187$export$2e2bcd8739ae039 = $5eb077b72b2eb187$var$context;



const $9a9f027adafde870$var$CardHeader = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , className: className , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div" , ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card-header");
    const contextValue = (0, $acw62.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eb077b72b2eb187$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix)
        })
    });
});
$9a9f027adafde870$var$CardHeader.displayName = "CardHeader";
var $9a9f027adafde870$export$2e2bcd8739ae039 = $9a9f027adafde870$var$CardHeader;



const $7f9683b4f5c2a43f$var$DivStyledAsH5 = (0, $31af5e1d0c3b3c37$export$2e2bcd8739ae039)("h5");
const $7f9683b4f5c2a43f$var$DivStyledAsH6 = (0, $31af5e1d0c3b3c37$export$2e2bcd8739ae039)("h6");
const $7f9683b4f5c2a43f$var$CardBody = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("card-body");
const $7f9683b4f5c2a43f$var$CardTitle = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("card-title", {
    Component: $7f9683b4f5c2a43f$var$DivStyledAsH5
});
const $7f9683b4f5c2a43f$var$CardSubtitle = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("card-subtitle", {
    Component: $7f9683b4f5c2a43f$var$DivStyledAsH6
});
const $7f9683b4f5c2a43f$var$CardLink = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("card-link", {
    Component: "a"
});
const $7f9683b4f5c2a43f$var$CardText = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("card-text", {
    Component: "p"
});
const $7f9683b4f5c2a43f$var$CardFooter = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("card-footer");
const $7f9683b4f5c2a43f$var$CardImgOverlay = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("card-img-overlay");
const $7f9683b4f5c2a43f$var$Card = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , className: className , bg: bg , text: text , border: border , body: body = false , children: children , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div" , ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7f9683b4f5c2a43f$var$CardBody, {
            children: children
        }) : children
    });
});
$7f9683b4f5c2a43f$var$Card.displayName = "Card";
var $7f9683b4f5c2a43f$export$2e2bcd8739ae039 = Object.assign($7f9683b4f5c2a43f$var$Card, {
    Img: (0, $d7330f2b9423c4ea$export$2e2bcd8739ae039),
    Title: $7f9683b4f5c2a43f$var$CardTitle,
    Subtitle: $7f9683b4f5c2a43f$var$CardSubtitle,
    Body: $7f9683b4f5c2a43f$var$CardBody,
    Link: $7f9683b4f5c2a43f$var$CardLink,
    Text: $7f9683b4f5c2a43f$var$CardText,
    Header: (0, $9a9f027adafde870$export$2e2bcd8739ae039),
    Footer: $7f9683b4f5c2a43f$var$CardFooter,
    ImgOverlay: $7f9683b4f5c2a43f$var$CardImgOverlay
});



var $acw62 = parcelRequire("acw62");


function $6a906738aa440808$export$2ed43d61a0a9f5a3({ as: as , bsPrefix: bsPrefix , className: className , ...props }) {
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "col");
    const breakpoints = (0, $626bd95fa485b758$export$8970c8db816a5863)();
    const minBreakpoint = (0, $626bd95fa485b758$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === "object" && propValue != null) ({ span: span , offset: offset , order: order  } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $6a906738aa440808$var$Col = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className , ...colProps }, { as: Component = "div" , bsPrefix: bsPrefix , spans: spans  }] = $6a906738aa440808$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, !spans.length && bsPrefix)
    });
});
$6a906738aa440808$var$Col.displayName = "Col";
var $6a906738aa440808$export$2e2bcd8739ae039 = $6a906738aa440808$var$Col;


/**
 * React Router DOM v6.11.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @remix-run/router v1.6.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ] , initialIndex: initialIndex , v5Compat: v5Compat = false  } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname , search: search , hash: hash  } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/" , search: search = "" , hash: hash = ""  } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/" , search: search = "" , hash: hash = ""  } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView , v5Compat: v5Compat = false  } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta  } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    } // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1; // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            const starParam = params[star]; // Apply the splat
            return starParam;
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $1d34d5c4a288b213$export$3e9cee6b33872309(false, 'Missing ":' + key + '" param');
            return param;
        } // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    }) // Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname , search: search = "" , hash: hash = ""  } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $1d34d5c4a288b213$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $1d34d5c4a288b213$var$isServer = !$1d34d5c4a288b213$var$isBrowser;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    }); //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
     // Routes keyed by ID
    let manifest = {}; // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/"; // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches , route: route  } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction , location: location , delta: delta  } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
         // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path , submission: submission , error: error  } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    }); // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches , route: route  } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change and not a mutation submission.
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".
        // For example, on /page#hash and submit a <Form method="post"> which will
        // default to a navigation to /page
        if (state.initialized && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $1d34d5c4a288b213$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited , loaderData: loaderData , errors: errors  } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $1d34d5c4a288b213$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>{
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        }); // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results , loaderResults: loaderResults , fetcherResults: fetcherResults  } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key)); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData , errors: errors  } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($1d34d5c4a288b213$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path , submission: submission  } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $1d34d5c4a288b213$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $1d34d5c4a288b213$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        ); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results , loaderResults: loaderResults , fetcherResults: fetcherResults  } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData , errors: errors  } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($1d34d5c4a288b213$var$_extends({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = $1d34d5c4a288b213$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename); // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            fetchRedirectIds.add(key);
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission: submission , replace: replace , isFetchActionRedirect: isFetchActionRedirect  } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, $1d34d5c4a288b213$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an absolute external redirect that goes to a new origin
        if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location) && $1d34d5c4a288b213$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (window.location.origin !== url.origin || isDifferentBasename) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod , formAction: formAction , formEncType: formEncType , formData: formData  } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            },
            fetcherSubmission: submission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation , nextLocation: nextLocation , historyAction: historyAction  } = _ref2;
        if (blockerFunctions.size === 0) return;
         // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$1d34d5c4a288b213$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$1d34d5c4a288b213$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext  } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches , route: route  } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches , route: route  } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId , requestContext: requestContext  } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error && !$1d34d5c4a288b213$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    } // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path"); // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    } // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        let formMethod = opts.formMethod || "get";
        submission = {
            formMethod: normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $1d34d5c4a288b213$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    let searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData); // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location); // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename); // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: fetcherMatches,
                match: fetcherMatch,
                controller: new AbortController()
            });
            return;
        } // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        let shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy(); // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest"); // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    } // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates); // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $1d34d5c4a288b213$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod , formEncType: formEncType , formData: formData  } = submission; // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData , errors: errors  } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key , match: match , controller: controller  } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname , routeId: routeId , method: method , type: type  } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return result;
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
     // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index]; // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $1d34d5c4a288b213$var$createUseMatchesMatch(match, loaderData) {
    let { route: route , pathname: pathname , params: params  } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

/**
 * React Router v6.11.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative  } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename , navigator: navigator  } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash , pathname: pathname , search: search  } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname  } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered."; // Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute  } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057); // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename , navigator: navigator  } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches  } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname  } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches  } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative  } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches  } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname  } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
} // Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator  } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches  } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext , match: match , children: children  } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($7939e29d663dd3ed$var$DataRouterHook || ($7939e29d663dd3ed$var$DataRouterHook = {}));
var $7939e29d663dd3ed$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($7939e29d663dd3ed$var$DataRouterStateHook || ($7939e29d663dd3ed$var$DataRouterStateHook = {}));
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
} // Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches , loaderData: loaderData  } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname , params: params  } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$2af03a1de5c0910(shouldBlock) {
    let { router: router  } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey] = $acw62.useState(()=>String(++$7939e29d663dd3ed$var$blockerId));
    let blockerFunction = $acw62.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    $acw62.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router,
        blockerKey
    ]); // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router  } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement , router: router  } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setState] = $acw62.useState(router.state);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]); // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes , state: state  } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename , children: children , initialEntries: initialEntries , initialIndex: initialIndex  } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to , replace: replace , state: state , relative: relative  } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { matches: matches  } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname  } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008(); // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/" , children: children = null , location: locationProp , navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop , navigator: navigator , static: staticProp = false  } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/" , search: search = "" , hash: hash = "" , state: state = null , key: key = "default"  } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children , location: location  } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children , errorElement: errorElement , resolve: resolve  } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($7939e29d663dd3ed$var$AwaitRenderStatus || ($7939e29d663dd3ed$var$AwaitRenderStatus = {}));
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children , errorElement: errorElement , resolve: resolve  } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children  } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, options, basename) {
    let method;
    let action = null;
    let encType;
    let formData;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("action");
            action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = options.encType || target.getAttribute("enctype") || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
         // <button>/<input type="submit"> may override attributes of <form>
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("formaction") || form.getAttribute("action");
            action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $040dbb9c344a508d$var$defaultMethod;
        action = options.action || null;
        encType = options.encType || $040dbb9c344a508d$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367)
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367)
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename , children: children , window: window1  } = _ref;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename , children: children , window: window1  } = _ref2;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref3) {
    let { basename: basename , children: children , history: history  } = _ref3;
    const [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick , relative: relative , reloadDocument: reloadDocument , replace: replace , state: state , target: target , to: to , preventScrollReset: preventScrollReset  } = _ref4, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref4, $040dbb9c344a508d$var$_excluded);
    let { basename: basename  } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306)); // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to; // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    } // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page" , caseSensitive: caseSensitive = false , className: classNameProp = "" , end: end = false , style: styleProp , to: to , children: children  } = _ref5, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref5, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator  } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
        ref: ref
    }));
});
const $040dbb9c344a508d$var$FormImpl = /*#__PURE__*/ $acw62.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument , replace: replace , method: method = $040dbb9c344a508d$var$defaultMethod , action: action , onSubmit: onSubmit , fetcherKey: fetcherKey , routeId: routeId , relative: relative , preventScrollReset: preventScrollReset  } = _ref6, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref6, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey , storageKey: storageKey  } = _ref7;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target , replace: replaceProp , state: state , preventScrollReset: preventScrollReset , relative: relative  } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    return $040dbb9c344a508d$var$useSubmitImpl();
}
function $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, fetcherRouteId) {
    let { router: router  } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmitImpl);
    let { basename: basename  } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { action: action , method: method , encType: encType , formData: formData  } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, options, basename); // Base options shared between fetch() and navigate()
        let opts = {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(fetcherRouteId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, fetcherRouteId, action, opts);
        } else router.navigate(action, $040dbb9c344a508d$var$_extends({}, opts, {
            replace: options.replace,
            fromRouteId: currentRouteId
        }));
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId,
        currentRouteId
    ]);
} // v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative  } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename  } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
function $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $040dbb9c344a508d$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router  } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $acw62.useState(()=>String(++$040dbb9c344a508d$var$fetcherId));
    let [Form] = $acw62.useState(()=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        return $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $acw62.useState(()=>(href)=>{
            !router && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
            !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $acw62.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey , storageKey: storageKey  } = _temp3 === void 0 ? {} : _temp3;
    let { router: router  } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition , preventScrollReset: preventScrollReset  } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture  } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture  } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref8) {
    let { when: when , message: message  } = _ref8;
    let blocker = (0, $7939e29d663dd3ed$export$2af03a1de5c0910)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}


// THIS FILE IS AUTO GENERATED
var $d0610069b91132c4$export$a0f7048edafc45cd = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    }
];


var $88a9a4518753b77c$exports = {};

$parcel$export($88a9a4518753b77c$exports, "GenIcon", () => $88a9a4518753b77c$export$6fce6cce1e9a936d);

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $235129a1ef69bfce$export$4a4ef469214f8641 = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var $235129a1ef69bfce$export$a49f528ae1a4d0ed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($235129a1ef69bfce$export$4a4ef469214f8641);


var $88a9a4518753b77c$var$__assign = undefined && undefined.__assign || function() {
    $88a9a4518753b77c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $88a9a4518753b77c$var$__assign.apply(this, arguments);
};
var $88a9a4518753b77c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $88a9a4518753b77c$var$Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, $88a9a4518753b77c$var$__assign({
            key: i
        }, node.attr), $88a9a4518753b77c$var$Tree2Element(node.child));
    });
}
function $88a9a4518753b77c$export$6fce6cce1e9a936d(data) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($88a9a4518753b77c$export$a188ecdd443fe91a, $88a9a4518753b77c$var$__assign({
            attr: $88a9a4518753b77c$var$__assign({}, data.attr)
        }, props), $88a9a4518753b77c$var$Tree2Element(data.child));
    };
}
function $88a9a4518753b77c$export$a188ecdd443fe91a(props) {
    var elem = function(conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = $88a9a4518753b77c$var$__rest(props, [
            "attr",
            "size",
            "title"
        ]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $88a9a4518753b77c$var$__assign({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: $88a9a4518753b77c$var$__assign($88a9a4518753b77c$var$__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title), props.children);
    };
    return (0, $235129a1ef69bfce$export$a49f528ae1a4d0ed) !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $235129a1ef69bfce$export$a49f528ae1a4d0ed).Consumer, null, function(conf) {
        return elem(conf);
    }) : elem((0, $235129a1ef69bfce$export$4a4ef469214f8641));
}





function $37dc6de0ae62a101$export$b4cb069571440df9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15H5.5v-4.5H4V9h3v6zm6.5-1.5h-3v-1h2c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1H9v1.5h3v1h-2c-.55 0-1 .45-1 1V15h4.5v-1.5zm6 .5v-4c0-.55-.45-1-1-1H15v1.5h3v1h-2v1h2v1h-3V15h3.5c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d1a034b42c1f98e9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.52 21.48A10.487 10.487 0 011.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08a1.07 1.07 0 01-.4-.24c-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56a1.67 1.67 0 00-.23-.51c-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31a2.098 2.098 0 00.89-.75c.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96a1.78 1.78 0 00-.51-.69c-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49a.87.87 0 01-.25.37c-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$833fc213ef3437b8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11h-1.5v-.5h-2v3h2V13H21v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zM8 10v5H6.5v-1.5h-2V15H3v-5c0-.55.45-1 1-1h3c.55 0 1 .45 1 1zm-1.5.5h-2V12h2v-1.5zm7 1.5c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-4V9h4c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM11 10.5v.75h2v-.75h-2zm2 2.25h-2v.75h2v-.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a6adf52bbbab56ff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$940afed16314c963(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2482bddb7552ca37(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "4.54",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C17.42 8.5 16.44 7 14.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L7.22 10l1.92.53L9.79 9H12l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H17v5h2v-5.5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bb44c4cc7bcda3ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 105.9 5.9h-2.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ee4b225b3e6c3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18v1c0 1.1-.9 2-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14c1.1 0 2 .9 2 2v1h-9a2 2 0 00-2 2v8a2 2 0 002 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a611b00a08891b44(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10h3v7H4zM10.5 10h3v7h-3zM2 19h20v3H2zM17 10h3v7h-3zM12 1L2 6v2h20V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$560978450a0edc92(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b66684852ec7e920(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0112.28 0C16.43 19.18 14.03 20 12 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c2de9db097f59034(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h10v-2H4v-6h18V6c0-1.11-.89-2-2-2zm0 4H4V6h16v2zm4 9v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b1dc8f27506a7575(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c.7 0 1.37.1 2 .29V9l-8-6-8 6v12h7.68A6.995 6.995 0 0118 11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm3 5.5h-2.5V21h-1v-2.5H15v-1h2.5V15h1v2.5H21v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$769b90b985333819(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm18.31 6l-2.76 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eaabdf1e604afd60(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.18L10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10L22 5.18zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8c1.57 0 3.04.46 4.28 1.25l1.45-1.45A10.02 10.02 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10c1.73 0 3.36-.44 4.78-1.22l-1.5-1.5c-1 .46-2.11.72-3.28.72zm7-5h-3v2h3v3h2v-3h3v-2h-3v-3h-2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$944afeb8f7af373b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21v-3h3v-2h-3v-3h-2v3h-3v2h3v3h2zm-4.97.5H5.66c-.72 0-1.38-.38-1.73-1l-2.36-4.1c-.36-.62-.35-1.38.01-2L7.92 3.49c.36-.61 1.02-.99 1.73-.99h4.7c.71 0 1.37.38 1.73.99l4.48 7.71a6.176 6.176 0 00-2.4-.14L14.35 4.5h-4.7L3.31 15.41l2.35 4.09h7.89c.35.77.85 1.45 1.48 2zM13.34 15c-.22.63-.34 1.3-.34 2H7.25l-.73-1.27 4.58-7.98h1.8l2.53 4.42c-.56.42-1.05.93-1.44 1.51l-2-3.49L9.25 15h4.09z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6bb465a369f406ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5v2h-3v3h-2V7h-3V5h3V2h2v3h3zm-3 14H5V5h6V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6h-2v6zm-4-6v4h2v-4h-2zm-4 4h2V9h-2v8zm-2 0v-6H7v6h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d69bdc90ba9a520e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11c.34 0 .67.04 1 .09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55-.69-.98-1.1-2.17-1.1-3.45 0-3.31 2.69-6 6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 1.38c.62 0 1.12.51 1.12 1.12s-.51 1.12-1.12 1.12-1.12-.51-1.12-1.12.5-1.12 1.12-1.12zm0 5.37c-.93 0-1.74-.46-2.24-1.17.05-.72 1.51-1.08 2.24-1.08s2.19.36 2.24 1.08c-.5.71-1.31 1.17-2.24 1.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7a3c2b3d118f9935(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.71 17.99A5.993 5.993 0 016 12c0-3.31 2.69-6 6-6 3.22 0 5.84 2.53 5.99 5.71l-2.1-.63a3.999 3.999 0 10-4.81 4.81l.63 2.1zM22 12c0 .3-.01.6-.04.9l-1.97-.59c.01-.1.01-.21.01-.31 0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8c.1 0 .21 0 .31-.01l.59 1.97c-.3.03-.6.04-.9.04-5.52 0-10-4.48-10-10S6.48 2 12 2s10 4.48 10 10zm-3.77 4.26L22 15l-10-3 3 10 1.26-3.77 4.27 4.27 1.98-1.98-4.28-4.26z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bee6bfe3bc995546(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$131a9ef6208c5717(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92a9 9 0 00-9-9c-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8A8.964 8.964 0 003 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$67e789d63d726ac7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9ecddf391c0ad367(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$163c4b2eaf4f5ef4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 6h-4c0 1.62-1.38 3-3 3s-3-1.38-3-3H5V5h14v4zm-4 7h6v3c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de1d39ac86e1e774(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M.21.16h24v24h-24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b474d275058347b6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-5h2v5zm4 0h-2v-3h2v3zm0-5h-2v-2h2v2zm4 5h-2V7h2v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a670106ea529cf0e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15l1.55 1.55c-.96 1.69-3.33 3.04-5.55 3.37V11h3V9h-3V7.82C14.16 7.4 15 6.3 15 5c0-1.65-1.35-3-3-3S9 3.35 9 5c0 1.3.84 2.4 2 2.82V9H8v2h3v8.92c-2.22-.33-4.59-1.68-5.55-3.37L7 15l-4-3v3c0 3.88 4.92 7 9 7s9-3.12 9-7v-3l-4 3zM12 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$64975f74f3827ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85a.637.637 0 00-.83.22l-1.88 3.24a11.463 11.463 0 00-8.94 0L5.65 5.67a.643.643 0 00-.87-.2c-.28.18-.37.54-.22.83L6.4 9.48A10.78 10.78 0 001 18h22a10.78 10.78 0 00-5.4-8.52zM7 15.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm10 0a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$77960772232fed1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d805657447987406(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12l-2 2-2-2 2-2 2 2zm-2-6l2.12 2.12 2.5-2.5L12 1 7.38 5.62l2.5 2.5L12 6zm-6 6l2.12-2.12-2.5-2.5L1 12l4.62 4.62 2.5-2.5L6 12zm12 0l-2.12 2.12 2.5 2.5L23 12l-4.62-4.62-2.5 2.5L18 12zm-6 6l-2.12-2.12-2.5 2.5L12 23l4.62-4.62-2.5-2.5L12 18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2bb7c4e7f21c67ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-2.5 4A2.5 2.5 0 0118 9.5c.42 0 .8.11 1.15.29l-3.36 3.36c-.18-.35-.29-.73-.29-1.15zm2.5 2.5c-.42 0-.8-.11-1.15-.29l3.36-3.36c.18.35.29.73.29 1.15a2.5 2.5 0 01-2.5 2.5zM17 18H7V6h10v1h2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$451b61cb796fd465(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18H7V6h10v1h2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v1zM20.38 9.62L21 11l.62-1.38L23 9l-1.38-.62L21 7l-.62 1.38L19 9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8l-1.25 2.75L12 12l2.75 1.25L16 16l1.25-2.75L20 12l-2.75-1.25zM21 13l-.62 1.38L19 15l1.38.62L21 17l.62-1.38L23 15l-1.38-.62z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cfef6127d2583ca2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 10V8h-2v4H8l4 4 4-4h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe966f6ad12c7d54(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12zm10-1h4v2h-4v3l-4-4 4-4v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e2d7b719e55fed41(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-10 1H8v-2h4V8l4 4-4 4v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c34cde37fe862208(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0 2c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm-1-10v4h2v-4h3l-4-4-4 4h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2e889c4814361ba8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6v2h8.59L5 17.59 6.41 19 16 9.41V18h2V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a683ad2f7ae57e49(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.01 11H4v2h12.01v3L20 12l-3.99-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dcb7142bdacc5ca7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ed93bbbef36f9fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$601a5743576dcff8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4b265c10059a60f6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm3 5.5h-2.5V21h-1v-2.5H15v-1h2.5V15h1v2.5H21v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.69 15c.36-.75.84-1.43 1.43-2H7v-2h11c1.07 0 2.09.25 3 .69V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6.69c-.44-.91-.69-1.93-.69-3 0-.34.03-.67.08-1H7v-2h4.69zM12 2.75c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM7 7h10v2H7V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$44784868f6b21abd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9bfc336cdd569dda(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f9090381246a423d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$25f2f48a666f5976(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$110fc5067b2fb507(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56510f29c71ded93(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6426768363af5d52(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h2v7H5zM11 10h2v7h-2zM22 6L12 1 2 6v2h20zM2 19v2h12.4c-.21-.64-.32-1.31-.36-2H2zM19 12.26V10h-2v3.26zM20 14l-4 2v2.55c0 2.52 1.71 4.88 4 5.45 2.29-.57 4-2.93 4-5.45V16l-4-2zm-.72 7l-2.03-2.03 1.06-1.06.97.97 2.41-2.38 1.06 1.06L19.28 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$57b1f77193bff2d8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 016 12c0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a3e7bb10f7e827(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6v14H6v2h14c1.1 0 2-.9 2-2V6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 16H4v-5h5v5zm7 0h-5v-5h5v5zm0-7H4V4h12v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d1d3ac393e8052b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da93e9d192b4dc95(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.83c.85-.3 1.53-.98 1.83-1.83H18l-3 7c0 1.66 1.57 3 3.5 3s3.5-1.34 3.5-3l-3-7h2V4h-6.17c-.41-1.17-1.52-2-2.83-2s-2.42.83-2.83 2H3v2h2l-3 7c0 1.66 1.57 3 3.5 3S9 14.66 9 13L6 6h3.17c.3.85.98 1.53 1.83 1.83V19H2v2h20v-2h-9V7.83zM20.37 13h-3.74l1.87-4.36L20.37 13zm-13 0H3.63L5.5 8.64 7.37 13zM12 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae536900057fe8c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 8.75h-4v-1.5h4v1.5zm-.38-4.38L22 3l-3.62 1.63L19 6l3.62-1.63zM19 10l-.62 1.37L22 13l.62-1.37L19 10zm-8 3c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1H9.64l-.74 2.78A2.999 2.999 0 016 22a2.995 2.995 0 01-2.9-3.77l1.82-6.8A4.028 4.028 0 013 8c0-2.21 1.79-4 4-4h8c1.49 0 2.45 1.56 1.79 2.89l-2 4C14.45 11.57 13.75 12 13 12h-2.02l-.27 1H11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c564db1340bf7ad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8H7c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-4 12.5h-2V19h2v1.5zm0-2.5h-2c0-1.5-2.5-3-2.5-5 0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 2-2.5 3.5-2.5 5zm5-11.5H6C6 5.67 6.67 5 7.5 5h9c.83 0 1.5.67 1.5 1.5zm-1-3H7C7 2.67 7.67 2 8.5 2h7c.83 0 1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$609d2cf6f7b99371(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7 18V6h10v12H7zm9-7V9.14C16 8.51 15.55 8 15 8H9c-.55 0-1 .51-1 1.14v1.96c.55 0 1 .45 1 1s-.45 1-1 1v1.76c0 .63.45 1.14 1 1.14h6c.55 0 1-.51 1-1.14V13c-.55 0-1-.45-1-1s.45-1 1-1zm-3.5 3.5h-1v-1h1v1zm0-2h-1v-1h1v1zm0-2h-1v-1h1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$62db1cfc9ca0e9b8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a581b8bbaafec45(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-2v2h-2V7h-2V5h2V3h2v2h2v2zm-2 14l-7-3-7 3V5c0-1.1.9-2 2-2h7a5.002 5.002 0 005 7.9V21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5bf741044e24fdd1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21l-7-3-7 3V5c0-1.1.9-2 2-2h7a5.002 5.002 0 005 7.9V21zM17.83 9L15 6.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41L17.83 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4fc036eac3f891d5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$92d97353fd772ac4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-6V5h6v2zm-2 3.9A5.002 5.002 0 0114 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V10.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6300af1a352e8859(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$232eaeb2325c36fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 18l2 1V3c0-1.1-.9-2-2-2H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13zM15 5H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1fba9c1b03230a08(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3a9 9 0 10.001 18.001A9 9 0 009 3zm2.79 13.21L8 12.41V7h2v4.59l3.21 3.21-1.42 1.41z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.99 3.52v2.16A6.99 6.99 0 0122 12c0 2.79-1.64 5.2-4.01 6.32v2.16C21.48 19.24 24 15.91 24 12s-2.52-7.24-6.01-8.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5fab42a0d2323171(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-2.81a5.985 5.985 0 00-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$22351a0bc24d4217(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.9 13.49l-1.4 1.4c-.2.2-.51.2-.71 0l-3.41-3.41c-1.22.43-2.64.17-3.62-.81a3.468 3.468 0 01-.59-4.1l2.35 2.35 1.41-1.41-2.35-2.34c1.32-.71 2.99-.52 4.1.59.98.98 1.24 2.4.81 3.62l3.41 3.41c.19.19.19.51 0 .7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91ffdd4ea7011613(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d7a052ea09fece3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8l-4 4h3c0 3.31-2.69 6-6 6a5.87 5.87 0 01-2.8-.7l-1.46 1.46A7.93 7.93 0 0012 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46A7.93 7.93 0 0012 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d9e48a95b4c30a6f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fd307ee61f247c7c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a708c3d7b5c6c16(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17h18v2H3zm0-7h18v5H3zm0-4h18v2H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20ce8afa0f3fb1e6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 11H4V6h4v5zm6 0h-4V6h4v5zm6 0h-4V6h4v5zM8 18H4v-5h4v5zm6 0h-4v-5h4v5zm6 0h-4v-5h4v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$757318287fb24c18(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 2h2.5v12H13V6zm-2 12H8.5V6H11v12zM4 6h2.5v12H4V6zm16 12h-2.5V6H20v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2f9f779848feed04(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f20e77410907dc76(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 9c-.42 0-.83.04-1.24.11L1.01 3 1 10l9 2-9 2 .01 7 8.07-3.46C9.59 21.19 12.71 24 16.5 24c4.14 0 7.5-3.36 7.5-7.5S20.64 9 16.5 9zm0 13c-3.03 0-5.5-2.47-5.5-5.5s2.47-5.5 5.5-5.5 5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.27 14.03l-1.77 1.76-1.77-1.76-.7.7 1.76 1.77-1.76 1.77.7.7 1.77-1.76 1.77 1.76.7-.7-1.76-1.77 1.76-1.77z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b62fe8596844fda(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 00-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$803cf44c71537388(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8c0e86edc409e70d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$51e117be17dbdbd1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$11c32301c396bf2b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c3bd1370d5a553d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a6416200b5cdecb6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M-74 29h48v48h-48V29zM0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$852055cf95599624(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 16.5c-.83 0-1.5-.67-1.5-1.5h3c0 .83-.67 1.5-1.5 1.5zm5-2.5H7v-1l1-1v-2.61C8 9.27 9.03 7.47 11 7v-.5c0-.57.43-1 1-1s1 .43 1 1V7c1.97.47 3 2.28 3 4.39V14l1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$194ec9bfe299c7fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dc8c8fb569c88545(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3.41L16.71 8.7 20 12h-8V4l3.29 3.29L20.59 2 22 3.41zM3.41 22l5.29-5.29L12 20v-8H4l3.29 3.29L2 20.59 3.41 22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$33e924af7f6c2a37(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.17 12l-4.58-4.59L16 6l6 6-3.59 3.59L17 14.17 19.17 12zM1.39 4.22l4.19 4.19L2 12l6 6 1.41-1.41L4.83 12 7 9.83l12.78 12.78 1.41-1.41L2.81 2.81 1.39 4.22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd4ff06446ef692f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bd7ebb071b4bfdd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 11l-2.5-1.5L14 13V5h5v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c78b2ee9b502f6a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9 11a5 5 0 00-9.8 0H2v2h5.1a5 5 0 009.8 0H22v-2h-5.1zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bfa7aa502c90d044(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4H5C3.34 4 2 5.34 2 7v8c0 1.66 1.34 3 3 3l-1 1v1h1l2-2.03L9 18v-5H4V5.98L13 6v2h2V7c0-1.66-1.34-3-3-3zM5 14c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm15.57-4.34c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 13.77l.01 5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V18h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d85e54c8f10c18eb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b84d7f8aebf8c56(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19h3v3h2v-3h3l-4-4-4 4zm8-15h-3V1h-2v3H8l4 4 4-4zM4 9v2h16V9H4zM4 12h16v2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ea0fa1f1ea234f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-2 8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8H8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0116 17.43V18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$275930a079c8a090(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$81871eb7d0f54994(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8.46 14.45l-1.36-.62c.28-.61.41-1.24.4-1.86a4.42 4.42 0 00-.4-1.8l1.36-.63c.35.75.53 1.56.54 2.4.01.86-.17 1.7-.54 2.51zm3.07 1.56l-1.3-.74c.52-.92.78-1.98.78-3.15 0-1.19-.27-2.33-.8-3.4l1.34-.67c.64 1.28.96 2.65.96 4.07 0 1.43-.33 2.74-.98 3.89zm3.14 1.32l-1.35-.66c.78-1.6 1.18-3.18 1.18-4.69 0-1.51-.4-3.07-1.18-4.64l1.34-.67c.9 1.78 1.34 3.56 1.34 5.31 0 1.74-.44 3.54-1.33 5.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b132e6976e223a3a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.88 9.14c1.28.06 1.61 1.15 1.63 1.66h1.79c-.08-1.98-1.49-3.19-3.45-3.19C9.64 7.61 8 9 8 12.14c0 1.94.93 4.24 3.84 4.24 2.22 0 3.41-1.65 3.44-2.95h-1.79c-.03.59-.45 1.38-1.63 1.44-1.31-.04-1.86-1.06-1.86-2.73 0-2.89 1.28-2.98 1.88-3zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a9d6c89d177d0ca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9 21.9L2.1 2.1.69 3.51l1.55 1.55c-.15.28-.23.6-.23.94L2 18c0 1.11.89 2 2 2h13.17l3.31 3.31 1.42-1.41zM4 12V8h1.17l4 4H4zm2.83-8H20c1.11 0 2 .89 2 2v12c0 .34-.08.66-.23.94L14.83 12H20V8h-9.17l-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ead44dd852d7993(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6c60f9a3c682275(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 14v-1H11v.5h2v-1h-2.5c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1H13v-.5h-2v1h2.5c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1zm7.5 1h3c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1h-2.5v-1h2v.5H21v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1h2.5v1h-2V13H16v1c0 .55.45 1 1 1zm-9-5c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-1H6.5v.5h-2v-3h2v.5H8v-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$739e8e5787974f84(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.89 11.1c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79.99 1.9 1.34l1.58-.67c-.15-.45-.82-1.92-2.54-2.24V5h-2v1.26c-2.48.56-2.49 2.86-2.49 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66.67c.63 2.19 2.28 2.78 2.9 2.96V19h2v-1.24c.4-.09 2.9-.59 2.9-3.22 0-1.39-.61-2.61-3.01-3.44zM3 21H1v-6h6v2H4.52c1.61 2.41 4.36 4 7.48 4a9 9 0 009-9h2c0 6.08-4.92 11-11 11-3.72 0-7.01-1.85-9-4.67V21zm-2-9C1 5.92 5.92 1 12 1c3.72 0 7.01 1.85 9 4.67V3h2v6h-6V7h2.48C17.87 4.59 15.12 3 12 3a9 9 0 00-9 9H1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f518b9440c01b599(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$195830f14faa666c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h8v8H3zm10 0h8v8h-8zM3 13h8v8H3zm15 0h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cc1c752b823eb939(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ee122203c70b415(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12c0 1.33.26 2.61.74 3.77L8 10.5l3.3 2.78L14.58 10H13V8h5v5h-2v-1.58L11.41 16l-3.29-2.79-4.4 4.4A9.996 9.996 0 0012 22h8c1.1 0 2-.9 2-2v-8c0-5.52-4.48-10-10-10zm7.5 18.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7953a631ac301b7f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.33 5.17l2 2 3.67-3.67 1.41 1.41L12.67 13l-2-2-3 3-1.41-1.41 4.41-4.42zM5 16h1.72L5 17.72V16zm.84 3l3-3h1.83l-3 3H5.84zm3.96 0l3-3h1.62l-3 3H9.8zm3.73 0l3-3h1.62l-3 3h-1.62zM19 19h-1.73L19 17.27V19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$346e8ab6a58a1e36(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$98f203437e4961f3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ef05d128f565b84e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bd34ad9a9b338095(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4f30623278757120(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v2H3zM3 19h18v2H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c8fdcd3a263dff2a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v2H3zM3 19h18v2H3zM3 11h18v2H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ba1dd4b28ffe00ad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h18v2H3zM3 20h18v2H3zM3 14h18v2H3zM3 8h18v2H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cfd87ed3934b771a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d68123cb0df7ed55(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm14 12.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a82138653a0e7a75(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 12.34c.01-.11.01-.23.01-.34 0-5.52-4.48-10-10-10S2 6.48 2 12c0 5.17 3.93 9.43 8.96 9.95a9.343 9.343 0 01-2.32-2.68A8.01 8.01 0 014 12c0-1.85.63-3.55 1.69-4.9l5.66 5.66c.56-.4 1.17-.73 1.82-1L7.1 5.69A7.902 7.902 0 0112 4c4.24 0 7.7 3.29 7.98 7.45.71.22 1.39.52 2.01.89zM17 13c-3.18 0-5.9 1.87-7 4.5 1.1 2.63 3.82 4.5 7 4.5s5.9-1.87 7-4.5c-1.1-2.63-3.82-4.5-7-4.5zm0 7a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm1.5-2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$70eac76707e9eb3b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h4v2h8v-2h4c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 14H4V5h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8.25h8v1.5H6zM16.5 9.75H18v-1.5h-1.5V7H15v4h1.5zM10 12.25h8v1.5h-8zM7.5 15H9v-4H7.5v1.25H6v1.5h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f3978864415bdb76(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffaa3a22e052ea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$50529e1f4d87b29b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 5.03l1.4 1.4L8.43 19.17l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 5.03m0-2.83L8.43 13.54l-4.2-4.2L0 13.57 8.43 22 24 6.43 19.77 2.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$24453c844b0a1bbb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a4f44e515299a3da(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3e9fa18debc590ca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$33c812d452f93d9c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c334726788f63a8d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20v-9h-2V4h7l-2 5h2l-5 11zm-2-7v7H4c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h11zm-8.75 2.75h-1.5v1.5h1.5v-1.5zM13 4v7H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h9zM6.25 6.75h-1.5v1.5h1.5v-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$647319bc18977b7d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.05 8.05a7.001 7.001 0 00-.02 9.88c1.47-3.4 4.09-6.24 7.36-7.93A15.952 15.952 0 008 19.32c2.6 1.23 5.8.78 7.95-1.37C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dcd02023444bb95a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22H5a2 2 0 01-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2v6h-2v-2H5v10h7v2zm10.13-5.01l.71-.71a.996.996 0 000-1.41l-.71-.71a.996.996 0 00-1.41 0l-.71.71 2.12 2.12zm-.71.71l-5.3 5.3H14v-2.12l5.3-5.3 2.12 2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$89deb87b45c2c5f4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19.88V22h2.12l5.17-5.17-2.12-2.12zM20 8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H12v-2.95l8-8V8zm-7 1V3.5L18.5 9H13zM22.71 14l-.71-.71a.996.996 0 00-1.41 0l-.71.71L22 16.12l.71-.71a.996.996 0 000-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5904d933deb79de3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.126 8.125l1.937-1.937 3.747 3.747-1.937 1.938zM20.71 5.63l-2.34-2.34a1 1 0 00-1.41 0l-1.83 1.83 3.75 3.75L20.71 7a1 1 0 000-1.37zM2 5l6.63 6.63L3 17.25V21h3.75l5.63-5.62L18 21l2-2L4 3 2 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$61fba1d8fc68f15f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17V9.93L13.93 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8.93L14.07 17H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15h4.24l7.2-7.2-4.24-4.24-7.2 7.2zM22.91 2.49L21.5 1.08c-.78-.78-2.05-.78-2.83 0l-1.06 1.06 4.24 4.24 1.06-1.06c.79-.78.79-2.05 0-2.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa8220c773856e13(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 24V0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17h14v2H5zm7-12L5.33 15h13.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$114c6f3c4e4022ae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18.5A6.48 6.48 0 019.24 15H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24A6.491 6.491 0 0115 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3A8.955 8.955 0 0015 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06a8.262 8.262 0 000 2H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$74bb8d8ebd99cfe4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12V6c0-1.1-.9-2-2-2h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V10h14v2h2zm-5.36 8a3.504 3.504 0 006.86-1c0-1.93-1.57-3.5-3.5-3.5-.95 0-1.82.38-2.45 1H18V18h-4v-4h1.5v1.43c.9-.88 2.14-1.43 3.5-1.43 2.76 0 5 2.24 5 5a5.002 5.002 0 01-9.9 1h1.54z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7eb21e679b23b9cf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18v3h3v-3h10v3h3v-6H4v3zm15-8h3v3h-3v-3zM2 10h3v3H2v-3zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$69effd0956567502(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6353550c7076e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5a2 2 0 00-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a54ce690072e0bcc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h16v2H4zM4 2h16v2H4zm9 7h3l-4-4-4 4h3v6H8l4 4 4-4h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e1f388349a1feed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.19 14.19l-1.41-1.41-1.56-1.56L11 11 9.81 9.81 4.93 4.93 2.27 2.27 1 3.54l2.78 2.78c-.11.16-.21.32-.31.48-.04.07-.09.14-.13.21-.09.15-.17.31-.25.47-.05.1-.1.21-.16.32-.06.14-.13.28-.19.43-.1.24-.19.48-.27.73l-.09.3c-.05.2-.1.39-.14.59-.02.11-.04.22-.07.33-.04.2-.07.4-.09.61-.01.1-.03.2-.03.3-.03.29-.05.6-.05.91 0 5.52 4.48 10 10 10 .31 0 .62-.02.92-.05l.3-.03c.2-.02.41-.06.61-.09.11-.02.22-.04.33-.07.2-.04.39-.09.58-.15.1-.03.2-.05.3-.09.25-.08.49-.17.73-.27.15-.06.29-.13.43-.19.11-.05.22-.1.33-.16.16-.08.31-.16.46-.25.07-.04.14-.09.21-.13.16-.1.32-.2.48-.31L20.46 23l1.27-1.27-2.66-2.66-4.88-4.88zM6 18l3-6.46L12.46 15 6 18zm16-6c0 .31-.02.62-.05.92l-.03.3c-.02.2-.06.41-.09.61-.02.11-.04.22-.07.33-.04.2-.09.39-.15.58-.03.1-.05.21-.09.31-.08.25-.17.49-.27.73-.06.15-.13.29-.19.43-.05.11-.1.22-.16.33-.08.16-.16.31-.25.46-.04.07-.09.14-.13.21-.1.16-.2.32-.31.48L15 12.46 18 6l-6.46 3-5.22-5.22c.16-.11.32-.21.48-.31.07-.04.14-.09.21-.13.15-.09.31-.17.46-.25.11-.05.22-.1.33-.16.14-.06.28-.13.43-.19.24-.1.48-.19.73-.27l.31-.09c.19-.05.38-.11.58-.15.11-.02.22-.04.33-.07.2-.04.4-.07.61-.09.1-.01.2-.03.3-.03.29-.02.6-.04.91-.04 5.52 0 10 4.48 10 10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d2513809f72f80fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c9a8ad824329b97c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.78 22.61l-1.63-1.63c-.05 0-.1.02-.15.02h-3.8c0-2.71-2.16-3-2.7-3s-2.7.29-2.7 3H5c-1.1 0-2-.9-2-2v-3.8c2.71 0 3-2.16 3-2.7s-.3-2.7-2.99-2.7V6c0-.05.02-.09.02-.14L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zm.22-5.44V15a2.5 2.5 0 000-5V6c0-1.1-.9-2-2-2h-4a2.5 2.5 0 00-5 0H6.83L20 17.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e29461a5192976a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5a2.5 2.5 0 00-5 0V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5a2.5 2.5 0 000-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84aefb18d2d92413(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm6 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37a9.974 9.974 0 0010.41 3.97c.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3accb700c8b83b35(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM10 17H5v-2h5v2zm0-4H5v-2h5v2zm0-4H5V7h5v2zm4.82 6L12 12.16l1.41-1.41 1.41 1.42L17.99 9l1.42 1.42L14.82 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aca9d0fc1bc016d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$57ca8b8d7b232624(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$974339116fa1419a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-1V4H8v16h14v-8c0-1.66-1.34-3-3-3zm-9-3h6v3h-6V6zm4 11h-4v-5h4v5zm2 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4.5 8A2.5 2.5 0 002 10.5v8a2.5 2.5 0 005 0v-8A2.5 2.5 0 004.5 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b2de62d5b4f4c7a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a5ed8df7433f7acb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V7l-5-5zM6 20V4h8v4h4v12H6zm10-10v5c0 2.21-1.79 4-4 4s-4-1.79-4-4V8.5a2.5 2.5 0 012.76-2.49c1.3.13 2.24 1.32 2.24 2.63V15h-2V8.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V15c0 1.1.9 2 2 2s2-.9 2-2v-5h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1522291d2549fe2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.79 5.61A.998.998 0 0019 4H6.83l7.97 7.97 4.99-6.36zM2.81 2.81L1.39 4.22 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.17l5.78 5.78 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$373390ae4f3dd2d2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24m0 24H0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0018.95 4H5.04c-.83 0-1.3.95-.79 1.61z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f1771a6acb659ce3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zM0 0h24m0 24H0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.25 5.66c.1.13 5.74 7.33 5.74 7.33V19c0 .55.45 1 1.01 1h2.01c.55 0 1.01-.45 1.01-1v-6.02s5.49-7.02 5.75-7.34C20.03 5.32 20 5 20 5c0-.55-.45-1-1.01-1H5.01C4.4 4 4 4.48 4 5c0 .2.06.44.25.66z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$370db8aad63ee911(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6aa909b8238edc0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05A6.976 6.976 0 0011 4c-3.53 0-6.43 2.61-6.92 6H6.1A5 5 0 0111 6zm5.64 9.14A6.89 6.89 0 0017.92 12H15.9a5 5 0 01-4.9 4c-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05A6.976 6.976 0 0011 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8d600988dcacaf8f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2a.506.506 0 01.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67a.49.49 0 01-.44.28zM3.5 9.72a.499.499 0 01-.41-.79c.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25a.5.5 0 01-.12.7c-.23.16-.54.11-.7-.12a9.388 9.388 0 00-3.39-2.94c-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07a.47.47 0 01-.35-.15c-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1a7.297 7.297 0 01-2.17-5.22c0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29a11.14 11.14 0 01-.73-3.96c0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f544a5dafd19f0a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4h3c1.1 0 2 .9 2 2v2h-2V6h-3V4zM4 8V6h3V4H4c-1.1 0-2 .9-2 2v2h2zm16 8v2h-3v2h3c1.1 0 2-.9 2-2v-2h-2zM7 18H4v-2H2v2c0 1.1.9 2 2 2h3v-2zM18 8H6v8h12V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9b9f03dfe6274665(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.05 17.58l-.01.01-2.4-2.4 1.06-1.06 1.35 1.35L16.54 13l1.06 1.06-3.54 3.54-.01-.02zM12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM7.34 6.28l1.41 1.41 1.41-1.41 1.06 1.06-1.41 1.41 1.41 1.41-1.06 1.06-1.41-1.41-1.41 1.41-1.06-1.06 1.41-1.41-1.41-1.41 1.06-1.06zM12 20c-2.2 0-4.2-.9-5.7-2.3L17.7 6.3C19.1 7.8 20 9.8 20 12c0 4.4-3.6 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$910b2b51197de12(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 19h19v2h-19v-2zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l16.57 4.44z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$39f5953439958e45(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 19h19v2h-19v-2zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49s7.12-1.9 16.57-4.43c.81-.23 1.28-1.05 1.07-1.85z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5b3b34ae32232cfa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8a2 2 0 00-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7a2 2 0 002 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12a2 2 0 002 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$12fe3a4de88d4cc9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3a2 2 0 002 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9a2 2 0 00-2 2v10a2 2 0 002 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$399ba877c5541f36(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.07 11.7c.29-.39.81-.56 1.27-.37.17.07.32.18.43.33.22.28.25.59.22.85-.05.33-.25.63-.54.79 0 0-4.87 2.95-5.07 2.69s3.69-4.29 3.69-4.29zM22 10c0 2.5-1 3-1.5 3-.23 0-.44-.1-.62-.26-.48 3.32-2.36 5.31-5.33 5.99.11.44.48.77.95.77h.58c.22 0 .41.15.48.36.17.52.66 1.02 1.02 1.32.25.21.24.59-.03.78-.34.24-.9.49-1.79.53a.501.501 0 01-.45-.22c-.13-.2-.31-.56-.31-1.01 0-.3.04-.57.09-.8-.78-.16-1.39-.78-1.55-1.56-.49.06-1 .1-1.54.1-.88 0-1.7-.09-2.45-.25-.02.08-.05.16-.05.25 0 .55.45 1 1 1h.58c.22 0 .41.15.48.36.17.52.66 1.02 1.02 1.32.25.21.24.59-.03.78-.34.24-.9.49-1.79.53a.501.501 0 01-.45-.22c-.13-.2-.31-.56-.31-1.01 0-.3.04-.57.09-.8-.9-.19-1.59-1-1.59-1.96 0-.18.03-.36.08-.53-2.46-.86-4.03-2.78-4.46-5.74-.18.17-.38.27-.62.27C3 13 2 12.5 2 10c0-2.27 1.7-4.5 3-4.5.43 0 .49.49.5.85a7.989 7.989 0 015.55-3.29c.2-.96 1.08-1.56 1.95-1.56v1s.33-.5 1-.5c.67 0 1 .5 1 .5-.49 0-.85.35-.96.77 1.82.48 3.39 1.59 4.46 3.08.01-.36.07-.85.5-.85 1.3 0 3 2.23 3 4.5zM5 11c0 .81.1 1.53.25 2.21.18-.69.46-1.33.83-1.92a3.77 3.77 0 01-.34-1.54A3.766 3.766 0 019.5 6c.96 0 1.84.37 2.5.97.66-.6 1.54-.97 2.5-.97 2.07 0 3.75 1.68 3.75 3.75 0 .55-.12 1.07-.34 1.54.37.59.66 1.24.84 1.94.15-.68.25-1.41.25-2.23 0-3.86-3.14-7-7-7s-7 3.14-7 7zm12.98 4.29c0-.1.02-.19.02-.29 0-1.01-.26-1.95-.7-2.78-.69.78-1.68 1.28-2.8 1.28-.27 0-.54-.03-.79-.09.14-.23.23-.49.27-.77.01-.07.01-.13.02-.19.17.03.33.05.5.05 1.52 0 2.75-1.23 2.75-2.75S16.02 7 14.5 7c-.67 0-1.32.25-1.83.72l-.67.6-.67-.6C10.82 7.25 10.17 7 9.5 7 7.98 7 6.75 8.23 6.75 9.75c0 1.34.96 2.46 2.23 2.7l-.76.83c-.6-.22-1.12-.59-1.53-1.05A6.01 6.01 0 006 15c0 .08.01.15.01.24C7.13 17.06 9.14 18 12 18c2.88 0 4.88-.91 5.98-2.71zM16 9.75c0 .97-.67 1.75-1.5 1.75S13 10.72 13 9.75 13.67 8 14.5 8s1.5.78 1.5 1.75zm-.75-.87c0-.21-.17-.38-.38-.38s-.37.17-.37.38.17.38.38.38.37-.18.37-.38zM11 9.75c0 .97-.67 1.75-1.5 1.75S8 10.72 8 9.75 8.67 8 9.5 8s1.5.78 1.5 1.75zm-.75-.87c0-.21-.17-.38-.38-.38s-.37.17-.37.38.17.38.38.38.37-.18.37-.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ab9c0e898b2b2b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.21 20H5V10h14v4.38l2-2V6c0-1.1-.9-2-2-2h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h8.21l-2-2zm5.33 2.5L13 18.96l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41-5.64 5.66zM10.41 14L12 15.59 10.59 17 9 15.41 7.41 17 6 15.59 7.59 14 6 12.41 7.41 11 9 12.59 10.59 11 12 12.41 10.41 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$83c5e37e0775493a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H11l-1-3H3c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8l1 3h9c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 16c-2.76 0-5-2.24-5-5s2.24-5 5-5c1.35 0 2.48.5 3.35 1.3L9.03 8.57c-.38-.36-1.04-.78-2.03-.78-1.74 0-3.15 1.44-3.15 3.21S5.26 14.21 7 14.21c2.01 0 2.84-1.44 2.92-2.41H7v-1.71h4.68c.07.31.12.61.12 1.02C11.8 13.97 9.89 16 7 16zm6.17-5.42h3.7c-.43 1.25-1.11 2.43-2.05 3.47-.31-.35-.6-.72-.86-1.1l-.79-2.37zm8.33 9.92c0 .55-.45 1-1 1H14l2-2.5-1.04-3.1 3.1 3.1.92-.92-3.3-3.25.02-.02c1.13-1.25 1.93-2.69 2.4-4.22H20v-1.3h-4.53V8h-1.29v1.29h-1.44L11.46 5.5h9.04c.55 0 1 .45 1 1v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eabb7103575ea0d7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.25 8.069l2.83-2.827 14.134 14.15-2.83 2.827zM9.486 3.827L12.314.998l5.657 5.656-2.828 2.83zM.999 12.315l2.828-2.829 5.657 5.657-2.828 2.828zM1 21h12v2H1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe2aed4f4b563955(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3 6.5h-2v5H8v-5H6V9h6v1.5zm8.25-6.75L23 5l-2.75 1.25L19 9l-1.25-2.75L15 5l2.75-1.25L19 1l1.25 2.75zm0 14L23 19l-2.75 1.25L19 23l-1.25-2.75L15 19l2.75-1.25L19 15l1.25 2.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db86ede83f288b2e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$426005f896c41371(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9.5 13v-1h1v1c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h1c.55 0 1 .45 1 1h-2v2h1zm3 1h-1v-4h1v4zm4-3h-2v.5H16v1h-1.5V14h-1v-4h3v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b4a32f2377958401(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zM19 10.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dcd7a9940c88d1c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0723d5d625a3cfe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h16v2H4V7zm0 6h16v-2H4v2zm0 4h7v-2H4v2zm0 4h7v-2H4v2zm11.41-2.83L14 16.75l-1.41 1.41L15.41 21 20 16.42 18.58 15l-3.17 3.17zM4 3v2h16V3H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3582cbc98c19746e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5zM9.5 8a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0zm6.5 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$706a11888ec4637a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6.99 15c-.7 0-1.26-.56-1.26-1.26 0-.71.56-1.25 1.26-1.25.71 0 1.25.54 1.25 1.25-.01.69-.54 1.26-1.25 1.26zm3.01-7.4c-.76 1.11-1.48 1.46-1.87 2.17-.16.29-.22.48-.22 1.41h-1.82c0-.49-.08-1.29.31-1.98.49-.87 1.42-1.39 1.96-2.16.57-.81.25-2.33-1.37-2.33-1.06 0-1.58.8-1.8 1.48l-1.65-.7C9.01 7.15 10.22 6 11.99 6c1.48 0 2.49.67 3.01 1.52.44.72.7 2.07.02 3.08z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d44ac901c5e52e15(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dc3197dd8fe880a6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a8256615e77291c7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l2.27 2.27A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l2.27 2.27 1.41-1.41L2.81 2.81zM12 20c-4.41 0-8-3.59-8-8 0-1.48.41-2.86 1.12-4.06l10.94 10.94C14.86 19.59 13.48 20 12 20zM7.94 5.12L6.49 3.66A9.91 9.91 0 0112 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51l-1.46-1.46A7.869 7.869 0 0020 12c0-4.41-3.59-8-8-8-1.48 0-2.86.41-4.06 1.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$80621804b754c82(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5h-2V3h2v2zm-2 16h2v-2.59L19.59 21 21 19.59 18.41 17H21v-2h-6v6zm4-12h2V7h-2v2zm0 4h2v-2h-2v2zm-8 8h2v-2h-2v2zM7 5h2V3H7v2zM3 17h2v-2H3v2zm2 4v-2H3c0 1.1.9 2 2 2zM19 3v2h2c0-1.1-.9-2-2-2zm-8 2h2V3h-2v2zM3 9h2V7H3v2zm4 12h2v-2H7v2zm-4-8h2v-2H3v2zm0-8h2V3c-1.1 0-2 .9-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1d7a3d7b28a525cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6dbab94de79f9024(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.1 19.37l1 1.74c-.96.44-2.01.73-3.1.84v-2.02c.74-.09 1.44-.28 2.1-.56zM4.07 13H2.05c.11 1.1.4 2.14.84 3.1l1.74-1c-.28-.66-.47-1.36-.56-2.1zM15.1 4.63l1-1.74c-.96-.44-2-.73-3.1-.84v2.02c.74.09 1.44.28 2.1.56zM19.93 11h2.02c-.11-1.1-.4-2.14-.84-3.1l-1.74 1c.28.66.47 1.36.56 2.1zM8.9 19.37l-1 1.74c.96.44 2.01.73 3.1.84v-2.02c-.74-.09-1.44-.28-2.1-.56zM11 4.07V2.05c-1.1.11-2.14.4-3.1.84l1 1.74c.66-.28 1.36-.47 2.1-.56zm7.36 3.1l1.74-1.01c-.63-.87-1.4-1.64-2.27-2.27l-1.01 1.74c.59.45 1.1.96 1.54 1.54zM4.63 8.9l-1.74-1c-.44.96-.73 2-.84 3.1h2.02c.09-.74.28-1.44.56-2.1zm15.3 4.1c-.09.74-.28 1.44-.56 2.1l1.74 1c.44-.96.73-2.01.84-3.1h-2.02zm-3.1 5.36l1.01 1.74c.87-.63 1.64-1.4 2.27-2.27l-1.74-1.01c-.45.59-.96 1.1-1.54 1.54zM7.17 5.64l-1-1.75c-.88.64-1.64 1.4-2.27 2.28l1.74 1.01a7.7 7.7 0 011.53-1.54zM5.64 16.83l-1.74 1c.63.87 1.4 1.64 2.27 2.27l1.01-1.74a7.7 7.7 0 01-1.54-1.53zM13 7h-2v5.41l4.29 4.29 1.41-1.41-3.7-3.7V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$15ee7bfffe6674bb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$77a5326594a47d25(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.83 15h1.67c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H17v-1h2v.5h1.5v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1H19v1h-2V13h-1.17l2 2zM8 10.83V15H6.5v-2.5h-2V15H3V9h1.5v2h2V9.33L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-7.6-7.6H10v-2.17l-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2e63bc4d96c73f8d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 9H8v6H6.5v-2.5h-2V15H3V9h1.5v2h2V9zm10 6h3c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H17v-1h2v.5h1.5v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1H19v1h-2V13h-1.5v1c0 .55.45 1 1 1zM14 15v-1.5h-2.5V9H10v6h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$41bc5bcd2d27fa9b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L4 9v12h5v-7h6v7h5V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91bc2f84217d1d90(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d736128939a389e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19h18v-6H3v6zm0-8h18V9H3v2zm0-6v2h18V5H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0af23208af84ad3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.58 10H1l6.17 4.41L4.83 22 11 17.31 17.18 22l-2.35-7.59L21 10h-7.58L11 2l-2.42 8zm12.78 12l-1.86-6.01L23.68 13h-3.44l-3.08 2.2 1.46 4.72L21.36 22zM17 8l-1.82-6-1.04 3.45.77 2.55H17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85333a8b38d07e85(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4h8v3.5l-2.84 2.84 1.25 1.25L18 8.01 17.99 8H18V2H6v1.17l2 2zM2.1 2.1L.69 3.51l8.9 8.9L6 16l.01.01H6V22h12v-1.17l2.49 2.49 1.41-1.41L2.1 2.1zM16 20H8v-3.5l2.84-2.84L16 18.83V20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f055fbd368d6d8e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ecec67afda03ae6e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$69761892af550845(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 9H5v6H3.5v-2.5h-2V15H0V9h1.5v2h2V9zm14 0H13c-.55 0-1 .45-1 1v5h1.5v-4.5h1V14H16v-3.51h1V15h1.5v-5c0-.55-.45-1-1-1zM11 9H6v1.5h1.75V15h1.5v-4.5H11V9zm13 6v-1.5h-2.5V9H20v6h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8f48b9da608e793f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b5d4a65085f0f05(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a7092accb50857f4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12a2 2 0 002 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4a2 2 0 00-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$630292876d3327c0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1f366c93ed4e1e3e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f1474135390d7a28(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14a2 2 0 00-2-2zM11 16l4-4-4-4v3H1v2h10v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9d8729b665fb15dd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17H4V5h8V3H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h4v2h8v-2h4c1.1 0 2-.9 2-2v-3h-2v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14l5-5-1.41-1.41L18 10.17V3h-2v7.17l-2.59-2.58L12 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56849670d3a9708c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18H7V6h7V1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-5h-2v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14l5-5-1.41-1.41L19 10.17V3h-2v7.17l-2.59-2.58L13 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db7f59dbd055accc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "3.5",
                    "r": ".75",
                    "fill": "none"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "3.5",
                    "r": ".75",
                    "fill": "none"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "3.5",
                    "r": ".75",
                    "fill": "none"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 11.17l-1.41 1.42L6 12l3.59-3.59L11 9.83 8.83 12 11 14.17zm1-9.92c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.34.75.75-.34.75-.75.75zm2.41 11.34L13 14.17 15.17 12 13 9.83l1.41-1.42L18 12l-3.59 3.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee3256c06ee1f764(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.81V19c-3.31 0-6-2.63-6-5.87 0-1.56.62-3.03 1.75-4.14L12 4.81M6.35 7.56C4.9 8.99 4 10.96 4 13.13 4 17.48 7.58 21 12 21s8-3.52 8-7.87c0-2.17-.9-4.14-2.35-5.57L12 2 6.35 7.56z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$786a8c2dc5d7fc97(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14v-1h1.5v.5h2v-1H13c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1h-1.5v-.5h-2v1H16c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1zM9 9v4.5H7.5v-1H6v1c0 .83.67 1.5 1.5 1.5H9c.83 0 1.5-.67 1.5-1.5V9H9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f7976fa700746c3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 12c0-.97.23-4.16 3.03-6.5C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-2.8-2.34-3.03-5.53-3.03-6.5zM16 5c-.9 0-1.75.19-2.53.5 2.8 2.34 3.03 5.53 3.03 6.5 0 .97-.23 4.16-3.03 6.5.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$186f5a373aaa1227(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.04 16.87c-.33.08-.68.13-1.04.13-2.76 0-5-2.24-5-5s2.24-5 5-5c.36 0 .71.05 1.04.13.39-.56.88-1.12 1.49-1.63C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-.61-.51-1.1-1.07-1.49-1.63zM16 5c-.9 0-1.75.19-2.53.5.61.51 1.1 1.07 1.49 1.63.33-.08.68-.13 1.04-.13 2.76 0 5 2.24 5 5s-2.24 5-5 5c-.36 0-.71-.05-1.04-.13-.39.56-.88 1.12-1.49 1.63.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ccba7604adb36d03(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 12c0-.97.23-4.16 3.03-6.5C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-2.8-2.34-3.03-5.53-3.03-6.5zM16 5c-.9 0-1.75.19-2.53.5.61.51 1.1 1.07 1.49 1.63.33-.08.68-.13 1.04-.13 2.76 0 5 2.24 5 5s-2.24 5-5 5c-.36 0-.71-.05-1.04-.13-.39.56-.88 1.12-1.49 1.63.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f66acd2fbf8b381(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12c0 .97-.23 4.16-3.03 6.5.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7c-.9 0-1.75.19-2.53.5 2.8 2.34 3.03 5.53 3.03 6.5zM8 19c.9 0 1.75-.19 2.53-.5-.61-.51-1.1-1.07-1.49-1.63-.33.08-.68.13-1.04.13-2.76 0-5-2.24-5-5s2.24-5 5-5c.36 0 .71.05 1.04.13.39-.56.88-1.12 1.49-1.63C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bec8dbb54fb90e8d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19H3l4.5-7L3 5h12c.65 0 1.26.31 1.63.84L21 12l-4.37 6.16c-.37.52-.98.84-1.63.84zm-8.5-2H15l3.5-5L15 7H6.5l3.5 5-3.5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$178ef58fc9fe2cee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 18.99l11 .01c.67 0 1.27-.33 1.63-.84L20.5 12l-4.37-6.16c-.36-.51-.96-.84-1.63-.84l-11 .01L8.34 12 3.5 18.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$242f03d242a96acc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.25 2.75l17 17L19 21l-2-2H5c-1.1 0-2-.9-2-2V7c0-.55.23-1.05.59-1.41L2 4l1.25-1.25zM22 12l-4.37-6.16C17.27 5.33 16.67 5 16 5H8l11 11 3-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$feb00fb96de5aded(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8f9fd0fc23e06b51(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0bec7f1b2ed8c5f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 00-1.38-3.56A8.03 8.03 0 0118.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 015.08 16zm2.95-8H5.08a7.987 7.987 0 014.33-3.56A15.65 15.65 0 008.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 01-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd0a16bce1d5908b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8051160ae3eb0e7f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 21H2V9h5.5v12zm7.25-18h-5.5v18h5.5V3zM22 11h-5.5v10H22V11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e56c72751613e274(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 17c-.83 0-1.5-.67-1.5-1.5h3c0 .83-.67 1.5-1.5 1.5zm3-2.5H9V15h6v1.5zm-.03-2.5H9.03A4.966 4.966 0 017 10c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.64-.8 3.09-2.03 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aab9a3152d31ec1b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2 11.7V16h-4v-2.3C8.48 12.63 7 11.53 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.49-1.51 3.65-3 4.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$473f678f9c7ca1ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9v1zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6d4e8b3030bde63f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$edf8ffa6299f36d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c5d3f9203d9e0a6c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ba381fde9152c1d1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 14.2l2.9 1.7-.8 1.3L13 15v-5h1.5v4.2zM22 14c0 4.41-3.59 8-8 8-2.02 0-3.86-.76-5.27-2H4c-1.15 0-2-.85-2-2V9c0-1.12.89-1.96 2-2v-.5C4 4.01 6.01 2 8.5 2c2.34 0 4.24 1.79 4.46 4.08.34-.05.69-.08 1.04-.08 4.41 0 8 3.59 8 8zM6 7h5v-.74A2.509 2.509 0 008.5 4 2.5 2.5 0 006 6.5V7zm14 7c0-3.31-2.69-6-6-6s-6 2.69-6 6 2.69 6 6 6 6-2.69 6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c3bd1459ffbfc377(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cc58d7a5a5f0f9c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ec58c2f252314a39(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c.7 0 1.37.1 2 .29V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6.26A6.995 6.995 0 0118 11zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 2c.83 0 1.5.67 1.5 1.5S18.83 18 18 18s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm0 6c-1.03 0-1.94-.52-2.48-1.32.73-.42 1.57-.68 2.48-.68s1.75.26 2.48.68c-.54.8-1.45 1.32-2.48 1.32z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7676d673ce4d8b9f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3a9 9 0 00-9 9H1l4 4 4-4H6c0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7c-1.9 0-3.62-.76-4.88-1.99L6.7 18.42A8.982 8.982 0 0013 21a9 9 0 000-18zm2 8v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4e09f420bc840ef9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a2372c70545e9c32(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a8c746af295624d1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a43219bf34ea6ce2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27A2.5 2.5 0 0110.5 11c.69 0 1.32.28 1.77.74l.73.72.73-.73a2.5 2.5 0 013.54 3.54z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56be70c40da8b36a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.67 13.02c-.22-.01-.44-.02-.67-.02-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V20h9.26a6.963 6.963 0 01-.59-6.98zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01 1 1.73 1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6188865049f6dc4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.69 18.37l1.14-1-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L20 14h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1c-.08.5-.08.76 0 1.26l-1.14 1 1 1.73 1.45-.49c.32.27.68.48 1.08.63L18 24h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1c.08-.51.08-.77 0-1.27zM19 21c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM11 7v5.41l2.36 2.36 1.04-1.79-1.4-1.39V7h-2zm10 5a9 9 0 00-9-9C9.17 3 6.65 4.32 5 6.36V4H3v6h6V8H6.26A7.01 7.01 0 0112 5c3.86 0 7 3.14 7 7h2zm-10.14 6.91c-2.99-.49-5.35-2.9-5.78-5.91H3.06c.5 4.5 4.31 8 8.94 8h.07l-1.21-2.09z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac030452d0c5eb5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.83 7h-2.6L10.5 4 4 7.4V17c-1.1 0-2-.9-2-2V7.17c0-.53.32-1.09.8-1.34L10.5 2l7.54 3.83c.43.23.73.7.79 1.17zM20 8H7c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2zm0 3.67L13.5 15 7 11.67V10l6.5 3.33L20 10v1.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$173c298602ef5873(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M-618-3000H782V600H-618zM0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da6a0a9449f94d85(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v2H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$972f7293a9138ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12l-4 4-1.41-1.41L18.17 13h-5.23A8.974 8.974 0 018 20.05 3.005 3.005 0 015 23c-1.66 0-3-1.34-3-3s1.34-3 3-3c.95 0 1.78.45 2.33 1.14A6.969 6.969 0 0010.91 13h-3.1C7.4 14.16 6.3 15 5 15c-1.66 0-3-1.34-3-3s1.34-3 3-3c1.3 0 2.4.84 2.82 2h3.1c-.32-2.23-1.69-4.1-3.59-5.14C6.78 6.55 5.95 7 5 7 3.34 7 2 5.66 2 4s1.34-3 3-3a2.99 2.99 0 012.99 2.95A8.974 8.974 0 0112.93 11h5.23l-1.58-1.59L18 8l4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$356c483b564a651a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19h12v2H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$33c8afe59de2fab3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 13.5c0 2-2.5 3.5-2.5 5h-2c0-1.5-2.5-3-2.5-5 0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5zm-2.5 6h-2V21h2v-1.5zm6-6.5c0 1.68-.59 3.21-1.58 4.42l1.42 1.42a8.978 8.978 0 00-1-12.68l-1.42 1.42A6.993 6.993 0 0119 13zm-3-8l-4-4v3a9 9 0 00-9 9c0 2.23.82 4.27 2.16 5.84l1.42-1.42A6.938 6.938 0 015 13c0-3.86 3.14-7 7-7v3l4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8638c9c20556cfd6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14.67L3.41 6.09 2 7.5l8.5 8.5H4v2h16v-2h-6.5l5.15-5.15A2.5 2.5 0 1019.5 6 2.5 2.5 0 0017 8.5c0 .35.07.67.2.97l-5.2 5.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b1505fd7f648a2fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12l-4.37 6.16c-.37.52-.98.84-1.63.84h-3v-6H9v-3H3V7c0-1.1.9-2 2-2h10c.65 0 1.26.31 1.63.84L21 12zm-11 3H7v-3H5v3H2v2h3v3h2v-3h3v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$23df2194940febd6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6 11.97h-5l2.26-2.26a4.94 4.94 0 00-3.76-1.74c-2.37 0-4.35 1.66-4.86 3.88l-.96-.32c.64-2.62 3-4.56 5.82-4.56 1.78 0 3.37.79 4.47 2.03L18 8.97v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b09182cbdd02d997(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 12c0-3.57 2.2-6.62 5.31-7.87.89-.36.75-1.69-.19-1.9-1.1-.24-2.27-.3-3.48-.14-4.51.6-8.12 4.31-8.59 8.83C4.44 16.93 9.13 22 15.01 22c.73 0 1.43-.08 2.12-.23.95-.21 1.1-1.53.2-1.9A8.46 8.46 0 0112.01 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$11117f51824c5b23(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.18 10.94c.2-.44.32-.92.32-1.44C15.5 7.57 13.93 6 12 6c-.52 0-1 .12-1.44.32l4.62 4.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 13c-2.32 0-4.45.8-6.14 2.12A7.957 7.957 0 014 12c0-1.85.63-3.55 1.69-4.9l2.86 2.86a3.47 3.47 0 002.99 2.99l2.2 2.2c-.57-.1-1.15-.15-1.74-.15zm6.31 1.9L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.54-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$671f98548428573d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15h-2a1.003 1.003 0 01-1.95.32c-.15-.44-.4-1.08-.93-1.61l-1.36-1.36C9.28 11.87 9 11.19 9 10.5a2.5 2.5 0 014.95-.5h2.02c-.25-2.25-2.16-4-4.47-4C9.02 6 7 8.02 7 10.5c0 1.22.49 2.41 1.35 3.27l1.36 1.36c.17.17.31.44.44.82A3.013 3.013 0 0013 18c1.65 0 3-1.35 3-3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.6 6.58l1.58 1.26c.35-.57.77-1.1 1.24-1.57L4.85 5.02c-.47.47-.88 1-1.25 1.56zM9.46 4.42l-.87-1.81c-.63.23-1.24.52-1.8.87l.87 1.81c.56-.36 1.16-.65 1.8-.87zM4.49 9.26l-1.96-.45c-.21.63-.36 1.28-.44 1.95l1.96.45a7.9 7.9 0 01.44-1.95zM20.4 6.58a9.4 9.4 0 00-1.25-1.56l-1.58 1.26c.48.47.89.99 1.24 1.57l1.59-1.27zM4.04 12.79l-1.96.45c.08.67.23 1.33.44 1.95l1.97-.45c-.22-.62-.38-1.27-.45-1.95zM17.21 3.48c-.57-.35-1.17-.64-1.8-.87l-.87 1.81c.64.22 1.24.51 1.8.87l.87-1.81zM13 4.07V2.05c-.33-.03-.66-.05-1-.05s-.67.02-1 .05v2.02c.33-.04.66-.07 1-.07s.67.03 1 .07zM11 19.93v2.02c.33.03.66.05 1 .05s.67-.02 1-.05v-2.02c-.33.04-.66.07-1 .07s-.67-.03-1-.07zM19.51 14.74l1.97.45c.21-.63.36-1.28.44-1.95l-1.96-.45c-.07.68-.23 1.33-.45 1.95zM19.96 11.21l1.96-.45a9.69 9.69 0 00-.44-1.95l-1.97.45c.22.62.38 1.27.45 1.95zM17.58 17.73l1.58 1.26c.47-.48.88-1 1.25-1.56l-1.58-1.26a9.4 9.4 0 01-1.25 1.56zM6.79 20.52c.57.35 1.17.64 1.8.87l.87-1.81c-.64-.22-1.24-.51-1.8-.87l-.87 1.81zM14.54 19.58l.87 1.81c.63-.23 1.24-.52 1.8-.87l-.87-1.81c-.56.36-1.16.65-1.8.87zM3.6 17.42a9.4 9.4 0 001.25 1.56l1.58-1.26a7.87 7.87 0 01-1.24-1.57L3.6 17.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2d2b8bd7616223c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c1.44 0 2.79.38 3.95 1.05L17.4 3.6C15.85 2.59 13.99 2 12 2s-3.85.59-5.41 1.59l1.45 1.45A8.034 8.034 0 0112 4zM20 12c0 1.44-.38 2.79-1.05 3.95l1.45 1.45c1.01-1.55 1.6-3.41 1.6-5.4s-.59-3.85-1.59-5.41l-1.45 1.45A8.034 8.034 0 0120 12zM12 20c-1.44 0-2.79-.38-3.95-1.05L6.6 20.4C8.15 21.41 10.01 22 12 22s3.85-.59 5.41-1.59l-1.45-1.45A8.034 8.034 0 0112 20zM4 12c0-1.44.38-2.79 1.05-3.95L3.59 6.59C2.59 8.15 2 10.01 2 12s.59 3.85 1.59 5.41l1.45-1.45A8.034 8.034 0 014 12zM11.5 6C9.02 6 7 8.02 7 10.5c0 1.22.49 2.41 1.35 3.27l1.36 1.36c.17.17.31.44.44.82A3.013 3.013 0 0013 18c1.65 0 3-1.35 3-3h-2a1.003 1.003 0 01-1.95.32c-.15-.44-.4-1.08-.93-1.61l-1.36-1.36C9.28 11.87 9 11.19 9 10.5a2.5 2.5 0 014.95-.5h2.02c-.25-2.25-2.16-4-4.47-4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f203d5f101d4dbe3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11.05l-3.42-3.42c.32-.34.74-.57 1.23-.61.48-.04.84.07 1.2.26.19.1.39.22.63.46l1.29 1.43c.98 1.08 2.53 1.85 4.07 1.83v2c-1.75-.01-3.71-.88-5-1.95zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM2.81 2.81L1.39 4.22 10 12.83V15c0 1.1.9 2 2 2h2.17l5.61 5.61 1.41-1.41L2.81 2.81zM10 20c-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 105.9 5.9h-2.07c-.41 1.16-1.52 2-2.83 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f34f0a36be73e2e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm1 0V8l5 4-5 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a79e0b06bf60ac9e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b54accccf7e3aa2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zM11.48 20v-6.26H8L13 4v6.26h3.35L11.48 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a04c4d5f045745df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$95ae902c50df33d2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h2v1h-2zM12 11c-1.1 0-2 .9-2 2 0 .74.4 1.38 1 1.72v.78h2v-.78c.6-.35 1-.98 1-1.72 0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1.01L6 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM18 18H6V6h12v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.01 15.95c.62-.83.99-1.84.99-2.95s-.37-2.12-.99-2.95l-1.07 1.07c.35.54.56 1.19.56 1.88s-.21 1.34-.56 1.88l1.07 1.07zM9.06 14.88c-.35-.54-.56-1.19-.56-1.88 0-1.93 1.57-3.5 3.5-3.5v1.25l2.25-2-2.25-2V8c-2.76 0-5 2.24-5 5 0 1.11.37 2.12.99 2.95l1.07-1.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b8d688a2f014ae55(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 11.5c0 2-2.5 3.5-2.5 5h-2c0-1.5-2.5-3-2.5-5C8.5 9.57 10.07 8 12 8s3.5 1.57 3.5 3.5zm-2.5 6h-2V19h2v-1.5zm9-5.5c0-2.76-1.12-5.26-2.93-7.07l-1.06 1.06A8.481 8.481 0 0120.5 12c0 2.34-.95 4.47-2.49 6.01l1.06 1.06A9.969 9.969 0 0022 12zM3.5 12c0-2.34.95-4.47 2.49-6.01L4.93 4.93A9.969 9.969 0 002 12c0 2.76 1.12 5.26 2.93 7.07l1.06-1.06A8.481 8.481 0 013.5 12zm14 0c0 1.52-.62 2.89-1.61 3.89l1.06 1.06A6.976 6.976 0 0019 12c0-1.93-.78-3.68-2.05-4.95l-1.06 1.06c.99 1 1.61 2.37 1.61 3.89zM7.05 16.95l1.06-1.06c-1-1-1.61-2.37-1.61-3.89s.62-2.89 1.61-3.89L7.05 7.05A6.976 6.976 0 005 12c0 1.93.78 3.68 2.05 4.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7a9d970090746f18(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0H0v24h24V0zm0 0H0v24h24V0zM0 24h24V0H0v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 8L12 2.35 6.34 8A8.02 8.02 0 004 13.64c0 2 .78 4.11 2.34 5.67a7.99 7.99 0 0011.32 0c1.56-1.56 2.34-3.67 2.34-5.67S19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f8a60d3f26d6ff3a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a124cb23cda2df8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a0c1dbba3086d14b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.79 5.8L14 3h7v7l-2.79-2.8-4.09 4.09-1.41-1.41 4.08-4.08zM19 12v4.17l2 2V12h-2zm.78 10.61L18.17 21H5a2 2 0 01-2-2V5.83L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM16.17 19l-4.88-4.88-1.59 1.59-1.41-1.41 1.59-1.59L5 7.83V19h11.17zM7.83 5H12V3H5.83l2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9313fa7a1f82fdda(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a819fe0081dff65b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$667d38626dcce782(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.88 9.54L8.92 16.5l-1.41-1.41 4.96-4.96L10.34 8l5.65.01.01 5.65-2.12-2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4bd2e4ecaee48251(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.88 9.54L8.92 16.5l-1.41-1.41 4.96-4.96L10.34 8l5.65.01.01 5.65-2.12-2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c5987b35c0a92e69(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zM8 11h2v3h4v-3h2l-4-4-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$26e204b8ebf33b7d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 11c.17 0 .34.01.5.03V6.87C19 5.84 18.16 5 17.13 5H3.87C2.84 5 2 5.84 2 6.87v10.26C2 18.16 2.84 19 3.87 19h9.73c-.38-.75-.6-1.6-.6-2.5 0-3.04 2.46-5.5 5.5-5.5zm-8.1 2L4 9.19V7h.23l6.18 3.68L16.74 7H17v2.16L10.4 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13l-1.41 1.41L19.17 16H15v2h4.17l-1.58 1.59L19 21l4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6f97d978f156d18(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9 12c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1zm5 6h-4v-2c0-1.1.9-2 2-2s2 .9 2 2v2zm2-7c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$808e2aec9bc44ac7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17l5-5-5-5-1.41 1.41L18.17 11H9v2h9.17l-2.58 2.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h14v2h2V5a2 2 0 00-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14a2 2 0 002-2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$18f74a022b3be37(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9a2.5 2.5 0 000 5 2.5 2.5 0 000-5zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa5008424c709d01(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.88 15.76V19h-1.75v-1.29c-.74-.18-2.39-.77-3.02-2.96l1.65-.67c.06.22.58 2.09 2.4 2.09.93 0 1.98-.48 1.98-1.61 0-.96-.7-1.46-2.28-2.03-1.1-.39-3.35-1.03-3.35-3.31 0-.1.01-2.4 2.62-2.96V5h1.75v1.24c1.84.32 2.51 1.79 2.66 2.23l-1.58.67c-.11-.35-.59-1.34-1.9-1.34-.7 0-1.81.37-1.81 1.39 0 .95.86 1.31 2.64 1.9 2.4.83 3.01 2.05 3.01 3.45 0 2.63-2.5 3.13-3.02 3.22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ceab592ca7459f9f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.98 14.82l-.63 4.46c-.14.99-.99 1.72-1.98 1.72h-6.16c-.53 0-1.29-.21-1.66-.59L5 15.62l.83-.84c.24-.24.58-.35.92-.28l3.25.74V4.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v6h.91c.31 0 .62.07.89.21l4.09 2.04c.77.39 1.21 1.22 1.09 2.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2158a01682910d1b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5336be5d5e402870(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f619350294caea23(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L16.5 17.2V14h1v2.79l1.85 1.85-.7.71zM18 3h-3.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H6c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h6.11a6.743 6.743 0 01-1.42-2H6V5h2v3h8V5h2v5.08c.71.1 1.38.31 2 .6V5c0-1.1-.9-2-2-2zm-6 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$32b3ba02caad6c02(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ccac0274bb5eefe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 11C9.43 11 11 9.43 11 7.5S9.43 4 7.5 4 4 5.57 4 7.5 5.57 11 7.5 11zm0-5C8.33 6 9 6.67 9 7.5S8.33 9 7.5 9 6 8.33 6 7.5 6.67 6 7.5 6zM4.002 18.583L18.59 3.996l1.414 1.414L5.417 19.997zM16.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$34bff24f4696a4ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$25f806473e7e9d0d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a81da5a38ebe9071(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83a.26.26 0 00.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83a3.908 3.908 0 000 .98l-1.06.83a.26.26 0 00-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73a.26.26 0 00-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$17e15ffee620dc15(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$46a7b5aba0594de2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.9a2.1 2.1 0 110 4.2 2.1 2.1 0 010-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$973c88727ab4e6e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$562e328407cf8b2b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.074 15.074 0 01-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da54af9f71ef150(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e5b72b842110b5a7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "9.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "5.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "5.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "9.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b61ce1fcac78ce41(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h1.5v6H13v-2.5h-2V15H9.5V9H11v2h2V9zm-5 1.5v1c0 .8-.7 1.5-1.5 1.5h-2v2H3V9h3.5c.8 0 1.5.7 1.5 1.5zm-1.5 0h-2v1h2v-1zm15 0v1c0 .8-.7 1.5-1.5 1.5h-2v2h-1.5V9H20c.8 0 1.5.7 1.5 1.5zm-1.5 0h-2v1h2v-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$42f208c5cd3a92a9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7a16518b75eaf87e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$89e225f2c44e5312(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12V6H4v12h10v2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v6h-2zm-1 2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm-4.34-6H9v5.66l2.12-2.12 2.83 2.83 1.41-1.41-2.83-2.83L14.66 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b3d98a37fdaffff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10v2H4v12h16v-6h2zm0-5c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm-10.53 5.12l-2.83 2.83 1.41 1.41 2.83-2.83L15 15.66V10H9.34l2.13 2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5587c0b1f3f23bf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2.5V1h5v5H9.5V3.56L3.56 9.5H6V11H1V6h1.5v2.44L8.44 2.5H6zm16.98 14.32l-.63 4.46c-.14.99-.99 1.72-1.98 1.72h-6.16c-.53 0-1.29-.21-1.66-.59L8 17.62l.83-.84c.24-.24.58-.35.92-.28l3.25.74V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v6h.91c.31 0 .62.07.89.21l4.09 2.04c.77.39 1.21 1.22 1.09 2.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a787396953cef96(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm1.04 17.45l-1.88-1.88c-1.33.71-3.01.53-4.13-.59a3.495 3.495 0 010-4.95 3.495 3.495 0 014.95 0 3.48 3.48 0 01.59 4.13l1.88 1.88-1.41 1.41zM13 9V3.5L18.5 9H13z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a2aff6e225e5a1fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ded4140baee5e654(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a48adbc4f48e8e5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42A6.92 6.92 0 0119 12c0 3.87-3.13 7-7 7A6.995 6.995 0 017.58 6.58L6.17 5.17A8.932 8.932 0 003 12a9 9 0 0018 0c0-2.74-1.23-5.18-3.17-6.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dfdfec7b9f854244(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9a3.285 3.285 0 00-2-3c0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$44edc2ae4d938818(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 16H5V7h14v12zm-5.5-6c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zM12 9c-2.73 0-5.06 1.66-6 4 .94 2.34 3.27 4 6 4s5.06-1.66 6-4c-.94-2.34-3.27-4-6-4zm0 6.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2d0197cd2242aff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b393a60efcfda14(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 6h2v2h-2V7zm0 4h2v6h-2v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1838df6d0a87df6e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.93 11c-.49-3.39-3.4-6-6.93-6s-6.44 2.61-6.93 6H2v2h3.07c.49 3.39 3.4 6 6.93 6s6.44-2.61 6.93-6H22v-2h-3.07zM15 14.5c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1v-1a2 2 0 012.34-1.97c.98.16 1.66 1.08 1.66 2.08v.89c.55 0 1 .45 1 1v3zM12.75 13c0 .41-.34.75-.75.75s-.75-.34-.75-.75.34-.75.75-.75.75.34.75.75zM13 9.5v1h-2v-1c0-.55.45-1 1-1s1 .45 1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da52c023c3b1bd67(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2V8h2v2zm0-4h-2V1h2v5zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03L21 4.96 19.25 4l-3.7 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$97d145123bfd63f7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 9.53l-7.07 7.07-4.24-4.24 1.41-1.41 2.83 2.83 5.66-5.66 1.41 1.41zM4 12c0-2.33 1.02-4.42 2.62-5.88L9 8.5v-6H3l2.2 2.2C3.24 6.52 2 9.11 2 12c0 5.19 3.95 9.45 9 9.95v-2.02c-3.94-.49-7-3.86-7-7.93zm18 0c0-5.19-3.95-9.45-9-9.95v2.02c3.94.49 7 3.86 7 7.93 0 2.33-1.02 4.42-2.62 5.88L15 15.5v6h6l-2.2-2.2c1.96-1.82 3.2-4.41 3.2-7.3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$791b3b96170fc522(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5e9a9a0238b2646(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$27e30b6f32ca02b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.07 12.85c.77-1.39 2.25-2.21 3.11-3.44.91-1.29.4-3.7-2.18-3.7-1.69 0-2.52 1.28-2.87 2.34L6.54 6.96C7.25 4.83 9.18 3 11.99 3c2.35 0 3.96 1.07 4.78 2.41.7 1.15 1.11 3.3.03 4.9-1.2 1.77-2.35 2.31-2.97 3.45-.25.46-.35.76-.35 2.24h-2.89c-.01-.78-.13-2.05.48-3.15zM14 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$352e335051ac3361(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h9v-8h7V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.5 16h-2.2l1.7-4h-5v6h2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$47d74cae83f0df5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "5",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.76 9.24L15 5 10.76.76 9.34 2.17 11.17 4H7.82C7.4 2.84 6.3 2 5 2 3.34 2 2 3.34 2 5c0 1.3.84 2.4 2 2.82v8.37C2.84 16.6 2 17.7 2 19c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82V7.82c.85-.31 1.51-.97 1.82-1.82h3.36L9.34 7.83l1.42 1.41zM10 19v3h3l6.26-6.26-3-3zM20.12 10.29a.996.996 0 00-1.41 0l-1.38 1.38 3 3 1.38-1.38a.996.996 0 000-1.41l-1.59-1.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a771e303c0b7a4c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bddf47f1b7f524be(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "9",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b6a8911b572d2bd9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 00-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d600729b97ab098c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.79 12l5.58 5.59L5.96 19 .37 13.41 1.79 12zm.45-7.78L12.9 14.89l-1.28 1.28L7.44 12l-1.41 1.41L11.62 19l2.69-2.69 4.89 4.89 1.41-1.41L3.65 2.81 2.24 4.22zm14.9 9.27L23.62 7 22.2 5.59l-6.48 6.48 1.42 1.42zM17.96 7l-1.41-1.41-3.65 3.66 1.41 1.41L17.96 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c23de89119a15f2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38A1.997 1.997 0 0017 22c.67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020 4H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f087f14e52866680(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$89c67b38e3de5351(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-6H3v6zm7.33-2v-2h3.33v2h-3.33zM19 19h-3.33v-2H19v2zM5 17h3.33v2H5v-2zM6 10l1.42-1.42L5.83 7H17c1.1 0 2 .9 2 2s-.9 2-2 2H3v2h14c2.21 0 4-1.79 4-4s-1.79-4-4-4H5.83l1.59-1.59L6 2 2 6l4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c949f725734c01fc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$991b5a04a7938ab5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm1 9h-4v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1h-2v-1H9v-2h4v-1h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1V8h2v1h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b279c98dc08911d9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3.5l-1-1h-5l-1 1H5v2h14zM6 7v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zm8 7v4h-4v-4H8l4-4 4 4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$463b9ad6938e4446(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5a3.5 3.5 0 00-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$613f718b00a8c9ad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$45858f3f132ff5cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.19 6.35c-2.04 2.29-3.44 5.58-3.57 5.89L2 10.69l4.05-4.05c.47-.47 1.15-.68 1.81-.55l1.33.26zM11.17 17s3.74-1.55 5.89-3.7c5.4-5.4 4.5-9.62 4.21-10.57-.95-.3-5.17-1.19-10.57 4.21C8.55 9.09 7 12.83 7 12.83L11.17 17zm6.48-2.19c-2.29 2.04-5.58 3.44-5.89 3.57L13.31 22l4.05-4.05c.47-.47.68-1.15.55-1.81l-.26-1.33zM9 18c0 .83-.34 1.58-.88 2.12C6.94 21.3 2 22 2 22s.7-4.94 1.88-6.12A2.996 2.996 0 019 18zm4-9c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$764d15a9fce6a51(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.5s4.5 2.04 4.5 10.5c0 2.49-1.04 5.57-1.6 7H9.1c-.56-1.43-1.6-4.51-1.6-7C7.5 4.54 12 2.5 12 2.5zm2 8.5c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-6.31 9.52c-.48-1.23-1.52-4.17-1.67-6.87l-1.13.75c-.56.38-.89 1-.89 1.67V22l3.69-1.48zM20 22v-5.93c0-.67-.33-1.29-.89-1.66l-1.13-.75c-.15 2.69-1.2 5.64-1.67 6.87L20 22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$92e8eb91bebd44a7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$97b69ac5523de827(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$987a7e06503e4556(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.35-.39.99-.73 1.65-.73h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f66f5098bb8f3dfc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.54 11L13 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L16.54 11zM11 7H2v2h9V7zm10 6.41L19.59 12 17 14.59 14.41 12 13 13.41 15.59 16 13 18.59 14.41 20 17 17.41 19.59 20 21 18.59 18.41 16 21 13.41zM11 15H2v2h9v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3b8219ce9c4fc77e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.44.59l-3.18 3.18c-.78.78-.78 2.05 0 2.83l1.24 1.24-.71.71-1.24-1.25c-.78-.78-2.05-.78-2.83 0L7.3 8.72c-.78.78-.78 2.05 0 2.83l1.24 1.24-.71.71-1.23-1.25c-.78-.78-2.05-.78-2.83 0L.59 15.43c-.78.78-.78 2.05 0 2.83l3.54 3.54c.78.78 2.05.78 2.83 0l3.18-3.18c.78-.78.78-2.05 0-2.83L8.9 14.55l.71-.71 1.24 1.24c.78.78 2.05.78 2.83 0l1.41-1.41c.78-.78.78-2.05 0-2.83L13.84 9.6l.71-.71 1.24 1.24c.78.78 2.05.78 2.83 0l3.18-3.18c.78-.78.78-2.05 0-2.83L18.26.58c-.78-.78-2.04-.78-2.82.01zM6.6 19.32l-1.06 1.06L2 16.85l1.06-1.06 3.54 3.53zm2.12-2.12l-1.06 1.06-3.54-3.54 1.06-1.06 3.54 3.54zm9.54-9.54L17.2 8.72l-3.54-3.54 1.06-1.06 3.54 3.54zm2.12-2.12L19.32 6.6l-3.54-3.54L16.85 2l3.53 3.54zM14 21v2a9 9 0 009-9h-2c0 3.87-3.13 7-7 7zm0-4v2c2.76 0 5-2.24 5-5h-2c0 1.66-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b01d682a39cb7cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm-2.17-1.5l2.14-1.53 2.14 1.53-.83-2.46 2.15-1.5h-2.62L9.47 6l-.84 2.54H6l2.14 1.49z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc213db293d0f7b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.83 7.5l-2.27-2.27c.07-.42.18-.81.32-1.15A1.498 1.498 0 0016.5 2c-1.64 0-3.09.79-4 2h-5C4.46 4 2 6.46 2 9.5S4.5 21 4.5 21H10v-2h2v2h5.5l1.68-5.59 2.82-.94V7.5h-2.17zM13 9H8V7h5v2zm3 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4571fa26d6622bd7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12.5H15v4l3 2 .75-1.23-2.25-1.52V12.5zM16 9L2 3v7l9 2-9 2v7l7.27-3.11C10.09 20.83 12.79 23 16 23c3.86 0 7-3.14 7-7s-3.14-7-7-7zm0 12c-2.75 0-4.98-2.22-5-4.97v-.07a5.008 5.008 0 015-4.97c2.76 0 5 2.24 5 5S18.76 21 16 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bbab0d08b3c6643f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ef9090ebd3152582(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 009.5 3C6.08 3 3.28 5.64 3.03 9h2.02C5.3 6.75 7.18 5 9.5 5 11.99 5 14 7.01 14 9.5S11.99 14 9.5 14c-.17 0-.33-.03-.5-.05v2.02c.17.02.33.03.5.03 1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.47 10.82L4 13.29l-2.47-2.47-.71.71L3.29 14 .82 16.47l.71.71L4 14.71l2.47 2.47.71-.71L4.71 14l2.47-2.47z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5bd51df252223bdc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$74c774a9f36a07e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18h12v-2H9v2zM3 6v2h18V6H3zm6 7h12v-2H9v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f0bafed055e4fe0b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10h-3L2 3v7l9 2-9 2v7l8-3.5V21c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2zm0 11h-9v-9h9v9zm-4.5-1L13 16h2v-3h3v3h2l-3.5 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6fab7ea28549dc7a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.14 10.96c-.09.33-.14.68-.14 1.04 0 1.1.45 2.1 1.17 2.83l-1.42 1.42A6.018 6.018 0 016 12c0-.93.21-1.8.58-2.59L5.11 7.94A7.897 7.897 0 004 12c0 2.21.9 4.21 2.35 5.65l-1.42 1.42A9.969 9.969 0 012 12c0-2.04.61-3.93 1.66-5.51L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41L8.14 10.96zm9.28 3.63c.37-.79.58-1.66.58-2.59 0-1.66-.67-3.16-1.76-4.24l-1.42 1.42a3.951 3.951 0 011.04 3.86l1.56 1.55zM20 12c0 1.48-.4 2.87-1.11 4.06l1.45 1.45A9.91 9.91 0 0022 12c0-2.76-1.12-5.26-2.93-7.07l-1.42 1.42A7.94 7.94 0 0120 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9767372f64c3f2cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.76 16.24C6.67 15.16 6 13.66 6 12s.67-3.16 1.76-4.24l1.42 1.42C8.45 9.9 8 10.9 8 12c0 1.1.45 2.1 1.17 2.83l-1.41 1.41zm8.48 0C17.33 15.16 18 13.66 18 12s-.67-3.16-1.76-4.24l-1.42 1.42C15.55 9.9 16 10.9 16 12c0 1.1-.45 2.1-1.17 2.83l1.41 1.41zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm8 2c0 2.21-.9 4.21-2.35 5.65l1.42 1.42C20.88 17.26 22 14.76 22 12s-1.12-5.26-2.93-7.07l-1.42 1.42A7.94 7.94 0 0120 12zM6.35 6.35L4.93 4.93C3.12 6.74 2 9.24 2 12s1.12 5.26 2.93 7.07l1.42-1.42C4.9 16.21 4 14.21 4 12s.9-4.21 2.35-5.65z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a83fdaf3b42db432(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 4c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 6c1.86.5 4 .83 6 1v12h2v-6h2v6h2V7c2-.17 4.14-.5 6-1l-.5-2zM12 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8667292718b5a817(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42a.353.353 0 01.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16a.353.353 0 01-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a3e4c6e9c7412796(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9a9 9 0 00-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7a6.995 6.995 0 01-11.06 5.7l-1.42 1.44A9 9 0 1012 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$28e60e7168a25360(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dbc9ab2de08c843e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$35bf13271ff4ace5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6dabb74b8db684d3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ef9bd93f40c5b8a6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29a2.5 2.5 0 00-5 0c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2a9 9 0 0118 0h2c0-6.07-4.93-11-11-11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e9017e0cbaed761c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc26af479a563f00(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c1c5efce85b38ae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3dd1960709c03d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1072f480142f7974(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1a2bb42adf184321(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.074 15.074 0 01-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ebf7a6da3b5c5410(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45A5.969 5.969 0 0118 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44A7.961 7.961 0 004 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$629dff522ce553f0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41a5.022 5.022 0 017.08 0l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$42bd02feb10aa8f1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8bf548d45b3a4200(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.488.488 0 00-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 00-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de6f28893895a3c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9H1v11c0 1.11.89 2 2 2h16v-2H3V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3.5L12 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2515607bd48c179b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d49fb54a09e351e7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$10fab6a8e56a3f32(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h-2c0-2.21-1.79-4-4-4S8 3.79 8 6H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-8 4c0 .55-.45 1-1 1s-1-.45-1-1V8h2v2zm2-6c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2zm4 6c0 .55-.45 1-1 1s-1-.45-1-1V8h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a589985561b93cb0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.21 9l-4.38-6.56a.993.993 0 00-.83-.42c-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ba5388048f317728(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03L21 4.96 19.25 4l-3.7 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2zM12 2l4 4-4 4-1.41-1.41L12.17 7H8V5h4.17l-1.59-1.59L12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$45587b26ff4fe53e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$17dec53242da6841(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9v6c0 1.1-.9 2-2 2h-1v-2h1V9H4v6h6v2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-7.5 10l1.09-2.41L18 15.5l-2.41-1.09L14.5 12l-1.09 2.41L11 15.5l2.41 1.09L14.5 19zm2.5-5l.62-1.38L19 12l-1.38-.62L17 10l-.62 1.38L15 12l1.38.62L17 14zm-2.5 5l1.09-2.41L18 15.5l-2.41-1.09L14.5 12l-1.09 2.41L11 15.5l2.41 1.09L14.5 19zm2.5-5l.62-1.38L19 12l-1.38-.62L17 10l-.62 1.38L15 12l1.38.62L17 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffa4ac0b42b826c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 10H6v-2h8v2zm4-4H6v-2h12v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f30628fee8257ebe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h6v18zm2 0h6c1.1 0 2-.9 2-2v-7h-8v9zm8-11V5c0-1.1-.9-2-2-2h-6v7h8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fce0dd14c35736a2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "9",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 002 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM20.36 1l-1.41 1.41a7.007 7.007 0 010 9.9l1.41 1.41a8.98 8.98 0 000-12.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.54 10.9a5.003 5.003 0 000-7.07l-1.41 1.41a3 3 0 010 4.24l1.41 1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8544ec6578f27cd0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "9",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 002 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM16 1h-2a9 9 0 009 9V8c-3.86 0-7-3.14-7-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 1h-2c0 2.76 2.24 5 5 5V4c-1.65 0-3-1.35-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7a4418cb39136bcf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "9",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 002 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM20.05 2.41L18.64 1c-3.51 3.51-3.51 9.21 0 12.73l1.41-1.41c-2.73-2.74-2.73-7.18 0-9.91z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.88 5.24l-1.41-1.41a5.003 5.003 0 000 7.07l1.41-1.41a3.012 3.012 0 010-4.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$653822c173ace6fc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8c8b265fba593bc1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a56b5e4ed3082525(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5eefdb58f598d766(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.43 10L12 2l-2.43 8H2l6.18 4.41L5.83 22 12 17.31 18.18 22l-2.35-7.59L22 10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6bd7864de7940625(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$90efba0195880c35(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H4.99C3.89 3 3 3.9 3 5l.01 14c0 1.1.89 2 1.99 2h10l6-6V5c0-1.1-.9-2-2-2zM7 8h10v2H7V8zm5 6H7v-2h5v2zm2 5.5V14h5.5L14 19.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5bcb861bd52e0f76(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1d1b1d3bfc58de39(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af4d082c962aba49(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H6.83l8 8H20v2h-3.17l4.93 4.93c.15-.28.24-.59.24-.93V6c0-1.1-.9-2-2-2zM1.04 3.87l1.2 1.2C2.09 5.35 2 5.66 2 6v12c0 1.1.9 2 2 2h13.17l2.96 2.96 1.41-1.41L2.45 2.45 1.04 3.87zM8 12v2H4v-2h4zm6 4.83V18H4v-2h9.17l.83.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$adfda702cf9f5162(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36 0 1.3-1.06 2.36-2.36 2.36s-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8225bf34d874b961(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7a2.5 2.5 0 000 5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$58bc3dd46dcef8de(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.46 7.12l-2.78 1.15a4.982 4.982 0 00-2.95-2.94l1.15-2.78c2.1.8 3.77 2.47 4.58 4.57zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM9.13 4.54l1.17 2.78a5 5 0 00-2.98 2.97L4.54 9.13a7.984 7.984 0 014.59-4.59zM4.54 14.87l2.78-1.15a4.968 4.968 0 002.97 2.96l-1.17 2.78a7.996 7.996 0 01-4.58-4.59zm10.34 4.59l-1.15-2.78a4.978 4.978 0 002.95-2.97l2.78 1.17a8.007 8.007 0 01-4.58 4.58z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$96cbeaf67e4dacbf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d5f17e04af61588(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-7-5.5l3.5 3.5-3.5 3.5V11h-4V9h4V6.5zm-6 11L5.5 14 9 10.5V13h4v2H9v2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$31f2e786456292d8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7360a6b81b1a07b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$264d88bec3eec986(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13.9a5 5 0 10-2 0v4.27l-1.59-1.59L8 18l4 4 4-4-1.41-1.41L13 18.17V13.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c3c0215a5b68fb64(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.8 12.18c-.2-.86-.3-1.76-.3-2.68 0-2.84.99-5.45 2.63-7.5L7.2 3.07a10.457 10.457 0 00-1.88 8.99l1.62-1.62L8 11.5 4.5 15 1 11.5l1.06-1.06 1.74 1.74zm10.05-.56l-2.68-5.37a1.498 1.498 0 00-2.01-.67c-.75.38-1.05 1.28-.68 2.02l4.81 9.6-3.24.8c-.33.09-.59.33-.7.66L9 19.78l6.19 2.25c.5.17 1.28.02 1.75-.22l5.51-2.75c.89-.45 1.32-1.48 1-2.42l-1.43-4.27a2 2 0 00-1.9-1.37h-4.56c-.31 0-.62.07-.89.21l-.82.41"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df69b00a3def2254(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1 13a5 5 0 100-2H5.83l1.59-1.59L6 8l-4 4 4 4 1.41-1.41L5.83 13h4.27z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ceaa20580f7e499b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.98 16.82l-.63 4.46c-.14.99-.99 1.72-1.98 1.72h-6.16c-.53 0-1.29-.21-1.66-.59L5 17.62l.83-.84c.24-.24.58-.35.92-.28l3.25.74V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v6h.91c.31 0 .62.07.89.21l4.09 2.04c.77.39 1.21 1.22 1.09 2.07zM12 2.5c4.74 0 7.67 2.52 8.43 4.5H22c-.73-2.88-4.51-6-10-6-3.22 0-6.18 1.13-8.5 3.02V2H2v5h5V5.5H4.09c2.12-1.86 4.88-3 7.91-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$99aaa8a728f01fed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9 11a5 5 0 100 2h4.27l-1.59 1.59L18 16l4-4-4-4-1.41 1.41L18.17 11H13.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$609b105a8f5cff28(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.98 16.82l-.63 4.46c-.14.99-.99 1.72-1.98 1.72h-6.16c-.53 0-1.29-.21-1.66-.59L5 17.62l.83-.84c.24-.24.58-.35.92-.28l3.25.74V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v6h.91c.31 0 .62.07.89.21l4.09 2.04c.77.39 1.21 1.22 1.09 2.07zM19.91 5.5H17V7h5V2h-1.5v2.02A13.413 13.413 0 0012 1C6.51 1 2.73 4.12 2 7h1.57C4.33 5.02 7.26 2.5 12 2.5c3.03 0 5.79 1.14 7.91 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$33fb105ed9e9fc4b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.83l1.59 1.59L16 6l-4-4-4 4 1.41 1.41L11 5.83v4.27a5 5 0 102 0V5.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$26954c5a67cf70c8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.06 5.56L1 4.5 4.5 1 8 4.5 6.94 5.56 5.32 3.94a10.457 10.457 0 001.88 8.99L6.13 14A11.974 11.974 0 013.5 6.5c0-.92.1-1.82.3-2.68L2.06 5.56zm11.79 6.06l-2.68-5.37a1.498 1.498 0 00-2.01-.67c-.75.38-1.05 1.28-.68 2.02l4.81 9.6-3.24.8c-.33.09-.59.33-.7.66L9 19.78l6.19 2.25c.5.17 1.28.02 1.75-.22l5.51-2.75c.89-.45 1.32-1.48 1-2.42l-1.43-4.27a2 2 0 00-1.9-1.37h-4.56c-.31 0-.62.07-.89.21l-.82.41"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e0ed50d0e1e314e8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3.5h2.02C1.13 5.82 0 8.78 0 12s1.13 6.18 3.02 8.5H1V22h5v-5H4.5v2.91c-1.86-2.11-3-4.88-3-7.91s1.14-5.79 3-7.91V7H6V2H1v1.5zm12.85 8.12l-2.68-5.37a1.498 1.498 0 00-2.01-.67c-.75.38-1.05 1.28-.68 2.02l4.81 9.6-3.24.8c-.33.09-.59.33-.7.66L9 19.78l6.19 2.25c.5.17 1.28.02 1.75-.22l5.51-2.75c.89-.45 1.32-1.48 1-2.42l-1.43-4.27a2 2 0 00-1.9-1.37h-4.56c-.31 0-.62.07-.89.21l-.82.41"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$432dfcdc40060127(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.89 14.75l-4.09-2.04c-.28-.14-.58-.21-.89-.21H13v-6c0-.83-.67-1.5-1.5-1.5S10 5.67 10 6.5v10.74l-3.25-.74a.99.99 0 00-.92.28l-.83.84 4.54 4.79c.38.38 1.14.59 1.67.59h6.16c1 0 1.84-.73 1.98-1.72l.63-4.46c.12-.85-.32-1.68-1.09-2.07z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.13 3.87C18.69 2.17 15.6 1 12 1S5.31 2.17 3.87 3.87L2 2v5h5L4.93 4.93c1-1.29 3.7-2.43 7.07-2.43s6.07 1.14 7.07 2.43L17 7h5V2l-1.87 1.87z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$311e22ad754c3a61(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 14h-2v-2h-2v2h-2v2h2v2h2v-2h2v-2zM7.06 8.94L5 8l2.06-.94L8 5l.94 2.06L11 8l-2.06.94L8 11l-.94-2.06zM8 21l.94-2.06L11 18l-2.06-.94L8 15l-.94 2.06L5 18l2.06.94L8 21zm-3.63-8.63L3 13l1.37.63L5 15l.63-1.37L7 13l-1.37-.63L5 11l-.63 1.37zM12 12c0-2.73 1.08-5.27 2.75-7.25L12 2h7v7l-2.82-2.82C14.84 7.82 14 9.88 14 12c0 3.32 2.1 6.36 5 7.82V22c-4.09-1.59-7-5.65-7-10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$949a0227eaabb579(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.06 8.94L5 8l2.06-.94L8 5l.94 2.06L11 8l-2.06.94L8 11l-.94-2.06zM8 21l.94-2.06L11 18l-2.06-.94L8 15l-.94 2.06L5 18l2.06.94L8 21zm-3.63-8.63L3 13l1.37.63L5 15l.63-1.37L7 13l-1.37-.63L5 11l-.63 1.37zM12 12c0-2.73 1.08-5.27 2.75-7.25L12 2h7v7l-2.82-2.82C14.84 7.82 14 9.88 14 12c0 3.32 2.1 6.36 5 7.82V22c-4.09-1.59-7-5.65-7-10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1c09868f31a860b8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12l4-4-4-4v3H3v2h15zM6 12l-4 4 4 4v-3h15v-2H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa905879dfff93b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 .5h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fdec3f2c003c9cd7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e232dfd428d118c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bfa449b0f4dedf42(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7H9c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 2v2H9V9h10zm-6 6v-2h2v2h-2zm2 2v2h-2v-2h2zm-4-2H9v-2h2v2zm6-2h2v2h-2v-2zm-8 4h2v2H9v-2zm8 2v-2h2v2h-2zM6 17H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v1h-2V5H5v10h1v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a55390f0f11dba05(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.18L10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10L22 5.18zm-2.21 5.04c.13.57.21 1.17.21 1.78 0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8c1.58 0 3.04.46 4.28 1.25l1.44-1.44A9.9 9.9 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-1.19-.22-2.33-.6-3.39l-1.61 1.61z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a154b45843dd7fe3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm0 14H4V8h16v10zm-2-1h-6v-2h6v2zM7.5 17l-1.41-1.41L8.67 13l-2.59-2.59L7.5 9l4 4-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$315e88ea8d826923(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12v1.5l11 4.75v-2.1l-2.2-.9v-5l2.2-.9v-2.1L3 12zm7 2.62l-5.02-1.87L10 10.88v3.74zm8-10.37l-3 3h2v12.5h2V7.25h2l-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8c9e135120370bb6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.75 5h-1.5L9.5 16h2.1l.9-2.2h5l.9 2.2h2.1L15.75 5zm-2.62 7L15 6.98 16.87 12h-3.74zM6 19.75l3-3H7V4.25H5v12.5H3l3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c389e9d045aab931(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.4 4.91l-1.06-1.06L7.2 8.27l1.48 1.48 2.19-.92 3.54 3.54-.92 2.19 1.48 1.48L19.4 4.91zm-6.81 3.1l4.87-2.23-2.23 4.87-2.64-2.64zM14.27 21v-4.24l-1.41 1.41-8.84-8.84-1.42 1.42 8.84 8.84L10.03 21h4.24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$314d54c477d794a2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.49 4.21L3.43 5.27 7.85 16.4l1.48-1.48-.92-2.19 3.54-3.54 2.19.92 1.48-1.48L4.49 4.21zm3.09 6.8L5.36 6.14l4.87 2.23-2.65 2.64zm12.99-1.68h-4.24l1.41 1.41-8.84 8.84L10.32 21l8.84-8.84 1.41 1.41V9.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c1c7ad91bcd41a63(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v-1.5L10 5.75v2.1l2.2.9v5l-2.2.9v2.1L21 12zm-7-2.62l5.02 1.87L14 13.12V9.38zM6 19.75l3-3H7V4.25H5v12.5H3l3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a924613cfaedb79a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.75 3h-1.5L6.5 14h2.1l.9-2.2h5l.9 2.2h2.1L12.75 3zm-2.62 7L12 4.98 13.87 10h-3.74zm10.37 8l-3-3v2H5v2h12.5v2l3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bd87921327c52f7b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8763e3fef0f93f7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.89 18.28l.57-2.89c.12-.59-.04-1.2-.42-1.66-.38-.46-.94-.73-1.54-.73H4v-1.08L6.57 6h8.09c.18 0 .34.16.34.34v7.84l-4.11 4.1M10 22l6.41-6.41c.38-.38.59-.89.59-1.42V6.34C17 5.05 15.95 4 14.66 4h-8.1c-.71 0-1.36.37-1.72.97l-2.67 6.15c-.11.25-.17.52-.17.8V13c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66.23.45.52.86.88 1.22L10 22zm10-7h2V4h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee49bbc215cf3e2e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f34ff8c118a15a0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.11 5.72l-.57 2.89c-.12.59.04 1.2.42 1.66.38.46.94.73 1.54.73H20v1.08L17.43 18H9.34a.35.35 0 01-.34-.34V9.82l4.11-4.1M14 2L7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.83C7 18.95 8.05 20 9.34 20h8.1c.71 0 1.36-.37 1.72-.97l2.67-6.15c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66a4.8 4.8 0 00-.88-1.22L14 2zM4 9H2v11h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b7998ce752df5ab1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$527ce0a8756b3aca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c85e86023643b4f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 8c0 1.1-.9 2-2 2a1.7 1.7 0 01-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56A1.7 1.7 0 0119 8c0-1.1.9-2 2-2s2 .9 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$391e7306aab0b8bb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20h4c0 1.1-.9 2-2 2s-2-.9-2-2zm-2-1h8v-2H5v2zm11.5-9.5c0 3.82-2.66 5.86-3.77 6.5H5.27c-1.11-.64-3.77-2.68-3.77-6.5C1.5 5.36 4.86 2 9 2s7.5 3.36 7.5 7.5zm4.87-2.13L20 8l1.37.63L22 10l.63-1.37L24 8l-1.37-.63L22 6l-.63 1.37zM19 6l.94-2.06L22 3l-2.06-.94L19 0l-.94 2.06L16 3l2.06.94L19 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e1e935d494c98082(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5100f910a96e079d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d5667be2935d377(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.97 6.43L12 2 4.03 6.43 9.1 9.24C9.83 8.48 10.86 8 12 8s2.17.48 2.9 1.24l5.07-2.81zM10 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm1 9.44L3 17V8.14l5.13 2.85c-.09.32-.13.66-.13 1.01 0 1.86 1.27 3.43 3 3.87v5.57zm2 0v-5.57c1.73-.44 3-2.01 3-3.87 0-.35-.04-.69-.13-1.01L21 8.14V17l-8 4.44z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c186024cb7b264ca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12a5.99 5.99 0 014-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09A5.99 5.99 0 013 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8b91fd9371677b6b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11.24V7.5a2.5 2.5 0 015 0v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74c-3.6-.76-3.54-.75-3.67-.75-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b59dbfb205df0c50(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H7V2H5v20h2v-8h14l-2-5 2-5zm-6 5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c9fd593603379161(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.07 4.93l-1.41 1.41A8.014 8.014 0 0120 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$67315765b7fa636e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.93 16l1.63-1.63c-2.77-3.02-2.77-7.56 0-10.74L17.93 2c-3.9 3.89-3.91 9.95 0 14zm4.99-5.05a3.317 3.317 0 010-3.89l-1.68-1.69c-2.02 2.02-2.02 5.07 0 7.27l1.68-1.69zM9 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm6.39 2.56C13.71 14.7 11.53 14 9 14s-4.71.7-6.39 1.56A2.97 2.97 0 001 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$247784f3d077fa19(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0014.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$209d315447b7bb24(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7630806c060ff2f1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12l-4-4v3H3v2h15v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b721475ae9bf518e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c4cac9457b2827fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20.59l-4.69-4.69A7.902 7.902 0 0019 11c0-4.42-3.58-8-8-8-4.08 0-7.44 3.05-7.93 7h2.02C5.57 7.17 8.03 5 11 5c3.31 0 6 2.69 6 6s-2.69 6-6 6c-2.42 0-4.5-1.44-5.45-3.5H3.4C4.45 16.69 7.46 19 11 19c1.85 0 3.55-.63 4.9-1.69L20.59 22 22 20.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.43 9.69L9.65 15h1.64l1.26-3.78.95 2.28h2V12h-1l-1.25-3h-1.54l-1.12 3.37L9.35 7H7.7l-1.25 4H1v1.5h6.55z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$23e2c3710b950378(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6.43 9.57L12 15l-1.57-3.43L7 10l3.43-1.57L12 5l1.57 3.43L17 10l-3.43 1.57z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d41f4ea561dc7659(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$48739fde10689aec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ddfe1b69b3950000(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.58 1.41L15.16 0l-3.17 3.17L8.82 0 7.41 1.41 11.99 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.58 6.41L15.16 5l-3.17 3.17L8.82 5 7.41 6.41 11.99 11zM7.42 17.59L8.84 19l3.17-3.17L15.18 19l1.41-1.41L12.01 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.42 22.59L8.84 24l3.17-3.17L15.18 24l1.41-1.41L12.01 18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0c703aed3adc567(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.83L15.17 11l1.41-1.41L12 5 7.41 9.59 8.83 11 12 7.83zm0-5L15.17 6l1.41-1.41L12 0 7.41 4.59 8.83 6 12 2.83zm0 18.34L8.83 18l-1.41 1.41L12 24l4.59-4.59L15.17 18 12 21.17zm0-5L8.83 13l-1.41 1.41L12 19l4.59-4.59L15.17 13 12 16.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1f1b03672b2e12ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l2.27 2.27A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l2.27 2.27 1.41-1.42zm-10.6-4.59l-4.24-4.24 1.41-1.41 2.83 2.83.18-.18 1.41 1.41-1.59 1.59zm3-5.84l-7.1-7.1A9.91 9.91 0 0112 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51L15 12.17l2.65-2.65-1.41-1.41-2.65 2.65z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c0d31217a33ef0cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.67 5.84L7.22 4.39A8.86 8.86 0 0112 3c2.74 0 5.19 1.23 6.84 3.16L21 4v6h-6l2.41-2.41C16.12 6.02 14.18 5 12 5c-1.2 0-2.34.31-3.33.84zM13 7h-2v1.17l2 2V7zm6.78 15.61l-3-3A8.973 8.973 0 0112 21a9 9 0 01-9-9c0-1.76.51-3.4 1.39-4.78l-3-3L2.8 2.81l18.38 18.38-1.4 1.42zm-4.46-4.46L5.84 8.67A7.06 7.06 0 005 12c0 3.86 3.14 7 7 7 1.2 0 2.34-.31 3.32-.85zM20.94 13h-2.02c-.12.83-.39 1.61-.77 2.32l1.47 1.47c.7-1.12 1.17-2.41 1.32-3.79z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dae53fffa99f6fdd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58s9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$37dc96e1293cabf1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18v2H8v-2h8zM11 7.99V16h2V7.99h3L12 4 8 7.99h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d92dd2a09ade7e11(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c6035badeb7dfb90(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12l-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12zm-12.91 4.72l-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dfcc8aaaf11f9064(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h8v-2H3v2zm0 4h8v-2H3v2zm0-8h8V9H3v2zm0-6v2h8V5H3zm10 0h8v14h-8V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c59f7cd066a07fa8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM19 3H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ecbff605d3dba32(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5h-3v14h3V5zm-4 0H7v14h10V5zM6 5H3v14h3V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c2ebe6c5744fbcd5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7h4v10H2V7zm5 12h10V5H7v14zM18 7h4v10h-4V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b7935b28acd1e127(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.67 5v14H9.33V5h5.34zm1 14H21V5h-5.33v14zm-7.34 0V5H3v14h5.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ac4f2f8a548ca33(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-9 13H7v-4h4v4zm0-6H7V7h4v4zm6 6h-4v-4h4v4zm0-6h-4V7h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$480bd0832ca4ab6d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8.5 12.5h-4v-4h4v4zm0-5h-4v-4h4v4zm5 5h-4v-4h4v4zm0-5h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$530534f682f95cb6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8.75 12.75h-4v-4h4v4zm0-5.5h-4v-4h4v4zm5.5 5.5h-4v-4h4v4zm0-5.5h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8f02b9f108f0d107(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$adea19e477402453(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$97525730465f4cb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.25 7.6l-5.5-3.18a1.49 1.49 0 00-1.5 0L5.75 7.6c-.46.27-.75.76-.75 1.3v6.35c0 .54.29 1.03.75 1.3l5.5 3.18c.46.27 1.04.27 1.5 0l5.5-3.18c.46-.27.75-.76.75-1.3V8.9c0-.54-.29-1.03-.75-1.3zM7 14.96v-4.62l4 2.32v4.61l-4-2.31zm5-4.03L8 8.61l4-2.31 4 2.31-4 2.32zm1 6.34v-4.61l4-2.32v4.62l-4 2.31zM7 2H3.5C2.67 2 2 2.67 2 3.5V7h2V4h3V2zm10 0h3.5c.83 0 1.5.67 1.5 1.5V7h-2V4h-3V2zM7 22H3.5c-.83 0-1.5-.67-1.5-1.5V17h2v3h3v2zm10 0h3.5c.83 0 1.5-.67 1.5-1.5V17h-2v3h-3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$49a4a7b9d49f58a0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7V7h2v10zm4-5h-2V7h2v5zm4 3h-2V7h2v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$524754e35291dcaf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h4v-4H3v4zm0 5h4v-4H3v4zM3 9h4V5H3v4zm5 5h13v-4H8v4zm0 5h13v-4H8v4zM8 5v4h13V5H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac99763683964b71(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.67 5v6.5H9.33V5h5.34zm1 6.5H21V5h-5.33v6.5zm-1 7.5v-6.5H9.33V19h5.34zm1-6.5V19H21v-6.5h-5.33zm-7.34 0H3V19h5.33v-6.5zm0-1V5H3v6.5h5.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$827620db4bfd2f8b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5v6.5H9.33V5H21zm-6.33 14v-6.5H9.33V19h5.34zm1-6.5V19H21v-6.5h-5.33zM8.33 19V5H3v14h5.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb6399474ad73856(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 20H2V4h14v16zm2-12h4V4h-4v4zm0 12h4v-4h-4v4zm0-6h4v-4h-4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4199a2af8e4d89ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17v-2c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2zM3 7v2c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8194783326593098(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14H6v-2h6v2zm3-4H9v-2h6v2zm3-4h-6V7h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6bc81af0c759cc8d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.33 20H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h1.33c1.1 0 2 .9 2 2v12a2 2 0 01-2 2zM22 18V6c0-1.1-.9-2-2-2h-1.33c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2H20a2 2 0 002-2zm-7.33 0V6c0-1.1-.9-2-2-2h-1.33c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h1.33c1.1 0 2-.9 2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7999250f9b14b649(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 001 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$274539fbe9f76603(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6bb5b57068fe8940(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.99 9.18c0-.06.01-.12.01-.18 0-2.21-1.79-4-4-4-.06 0-.12.01-.18.01l4.17 4.17zm-6.1-3.56L4.27 3 3 4.27l2.62 2.62C5.23 7.5 5 8.22 5 9c0 2.21 1.79 4 4 4 .78 0 1.5-.23 2.11-.62L19.73 21 21 19.73l-8.62-8.62-5.49-5.49zM9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af3f2ad6fb186869(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a6529ad46f55d638(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15h5.88c.27-.31.67-.5 1.12-.5.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.44 0-.84-.19-1.12-.5H11.9A5 5 0 116 11.1v2.07c-1.16.41-2 1.53-2 2.83 0 1.65 1.35 3 3 3s3-1.35 3-3v-1zm2.5-11c1.65 0 3 1.35 3 3h2c0-2.76-2.24-5-5-5a5.002 5.002 0 00-3.45 8.62l-2.35 3.9c-.68.14-1.2.75-1.2 1.48 0 .83.67 1.5 1.5 1.5a1.498 1.498 0 001.43-1.95l3.38-5.63A3.003 3.003 0 019.5 7c0-1.65 1.35-3 3-3zm4.5 9c-.64 0-1.23.2-1.72.54l-3.05-5.07C11.53 8.35 11 7.74 11 7c0-.83.67-1.5 1.5-1.5S14 6.17 14 7c0 .15-.02.29-.06.43l2.19 3.65c.28-.05.57-.08.87-.08 2.76 0 5 2.24 5 5s-2.24 5-5 5a5 5 0 01-4.33-2.5h2.67c.48.32 1.05.5 1.66.5 1.65 0 3-1.35 3-3s-1.35-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c42fc28f8a91a32(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 6h1v12H4V6zm16 12h-1V6h1v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$21e826b1c797a149(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 6h4v12H4V6zm16 12h-4V6h4v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7a818cd64e2c816(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 6h2v12H4V6zm16 12h-2V6h2v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cb04d00906a2e6a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.71 5.29L19 3h-8v8l2.3-2.3c1.97 1.46 3.25 3.78 3.25 6.42 0 1.31-.32 2.54-.88 3.63 2.33-1.52 3.88-4.14 3.88-7.13 0-2.52-1.11-4.77-2.84-6.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.46 8.88c0-1.31.32-2.54.88-3.63a8.479 8.479 0 00-3.88 7.13c0 2.52 1.1 4.77 2.84 6.33L5 21h8v-8l-2.3 2.3c-1.96-1.46-3.24-3.78-3.24-6.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4cf889c9c52494d5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c1.49 0 2.87.47 4 1.26V8c0-1.11-.89-2-2-2h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h7.68A6.995 6.995 0 0118 11zm-8-7h4v2h-4V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L17.5 18.2V15h1v2.79l1.85 1.85-.7.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$931e23d8a9c9b467(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 21.74l-1.46-1.46L7.21 5.95 3.25 1.99 1.99 3.25l2.7 2.7h-.64c-1.11 0-1.99.89-1.99 2l-.01 11c0 1.11.89 2 2 2h15.64L21.74 23 23 21.74zM22 7.95c.05-1.11-.84-2-1.95-1.95h-4V3.95c0-1.11-.89-2-2-1.95h-4c-1.11-.05-2 .84-2 1.95v.32l13.95 14V7.95zM14.05 6H10V3.95h4.05V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b2da5724154bb8e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 6V4h-4v2h4zM4 8v11h16V8H4zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9d6a7ece335b9d62(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$18ff39d5397254b1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 16H5V7h14v12zm-2-7H7v-2h10v2zm-4 4H7v-2h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$50138fa87d1f9897(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.01 14h-.8l-.27-.27a6.451 6.451 0 001.57-4.23c0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51a4.5 4.5 0 019 0 4.507 4.507 0 01-6.32 4.12L7.71 15.1a6.474 6.474 0 007.52-.67l.27.27v.79l5.01 4.99L22 19l-4.99-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b4a9f9938e5b0363(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$58a9fbedc672ee1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e9da6ec091b5ccce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72A6.873 6.873 0 005.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$961e106f5c692a9e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2h-3.5l-1-1h-5l-1 1H1v2h14zM16 9c-.7 0-1.37.1-2 .29V5H2v12c0 1.1.9 2 2 2h5.68A6.999 6.999 0 0023 16c0-3.87-3.13-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12H15v5l3.6 2.1.8-1.2-2.9-1.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$13f5e02d7c83ba90(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b5def81f8616565(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ea47f74bc3e11556(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-5 0h-2v-2h2v2zm0-4h-2V8h2v4zm-1 10c1.1 0 2-.9 2-2h-4a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e886023cfd81e535(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16h-2v2h2zM13 10h-2v5h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9ca93957eae07e16(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$15896ab99152c199(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.5h1.5v3H10zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 15H6v-4.5H4.5V9h3v6zm5.5-1c0 .55-.45 1-1 1H9.5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1H12c.55 0 1 .45 1 1v4zm6.5 1h-1.75L16 12.75V15h-1.5V9H16v2.25L17.75 9h1.75l-2.25 3 2.25 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a2ed4add8e6f824(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 15H7.5v-4.5H6V9h3v6zm4.75 0L12 12.75V15h-1.5V9H12v2.25L13.75 9h1.75l-2.25 3 2.25 3h-1.75zm5.75-2.5H18V14h-1v-1.5h-1.5v-1H17V10h1v1.5h1.5v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f6242d3825700e6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.5 12H9v-4.5H7.5V9h3v6zm7 0h-1.75L14 12.75V15h-1.5V9H14v2.25L15.75 9h1.75l-2.25 3 2.25 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c4f38a19b2d93c7e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9.5 8.5c0 .55-.45 1-1 1h-2v1h3V15H5v-2.5c0-.55.45-1 1-1h2v-1H5V9h3.5c.55 0 1 .45 1 1v1.5zm4.75 3.5l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15h-1.75zM20 12.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9b62ab8a84f18077(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9.5H8v1h3V15H6.5v-2.5c0-.55.45-1 1-1h2v-1h-3V9H10c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1zm8 2.5h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3a4f41bf70eb4d43(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9.5 14c0 .55-.45 1-1 1H5v-1.5h3v-1H6v-1h2v-1H5V9h3.5c.55 0 1 .45 1 1v4zm6.5 1h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fffd7dcbaea76dbf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 11c0 .55-.45 1-1 1H6.5v-1.5h3v-1h-2v-1h2v-1h-3V9H10c.55 0 1 .45 1 1v4zm7 1h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dc447273ffbbc59c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.5 10.5h-1V15H8v-1.5H5V9h1.5v3H8V9h1.5v3h1v1.5zM16 15h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a5e61914f427f596(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 10.5h-1V15H9.5v-1.5h-3V9H8v3h1.5V9H11v3h1v1.5zm6 1.5h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$53b73cca59641e3d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13h2v2h-5V9h7c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4v2zM3 13h5v2H3v2h5c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2H5V9h5V7H3v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$87a973bd9d2193fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9.5 7.5h-3v1h2c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H5v-1.5h3v-1H5V9h4.5v1.5zM16 15h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f3c73092781d921b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 7.5H8v1h2c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H6.5v-1.5h3v-1h-3V9H11v1.5zm7 4.5h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f9a75279cd8512f2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 12.5H8V14H6.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9.5 7.5h-3v1h2c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3.5v1.5zM16 15h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$531bee497136dcae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.5h1.5V14H8zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 7.5H8v1h2c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H7.5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1H11v1.5zm7 4.5h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$76d5b9c0d4cf2d7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8 15H6.25l1.38-4.5H5V9h3.5c.67 0 1.15.65.96 1.29L8 15zm8 0h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d20300b7b8a9de89(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9.5 15H7.75l1.38-4.5H6.5V9H10c.67 0 1.15.65.96 1.29L9.5 15zm8.5 0h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$157e7d64d2d9f8ad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 12.5H8V14H6.5zm0-2.5H8v1.5H6.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9.5 14c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zm6.5 1h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a0744d45471479d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.5h1.5V14H8zM8 10h1.5v1.5H8zm11-7H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 11c0 .55-.45 1-1 1H7.5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1H10c.55 0 1 .45 1 1v4zm7 1h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$66b593cb02615366(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 10H8v1.5H6.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9.5 14c0 .55-.45 1-1 1H5v-1.5h3v-1H6c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zm6.5 1h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f11335e93864e06(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10h1.5v1.5H8zm11-7H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 11c0 .55-.45 1-1 1H6.5v-1.5h3v-1h-2c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1H10c.55 0 1 .45 1 1v4zm7 1h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$243f6a866ba7ea2c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 00-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f0c447ad074b5a47(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12l-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ca7f4dc085bfc175(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b911202ce83d67bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9cd87db5301a864e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 11h-3v3.75c0 1.24-1.01 2.25-2.25 2.25S8.5 17.99 8.5 16.75s1.01-2.25 2.25-2.25c.46 0 .89.14 1.25.38V11h4v2zm-3-4V3.5L18.5 9H13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e329c6667d5a968e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9a9 9 0 000-18h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$58e4d1233ed349fc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9b6fa8d4bc3d56cf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$76eb4e2eac9a011b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.83 4H19c1.1 0 2 .9 2 2v12c0 .05-.01.1-.02.16l-3.38-3.38c.24-.19.4-.46.4-.78v-1h-1.5v.5h-.17l-1.83-1.83V10.5h2v.5H18v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v.17L6.83 4zm12.95 18.61L17.17 20H5a2 2 0 01-2-2V6c0-.05.02-.1.02-.15L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM11 13.83l-.83-.83H9.5v.5h-2v-3h.17L6.4 9.22c-.24.19-.4.46-.4.78v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cf8f16d5031cc805(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 5.5v13h-15v-13h15zM19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c09251efc7038ad9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c71a7fb8cf328a4f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.54 5.54L13.77 7.3 12 5.54 10.23 7.3 8.46 5.54 12 2zm2.92 10l-1.76-1.77L18.46 12l-1.76-1.77 1.76-1.77L22 12zm-10 2.92l1.77-1.76L12 18.46l1.77-1.76 1.77 1.76L12 22zm-2.92-10l1.76 1.77L5.54 12l1.76 1.77-1.76 1.77L2 12z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cff8992bf598689c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$294795361e9aa1a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5befe88b3ed44e78(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$970a6806eeea5634(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fad7e3b43ec12f29(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$349637c289a78640(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1f2a90d404ee9cd9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 10.5h2v1h-2v-1zm-13 0h2v3h-2v-3zM21 3H3c-1.11 0-2 .89-2 2v14a2 2 0 002 2h18a2 2 0 002-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a748e1526af18970(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "8"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$546da97e948b68b9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20a13bb628a15ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bf19b374c3f50a9f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4.26v2.09a5.99 5.99 0 010 11.3v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$76ae4dd82530d076(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.86 15.94v-4.27h-.09L9 12.3v.69l1.01-.31v3.26zM12.25 13.44v.74c0 1.9 1.31 1.82 1.44 1.82.14 0 1.44.09 1.44-1.82v-.74c0-1.9-1.31-1.82-1.44-1.82-.14 0-1.44-.09-1.44 1.82zm2.04-.12v.97c0 .77-.21 1.03-.59 1.03s-.6-.26-.6-1.03v-.97c0-.75.22-1.01.59-1.01.38-.01.6.26.6 1.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84da1f9764934309(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.06 15.38c-.29 0-.62-.17-.62-.54h-.85c0 .97.9 1.23 1.45 1.23.87 0 1.51-.46 1.51-1.25 0-.66-.45-.9-.71-1 .11-.05.65-.32.65-.92 0-.21-.05-1.22-1.44-1.22-.62 0-1.4.35-1.4 1.16h.85c0-.34.31-.48.57-.48.59 0 .58.5.58.54 0 .52-.41.59-.63.59h-.46v.66h.45c.65 0 .7.42.7.64 0 .32-.21.59-.65.59zM13.85 11.68c-.14 0-1.44-.08-1.44 1.82v.74c0 1.9 1.31 1.82 1.44 1.82.14 0 1.44.09 1.44-1.82v-.74c.01-1.91-1.3-1.82-1.44-1.82zm.6 2.67c0 .77-.21 1.03-.59 1.03s-.6-.26-.6-1.03v-.97c0-.75.22-1.01.59-1.01.38 0 .6.26.6 1.01v.97z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ec4192fd6124a5d7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.03 15.38c-.44 0-.58-.31-.6-.56h-.84c.03.85.79 1.25 1.44 1.25.93 0 1.44-.63 1.44-1.43 0-1.33-.97-1.44-1.3-1.44-.2 0-.43.05-.64.16l.11-.92h1.7v-.71h-2.39l-.25 2.17.67.17c.13-.13.28-.23.57-.23.4 0 .69.23.69.75-.01.05.02.79-.6.79z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ebeb2313b7966d78(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a42a7cf55d4a08a0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$67e69e1cc945e173(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.03 3.2C7.15 2.44 8.51 2 10 2c3.93 0 7 3.07 7 7 0 1.26-.38 2.65-1.07 3.9-.02.04-.05.08-.08.13l-1.48-1.48c.4-.86.63-1.75.63-2.55 0-2.8-2.2-5-5-5-.92 0-1.76.26-2.5.67L6.03 3.2zm11.18 11.18l1.43 1.43C20.11 13.93 21 11.57 21 9c0-3.04-1.23-5.79-3.22-7.78l-1.42 1.42A8.937 8.937 0 0119 9c0 2.02-.67 3.88-1.79 5.38zM10 6.5c-.21 0-.4.03-.59.08l3.01 3.01c.05-.19.08-.38.08-.59A2.5 2.5 0 0010 6.5zm11.19 14.69L2.81 2.81 1.39 4.22l2.13 2.13C3.19 7.16 3 8.05 3 9h2c0-.36.05-.71.12-1.05l6.61 6.61c-.88.68-1.78 1.41-2.27 2.9-.5 1.5-1 2.01-1.71 2.38-.19.1-.46.16-.75.16-1.1 0-2-.9-2-2H3a3.999 3.999 0 005.64 3.65c1.36-.71 2.13-1.73 2.73-3.55.32-.98.9-1.43 1.71-2.05.03-.02.05-.04.08-.06l6.62 6.62 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b7a8a5c352ce1024(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55A3.999 3.999 0 0021 18h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9a2.5 2.5 0 005 0 2.5 2.5 0 00-5 0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$66f228d97cdcc91f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c88c645852d461ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 16.5c-.83 0-1.5-.67-1.5-1.5v-2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V15c0 .83-.67 1.5-1.5 1.5zM20 20h1v-1.54c1.69-.24 3-1.7 3-3.46h-1a2.5 2.5 0 01-5 0h-1c0 1.76 1.31 3.22 3 3.46V20zM9 12c-2.21 0-4-1.79-4-4a3.999 3.999 0 015.34-3.77A5.938 5.938 0 009 8c0 1.43.5 2.74 1.34 3.77-.42.15-.87.23-1.34.23zm-1.89 1.13A4.965 4.965 0 005 17.22V20H1v-2.78c0-1.12.61-2.15 1.61-2.66 1.24-.64 2.76-1.19 4.5-1.43zM11 8c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4zm7.32 12a4.997 4.997 0 01-2.82-4.5c0-.89.23-1.73.64-2.45-.37-.03-.75-.05-1.14-.05-2.53 0-4.71.7-6.39 1.56A2.97 2.97 0 007 17.22V20h11.32z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc959892db5b6cbe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41 12.47 14zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ed0f621312189d1b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9057573a10fcaf84(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$65c7fc5643387db9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5a2.5 2.5 0 01-5 0 2.5 2.5 0 012.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3bfa93c9669c4928(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0020 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 004 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$505d73ef4feec379(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9c0-2.04 1.24-3.79 3-4.57V4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h9c1.1 0 2-.9 2-2v-2.42c-1.76-.78-3-2.53-3-4.58zm-4 5H6v-2h4v2zm3-3H6V9h7v2zm0-3H6V6h7v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V3h2V1h-4v5.18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd5b0649bc0cd291(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eb1a638058ce754a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6cae65995338c0dd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b39c79c29ee2e4c7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM10 15l-3.89-3.89v2.55H5V9.22h4.44v1.11H6.89l3.11 3.1 4.22-4.22.78.79-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$18a2e4ed7e07cea9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10h18V6c0-1.1-.9-2-2-2h-3l2 4h-3l-2-4h-2l2 4h-3L9 4H7l2 4H6L4 4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h8v-2H4v-8zM14 18.88V21h2.12l5.17-5.17-2.12-2.12zM22.71 13l-.71-.71a.996.996 0 00-1.41 0l-.71.71L22 15.12l.71-.71a.996.996 0 000-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a988009af81e0500(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f926ab125bfd8946(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03A3.003 3.003 0 0111 18c-1.66 0-3-1.34-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1694163a24c4e483(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f0152f10eacf41f7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab523f56fbf1226b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db1b7d8c6b830874(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d41b20390674183e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ec2c5efeca30784d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd7898b67e0169e1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$603f6dd32a0b8e80(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5v14l11-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5767edf075995e5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5782b1eb9f2409b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a1a482ca28450f6d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.5 16.5v-9l7 4.5-7 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a5746f96f2a93a6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm11.75 11.47l-.11-.11.11.11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5.19V5l11 7-2.55 1.63L8 5.19zm12 14.54l-5.11-5.11L8 7.73 4.27 4 3 5.27l5 5V19l5.33-3.4 5.4 5.4L20 19.73z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2f783e15d8b2b63b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7 7h7v2H7V7zm0 3h7v2H7v-2zm3 5H7v-2h3v2zm4.05 3.36l-2.83-2.83 1.41-1.41 1.41 1.41L17.59 12 19 13.41l-4.95 4.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ddb17e54ad17b1e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h11v2H3zM3 6h11v2H3zM3 14h7v2H3zM20.59 11.93l-4.25 4.24-2.12-2.12-1.41 1.41L16.34 19 22 13.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bf96e573cd6265f4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7 7h7v2H7V7zm3 8H7v-2h3v2zm-3-3v-2h7v2H7zm12 3h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$175ee98f6e591b68(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H3v2h11v-2zm0-4H3v2h11V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM3 16h7v-2H3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9e6a8a3f2a69130c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h11v2H3zM3 6h11v2H3zM3 14h7v2H3zM16 13v8l6-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$200ad11b97f54942(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H3v2h11v-2zm0-4H3v2h11V6zM3 16h7v-2H3v2zm11.41 6L17 19.41 19.59 22 21 20.59 18.41 18 21 15.41 19.59 14 17 16.59 14.41 14 13 15.41 15.59 18 13 20.59 14.41 22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6dc02a77afa073df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8432fa59e6183b77(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h2v-2H3V5h18v8h2V5a2 2 0 00-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$301f0aae9c853148(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$50528e64abb6638a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.24 6.15C2.51 6.43 2 7.17 2 8v12a2 2 0 002 2h16a2 2 0 002-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c5f464aacfe281(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a64468b8578f9de2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 00-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7480a63910e68ce9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M21 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee6811b21c0ce422(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M21 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd1d7c9439b72e91(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8c54472caa54eeba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9ecc918b127ad896(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.89 16h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zM15.17 14.24c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$511d7366501ce7c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.56 13.49h.45c.21 0 .37-.05.48-.16s.16-.25.16-.43a.538.538 0 00-.15-.39c-.05-.05-.11-.09-.18-.11s-.16-.04-.25-.04c-.08 0-.15.01-.22.03s-.13.05-.18.1-.09.09-.12.15-.05.13-.05.2h-.85a1.06 1.06 0 01.41-.85c.13-.1.27-.18.44-.23s.35-.08.54-.08c.21 0 .41.03.59.08s.33.13.46.23.23.23.3.38.11.33.11.53a.842.842 0 01-.17.52 1.1 1.1 0 01-.48.39c.24.09.42.21.54.39s.18.38.18.61c0 .2-.04.38-.12.53s-.18.29-.32.39-.29.19-.48.24-.38.08-.6.08c-.18 0-.36-.02-.53-.07s-.33-.12-.46-.23-.25-.23-.33-.38-.12-.34-.12-.55h.85c0 .08.02.15.05.22s.07.12.13.17.12.09.2.11.16.04.25.04c.1 0 .19-.01.27-.04s.15-.07.2-.12.1-.11.13-.18.04-.15.04-.24c0-.11-.02-.21-.05-.29s-.08-.15-.14-.2-.13-.09-.22-.11-.18-.04-.29-.04h-.47v-.65zM15.3 14.24c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32c.03-.13.04-.29.04-.48v-.97z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6833dc24919b2c9f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.69 13.9l.25-2.17h2.39v.71h-1.7l-.11.92c.03-.02.07-.03.11-.05s.09-.04.15-.05.12-.03.18-.04.13-.02.2-.02c.21 0 .39.03.55.1s.3.16.41.28.2.27.25.45.09.38.09.6c0 .19-.03.37-.09.54s-.15.32-.27.45-.27.24-.45.31-.39.12-.64.12c-.18 0-.36-.03-.53-.08s-.32-.14-.46-.24-.24-.24-.32-.39-.13-.33-.13-.53h.84c.02.18.08.32.19.41s.25.15.42.15a.49.49 0 00.45-.23c.04-.07.08-.15.11-.25s.03-.2.03-.31-.01-.21-.04-.31-.07-.17-.13-.24-.13-.12-.21-.15-.19-.05-.3-.05c-.08 0-.15.01-.2.02s-.11.03-.15.05-.08.05-.12.07-.07.06-.1.09l-.67-.16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de41248938709bb8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6 10c0 3.31-2.69 6-6 6s-6-2.69-6-6h2c0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4v3L8 7l4-4v3c3.31 0 6 2.69 6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b54da0d81201b673(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20eb8b05268ca03(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm-3.5 4.5v-1H7c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1H9.5v-.5h-2v1H10c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-1h1.5v.5h2zm5 0h2v-3h-2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d9f2db5a3037e59(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M21 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$110e77144fef0d4d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$725ae522be45905d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$810aeba7c22ee4f3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h2v12H6zm3.5 6l8.5 6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$21ceda8cd71e7d26(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0111 4.07zM5.69 7.1L4.26 5.68A9.949 9.949 0 002.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 014.07 13zm1.61 6.74A9.981 9.981 0 0011 21.95v-2.02a7.941 7.941 0 01-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9191ecce841cb885(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1f919c13f99efb8f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm.75.75h22.5v22.5H.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$601be09b1aac3530(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.38 8.57l-1.23 1.85a8 8 0 01-.22 7.58H5.07A8 8 0 0115.58 6.85l1.85-1.23A10 10 0 003.35 19a2 2 0 001.72 1h13.85a2 2 0 001.74-1 10 10 0 00-.27-10.44zm-9.79 6.84a2 2 0 002.83 0l5.66-8.49-8.49 5.66a2 2 0 000 2.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$50975ff9eec76004(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 14H8V8h8v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16163887c1d8d3b7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h12v12H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6de2fb6bba3b896(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$484f672ceeb15d1c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f81bacabce32656(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41A7.909 7.909 0 014 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41A7.909 7.909 0 0120 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af62d7bdebc8c593(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1603d6428d21b910(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6.01a2 2 0 00-2 2L4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-1 7V3.5L18.5 9H13zm1 5l2-1.06v4.12L14 16v1c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3b5151b095f5cc8e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91bc889bbbf45d1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c7193085c18825bb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18v5h2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H3V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12L9 8v8zM22.71 18.43c.03-.29.04-.58.01-.86l1.07-.85c.1-.08.12-.21.06-.32l-1.03-1.79c-.06-.11-.19-.15-.31-.11l-1.28.5a3.44 3.44 0 00-.75-.42l-.2-1.36a.249.249 0 00-.25-.22h-2.07c-.12 0-.23.09-.25.21l-.2 1.36c-.26.11-.51.26-.74.42l-1.28-.5c-.12-.05-.25 0-.31.11l-1.03 1.79c-.06.11-.04.24.06.32l1.07.86c-.03.29-.04.58-.01.86l-1.07.85c-.1.08-.12.21-.06.32l1.03 1.79c.06.11.19.15.31.11l1.27-.5c.23.17.48.31.75.42l.2 1.36c.02.12.12.21.25.21h2.07c.12 0 .23-.09.25-.21l.2-1.36c.26-.11.51-.26.74-.42l1.28.5c.12.05.25 0 .31-.11l1.03-1.79c.06-.11.04-.24-.06-.32l-1.06-.85zM19 19.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4648e57a6c3b014b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f7e71b4713824ae2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8228f3679eea7e31(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02S15.48 8.71 14 7.97zM3 9v6h4l5 5V4L7 9H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c4167f7e3a2288e6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 12A4.5 4.5 0 0016 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$63f9dc462cf6358(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9v6h4l5 5V4l-5 5H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aee04003f37b86f1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12A4.5 4.5 0 0014 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0021 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 003.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a92124467ca28c62(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3177b35f1416ba0f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.83 4H20a2 2 0 012 2v12c0 .34-.09.66-.23.94L20 17.17V8h-9.17l-4-4zm13.66 19.31L17.17 20H4a2 2 0 01-2-2V6c0-.34.08-.66.23-.94L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM15.17 18l-10-10H4v10h11.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d89e1f4a6289c5c4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm0 14H5V8h14v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c9b03c6f34d761(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b56706948725f483(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4.01c-1.1 0-2 .9-2 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8H8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0116 13.43V14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7fc07b7db9567124(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM21 6h-3V3h-2v3h-3v2h3v3h2V8h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c269624008d06e50(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d318b473a913aea8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4h4v4h-4zM4 16h4v4H4zM4 10h4v4H4zM4 4h4v4H4zM14 12.42V10h-4v4h2.42zM20.88 11.29l-1.17-1.17a.41.41 0 00-.58 0l-.88.88L20 12.75l.88-.88a.41.41 0 000-.58zM11 18.25V20h1.75l6.67-6.67-1.75-1.75zM16 4h4v4h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d70f4995f3d98663(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e21c919652323e2c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08a.956.956 0 01-.29-.7c0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28a11.27 11.27 0 00-2.67-1.85.996.996 0 01-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a809ec15b91bfd0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a47293013e089a7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a579be4970fd5e7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f4f9f544d7145058(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a3a7c37c49fbed3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$545d185c91225bf8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$960e53b5f77b766e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$504278e5e1223fb0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.1H3V5h18v14.1zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M21 19.1H3V5h18v14.1zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8ad76b0087deffc3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.3 14.7l1.2-1.2c-1-1-1.5-2.3-1.5-3.5 0-1.3.5-2.6 1.5-3.5L7.3 5.3c-1.3 1.3-2 3-2 4.7s.7 3.4 2 4.7zM19.1 2.9l-1.2 1.2c1.6 1.6 2.4 3.8 2.4 5.9 0 2.1-.8 4.3-2.4 5.9l1.2 1.2c2-2 2.9-4.5 2.9-7.1 0-2.6-1-5.1-2.9-7.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.1 4.1L4.9 2.9C3 4.9 2 7.4 2 10c0 2.6 1 5.1 2.9 7.1l1.2-1.2c-1.6-1.6-2.4-3.8-2.4-5.9 0-2.1.8-4.3 2.4-5.9zM16.7 14.7c1.3-1.3 2-3 2-4.7-.1-1.7-.7-3.4-2-4.7l-1.2 1.2c1 1 1.5 2.3 1.5 3.5 0 1.3-.5 2.6-1.5 3.5l1.2 1.2zM14.5 10a2.5 2.5 0 00-5 0c0 .76.34 1.42.87 1.88L7 22h2l.67-2h4.67l.66 2h2l-3.37-10.12c.53-.46.87-1.12.87-1.88zm-4.17 8L12 13l1.67 5h-3.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1559c009550cea78(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9.98L6 22h16V5.97l-4 4.01zM20 20h-2v-7.22l2-2V20zM5.22 7.22L3.93 5.93c3.9-3.91 10.24-3.91 14.15 0l-1.29 1.29c-3.19-3.19-8.38-3.19-11.57 0zm7.71 3.85L11 13l-1.93-1.93a2.74 2.74 0 013.86 0zm1.29-1.28c-1.78-1.77-4.66-1.77-6.43 0L6.5 8.5a6.374 6.374 0 019 0l-1.28 1.29z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6542e69c8003adf3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d56e300e5b733040(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f53890922134e72(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3daa76df5361dd09(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a8ad603788b7ee7e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v8h2V5h18v16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.39 16.56C13.71 15.7 11.53 15 9 15s-4.71.7-6.39 1.56A2.97 2.97 0 001 19.22V22h16v-2.78c0-1.12-.61-2.15-1.61-2.66z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6adeef565681e08(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b9a0bd314fae4256(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.83 14H18v-2h-3.17l-1-1H18V9h-6.17l-1-1H18V6H8.83l-4-4H20c1.1 0 2 .9 2 2v15.17L16.83 14zM2.1 2.1L.69 3.51 2 4.83V16c0 1.1.9 2 2 2h11.17l5.31 5.31 1.41-1.41L2.1 2.1zM6 9h.17l2 2H6V9zm0 5v-2h3.17l2 2H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e9d5c2621dc4727c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM9 8c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zM2.08 19c1.38-2.39 3.96-4 6.92-4s5.54 1.61 6.92 4H2.08zm18.89-9.15l-.75 1.3-1.47-.85V12h-1.5v-1.7l-1.47.85-.75-1.3L16.5 9l-1.47-.85.75-1.3 1.47.85V6h1.5v1.7l1.47-.85.75 1.3L19.5 9l1.47.85z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19c48289fdb00059(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5bc1b216ba1d9e7b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99A7.512 7.512 0 0116.28 14c-.18-.64-.28-1.31-.28-2s.1-1.36.28-2a7.474 7.474 0 012.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c58abcc5481f4e1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9162015873a04637(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 16c0 1.1-.9 2-2 2h-1l-2-2h3V4H6L4 2h17c1.1 0 2 .9 2 2v12zm-5.5 2l-2-2zm-2.6 0l6 6 1.3-1.3-4.7-4.7-2-2L1.2 1.8 0 3.1l1 1V16c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h.9zM3 16V6.1l9.9 9.9H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$217efabc5943c615(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57a.998.998 0 00-1.01.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d105eddae6b56788(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c3e1c3917a1aa142(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3H4v3H2V1h5v2zm15 3V1h-5v2h3v3h2zM7 21H4v-3H2v5h5v-2zm13-3v3h-3v2h5v-5h-2zm-1 0c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v12zM15 8H9v2h6V8zm0 3H9v2h6v-2zm0 3H9v2h6v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$24c07dc3531717e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5h2v2h-.9L12 9.9V9h8v8.9l2 2V7H12V3H5.1L8 5.9zm8 6h2v2h-2zM1.3 1.8L.1 3.1 2 5v16h16l3 3 1.3-1.3-21-20.9zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm4 8H8v-2h2v2zm0-4H8v-2h2v2zm2 4v-2h2l2 2h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$726683eb04527943(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.6 10.88l-1.42-1.42-4.24 4.25-2.12-2.13L7.4 13l3.54 3.54z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm0 14H5V8h14v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3514fbd9b8b9eb28(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h-8C6.38 2 2 6.66 2 12.28 2 17.5 6.49 22 11.72 22 17.39 22 22 17.62 22 12V4c0-1.1-.9-2-2-2zm-3 13l-3-2v2H7V9h7v2l3-2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9d260b06e2b07e2b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4ef77571b3c0c6c4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$83f7cbedef68583f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H4V8l8 5 8-5v5h2V6c0-1.1-.9-2-2-2zm-8 7L4 6h16l-8 5zm7 4l4 4-4 4v-3h-4v-2h4v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$984d04398eebbf74(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22l-.01-6L14 12l3.99-4.01L18 2H6v6l4 4-4 3.99V22h12zM8 7.5V4h8v3.5l-4 4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$99e3bee04dbb1415(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2l.01 6L10 12l-3.99 4.01L6 22h12v-6l-4-4 4-3.99V2H6zm10 14.5V20H8v-3.5l4-4 4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2424187012872bce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.4 18.2c.38.5.6 1.12.6 1.8 0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3c.44 0 .85.09 1.23.26l1.41-1.77a4.504 4.504 0 01-1.09-3.69l-2.03-.68A2.997 2.997 0 010 9.5c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .07 0 .14-.01.21l2.03.68a4.468 4.468 0 013.22-2.32V5.91A3.018 3.018 0 019 3c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.4-.96 2.57-2.25 2.91v2.16c1.4.23 2.58 1.11 3.22 2.32L18 9.71V9.5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3c-1.06 0-1.98-.55-2.52-1.37l-2.03.68a4.49 4.49 0 01-1.09 3.69l1.41 1.77c.38-.18.79-.27 1.23-.27 1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3c0-.68.22-1.3.6-1.8l-1.41-1.77c-1.35.75-3.01.76-4.37 0L8.4 18.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5639d6fb91db3eac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 4.5c-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .65.73.45.75.45C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.41.21.75-.19.75-.45V6c-1.49-1.12-3.63-1.5-5.5-1.5zm3.5 14c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8495da5af09b908d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc9ad46c40854098(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l4.2 4.2a7.73 7.73 0 00-1.6 4.7C4 17.48 7.58 21 12 21c1.75 0 3.36-.56 4.67-1.5l3.1 3.1 1.42-1.41zM12 19c-3.31 0-6-2.63-6-5.87 0-1.19.36-2.32 1.02-3.28L12 14.83V19zM8.38 5.56L12 2l5.65 5.56C19.1 8.99 20 10.96 20 13.13c0 1.18-.27 2.29-.74 3.3L12 9.17V4.81L9.8 6.97 8.38 5.56z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$75df1d4209843b55(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.91 14.09L17 14l2 2 4-4.04L21 10h-8.17l4.08 4.09zM3.98 6.81A6.012 6.012 0 001 12c0 3.31 2.69 6 6 6 2.21 0 4.15-1.2 5.18-2.99l7.59 7.59 1.41-1.41L2.81 2.81 1.39 4.22l2.59 2.59zm5.93 5.93A3.015 3.015 0 017 15c-1.65 0-3-1.35-3-3 0-1.4.97-2.58 2.26-2.91l3.65 3.65z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$72a81ad1a1258629(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10h-8.35A5.99 5.99 0 007 6c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 005.65-4H13l2 2 2-2 2 2 4-4.04L21 10zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb91064b059600fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM11 7h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1d887e46fa72a91b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5a2 2 0 00-2 2v14a2 2 0 002 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4350a0194c7b048a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm11.75 11.47l-.11-.11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.5A2.5 2.5 0 0114.5 9c0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7a7 7 0 00-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$794d5d4ea22bbf93(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$576eefcfb817334d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.97V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h12v-5.03c0-2.76 2.24-5 5-5h1zM20 8l-8 5-8-5V6l8 5 8-5v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 15v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$98080e63f6e534fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$363aba4ea436e706(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 20l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L23 14.34 17.34 20zM12 17a6.995 6.995 0 0110-6.32V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v18l4-4h6c0-.17.01-.33.03-.5A4.07 4.07 0 0112 17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9e118fcd4a49e4cf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6.98V16c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2h10.1A5.002 5.002 0 0019 8c1.13 0 2.16-.39 3-1.02zM16 3c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3c10bc90d63519b6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19a6.995 6.995 0 0110-6.32V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h8.08c-.05-.33-.08-.66-.08-1zM4 6l8 5 8-5v2l-8 5-8-5V6zm13.34 16l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L23 16.34 17.34 22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$65320654ce896f58(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8.98V18c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10.1c-.06.32-.1.66-.1 1 0 1.48.65 2.79 1.67 3.71L12 11 4 6v2l8 5 5.3-3.32c.54.2 1.1.32 1.7.32 1.13 0 2.16-.39 3-1.02zM16 5c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1a70bc2bc3ee67ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "3",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8V6h9.03a4.906 4.906 0 01-.92-4H4.01a2 2 0 00-2 2L2 22l4-4h14c1.1 0 2-.9 2-2V6.97C21.16 7.61 20.13 8 19 8H6zm8 6H6v-2h8v2zm4-3H6V9h12v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$162ec8fe24f28cd2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19d7cda85642d687(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-4.2-5.78v1.75l3.2-2.99L12.8 9v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c454ce222a08f3c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8v6l4.7 2.9.8-1.2-4-2.4V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.92 12A6.957 6.957 0 0111 20c-3.9 0-7-3.1-7-7s3.1-7 7-7c.7 0 1.37.1 2 .29V4.23c-.64-.15-1.31-.23-2-.23-5 0-9 4-9 9s4 9 9 9a8.963 8.963 0 008.94-10h-2.02z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5V2h-2v3h-3v2h3v3h2V7h3V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$86dd1b2c6c06fcef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.82 13H11v-2H6.82C6.4 9.84 5.3 9 4 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c1.3 0 2.4-.84 2.82-2zM4 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12l-4-3v2h-4.05c-.5-5.05-4.76-9-9.95-9v2c4.42 0 8 3.58 8 8s-3.58 8-8 8v2c5.19 0 9.45-3.95 9.95-9H19v2l4-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ae046a0f55d7c6a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6d97456279c6f06b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.1H3V5h18v14.1zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M21 19.1H3V5h18v14.1zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8h2v8H9zm4 0h2v8h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a7fef224eec98ec7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "8",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 20v-2c0-2.3-4.1-3.7-6.9-3.9l6 5.9h.9zm-11.6-5.5C9.2 15.1 7 16.3 7 18v2h9.9l4 4 1.3-1.3-21-20.9L0 3.1l4 4V10H1v2h3v3h2v-3h2.9l2.5 2.5zM6 10v-.9l.9.9H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7b81c2b88b3c7b7c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.35 14.01C7.62 13.91 2 15.27 2 18v2h9.54c-2.47-2.76-1.23-5.89-1.19-5.99zM19.43 18.02c.36-.59.57-1.28.57-2.02 0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4c.74 0 1.43-.22 2.02-.57L20.59 22 22 20.59l-2.57-2.57zM16 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3c8a3d3eff7a40e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 14.54l-1.43-1.43c.56-.73 1.05-1.5 1.47-2.32l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1H20c.55 0 1 .45 1 1 0 3.98-1.37 7.64-3.66 10.54zm-2.82 2.81A16.884 16.884 0 014 21c-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.35-.12.75-.03 1.02.24l2.2 2.2c.81-.42 1.58-.9 2.3-1.46L1.39 4.22l1.42-1.41L21.19 21.2l-1.41 1.41-5.26-5.26z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$510f5bff8f196b15(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.38 10.79l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1H20c.55 0 1 .45 1 1 0 9.39-7.61 17-17 17-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.35-.12.75-.03 1.02.24l2.2 2.2c2.83-1.45 5.15-3.76 6.59-6.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9d00f9e5cee7bb49(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d56d3dc7d649c838(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$edb8c669116ed8d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19c10b603ce9c3eb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c6e595c4f58f1132(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.82 12.49c.02-.16.04-.32.04-.49 0-.17-.02-.33-.04-.49l1.08-.82c.1-.07.12-.21.06-.32l-1.03-1.73c-.06-.11-.2-.15-.31-.11l-1.28.5c-.27-.2-.56-.36-.87-.49l-.2-1.33c0-.12-.11-.21-.24-.21H5.98a.26.26 0 00-.26.21l-.2 1.32c-.31.12-.6.3-.87.49l-1.28-.5c-.12-.05-.25 0-.31.11l-1.03 1.73c-.06.12-.03.25.07.33l1.08.82c-.02.16-.03.33-.03.49 0 .17.02.33.04.49l-1.09.83c-.1.07-.12.21-.06.32l1.03 1.73c.06.11.2.15.31.11l1.28-.5c.27.2.56.36.87.49l.2 1.32c.01.12.12.21.25.21h2.06c.13 0 .24-.09.25-.21l.2-1.32c.31-.12.6-.3.87-.49l1.28.5c.12.05.25 0 .31-.11l1.03-1.73c.06-.11.04-.24-.06-.32l-1.1-.83zM7 13.75c-.99 0-1.8-.78-1.8-1.75s.81-1.75 1.8-1.75 1.8.78 1.8 1.75S8 13.75 7 13.75zM18 1.01L8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$76c23b255bbe7fa1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06a3.999 3.999 0 013.95 4.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47A9.86 9.86 0 0022 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af480b2f7f983008(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3894224f800fe5cb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.1 17H22v-6c0-1.7-1.3-3-3-3h-9l9.1 9zm-.1-7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-1-3V3H6v1.1L9 7zM1.2 1.8L0 3l4.9 5C3.3 8.1 2 9.4 2 11v6h4v4h11.9l3 3 1.3-1.3-21-20.9zM8 19v-5h2.9l5 5H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6d616287a885f69a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21h-2v-2h2v2zm-2-7h-2v5h2v-5zm8-2h-2v4h2v-4zm-2-2h-2v2h2v-2zM7 12H5v2h2v-2zm-2-2H3v2h2v-2zm7-5h2V3h-2v2zm-7.5-.5v3h3v-3h-3zM9 9H3V3h6v6zm-4.5 7.5v3h3v-3h-3zM9 21H3v-6h6v6zm7.5-16.5v3h3v-3h-3zM21 9h-6V3h6v6zm-2 10v-3h-4v2h2v3h4v-2h-2zm-2-7h-4v2h4v-2zm-4-2H7v2h2v2h2v-2h2v-2zm1-1V7h-2V5h-2v4h4zM6.75 5.25h-1.5v1.5h1.5v-1.5zm0 12h-1.5v1.5h1.5v-1.5zm12-12h-1.5v1.5h1.5v-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$890f717eb56468c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 6.5v3h-3v-3h3M11 5H5v6h6V5zm-1.5 9.5v3h-3v-3h3M11 13H5v6h6v-6zm6.5-6.5v3h-3v-3h3M19 5h-6v6h6V5zm-6 8h1.5v1.5H13V13zm1.5 1.5H16V16h-1.5v-1.5zM16 13h1.5v1.5H16V13zm-3 3h1.5v1.5H13V16zm1.5 1.5H16V19h-1.5v-1.5zM16 16h1.5v1.5H16V16zm1.5-1.5H19V16h-1.5v-1.5zm0 3H19V19h-1.5v-1.5zM22 7h-2V4h-3V2h5v5zm0 15v-5h-2v3h-3v2h5zM2 22h5v-2H4v-3H2v5zM2 2v5h2V4h3V2H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6eb0dab0e987c327(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM19 19h2v2h-2zM13 13h2v2h-2zM15 15h2v2h-2zM13 17h2v2h-2zM15 19h2v2h-2zM17 17h2v2h-2zM17 13h2v2h-2zM19 15h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7196febe11604dee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h9v2h-9zM13 15h9v2h-9zM16 11h6v2h-6zM13 12L8 7v4H2v2h6v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d74243b1332b7bb1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.71 16.67A16.971 16.971 0 0012 12C7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71a.99.99 0 00-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7fa1119aad9dc77d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.18",
                    "cy": "17.82",
                    "r": "2.18"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e2ee5cd015fe966d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.03 3l-1.11 7.07h2.62l.7-4.5h2.58L11.8 18.43H9.47L9.06 21h7.27l.4-2.57h-2.35l2-12.86h2.58l-.71 4.5h2.65L22 3H9.03zM8 5H4l-.31 2h4L8 5zm-.61 4h-4l-.31 2h4l.31-2zm.92 8h-6L2 19h6l.31-2zm.62-4h-6l-.31 2h6.01l.3-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$520527d34fcc934(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 6a2 2 0 00-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 002 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d86063f1c324ecfa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6c0-1.1-.9-2-2-2h-4a2.5 2.5 0 00-5 0H5.01c-1.1 0-2 .9-2 2v3.8C5.7 9.8 6 11.96 6 12.5s-.29 2.7-3 2.7V19c0 1.1.9 2 2 2h3.8c0-2.16 1.37-2.78 2.2-2.94v-9.3l9 4.5V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12v4l4 1-4 1v4l10-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$252dd65807cddd6b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-2.5c2.33 0 4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2s-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cbe4814ac8ee4cea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 10.5h2v1h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-10 6.5H6.5v.75H9c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H5v-1.5h3.5v-.75H6c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h4v1.5zm3 4.5h-2V9h2v6zm6-3c0 .55-.45 1-1 1h-2.5v2H14V9h4c.55 0 1 .45 1 1v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e8cc944595602224(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41A10.963 10.963 0 0012 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3bbfdfa8a4bf0df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7c0 2.21-1.79 4-4 4S8 9.21 8 7s1.79-4 4-4 4 1.79 4 4zm-9 6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm10 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f1733ead54881b5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0be885ebb90530a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9d4ff6859c31a548(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ec3aef9f5d7f5780(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$400e15400bdb4309(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10a2 2 0 00-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10a2 2 0 002 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b660d93f6e269bb0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$480044dffe7edf02(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$74f33a1dd9d3d187(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm2 4h-4v-1h4v1zm-6.95 0c-.02-.17-.05-.33-.05-.5 0-2.76 2.24-5 5-5 .92 0 1.76.26 2.5.69V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h8.55zM12 10.5L5 7V5l7 3.5L19 5v2l-7 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6734a447c6c5dd1e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8ee1ddc5b546de8e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.83 18H21v-4h2v-4H12.83l8 8zm-1.05 4.61l1.41-1.41L2.81 2.81 1.39 4.22l2.59 2.59A6.012 6.012 0 001 12c0 3.31 2.69 6 6 6 2.21 0 4.15-1.2 5.18-2.99l7.6 7.6zM8.99 11.82c.01.06.01.12.01.18 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.06 0 .12 0 .18.01l1.81 1.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac1c204163c6d07a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.65 10A5.99 5.99 0 007 6c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 005.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1f0cf5c32670c705(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4.95C21.79 4.78 19.67 3 16.5 3c-3.18 0-5.29 1.78-5.5 1.95L16.5 12 22 4.95z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.51c-1.24 0-2.45-.2-3.57-.57a.994.994 0 00-1.02.24l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a653b552d785686(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2d487610f61bf64d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7903858ae0b95be5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b4d984b66b61d78d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8zm12.1 1H22c0-2.76-2.24-5-5-5h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1zM3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM19 12h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b958b3f2e6c36df2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac085a7b6a3313aa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4h10v15H7zM3 6h2v11H3zM19 6h2v11h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8dd31c786bcfab9f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9ea0e295d7b9722(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.5c-.91 0-2.75.46-2.75 1.38v4.62h1.5V19h2.5v-4.5h1.5V9.88c0-.91-1.84-1.38-2.75-1.38z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ed2158f3b46a6716(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f6e856a0909a2d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13 9.5h5v-2h-5v2zm0 7h5v-2h-5v2zm6 4.5H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM6 11h5V6H6v5zm1-4h3v3H7V7zM6 18h5v-5H6v5zm1-4h3v3H7v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d1092a0d81c2ade7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19c-1.1 0-2 .9-2 2h14c0-1.1-.9-2-2-2h-4v-2h3c1.1 0 2-.9 2-2h-8c-1.66 0-3-1.34-3-3 0-1.09.59-2.04 1.46-2.56C8.17 9.03 8 8.54 8 8c0-.21.04-.42.09-.62A5.01 5.01 0 005 12c0 2.76 2.24 5 5 5v2H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.56 5.51C11.91 5.54 13 6.64 13 8c0 .75-.33 1.41-.85 1.87l.59 1.62.94-.34.34.94 1.88-.68-.34-.94.94-.34-2.74-7.53-.94.34-.34-.94-1.88.68.34.94-.94.35.56 1.54z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "8",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f06c50e892f4b713(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.5-4.5-10-10-10S2 6.5 2 12s4.5 10 10 10 10-4.5 10-10zM5.7 7.1l11.2 11.2c-1.3 1.1-3 1.7-4.9 1.7-4.4 0-8-3.6-8-8 0-1.9.6-3.6 1.7-4.9zM20 12c0 1.9-.6 3.6-1.7 4.9L7.1 5.7C8.4 4.6 10.1 4 12 4c4.4 0 8 3.6 8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$728bf6c45714b6f6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 014 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0120 12c0 4.42-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d89c05eecae4c494(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9b72bede6a0381a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5.97 4.06L14.09 6l1.41 1.41L16.91 6l1.06 1.06-1.41 1.41 1.41 1.41-1.06 1.06-1.41-1.4-1.41 1.41-1.06-1.06 1.41-1.41-1.41-1.42zm-6.78.66h5v1.5h-5v-1.5zM11.5 16h-2v2H8v-2H6v-1.5h2v-2h1.5v2h2V16zm6.5 1.25h-5v-1.5h5v1.5zm0-2.5h-5v-1.5h5v1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f17e533dc8c9119e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.06 17v-2.01H12c-1.28 0-2.56-.49-3.54-1.46a5.006 5.006 0 01-.64-6.29l1.1 1.1c-.71 1.33-.53 3.01.59 4.13.7.7 1.62 1.03 2.54 1.01v-2.14l2.83 2.83L12.06 19zm4.11-4.24l-1.1-1.1c.71-1.33.53-3.01-.59-4.13A3.482 3.482 0 0012 8.5h-.06v2.15L9.11 7.83 11.94 5v2.02c1.3-.02 2.61.45 3.6 1.45 1.7 1.7 1.91 4.35.63 6.29z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6029771ddc70c890(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a065906c8469b00(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$27eeec043437cecf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "2",
                    "fill": "none"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": ".5",
                    "fill": "none"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "2",
                    "fill": "none"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$43d84711860f4a8a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v3h10V5h2v6h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.01 13l-1.42 1.41 1.58 1.58H12v2h6.17l-1.58 1.59 1.42 1.41 3.99-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a80f5529cd6e22a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.42zM5 19V7.83L16.17 19H5zM17 8V5h2v11.17l2 2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5.83l5 5H17zm-5-5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1dcbe5fcaf1baa4f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v3h10V5h2v5h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.3 18.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S12 14 12 16.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l2.7 2.7 1.4-1.4-2.7-2.7zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$28b8a9f892cdda5e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cc99e086d28883ef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H9V4h9v12zM3 15v-2h2v2H3zm0-5.5h2v2H3v-2zM10 20h2v2h-2v-2zm-7-1.5v-2h2v2H3zM5 22c-1.1 0-2-.9-2-2h2v2zm3.5 0h-2v-2h2v2zm5 0v-2h2c0 1.1-.9 2-2 2zM5 6v2H3c0-1.1.9-2 2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b098d6a3ff9ca710(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f075bd848736c5ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c407208502bb83ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h2v-2H3v2zm4 8h2v-2H7v2zm6-18h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zm8 4h2v-2h-2v2zm8-8h2v-2h-2v2zm0-4h2V7h-2v2zm-4-4h2V3h-2v2zM7.83 5L7 4.17V3h2v2H7.83zm12 12l-.83-.83V15h2v2h-1.17zm1.36 4.19L2.81 2.81 1.39 4.22 4.17 7H3v2h2V7.83l2 2V17h7.17l2 2H15v2h2v-1.17l2.78 2.78 1.41-1.42zM9 15v-3.17L12.17 15H9zm6-2.83V9h-3.17l-2-2H17v7.17l-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$38e51bf671f30044(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3fbbc12897006f69(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8H6v7c0 1.1.9 2 2 2h9v-2H8V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8h-8V7h8v4zM4 12H2v7c0 1.1.9 2 2 2h9v-2H4v-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$672bc011e96b37a0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2e22f2bbdc11409b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.83 8H21V6H8.83l2 2zm5 5H18v-2h-4.17l2 2zM14 16.83V18h-4v-2h3.17l-3-3H6v-2h2.17l-3-3H3V6h.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41L14 16.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4be9d810ce13305e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c64977a6ff775b03(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6 13h-5l-1-2H9.5v5H8V7h6l1 2h3v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a46a75f67258b746(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$670981d97adf841f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.58 9.75l-.87-.87.23-.66h.1l.54 1.53zm-2.23-2.23L10.92 6h2.14l2.55 6.79L22 19.17V4c0-1.1-.9-2-2-2H4.83l5.52 5.52zm10.14 15.79L19.17 22H4c-1.1 0-2-.9-2-2V4.83L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zm-8.39-8.38l-3.3-3.3L6.41 18h2.08l1.09-3.07h2.52z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5d6efae5bfcdd889(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "baseProfile": "tiny",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$12554e7089f27622(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8V4l8 8-8 8v-4H4V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df6eb5dca706296a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee8591914dc941f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M9 17l3-2.94a9.34 9.34 0 00-1-.06c-2.67 0-8 1.34-8 4v2h9l-3-3zm2-5c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4M15.47 20.5L12 17l1.4-1.41 2.07 2.08 5.13-5.17 1.4 1.41z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb6089801b402d8a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4c0 1.1.89 2 1.99 2H19a2 2 0 002-2v-4l-3-3zm-1-5.05l-4.95 4.95-3.54-3.54 4.95-4.95L17 7.95zm-4.24-5.66L6.39 8.66a.996.996 0 000 1.41l4.95 4.95c.39.39 1.02.39 1.41 0l6.36-6.36a.996.996 0 000-1.41L14.16 2.3a.975.975 0 00-1.4-.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$80ad5364587bba30(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a67447c396cb3ae0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8c-1.45 0-2.26 1.44-1.93 2.51l-3.55 3.56c-.3-.09-.74-.09-1.04 0l-2.55-2.55C12.27 10.45 11.46 9 10 9c-1.45 0-2.27 1.44-1.93 2.52l-4.56 4.55C2.44 15.74 1 16.55 1 18c0 1.1.9 2 2 2 1.45 0 2.26-1.44 1.93-2.51l4.55-4.56c.3.09.74.09 1.04 0l2.55 2.55C12.73 16.55 13.54 18 15 18c1.45 0 2.27-1.44 1.93-2.52l3.56-3.55c1.07.33 2.51-.48 2.51-1.93 0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9l.94-2.07L18 6l-2.06-.93L15 3l-.92 2.07L12 6l2.08.93zM3.5 11L4 9l2-.5L4 8l-.5-2L3 8l-2 .5L3 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9d8e40fd388422aa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-5 12H9v-2h6v2zm5-7H4V4h16v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8d9d98ea975906f2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-5 12H9v-2h6v2zm5-7H4V4l16-.02V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de5ba658842b478e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11A4.991 4.991 0 002 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3 2 4.27z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 24V0"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$efb79807b07cec7b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d32ee4047a3c9e4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f089d46e51c79479(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b2918aa80e843fa1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c46cb3e4fdfaec70(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9367346bf488813e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$866ed8f5e4632952(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$59b2ef36e9e0897e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5l-9-4-9 4v6c0 5.55 3.84 10.74 9 12 2.3-.56 4.33-1.9 5.88-3.71l-3.12-3.12a4.994 4.994 0 01-6.29-.64 5.003 5.003 0 010-7.07 5.003 5.003 0 017.07 0 5.006 5.006 0 01.64 6.29l2.9 2.9C20.29 15.69 21 13.38 21 11V5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56e48863e90f952(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$23a6584655829ac6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16a8.002 8.002 0 017.6-5.5c1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$819578fe910e8810(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$300ac45823727b52(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e79bba7fe4aa0120(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13H5v-2h14v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$62564f2e47239ce1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d00812005e831f2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9523afd39461093a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v6h-2zM11 15h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7e2bf65647a0e1db(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2.92l6.91 6.91 1.09-1.1V8.27L15.73 3H8.27L7.18 4.1 11 7.92zm11.27 14.73l-20-20.01L1 2.99l3.64 3.64L3 8.27v7.46L8.27 21h7.46l1.64-1.63L21 23l1.27-1.27zM12 17.3c-.72 0-1.3-.58-1.3-1.3s.58-1.3 1.3-1.3 1.3.58 1.3 1.3-.58 1.3-1.3 1.3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af9c4c9bd1a9b54d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aeac6fac78d07980(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6ec7a16d3fb06a63(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.4V7l-4-4H5a2 2 0 00-2 2v14a2 2 0 002 2h7.4l8.6-8.6zM15 15c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zM6 6h9v4H6V6zm13.99 10.25l1.77 1.77L16.77 23H15v-1.77l4.99-4.98zm3.26.26l-.85.85-1.77-1.77.85-.85c.2-.2.51-.2.71 0l1.06 1.06c.2.2.2.52 0 .71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ce2f5ee6c448b2b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$94cf2a162cfcb449(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9599065432f09240(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bd35c95d9bd4dd9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffd5019105f092a5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fd5de65bfe63d3e1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 17.66l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L9.7 9.7l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L4 4v14c0 1.1.9 2 2 2h14l-2.34-2.34zM7 17v-5.76L12.76 17H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$297062287b046190(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h4v11H4zM4 4h4v4H4zM10 7h4v4h-4zM16 10h4v4h-4zM16 15h4v5h-4zM10 12h4v8h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2d30c877e4105756(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "20",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.05 8.59L6.03 4.55h-.01l-.31-.32-1.42 1.41 4.02 4.05.01-.01.31.32zm3.893.027l4.405-4.392L19.76 5.64l-4.405 4.393zM10.01 15.36l-1.42-1.41-4.03 4.01-.32.33 1.41 1.41 4.03-4.02zm9.75 2.94l-3.99-4.01-.36-.35L14 15.35l3.99 4.01.35.35z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$901e0f46246f7f9c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4h4zm-6 4h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$28a2ef6c035d88b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$88850bae42c80ef4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.55 5.22l-1.39-1.68A1.51 1.51 0 0018 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19a2 2 0 002 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$881a8de0f6736451(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8cff29007af1c839(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.16 7.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM11 3h2v5h-2zM6.4 10.81L7.81 9.4 4.26 5.84 2.84 7.26c.11.03 3.56 3.55 3.56 3.55zM20 12h-5c0 1.66-1.34 3-3 3s-3-1.34-3-3H4c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a93d7df594f9c61b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16.99c-1.35 0-2.2.42-2.95.8-.65.33-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.95c1.35 0 2.2-.42 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.42 2.95-.8c.65-.33 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm0-4.45c-1.35 0-2.2.43-2.95.8-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.32-1.17.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm2.95-8.08c-.75-.38-1.58-.8-2.95-.8s-2.2.42-2.95.8c-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.37-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.93c1.35 0 2.2-.43 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V5.04c-.9 0-1.4-.25-2.05-.58zM17 8.09c-1.35 0-2.2.43-2.95.8-.65.35-1.15.6-2.05.6s-1.4-.25-2.05-.6c-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.35-1.15.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.32 1.18-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V9.49c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa6ddcf1fdd87c6d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2V4zM2 20c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v16zm19-2c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a5d172bea07b840f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10c-1.1 0-2 .9-2 2v3H5v-3a2 2 0 10-4 0v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.52 2 2.81V14h12v-2.03c0-1.3.84-2.4 2-2.81V7c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ca7f0298dc5fac68(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c3.86 0 7 3.14 7 7 0 5.25-7 13-7 13S5 14.25 5 9c0-3.86 3.14-7 7-7zm-1.53 12L17 7.41 15.6 6l-5.13 5.18L8.4 9.09 7 10.5l3.47 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d3d17a90ffb60b42(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h4v10H6V9H4V7zm11.83 4.72L18.66 7h-2.33l-1.66 2.77L13 7h-2.33l2.83 4.72L10.33 17h2.33l2-3.34 2 3.34H19l-3.17-5.28z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6388d1947c199165(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5v3h6v2.5H3v3h5V16H2v3h6c1.66 0 3-1.34 3-3v-1.9A2.1 2.1 0 008.9 12 2.1 2.1 0 0011 9.9V8c0-1.66-1.34-3-3-3H2zm17 3v8h-4V8h4m0-3h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$661fe87fb0f26019(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7v2h5v2H4v2h4v2H3v2h5c1.1 0 2-.9 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V9c0-1.1-.9-2-2-2H3zm18 4v4c0 1.1-.9 2-2 2h-5c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h5c1.1 0 2 .9 2 2h-7v6h5v-2h-2.5v-2H21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a7bf73d1ec8c8bb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H7v5H5V7H3v7h4v3h2v-3h2v-2H9V7zm8 4v2h2v2h-5V9h7c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84502426f2efbab3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11v2h2v2h-4V9h6c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-4h-4zm11 0h-2V9h-2v2h-2v2h2v2h2v-2h2v-2zM7 7H5v5H3V7H1v7h4v3h2v-3h1v-2H7V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$82a617b4224a806b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8v8h-4V8h4m0-3h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3zm-9 3V5H5C3.34 5 2 6.34 2 8v8c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3v-3c0-1.66-1.34-3-3-3H5V8h5zm-2 5v3H5v-3h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$42b3cf7de0d56064(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c2f76e7b119eb8dc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M-618-568H782v3600H-618zM0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df468d243d157c99(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm3.3 14.71L11 12.41V7h2v4.59l3.71 3.71-1.42 1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$783f01e0764e22b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5db749e8c2e17278(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zM8 6h8v2H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$358c7c3641209ccb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa82fb29819d7b3f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1.01L8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM10 15h2V8H5v2h3.59L3 15.59 4.41 17 10 11.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d76abe708563eb3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 17c0 1.65-1.35 3-3 3s-3-1.35-3-3h2c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1H2v-2h9.5c1.65 0 3 1.35 3 3zM19 6.5C19 4.57 17.43 3 15.5 3S12 4.57 12 6.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S16.33 8 15.5 8H2v2h13.5c1.93 0 3.5-1.57 3.5-3.5zm-.5 4.5H2v2h16.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5v2c1.93 0 3.5-1.57 3.5-3.5S20.43 11 18.5 11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bbb381fe9f5a3e0e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.19 4H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.81-2-1.81-2zm-2.46 9.3l-8.86 2.36-1.66-2.88.93-.25 1.26.99 2.39-.64-2.4-4.16 1.4-.38 4.01 3.74 2.44-.65a.967.967 0 011.18.68.988.988 0 01-.69 1.19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f64cf7bd4e08071(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ca3e38e3d5f01ff4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 7.67V3.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V9l8.5 5v2l-4.49-1.32-7.01-7.01zm9.28 14.94l1.41-1.41-7.69-7.7-3.94-3.94-6.75-6.75-1.42 1.41 6.38 6.38L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-2.67l6.28 6.28z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e2b1250238aeff97(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 18H7V6h10v12zm-9-8h8v1.5H8V10zm1 3h6v1.5H9V13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fce41ea2418c6a2c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v14h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7a4249cef2854d4a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v12h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d82c0471a53cac48(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v10h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$466caa5938691d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v8h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a46e6e892651421(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v6h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$67fe54ef7ef6afd6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v4h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c5ce602e5fa5c7fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v2h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$55681af8496c6baf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa1ad53d8674c1e9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3c900c10753ef2cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5aea07cf1911c154(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h-2V2h-4v2H8c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 10h-2v2h-2v-2H9v-2h2v-2h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b4a4a532bbb17a9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ced48b7b07a96dcc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94A1.498 1.498 0 0012 9.5c-.83 0-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$faba9d88bfa19c4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zm3 16H9v-2h6v2zm0-5h-2v2h-2v-2H9v-2h2V9h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$888db96eb19a8f12(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$becf232ecf516b6e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$99a135e2d0052be7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10H4.81l1.04-3H15V5H5.5c-.66 0-1.21.42-1.42 1.01L2 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8h-3c-1.1 0-2-.9-2-2zm-8.5 6c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3.85L19.15 1h-.5v3.79l-2.3-2.29-.7.7L18.44 6l-2.79 2.79.7.71 2.3-2.3V11h.5L22 8.14 19.85 6 22 3.85zm-2.35-.94l.94.94-.94.94V2.91zm.94 5.23l-.94.94V7.2l.94.94z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5831b9a09391f3a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2a9.936 9.936 0 001.54-5.31c-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7be419572e5e7fc8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$87f6194b5ce50b22(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b5a9cc95e16b2b0e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4a915c37c059cd60(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$25b4e3051c91fa1b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1a4a4fca1d96e5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5V4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1h-1v4c0 .55.45 1 1 1h1v7c0 1.1-.9 2-2 2s-2-.9-2-2V7c0-2.21-1.79-4-4-4S5 4.79 5 7v7H4c-.55 0-1 .45-1 1v4h1v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h1v-4c0-.55-.45-1-1-1H7V7c0-1.1.9-2 2-2s2 .9 2 2v10c0 2.21 1.79 4 4 4s4-1.79 4-4v-7h1c.55 0 1-.45 1-1V5h-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7aa44ab933d379ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h-1l-1-1h-4L9 7H8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-4 7c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.57.51l4.48 4.48V2.04c4.72.47 8.48 4.23 8.95 8.95h2C23.34 3.02 15.49-1.59 8.57.51zM10.95 21.96c-4.72-.47-8.48-4.23-8.95-8.95H0c.66 7.97 8.51 12.58 15.43 10.48l-4.48-4.48v2.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4735fc3a6cc7a1b0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h5v-2H4v-6h18V6c0-1.11-.89-2-2-2zm0 4H4V6h16v2zm-5.07 11.17l-2.83-2.83-1.41 1.41L14.93 22 22 14.93l-1.41-1.41-5.66 5.65z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$454828cd862c88e8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3a9 9 0 109 9c0-.46-.04-.92-.1-1.36a5.389 5.389 0 01-4.4 2.26 5.403 5.403 0 01-3.14-9.8c-.44-.06-.9-.1-1.36-.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bfebf53d0c3b0da1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0112 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$302a3e3560f3997f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8v3H8v2h3v3h2v-3h3v-2h-3V8h-2zm2-5.95v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0112 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b8b181e778144e9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0112 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$57d1e64a0a6e91fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.09 17H7v-4h3.69c.95-.63 2.09-1 3.31-1h6c.34 0 .67.04 1 .09V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h3.81C8.3 20.12 8 19.09 8 18c0-.34.04-.67.09-1zM13 7h4v4h-4V7zM7 7h4v4H7V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c0-1.1.9-2 2-2h2v-2h-2c-2.21 0-4 1.79-4 4s1.79 4 4 4h2v-2h-2c-1.1 0-2-.9-2-2zM20 14h-2v2h2c1.1 0 2 .9 2 2s-.9 2-2 2h-2v2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17h6v2h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bd5d5e0a48cc846f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 14H7v-4h4v4zm0-6H7V7h4v4zm6 6h-4v-4h4v4zm0-6h-4V7h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4491c439463d9d65(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8b4c039c38dc3acb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-8c0-.55.45-1 1-1s1 .45 1 1h-1v1h1v2h-1v1h1v2h-2V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2d08f5ed0b2a00d9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-3c0-1.43-1.47-2.4-2.79-1.84l-3 1.29C10.48 2.76 10 3.49 10 4.29V19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-5.33l1.12-.48c.73-.32 1.21-1.04 1.21-1.84V5h3v14zM2 3h2v2H2zM2 19h2v2H2zM2 15h2v2H2zM2 11h2v2H2zM2 7h2v2H2zM6 3h2v2H6zM6 19h2v2H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$17dce2374f409413(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6f6a6a8d51de68ef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.79 21L3 11.21v2c0 .53.21 1.04.59 1.41l7.79 7.79c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83L12.79 21z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.38 17.41c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83L12.63.58A2.04 2.04 0 0011.21 0H5C3.9 0 3 .9 3 2v6.21c0 .53.21 1.04.59 1.41l7.79 7.79zM7.25 3a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dcb26f966795f355(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.6-6-6-6zm3 7H9v-2h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d054ca660455f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3a5aae5f0c63513(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9V7H8v10h8v-2h-6v-2h6v-2h-6V9h6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6ba9ba6ccebdf7a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7h2v7H3V7zm-3 3h2v7H0v-7zm22-3h2v7h-2V7zm-3 3h2v7h-2v-7zm-3-7.99L8 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-1.99-2-1.99zM16 17H8V7h8v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c8404d2e9f02b5fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7h2v7H2V7zm18 3h2v7h-2v-7zm-4-7.99L8 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-1.99-2-1.99zM16 17H8V7h8v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ccc78ae36e5694fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5V2H6v1.17L7.83 5zM16 11l2-3V7H9.83L16 13.17zM2.81 2.81L1.39 4.22 8 10.83V22h8v-3.17l3.78 3.78 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4b610b44aadb03d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2h12v3H6zM6 7v1l2 3v11h8V11l2-3V7H6zm6 8.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c40466676da0ac7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9h14v6H5zM11 2h2v3h-2zM17.286 6.399l1.79-1.803 1.42 1.41-1.79 1.802zM11 19h2v3h-2zM17.29 17.71l1.79 1.8 1.42-1.42-1.8-1.79zM3.495 6.01l1.407-1.408L6.69 6.391 5.284 7.798zM3.492 18.076l1.803-1.79 1.409 1.42-1.803 1.79z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$44daacddbd91d9cf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9h14v6H5zM11 2h2v3h-2zM17.286 6.399l1.79-1.803 1.42 1.41-1.79 1.802zM11 19h2v3h-2zM17.29 17.71l1.79 1.8 1.42-1.42-1.8-1.79zM3.495 6.01l1.407-1.408L6.69 6.391 5.284 7.798zM3.492 18.076l1.803-1.79 1.409 1.42-1.803 1.79z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5b6b5639db889673(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8C20 5.22 16.2 2 12 2zm1 13h-2v-2h2v2zm0-4h-2V6h2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$86fc60ce525c651e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8C20 5.22 16.2 2 12 2zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bbc4b77213046bb6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11v2h2v2H9V9h7c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb7f645dcdb980(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm3.5 12.09l-1.41 1.41L12 13.42 9.91 15.5 8.5 14.09 10.59 12 8.5 9.91 9.91 8.5 12 10.59l2.09-2.09 1.41 1.41L13.42 12l2.08 2.09z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ec02266171176b2f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm-1.06 13.54L7.4 12l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41-5.64 5.66z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f54419c5ed88f7ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm1 14h-2v-2h2v2zm0-4h-2V7h2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$68d167f22411dc45(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$210d4a9e52763b34(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d2b227027f8e7bd3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5A6.995 6.995 0 0119 12c0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04A8.914 8.914 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27a6.995 6.995 0 01-9.81-9.81l9.81 9.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d71eebe2d3c87efd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$53b3c8801bbd4919(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4h4zm-6 4h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4f24bad707159508(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7V5h-3V2h-2v3h-4V2h-2v3H7V2H5v3H2v2h3v4H2v2h3v4H2v2h3v3h2v-3h4v3h2v-3h4v3h2v-3h3v-2h-3v-4h3v-2h-3V7h3zM7 7h4v4H7V7zm0 10v-4h4v4H7zm10 0h-4v-4h4v4zm0-6h-4V7h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd425e5818b16502(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V9h-7V2h-2v7h-2V2H9v7H2v2h7v2H2v2h7v7h2v-7h2v7h2v-7h7v-2h-7v-2h7zm-9 2h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b576cfe1b96d6866(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11H9V7H7v10h2v-4h6v4h2V7h-2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ff3905301df7177(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11H6V7H4v10h2v-4h6v4h2V7h-2v4zm10 0h-2V9h-2v2h-2v2h2v2h2v-2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4913f5102eeba807(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16H6.5v6H10c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5H8v-3h2v3zM16.5 16H13v6h1.5v-2h1.1l.9 2H18l-.9-2.1c.5-.3.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1zM3.5 18h-2v-2H0v6h1.5v-2.5h2V22H5v-6H3.5zM22 18.5v-2h-1.5v2h-2V20h2v2H22v-2h2v-1.5zM11.97 5.3l-1.02 2.89h2.1L12.03 5.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.69 2 6 4.69 6 8s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm2.04 9l-.63-1.79h-2.83L9.96 11H8.74l2.63-7h1.25l2.63 7h-1.21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$48285bdda19a2bd3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.04 8.04h-.09l-1.6 4.55h3.29z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.21 15l-.98-2.81H9.78l-1 2.81h-1.9l4.13-11h1.97l4.13 11h-1.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7bddf47d0961c866(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18.5v-1c0-.8-.7-1.5-1.5-1.5H13v6h1.5v-2h1.1l.9 2H18l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2v-2H0v6h1.5v-2.5h2V22H5v-6H3.5v2zm6.5-2H6.5v6H10c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5H8v-3h2v3zm14-.5h-2v2h-1.5v-2h-2v-1.5h2v-2H22v2h2V20zM10.98 4.15L9.42 2.59c5.1-2.42 10.41 2.89 7.99 7.99l-1.56-1.56c.81-2.96-1.91-5.68-4.87-4.87zM6.34 2.34L4.93 3.76l1.66 1.66c-2.42 5.1 2.89 10.41 7.99 7.99l1.66 1.66 1.41-1.41L6.34 2.34zm1.81 4.64l4.87 4.87c-2.96.81-5.68-1.91-4.87-4.87z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f02d4b16e06bf83f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18.5v-1c0-.8-.7-1.5-1.5-1.5H13v6h1.5v-2h1.1l.9 2H18l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2v-2H0v6h1.5v-2.5h2V22H5v-6H3.5v2zm6.5-2H6.5v6H10c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5H8v-3h2v3zm14-.5h-2v2h-1.5v-2h-2v-1.5h2v-2H22v2h2V20zM12 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4m0-2C8.69 2 6 4.69 6 8s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$75e61f17aa7cac8a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 22h8v-7h-3v-4h-5V9h3V2H8v7h3v2H6v4H3v7h8v-7H8v-2h8v2h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a58d590b025acec2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$950df6cb028123e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58a.996.996 0 00-1.41 0 .996.996 0 000 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37a.996.996 0 00-1.41 0 .996.996 0 000 1.41l1.06 1.06c.39.39 1.03.39 1.41 0a.996.996 0 000-1.41l-1.06-1.06zm1.06-10.96a.996.996 0 000-1.41.996.996 0 00-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36a.996.996 0 000-1.41.996.996 0 00-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$49999befc88cf7b8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5A6.995 6.995 0 0119 12c0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04A8.914 8.914 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27a6.995 6.995 0 01-9.81-9.81l9.81 9.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$92f3ea86d5461d1a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$73989a8dbf294af0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h3v2H4V8h2v6zm3-4h2v6h2v-6h2V8H9v2zm12 0V8h-5v8h5v-2h-3v-1h3v-2h-3v-1h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d7d98f7a2db2e75(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h3v2H1V8h2v6zm2-4h2v6h2v-6h2V8H5v2zm7 6h5v-2h-3v-1h3v-2h-3v-1h3V8h-5v8zm12-5h-2V9h-2v2h-2v2h2v2h2v-2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$28063b413d3b6b69(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.98 17.15A8.909 8.909 0 0021 13c-1.5 0-2.91.37-4.15 1.02l3.13 3.13zM3 13a9 9 0 009 9 9 9 0 00-9-9zM12 5.5A2.5 2.5 0 0114.5 8c0 .99-.58 1.84-1.42 2.25l2.48 2.48c.11.02.23.03.35.03a2.5 2.5 0 002.5-2.5c0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25a2.5 2.5 0 00-3.92-2.06l.01-.2a2.5 2.5 0 00-5 0l.02.19a2.485 2.485 0 00-2.93.08l3.16 3.16c.41-.85 1.26-1.43 2.25-1.43z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l4.64 4.64c-.27.4-.43.87-.43 1.39a2.5 2.5 0 002.5 2.5c.52 0 .99-.16 1.4-.43l.02.02-.02.16A2.5 2.5 0 0012 15c.05 0 .1-.01.16-.02l1.64 1.64A8.905 8.905 0 0012 22c2.02 0 3.88-.67 5.38-1.8l2.4 2.4 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab21a9f9a9edbbf8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6.17V3h6v4h-4v1.17l-2-2zM19.42 15L22 17.57l-.8.8-6.78-6.78.8-.8 2.75 2.75V9h.6L22 12.43 19.42 15zm-.25-1.45l1.13-1.13-1.13-1.13v2.26zm2.02 7.64l-1.41 1.41-3.98-3.98-.58.58-.85-.85.58-.58L11 13.83V17c0 2.21-1.78 4-3.99 4S3 19.21 3 17s1.79-4 4.01-4c.73 0 1.41.21 2 .55v-1.72L1.39 4.22 2.8 2.81l18.39 18.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$accc131826bfe06a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3l.01 10.55c-.6-.34-1.28-.55-2-.55a4.001 4.001 0 100 8C9.23 21 11 19.21 11 17V7h4V3H9zm12 9.43L17.57 9h-.6v4.55l-2.75-2.75-.85.85L16.73 15l-3.35 3.35.85.85 2.75-2.75V21h.6L21 17.57 18.42 15 21 12.43zm-2.83-1.13l1.13 1.13-1.13 1.13V11.3zm1.13 6.27l-1.13 1.13v-2.26l1.13 1.13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd4c596e7bb867e1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h12v2H3zM14 6H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-1 9h-2.5v2.5h-3V15H5v-3h2.5V9.5h3V12H13v3zM20 6c-1.68 0-3 1.76-3 4 0 1.77.83 3.22 2 3.76V20c0 .55.45 1 1 1s1-.45 1-1v-6.24c1.17-.54 2-1.99 2-3.76 0-2.24-1.32-4-3-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a2b858d1fd659530(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3h12v2H6zM17 6H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-1 9h-2.5v2.5h-3V15H8v-3h2.5V9.5h3V12H16v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ddd5f5c5bb0d3472(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7.01 13.47l-2.55-2.55-1.27 1.27L7 16l7.19-7.19-1.27-1.27z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$842a0ec251ed0c25(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.76 2.49L1.49 3.76 5 7.27V21c0 1.1.9 2 2 2h10c1.02 0 1.85-.77 1.98-1.75l1.72 1.72 1.27-1.27L2.76 2.49zM7 19V9.27L16.73 19H7zM17 5v9.17l2 2V3c0-1.1-.9-2-2-2H7c-.85 0-1.58.54-1.87 1.3L7.83 5H17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd61e293dc4b993(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h3l-4-4-4 4h3v4.17l2 2zM2.81 2.81L1.39 4.22 8 10.83v6.18l-3 .01L9 21l4-4-3 .01v-4.18l9.78 9.78 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cfcf2ef1f968045e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 2c-1.82 0-3.53.5-5 1.35 2.99 1.73 5 4.95 5 8.65s-2.01 6.92-5 8.65c1.47.85 3.18 1.35 5 1.35 5.52 0 10-4.48 10-10S15.02 2 9.5 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9cece3198407c000(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8d81c97d683a8237(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.11 12.45L14 10.24l-3.11 6.21c-.16.34-.51.55-.89.55s-.73-.21-.89-.55L7.38 13H2v5c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-5h-6c-.38 0-.73-.21-.89-.55z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v5h6c.38 0 .73.21.89.55L10 13.76l3.11-6.21c.34-.68 1.45-.68 1.79 0L16.62 11H22V6c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7e4accf19b38fe57(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 9c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8.5h1v1h-1zM11.5 8.5h1v1h-1zM13 8.5h1v1h-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a4f233cb66655705(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.57l4.42 4.42L12 16.41l-4.42-4.42L12 7.57zm0 11.62l-7.2-7.2 7.2-7.2 6 6V7.16l-4.58-4.58c-.78-.78-2.05-.78-2.83 0l-8.01 8c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0L18 16.82v-3.63l-6 6zm8 .81h2v2h-2v-2zm2-10h-2v8h2v-8"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1c1030f007fa79a9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 13.42L18.83 16l-1.81-1.81L19.2 12 12 4.8 9.81 6.99 8 5.17l2.58-2.58c.78-.78 2.05-.78 2.83 0l8 8c.79.78.79 2.04 0 2.83zm-.22 7.77l-1.41 1.41L16 18.83l-2.58 2.58c-.78.78-2.05.78-2.83 0l-8-8c-.78-.78-.78-2.05 0-2.83L5.17 8 1.39 4.22 2.8 2.81l18.39 18.38zm-7-4.17l-1.39-1.39-.8.8L7.58 12l.8-.8-1.4-1.39L4.8 12l7.2 7.2 2.19-2.18zM16.42 12L12 7.58l-.8.8 4.42 4.42.8-.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ad21d32f599f5063(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20V2L2 22zm18-2h-3V9.83l3-3V20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$23ff087fbc017f3c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zm3.32 10.84C14.34 14.3 13.2 14 12 14c-1.2 0-2.34.3-3.32.84L2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-5.76 5.77z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b87f81244c5935c8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zm4.78 9.38A8.853 8.853 0 0012 12c-1.76 0-3.4.5-4.78 1.38l-4.3-4.3C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-4.3 4.31z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1aa48743ebe1f104(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zM2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-2.85 2.86A10.945 10.945 0 0012 10c-2.31 0-4.46.71-6.23 1.93L2.92 9.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d343ce8a3519557(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98zm-21.08.09C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-1.43 1.43C17.5 8.94 14.86 8 12 8s-5.5.94-7.65 2.51L2.92 9.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3fe42f11d0556143(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M4 20h16V4H4v16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$70278990942b593a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2c1.82 0 3.53.5 5 1.35-2.99 1.73-5 4.95-5 8.65s2.01 6.92 5 8.65A9.973 9.973 0 0114 22C8.48 22 4 17.52 4 12S8.48 2 14 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9f9d7d0e5a86e825(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM9.1 17H7v-2.14l5.96-5.96 2.12 2.12L9.1 17zm7.75-7.73l-1.06 1.06-2.12-2.12 1.06-1.06c.2-.2.51-.2.71 0l1.41 1.41c.2.2.2.51 0 .71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$32af97fc0e6e878d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17h20v2H2v-2zm1.15-4.05L4 11.47l.85 1.48 1.3-.75-.85-1.48H7v-1.5H5.3l.85-1.47L4.85 7 4 8.47 3.15 7l-1.3.75.85 1.47H1v1.5h1.7l-.85 1.48 1.3.75zm6.7-.75l1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H15v-1.5h-1.7l.85-1.47-1.3-.75L12 8.47 11.15 7l-1.3.75.85 1.47H9v1.5h1.7l-.85 1.48zM23 9.22h-1.7l.85-1.47-1.3-.75L20 8.47 19.15 7l-1.3.75.85 1.47H17v1.5h1.7l-.85 1.48 1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H23v-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4951b986d584a433(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm2 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-.02 6c-.74 0-1.37.4-1.72 1h-2.54a1.98 1.98 0 00-3.44 0H8.41l3.07-3.07c.17.04.34.07.52.07 1.1 0 2-.9 2-2 0-.18-.03-.35-.07-.51l3.56-3.56c.16.04.33.07.51.07 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .18.03.35.07.51l-3.56 3.56c-.16-.04-.33-.07-.51-.07-1.1 0-2 .9-2 2 0 .18.03.35.07.51l-3.56 3.56C6.35 16.03 6.18 16 6 16c-1.1 0-2 .9-2 2s.9 2 2 2c.74 0 1.37-.4 1.72-1h2.57a1.98 1.98 0 003.44 0h2.55c.34.6.98 1 1.72 1 1.1 0 2-.9 2-2-.02-1.1-.92-2-2.02-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ff92cd5ac188ebd5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9c0-1.3-.84-2.4-2-2.82V2h-2v4.18C13.84 6.6 13 7.7 13 9s.84 2.4 2 2.82V15c0 2.21-1.79 4-4 4s-4-1.79-4-4v-1h3L5 9v6c0 3.31 2.69 6 6 6s6-2.69 6-6v-3.18c1.16-.42 2-1.52 2-2.82zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d3d833c7a4b89ffc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.64 15H6.49v-4.5l-.9.66-.58-.89L6.77 9h.87v6zm5.86 0H9.61v-1.02c1.07-1.07 1.77-1.77 2.13-2.15.4-.42.54-.69.54-1.06 0-.4-.31-.72-.81-.72-.52 0-.8.39-.9.72l-1.01-.42c.01-.02.18-.76 1-1.15.69-.33 1.48-.2 1.95.03.86.44.91 1.24.91 1.48 0 .64-.31 1.26-.92 1.86-.25.25-.72.71-1.4 1.39l.03.05h2.37V15zm5.25-.85c-.08.13-.56.85-1.76.85-.04 0-1.6.08-2.05-1.51l1.03-.41c.03.1.19.86 1.02.86.41 0 .89-.28.89-.77 0-.55-.48-.79-1.04-.79h-.5v-1h.46c.33 0 .88-.14.88-.72 0-.39-.31-.65-.75-.65-.5 0-.74.32-.85.64l-.99-.41C15.2 9.9 15.68 9 16.94 9c1.09 0 1.54.64 1.62.75.33.5.28 1.16.02 1.57-.15.22-.32.38-.52.48v.07c.28.11.51.28.68.52.37.52.33 1.27.01 1.76z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6260b89643d371ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c.34 0 .67.03 1 .08V4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h7.26A6.995 6.995 0 0118 11zM7 11V4h5v7L9.5 9.5 7 11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm-1.25 7.5v-5l4 2.5-4 2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$353a76ff20a3b9f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm-8 6H8v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1H8v-1H6v-2h4v-1H7c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h1V7h2v1h2v2zm4 6.25l-2-2h4l-2 2zM14 10l2-2 2 2h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ef847d5d51554e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13V9c0-.55-.45-1-1-1H7V6h5V4H9.5V3h-2v1H6c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4v2H5v2h2.5v1h2v-1H11c.55 0 1-.45 1-1zM19.59 12.52l-5.66 5.65-2.83-2.83-1.41 1.42L13.93 21 21 13.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4ce187723e44934c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6h-1V1H6v5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM8 3h8v3H8V3zm4 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 11.5h-1v2.71l1.64 1.64.71-.71-1.35-1.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$59fe74f01491329c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.99 13c-.59 0-1.05-.47-1.05-1.05 0-.59.47-1.04 1.05-1.04.59 0 1.04.45 1.04 1.04-.01.58-.45 1.05-1.04 1.05zm2.5-6.17c-.63.93-1.23 1.21-1.56 1.81-.13.24-.18.4-.18 1.18h-1.52c0-.41-.06-1.08.26-1.65.41-.73 1.18-1.16 1.63-1.8.48-.68.21-1.94-1.14-1.94-.88 0-1.32.67-1.5 1.23l-1.37-.57C11.51 5.96 12.52 5 13.99 5c1.23 0 2.08.56 2.51 1.26.37.61.58 1.73.01 2.57z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ede2f19ebd6a75d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.8 7.2L9 10H7L5.87 7.33H4V10H2V2h5c1.13 0 2 .87 2 2v1.33c0 .8-.53 1.54-1.2 1.87zM7 4H4v1.33h3V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$27b357d69846ce3c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.74 18.33A9.984 9.984 0 0022 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10a9.984 9.984 0 007.11-2.97c.03-.03.05-.06.07-.08.2-.2.39-.41.56-.62zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8c0 1.85-.63 3.54-1.69 4.9l-1.43-1.43c.69-.98 1.1-2.17 1.1-3.46 0-3.31-2.69-6-6-6s-6 2.69-6 6 2.69 6 6 6c1.3 0 2.51-.42 3.49-1.13l1.42 1.42A7.822 7.822 0 0112 20zm1.92-7.49c.17-.66.02-1.38-.49-1.9l-.02-.02c-.77-.77-2-.78-2.78-.04-.01.01-.03.02-.05.04-.78.78-.78 2.05 0 2.83l.02.02c.52.51 1.25.67 1.91.49l1.51 1.51c-.6.36-1.29.58-2.04.58-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4c0 .73-.21 1.41-.56 2l-1.5-1.51z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$389a009d75529cc8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 14.21c-1.5-.77-3.2-1.21-5-1.21s-3.5.44-5 1.21V6h10v9.21z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1c02f7a6fe0ce804(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10h-8.01V7L9 11l3.99 4v-3H21v5H3V5h18v3h2V5c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2v-5H23c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c897c18aebb86a83(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V2L8 6l4 4V7c3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93 0-4.42-3.58-8-8-8zM6 13c0-1.65.67-3.15 1.76-4.24L6.34 7.34A8.014 8.014 0 004 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cefa98c090cd4af1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6.43 9.57L12 15l-1.57-3.43L7 10l3.43-1.57L12 5l1.57 3.43L17 10l-3.43 1.57z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8d010e6066d0bfc2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9h1.5l-1.75 6h-1.5L12.5 9H14l1 3.43L16 9zM5.1 12.9L6 15H4.5l-.85-2H2.5v2H1V9h3.5c.85 0 1.5.65 1.5 1.5v1c0 .6-.4 1.15-.9 1.4zm-.6-2.4h-2v1h2v-1zm17 2.5h-2v2H18V9h3.5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5zm0-2.5h-2v1h2v-1zM11.5 9v1.5h-3v.75h2c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H7v-1.5h3v-.75H7.75c-.41 0-.75-.34-.75-.75v-2c0-.55.45-1 1-1h3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$12b40b9c4ff96c81(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1a2 2 0 10-4 0v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d9ef3a6900b2f61(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1a2 2 0 10-4 0v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6095d926c73dc844(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75a1.49 1.49 0 00-2.12 0L2.75 7.11a1.49 1.49 0 000 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48A10.487 10.487 0 012.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5a2.5 2.5 0 00-5 0V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$341506db416bc56c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77a1.49 1.49 0 00-2.12 0L1.75 8.11a1.49 1.49 0 000 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29A10.487 10.487 0 011.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$61bf58d2623f8101(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M9.6 16.8h4.8v1.8H9.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 6a2 2 0 00-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 002 2H0v2h24v-2h-4zM4 16V6h16v10.01L4 16zm5.097-6.047c0-1.027.836-1.864 1.864-1.864 1.027 0 1.864.837 1.864 1.864a1.867 1.867 0 01-1.864 1.864 1.867 1.867 0 01-1.864-1.864zm7.032 4.236l-2.482-2.482a3.19 3.19 0 00.527-1.754A3.216 3.216 0 0010.96 6.74a3.217 3.217 0 00-3.214 3.213 3.218 3.218 0 003.214 3.214 3.19 3.19 0 001.724-.51l2.489 2.487.955-.955z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6835d352d0973cca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h4v2h8v-2h4c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 14H4V5h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 7.5H9V6H5v4h1.5zM19 12h-1.5v2.5H15V16h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe30cef346c9d764(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 18H7V6h10v12zM9.5 8.5H12V7H8v4h1.5V8.5zM12 17h4v-4h-1.5v2.5H12V17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$928f3a1c5fc0a7ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$98f2b7a0744e5d24(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 17H7V6h10v12zm-1-7.95l-1.41-1.41-3.54 3.54-1.41-1.41-1.41 1.41L11.05 15 16 10.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$93fb00805661bc74(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zM11 7h2v6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 17H7V6h10v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$afdb474ee83a9329(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2zm12 15H7V6h10v12zm-1-6h-3V8h-2v4H8l4 4 4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85ecb5d8998f613a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 11.41l-8.83-8.83c-.37-.37-.88-.58-1.41-.58H4c-1.1 0-2 .9-2 2v7.17c0 .53.21 1.04.59 1.41l8.83 8.83c.78.78 2.05.78 2.83 0l7.17-7.17c.78-.78.78-2.04-.01-2.83zM6.5 8C5.67 8 5 7.33 5 6.5S5.67 5 6.5 5 8 5.67 8 6.5 7.33 8 6.5 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7b282892a2572e64(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17h2v4c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-1.99 2-1.99L17 1c1.1 0 2 .9 2 2v4h-2V6H7v12h10v-1zm5-5l-4-4v3h-5v2h5v3l4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db974bdb843f462b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.41 6.59L15 5.5l2.41-1.09L18.5 2l1.09 2.41L22 5.5l-2.41 1.09L18.5 9l-1.09-2.41zm3.87 6.13L20.5 11l-.78 1.72-1.72.78 1.72.78.78 1.72.78-1.72L23 13.5l-1.72-.78zm-5.04 1.65l1.94 1.47-2.5 4.33-2.24-.94c-.2.13-.42.26-.64.37l-.3 2.4h-5l-.3-2.41c-.22-.11-.43-.23-.64-.37l-2.24.94-2.5-4.33 1.94-1.47c-.01-.11-.01-.24-.01-.36s0-.25.01-.37l-1.94-1.47 2.5-4.33 2.24.94c.2-.13.42-.26.64-.37L7.5 6h5l.3 2.41c.22.11.43.23.64.37l2.24-.94 2.5 4.33-1.94 1.47c.01.12.01.24.01.37s0 .24-.01.36zM13 14c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c45d209f9e42ec22(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h6.5a2.5 2.5 0 000-5h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16A2.994 2.994 0 006 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$72bc5fd7f3ba46f0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.02 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.42-1.43a7.941 7.941 0 01-3.9 1.62zM4.03 12c0-4.05 3.03-7.41 6.95-7.93V2.05C5.95 2.58 2.03 6.84 2.03 12c0 5.16 3.92 9.42 8.95 9.95v-2.02c-3.92-.52-6.95-3.88-6.95-7.93zM19.95 11h2.02c-.2-2.01-1-3.84-2.21-5.32l-1.43 1.43c.86 1.1 1.44 2.43 1.62 3.89zM18.34 4.26a9.981 9.981 0 00-5.32-2.21v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM18.33 16.9l1.43 1.42A9.949 9.949 0 0021.97 13h-2.02a7.941 7.941 0 01-1.62 3.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11.1C16 8.61 14.1 7 12 7s-4 1.61-4 4.1c0 1.66 1.33 3.63 4 5.9 2.67-2.27 4-4.24 4-5.9zm-4 .9a1.071 1.071 0 010-2.14A1.071 1.071 0 0112 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e708c62df83ba1fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11l-6-6v5H8c-2.76 0-5 2.24-5 5v4h2v-4c0-1.65 1.35-3 3-3h7v5l6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$54f1a038d274d494(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f23e0b1c3986c2b0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20V2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2f62f675ff0e6a86(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14h3v6H5v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9746c2b4e4fc0cd6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14h3v6H5v-6zm6-5h3v11h-3V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4b9f4b05d4e847be(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4h3v16h-3zM5 14h3v6H5zm6-5h3v11h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dab1a5b8d82a32(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zm-2-2v2H2L22 2v6h-2V6.83L6.83 20H18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3907b5548b83d5c8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$add07a3c502db24c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M-618-2872H782V728H-618zM-1 0h26v24H-1zm1 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M.01 0h24v24h-24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7eaa175f565f8287(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13h-9v9H2L22 2v11zm-1 2.41L19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$14769df3973d485a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$79f0378095a58084(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c4cc21dbdda8ea52(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c3.33 0 6.49 1.08 9.08 3.07L12 18.17l-9.08-9.1C5.51 7.08 8.67 6 12 6m0-2C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$58d0bd41637935bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.98 11L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36L12 21l3.05-3.05V15c0-.45.09-.88.23-1.29.54-1.57 2.01-2.71 3.77-2.71h2.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8177fd6c3c11aa80(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$930bf2381838c8f6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21v-9h8.99L24 8.98zM19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41 19.59 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$31b746e3335b0c08(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21v-9h8.99L24 8.98zM19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41 19.59 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e95f367ee531c125(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c784c599d7cc1f2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3aec7d023434c608(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21l5-5.01V8h5.92C19.97 5.51 16.16 4 12 4zM19 18h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6fadf3fc7e26f1d4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zM2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07L12 18.17l-9.08-9.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4dcd75eed0f7c015(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 15l-4-4h3V9.02L13 9v4h3l-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3b0f618a70ff9c8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4v5H6V4h12m0-2H6c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 13v5H6v-5h12m0-2H6c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a8a002308a1687f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6H9V4h2v2zm4-2h-2v2h2V4zM9 14h2v-2H9v2zm10-4V8h-2v2h2zm0 4v-2h-2v2h2zm-6 0h2v-2h-2v2zm6-10h-2v2h2V4zm-6 4V6h-2v2h2zm-6 2V8h2V6H7V4H5v16h2v-8h2v-2H7zm8 2h2v-2h-2v2zm-4-2v2h2v-2h-2zM9 8v2h2V8H9zm4 2h2V8h-2v2zm2-4v2h2V6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$37e98cd52e3b92d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5.47L12 12 7.62 7.62 3 11V8.52L7.83 5l4.38 4.38L21 3v2.47zM21 15h-4.7l-4.17 3.34L6 12.41l-3 2.13V17l2.8-2 6.2 6 5-4h4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16d90236cbc572bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc9e104e97d91be5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.93 8C16.72 4.18 11.82 2.87 8 5.07c-1.41.82-2.48 2-3.16 3.37-.13-2.2.22-4.4 1.02-6.44H3.74C2.2 6.49 2.52 11.58 5.07 16a7.96 7.96 0 004.86 3.72c1.98.53 4.16.31 6.07-.79 1.41-.82 2.48-2 3.16-3.37.13 2.2-.21 4.4-1.01 6.44h2.11c1.53-4.49 1.22-9.58-1.33-14zM15 17.2A6.012 6.012 0 016.8 15c-.11-.2-.21-.4-.3-.6-1.2-2.76-.17-6.06 2.5-7.6 2.86-1.65 6.54-.67 8.2 2.2.11.2.21.4.3.6 1.2 2.76.17 6.06-2.5 7.6zM12 10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a7a0742a22737c51(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V9l-6-6zM8 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 1V4.5l5.5 5.5H14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5bd457cef155e62b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 17H7V6h10v12zm-1-7.95l-1.41-1.41-3.54 3.54-1.41-1.41-1.41 1.41L11.05 15 16 10.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$829997a93efaf233(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zM11 7h2v6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 17H7V6h10v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5cd5c44b20245ab1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2zm12 15H7V6h10v12zm-1-6h-3V8h-2v4H8l4 4 4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f1eeefb6b113cc74(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-3.06 16L7.4 14.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L10.94 18zM13 9V3.5L18.5 9H13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b73b6864eabcd5b1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-2V5c0-.55.45-1 1-1s1 .45 1 1v1h-1v1h1v2h-1v1h1v1h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$785b63c7ce9c4661(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8v8h-3V8h3m0-3h-3C8.34 5 7 6.34 7 8v8c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3zM1 8h2v11h3V5H1v3zm17.5 3c-.83 0-1.5.68-1.5 1.5v2c0 .82.67 1.5 1.5 1.5H21v1h-4v2h4.5c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H19v-1h4v-2h-4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$72b59937189c0683(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11v2h-4v1h2.5c.83 0 1.5.68 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5H15v-2h4v-1h-2.5c-.82 0-1.5-.68-1.5-1.5v-2c0-.82.68-1.5 1.5-1.5H21zM4 5v3h6v2.5H4v3h6V16H4v3h6c1.66 0 3-1.34 3-3v-1.9a2.1 2.1 0 00-2.1-2.1A2.1 2.1 0 0013 9.9V8c0-1.66-1.34-3-3-3H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$95dc3c046903e259(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19h2v3h-2zM2 11h3v2H2zM19 11h3v2h-3zM15.894 17.801l1.407-1.407 2.122 2.122-1.408 1.407zM4.584 18.509l2.121-2.122 1.408 1.407-2.122 2.122zM15 8.02V3H9v5.02c-1.21.92-2 2.35-2 3.98 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.06-2-3.98zM11 5h2v2.1c-.32-.06-.66-.1-1-.1s-.68.04-1 .1V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b16952636f49286(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8h4v4h-1v2c0 .34-.08.66-.23.94L16 13.17V12h-1V8zm-4 .17l2 2V6h2l-3-4-3 4h2v2.17zM13 16v2.28c.6.34 1 .98 1 1.72 0 1.1-.9 2-2 2s-2-.9-2-2c0-.74.4-1.37 1-1.72V16H8c-1.11 0-2-.89-2-2v-2.28c-.6-.34-1-.98-1-1.72 0-.59.26-1.13.68-1.49L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-6.6-6.6H13zm-2-2v-.17l-2.51-2.51c-.14.16-.31.29-.49.4V14h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$649af88a6d17c18(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95a2.2 2.2 0 004.4 0c0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$95779bfedfc470d1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20c10068c232bf5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.98 14H22h-.02zM5.35 13c1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.31 1v-2c-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1zm13.32 2c-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.1 1-3.34 1-1.24 0-1.38-1-3.33-1-1.95 0-2.1 1-3.34 1v2c1.95 0 2.11-1 3.34-1 1.24 0 1.38 1 3.33 1 1.95 0 2.1-1 3.34-1 1.19 0 1.42 1 3.33 1 1.94 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1v-2c-1.24 0-1.38-1-3.33-1zM5.35 9c1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.31 1V8c-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1C3.38 7 3.24 8 2 8v2c1.9 0 2.17-1 3.35-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a2689d9e63abc8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e422bd1354879d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.53 17.46L12 21l-3.53-3.54c.9-.9 2.15-1.46 3.53-1.46s2.63.56 3.53 1.46z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e7f7a054661241b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c3.03 0 5.78 1.23 7.76 3.22l-2.12 2.12A7.967 7.967 0 0012 13c-2.2 0-4.2.9-5.64 2.35l-2.12-2.12C6.22 11.23 8.97 10 12 10zm0 6c-1.38 0-2.63.56-3.53 1.46L12 21l3.53-3.54A4.98 4.98 0 0012 16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e91321197de84e4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 3c-2.21 0-4.21.9-5.66 2.34l1.06 1.06a6.47 6.47 0 019.18 0l1.06-1.06A7.932 7.932 0 0016.49 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.03 7.46a5.022 5.022 0 00-7.08 0l1.06 1.06c.63-.63 1.51-1.03 2.47-1.03s1.84.39 2.47 1.03l1.08-1.06zM15.08 9.59L16.49 11l1.41-1.41c-.36-.37-.86-.59-1.41-.59s-1.05.22-1.41.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.63 14.4l-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.56.03 1.03-.44 1.03-1v-4.15c0-.48-.34-.89-.8-.98l-3.67-.73a.985.985 0 00-.9.26z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b31536a4d303c988(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3c-2.51 0-3.77 5.61-4.4 10.57C10.79 10.66 9.61 8 8 8 4.43 8 3 21 3 21h2.01c.61-5.27 2-9.82 2.99-10.87.98 1.05 2.38 5.61 2.99 10.87H13c.5-2.53 2-6 3-6s2.5 3.53 3 6h2s-.5-18-5-18zm0 10c-.99 0-1.82.62-2.5 1.5.57-4.77 1.54-8.62 2.5-9.44.97.81 1.91 4.67 2.49 9.43C17.81 13.62 16.98 13 16 13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fd0a7b1ce2d0c5a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14c0-3.36 2.64-6 6-6 2.2 0 4.08 1.13 5.13 2.86L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21l1.86-1.87C12.14 18.09 11 16.2 11 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14c0-2.24-1.76-4-4-4s-4 1.76-4 4 1.76 4 4 4c.75 0 1.44-.21 2.03-.56L21.59 20 23 18.59l-2.56-2.56c.35-.59.56-1.28.56-2.03zm-6 0c0-1.12.88-2 2-2s2 .88 2 2-.88 2-2 2-2-.88-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df16dc41baba6fa7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.98 11L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36L12 21l3.05-3.05V15c0-.45.09-.88.23-1.29.54-1.57 2.01-2.71 3.77-2.71h2.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d3bba38660460d2f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 19v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1zm2-10.02l-2.12 2.13C19.35 8.57 15.85 7 12 7s-7.35 1.57-9.88 4.11L0 8.98C3.07 5.9 7.31 4 12 4s8.93 1.9 12 4.98zM12 10c3.03 0 5.78 1.23 7.76 3.22l-2.12 2.12A7.967 7.967 0 0012 13c-2.2 0-4.2.9-5.64 2.35l-2.12-2.12C6.22 11.23 8.97 10 12 10zm3.53 7.46L12 21l-3.53-3.54c.9-.9 2.15-1.46 3.53-1.46s2.63.56 3.53 1.46z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1c9e4829bb629a5f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-3.31 0-6 2.69-6 6 0 1.66.68 3.15 1.76 4.24l1.42-1.42A3.934 3.934 0 018 13c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.11-.45 2.1-1.18 2.82l1.42 1.42A6.003 6.003 0 0018 13c0-3.31-2.69-6-6-6zm0-4C6.48 3 2 7.48 2 13c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42A7.94 7.94 0 014 13c0-4.42 3.58-8 8-8 2.53 0 4.78 1.17 6.24 3h2.42C18.93 5.01 15.7 3 12 3zm0 8c-1.1 0-2 .9-2 2 0 .55.23 1.05.59 1.41.36.36.86.59 1.41.59s1.05-.23 1.41-.59c.36-.36.59-.86.59-1.41 0-1.1-.9-2-2-2zm8-1h2v6h-2v-6zm0 8h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df974c616a9d1dbd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-3.31 0-6 2.69-6 6 0 1.66.68 3.15 1.76 4.24l1.42-1.42A3.934 3.934 0 018 13c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.11-.45 2.1-1.18 2.82l1.42 1.42A6.003 6.003 0 0018 13c0-3.31-2.69-6-6-6zm0-4C6.48 3 2 7.48 2 13c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42A7.94 7.94 0 014 13c0-4.42 3.58-8 8-8 2.53 0 4.78 1.17 6.24 3h2.42C18.93 5.01 15.7 3 12 3zm0 8c-1.1 0-2 .9-2 2 0 .55.23 1.05.59 1.41.36.36.86.59 1.41.59s1.05-.23 1.41-.59c.36-.36.59-.86.59-1.41 0-1.1-.9-2-2-2zm8-1h2v6h-2v-6zm0 8h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3b746792fe10ed76(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l2.69 2.69A9.958 9.958 0 002 13c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42a7.957 7.957 0 01-.84-10.31l1.43 1.43a6.003 6.003 0 00.82 7.47l1.42-1.42A3.934 3.934 0 018 13c0-.63.15-1.23.41-1.76l1.61 1.61c0 .05-.02.1-.02.15 0 .55.23 1.05.59 1.41.36.36.86.59 1.41.59.05 0 .1-.01.16-.02l7.62 7.62 1.41-1.41L2.81 2.81zM17.7 14.87c.19-.59.3-1.22.3-1.87 0-3.31-2.69-6-6-6-.65 0-1.28.1-1.87.3l1.71 1.71C11.89 9 11.95 9 12 9c2.21 0 4 1.79 4 4 0 .05 0 .11-.01.16l1.71 1.71zM12 5c4.42 0 8 3.58 8 8 0 1.22-.27 2.37-.77 3.4l1.49 1.49A9.953 9.953 0 0022 13c0-5.52-4.48-10-10-10-1.78 0-3.44.46-4.89 1.28l1.48 1.48C9.63 5.27 10.78 5 12 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3773b46614a270e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e593583be12ee934(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9.99h2v7H6zm8 3h2v4h-2zm-4-6h2v10h-2zM20 7V4h-2v3h-3v2h3v3h2V9h3V7zm-2 12H4V5h12V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5h-2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$96b4779397ab4073(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM17 11h-4v4h-2v-4H7V9h4V5h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffa9d2162d3f2b50(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h2v5h8v3h-8v4h5v3h-5v5h-2v-5H6v-3h5v-4H3V7h8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2de0e218ddeedb8b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22H2V2h2v20zM22 7H6v3h16V7zm-6 7H6v3h10v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a454ad558221de01(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h2v20h-2V2zM2 10h16V7H2v3zm6 7h10v-3H8v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$260115c16af9d807(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22H2v-2h20v2zM10 2H7v16h3V2zm7 6h-3v10h3V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9f441ca0c9bc8d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11h-5V6h-3v5h-4V3H7v8H1.84v2H7v8h3v-8h4v5h3v-5h5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5853be68b4975e4e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2v2H2V2h20zM7 22h3V6H7v16zm7-6h3V6h-3v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9b511204d716dd94(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13v7h18v-1.5l-9-7L8 17l-5-4zm0-6l4 3 5-7 5 4h4v8.97l-9.4-7.31-3.98 5.48L3 10.44V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e2dd149effd7a403(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 015 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 005 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f4f95c7247918b54(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cc45a54fb85e96e0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.06 9.94L12 9l2.06-.94L15 6l.94 2.06L18 9l-2.06.94L15 12l-.94-2.06zM4 14l.94-2.06L7 11l-2.06-.94L4 8l-.94 2.06L1 11l2.06.94L4 14zm4.5-5l1.09-2.41L12 5.5 9.59 4.41 8.5 2 7.41 4.41 5 5.5l2.41 1.09L8.5 9zm-4 11.5l6-6.01 4 4L23 8.93l-1.41-1.41-7.09 7.97-4-4L3 19l1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$107bda334a51e92b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d16d735f7e426ced(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bfc2bed4a847b2a7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8672f7bc0c28b8fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85a7e1461bcc3a4c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 24H2v-4h20v4zM13.06 5.19l3.75 3.75L7.75 18H4v-3.75l9.06-9.06zm4.82 2.68l-3.75-3.75 1.83-1.83a.996.996 0 011.41 0l2.34 2.34c.39.39.39 1.02 0 1.41l-1.83 1.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$198ab6c2e8a21e1b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f7024f9eb3e2fd2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dce88f90983475f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f9aebc4cfcd0f5c4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c517b1b9374116e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$224111ccf1ac5ff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$74083fee55f39e2d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$38568374f33f74c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a1db3ba8c96c75dd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.2",
                    "cy": "14.4",
                    "r": "3.2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.8",
                    "cy": "18",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.2",
                    "cy": "8.8",
                    "r": "4.8"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84e6a6a4f5e197bf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4H7v2H5v12h2v2h2v-2h2V6H9zM19 8h-2V4h-2v4h-2v7h2v5h2v-5h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$90c22d4c248b504c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H2v2h9V7zm0 8H2v2h9v-2zm5.34-4L12.8 7.46l1.41-1.41 2.12 2.12 4.24-4.24L22 5.34 16.34 11zm0 8l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L22 13.34 16.34 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$87e80863cdb0932b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7h-9v2h9V7zm0 8h-9v2h9v-2zM5.54 11L2 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 11zm0 8L2 15.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$978fed2184034e77(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4v2h3v12h-3v2h5V4zM4 20h5v-2H6V6h3V4H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$75c6f67d3b9b0066(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7v2c0 .55-.45 1-1 1H2v4h1c.55 0 1 .45 1 1v2c0 1.65 1.35 3 3 3h3v-2H7c-.55 0-1-.45-1-1v-2c0-1.3-.84-2.42-2-2.83v-.34C5.16 11.42 6 10.3 6 9V7c0-.55.45-1 1-1h3V4H7C5.35 4 4 5.35 4 7zM21 10c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3h-3v2h3c.55 0 1 .45 1 1v2c0 1.3.84 2.42 2 2.83v.34c-1.16.41-2 1.52-2 2.83v2c0 .55-.45 1-1 1h-3v2h3c1.65 0 3-1.35 3-3v-2c0-.55.45-1 1-1h1v-4h-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ccdeaf48b95de6a5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dbf89f4af527887b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.85 10.39l1.06-1.06c.78-.78.78-2.05 0-2.83L18.5 5.09c-.78-.78-2.05-.78-2.83 0l-1.06 1.06 4.24 4.24zm-5.66-2.83L4 16.76V21h4.24l9.19-9.19-4.24-4.25zM19 17.5c0 2.19-2.54 3.5-5 3.5-.55 0-1-.45-1-1s.45-1 1-1c1.54 0 3-.73 3-1.5 0-.47-.48-.87-1.23-1.2l1.48-1.48c1.07.63 1.75 1.47 1.75 2.68zM4.58 13.35C3.61 12.79 3 12.06 3 11c0-1.8 1.89-2.63 3.56-3.36C7.59 7.18 9 6.56 9 6c0-.41-.78-1-2-1-1.26 0-1.8.61-1.83.64-.35.41-.98.46-1.4.12a.992.992 0 01-.15-1.38C3.73 4.24 4.76 3 7 3s4 1.32 4 3c0 1.87-1.93 2.72-3.64 3.47C6.42 9.88 5 10.5 5 11c0 .31.43.6 1.07.86l-1.49 1.49z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2f3e5102a52ddb0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h11v2H3v-2zm0-2h11V6H3v2zm0 8h7v-2H3v2zm15.01-3.13l.71-.71a.996.996 0 011.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.71-2.12-2.12zm-.71.71l-5.3 5.3V21h2.12l5.3-5.3-2.12-2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f37f655379f10597(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4445f4a6acac4c7e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9e1fdca06ca0c1d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$83a83515ecccc5ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$289d641a8d61d0fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$849e95b7c84077a2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$14834ff96da87323(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 000 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5zM2 20h20v4H2v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d881c04d9713c672(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4140aa0aab39089(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v4H2v-4zm3.49-3h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5L5.49 17zm4.42-5.61l2.03-5.79h.12l2.03 5.79H9.91z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f93acbebcaf2830b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f654b40aa6fd621b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$70caf8f7c4d7b731(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5b1fa4a9f45f86a9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d7692d371a86714e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm3 5.5h-2.5V21h-1v-2.5H15v-1h2.5V15h1v2.5H21v1zM7 5h13v2H7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3.5",
                    "cy": "18",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11H7v2h6.11c1.26-1.24 2.99-2 4.89-2zM7 17v2h4.08c-.05-.33-.08-.66-.08-1s.03-.67.08-1H7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3.5",
                    "cy": "6",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3.5",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3914b381a5052095(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ca83413908c0596(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17h2v.5h-1v1h1v.5h-2v1h3v-4h-3zm1-9h1V4h-2v1h1zm-1 3h1.8L18 13.1v.9h3v-1h-1.8l1.8-2.1V10h-3zM2 5h14v2H2zm0 12h14v2H2zm0-6h14v2H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e76d713d7c488dd6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84cf76eb2d22035(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2dbfe9542b3b35ca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$606326d006723bd8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a3937425d9edb16c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6aa43f3a62ccea2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2bb27b4c4fb4f3ea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bdc0009165e38b16(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c02fb1854ab2fda5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c05abac9fb7f2a4d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fcf0720c1f6ee0b5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$82da298902ca5df7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 3H6.8l-5.2 9 5.2 9h10.4l5.2-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f9e3bfecd1b98d0b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14l3 3v5h6v-5l3-3V9H6v5zm5-12h2v3h-2V2zM3.5 5.88l1.41-1.41 2.12 2.12L5.62 8 3.5 5.88zm13.46.71l2.12-2.12 1.41 1.41L18.38 8l-1.42-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$61562cca2828e46f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22H2V2h2v20zM22 2h-2v20h2V2zm-8.5 5h-3v10h3V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d276e2e434b79b57(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 11h16v2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$43c8ebdb030cb1e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$66b90b98e2785859(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1309b485a31514e4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cec9283c252a891a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa7cbc2d594443dc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$29a99bc6eee6574d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a8fda15d0952d36d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da888b0b07721b48(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2v-3H4v3zM20 8l-6-6H6c-1.1 0-1.99.9-1.99 2v7H20V8zm-7 1V3.5L18.5 9H13zM9 13h6v2H9zM17 13h6v2h-6zM1 13h6v2H1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb8fda9957d1349e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e14104de6a91e5ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.43l-1.41-1.41-4.03 4.53L9.5 4 2 11.51l1.5 1.5 6.14-6.15 5.59 5.18-1.73 1.95-4-4L2 17.5 3.5 19l6-6.01 4 4 3.19-3.59 3.9 3.61L22 15.6l-3.98-3.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$707745c2c35f4cb4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5a2.5 2.5 0 000 5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5a2.5 2.5 0 000-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a4022f1df8af380(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm16 16H5V5h14v14zM11 7h2v2h-2zM7 7h2v2H7zm8 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cbb427e9393c7e10(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$13ec901b7463d55c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ce90b660f35728db(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8ab2f6592ae7b2b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c635d294c43930f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d479e04e8ab47e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9c0b421081cb64e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.53 7.43c.42-.31.93-.47 1.54-.47s1.11.16 1.5.49c.39.32.65.7.79 1.12l1.89-.8c-.24-.71-.71-1.35-1.4-1.92-.5-.4-1.12-.65-1.85-.77V3h-2v2.11c-.41.08-.79.21-1.14.39-.35.18-.64.39-.9.63l1.43 1.43c.04-.04.09-.09.14-.13zM2.81 2.81L1.39 4.22l12.35 12.35c-.43.28-.95.43-1.55.43-.71 0-1.32-.23-1.83-.7-.5-.47-.86-1.07-1.06-1.81l-1.98.8c.34 1.17.95 2.08 1.83 2.73.57.42 1.19.68 1.85.83V21h2v-2.08c.44-.07.87-.17 1.29-.35.34-.14.64-.32.92-.53l4.57 4.57 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6e30a348393bc5f3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$34afee001b54792b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11c0 2.45 1.76 4.47 4.08 4.91l-1.49-1.49L7 13l4 4.01L7 21l-1.41-1.41 1.58-1.58v-.06A7.007 7.007 0 011 11c0-3.87 3.13-7 7-7h3v2H8c-2.76 0-5 2.24-5 5zM22 11V4h-9v7h9zm-2-2h-5V6h5v3zM13 13h9v7h-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8d4d2f4f4a0c2d9b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13c0-2.45 1.76-4.47 4.08-4.91l-1.49 1.5L7 11l4-4.01L7 3 5.59 4.41l1.58 1.58v.06A7.007 7.007 0 001 13c0 3.87 3.13 7 7 7h3v-2H8c-2.76 0-5-2.24-5-5zM13 13v7h9v-7h-9zm7 5h-5v-3h5v3zM13 4h9v7h-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f1c4a5561f2787be(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$31397eaf248e5ab8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h12v-2H3v2zM3 6v2h18V6H3zm0 7h18v-2H3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3557c9114e968283(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 10l.5-2h-4l1-4h-2l-1 4h-4l1-4h-2L9 8H5l-.5 2h4l-1 4h-4L3 16h4l-1 4h2l1-4h4l-1 4h2l1-4h4l.5-2h-4l1-4h4zm-7 4h-4l1-4h4l-1 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$93a0afad59c095c8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm16 16H5V5h14v14zM11 7h2v2h-2zM7 7h2v2H7zm8 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa38338264da5252(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9l4 12h12l4-12-10-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3219b77ac6b2f8d4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93A8.002 8.002 0 0113 19.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8235f1df64cef2ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93A8.002 8.002 0 0113 19.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$41a00d6c7a1e066a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b032588857bffc39(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16v1.26l-6-3v-3.17L11.7 8H16V2h-6v4.9L7.3 10H3v6h5l7 3.5V22h6v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa30ff2021efe3f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zM7 12v2h8v-2h-3zM7 15h8v2H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$331111cc112a9785(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c01dc6f82614ce1e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.88 18.47c.44-.7.7-1.51.7-2.39 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21.58 23 23 21.58l-3.12-3.11zm-3.8.11a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm-.36-8.5c-.74.02-1.45.18-2.1.45l-.55-.83-3.8 6.18-3.01-3.52-3.63 5.81L1 17l5-8 3 3.5L13 6l2.72 4.08zm2.59.5c-.64-.28-1.33-.45-2.05-.49L21.38 2 23 3.18l-4.69 7.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6edcbbecc00ac571(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4h20v16H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b2ce53b60991d6c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "14",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.6",
                    "cy": "17.6",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a42ddc42669a22c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9v2h-3V9H8.5V7H11V1H4v6h2.5v2H4v6h2.5v2H4v6h7v-6H8.5v-2H11v-2h3v2h7V9h-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$66add714e1b307ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 2h1.5v3l2-3h1.7l-2 3 2 3h-1.7l-2-3v3H12V5zM7 7.25h2.5V6.5H7V5h4v3.75H8.5v.75H11V11H7V7.25zM19 13l-6 6-4-4-4 4v-2.5l4-4 4 4 6-6V13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e73ef2131659ef84(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11c2.76 0 5-2.24 5-5S8.76 1 6 1 1 3.24 1 6s2.24 5 5 5zM21 14h-5c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.71 7.7c.4.19.83.3 1.29.3 1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3c0 .46.11.89.3 1.29L6.29 16.3c-.4-.19-.83-.3-1.29-.3-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3c0-.46-.11-.89-.3-1.29L17.71 7.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6279ba0ef02d052a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h16v2H4V9zm0 4h10v2H4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1eeca07e2d6a5a8d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56394f3d181591cf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9v4H6V9H4v6h16V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$39905ecc17aea3a5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v18H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$214f068a4e2a2959(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19.99l7.5-7.51 4 4 7.09-7.97L22 9.92l-8.5 9.56-4-4-6 6.01-1.5-1.5zm1.5-4.5l6-6.01 4 4L22 3.92l-1.41-1.41-7.09 7.97-4-4L2 13.99l1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab7c84c9d7b1d916(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.85 7.08C6.85 4.37 9.45 3 12.24 3c1.64 0 3 .49 3.9 1.28.77.65 1.46 1.73 1.46 3.24h-3.01c0-.31-.05-.59-.15-.85-.29-.86-1.2-1.28-2.25-1.28-1.86 0-2.34 1.02-2.34 1.7 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.21-.34-.54-.89-.54-1.92zM21 12v-2H3v2h9.62c1.15.45 1.96.75 1.96 1.97 0 1-.81 1.67-2.28 1.67-1.54 0-2.93-.54-2.93-2.51H6.4c0 .55.08 1.13.24 1.58.81 2.29 3.29 3.3 5.67 3.3 2.27 0 5.3-.89 5.3-4.05 0-.3-.01-1.16-.48-1.94H21V12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2baefb659456cb21(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18h-2v1h3v1h-4v-2c0-.55.45-1 1-1h2v-1h-3v-1h3c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM5.88 18h2.66l3.4-5.42h.12l3.4 5.42h2.66l-4.65-7.27L17.81 4h-2.68l-3.07 4.99h-.12L8.85 4H6.19l4.32 6.73L5.88 18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3a60ddf1c7c0e477(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7h-2v1h3v1h-4V7c0-.55.45-1 1-1h2V5h-3V4h3c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM5.88 20h2.66l3.4-5.42h.12l3.4 5.42h2.66l-4.65-7.27L17.81 6h-2.68l-3.07 4.99h-.12L8.85 6H6.19l4.32 6.73L5.88 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aebbd3f0378ef7fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.02h5V21h-5zM17 21h3c1.1 0 2-.9 2-2v-9h-5v11zm3-18H5c-1.1 0-2 .9-2 2v3h19V5c0-1.1-.9-2-2-2zM3 19c0 1.1.9 2 2 2h3V10H3v9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f557242bfeb76912(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8H3V4h18v4zm0 2H3v4h18v-4zm0 6H3v4h18v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$838fcf517c37d110(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.99 19h2.42l1.27-3.58h5.65L11.59 19h2.42L8.75 5h-2.5L.99 19zm4.42-5.61L7.44 7.6h.12l2.03 5.79H5.41zM23 11v2h-8v-2h8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$624c1e7decbc705b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e5ea2a0eee699f80(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.99 19h2.42l1.27-3.58h5.65L11.59 19h2.42L8.75 5h-2.5L.99 19zm4.42-5.61L7.44 7.6h.12l2.03 5.79H5.41zM20 11h3v2h-3v3h-2v-3h-3v-2h3V8h2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$30d10c9962056c70(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4v3h5.5v12h3V7H19V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a7eb856492a18f4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3.37 12.5l-.8-2.3H12.2l-.82 2.3H9.81l3.38-9h1.61l3.38 9h-1.55z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.96 7.17l-1.31 3.72h2.69l-1.3-3.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85c3b1f988aa3307(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de22409598430f3b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2b0ba2c98515be47(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c28afcf07137ff2a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2v2H2V2h20zM7 10.5v3h10v-3H7zM2 20v2h20v-2H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a990b67b2f7a7c1a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f6792a8f2bf8adac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16v6h16v-6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2zm14 2H6v-2h12v2zM12 2C9.24 2 7 4.24 7 7l5 7 5-7c0-2.76-2.24-5-5-5zm0 9L9 7c0-1.66 1.34-3 3-3s3 1.34 3 3l-3 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3cfac08ad5c124f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10V4c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2L1 16c0 1.1.9 2 2 2h11v-5c0-1.66 1.34-3 3-3h4zm-10 1L3 6V4l8 5 8-5v2l-8 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14v4c0 1.1-.9 2-2 2s-2-.9-2-2v-4.5c0-.28.22-.5.5-.5s.5.22.5.5V18h2v-4.5a2.5 2.5 0 00-5 0V18c0 2.21 1.79 4 4 4s4-1.79 4-4v-4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3687b4a25c7cd8ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5a2.5 2.5 0 010-5H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$92c0931162003725(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01A3.98 3.98 0 0112 7c2.21 0 4 1.79 4 4h.5a2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6f5a09ff76f0f9a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91110c90d9d5c82a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2432b75fd86b4921(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46a5.497 5.497 0 018.05 4.87v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3594bab6df3a29cb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4015cf37684ac89f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.5 14.98c-.02 0-.03 0-.05.01A3.49 3.49 0 0018 12c-1.4 0-2.6.83-3.16 2.02A2.988 2.988 0 0012 17c0 1.66 1.34 3 3 3l6.5-.02a2.5 2.5 0 000-5zM10 4.26v2.09C7.67 7.18 6 9.39 6 12c0 1.77.78 3.34 2 4.44V14h2v6H4v-2h2.73A7.942 7.942 0 014 12c0-3.73 2.55-6.85 6-7.74zM20 6h-2.73a7.98 7.98 0 012.66 5h-2.02c-.23-1.36-.93-2.55-1.91-3.44V10h-2V4h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5dcbe356d077741f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$894ef6e17611ac84(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$589823441de4a2a7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f039a251d29c98dd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 23H4c-1.1 0-2-.9-2-2V7h2v14h14v2zM15 1H8c-1.1 0-1.99.9-1.99 2L6 17c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V7l-6-6zm1.5 14h-6v-2h6v2zm0-6h-2v2h-2V9h-2V7h2V5h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$74f4c49d795082b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.13 5.41L18.72 4l-9.19 9.19-4.25-4.24-1.41 1.41 5.66 5.66zM5 18h14v2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9e6728e0aab79dcb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm-1 8V6h2v4h3l-4 4-4-4h3zm6 7H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9efed4d4df62077(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2cc3d85bc733c240(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.32 4.26A9.949 9.949 0 0013 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1a7.941 7.941 0 011.62 3.9zm-1.62 5.9l1.43 1.43a9.981 9.981 0 002.21-5.32h-2.02a7.945 7.945 0 01-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zM13 12V7h-2v5H7l5 5 5-5h-4zm-2 7.93v2.02c-5.05-.5-9-4.76-9-9.95s3.95-9.45 9-9.95v2.02C7.05 4.56 4 7.92 4 12s3.05 7.44 7 7.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$668e633afc63755c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10zm-8.01-9l-1.41 1.41L12.16 12H8v2h4.16l-1.59 1.59L11.99 17 16 13.01 11.99 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$727e58902cdf2a1d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-8 11l-4-4 4-4v3h4v2h-4v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4a4805ab1a6fb444(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 12v-3h-4v-4h4V8l5 5-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eb8128073f6edee9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.41 5.8L17.2 4.59c-.78-.78-2.05-.78-2.83 0l-2.68 2.68L3 15.96V20h4.04l8.74-8.74 2.63-2.63c.79-.78.79-2.05 0-2.83zM6.21 18H5v-1.21l8.66-8.66 1.21 1.21L6.21 18zM11 20l4-4h6v4H11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$25f723f0c10cdba2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10zM8 13.01l1.41 1.41L11 12.84V17h2v-4.16l1.59 1.59L16 13.01 12.01 9 8 13.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$90f27e15c3ad3b37(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18h14v2H5v-2zm4.6-2.7L5 10.7l2-1.9 2.6 2.6L17 4l2 2-9.4 9.3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$267c363917c23e8c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6.17V3h6v6h4l-3.59 3.59L9 6.17zm12.19 15.02L2.81 2.81 1.39 4.22 6.17 9H5l7 7 .59-.59L15.17 18H5v2h12.17l2.61 2.61 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af94abf7b36e783f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bee2e851d766ec9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H15v-8h5V8l-6-6zm-1 7V3.5L18.5 9H13zm4 12.66V16h5.66v2h-2.24l2.95 2.95-1.41 1.41L19 19.41v2.24h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$342ce8fab7231669(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l4.7 4.69L5 10h2.17L9 11.83V16h4.17l2 2H5v2h12.17l2.61 2.61zM15 10h4l-7-7-3.09 3.09L15 12.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1c993b48a7a6d524(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9b28c5690955fa21(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6H1v13c0 1.1.9 2 2 2h17v-2H3V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4h-7l-2-2H7c-1.1 0-1.99.9-1.99 2L5 15c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e0975c5ee0064a32(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2h6l2 2h8c1.1 0 2 .9 2 2zm-5.5 2V9h-2v1H12v1.5h1v4c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-4h1V10h-2.5zm0 5.5h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ea948b02fdc01c2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H6.83l14.93 14.93c.15-.28.24-.59.24-.93V8c0-1.1-.9-2-2-2zM2.1 2.1L.69 3.51l1.56 1.56c-.15.28-.24.59-.24.93L2 18c0 1.1.9 2 2 2h13.17l3.31 3.31 1.41-1.41L2.1 2.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$628287b844aa4b8c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d02800304bf0d9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ff6019d163faa80b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2 6h-2v2h2v2h-2v2h-2v-2h2v-2h-2v-2h2v-2h-2V8h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7580638db279d56b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f31faef38f1c7985(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3v2H5V3h14zm-7 4c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm0 11.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 9.5 12 9.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9f0760bfa0a5df8f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "fill": "none",
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M3 3v8h8V3H3zm6 6H5V5h4v4zm-6 4v8h8v-8H3zm6 6H5v-4h4v4zm4-16v8h8V3h-8zm6 6h-4V5h4v4zm-6 4v8h8v-8h-8zm6 6h-4v-4h4v4z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b32a266171e11b7c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3l-1.67 1.67L18.67 3 17 4.67 15.33 3l-1.66 1.67L12 3l-1.67 1.67L8.67 3 7 4.67 5.33 3 3.67 4.67 2 3v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V3zM11 19H4v-6h7v6zm9 0h-7v-2h7v2zm0-4h-7v-2h7v2zm0-4H4V8h16v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3738b376667f7f15(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm1 10h-4v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1h-2v-1H9v-2h4v-1h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1V9h2v1h2v2zm-2-4V3.5L17.5 8H13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d864c68caf45b1e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM7.83 16L5 13.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41L7.83 16zm9.58-3L19 14.59 17.59 16 16 14.41 14.41 16 13 14.59 14.59 13 13 11.41 14.41 10 16 11.59 17.59 10 19 11.41 17.41 13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$53766087e77ae103(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.88 10.5l1.62 1.62v3.38h-3v-5h1.38zM22 8v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2h6l2 2h8c1.1 0 2 .9 2 2zm-3 3.5L16.5 9H13v8h6v-5.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2839474753f8de8f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.41 8.41l-4.83-4.83c-.37-.37-.88-.58-1.41-.58H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9.83c0-.53-.21-1.04-.59-1.42zM7 7h7v2H7V7zm10 10H7v-2h10v2zm0-4H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1a9c79ad65c1dcb8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 10H6v-2h8v2zm4-4H6v-2h12v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f5704c2de71858f7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fdbfddfecad38d5e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20h14v-2H5v2zm0-10h4v6h6v-6h4l-7-7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d9797f45c5fcc0d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6-10C9.8 3 8 4.8 8 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6 10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19df112ebb02a28d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6-8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2C9.8 3 8 4.8 8 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6 12c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d3db962710ab69d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6-10C9.8 3 8 4.8 8 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6 10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a4244e761ff2fd0e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h-1V4H6v8H5c-1.66 0-3 1.34-3 3v5h20v-5c0-1.66-1.34-3-3-3zm-3 0H8V6h8v6zm2 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8efeecb964e20e1c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v10.5l1.95 1.95c.03-.15.05-.3.05-.45V6c0-1.1-.9-2-2-2H6.5l2 2H19zM3.22 3.32L1.95 4.59 3 5.64V18c0 1.1.9 2 2 2h12.36l2.06 2.06 1.27-1.27L3.22 3.32zM15 18H5V7.64L15.36 18H15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$78f95436cbd03080(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13v3c0 1.1-.9 2-2 2h-3l1 1v2H6v-2l1-1H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h8v2H4v11h16v-3h2zm-7 2l-5-5h4V3h2v7h4l-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$54b4040655ff912a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z",
                    "opacity": ".1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2a9 9 0 019 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$249f7d45562b20a0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2a9 9 0 019 9h2c0-6.08-4.93-11-11-11zm10 1.09v2L14.5 15l3.5-1.91v-2L14.5 13 11 11.09zM14.5 6L9 9l5.5 3L20 9l-5.5-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f3c41e7ff6aa75e9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z",
                    "opacity": ".1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2a9 9 0 019 9h2c0-6.08-4.93-11-11-11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$83343896170867c3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b17c78931dfc3933(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zM4 14v2h2c0-1.11-.89-2-2-2zm0-3v1.43c1.97 0 3.57 1.6 3.57 3.57H9c0-2.76-2.24-5-5-5zm0-3v1.45c3.61 0 6.55 2.93 6.55 6.55H12c0-4.42-3.59-8-8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3c8d54ae54bbce2f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15H5c-1.66 0-3 1.34-3 3s1.34 3 3 3h14c1.66 0 3-1.34 3-3s-1.34-3-3-3zm0 4H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1zM9 4v8c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1h-8c-.55 0-1 .45-1 1zm7 4h-4V6.02h4V8zM2 9.02h4.94v1.91H2V9.02zm2.01-3h2.93v1.96H4.01V6.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$49fd654567a1c3aa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h6l-2 2v1h8v-1l-2-2h6c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20a6ae79ff92fd12(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6v2H8v2h8v-2h-2v-2h6c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cb7ba93cda6eb74c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.83 5H18v10.17L19.83 17H22v-2h-2v-2h2v-2h-2V9h2V7h-2V5c0-1.1-.9-2-2-2H5.83l2 2zM12 9.17V7h4v3h-3.17L12 9.17zM9.83 7H11v1.17L9.83 7zm4 4H16v2.17L13.83 11zM18 21c.06 0 .11 0 .16-.01l2.32 2.32 1.41-1.41L2.1 2.1.69 3.51l1.32 1.32C2 4.89 2 4.94 2 5v14c0 1.1.9 2 2 2h14zM4 19V6.83l2 2V12h3.17l1 1H6v4h5v-3.17l1 1V17h2.17l2 2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7452e3a80628ad84(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2d3bbb453433383e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$426a103697d10982(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zM12 6.72c-1.96 0-3.5 1.52-3.5 3.47h1.75c0-.93.82-1.75 1.75-1.75s1.75.82 1.75 1.75c0 1.75-2.63 1.57-2.63 4.45h1.76c0-1.96 2.62-2.19 2.62-4.45 0-1.96-1.54-3.47-3.5-3.47zm-.88 8.8h1.76v1.76h-1.76z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$24890144f4733b81(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6cc241371ad4f3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5405b711051a4fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-1V6h-2v1h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zM10.62 6C8.76 6 7.25 7.51 7.25 9.38v5.25c0 1.04-.84 1.88-1.88 1.88s-1.87-.85-1.87-1.89v-4.7c.16.05.33.08.5.08 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2v6.62C2 16.49 3.51 18 5.38 18s3.38-1.51 3.38-3.38V9.38c0-1.04.84-1.88 1.88-1.88s1.88.84 1.88 1.88v4.7c-.18-.05-.35-.08-.52-.08-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2V9.38C14 7.51 12.49 6 10.62 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$93a2bfa7060d3b8c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.2 3.01C4.44 2.89 3 4.42 3 6.19V16c0 2.76 2.24 5 5 5s5-2.24 5-5V8c0-1.66 1.34-3 3-3s3 1.34 3 3v7h-.83c-1.61 0-3.06 1.18-3.17 2.79A3 3 0 0017.8 21c1.76.12 3.2-1.42 3.2-3.18V8c0-2.76-2.24-5-5-5s-5 2.24-5 5v8c0 1.66-1.34 3-3 3s-3-1.34-3-3V9h.83C7.44 9 8.89 7.82 9 6.21c.11-1.68-1.17-3.1-2.8-3.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$45cd892a63088e35(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 17v2h-5V3h2v14h3zm-6.27-1.85c.17.42.27.87.27 1.35 0 1.93-1.57 3.5-3.5 3.5-1.4 0-2.6-.82-3.16-2H6.83A2.99 2.99 0 014 20c-1.66 0-3-1.34-3-3 0-.89.39-1.69 1-2.24V10h2V4h8l4.73 11.15zM5 17c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zm8.65-4l-2.97-7H6v4l2.92 3h4.73zM15 16.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5.67 1.5 1.5 1.5 1.5-.67 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b4c3162c88a7c3a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 6.5l-1.91 1.91c-.38.38-.59.89-.59 1.42V11h-1V7c0-1.66-1.34-3-3-3H8v5H3c-1.1 0-2 .9-2 2v5.85c0 1.58 1.16 3.01 2.74 3.14a2.99 2.99 0 003.07-1.98l4.37-.01a2.979 2.979 0 003.41 1.94 3.013 3.013 0 002.35-2.39c.2-1.11-.22-2.11-.95-2.77V13h1c0 1.1.9 2 2 2h5L19.5 6.5zM4 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6-12h3c.55 0 1 .45 1 1v4h-4V6zm4 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1f5914debff9d84b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$185bbeb8e3cf823(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-1V6h-2v1h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zM8 6c-3.31 0-6 2.69-6 6v4c0 1.1.9 2 2 2h2v-5H3.5v-1c0-2.48 2.02-4.5 4.5-4.5s4.5 2.02 4.5 4.5v1H10v5h2c1.1 0 2-.9 2-2v-4c0-3.31-2.69-6-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7e2dcff43b0626cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3a9 9 0 00-9 9v7c0 1.1.9 2 2 2h4v-8H5v-1c0-3.87 3.13-7 7-7s7 3.13 7 7v1h-4v8h4c1.1 0 2-.9 2-2v-7a9 9 0 00-9-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e7e3fb0c626ffa0b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z",
                    "opacity": ".1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a9 9 0 00-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10a9 9 0 00-9-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3f1d947069d6cc1d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c3.87 0 7 3.13 7 7v2h-2.92L21 17.92V11a9 9 0 00-9-9c-1.95 0-3.76.62-5.23 1.68l1.44 1.44A6.914 6.914 0 0112 4zM2.27 1.72L1 3l3.33 3.32A8.899 8.899 0 003 11v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-1.17.29-2.26.79-3.22L15 17v4h3c.3 0 .59-.06.86-.14L21 23l1.27-1.27-20-20.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$86c45bcf35ef74ef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z",
                    "opacity": ".1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a9 9 0 00-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7a9 9 0 00-9-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af4690ae817c494c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H5C2.79 5 1 6.79 1 9v5c0 2.21 1.79 4 4 4h2v1h10v-1h2c2.21 0 4-1.79 4-4V9c0-2.21-1.79-4-4-4zm2 9c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$626a87dde20c6c5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5C4.19 5 2 9.48 2 12c0 3.86 3.13 7 6.99 7h6.02C17.7 19 22 16.92 22 12c0 0 0-7-10-7zm0 2c7.64 0 7.99 4.51 8 5H4c0-.2.09-5 8-5zm2.86 10H9.14c-2.1 0-3.92-1.24-4.71-3h15.15c-.8 1.76-2.62 3-4.72 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f913794cd64db03a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 12v2H5v-2h2zm-2-2V8h2v2H5zm6 2v2H9v-2h2zm-2-2V8h2v2H9zm7 6v1H8v-1h8zm-1-4v2h-2v-2h2zm-2-2V8h2v2h-2zm4 4v-2h2v2h-2zm2-4h-2V8h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$94186b5c30d2125(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4773153bc0076cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe9840acab45e235(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$86ba4accb3dc11d6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9cee6c080606091a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$18418ba2b1aae126(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e862238613dd4085(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 3C15.57 3 14 4.57 14 6.5V8h-4V6.5C10 4.57 8.43 3 6.5 3S3 4.57 3 6.5 4.57 10 6.5 10H8v4H6.5C4.57 14 3 15.57 3 17.5S4.57 21 6.5 21s3.5-1.57 3.5-3.5V16h4v1.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5H16v-4h1.5c1.93 0 3.5-1.57 3.5-3.5S19.43 3 17.5 3zM16 8V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S18.33 8 17.5 8H16zM6.5 8C5.67 8 5 7.33 5 6.5S5.67 5 6.5 5 8 5.67 8 6.5V8H6.5zm3.5 6v-4h4v4h-4zm7.5 5c-.83 0-1.5-.67-1.5-1.5V16h1.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zm-11 0c-.83 0-1.5-.67-1.5-1.5S5.67 16 6.5 16H8v1.5c0 .83-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f063d2ca7c341c81(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12l1.41 1.41L12 7.83l5.59 5.58L19 12l-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d96afaae0697a798(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6.41L16.59 5 12 9.58 7.41 5 6 6.41l6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13l-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$18fad0dc55bd53d2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.59 18L19 16.59 14.42 12 19 7.41 17.59 6l-6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18l1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ddccacf3cb05f786(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.41 6L5 7.41 9.58 12 5 16.59 6.41 18l6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6l-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a3793cf6aeb6580(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 17.59L7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11l1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$125718b1b0ecb490(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$42fe78c2c16cfcc5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5h6v2h-6zM9 5H3v2h4.85l6.92 12H21v-2h-5.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e87612b0e59dd70b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de722510e04dc788(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3cc58193d18da65c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$74088a2551f46a6d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1baa703c03382bdf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$be65d7ac1a1ad25f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4ca00e62a4b97e77(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e581701f4aafd309(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2e97f5e9940d2eb6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4913c1773bc1c093(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v2h12v-2l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc9b3e36c53066be(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d83187162d60e45c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18v4h3v-2h5.5v2h3v-2H19v2h3v-4zM18 2H6c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-3 6H9V6h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5341524439b0147c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffc20d4d1ce795c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 1h-8A2.5 2.5 0 005 3.5v17A2.5 2.5 0 007.5 23h8a2.5 2.5 0 002.5-2.5v-17A2.5 2.5 0 0015.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7795b93b3a2c7097(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c3f4837417413663(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cf021182a5a2bf74(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 4H7V4h10v2zm3 16H4c-1.1 0-2-.9-2-2v-1h20v1c0 1.1-.9 2-2 2zm-1.47-11.81A2.008 2.008 0 0016.7 9H7.3c-.79 0-1.51.47-1.83 1.19L2 18h20l-3.47-7.81zM9.5 16h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm3 4h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm3 4h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f7513675199e866f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b557ab61d7063671(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c0ec0c48b2da8004(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c34f4a1cc3c2e5f0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae8de7030130c331(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9d1fcf1b5f5af662(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM9.5 16.5v-9l7 4.5-7 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$be3022fdb50235d1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-3 12H6V7h12v10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11.25h1.5v1.5H15zM12.5 11.25H14v1.5h-1.5zM10 11.25h1.5v1.5H10zM7.5 11.25H9v1.5H7.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aca6585c8f72aa43(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM7.5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S9.83 13 9 13s-1.5-.67-1.5-1.5zM16 17H8v-2h8v2zm-1-4c-.83 0-1.5-.67-1.5-1.5S14.17 10 15 10s1.5.67 1.5 1.5S15.83 13 15 13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd0aac4c3f910e17(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bcf154f0421558d5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "12.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5H4v16a2 2 0 002 2h10v-2H6V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1aeb59984cc48eb7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2a2 2 0 110-4zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$55fde92cb661fe31(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 7.41L18.17 11H6v2h12.17l-3.59 3.59L16 18l6-6-6-6-1.41 1.41zM2 6v12h2V6H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ada1b79100672e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3f847de0dc94e780(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 0h-14A2.5 2.5 0 002 2.5v19A2.5 2.5 0 004.5 24h14a2.5 2.5 0 002.5-2.5v-19A2.5 2.5 0 0018.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$46d793da3076101a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9801169c0f38fed3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 14c0-1.95-1.4-3.57-3.25-3.92L17.4 6.05A2.978 2.978 0 0014.56 4H9.44C8.15 4 7 4.82 6.6 6.05L5.81 8.4 4.41 7l.29-.29A.996.996 0 103.29 5.3l-2 2A.996.996 0 102.7 8.71l.3-.3 1.79 1.79C3.18 10.72 2 12.22 2 14c0 1.5.83 2.79 2.05 3.48A3 3 0 007 20c1.3 0 2.4-.84 2.82-2h4.37c.41 1.16 1.51 2 2.82 2a3 3 0 002.95-2.52C21.17 16.79 22 15.5 22 14zM7 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4-8H7.41l-.02-.02 1.1-3.3A1 1 0 019.44 6H11v4zm2-4h1.56a1 1 0 01.95.68l1.1 3.32H13V6zm4 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7dd1de48974eebe2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14v2H4V4H2V2h4v12h15zM5.99 17C4.89 17 4 17.9 4 19s.89 2 1.99 2C7.1 21 8 20.1 8 19s-.9-2-2.01-2zm13 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2S21 20.1 21 19s-.9-2-2.01-2zM13 13H7V7h6v6zm7 0h-6V7h6v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$453576d6234d603c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$901fa58852b16d77(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 3.3 6.13C2.54 6.41 2 7.15 2 8v8c0 1.1.9 2 2 2h11.17l4.61 4.61 1.41-1.42zM9 13v2H7v-2H5v-2h2V9.83L10.17 13H9zm11.7 4.87c.76-.28 1.3-1.02 1.3-1.87V8c0-1.1-.9-2-2-2H8.83L20.7 17.87zM17.5 9c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$941b5d176d6570c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0v24h24V0H0zm23 16c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bdf15de9f5d58922(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c2.76 0 5 2.24 5 5 0 .64-.13 1.25-.35 1.82l1.5 1.5a6.963 6.963 0 00-1.79-8.79L15 2H9l-.96 3.21 2.14 2.14C10.75 7.13 11.36 7 12 7zM2.81 2.81L1.39 4.22l4.46 4.46a6.963 6.963 0 001.79 8.79L9 22h6l.96-3.21 3.82 3.82 1.41-1.41L2.81 2.81zM12 17c-2.76 0-5-2.24-5-5 0-.64.13-1.25.35-1.82l6.47 6.47c-.57.22-1.18.35-1.82.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f55c3371b1bf0ff9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z",
                    "opacity": ".1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73A7.976 7.976 0 0020 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$25f66607bfe8e91e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.03 3.56c-1.67-1.39-3.74-2.3-6.03-2.51v2.01c1.73.19 3.31.88 4.61 1.92l1.42-1.42zM11 3.06V1.05c-2.29.2-4.36 1.12-6.03 2.51l1.42 1.42A8.928 8.928 0 0111 3.06zM4.98 6.39L3.56 4.97C2.17 6.64 1.26 8.71 1.05 11h2.01c.19-1.73.88-3.31 1.92-4.61zM20.94 11h2.01c-.21-2.29-1.12-4.36-2.51-6.03l-1.42 1.42A8.928 8.928 0 0120.94 11zM7 12l3.44 1.56L12 17l1.56-3.44L17 12l-3.44-1.56L12 7l-1.56 3.44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21a8.96 8.96 0 01-7.46-4H7v-2H1v6h2v-2.7c1.99 2.84 5.27 4.7 9 4.7 4.87 0 9-3.17 10.44-7.56l-1.96-.45C19.25 18.48 15.92 21 12 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c057d34f9eaa051c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h11.25c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75H22v-2h-2zm-2-8h-2V9h2v2zm-4 0H6V9h8v2zm0 2v2H6v-2h8zm2 0h2v2h-2v-2zm2-6h-2V5h2v2zm-4-2v2H6V5h8zM6 19v-2h8v2H6zm10 0v-2h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f3fc1fca871a6eab(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM16 9h2v2h-2V9zm-2 2H6V9h8v2zm4-4h-2V5h2v2zm-4-2v2H6V5h8zM6 19v-6h8v1.82A1.746 1.746 0 0015 18a1.746 1.746 0 001-3.18V13h2v6H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2bafd15dda46cd39(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6c0-1.1-.9-2-2-2H4v2h16v2.59c.73.29 1.4.69 2 1.17V6zM8 9H3c-.5 0-1 .5-1 1v9c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-9c0-.5-.5-1-1-1zm-1 9H4v-7h3v7zM17.75 16.97c.3-.23.5-.57.5-.97a1.25 1.25 0 00-2.5 0c0 .4.2.75.5.97V22h1.5v-5.03z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13.5a2.5 2.5 0 012.5 2.5c0 .69-.28 1.31-.73 1.76l1.06 1.06C20.55 18.1 21 17.1 21 16c0-2.21-1.79-4-4-4s-4 1.79-4 4c0 1.1.45 2.1 1.17 2.83l1.06-1.06A2.5 2.5 0 0117 13.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9.5a6.5 6.5 0 00-6.5 6.5c0 1.79.73 3.42 1.9 4.6l1.06-1.06C12.56 18.63 12 17.38 12 16c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.37-.56 2.62-1.46 3.52l1.07 1.06A6.5 6.5 0 0017 9.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e97c3655a066505(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8c.7 0 1.38.1 2.02.27L12 3 4 9v12h6.76A7.998 7.998 0 0117 8zM17 14.75c-.69 0-1.25.56-1.25 1.25 0 .4.2.75.5.97V22h1.5v-5.03c.3-.23.5-.57.5-.97 0-.69-.56-1.25-1.25-1.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.21 0-4 1.79-4 4 0 1.1.45 2.1 1.17 2.83l1.06-1.06A2.5 2.5 0 1119.5 16c0 .69-.28 1.31-.73 1.76l1.06 1.06C20.55 18.1 21 17.1 21 16c0-2.21-1.79-4-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9.5a6.5 6.5 0 00-6.5 6.5c0 1.79.73 3.42 1.9 4.6l1.06-1.06C12.56 18.63 12 17.38 12 16c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.37-.56 2.62-1.46 3.52l1.07 1.06A6.5 6.5 0 0017 9.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16e6b340d0abbfcb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm12 0c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm-9 4c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm3-4c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm3 4c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm3.5-6h-10A5.51 5.51 0 012 10.5c0-2.76 2.09-5.09 4.78-5.44A5.975 5.975 0 0112 2c2.97 0 5.45 2.18 5.92 5.02A4.5 4.5 0 0122 11.5c0 2.48-2.02 4.5-4.5 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f0c53de18e616858(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM11 5h2v14h-2V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae9a64b00c12fcd0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM8.19 12c2.04-1.35 3.5-3.94 3.76-7h.09c.26 3.06 1.72 5.65 3.76 7-2.04 1.35-3.5 3.94-3.76 7h-.09c-.26-3.06-1.72-5.65-3.76-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8f41a7c12ffd7dc3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.69 2.21L4.33 11.49c-.64.58-.28 1.65.58 1.73L13 14l-4.85 6.76c-.22.31-.19.74.08 1.01.3.3.77.31 1.08.02l10.36-9.28c.64-.58.28-1.65-.58-1.73L11 10l4.85-6.76c.22-.31.19-.74-.08-1.01a.77.77 0 00-1.08-.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c0586c5550a6d1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.96 0-9 4.04-9 9 0 3.91 2.51 7.24 6 8.47V22h2v-2.06a8.262 8.262 0 002 0V22h2v-2.53c3.49-1.24 6-4.57 6-8.47 0-4.96-4.04-9-9-9zm2.25 12l-3 3-1.5-1.5L11 14.25 9.75 13l3-3 1.5 1.5L13 12.75 14.25 14zM16 9H8V7h8v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$414ac2a788b8c6ff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.8 0-9 3.86-9 9 0 2.12.74 4.07 1.97 5.61L3 19.59 4.41 21l1.97-1.97A9.012 9.012 0 0012 21c2.3 0 4.61-.88 6.36-2.64A8.95 8.95 0 0021 12V3h-9zm3.83 9.26l-5.16 4.63c-.16.15-.41.14-.56-.01a.397.397 0 01-.04-.52l2.44-3.33-4.05-.4a.514.514 0 01-.3-.89l5.16-4.63c.16-.15.41-.14.56.01.14.14.16.36.04.52l-2.44 3.33 4.05.4c.45.04.63.59.3.89z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3f9ebf578d9e6464(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.92 7.02C17.45 4.18 14.97 2 12 2 9.82 2 7.83 3.18 6.78 5.06 4.09 5.41 2 7.74 2 10.5 2 13.53 4.47 16 7.5 16h10c2.48 0 4.5-2.02 4.5-4.5a4.5 4.5 0 00-4.08-4.48zm.08 9.99c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-11 3c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-1-3h9c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1zm4 3h7c.55 0 1 .45 1 1s-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f8466ba4bcd78194(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h-1V2h-2v2h-2V2H9v2H8C5.79 4 4 5.79 4 8v10c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zm-4 14c-1.38 0-2.5-1.1-2.5-2.46 0-1.09.43-1.39 2.5-3.79 2.05 2.38 2.5 2.7 2.5 3.79C14.5 16.9 13.38 18 12 18zm4-8H8V8h8v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$35962f44842c4dca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6.25 4.08c.82.12 1.57.44 2.2.91l-2.2 2.2V7.08zm-1.5 0v3.11l-2.2-2.2c.63-.47 1.38-.79 2.2-.91zM7.99 9.05l2.2 2.2H7.08c.12-.82.44-1.57.91-2.2zm-.91 3.7h3.11l-2.2 2.2c-.47-.63-.79-1.38-.91-2.2zm4.17 4.17c-.82-.12-1.57-.44-2.2-.91l2.2-2.2v3.11zM12 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm.75 3.92v-3.11l2.2 2.2c-.63.47-1.38.79-2.2.91zm3.26-1.97l-2.2-2.2h3.11c-.12.82-.44 1.57-.91 2.2zm-2.2-3.7l2.2-2.2c.47.64.79 1.39.91 2.2h-3.11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb4e702f5cf4aa4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.34 8.36l-2.29.82c-.18-.13-.38-.25-.58-.34.17-.83.63-1.58 1.36-2.06C16.85 5.44 16.18 2 13.39 2c-3.08 0-4.9 1.47-5.3 3.26L18.73 15.9c1.5.39 3.27-.51 3.27-2.51 0-4.39-3.01-6.23-5.66-5.03zM2.81 2.81L1.39 4.22 5.27 8.1C3.77 7.7 2 8.61 2 10.61c0 4.4 3.01 6.24 5.66 5.03l2.29-.82c.18.13.38.25.58.34-.17.83-.63 1.58-1.36 2.06C7.15 18.56 7.82 22 10.61 22c3.08 0 4.9-1.47 5.3-3.26l3.87 3.87 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b28acd0ffd58cae4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.83 1.01l-4.11.42C8.47 1.75 6 4.48 6 7.75s2.47 6 5.72 6.33l1.9.19-.56.85c-.35-.08-.7-.12-1.06-.12-2.76 0-5 2.24-5 5v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-2c0-1.67-.83-3.15-2.09-4.06l.97-1.45c1.14.07 2.12-.83 2.12-1.99V3c0-1.17-1-2.09-2.17-1.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b1c9c118bf3b974(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c.55 0 1-.45 1-1s-.45-1-1-1h-1V5h1c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h1v6H4c-.55 0-1 .45-1 1s.45 1 1 1h1v6H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1h-1v-6h1zm-8 3c-1.66 0-3-1.32-3-2.95 0-1.3.52-1.67 3-4.55 2.47 2.86 3 3.24 3 4.55 0 1.63-1.34 2.95-3 2.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$74adf285f1e6c263(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15v3c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4v-3H4zM20 13v-3c0-1.86-1.28-3.41-3-3.86V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2.14c-1.72.45-3 2-3 3.86v3h16zM9 4h6v2h-2c0-.55-.45-1-1-1s-1 .45-1 1H9V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6bb12ffc2e8a3799(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6h-1V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v1H7c-3.31 0-6 2.69-6 6s2.69 6 6 6v3h2v-3h6v3h2v-3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm-7-1h4v1h-4V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e59c06f0534e8d1a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h8.25c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75H22v-2h-2zM6 19v-2h5v2H6zm7 0v-2h5v2h-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$789055c2e66cff42(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM6 19v-6h5v1.8c-.4.3-.8.8-.8 1.4 0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8c0-.6-.3-1.1-.8-1.4V13h5v6H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7e66352c143d66c8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v18h16V4c0-1.1-.9-2-2-2zm-2.5 11.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f26af06790e96864(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zM12 12c-1.84 0-3.56.5-5.03 1.37-.61.35-.97 1.02-.97 1.72V17h12v-1.91c0-.7-.36-1.36-.97-1.72A9.844 9.844 0 0012 12zM21.23 8.15l1.85-.77A12.056 12.056 0 0016.62.92l-.77 1.85c2.42 1.02 4.36 2.96 5.38 5.38zM8.15 2.77L7.38.92A12.089 12.089 0 00.92 7.38l1.85.77c1.02-2.42 2.96-4.36 5.38-5.38zM2.77 15.85l-1.85.77c1.22 2.91 3.55 5.25 6.46 6.46l.77-1.85a10.117 10.117 0 01-5.38-5.38zM15.85 21.23l.77 1.85c2.91-1.22 5.25-3.55 6.46-6.46l-1.85-.77a10.117 10.117 0 01-5.38 5.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6756a04bb1d20fd7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4v16H6V4h12m0-2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM7 19h10v-6H7v6zm3-9h4v1h3V5H7v6h3v-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a3d2c22d7180ff57(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1v2H5V1H3v22h2v-2h14v2h2V1h-2zm0 4v6h-6V7H7v4H5V5h14zm-2 14v-4h-6v4H5v-6h14v6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c685a2875e6868cb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm3.97 12.41c-1.84 2.17-5.21 2.1-6.96-.07-2.19-2.72-.65-6.72 2.69-7.33.34-.06.63.27.51.6-.46 1.23-.39 2.64.32 3.86a4.51 4.51 0 003.18 2.2c.34.05.49.47.26.74z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$98b902b7a18088a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM4.75 6a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm12 8a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm0-8a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm-9 12a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm0-8a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm3 4a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm0-8a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm3 12a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm0-8a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da04666706ce9e61(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.33 16H11v-3H4zM13 16h7.67L20 13h-7zM21.11 18H13v4h9zM2 22h9v-4H2.89zM11 8h2v3h-2zM15.764 7.205l1.415-1.414L19.3 7.912l-1.414 1.414zM4.705 7.913L6.826 5.79 8.24 7.206 6.12 9.327zM3 2h3v2H3zM18 2h3v2h-3zM12 7c2.76 0 5-2.24 5-5H7c0 2.76 2.24 5 5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16b56068bdfaef6a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5h-2V1h2v4zM1 11h4v2H1v-2zm18 2v-2h4v2h-4zm-1.34-5.24l-1.41-1.41 2.83-2.83 1.41 1.41-2.83 2.83zM3.51 4.93l1.41-1.41 2.83 2.83-1.41 1.41-2.83-2.83zM4.75 17a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm12 0a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm-9 4a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm3-4a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm3 4a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zM17 13v-1c0-2.76-2.24-5-5-5s-5 2.24-5 5v1h10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$52ef17aaa49fcb81(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4V2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1zm7.36 3.05l1.41-1.42a.996.996 0 10-1.41-1.41l-1.41 1.42a.996.996 0 101.41 1.41zM22 11h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zm-10 8c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1zM5.64 7.05L4.22 5.64c-.39-.39-.39-1.03 0-1.41s1.03-.39 1.41 0l1.41 1.41c.39.39.39 1.03 0 1.41s-1.02.39-1.4 0zm11.31 9.9a.996.996 0 000 1.41l1.41 1.41c.39.39 1.03.39 1.41 0a.996.996 0 000-1.41l-1.41-1.41a.996.996 0 00-1.41 0zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm3.64 6.78l1.41-1.41c.39-.39.39-1.03 0-1.41s-1.03-.39-1.41 0l-1.41 1.41a.996.996 0 000 1.41c.38.39 1.02.39 1.41 0zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1542db91220353be(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM13 5h1.5v14H13V5zm-2 14H9.5V5H11v14zM6 5h1.5v14H6V5zm10.5 14V5H18v14h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$78fb76c71f0b03e8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zm-10 0V5h4v14h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$47f801da52fa4f53(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h6v2H4zM1 7h5v2H1zM3 19h5v2H3zM13.73 10.61c.75.23 1.3.78 1.57 1.46l4.27-7.11a2.28 2.28 0 00-3.51-2.84l-3.43 3.21c-.4.37-.63.9-.63 1.45v3.93c.36-.15.98-.33 1.73-.1zM10.61 12.27c.16-.52.48-.96.89-1.27H3.28a2.279 2.279 0 00-.63 4.47l4.51 1.29c.53.15 1.1.08 1.58-.21l2.69-1.61a2.487 2.487 0 01-.82-2.67zM22.21 18.61l-2.28-4.1a2.05 2.05 0 00-1.26-.97l-3.18-.8c.03.32 0 .66-.1.99A2.478 2.478 0 0113 15.5c-.61 0-.99-.22-1-.22V21c-1.1 0-2 .9-2 2h6c0-1.1-.9-2-2-2v-4.28l4.61 4.61c.89.89 2.33.89 3.22 0 .72-.72.88-1.83.38-2.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.56 14.43c.79.24 1.63-.2 1.87-1 .24-.79-.2-1.63-1-1.87-.79-.24-1.63.2-1.87 1-.24.79.21 1.63 1 1.87z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9bbbdd4c389700c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 7H15v3h-1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zm6.5 5c0 .55-.45 1-1 1H13c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zm-1 3.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb5a716b22fe1b83(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM11 5.5v6H9.5V7H8V5.5h3zm5 0v6h-1.5V7H13V5.5h3zm-.5 8.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$86e991f1dc4befb2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zM15.5 9h-2v1h3v1.5H12V9c0-.55.45-1 1-1h2V7h-3V5.5h3.5c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm0 5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d58b3cee01552e5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zm6.5 5c0 .55-.45 1-1 1H12V10h3V9h-2V8h2V7h-3V5.5h3.5c.55 0 1 .45 1 1v4zm-1 3.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$73022cfd6a615c2f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zm7.5 4.5h-1v1.5H15V10h-3V5.5h1.5v3H15v-3h1.5v3h1V10zm-2 4H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a97a0c601158536(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zM16.5 7h-3v1h2c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1H12V10h3V9h-3V5.5h4.5V7zm-1 7H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e841a963e85ac5e1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 9H15v1.5h-1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zm3 6c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3.5V7h-3v1h2c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1H13zm2.5 2.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4fdb3e7fc6022de0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zm5 6h-1.75L14.62 7H12V5.5h3.5c.67 0 1.15.65.96 1.29L15 11.5zm.5 2.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a0e583efb9d36792(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zm6.5 5c0 .55-.45 1-1 1H13c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zm-3 0H15V9h-1.5v1.5zm0-2.5H15V6.5h-1.5V8zm2 6H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d36afd400a6dedd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 7h3V9h-2c-.55 0-1-.45-1-1V6.5c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1H12V10zm1.5-2H15V6.5h-1.5V8zM7 5.5h3v6H8.5V7H7V5.5zm5 13h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm6.5-2.5c0 .55-.45 1-1 1h-2v1.5H14v-6h3.5c.55 0 1 .45 1 1V16zm-3-2H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5151b07dbd1d9427(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 7H16v3h-1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm2-8c0 .55-.45 1-1 1H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zM10 9H8v1h3v1.5H6.5V9c0-.55.45-1 1-1h2V7h-3V5.5H10c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm5.5 5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5967c42288124dbd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM11 9H9v1h3v1.5H7.5V9c0-.55.45-1 1-1h2V7h-3V5.5H11c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm3-3.5h3v6h-1.5V7H14V5.5zm1.5 8.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cdc7ac74d63d988f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 9H8v1h3v1.5H6.5V9c0-.55.45-1 1-1h2V7h-3V5.5H10c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm6.5 0h-2v1h3v1.5H13V9c0-.55.45-1 1-1h2V7h-3V5.5h3.5c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm-1 5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$54834c6fed05c206(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 9H8v1h3v1.5H6.5V9c0-.55.45-1 1-1h2V7h-3V5.5H10c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm7.5 1.5c0 .55-.45 1-1 1H13V10h3V9h-2V8h2V7h-3V5.5h3.5c.55 0 1 .45 1 1v4zm-2 3.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d1dbbcd25c5c6c49(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 9H8v1h3v1.5H6.5V9c0-.55.45-1 1-1h2V7h-3V5.5H10c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm8.5 1h-1v1.5H16V10h-3V5.5h1.5v3H16v-3h1.5v3h1V10zm-3 4H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac58d340e2ca259f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm-2-9.5h-2v1h3v1.5H10V9c0-.55.45-1 1-1h2V7h-3V5.5h3.5c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm2 5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6ec7f9734f88f074(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v2h5v2H5v2h4v2H4v2h5c1.1 0 2-.9 2-2v-1.5c0-.83-.17-1.5-1-1.5.83 0 1-.67 1-1.5V6c0-1.1-.9-2-2-2H4zm14 0c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h3zm0 2h-3v6h3V6zM5 22H3v-5h2v5zm4 0H7v-5h2v5zm4 0h-2v-5h2v5zm8 0h-6v-5h6v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$be52fd67c8b75547(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm-1-8c0 .55-.45 1-1 1H10V10h3V9h-2V8h2V7h-3V5.5h3.5c.55 0 1 .45 1 1v4zm1 3.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$43c44672cf05ed3a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3-8.5h-1v1.5h-1.5V10h-3V5.5H11v3h1.5v-3H14v3h1V10zm.5 8.5H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm0-4.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$73a179221c39288b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM14.5 7h-3v1h2c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1H10V10h3V9h-3V5.5h4.5V7zm1 7H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$33ac388fd5e5d264(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6v6h-3V6h3zm0-2h-3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 2V4H6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2H6V6h5zm-2 4v2H6v-2h3zM5 22H3v-5h2v5zm4 0H7v-5h2v5zm4 0h-2v-5h2v5zm8 0h-6v-5h6v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4205f7e6a2045aef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9H13v1.5h-1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm-1-7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3.5V7h-3v1h2c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1H11zm4.5 7H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm0-4.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d00874adaeea9d31(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm-2.5-7h-1.75L12.62 7H10V5.5h3.5c.67 0 1.15.65.96 1.29L13 11.5zm2.5 2.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$74a6834b12c9d1df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9H13v1.5h-1.5zm0-2.5H13V8h-1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm-1-8c0 .55-.45 1-1 1H11c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zm1 3.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$547883bbe26502a0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 6.5H13V8h-1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm-1-8c0 .55-.45 1-1 1H10V10h3V9h-2c-.55 0-1-.45-1-1V6.5c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zm1 3.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$32fe2ab7440ac656(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cc99b0b1f3610f2c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$141be8936b43741b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0be5601b21ec661(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd621e7f1124d91d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2c-2.71 0-5.05 1.54-6.22 3.78a7.062 7.062 0 00-3 3A7.014 7.014 0 002 15c0 3.87 3.13 7 7 7 2.71 0 5.05-1.54 6.22-3.78a7.062 7.062 0 003-3A7.014 7.014 0 0022 9c0-3.87-3.13-7-7-7zM9 20a5.002 5.002 0 01-4-8c0 3.87 3.13 7 7 7-.84.63-1.88 1-3 1zm3-3a5.002 5.002 0 01-4-8c0 3.86 3.13 6.99 7 7-.84.63-1.88 1-3 1zm4.7-3.3c-.53.19-1.1.3-1.7.3-2.76 0-5-2.24-5-5 0-.6.11-1.17.3-1.7.53-.19 1.1-.3 1.7-.3 2.76 0 5 2.24 5 5 0 .6-.11 1.17-.3 1.7zM19 12c0-3.86-3.13-6.99-7-7a5.002 5.002 0 017 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2325534283ec10e0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dbcb3a095fa82a80(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$23c7f71b8249f4ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v9.28a4.39 4.39 0 00-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f188fbe1ae96d75(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a2 2 0 002 2h6V3H5a2 2 0 00-2 2zm16-2h-6v8h8V5c0-1.1-.9-2-2-2zm-6 18h6c1.1 0 2-.9 2-2v-6h-8v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de3289420b9f6e12(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H4a2 2 0 00-2 2v10h2V4h10V2zm4 4H8a2 2 0 00-2 2v10h2V8h10V6zm2 4h-8a2 2 0 00-2 2v8a2 2 0 002 2h8c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9bafee83c31be969(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b8d0006de60fe520(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 5.6L10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.996.996 0 00-1.41 0L1.29 18.96a.996.996 0 000 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05a.996.996 0 000-1.41l-2.33-2.35zm-1.03 5.49l-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ccff08fd001e8bf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.996.996 0 00-1.41 0L1.29 18.96a.996.996 0 000 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05a.996.996 0 000-1.41l-2.33-2.35zm-1.03 5.49l-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$76c3a9d484aee175(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 1l-2.5 1.4L18 1l1.4 2.5L18 6l2.5-1.4L23 6l-1.4-2.5L23 1zm-8.34 6.22l2.12 2.12-2.44 2.44.81.81 2.55-2.55a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0L11.4 8.84l.81.81 2.45-2.43zm-.78 6.65l-3.75-3.75-6.86-6.86L2 4.53l6.86 6.86-6.57 6.57a.996.996 0 000 1.41l2.34 2.34c.39.39 1.02.39 1.41 0l6.57-6.57L19.47 22l1.27-1.27-6.86-6.86z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e846401014c2783c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1l-5 5v11l5-4.5V1zM1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5V6c-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6zm22 13.5V6c-.6-.45-1.25-.75-2-1v13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5v2c1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5v-1.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$beebd6966e61c5ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.03 6.3h-.06l-1.02 2.89h2.1zM3 17h2v5H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm-.63-10h1.25l2.63 7h-1.21l-.63-1.79h-2.83L9.96 12H8.74l2.63-7zM7 17h2v5H7zM11 17h2v5h-2zM15 17h6v5h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b6fb5f84eaf39539(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l2.27 2.27A9.959 9.959 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.62 5.51-1.66l2.27 2.27 1.41-1.42zM12.34 2.02c-2.18-.07-4.19.55-5.85 1.64l4.59 4.59c-.27-2.05.1-4.22 1.26-6.23z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$edbde0be8f559e7d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.34 2.02C6.59 1.82 2 6.42 2 12c0 5.52 4.48 10 10 10 3.71 0 6.93-2.02 8.66-5.02-7.51-.25-12.09-8.43-8.32-14.96z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c1e3c04930bb9132(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d360861ab648968(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e0ba32f742695ab8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81A.875.875 0 0014 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d0a129f3b841726(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c6216b94798155c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3dc0e52c2424345d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dfa76c83bc4ca8d2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6065035d578ae49d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4b8793ce451dacd7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16bb2e752f1c7357(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5e77d9d55d242cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7574fad5a27d4d9b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0zm21 19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1d997eb81f40641c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34a.996.996 0 00-1.41 0L9 12.25 11.75 15l8.96-8.96a.996.996 0 000-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dc1ad4ddcbc0a838(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$79559d1ff2aaf5e7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3.2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c2c21614753bfda9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e523bac042fb1923(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1182c2dc6b76389e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e32250e54db670d6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 10.5l4.77-8.26a9.984 9.984 0 00-8.49 2.01l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25A9.91 9.91 0 0022 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75A9.958 9.958 0 002.2 14h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76a9.984 9.984 0 008.49-2.01l-3.66-6.35-.93 1.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a7f910a6838e9e44(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V4l-2-2h-5L9 4v2H5v11s1 2 2 2h13s2-.98 2-2V6h-4zM4 9H2v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H4V9zm7-4c0-.55.53-1 1-1h3c.46 0 1 .54 1 1v1h-5V5zM5 6h17v11c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$79c8bd6b205daafd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c3822ec35deeec1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$400e9c5ab86b982e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d22e0e4804fd0c3d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$449008750bff5ea4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e278adce1bb3447(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3a9 9 0 000 18c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9edcb40327a4a742(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.71 5.63l-2.34-2.34a.996.996 0 00-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c6f97cd26e34983f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$75ff98b60cb43e31(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm1-17.93c3.94.49 7 3.85 7 7.93s-3.05 7.44-7 7.93V4.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$58d80561e07ce85(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16A6.99 6.99 0 012 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6b7dd52cb9182a9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2af8085ec24b8510(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ca3b4d9945be20c0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7598b84be87566a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f4aac9dae92108f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7c8c4b3d09d8a0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d992099a714b5a9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f75b2a8df6e2018f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e72794663d224ed8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$afd1569de829e064(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$caa1a48091d30292(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8a2 2 0 00-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8a2 2 0 002 2h8v2h2v-2h2v-2H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8ae6e20c622feab8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5693a5716721f4e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e266ddafcc9e776b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.06 11.57c.59-.69.94-1.59.94-2.57 0-1.86-1.27-3.43-3-3.87V3h-2v2h-2V3H9v2H6v2h2v10H6v2h3v2h2v-2h2v2h2v-2c2.21 0 4-1.79 4-4 0-1.45-.78-2.73-1.94-3.43zM10 7h4c1.1 0 2 .9 2 2s-.9 2-2 2h-4V7zm5 10h-5v-4h5c1.1 0 2 .9 2 2s-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c689a0c2d85c03fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5V3H7v13H5v2h2v3h2v-3h4v-2H9v-3h8v-2H9V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f8dea2227d21c6de(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8.76V3h2v4.51L15 5v2.36l-4 2.51.01 2.35L15 9.72v2.36l-4 2.51V19c2.76 0 5-2.24 5-5h2c0 3.87-3.13 7-7 7H9v-5.16l-3 1.88v-2.36l3-1.88v-2.36L6 13v-2.36l3-1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e7b6e4fe136317f5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21c1.93 0 3.62-1.17 4-3l-1.75-.88C16 18.21 15.33 19 14 19H9.1c.83-1 1.5-2.34 1.5-4 0-.35-.03-.69-.08-1H14v-2H9.82C9 10.42 8 9.6 8 8a3.5 3.5 0 016.78-1.22L16.63 6c-.8-2.05-2.79-3.5-5.13-3.5C8.46 2.5 6 4.96 6 8c0 1.78.79 2.9 1.49 4H6v2h2.47c.08.31.13.64.13 1 0 2.7-2.6 4-2.6 4v2h8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0042ba94f53b2ff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 3H7v9H5v2h2v2H5v2h2v3h2v-3h4v-2H9v-2h4.5c3.04 0 5.5-2.46 5.5-5.5S16.54 3 13.5 3zm0 9H9V5h4.5C15.43 5 17 6.57 17 8.5S15.43 12 13.5 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ad40ab1f52672590(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.66 7c-.56-1.18-1.76-2-3.16-2H6V3h12v2h-3.26c.48.58.84 1.26 1.05 2H18v2h-2.02c-.25 2.8-2.61 5-5.48 5h-.73l6.73 7h-2.77L7 14v-2h3.5c1.76 0 3.22-1.3 3.46-3H6V7h7.66z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$44f8d040d6f231a6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.92 11H18v2h-5v2h5v2h-5v4h-2v-4H6v-2h5v-2H6v-2h4.08L5 3h2.37L12 10.29 16.63 3H19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d1ddde7e006d2d4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.28 12H18v2h-5v7h-2v-7H6v-2h4.72L5 3h2.37L12 10.29 16.63 3H19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$58ace95d5200e43(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v18a9 9 0 000-18z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "14",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "10",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3",
                    "cy": "10",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3",
                    "cy": "14",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "21",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "3",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "14",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "10",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "18",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a402fc724742443(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a5ecdf32ce259381(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L2 21h20L12 3zm1 5.92L18.6 19H13V8.92zm-2 0V19H5.4L11 8.92z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bcb5cb916561bf91(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.95 19H20V7H4v12h7.24c.14-.98.42-2.05-.16-2.43-.89-.59-1.27 2.06-2.8 1.35-1.39-1.12 1.05-1.29.5-3.27-.22-.79-2.28.36-2.4-1.24-.08-1 1.49-.74 1.51-1.49.03-.75-1.03-1.05-.25-1.91.22-.24.71-.26.91-.19.79.27 1.55 1.82 2.51 1.19 1.03-.66-1.88-2.35 0-2.86 1.64-.44 1.31 2.08 2.65 2.44 1.94.52 2.65-4.55 4.41-2.33 1.85 2.33-3.43 2.27-2.85 4.01.34 1.01 2.15-1.2 2.76.53.64 1.83-3.09.82-3.04 1.66.06.83 2.41.55 1.64 2.12-1.14 1.86-3-1.03-3.81.09-.39.57-.09 1.49.13 2.33zM20 5c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h3.17L9 3h6l1.83 2H20zm-1.86 13.01c-.47 0-.86-.38-.86-.86s.38-.86.86-.86c.47 0 .86.38.86.86s-.38.86-.86.86z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7e28bc8eda6c89cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae77917961e36ab8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18.5A6.48 6.48 0 019.24 15H15l1-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15l1-2H9.24A6.491 6.491 0 0115 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3A8.955 8.955 0 0015 3c-3.92 0-7.24 2.51-8.48 6H3l-1 2h4.06a8.262 8.262 0 000 2H3l-1 2h4.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7fe8660c7061b1a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2d5e13e44e333be(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71A5.72 5.72 0 0016.47 5c-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8cdcc76f39c49582(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1bfc19c13ca2c33b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71A5.72 5.72 0 0017.47 5c-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$52223e4f9639a90c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dae751d5cf0bbf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM6 7h5v1.5H6V7zm13 12H5L19 5v14zm-4.5-3v2H16v-2h2v-1.5h-2v-2h-1.5v2h-2V16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f172d3d87604674e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.77 8.58l-.92 2.01c.09.46.15.93.15 1.41 0 4.41-3.59 8-8 8s-8-3.59-8-8c0-.05.01-.1 0-.14 2.6-.98 4.69-2.99 5.74-5.55A10 10 0 0017.5 10c.45 0 .89-.04 1.33-.1l-.6-1.32-.88-1.93-1.93-.88-2.79-1.27 2.79-1.27.71-.32A9.86 9.86 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-1.47-.33-2.87-.9-4.13l-.33.71z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.6 5.6L19.5 8l-1.1-2.4L16 4.5l2.4-1.1L19.5 1l1.1 2.4L23 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$74c64c758d28b5e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 10c.75 0 1.47-.09 2.17-.24.21.71.33 1.46.33 2.24 0 1.22-.28 2.37-.77 3.4l1.49 1.49A9.981 9.981 0 0022 12c0-5.52-4.48-10-10-10-1.78 0-3.44.47-4.89 1.28l5.33 5.33c1.49.88 3.21 1.39 5.06 1.39zM1.89 3.72l2.19 2.19A9.958 9.958 0 002 12c0 5.52 4.48 10 10 10 2.29 0 4.4-.78 6.09-2.08l2.19 2.19 1.41-1.41L3.31 2.31 1.89 3.72zm14.77 14.77A7.91 7.91 0 0112 20c-4.41 0-8-3.59-8-8 0-.05.01-.1 0-.14a9.946 9.946 0 003.64-2.39l9.02 9.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3492ba9b2ee00063(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd2361d14502e2a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2a2 2 0 002-2V7a2 2 0 00-2-2h-4v2h4v2h-2a2 2 0 00-2 2v4h6v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab92b380e3751e5f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 00-2-2h-4v2h4v2h-2v2h2v2h-4v2h4a2 2 0 002-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$39a008ac13adb6a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$22291ddf8b584012(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2a2 2 0 00-2-2h-2V7h4V5h-6v6h4v2h-4v2h4a2 2 0 002-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6891f8edb012003e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2a2 2 0 002-2v-2a2 2 0 00-2-2h-2V7h4V5h-4a2 2 0 00-2 2v6a2 2 0 002 2zm0-4h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6da21991a351148(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$863840ab0525d638(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2a2 2 0 002-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 00-2-2h-2a2 2 0 00-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13a2 2 0 002 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d71453a6dc0c4e6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8a2 2 0 00-2-2h-1a2 2 0 00-2 2v1a2 2 0 002 2h1v1H9v2h3a2 2 0 002-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e61b5d1962a2c61a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2a2 2 0 00-2 2v2a2 2 0 002 2h2v2h-4v2h4a2 2 0 002-2V7a2 2 0 00-2-2zm0 4h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$57014fd0117520b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b1efbf01539ab1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$76f7191932adb50e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4a7.48 7.48 0 00-6.64 4.04A5.996 5.996 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$333c1b3b17a23683(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d3f20c076a04750(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b85676b97d5a655e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d61466fb695c633(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0111 4.07zm7.32.19A9.949 9.949 0 0013 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1a7.941 7.941 0 011.62 3.9zM5.69 7.1L4.26 5.68A9.949 9.949 0 002.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 014.07 13zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43a9.981 9.981 0 002.21-5.32h-2.02a7.945 7.945 0 01-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19A9.981 9.981 0 0011 21.95v-2.02a7.941 7.941 0 01-3.9-1.62l-1.42 1.43z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3afb55186ff72644(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.7 12.4a6.06 6.06 0 00-.86-.4c.29-.11.58-.24.86-.4a6.012 6.012 0 003-5.19 6.007 6.007 0 00-6 0c-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55a6.008 6.008 0 00-6 0 5.97 5.97 0 003 5.19c.28.16.57.29.86.4-.29.11-.58.24-.86.4a6.012 6.012 0 00-3 5.19 6.007 6.007 0 006 0c.28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54a6.008 6.008 0 006 0 6.012 6.012 0 00-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f307a65c38f729a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e194d11a72630a86(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9b15875d1f863d72(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab79af29d82d53d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c45b6c4689a4bb3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2v11h3v9l7-12h-4l4-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b1f02cbcf52e0371(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10V8H5.09C6.47 5.61 9.05 4 12 4c3.72 0 6.85 2.56 7.74 6h2.06c-.93-4.56-4.96-8-9.8-8-3.27 0-6.18 1.58-8 4.01V4H2v6h6zM16 14v2h2.91c-1.38 2.39-3.96 4-6.91 4-3.72 0-6.85-2.56-7.74-6H2.2c.93 4.56 4.96 8 9.8 8 3.27 0 6.18-1.58 8-4.01V20h2v-6h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4ee0b7fb87f3fee2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5H5l2.5-2.5L10 13H8c0 2.21 1.79 4 4 4 .58 0 1.13-.13 1.62-.35l.74.74c-.71.37-1.5.61-2.36.61zm4.5-2.5L14 13h2c0-2.21-1.79-4-4-4-.58 0-1.13.13-1.62.35l-.74-.73C10.35 8.24 11.14 8 12 8c2.76 0 5 2.24 5 5h2l-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5b5c1d282f10e3fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a155a27fa3c947b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$40c2c241f3da7696(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2778940734ea8529(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5939fb999b472905(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$25e78b4b66a87c52(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm0 2C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm1 7h-2V9H9V7h2V5h2v2h2v2h-2v2zm11 9h-2v2h-1.5v-2h-2v-1.5h2v-2H22v2h2V20zm-6-1.5c0 .6-.4 1.1-.9 1.4L18 22h-1.5l-.9-2h-1.1v2H13v-6h3.5c.8 0 1.5.7 1.5 1.5v1zm-1.5 0v-1h-2v1h2zm-13-.5v-2H5v6H3.5v-2.5h-2V22H0v-6h1.5v2h2zm6.5-2c.8 0 1.5.7 1.5 1.5v3c0 .8-.7 1.5-1.5 1.5H6.5v-6H10zm0 4.5v-3H8v3h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$15c86a2ee06ba1ab(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fd75e5a8b64ca99f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a4b5b80ae86204b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 14.5h2v1h-2zM14.5 7.5H16v3h-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 13.5c0 .6-.4 1.1-.9 1.4L12 19h-1.5l-.9-2H8.5v2H7v-6h3.5c.8 0 1.5.7 1.5 1.5v1zm0-3.5h-1.5V9.5h-2V12H7V6h1.5v2h2V6H12v6zm5.5 4H16v1.5h-1.5V16H13v-1.5h1.5V13H16v1.49h1.5V16zm0-5.5c0 .8-.7 1.5-1.5 1.5h-3V6h3c.8 0 1.5.7 1.5 1.5v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a37217d4f33a46e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b68599d3b02c265(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d2ec74a4f098a7b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.73 12.02l3.98-3.98a.996.996 0 000-1.41l-4.34-4.34a.996.996 0 00-1.41 0l-3.98 3.98L8 2.29a1.001 1.001 0 00-1.41 0L2.25 6.63a.996.996 0 000 1.41l3.98 3.98L2.25 16a.996.996 0 000 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34a.996.996 0 000-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$50121e1fcb326661(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 11h-1V9H3v6h1.5v-2.5h1V15H7V9H5.5zM21 11v-1c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h-1.5v.5h-1v-3h1v.5H21zM14.25 13.5L13.5 9H12l1 6h2.5l1-6H15zM8 9v6h3.5v-1.5h-2v-1h2V11h-2v-.5h2V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$63f05cddfd901109(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c0-1.1-.9-2-2-2H5.83L21 18.17V5zM2.81 2.81L1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.41L2.81 2.81zM6 17l3-4 2.25 3 .82-1.1 2.1 2.1H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c33eec8a87494d3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2538f2e3cec7a771(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9 21.9l-8.49-8.49-9.82-9.82L2.1 2.1.69 3.51 3 5.83V19c0 1.1.9 2 2 2h13.17l2.31 2.31 1.42-1.41zM5 18l3.5-4.5 2.5 3.01L12.17 15l3 3H5zm16 .17L5.83 3H19c1.1 0 2 .9 2 2v13.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$27cf9ef76a4d87e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13v7H4V6h5.02c.05-.71.22-1.38.48-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5l-2-2zm-1.5 5h-11l2.75-3.53 1.96 2.36 2.75-3.54zm2.8-9.11c.44-.7.7-1.51.7-2.39C20 4.01 17.99 2 15.5 2S11 4.01 11 6.5s2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21 13.42 22.42 12 19.3 8.89zM15.5 9a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c4e62c7478c0d013(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b732432915e14cc7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-2.76 1.12-5.26 2.93-7.07L12 12V2c5.52 0 10 4.48 10 10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$197d8465963db37f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d96ec4cb7718d434(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dad703be6147f6fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2a9 9 0 01-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2a9 9 0 019-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a4b43fcab5467326(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97A8.99 8.99 0 013 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5A11.044 11.044 0 0010 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43A6.922 6.922 0 0014 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46A8.98 8.98 0 0121 12v-2c-2.06 0-3.98.58-5.62 1.56z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5464c45d356540fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$803bce0a985bd00d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "3.2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "5",
                    "fill": "none"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0H0v24h24V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ad3ce36b2d2ed3b0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.68 14.98H6V9h1.71c1.28 0 1.71 1.03 1.71 1.71v2.56c0 .68-.42 1.71-1.74 1.71zm4.7-3.52v1.07H11.2v1.39h1.93v1.07h-2.25c-.4.01-.74-.31-.75-.71V9.75c-.01-.4.31-.74.71-.75h2.28v1.07H11.2v1.39h1.18zm4.5 2.77c-.48 1.11-1.33.89-1.71 0L13.77 9h1.18l1.07 4.11L17.09 9h1.18l-1.39 5.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.77 10.12h-.63v3.77h.63c.14 0 .28-.05.42-.16.14-.1.21-.26.21-.47v-2.52c0-.21-.07-.37-.21-.47a.72.72 0 00-.42-.15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e705ff5efec44871(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M.01 0h24v24h-24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15a2 2 0 01-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4a2 2 0 012 2v1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$526b87f69a0133d6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$603dc7fde699be89(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2a2 2 0 012 2v2a2 2 0 01-2 2H9v-2h4v-2H9V7h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$36ab4540e19283e4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V9a2 2 0 012-2h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$717fec7aa2b203db(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4545dfaa15463e36(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8a2 2 0 01-2 2h-2v2h4v2H9v-4a2 2 0 012-2h2V9H9V7h4a2 2 0 012 2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$397f6dcbbc121a79(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc649f75dc831956(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8c2e2df849229132(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 5.17 8H4l1 10h1c0 2.21 1.79 4 4 4s4-1.79 4-4v-1.17l5.78 5.78 1.41-1.42zM12 18c0 1.1-.9 2-2 2s-2-.9-2-2h1l.56-5.61L12 14.83V18zm2-12v5.17l-2-2V6c0-2.21 1.79-4 4-4s4 1.79 4 4v11.17l-2-2V6c0-1.1-.9-2-2-2s-2 .9-2 2zm-4-1c0 .62-.2 1.18-.52 1.66L5.33 2.51A2.996 2.996 0 0110 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$696dd78a50c873b5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.22 7H4.78C4.3 6.47 4 5.77 4 5c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .77-.3 1.47-.78 2zM16 2c2.21 0 4 1.79 4 4v16h-2V6c0-1.1-.9-2-2-2s-2 .9-2 2v12c0 2.21-1.79 4-4 4s-4-1.79-4-4H5L4 8h6L9 18H8c0 1.1.9 2 2 2s2-.9 2-2V6c0-2.21 1.79-4 4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3faafe2d98fb9b95(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zM-74 29h48v48h-48V29z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bdb1c16627911936(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.88 7.88l1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM7 5.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5zm5.03 3.49h-.07L10.8 12.3h2.39l-1.16-3.31zM12 18c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm-.71-10.5h1.43l3.01 8h-1.39l-.72-2.04h-3.23l-.73 2.04H8.28l3.01-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db279cd2dfd47669(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.84 20.84L3.16 3.16 1.89 4.43l1.89 1.89A9.92 9.92 0 002 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.77l1.89 1.89 1.27-1.28zM12 20c-4.41 0-8-3.59-8-8 0-1.55.45-3 1.22-4.23l1.46 1.46C6.25 10.06 6 11 6 12c0 3.31 2.69 6 6 6 1 0 1.94-.25 2.77-.68l1.46 1.46A7.951 7.951 0 0112 20zM6.32 3.77A9.986 9.986 0 0112 2c5.52 0 10 4.48 10 10 0 2.11-.66 4.07-1.77 5.68l-1.45-1.45A7.951 7.951 0 0020 12c0-4.41-3.59-8-8-8-1.55 0-3 .45-4.23 1.22L6.32 3.77zM18 12c0 1-.25 1.94-.68 2.77L9.23 6.68C10.06 6.25 11 6 12 6c3.31 0 6 2.69 6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f0ce0c937a839230(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.88 7.88l1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6zm1-6.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3a216a26fd29265d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.88 7.88l1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM7 5.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5zm5 .5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 9H9V9h2v6zm4 0h-2V9h2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$684bb8aae381199e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-1.19.22-2.32.6-3.38l1.88.68C4.17 10.14 4 11.05 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.95 0-1.85.17-2.69.48l-.68-1.89C9.69 2.22 10.82 2 12 2c5.52 0 10 4.48 10 10zM5.5 4C4.67 4 4 4.67 4 5.5S4.67 7 5.5 7 7 6.33 7 5.5 6.33 4 5.5 4zM11 16V8H9v8h2zm4 0V8h-2v8h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6d6d969711748b6f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3fd3a38a7559d7c7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$14d87c4c5da263de(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM6.5 9H11c.55 0 1 .45 1 1v5h-1.5v-4.5h-1v3H8v-3H7V15H5.5v-5c0-.55.45-1 1-1zm9 6H14V9h3.5c.55 0 1 .45 1 1v2.5c0 .55-.45 1-1 1h-2V15zm0-3H17v-1.5h-1.5V12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f7b35d38609a9cbb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$988a72841a500d76(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.27 3L3 4.27l9 9v.28c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4v-1.73L19.73 21 21 19.73 4.27 3zM14 7h4V3h-6v5.18l2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$90cf0d6b31f11bfa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7A6.98 6.98 0 0014 16.06V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88a7 7 0 006.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$489f694b7f394614(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16.12a7 7 0 006.17-6.95c0-3.87-3.13-7-7-7s-7 3.13-7 7A6.98 6.98 0 0011 16.06V20H5v2h14v-2h-6v-3.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5c93c7ddde1f76f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4fc5a5b2abda9c58(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$11179239c0329fb1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10a2.5 2.5 0 002.5-2.5c0-.61-.23-1.2-.64-1.67a.528.528 0 01-.13-.33c0-.28.22-.5.5-.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9zm5.5 11c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm-3-4c-.83 0-1.5-.67-1.5-1.5S13.67 6 14.5 6s1.5.67 1.5 1.5S15.33 9 14.5 9zM5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S7.33 13 6.5 13 5 12.33 5 11.5zm6-4c0 .83-.67 1.5-1.5 1.5S8 8.33 8 7.5 8.67 6 9.5 6s1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1be993f697792b3c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d74a09e7478fceb9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7s-6.18-.55-9.12-1.64A.94.94 0 002.57 4c-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64s6.18.55 9.12 1.64c.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ff196dab1554dae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64A.94.94 0 002.57 4c-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee1313cab4c595e1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.49 8.51c-.47-.23-.93-.44-1.4-.64C19.52 4.41 16.05 2 12 2S4.47 4.41 2.9 7.88c-.47.2-.93.41-1.4.63-.31.15-.5.48-.5.83v5.32c0 .35.19.68.51.83.47.23.93.44 1.39.64 3.55 7.83 14.65 7.82 18.2 0 .47-.2.93-.41 1.39-.63.31-.17.51-.49.51-.84V9.34a.91.91 0 00-.51-.83zM12 3.8c2.6 0 4.91 1.23 6.41 3.12-4.1-1.19-8.48-1.26-12.83.01C7.08 5.03 9.4 3.8 12 3.8zM5.6 17.08c4.19 1.22 8.57 1.23 12.82-.01a8.136 8.136 0 01-12.82.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2cee2512bcc3e725(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.4 11.32v2.93c-.1.05-2.17.85-3.33 1.17-.94.26-3.84.73-6.07.73-3.7 0-7-.7-9.16-1.8-.08-.04-.16-.06-.24-.1V9.76c6.02-2.84 12.6-2.92 18.8 0v1.56zm-9.39 8.88c-2.5 0-4.87-1.15-6.41-3.12 4.19 1.22 8.57 1.23 12.82-.01a8.136 8.136 0 01-6.41 3.13zM12 3.8c2.6 0 4.91 1.23 6.41 3.12-4.1-1.19-8.48-1.26-12.83.01C7.08 5.03 9.4 3.8 12 3.8zm10.49 4.71c-.47-.23-.93-.44-1.4-.64C19.52 4.41 16.05 2 12 2S4.47 4.41 2.9 7.88c-.47.2-.93.41-1.4.63-.31.15-.5.48-.5.83v5.32c0 .35.19.68.51.83.47.23.93.44 1.39.64 3.55 7.83 14.65 7.82 18.2 0 .47-.2.93-.41 1.39-.63.31-.17.51-.49.51-.84V9.34a.91.91 0 00-.51-.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$610ef9eff8321bf4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.93 21.12c-1.1-2.94-1.64-6.03-1.64-9.12s.55-6.18 1.64-9.12c.05-.11.07-.22.07-.31 0-.34-.24-.57-.64-.57H4.62c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.7 8.91 5.7 12s-.55 6.18-1.64 9.12c-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57 0-.1-.02-.2-.07-.31z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ddd86bc5cb428c6a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12a.94.94 0 00.06-.31c0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c304e0ca58f38a64(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$652e4cd728a4d4a0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c2.45 0 4.71.2 7.29.64A21 21 0 0120 12a21 21 0 01-.71 5.36c-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64A21 21 0 014 12a21 21 0 01.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d3ed45e85cc3addd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7fcb96b4c3a69614(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 2h5v7l-2.5-1.5L11 11V4zM7 18l2.38-3.17L11 17l2.62-3.5L17 18H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84e210d8e1846062(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h3.17L9 3h6l1.83 2H20zm0 14V7H4v12h16zm-6-7l-3 3.72L9 13l-3 4h12l-4-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0b9d4502275e35a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48l4-3.98v11l-4-3.98V18c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v4.48zm-2-.79V6H4v12h12V9.69zM10 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0 1c1.34 0 4 .67 4 2v1H6v-1c0-1.33 2.66-2 4-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c4921e243773f468(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3.2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$96cada81b016372(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f28c6232c6fe81d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$472e74da06ce66a5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2cb39a99edbc9691(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c8ce3753e0e7294d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm24 24H0V0h24v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$42558a2a6ec350e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9eb9f83d0719ec9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$23a25dc75eb569cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b08e6de006138829(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.15 14.32l.59-2.36.76 3.04h1.48l1.5-6h-1.5l-.74 3-.74-3h-1.52l-.74 3-.74-3H14l.72 2.9zM1.39 4.22L6.17 9H3v6h1.5v-2h1.1l.9 2H8l-.9-2.1c.5-.3.9-.8.9-1.4v-.67l1.43 1.43L8.75 15h1.5l.38-1.5h.04l9.11 9.11 1.41-1.41L2.81 2.81 1.39 4.22zM6.5 11.5h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bcbe0d68232b3ca8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 9H3v6h1.5v-2h1.1l.9 2H8l-.9-2.1c.5-.3.9-.8.9-1.4v-1C8 9.7 7.3 9 6.5 9zm0 2.5h-2v-1h2v1zM10.25 9l-1.5 6h1.5l.38-1.5h1.75l.37 1.5h1.5l-1.5-6h-2.5zm.75 3l.25-1h.5l.25 1h-1zM19.98 9l-.74 3-.74-3h-1.52l-.74 3-.74-3H14l1.5 6h1.48l.76-3.04.76 3.04h1.48l1.5-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc7c1c0dd452026a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2v14H3v3c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V2l-1.5 1.5zM19 19c0 .55-.45 1-1 1s-1-.45-1-1v-3H8V5h11v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7h6v2H9zM16 7h2v2h-2zM9 10h6v2H9zM16 10h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b11c26fc08e8cebd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f683ee499ef8d4ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26A8.95 8.95 0 0013 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05a7.007 7.007 0 010 9.9 6.973 6.973 0 01-7.79 1.44l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64a8.98 8.98 0 000-12.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16bb092440342431(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.64 19.37c3.03 3.03 7.67 3.44 11.15 1.25l-1.46-1.46c-2.66 1.43-6.04 1.03-8.28-1.21a7.007 7.007 0 010-9.9C7.42 6.69 9.21 6.03 11 6.03V9l4-4-4-4v3.01c-2.3 0-4.61.87-6.36 2.63-3.52 3.51-3.52 9.21 0 12.73zM11 13l6 6 6-6-6-6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc58cb8998b5808a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$99e27d588e842348(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11a7.906 7.906 0 00-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bde9738978d432e9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 1H9v2h6V1zm4.03 6.39l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a8.994 8.994 0 007.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-.32-5H6.35a5.992 5.992 0 003.41 3.56l-.11-.06 2.03-3.5zm5.97-4a6.012 6.012 0 00-3.34-3.54L12.26 11h5.39zm-7.04 7.83c.45.11.91.17 1.39.17 1.34 0 2.57-.45 3.57-1.19l-2.11-3.9-2.85 4.92zM7.55 8.99A5.965 5.965 0 006 13c0 .34.04.67.09 1h4.72L7.55 8.99zm8.79 8.14A5.94 5.94 0 0018 13c0-.34-.04-.67-.09-1h-4.34l2.77 5.13zm-3.01-9.98C12.9 7.06 12.46 7 12 7c-1.4 0-2.69.49-3.71 1.29l2.32 3.56 2.72-4.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aad5ab57902b3b47(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4faf2305db92085e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ecf2c042f8800897(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98a2.013 2.013 0 00-1.81-1.23c-.26 0-.53.04-.79.15L7.1 5.95a1.999 1.999 0 00-1.08 2.6l4.96 11.97a1.998 1.998 0 002.6 1.08l7.36-3.05a1.994 1.994 0 001.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9b36368514152e11(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a898d5d8d8fe571(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a52b941bf9a57470(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3f67c7bc70c819f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$901f166d3d0efd33(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12V6c0-1.66-1.34-3-3-3S5 4.34 5 6v6c-1.21.91-2 2.37-2 4 0 1.12.38 2.14 1 2.97V19h.02c.91 1.21 2.35 2 3.98 2s3.06-.79 3.98-2H12v-.03c.62-.83 1-1.85 1-2.97 0-1.63-.79-3.09-2-4zm-6 4c0-.94.45-1.84 1.2-2.4L7 13V6c0-.55.45-1 1-1s1 .45 1 1v7l.8.6c.75.57 1.2 1.46 1.2 2.4H5zM18.62 4h-1.61l-3.38 9h1.56l.81-2.3h3.63l.8 2.3H22l-3.38-9zm-2.15 5.39l1.31-3.72h.08l1.31 3.72h-2.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$552ffbb8aaf5ff25(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 7.76A5.974 5.974 0 0012 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0a5.99 5.99 0 00-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c56f274abe170ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38a6.64 6.64 0 01-.87-.23 2.61 2.61 0 01-.55-.25.717.717 0 01-.28-.3.978.978 0 01.01-.8c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95a2.517 2.517 0 00-.93-1.97c-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24a1.333 1.333 0 01-.59-1.11h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b1cf9ad4a891738b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.61 12.97c-.16-.24-.36-.46-.62-.65a3.38 3.38 0 00-.93-.48c.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38a6.64 6.64 0 01-.87-.23 2.61 2.61 0 01-.55-.25.717.717 0 01-.28-.3c-.05-.11-.08-.24-.08-.39a.946.946 0 01.36-.75c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95a2.517 2.517 0 00-.93-1.97c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24a1.333 1.333 0 01-.59-1.11h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d47afe4794cb3479(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1h6v2H9zM13 8v2.17l6.98 6.98a8.963 8.963 0 00-.95-9.76l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42a8.962 8.962 0 00-9.77-.96L10.83 8H13zM2.81 2.81L1.39 4.22l3.4 3.4a8.994 8.994 0 0012.59 12.59l2.4 2.4 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a6f12773f0f9b3e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1h6v2H9zM19.03 7.39l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012 4a9 9 0 00-9 9c0 4.97 4.02 9 9 9a8.994 8.994 0 007.03-14.61zM13 14h-2V8h2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$73be5bb3bab86bba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d4164ff060b7435d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$843ad8a38ddbaa5e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d458191b7a3649b8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM5 16l2.38-3.17L9 15l2.62-3.5L15 16H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7b336d8ab1b2e513(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM10 8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8H6v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0114 15.43V16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fd243cfd69db4b4f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h2.95l-2.33 8.73L16.82 18H4zm16 0h-2.95l2.34-8.73L7.18 6H20v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7fbc55049a906d26(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v7h20V4H2zm8 16h12v-7H10v7zm-8 0h6v-7H2v7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c1da4b1595344379(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h2.5v-2.5H4V18zm0-4.75h2.5v-2.5H4v2.5zM4 8.5h2.5V6H4v2.5zM17.5 6v2.5H20V6h-2.5zM13 8.5h2.5V6H13v2.5zm4.5 9.5H20v-2.5h-2.5V18zm0-4.75H20v-2.5h-2.5v2.5zM8.5 18H11v-2.5H8.5V18zm4.5 0h2.5v-2.5H13V18zM8.5 8.5H11V6H8.5v2.5zm4.5 4.75h2.5v-2.5H13v2.5zm-4.5 0H11v-2.5H8.5v2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4dfb25f2e555d32d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da1b63674b40dc5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.69 4.05C18.66 4.73 15.86 5.5 12 5.5c-3.89 0-6.95-.84-8.69-1.43A.993.993 0 002 5.02V19c0 .68.66 1.17 1.31.95C5.36 19.26 8.1 18.5 12 18.5c3.87 0 6.66.76 8.69 1.45A.999.999 0 0022 19V5c0-.68-.66-1.16-1.31-.95zM12 15c-2.34 0-4.52.15-6.52.41l3.69-4.42 2 2.4L14 10l4.51 5.4c-1.99-.25-4.21-.4-6.51-.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b32e7e5454183644(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1a23f009a3360968(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dcb30346231bfc9a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a1b92085af05ea9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c32fe0832a7e12eb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12v2.5l5.5 5.5H22zm0 8h3l-3-3zM8 4l-6 6h2v10h8V10h2L8 4zm1 10H7v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7c0c18acc0fd6062(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a1dee7de562c6d7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.954 8.66l2.12-2.12 1.415 1.414-2.13 2.12zM17.9 14c-.5-2.85-2.95-5-5.9-5s-5.45 2.15-5.9 5h11.8zM2 16h20v4H2zm9-12h2v3h-2zM3.54 7.925L4.954 6.51l2.122 2.122-1.415 1.415z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1711b40686458d94(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.955 8.662l2.12-2.122 1.416 1.414-2.121 2.122zM2 18h20v2H2zM11 4h2v3h-2zM3.543 7.925L4.957 6.51l2.121 2.12-1.414 1.415zM5 16h14c0-3.87-3.13-7-7-7s-7 3.13-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3411604917dad5e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7C6.48 7 2 9.24 2 12c0 2.24 2.94 4.13 7 4.77V20l4-4-4-4v2.73c-3.15-.56-5-1.9-5-2.73 0-1.06 3.04-3 8-3s8 1.94 8 3c0 .73-1.46 1.89-4 2.53v2.05c3.53-.77 6-2.53 6-4.58 0-2.76-4.48-5-10-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb4934cf9d19d761(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17h2v-3h1v-2l-1-5H2l-1 5v2h1v6h9v-6h4v3zm-6 1H4v-4h5v4zM2 4h15v2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e77f5b000685c34(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 1v3h3v2h-3v3h-2V6h-3V4h3V1h2zm-8 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2-9.75V7h3v3h2.92c.05.39.08.79.08 1.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 6.22 7.8 3 12 3c.68 0 1.35.08 2 .25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f4103b3981d51470(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7a98795a9a925155(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2zM18 4h2v9h-2zM4 4h2v16H4zM11 4h2v4h-2zM11 10h2v4h-2zM11 16h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91461c1a504836bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 12c.93 0 1.78.28 2.5.76V8c0-1.1-.9-2-2-2h-6.29l-1.06-1.06 1.41-1.41-.71-.71-3.53 3.53.71.71 1.41-1.41L13 6.71V9c0 1.1-.9 2-2 2h-.54A5.98 5.98 0 0112 15c0 .34-.04.67-.09 1h3.14c.25-2.25 2.14-4 4.45-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM4 9h5c0-1.1-.9-2-2-2H4c-.55 0-1 .45-1 1s.45 1 1 1zM9.83 13.82l-.18-.47.93-.35a4.92 4.92 0 00-2.31-2.43l-.4.89-.46-.21.4-.9C7.26 10.13 6.64 10 6 10c-.53 0-1.04.11-1.52.26l.34.91-.47.18-.35-.93a4.92 4.92 0 00-2.43 2.31l.89.4-.21.46-.9-.4C1.13 13.74 1 14.36 1 15c0 .53.11 1.04.26 1.52l.91-.34.18.47-.93.35a4.92 4.92 0 002.31 2.43l.4-.89.46.21-.4.9c.55.22 1.17.35 1.81.35.53 0 1.04-.11 1.52-.26l-.34-.91.47-.18.35.93a4.92 4.92 0 002.43-2.31l-.89-.4.21-.46.9.4c.22-.55.35-1.17.35-1.81 0-.53-.11-1.04-.26-1.52l-.91.34zm-2.68 3.95c-1.53.63-3.29-.09-3.92-1.62-.63-1.53.09-3.29 1.62-3.92 1.53-.63 3.29.09 3.92 1.62.64 1.53-.09 3.29-1.62 3.92z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1efc2adb1b3d62f0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.21 9.21C15.93 10.78 13.45 13.3 13 17h2v2H9v-2h2c-.5-4.5-4.37-8-9-8V7c4.39 0 8.22 2.55 10 6.3 1.13-2.43 2.99-4.25 4.78-5.52L14 5h7v7l-2.79-2.79z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2702f7a99399358c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4L2 20h17l3-16h-9zm1.5 10a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$63401a78739b00a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.78 11.16l-1.42 1.42a7.282 7.282 0 01-1.79-2.94l1.94-.49c.32.89.77 1.5 1.27 2.01zM11 6L7 2 3 6h3.02c.02.81.08 1.54.19 2.17l1.94-.49C8.08 7.2 8.03 6.63 8.02 6H11zm10 0l-4-4-4 4h2.99c-.1 3.68-1.28 4.75-2.54 5.88-.5.44-1.01.92-1.45 1.55-.34-.49-.73-.88-1.13-1.24L9.46 13.6c.93.85 1.54 1.54 1.54 3.4v5h2v-5c0-2.02.71-2.66 1.79-3.63 1.38-1.24 3.08-2.78 3.2-7.37H21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$95e87e034b6c436a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9v1.5h2.25V15h1.5v-4.5H14V9zM6 9H3c-.55 0-1 .45-1 1v5h1.5v-1.5h2V15H7v-5c0-.55-.45-1-1-1zm-.5 3h-2v-1.5h2V12zM21 9h-4.5c-.55 0-1 .45-1 1v5H17v-4.5h1V14h1.5v-3.51h1V15H22v-5c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eed32d52cf6360cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.43 18.75c.37-.46.94-.75 1.57-.75.63 0 1.19.29 1.56.75.39-.09.76-.21 1.12-.36l-1.42-3.18a3.522 3.522 0 01-2.56-.02l-1.43 3.19c.38.16.76.29 1.16.37zM5.15 10a7.06 7.06 0 00.08 4c.63.05 1.22.4 1.56.99.33.57.35 1.23.11 1.79.27.27.56.53.87.76l1.52-3.39c-.47-.58-.75-1.32-.75-2.13 0-1.89 1.55-3.41 3.46-3.41s3.46 1.53 3.46 3.41c0 .82-.29 1.57-.78 2.16l1.5 3.35c.32-.24.62-.5.9-.79-.22-.55-.2-1.2.12-1.75.33-.57.9-.92 1.52-.99a7.025 7.025 0 00.09-4.02c-.64-.04-1.26-.39-1.6-1-.36-.62-.35-1.36-.03-1.95-.91-.98-2.1-1.71-3.44-2.05C13.39 5.6 12.74 6 12 6s-1.39-.41-1.74-1.01a7.053 7.053 0 00-3.44 2.03c.33.6.35 1.35-.02 1.98-.35.62-.99.97-1.65 1zm-1.3-.42c-.78-.6-1.02-1.7-.51-2.58.51-.88 1.58-1.23 2.49-.85a8.53 8.53 0 014.18-2.42C10.15 2.75 10.99 2 12 2s1.85.75 1.98 1.73c1.63.39 3.07 1.24 4.18 2.42a1.99 1.99 0 012.49.85c.51.88.27 1.98-.51 2.58.23.77.35 1.58.35 2.42s-.12 1.65-.35 2.42c.78.6 1.02 1.7.51 2.58-.51.88-1.58 1.23-2.49.85-.4.43-.85.81-1.34 1.15l1.34 3H16.3l-.97-2.17c-.43.18-.88.33-1.34.44-.14.98-.98 1.73-1.99 1.73s-1.85-.75-1.98-1.73c-.48-.12-.94-.27-1.38-.46L7.66 22H5.78l1.36-3.03a8.72 8.72 0 01-1.3-1.12c-.92.38-1.99.03-2.5-.85s-.27-1.98.51-2.58c-.23-.77-.35-1.58-.35-2.42s.12-1.65.35-2.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3282edd796a09f3e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM9 12c.83 0 1.5.67 1.5 1.5S9.83 15 9 15s-1.5-.67-1.5-1.5S8.17 12 9 12zm3 6H6v-.75c0-1 2-1.5 3-1.5s3 .5 3 1.5V18zm1-9h-2V4h2v5zm5 7.5h-4V15h4v1.5zm0-3h-4V12h4v1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e2bb797d1afae755(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.28 16.34L17.46 15s.32-.59.96-1.78a.944.944 0 011.6 0l.81 1.26c.19.3.21.68.06 1l-.22.47a.94.94 0 01-1.39.39zm-14.56 0a.946.946 0 01-1.39-.38l-.23-.47c-.15-.32-.13-.7.06-1l.81-1.26a.944.944 0 011.6 0c.65 1.18.97 1.77.97 1.77l-1.82 1.34zm10.64-6.97c.09-.68.73-1.06 1.27-.75l1.59.9c.46.26.63.91.36 1.41L16.5 15h-1.8l.66-5.63zm-6.73 0L9.3 15H7.5l-2.09-4.08c-.27-.5-.1-1.15.36-1.41l1.59-.9c.53-.3 1.18.08 1.27.76zM13.8 15h-3.6l-.74-6.88c-.07-.59.35-1.12.88-1.12h3.3c.53 0 .94.53.88 1.12L13.8 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe109af421ab7209(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$47751395f2d5d20b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14h.74L8.82 5.56A2.009 2.009 0 006.87 4H3v2h3.87l1.42 6.25h-.01A6.008 6.008 0 004.09 17H0v2h6v-1c0-2.21 1.79-4 4-4zM19 8h-.82l-1.35-3.69A1.976 1.976 0 0014.96 3H11v2h3.96l1.1 3H10.4l.46 2H15c-.43.58-.75 1.25-.9 2h-2.79l.46 2h2.33c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5C24 10.2 21.8 8 19 8zm0 8c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.03 0 .06-.01.09-.01 1.68 0 3 1.32 3 3s-1.33 3-3.01 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e627c574b7ea181(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 3H6C3.79 3 2 4.79 2 7c0 1.48.81 2.75 2 3.45V19c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8.55c1.19-.69 2-1.97 2-3.45 0-2.21-1.79-4-4-4zm-4 12h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$753ff2ba3d1f6464(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 8h2V4h-2v4zm-2.49 14H2.49c-.27 0-.49-.22-.49-.5V20h14v1.5c0 .28-.22.5-.49.5zM18 15.89l-.4-.42a5.852 5.852 0 01-1.6-4V2h6v9.51c0 1.46-.54 2.87-1.53 3.94l-.47.52V20h2v2h-4v-6.11zM7 16v-2h4v2h4.5c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-13c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16922e7e8f7822e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1a7 7 0 00-5.78 3.05l.02-.03C9.84 4 9.42 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V22a1 1 0 001 1h1a1 1 0 001-1v-1h8v1a1 1 0 001 1h1a1 1 0 001-1v-1.78c.61-.55 1-1.34 1-2.22v-3.08A7 7 0 0016 1zM4.5 19a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM3 13V8h6c0 1.96.81 3.73 2.11 5H3zm10.5 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm2.5-6a5 5 0 110-10 5 5 0 010 10zm-1-9h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4f15700e9d588127(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 6h-1V3h1v4zm0 1v1h-1V8h1zm-.59 5c.06.16.09.33.09.5 0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5c0-.39.15-.74.39-1.01A7.032 7.032 0 0111.68 9H5.81l1.04-3H11c0-.69.1-1.37.29-2H6.5c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-6.68c-1.05.51-2.16.69-3.09.68zM7.5 15c-.83 0-1.5-.67-1.5-1.5S6.67 12 7.5 12s1.5.67 1.5 1.5S8.33 15 7.5 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d3ac3cc22e2c5742(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.39 9H7.61c-.43 0-.81.28-.95.68l-1.66 5v6.81c0 .29.23.51.5.51h1c.28 0 .5-.22.5-.5V20h10v1.5c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5v-6.81l-1.66-5a1.01 1.01 0 00-.95-.69zm-8.61 9c-.68 0-1.22-.54-1.22-1.22s.54-1.22 1.22-1.22S9 16.11 9 16.78 8.46 18 7.78 18zm8.44 0c-.67 0-1.22-.54-1.22-1.22s.54-1.22 1.22-1.22 1.22.54 1.22 1.22S16.9 18 16.22 18zm-9.93-4l1.33-4h8.78l1.33 4H6.29zM10.83 3A3.01 3.01 0 008 1C6.34 1 5 2.34 5 4c0 1.65 1.34 3 3 3 1.3 0 2.41-.84 2.83-2H16v2h2V5h1V3h-8.17zM8 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ccbe51f68ee01496(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.22 12c.68 0 1.22-.54 1.22-1.22 0-.67-.54-1.22-1.22-1.22S15 10.11 15 10.78c0 .68.55 1.22 1.22 1.22zm-9.66-1.22c0 .67.54 1.22 1.22 1.22S9 11.46 9 10.78c0-.67-.54-1.22-1.22-1.22s-1.22.55-1.22 1.22zM7.61 4L6.28 8h11.43l-1.33-4H7.61zm8.67-1s.54.01.92.54c.02.02.03.04.05.07.07.11.14.24.19.4.22.65 1.56 4.68 1.56 4.68v6.5c0 .45-.35.81-.78.81h-.44c-.43 0-.78-.36-.78-.81V14H7v1.19c0 .45-.35.81-.78.81h-.44c-.43 0-.78-.36-.78-.81v-6.5S6.34 4.67 6.55 4c.05-.16.12-.28.19-.4.03-.02.04-.04.06-.06.38-.53.92-.54.92-.54h8.56zM4 17.01h16V19h-7v3h-2v-3H4v-1.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3273d8e0efb9258b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9v2h-2V3h-2v2h-2V3h-2v2h-2V3H9v2H7V3H5v8H3V9H1v12h9v-3c0-1.1.9-2 2-2s2 .9 2 2v3h9V9h-2zm-10 3H9V9h2v3zm4 0h-2V9h2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c2ec0d190051f423(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2l-5.5 9h11z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "17.5",
                    "r": "4.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13.5h8v8H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7807017451021fdf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22l14-5-9-9zM14.53 12.53l5.59-5.59a1.25 1.25 0 011.77 0l.59.59 1.06-1.06-.59-.59a2.758 2.758 0 00-3.89 0l-5.59 5.59 1.06 1.06zM10.06 6.88l-.59.59 1.06 1.06.59-.59a2.758 2.758 0 000-3.89l-.59-.59-1.06 1.07.59.59c.48.48.48 1.28 0 1.76zM17.06 11.88l-1.59 1.59 1.06 1.06 1.59-1.59a1.25 1.25 0 011.77 0l1.61 1.61 1.06-1.06-1.61-1.61a2.758 2.758 0 00-3.89 0zM15.06 5.88l-3.59 3.59 1.06 1.06 3.59-3.59a2.758 2.758 0 000-3.89l-1.59-1.59-1.06 1.06 1.59 1.59c.48.49.48 1.29 0 1.77z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa78bd02b66e8c7f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12.22V9l-5-2.5V5h2V3h-2V1h-2v2H9v2h2v1.5L6 9v3.22L2 14v8h8v-3c0-1.1.9-2 2-2s2 .9 2 2v3h8v-8l-4-1.78zm-6 1.28c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af7683c9348b9506(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11h-1V3c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v8H8c-2.76 0-5 2.24-5 5v7h18v-7c0-2.76-2.24-5-5-5zm3 10h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H9v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H5v-5c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$791aca66939ec050(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "17",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.07c1.95 0 3.72.79 5 2.07l5-5C19.44 4.59 15.9 3 12 3S4.56 4.59 2 7.15l5 5a7.06 7.06 0 015-2.08z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b47c0635ca21edd8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4 17l1.3 4.4h-1.1L13 17h-3c-.55 0-1-.45-1-1s.45-1 1-1h3l2.6-4.4h1.1L15.4 15h2.85l.75-1h1l-.6 2 .6 2h-1l-.75-1H15.4zM5.75 7L5 6H4l.6 2-.6 2h1l.75-1H8.6l-1.3 4.4h1.1L11 9h3c.55 0 1-.45 1-1s-.45-1-1-1h-3L8.4 2.6H7.3L8.6 7H5.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ea1e3a411f099e23(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2.5c0 1.5-1.5 6-1.5 6h-2S9.5 4 9.5 2.5a2.5 2.5 0 015 0zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4.08-4.89c.18-.75.33-1.47.39-2.06A9.996 9.996 0 0122 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-3.92 2.25-7.31 5.53-8.95.07.59.21 1.32.39 2.06A8.028 8.028 0 004 12c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.93-1.58-5.49-3.92-6.89zM18 12c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2 .98-3.77 2.48-4.86.23.81.65 2.07.65 2.07C8.43 9.93 8 10.92 8 12c0 2.21 1.79 4 4 4s4-1.79 4-4c0-1.08-.43-2.07-1.13-2.79 0 0 .41-1.22.65-2.07A5.998 5.998 0 0118 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e434a94e2778a68d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 14H10V9H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 10.35V7zM7 17c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6h5v2H5zM19 13c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$73a307373d765e88(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1c-2.4 0-4.52 1.21-5.78 3.05.01-.01.01-.02.02-.03C9.84 4 9.42 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V22c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22v-3.08c3.39-.49 6-3.39 6-6.92 0-3.87-3.13-7-7-7zM4.5 19c-.83 0-1.5-.67-1.5-1.5S3.67 16 4.5 16s1.5.67 1.5 1.5S5.33 19 4.5 19zM3 13V8h6c0 1.96.81 3.73 2.11 5H3zm10.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2.5-6c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm.5-9H15v5l3.62 2.16.75-1.23-2.87-1.68z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f799d719ae2f60d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 11.51l1.57-1.57-3.75-3.75-1.57 1.57-4.14-4.13c-.78-.78-2.05-.78-2.83 0l-1.9 1.9c-.78.78-.78 2.05 0 2.83l4.13 4.13L3 17.25V21h3.75l4.76-4.76 4.13 4.13c.95.95 2.23.6 2.83 0l1.9-1.9c.78-.78.78-2.05 0-2.83l-4.13-4.13zm-7.06-.44L5.04 6.94l1.89-1.9L8.2 6.31 7.02 7.5l1.41 1.41 1.19-1.19 1.45 1.45-1.89 1.9zm7.88 7.89l-4.13-4.13 1.9-1.9 1.45 1.45-1.19 1.19 1.41 1.41 1.19-1.19 1.27 1.27-1.9 1.9zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34c-.47-.47-1.12-.29-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e83187b1b43074d3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.16 3h-.32L9.21 8.25h5.58zM16.46 8.25h5.16L19 3h-5.16zM21.38 9.75h-8.63V20.1zM11.25 20.1V9.75H2.62zM7.54 8.25L10.16 3H5L2.38 8.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$58781b624ed29a98(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19h20l-2 2H4l-2-2zM5 6h1v1H5V6zm0-2h1v1H5V4zm4 0v1H7V4h2zm0 3H7V6h2v1zm-3 8.23c-.36.11-.69.28-1 .47V8h1v7.23zm-2 1.29c-.38.44-.68.93-.84 1.48h16.82c.01-.16.03-.33.03-.5a5.497 5.497 0 00-10.58-2.1c-.59-.25-1.24-.4-1.93-.4-.17 0-.33.02-.5.04V8h2c1.03.06 1.9-.96 2-2h10V5H11c-.1-1.05-.97-1.97-2-2H3v1h1v1H3v1h1v1H3v1h1v8.52z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d74336521ab089a2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$65c8c87c3011c1de(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99a8.752 8.752 0 008 0c1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.9-6.68c.11-.37.04-1.06-.66-1.28L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.63.19-.81.84-.66 1.28L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c8f1312a41fd697(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99a8.752 8.752 0 008 0c1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42a1.007 1.007 0 00-.66 1.28L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7069641e46b84a9f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5c0 .95.38 1.81 1 2.44V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-2.06c.62-.63 1-1.49 1-2.44V6c0-3.5-3.58-4-8-4zM8.5 16c-.83 0-1.5-.67-1.5-1.5S7.67 13 8.5 13s1.5.67 1.5 1.5S9.33 16 8.5 16zm7 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2.5-6H6V7h12v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$395d6422208687d1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd2443b46502cda1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM7.5 16c-.83 0-1.5-.67-1.5-1.5S6.67 13 7.5 13s1.5.67 1.5 1.5S8.33 16 7.5 16zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5.81 10l1.04-3h10.29l1.04 3H5.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db3c1bc8e9c0a054(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3cc2fe67e2604cc1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm0 14c-.83 0-1.5-.67-1.5-1.5S11.17 13 12 13s1.5.67 1.5 1.5S12.83 16 12 16zm6-6H6V7h12v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cf846fe6e1187e39(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$beb21bb18bba0460(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8821cb2106544285(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM8.5 16c-.83 0-1.5-.67-1.5-1.5S7.67 13 8.5 13s1.5.67 1.5 1.5S9.33 16 8.5 16zm2.5-6H6V7h5v3zm4.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2.5-6h-5V7h5v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$297f65d14363f00d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$42dc18ed112f5385(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM8.5 16c-.83 0-1.5-.67-1.5-1.5S7.67 13 8.5 13s1.5.67 1.5 1.5S9.33 16 8.5 16zm2.5-6H6V7h5v3zm4.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2.5-6h-5V7h5v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4bd15c148daa92f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3e323643a387ddb8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1689b940b904835f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 10.59l-7.99-8c-.78-.78-2.05-.78-2.83 0l-8.01 8c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0l7.99-8c.79-.79.79-2.05 0-2.83zM13.5 14.5V12H10v3H8v-4c0-.55.45-1 1-1h4.5V7.5L17 11l-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af0f785fa4904bf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.56 11.36L13 8.44V7c0-.55-.45-1-1-1s-1-.45-1-1 .45-1 1-1 1 .45 1 1h2c0-1.84-1.66-3.3-3.56-2.95-1.18.22-2.15 1.17-2.38 2.35-.3 1.56.6 2.94 1.94 3.42v.63l-6.56 2.92c-.88.38-1.44 1.25-1.44 2.2v.01C3 14.92 4.08 16 5.42 16H7v6h10v-6h1.58c1.34 0 2.42-1.08 2.42-2.42v-.01c0-.95-.56-1.82-1.44-2.21zM18.58 14H17v-1H7v1H5.42c-.23 0-.42-.19-.42-.43 0-.17.1-.32.25-.38l6.75-3 6.75 3a.423.423 0 01-.17.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$45eb16aacda3cd00(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.63 7H6.37C3.96 7 2 9.24 2 12s1.96 5 4.37 5h11.26c2.41 0 4.37-2.24 4.37-5s-1.96-5-4.37-5zM7.24 14.46l-2.57-2.57.7-.7 1.87 1.87 3.52-3.52.7.7-4.22 4.22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d962a1297c5991c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.95 13H9V8.05l5.61-5.61A8.17 8.17 0 0012 2c-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8 0-1.01-.16-1.94-.45-2.8l-5.6 5.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11h2.12l6.16-6.16-2.12-2.12L11 8.88zM20.71 2L20 1.29c-.2-.19-.45-.29-.71-.29-.13 0-.48.07-.71.29l-.72.72 2.12 2.12.72-.72c.4-.39.4-1.02.01-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a99513e5160e19bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7a.38.38 0 01.54 0l.9.9c.15.15.15.39 0 .54z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3f0bdcf17c490e1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h-2v7.9l2-2zM4 4h2v16H4zM10 4h2v4h-2zM10 10h2v4h-2zM10 16h2v4h-2zM22.56 12.59l-1.15-1.15a1.49 1.49 0 00-2.12 0L14 16.73V20h3.27l5.29-5.29c.59-.59.59-1.54 0-2.12zm-5.98 5.86h-1.03v-1.03L19 13.97 20.03 15l-3.45 3.45z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e22400e90390d1b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9c-2-2-3.01-7-9.03-7C4.95 2 1.94 6 2 11.52 2.06 17.04 6.96 19 9.97 19c2.01 0 2.01 3 6.02 3C19 22 22 19 22 15.02 22 12 21.01 11 19 9zm-7 6.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e990b2bc7980d37(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C8.5 3 5 9.33 5 14c0 3.87 3.13 7 7 7s7-3.13 7-7c0-4.67-3.5-11-7-11zm1 15c-3 0-5-1.99-5-5 0-.55.45-1 1-1s1 .45 1 1c0 2.92 2.42 3 3 3 .55 0 1 .45 1 1s-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c13db81d4b35646(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-.82l-1.7-4.68A2.008 2.008 0 0014.6 1H12v2h2.6l1.46 4h-4.81l-.36-1H12V4H7v2h1.75l1.82 5H9.9c-.44-2.23-2.31-3.88-4.65-3.99C2.45 6.87 0 9.2 0 12c0 2.8 2.2 5 5 5 2.46 0 4.45-1.69 4.9-4h4.2c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5C24 9.2 21.8 7 19 7zM7.82 13c-.4 1.17-1.49 2-2.82 2-1.68 0-3-1.32-3-3s1.32-3 3-3c1.33 0 2.42.83 2.82 2H5v2h2.82zm6.28-2h-1.4l-.73-2H15c-.44.58-.76 1.25-.9 2zm4.9 4c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.02 0 .05-.01.08-.01 1.68 0 3 1.32 3 3s-1.32 3-3 3zM11 20H7l6 3v-2h4l-6-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6f30ef901ccecc75(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 2.01C18.72 1.42 18.16 1 17.5 1h-11c-.66 0-1.21.42-1.42 1.01L3 8v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8l-2.08-5.99zM6.5 12c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm11 0c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 7l1.5-4.5h11L19 7H5zM7 20h4v-2l6 3h-4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$777d52b28884d97b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 12H10V7H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 8.35V5zM7 15c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4h5v2H5zM19 11c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM7 20h4v-2l6 3h-4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$53d655b34bbe4af6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.18V9.72c0-.47-.16-.92-.46-1.28L16.6 3.72c-.38-.46-.94-.72-1.54-.72H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h.18C3.6 16.16 4.7 17 6 17s2.4-.84 2.82-2h8.37a2.996 2.996 0 005.82-1c-.01-1.3-.85-2.4-2.01-2.82zM18.4 9H16V6.12L18.4 9zM3 5h4v4H3V5zm3 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3-2v-2h3V9H9V5h5v8H9zm11 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM7 20h4v-2l6 3h-4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$218d5eeebcecc0ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.82 16H15v-1c0-2.21 1.79-4 4-4h.74l-1.9-8.44A2.009 2.009 0 0015.89 1H12v2h3.89l1.4 6.25h-.01A6.008 6.008 0 0013.09 14H7.82a2.996 2.996 0 00-3.42-1.94c-1.18.23-2.13 1.2-2.35 2.38A3.002 3.002 0 005 18c1.3 0 2.4-.84 2.82-2zM5 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM11 20H7l6 3v-2h4l-6-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7c26c7deb295f11a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14c0-.55-.45-1-1-1h-2v2h2c.55 0 1-.45 1-1zM20 17h-2v2h2c.55 0 1-.45 1-1s-.45-1-1-1zM12 14h-2v4h2c0 1.1.9 2 2 2h3v-8h-3c-1.1 0-2 .9-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13c0-1.1.9-2 2-2h1.5c1.93 0 3.5-1.57 3.5-3.5S10.43 4 8.5 4H5c-.55 0-1 .45-1 1s.45 1 1 1h3.5c.83 0 1.5.67 1.5 1.5S9.33 9 8.5 9H7c-2.21 0-4 1.79-4 4s1.79 4 4 4h2v-2H7c-1.1 0-2-.9-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$890ccf583dc253be(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM12 12l3 1.73-1 1.73-3-1.73V17H9v-3.27l-3 1.73-1-1.73L8 12l-3-1.73 1-1.73 3 1.73V7h2v3.27l3-1.73 1 1.73L12 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bb42d30086bbb788(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c-3.15 0-6 2.41-6 6.15 0 2.49 2 5.44 6 8.85 4-3.41 6-6.36 6-8.85C18 11.41 15.15 9 12 9zm0 7.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM12 4c1.93 0 3.68.78 4.95 2.05l-1.41 1.41a5.022 5.022 0 00-7.08 0L7.05 6.05A6.976 6.976 0 0112 4zm7.78-.77l-1.41 1.41C16.74 3.01 14.49 2 12.01 2S7.27 3.01 5.64 4.63L4.22 3.22C6.22 1.23 8.97 0 12.01 0s5.78 1.23 7.77 3.23z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$89cbd114534a9127(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.79 9.23l-2-3.46L14 8.54V3h-4v5.54L5.21 5.77l-2 3.46L8 12l-4.79 2.77 2 3.46L10 15.46V21h4v-5.54l4.79 2.77 2-3.46L16 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$72b9de1c5abb75f5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 002.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 005 0V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3d095269dfba10a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10v12H2V10l7-3v2l5-2v3h8zm-4.8-1.5L18 2h3l.8 6.5h-4.6zM11 18h2v-4h-2v4zm-4 0h2v-4H7v4zm10-4h-2v4h2v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e995193b7789e8bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.06 22.99h1.66c.84 0 1.53-.64 1.63-1.46L23 5.05h-5V1h-1.97v4.05h-4.97l.3 2.34c1.71.47 3.31 1.32 4.27 2.26 1.44 1.42 2.43 2.89 2.43 5.29v8.05zM1 21.99V21h15.03v.99c0 .55-.45 1-1.01 1H2.01c-.56 0-1.01-.45-1.01-1zm15.03-7c0-8-15.03-8-15.03 0h15.03zM1.02 17h15v2h-15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e629d7ff1e1aff7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.7V4h3l-1-1.49L16 1h-5v4.7L2 12v10h7v-5l3.03-2L15 17v5h7V12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e7bcfcfd28f744f7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-1V8h2V6h-2.35a5.99 5.99 0 00-11.3 0H4v2h2v3H5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v3H4v2h16v-2h-2v-3h1c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm-7 6.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$895c69e762718647(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.9 10.69l-1.44-4.32A2.01 2.01 0 0019.56 5H19V4c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1h-2c-1.1 0-2 .9-2 2v4H1v5c0 1.1.9 2 2 2h1c0 1.66 1.34 3 3 3s3-1.34 3-3h4c0 1.66 1.34 3 3 3s3-1.34 3-3h3v-6.68c0-.21-.03-.42-.1-.63zM7 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm10 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-3-8V7h5.56l1.33 4H14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.5h-1v-2h1V5H1v1.5h1v2H1V10h10V8.5zm-5.75 0H3.5v-2h1.75v2zm3.25 0H6.75v-2H8.5v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dfd6405a017bbf88(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h-2c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM9.5 16H18v2H9.49c-.88 0-1.66-.58-1.92-1.43L5 8V4h2v4l2.5 8zM8 19h10v2H8v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5d904aabc29d04c0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1985d327ebfcd4ff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12L9 2 2 12h1.86L0 18h7v4h4v-4h7l-3.86-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.14 12H22L15 2l-2.39 3.41L17.92 13h-1.95l3.22 5H24zM13 19h4v3h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$43f53dc030ac933a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.41 15.59L8 17l-4-4 4-4 1.41 1.41L7.83 12c1.51-.33 3.73.08 5.17 1.36V6.83l-1.59 1.59L10 7l4-4 4 4-1.41 1.41L15 6.83V21h-2v-4c-.73-2.58-3.07-3.47-5.17-3l1.58 1.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa0bad340395ef3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 15.59L16 17l4-4-4-4-1.41 1.41L16.17 12c-1.51-.33-3.73.08-5.17 1.36V6.83l1.59 1.59L14 7l-4-4-4 4 1.41 1.41L9 6.83V21h2v-4c.73-2.58 3.07-3.47 5.17-3l-1.58 1.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$38adcb8963374e6e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3v2h-2V3h-2v2h-2V3h-2v4l2 2v1H9V9l2-2V3H9v2H7V3H5v2H3V3H1v4l2 2v6l-2 2v4h9v-3c0-1.1.9-2 2-2s2 .9 2 2v3h9v-4l-2-2V9l2-2V3h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4a06bd70d75cd5c0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm5-4h2v.4c-.1 2.2-.8 3.9-2.3 5.1-.5.4-1.1.7-1.7.9V22h-2v-6h-2v6H9V10.1c-.3.1-.5.2-.6.3-.9.7-1.39 1.6-1.4 3.1v.5H5v-.5c0-2 .71-3.59 2.11-4.79C8.21 7.81 10 7 12 7s2.68-.46 3.48-1.06C16.48 5.14 17 4 17 2.5V2zM4 16h3v6H4v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4338abe1d5012d5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.67 18.17l-5.3-5.3h-.99l-2.54 2.54v.99l5.3 5.3c.39.39 1.02.39 1.41 0l2.12-2.12a.996.996 0 000-1.41z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 10.19l1.41-1.41 2.12 2.12a3 3 0 000-4.24l-3.54-3.54-1.41 1.41V1.71l-.7-.71-3.54 3.54.71.71h2.83l-1.41 1.41 1.06 1.06-2.89 2.89-4.13-4.13V5.06L4.83 2.04 2 4.87 5.03 7.9h1.41l4.13 4.13-.85.85H7.6l-5.3 5.3a.996.996 0 000 1.41l2.12 2.12c.39.39 1.02.39 1.41 0l5.3-5.3v-2.12l5.15-5.15 1.06 1.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1d0c760bf0cd0d65(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3l-3 3V3H9C6.24 3 4 5.24 4 8h5v3h6V8l3 3h2V3h-2zM9 13v7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-7H9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b758f69d96d79897(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16h-2v-1H8v1H6v-1H2v5h20v-5h-4zM20 8h-3V6c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v4h4v-2h2v2h8v-2h2v2h4v-4c0-1.1-.9-2-2-2zm-5 0H9V6h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f56b38ac7db84ead(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$21e7c8570d14e54c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c1.01 0 1.91-.39 2.62-1H9.38c.71.61 1.61 1 2.62 1zM8.56 14h6.89c.26-.45.44-.96.51-1.5h-7.9c.06.54.23 1.05.5 1.5zM12 8c-1.01 0-1.91.39-2.62 1h5.24c-.71-.61-1.61-1-2.62-1zM8.56 10c-.26.45-.44.96-.51 1.5h7.9c-.07-.54-.24-1.05-.51-1.5H8.56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8d26dd3c498054d6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.79 12.4l3.26 6.22 3.17-6.21c-.11-.08-.21-.16-.3-.25-.84.53-1.85.84-2.92.84s-2.08-.31-2.92-.84c-.09.09-.19.17-.29.24zm-1.96.59A2.995 2.995 0 014 10a3 3 0 012.52-2.96C6.75 4.22 9.12 2 12 2s5.25 2.22 5.48 5.04A3 3 0 0120 10c0 1.59-1.24 2.9-2.81 2.99L12.07 23 6.83 12.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c34e783a3edd288f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75 8H11v5H7.75v1h.75a2.5 2.5 0 010 5h-.75v4h-1.5v-4H5.5a2.5 2.5 0 010-5h.75v-1H3V8h3.25V7H5.5a2.5 2.5 0 010-5h.75V1h1.5v1h.75a2.5 2.5 0 010 5h-.75v1zm10-1h.75a2.5 2.5 0 000-5h-.75V1h-1.5v1h-.75a2.5 2.5 0 000 5h.75v1H13v5h3.25v1h-.75a2.5 2.5 0 000 5h.75v4h1.5v-4h.75a2.5 2.5 0 000-5h-.75v-1H21V8h-3.25V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85541aef501de737(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1656ffb6af726f6a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2820a38566cd3f06(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14c0 1.3.84 2.4 2 2.82V20H3v2h6v-2H7v-3.18C8.16 16.4 9 15.3 9 14V6H3v8zm2-6h2v3H5V8zM20.63 8.54l-.95-.32a.991.991 0 01-.68-.94V3c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4.28c0 .43-.28.81-.68.95l-.95.32c-.82.27-1.37 1.03-1.37 1.89V20c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2v-9.56c0-.86-.55-1.62-1.37-1.9zM16 4h1v1h-1V4zm-3 6.44l.95-.32C15.18 9.72 16 8.57 16 7.28V7h1v.28a3 3 0 002.05 2.85l.95.31V12h-7v-1.56zM20 20h-7v-2h7v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a0c830341887f67(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3f7fca782cded4a7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5bdb4bd5eac0c0b8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c4427191d987d246(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7bb68a6a78e01483(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 002-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$78b0363ec4b2ba1e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$34310eb660cad4f8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a36bbf6fcf0a628c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 000 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$68a0249e1437c33c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e9f42455d62222b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.9l-2.13 2.09c-.56.56-.87 1.29-.87 2.07C9 18.68 10.35 20 12 20s3-1.32 3-2.94c0-.78-.31-1.52-.87-2.07L12 12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6l-.44.55C14.38 8.02 12 7.19 12 5.3V2S4 6 4 13c0 2.92 1.56 5.47 3.89 6.86-.56-.79-.89-1.76-.89-2.8 0-1.32.52-2.56 1.47-3.5L12 10.1l3.53 3.47c.95.93 1.47 2.17 1.47 3.5 0 1.02-.31 1.96-.85 2.75 1.89-1.15 3.29-3.06 3.71-5.3.66-3.55-1.07-6.9-3.86-8.52z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$debbcf39c7f823e0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a9 9 0 009-9 9 9 0 00-9 9zM5.6 10.25a2.5 2.5 0 003.92 2.06l-.02.19a2.5 2.5 0 005 0l-.02-.19c.4.28.89.44 1.42.44a2.5 2.5 0 002.5-2.5c0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25a2.5 2.5 0 00-3.92-2.06l.02-.19a2.5 2.5 0 00-5 0l.02.19c-.4-.28-.89-.44-1.42-.44a2.5 2.5 0 00-2.5 2.5c0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5a2.5 2.5 0 010 5 2.5 2.5 0 010-5zM3 13a9 9 0 009 9 9 9 0 00-9-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$605a2ed9a91b628e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 002.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 005 0V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$810daca4cc8f286f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a5e92cd79bcc25e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2f970905c2907bb2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$71811598ae0cb657(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 16.83a4.008 4.008 0 005.66 0 4.008 4.008 0 000-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c23ac94f99a5a147(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9bdc02da69970123(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$620bd6c314485b64(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b956e8353c27ca94(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc55069c22db0459(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dc4281fb16248250(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f4cd46cdc4e621d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc55ac5af7c18973(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2b6b0ec4ac35d535(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c8722d77446e872e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm2.5 11.59l.9 3.88-3.4-2.05-3.4 2.05.9-3.87-3-2.59 3.96-.34L12 6.02l1.54 3.64 3.96.34-3 2.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a31185db96026868(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$40b94a52c58e0b50(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4749fa1e88980571(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3.2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee33265d5ed162b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f9c66bec0faa903a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f2ef2ccbac31d7d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.13 2 5 5.13 5 9c0 1.74.5 3.37 1.41 4.84.95 1.54 2.2 2.86 3.16 4.4.47.75.81 1.45 1.17 2.26.26.55.47 1.5 1.26 1.5s1-.95 1.25-1.5c.37-.81.7-1.51 1.17-2.26.96-1.53 2.21-2.85 3.16-4.4C18.5 12.37 19 10.74 19 9c0-3.87-3.13-7-7-7zm0 9.75a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b2858e435b5e585(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M22 10c.32-3.28-4.28-6-9.99-6S1.7 6.72 2.02 10H22zM5.35 13.5c.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.63 2.17.64v-1.98s-.79-.16-1.16-.38c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.21-.64.37-.23.59-.36 1.14-.36zM2 16v2c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-2H2z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d71d86eaf79d6c32(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f786701308feddb6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2C6.48 2 2 6.48 2 12c0 1.54.36 2.98.97 4.29L1 23l6.71-1.97c1.31.61 2.75.97 4.29.97 5.52 0 10-4.48 10-10S17.52 2 12 2zm4 11h-3v3h-2v-3H8v-2h3V8h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$593737d6820e646c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-9-3h2v5h-2V4zm0 12H9v2H7v-2H5v-2h2v-2h2v2h2v2zm2-1.5V13h6v1.5h-6zm0 3V16h4v1.5h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e5a80862b4de10c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM10 4h4v2h-4V4zm6 11h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ddfb2e6c174787b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99zM13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zM17.5 14.33c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cac4c79922a5822a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.41 21L5 19.59l4.83-4.83c.75-.75 1.17-1.77 1.17-2.83v-5.1L9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83v5.1c0 1.06.42 2.08 1.17 2.83L19 19.59 17.59 21 12 15.41 6.41 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$81ca8edbe2f9bfc0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 9.01C18.72 8.42 18.16 8 17.5 8h-11c-.66 0-1.21.42-1.42 1.01L3 15v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 10h10.29l1.04 3H5.81l1.04-3zM6 17.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S8.33 19 7.5 19 6 18.33 6 17.5zm9 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zM9.41 5L8 6.41l-3-3L6.41 2l3 3zM16 6.41L14.59 5l3-3L19 3.41l-3 3zM13 5h-2V0h2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$703399fe3e0f5163(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.17 13.71l1.4-2.42c.09-.15.05-.34-.08-.45l-1.48-1.16c.03-.22.05-.45.05-.68s-.02-.46-.05-.69l1.48-1.16c.13-.11.17-.3.08-.45l-1.4-2.42c-.09-.15-.27-.21-.43-.15l-1.74.7c-.36-.28-.75-.51-1.18-.69l-.26-1.85a.364.364 0 00-.35-.29h-2.8c-.17 0-.32.13-.35.3L6.8 4.15c-.42.18-.82.41-1.18.69l-1.74-.7c-.16-.06-.34 0-.43.15l-1.4 2.42c-.09.15-.05.34.08.45l1.48 1.16c-.03.22-.05.45-.05.68s.02.46.05.69l-1.48 1.16c-.13.11-.17.3-.08.45l1.4 2.42c.09.15.27.21.43.15l1.74-.7c.36.28.75.51 1.18.69l.26 1.85c.03.16.18.29.35.29h2.8c.17 0 .32-.13.35-.3l.26-1.85c.42-.18.82-.41 1.18-.69l1.74.7c.16.06.34 0 .43-.15zM8.81 11c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM21.92 18.67l-.96-.74c.02-.14.04-.29.04-.44 0-.15-.01-.3-.04-.44l.95-.74c.08-.07.11-.19.05-.29l-.9-1.55c-.05-.1-.17-.13-.28-.1l-1.11.45c-.23-.18-.48-.33-.76-.44l-.17-1.18a.216.216 0 00-.21-.2h-1.79c-.11 0-.21.08-.22.19l-.17 1.18c-.27.12-.53.26-.76.44l-1.11-.45a.23.23 0 00-.28.1l-.9 1.55c-.05.1-.04.22.05.29l.95.74a3.145 3.145 0 000 .88l-.95.74c-.08.07-.11.19-.05.29l.9 1.55c.05.1.17.13.28.1l1.11-.45c.23.18.48.33.76.44l.17 1.18c.02.11.11.19.22.19h1.79c.11 0 .21-.08.22-.19l.17-1.18c.27-.12.53-.26.75-.44l1.12.45c.1.04.22 0 .28-.1l.9-1.55c.06-.09.03-.21-.05-.28zm-4.29.16a1.35 1.35 0 11.001-2.701 1.35 1.35 0 01-.001 2.701z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5b7d3659930f7ebf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.31 18.9c-.96 1-2.06 2.03-3.31 3.1-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2c4 0 7.64 2.92 7.97 7.5h3.53L19 14l-4.5-4.5h3.47C17.65 6.24 15.13 4 12 4c-3.35 0-6 2.57-6 6.2 0 2.34 1.95 5.44 6 9.14.64-.59 1.23-1.16 1.77-1.71a2.5 2.5 0 01-.27-1.12 2.5 2.5 0 015 0 2.492 2.492 0 01-3.19 2.39z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2e8c634404861834(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8h2v8H5zm7 0H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 6h-1v-4h1v4zm7-6h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 6h-1v-4h1v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M4 6h16v12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v16h20V4H2zm2 14V6h16v12H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d9c64fb7c286532(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 14H10V9H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 10.35V7zM7 17c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6h5v2H5zM19 13c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$944de03b86be5bff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8h10c.29 0 .57.06.84.13.09-.33.16-.67.16-1.04 0-1.31-.65-2.53-1.74-3.25L12 1 7.74 3.84A3.887 3.887 0 006 7.09c0 .37.07.71.16 1.04.27-.07.55-.13.84-.13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 7c0-1.1-2-3-2-3s-2 1.9-2 3c0 .74.4 1.38 1 1.72V13h-2v-2c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v2H3V8.72c.6-.34 1-.98 1-1.72 0-1.1-2-3-2-3S0 5.9 0 7c0 .74.4 1.38 1 1.72V21h9v-4c0-1.1.9-2 2-2s2 .9 2 2v4h9V8.72c.6-.34 1-.98 1-1.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fd6c02c3ef0dc379(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.71 9.71L22 12V6h-6l2.29 2.29-4.17 4.17a.996.996 0 01-1.41 0l-1.17-1.17a3 3 0 00-4.24 0L2 16.59 3.41 18l5.29-5.29a.996.996 0 011.41 0l1.17 1.17a3 3 0 004.24 0l4.19-4.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ff0b4e9be7b06ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4l4 4-4 4V9h-4V7h4V4zm-7 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM6 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm1 10h4v-2H7v-3l-4 4 4 4v-3zm7 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3344d0d97f1b9bc1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9h2zm-6 7h-2v-4l-2 3-2-3v4H8v-7h2l2 3 2-3h2v7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bbe9a246b74216c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c20d3639d98029e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b095e139b1c97334(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.34L21 3l-3.34 9L12 6.34zm10.61 13.44L4.22 1.39 2.81 2.81l5.07 5.07L3 9.69v1.41l7.07 2.83L12.9 21h1.41l1.81-4.88 5.07 5.07 1.42-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$98b7a2bc55b82248(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b38b09f7bc68da6d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5h14l-6 9v4h2v2H5v-2h2v-4L1 5zm9.1 4l1.4-2H4.49l1.4 2h4.21zM17 5h5v3h-3v9c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3a3 3 0 011 .17V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$adb452e7dcfdad11(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 9.01C18.72 8.42 18.16 8 17.5 8h-11c-.66 0-1.21.42-1.42 1.01L3 15v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 10h10.29l1.04 3H5.81l1.04-3zM6 17.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S8.33 19 7.5 19 6 18.33 6 17.5zm9 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zM12 6.36L9.17 3.54l1.41-1.41L12 3.54 15.54 0l1.41 1.41L12 6.36z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$47ebdf5b7f84a1ef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14V6c0-1.76 2.24-4 5-4v16.17l-2-2V14h-3zm4.49 9.31L10.02 12.85c-.33.09-.66.15-1.02.15v9H7v-9c-2.21 0-4-1.79-4-4V5.83L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM6.17 9L5 7.83V9h1.17zM9 2H7v2.17l2 2V2zm4 7V2h-2v6.17l1.85 1.85c.09-.33.15-.66.15-1.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$98c681c5f3d402e1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14V6c0-1.76 2.24-4 5-4v16.17l-2-2V14h-3zm4.49 9.31L10.02 12.85c-.33.09-.66.15-1.02.15v9H7v-9c-2.21 0-4-1.79-4-4V5.83L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM6.17 9L5 7.83V9h1.17zM9 2H7v2.17l2 2V2zm4 7V2h-2v6.17l1.85 1.85c.09-.33.15-.66.15-1.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6785601ee18f14e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 4 6.83V16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.05 0 .09-.02.14-.03l1.64 1.64 1.41-1.42zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zM6 11V8.83L8.17 11H6zm2.83-5L5.78 2.95C7.24 2.16 9.48 2 12 2c4.42 0 8 .5 8 4v10c0 .35-.08.67-.19.98L13.83 11H18V6H8.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$51929806a5e76c2c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm.88 13.75h-1.75V14h1.75v1.75zm0-2.87h-1.75c0-2.84 2.62-2.62 2.62-4.38 0-.96-.79-1.75-1.75-1.75s-1.75.79-1.75 1.75H8.5C8.5 6.57 10.07 5 12 5s3.5 1.57 3.5 3.5c0 2.19-2.62 2.41-2.62 4.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3467198c39e32795(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h2L12 2 5.05 12H7l-3.9 6h6.92v4h3.96v-4H21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9a9f63bdbd329e6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.18 10l-1.7-4.68A2.008 2.008 0 0014.6 4H12v2h2.6l1.46 4h-4.81l-.36-1H12V7H7v2h1.75l1.82 5H9.9c-.44-2.23-2.31-3.88-4.65-3.99C2.45 9.87 0 12.2 0 15c0 2.8 2.2 5 5 5 2.46 0 4.45-1.69 4.9-4h4.2c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5 0-2.8-2.2-5-5-5h-.82zM7.82 16c-.4 1.17-1.49 2-2.82 2-1.68 0-3-1.32-3-3s1.32-3 3-3c1.33 0 2.42.83 2.82 2H5v2h2.82zm6.28-2h-1.4l-.73-2H15c-.44.58-.76 1.25-.9 2zm4.9 4c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.03 0 .06-.01.09-.01 1.68 0 3 1.32 3 3s-1.33 3-3.01 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fbc1d35d871b6b90(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2a2 2 0 11.001 4.001A2 2 0 0112 4zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05A4.783 4.783 0 0112 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c89cb3abbb1721b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a9 9 0 00-9 9c0 4.17 2.84 7.67 6.69 8.69L12 22l2.31-2.31C18.16 18.67 21 15.17 21 11a9 9 0 00-9-9zm0 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.3a7.2 7.2 0 01-6-3.22c.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08a7.2 7.2 0 01-6 3.22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$38c732d43b0cf143(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.31 17.38l-2.39-2.13c.52-2.36-1.36-4.25-3.42-4.25-1.16 0-3.5.9-3.5 3.5 0 .97.39 1.84 1.03 2.47l-.71.71A4.457 4.457 0 0111 14.5c0-1.7.96-3.17 2.35-3.93a5 5 0 00-2.28-.57c-2.38 0-4.37 1.65-4.91 3.87A2.997 2.997 0 014 11c0-1.66 1.34-3 3-3h2.5a2.5 2.5 0 000-5H8c-.55 0-1 .45-1 1s.45 1 1 1h1.5c.28 0 .5.22.5.5s-.22.5-.5.5H7a5.002 5.002 0 00-1 9.9v.03C6 18.73 8.27 21 11.07 21h8.86c1.87 0 2.81-2.34 1.38-3.62zM18 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9562018cf92f819b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v-2h-3.07c-.05-.39-.12-.77-.22-1.14l2.58-1.49-1-1.73L16.92 10c-.28-.48-.62-.91-.99-1.29.04-.23.07-.46.07-.71 0-.8-.24-1.55-.65-2.18L17 4.17l-1.41-1.41-1.72 1.72c-1.68-.89-3.1-.33-3.73 0L8.41 2.76 7 4.17l1.65 1.65A3.99 3.99 0 008 8c0 .25.03.48.07.72-.37.38-.71.81-.99 1.28L4.71 8.63l-1 1.73 2.58 1.49c-.1.37-.17.75-.22 1.14H3v2h3.07c.05.39.12.77.22 1.14l-2.58 1.49 1 1.73L7.08 18c1.08 1.81 2.88 3 4.92 3s3.84-1.19 4.92-3l2.37 1.37 1-1.73-2.58-1.49c.1-.37.17-.75.22-1.14H21zm-8 2h-2v-6h2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b23c917c8e2d5e1a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2a2 2 0 11-4 0zM5 20v2h14v-2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c8f3b9fab49bc31a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4c57d8dd4afe85d8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.28 4.93l-2.12-2.12c-.78-.78-2.05-.78-2.83 0L11.5 5.64l2.12 2.12 2.12-2.12 3.54 3.54a3.012 3.012 0 000-4.25zM5.49 13.77c.59.59 1.54.59 2.12 0l2.47-2.47-2.12-2.13-2.47 2.47c-.59.59-.59 1.54 0 2.13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.04 7.76l-.71.71-.71.71L10.44 6c-.59-.6-1.54-.6-2.12-.01a1.49 1.49 0 000 2.12l3.18 3.18-.71.71-6.36 6.36c-.78.78-.78 2.05 0 2.83.78.78 2.05.78 2.83 0L16.45 12a.996.996 0 101.41-1.41l-2.82-2.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$194bcf626a880778(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 8a7 7 0 00-11.95-4.95A33.8 33.8 0 009 3c-4.42 0-8 .5-8 4v10.5A3.5 3.5 0 004.5 21L3 22.5v.5h12v-.5L13.5 21a3.5 3.5 0 003.5-3.5v-2.58A7 7 0 0023 8zM3 12V7h6.08a6.96 6.96 0 001.18 5H3zm6 7c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm7.71-6.06l-.2.03L16 13l-.47-.02-.16-.02-.29-.04-.2-.04-.22-.06a1.55 1.55 0 01-.23-.07l-.13-.05A4.99 4.99 0 0111.1 7c.04-.19.09-.37.15-.54l.05-.14.15-.38.07-.15.2-.36.07-.12.3-.42.02-.02c.24-.3.52-.57.82-.81l.01-.01.46-.32.03-.02A5.25 5.25 0 0116 3a5 5 0 01.71 9.94zM15 4h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e22b3ad5531ad5ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6H8V4.65l1-.12V6zm0 6H8V7h1v5zM6 7h1v5H6V7zm0-2.12l1-.12V6H6V4.88zM22 3V2L5 4v8H2c0 3.69 2.47 6.86 6 8.25V22h8v-1.75c3.53-1.39 6-4.56 6-8.25H10V7h12V6H10V4.41L22 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$477f318f8dde782(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21h-2V6.83L9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83V9c0 4.27 4.03 7.13 6 8.27l-1.46 1.46c-1.91-1.16-3.44-2.53-4.54-4.02V21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$71f63e878ccb69ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21h2V6.83l1.59 1.59L16 7l-4-4-4 4 1.41 1.41L11 6.83V9c0 4.27-4.03 7.13-6 8.27l1.46 1.46C8.37 17.56 9.9 16.19 11 14.7V21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3b2c14ce2e08f07c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm15.35 6.41l-1.77-1.77c-.2-.2-.51-.2-.71 0L6 11.53V14h2.47l6.88-6.88c.2-.19.2-.51 0-.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ce7bf2a015a06f75(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h2v9h-2zM4 4h2v16H4zM11 4h2v4h-2zM11 10h2v4h-2zM11 16h2v4h-2zM22.5 16.41L21.09 15 19 17.09 16.91 15l-1.41 1.41 2.09 2.09-2.09 2.09L16.91 22 19 19.91 21.09 22l1.41-1.41-2.09-2.09z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7545169bd5d456df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 000 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5135ac3ac9d21545(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd9de0c3e86be102(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.08 8A6 6 0 0116 3c3.31 0 6 2.69 6 6 0 2.97-2.16 5.44-5 5.92V21h-2v-6.09c0-.98.71-1.8 1.67-1.97a3.999 3.999 0 10-4.61-4.61c-.17.96-.99 1.67-1.97 1.67H5.83l1.59 1.59L6 13 2 9l4-4 1.41 1.41L5.83 8h4.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e878eb4c59ed80(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.92 8C13.44 5.16 10.97 3 8 3 4.69 3 2 5.69 2 9c0 2.97 2.16 5.44 5 5.92V21h2v-6.09c0-.98-.71-1.8-1.67-1.97a3.999 3.999 0 114.61-4.61c.17.96.99 1.67 1.97 1.67h4.26l-1.59 1.59L18 13l4-4-4-4-1.41 1.41L18.17 8h-4.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6e03e84225514091(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15.18V7c0-2.21-1.79-4-4-4s-4 1.79-4 4v10c0 1.1-.9 2-2 2s-2-.9-2-2V8.82C8.16 8.4 9 7.3 9 6c0-1.66-1.34-3-3-3S3 4.34 3 6c0 1.3.84 2.4 2 2.82V17c0 2.21 1.79 4 4 4s4-1.79 4-4V7c0-1.1.9-2 2-2s2 .9 2 2v8.18A2.996 2.996 0 0018 21c1.66 0 3-1.34 3-3 0-1.3-.84-2.4-2-2.82z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85b72eba1754a357(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.5 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.5 6c-.7 0-2.01-.54-2.91-1.76l-.41 2.35L14 14.03V18h-1v-3.58l-1.11-1.21-.52 2.64-3.77-.77.2-.98 2.78.57.96-4.89-1.54.57V12H9V9.65l3.28-1.21c.49-.18 1.03.06 1.26.53.83 1.7 2.05 2.03 2.46 2.03v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c9f3985eabfc676e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm0 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm1.65-2.65L11.5 12.2V9h1v2.79l1.85 1.85-.7.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$728ed68fbc7e070f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13.5V2L3 13.5h8zm10 0C21 6.5 14.5 1 12.5 1c0 0 1 3 1 6.5s-1 6-1 6H21zm1 1.5H2a6.233 6.233 0 002.33 3.73c.65-.27 1.22-.72 1.67-1.23.73.84 1.8 1.5 3 1.5s2.27-.66 3-1.5c.73.84 1.8 1.5 3 1.5s2.26-.66 3-1.5c.45.51 1.02.96 1.67 1.23 1.17-.89 2.02-2.2 2.33-3.73zm0 8v-2h-1c-1.04 0-2.08-.35-3-1-1.83 1.3-4.17 1.3-6 0-1.83 1.3-4.17 1.3-6 0-.91.65-1.96 1-3 1H2v2h1c1.03 0 2.05-.25 3-.75 1.89 1 4.11 1 6 0 1.89 1 4.11 1 6 0 .95.5 1.97.75 3 .75h1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e5e90c569dc17560(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d12dabc860f282e4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7.59l5-5c.78-.78 2.05-.78 2.83 0L20.24 11h-2.83L10.4 4 5.41 9H8v2H2V5h2v2.59zM20 19h2v-6h-6v2h2.59l-4.99 5-7.01-7H3.76l8.41 8.41c.78.78 2.05.78 2.83 0l5-5V19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e3f18baf6b2dd8da(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.05 17.56l-17.97.94L3 17l17.98-.94.07 1.5zM21 19.48H3v1.5h18v-1.5zM22 5v7c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-2 1c-1.68 0-3.04.98-3.21 2.23-.64-.73-2.73-2.73-6.54-2.73-4.67 0-6.75 3-6.75 3s2.08 3 6.75 3c3.81 0 5.9-2 6.54-2.73C16.96 10.02 18.32 11 20 11V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c43c434e3bab9bfe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h5l3-3-3-3h-5V2h-2v2H4v6h7v2H6l-3 3 3 3h5v4h2v-4h7v-6h-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1c3e2999fb435088(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17c0 .55-.45 1-1 1h-.17l-2.2-2.2C20.58 15.37 22 14.4 22 13c0-1-8-8-8-8h-3v2h2.25l1.45 1.3L11 11l-9.5-1L0 13l4.54 1.36-3.49 1.88C-.77 17.22-.07 20 2 20h6c2.21 0 4-1.79 4-4h4l2 2h-3v2h6c1.66 0 3-1.34 3-3h-2zM8 18H2l5.25-2.83L10 16a2 2 0 01-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$77b60ea7ae6ec98b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 7h-3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8h-3V9h3v6zM1 15h4v-2H3c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h4v2H3v2h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H1v-2zm16 0h4v-2h-2c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h4v2h-4v2h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c9e2bcfbb31f108(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.4 7c-.34.55-.4.97-.4 1.38C6 9.15 7 11 7 12c0 .95-.4 1.5-.4 1.5H5.1s.4-.55.4-1.5c0-1-1-2.85-1-3.62 0-.41.06-.83.4-1.38h1.5zm5 0c-.34.55-.4.97-.4 1.38 0 .77 1 2.62 1 3.62 0 .95-.4 1.5-.4 1.5h1.5s.4-.55.4-1.5c0-1-1-2.85-1-3.62 0-.41.06-.83.4-1.38h-1.5zM8.15 7c-.34.55-.4.97-.4 1.38 0 .77 1 2.63 1 3.62 0 .95-.4 1.5-.4 1.5h1.5s.4-.55.4-1.5c0-1-1-2.85-1-3.62 0-.41.06-.83.4-1.38h-1.5zm13.32-.5s.13-1.06.13-1.5c0-1.65-1.35-3-3-3-1.54 0-2.81 1.16-2.98 2.65L14.53 15H4.01c-.6 0-1.09.53-1 1.13C3.53 19.46 6.39 22 9.75 22c3.48 0 6.34-2.73 6.71-6.23L17.61 4.9c.05-.51.47-.9.99-.9.55 0 1 .45 1 1 0 .3-.1 1.25-.1 1.25l1.97.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c981d0b028ce79b7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5L3 7V3l4 2zm11-2v4l4-2-4-2zm-7-1v4l4-2-4-2zm-6 8.04c1.38.49 3.77.96 7 .96s5.62-.47 7-.96C19 9.86 16.22 9 12 9s-7 .86-7 1.04zM15 17H9v4.88c-4.06-.39-7-1.54-7-2.88v-9c0-1.66 4.48-3 10-3s10 1.34 10 3v9c0 1.34-2.94 2.48-7 2.87V17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$90c3227bfcdcdea5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$55bff6d49877acaa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.83L9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83V21h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$51878fd8fe96f0ea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82A6.435 6.435 0 0111.5 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$49c4bc7c717dc6eb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0v24h24V0H0zm22 22H2V8.86C2 6.05 3.53 3.84 6.2 2.8 8 2.09 10.14 2 12 2c1.86 0 4 .09 5.8.8C20.47 3.84 22 6.05 22 8.86V22z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5658f46bc8eb7d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8v13h4v-5c0-1.1.9-2 2-2s2 .9 2 2v5h4V8l-6-5-6 5zm7.5 2c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zM3 5c-1.1 0-2 .9-2 2v1h4V7c0-1.1-.9-2-2-2zM1 9h4v12H1zM21 5c-1.1 0-2 .9-2 2v1h4V7c0-1.1-.9-2-2-2zM19 9h4v12h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4fb2b42f7e14d852(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.26 11h13.48l-.67 9H5.93l-.67-9zm3.76-7h5.95L19 7.38l1.59-1.59L22 7.21 19.21 10H4.79L2 7.21 3.41 5.8 5 7.38 9.02 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$34b368d1587e7d02(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 8A7 7 0 009.68 5H7v2H4.5a1.5 1.5 0 00-1.42 1.01L1 14v8a1 1 0 001 1h1a1 1 0 001-1v-1h12v1a1 1 0 001 1h1a1 1 0 001-1v-7.68A7.01 7.01 0 0023 8zm-18.5.5h4.53a6.93 6.93 0 002.08 4.5H3l1.5-4.5zm0 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm11 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm2.93-5.63l-.21.11-.18.09a4.97 4.97 0 01-.42.16l-.22.07-.23.06-.2.05a5 5 0 01-5.94-4.41A4.07 4.07 0 0111 8l.02-.47.02-.17.04-.28.04-.21.05-.21.07-.24.05-.13a4.99 4.99 0 019.69 1.7 4.96 4.96 0 01-2.55 4.38zM15 4h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b648e77523ce7fc4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9.02c0 1.09-.89 1.98-1.98 1.98H4.98C3.89 11 3 10.11 3 9.02H1c0 1.86 1.28 3.4 3 3.84V22h6v-3c0-1.1.9-2 2-2s2 .9 2 2v3h6v-9.14c.55-.14 3-1.04 3-3.86l-2 .02z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8.86V10h12V8.86c.55-.14 3-1.04 3-3.86l-2 .02C19 6.11 18.11 7 17.02 7H6.98C5.89 7 5 6.11 5 5.02H3c0 1.85 1.28 3.4 3 3.84z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L8.25 6h7.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c16b62f599155f23(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.6 11h10.8l-.9-3h-9zM20 11v2H4v-2H2v11h8v-5h4v5h8V11zM15.9 6L15 3V1h-2v2h-2.03V1h-2v2.12L8.1 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b87649c0d1be1896(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db2b7deedb8c1577(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.5C2 19.54 4.46 22 7.5 22s5.5-2.46 5.5-5.5V10H2v6.5zm5.5 2C6.12 18.5 5 17.83 5 17h5c0 .83-1.12 1.5-2.5 1.5zM10 13c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-5 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3v6h3v2.5c0-.83 1.12-1.5 2.5-1.5s2.5.67 2.5 1.5h-5v2.89c.75.38 1.6.61 2.5.61 3.04 0 5.5-2.46 5.5-5.5V3H11zm3 5.08c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1c0 .56-.45 1-1 1zm5 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1c0 .56-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b019d88de4b53875(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7a1.003 1.003 0 001.71.71c.4-.4 1.04-2.46 1.04-2.46s-2.06.64-2.46 1.04c-.18.18-.29.43-.29.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2c-2.76 0-5 2.24-5 5 0 2.05 1.23 3.81 3 4.58V13h1v5c0 .55-.45 1-1 1s-1-.45-1-1v-2a3.009 3.009 0 00-4-2.83V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-3c0-.55.45-1 1-1s1 .45 1 1v2c0 1.65 1.35 3 3 3s3-1.35 3-3v-5h1v-1.42c1.77-.77 3-2.53 3-4.58 0-2.76-2.24-5-5-5zM6 19.5l-2-2v-2.83l2 2v2.83zm0-5l-2-2V9.67l2 2v2.83zm0-5l-2-2V4.67l2 2V9.5zm4 8l-2 2v-2.83l2-2v2.83zm0-5l-2 2v-2.83l2-2v2.83zm0-5l-2 2V6.67l2-2V7.5zm9 2.5c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$faf5fe9df7925024(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9a2 2 0 11-.001-3.999A2 2 0 0112 19zm0-5a2 2 0 11-.001-3.999A2 2 0 0112 14zm0-5a2 2 0 01-2-2c0-1.11.89-2 2-2a2 2 0 110 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd1ea09609ae8884(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a59c6321d8ceb7e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c554ae5c44315660(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$952d2b94e0e1d0c7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18H6V8h3v4.77L15.98 6 18 8.03 11.15 15H16v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc0d838d3ae0e7d9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm10 6c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$808727c7a9ea4e4c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.83 11l1.59 1.59L7 14l-4-4 4-4 1.41 1.41L6.83 9H15c1.1 0 2 .9 2 2v9h-2v-9H6.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dac7652f78913271(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.17 11l-1.59 1.59L17 14l4-4-4-4-1.41 1.41L17.17 9H9c-1.1 0-2 .9-2 2v9h2v-9h8.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5426b59837f8d233(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.83L4.41 8.41 3 7l4-4 4 4-1.41 1.41L8 6.83V13h8c1.1 0 2 .9 2 2v6h-2v-6H8c-1.1 0-2-.9-2-2V6.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$32c711e942fdc9d4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6.83l1.59 1.59L21 7l-4-4-4 4 1.41 1.41L16 6.83V13H8c-1.1 0-2 .9-2 2v6h2v-6h8c1.1 0 2-.9 2-2V6.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7eed2d118f7fa6d9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.66 6V4H6v5.66h2V7.41l5 5V20h2v-7.58c0-.53-.21-1.04-.59-1.41l-5-5h2.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$61e86b255acf85c4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.34 6V4H18v5.66h-2V7.41l-5 5V20H9v-7.58c0-.53.21-1.04.59-1.41l5-5h-2.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$72801b23125450a5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11c-.18 0-.36.03-.53.05L17.41 9H20V6l-3.72 1.86L13.41 5H9v2h3.59l2 2H11l-4 2-2-2H0v2h4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4l2 2h3l3.49-6.1 1.01 1.01c-.91.73-1.5 1.84-1.5 3.09 0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4zM4 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm16 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f3a657b02dea734a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9v12h-2V9c0-2.21-1.79-4-4-4S8 6.79 8 9v4.17l1.59-1.59L11 13l-4 4-4-4 1.41-1.41L6 13.17V9c0-3.31 2.69-6 6-6s6 2.69 6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$61069f9c40964e6a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9v12h2V9c0-2.21 1.79-4 4-4s4 1.79 4 4v4.17l-1.59-1.59L13 13l4 4 4-4-1.41-1.41L18 13.17V9c0-3.31-2.69-6-6-6S6 5.69 6 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c4c1a773b892a9a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11h4v11H1zM16 3.25C16.65 2.49 17.66 2 18.7 2 20.55 2 22 3.45 22 5.3c0 2.27-2.91 4.9-6 7.7-3.09-2.81-6-5.44-6-7.7C10 3.45 11.45 2 13.3 2c1.04 0 2.05.49 2.7 1.25zM20 17h-7l-2.09-.73.33-.94L13 16h2.82c.65 0 1.18-.53 1.18-1.18 0-.49-.31-.93-.77-1.11L8.97 11H7v9.02L14 22l8.01-3c-.01-1.1-.9-2-2.01-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f3eaa2b96751b5c7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 21V7L12 3 2 7v14h5v-9h10v9h5zm-11-2H9v2h2v-2zm2-3h-2v2h2v-2zm2 3h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d9b82c6d016a8206(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v6c0 2.97 2.16 5.43 5 5.91V19H8v2h8v-2h-3v-4.09c2.84-.48 5-2.94 5-5.91V3H6zm10 5H8V5h8v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b498ca6a53d16672(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10V3.26c-.65-.17-1.32-.26-2-.26-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8 0-.41-.04-.81-.09-1.2H14zm-2 3c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.54 2.88l-1.42-1.42L19 3.59l-2.12-2.13-1.42 1.42L17.59 5l-2.13 2.12 1.42 1.42L19 6.41l2.12 2.13 1.42-1.42L20.41 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$37e35d8c1765ac47(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9V3H7v2.59L3.91 2.5 2.5 3.91 5.59 7H3v2h6zm12 0V7h-2.59l3.09-3.09-1.41-1.41L17 5.59V3h-2v6h6zM3 15v2h2.59L2.5 20.09l1.41 1.41L7 18.41V21h2v-6H3zm12 0v6h2v-2.59l3.09 3.09 1.41-1.41L18.41 17H21v-2h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7991ed0ed47a58d7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3v6zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a81892d7fea52f0c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11.68V11L8 6l-7 5v10h5v-6h4v6h1.68c-.43-.91-.68-1.92-.68-3 0-2.79 1.64-5.19 4-6.32zM23 13.11V3H10v1.97l7 5v1.11c.33-.05.66-.08 1-.08 1.96 0 3.73.81 5 2.11zM17 7h2v2h-2V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 18c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5zm-5.5 3v-2.5H15v-1h2.5V15h1v2.5H21v1h-2.5V21h-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b260c59765c568d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.81 12.74l-.82-.63v-.22l.8-.63c.16-.12.2-.34.1-.51l-.85-1.48a.395.395 0 00-.35-.2c-.05 0-.1.01-.15.03l-.95.38c-.08-.05-.11-.07-.19-.11l-.15-1.01a.408.408 0 00-.4-.36h-1.71c-.2 0-.37.15-.4.34l-.14 1.01c-.03.02-.07.03-.1.05l-.09.06-.95-.38a.401.401 0 00-.5.17l-.85 1.48c-.1.17-.06.39.1.51l.8.63v.23l-.8.63a.39.39 0 00-.1.51l.85 1.48c.07.13.21.2.35.2.05 0 .1-.01.15-.03l.95-.37c.08.05.12.07.2.11l.15 1.01c.03.2.2.34.4.34h1.71c.2 0 .37-.15.4-.34l.15-1.01c.03-.02.07-.03.1-.05l.09-.06.95.38a.401.401 0 00.5-.17l.85-1.48a.39.39 0 00-.1-.51zM18 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM17 17h2v4c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v4h-2V6H7v12h10v-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9ef3a805f34bd226(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6 6h4v-4h-4v4zm3-20c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 8h-1V7h1v1zm0-2h-1V2h1v4zM16 14h4v-2.07c-.33.05-.66.07-1 .07-1.07 0-2.09-.24-3-.68V14zM10 4v4h2.68c-.44-.91-.68-1.93-.68-3 0-.34.02-.67.07-1H10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1275b58f5cfd434b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c3a1773cd5350e3e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.77 3.77L16 2 6 12l10 10 1.77-1.77L9.54 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$467e4b1f1d98c34a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9cfad5719d8ef3a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b7c567ebbe29677a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d8bf674e59cfe2d2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$29ac9ad7531ad168(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10l5 5 5-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$222d659c115e8bf0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14l5-5 5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d76971d043ca5a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.23 20.23L8 22l10-10L8 2 6.23 3.77 14.46 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc8e96d206fca183(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c267194b53cf2907(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7l-5 5 5 5V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0v24H0V0h24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1dc1425e72312760(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17l5-5-5-5v10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 24V0h24v24H0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9e384553c0cee73c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b849ca0fb7832f4b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H9c-.6 0-1 .4-1 1v4h2v-3h4v2.5l3.5-3.5L14 7.5V10zm-2-9C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm7.73 11.58l-7.19 7.22c-.35.27-.79.27-1.15 0L4.2 12.58a.932.932 0 010-1.16l7.19-7.22c.35-.27.79-.27 1.15 0l7.19 7.22c.36.27.36.8 0 1.16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bf494dede0b3f491(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm3.57 16L12 15.42 8.43 17l-.37-.37L12 7l3.95 9.63-.38.37z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ad7892f2d30fd175(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$704eec101b9052e7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ddb4540e05bcfe0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5d8cdbf0fb84c445(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$32cfe72a00af996e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3c90d63de09735ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e108b861637ecf9a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 5H11l5 7-5 7h4.5l5-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5H4l5 7-5 7h4.5l5-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a024475115ca8f36(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5l-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8eaa90b74e57fc28(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 13.5L7.5 11l1.42-1.41L12 12.67l3.08-3.08L16.5 11 12 15.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$180a8dedfead777a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6112bc36b9d7c8e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$57ffeec7e1dae549(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$208fee4d434ee272(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6217ee6a295077db(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6e853e9aba9556cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11v10h5v-6h4v6h5V11L8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3v1.97l7 5V11h2v2h-2v2h2v2h-2v4h6V3H10zm9 6h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b7d178eb42fd0903(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dab016b259b78b14(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15H4v-2h16v2zm0 2H4v2h16v-2zm-5-6l5-3.55V5l-5 3.55L10 5 4 8.66V11l5.92-3.61L15 11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$618545f8c55a44ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11v10h5v-6h4v6h5V11L8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3v1.97l7 5V11h2v2h-2v2h2v2h-2v4h6V3H10zm9 6h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d8e2f4fcaec70eb1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1cacc4875fdbad81(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6f00c69fe24f457a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab49fb3693cb43ea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$632f6541b1b8c145(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6df65e6f53279731(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h2V8.41L18.59 20 20 18.59 8.41 7H15V5H5v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9716385dff3666b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9l1.41 1.41L11 5.83V22h2V5.83l4.59 4.59L19 9l-7-7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$688e1b292a3c1926(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.6 10.26v1.31L17 9.33 14.6 7.1v1.28c-2.33.32-3.26 1.92-3.6 3.52.83-1.13 1.93-1.64 3.6-1.64zM16 23H6c-1.1 0-2-.9-2-2V5h2v16h10v2zm2-22h-8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 15h-8V4h8v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4195ab9a78354dcf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-6v11c0 1.1-.9 2-2 2H4v-2h17V7h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1217fa5d1cab304c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8h11V5c0-1.1-.9-2-2-2h-9v5zM3 8h5V3H5c-1.1 0-2 .9-2 2v3zm2 13h3V10H3v9c0 1.1.9 2 2 2zm8 1l-4-4 4-4zm1-9l4-4 4 4zM14.58 19H13v-2h1.58c1.33 0 2.42-1.08 2.42-2.42V13h2v1.58c0 2.44-1.98 4.42-4.42 4.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6be079ce58608c74(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7367fbf6b1b79888(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-2v6.59L5.41 4 4 5.41 15.59 17H9v2h10V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d77e85e815e754fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19v-2H8.41L20 5.41 18.59 4 7 15.59V9H5v10h10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9e696e023882a863(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15l-1.41-1.41L13 18.17V2h-2v16.17l-4.59-4.59L5 15l7 7 7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7734acfdeb43e25(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$296b2bf9095b1650(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$33c958f48cf859d5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 8.62v6.76L5.12 12 8.5 8.62M10 5l-7 7 7 7V5zm4 0v14l7-7-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5d4725b361ff45b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 15.38V8.62L18.88 12l-3.38 3.38M14 19l7-7-7-7v14zm-4 0V5l-7 7 7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a4405cccfa7722d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9e5090dcbef0c2df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f5ed952deb9d9115(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h3v16h-3zM3 13h3v7H3zm11-9h3v3h-3zm-4 1h3v4h-3zm-3 5h3v4H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$33c143ce9d2452cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19l1.41-1.41L5.83 13H22v-2H5.83l4.59-4.59L9 5l-7 7 7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$782b6508519b5915(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c255f359aa6cbc2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19cde9860640a9f3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM21 6h-3V3h-2v3h-3v2h3v3h2V8h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$752665ef62389d9d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09a4 4 0 012.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94a3.01 3.01 0 001.41-4A3.005 3.005 0 004.7 4.8a2.99 2.99 0 00-1.4 4 2.99 2.99 0 004 1.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c7b95e1dfefdf8b6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9a3 3 0 00-.04-4.24 3 3 0 00-4.24.04 3 3 0 00.04 4.24 3 3 0 004.24-.04z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fbaee0308122e524(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f74f462f3d84ca0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98a2.01 2.01 0 00-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c9df35bb791dd56(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b65f5aba0a2eebc7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e8023f72b525881b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76A5.01 5.01 0 008.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38a2.21 2.21 0 00-.99-.06h-.02a2.268 2.268 0 00-1.84 2.61l1.35 5.92A3.008 3.008 0 009.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c3599ae01c35b73(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$89e4f4f97d287e7b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2a9.936 9.936 0 001.54-5.31c-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7c49f77cdb15a800(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V6a2 2 0 00-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9e0418f24589c4a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.83 10h.67V7.5L17 11l-1.59 1.59L18.83 16l2.59-2.59c.78-.78.78-2.05 0-2.83l-7.99-8c-.78-.78-2.05-.78-2.83 0L8 5.17 12.83 10zM2.81 2.81L1.39 4.22 5.17 8l-2.59 2.59c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0L16 18.83l3.78 3.78 1.41-1.41L2.81 2.81zM10 15H8v-4c0-.05.02-.09.03-.14L10 12.83V15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a8a707737c333131(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f2e15fd191b91cd3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$405fff3fe2e3bd5c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11v2h-1.17l4.51 4.51A9.91 9.91 0 0022 12c0-5.52-4.48-10-10-10-2.04 0-3.93.61-5.51 1.66L13.83 11H17zM1.39 4.22l2.27 2.27A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l2.27 2.27 1.41-1.41L2.81 2.81 1.39 4.22zM7 11h1.17l2 2H7v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$60123f39eba06246(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$81d7f9c473b05f7c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$22aa9f73f72e74fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M-618-1464H782v3600H-618zM0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$50966783781019f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11v2h-1.46l4.68 4.68A9.92 9.92 0 0022 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17zM2.27 2.27L1 3.54l2.78 2.78A9.92 9.92 0 002 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27zM7 13v-2h1.46l2 2H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e811b156e5dec9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$10ae43eabacbc963(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bb423008a006404d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c68498838deac341(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d03482cacb56f4c1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db195e1b9b975078(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b6dcfb181b37d93a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85fe2b654a548f84(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3c519db056272b3a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2v6H6V6H4v4h10v5h2v8h-6v-8h2v-3H2V4h4V2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$741b03d06a2096ea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3a2 2 0 00-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8a2 2 0 00-2-2zm0 14H3V8h18v12zM9 10v8l7-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ab6c07eb21d894b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6fbc88bd1c15ba47(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6e685b9dcc4d8c07(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2a15.367 15.367 0 00-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2a7.1 7.1 0 014.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84dd03077697b7aa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5a2.5 2.5 0 00-5 0V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$86ad5c47364963a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.27L20 17.17V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.21 0-4.07 1.45-4.73 3.44L8.9 6.07V6zM2.1 2.1L.69 3.51 5.3 8.13C4.55 8.42 4 9.15 4 10v10c0 1.1.9 2 2 2h12c.34 0 .65-.09.93-.24l1.56 1.56 1.41-1.41L2.1 2.1zM12 17c-1.1 0-2-.9-2-2 0-.59.27-1.12.68-1.49l2.81 2.81c-.37.41-.9.68-1.49.68z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a70a0e44f94d89ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$686856e15075c27d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 00-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9f70f806107dd23c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 00-2-2zm0 14H3V5h18v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9eef4d96b95e7b12(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d40b8a7bf5e8b093(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2zm13.54-7.1l-.71-.7L13 9.29V5h-1v6h6v-1h-4.15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ca4609aaa7ad9000(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$871121db5e7a04b1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2a9 9 0 00-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2f3f65945abe07b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5V4c0-1.1-.9-2-2-2s-2 .9-2 2v1h-1v5h6V5h-1zm-1 0h-2V4c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.63 14.4l-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.56.03 1.03-.44 1.03-1v-4.15c0-.48-.34-.89-.8-.98l-3.67-.73a.985.985 0 00-.9.26z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$818d40c8516e634c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17A16.971 16.971 0 0012 12C7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8b57e0db41b1634e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e55db132f245dc9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14.49V9c0-1-1.01-2.01-2-2V3h-2v4h-4V3H8v2.48l9.51 9.5.49-.49zm-1.76 1.77L7.2 7.2l-.01.01L3.98 4 2.71 5.25l3.36 3.36C6.04 8.74 6 8.87 6 9v5.48L9.5 18v3h5v-3l.48-.48L19.45 22l1.26-1.28-4.47-4.46z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$64c1be638b0cffd4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e8060c4ff543ef8a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "19",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3h4v12h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8061c332a492ea37(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10v8h-2v-8h2zm-2 10v2h2v-2h-2zm-2-2.71A7.99 7.99 0 0112 20c-4.41 0-8-3.59-8-8s3.59-8 8-8v9l7.55-7.55A9.965 9.965 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10c2.25 0 4.33-.74 6-2v-2.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8927b06e47d195b1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8808f778ae7e0fec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aed9b31d6b15e49c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7b6c43177df320e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fdd673cc677ebe5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df62bfa46a207927(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.22C21 6.73 16.74 3 12 3c-4.69 0-9 3.65-9 9.28-.6.34-1 .98-1 1.72v2c0 1.1.9 2 2 2h1v-6.1c0-3.87 3.13-7 7-7s7 3.13 7 7V19h-8v2h8c1.1 0 2-.9 2-2v-1.22c.59-.31 1-.92 1-1.64v-2.3c0-.7-.41-1.31-1-1.62z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11.03A6.04 6.04 0 0012.05 6c-3.03 0-6.29 2.51-6.03 6.45a8.075 8.075 0 004.86-5.89c1.31 2.63 4 4.44 7.12 4.47z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e042b8987455718(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36a7.925 7.925 0 001.14 9.87L4 20h6v-6l-2.24 2.24A6.003 6.003 0 016 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24A6.003 6.003 0 0118 12c0 1-.25 1.94-.68 2.77l1.46 1.46a7.925 7.925 0 00-1.14-9.87L20 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f07e345351ef3d69(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4.26v2.09C7.67 7.18 6 9.39 6 12c0 1.77.78 3.34 2 4.44V14h2v6H4v-2h2.73A7.942 7.942 0 014 12c0-3.73 2.55-6.85 6-7.74zM20 4h-6v6h2V7.56c1.22 1.1 2 2.67 2 4.44h2c0-2.4-1.06-4.54-2.73-6H20V4zm0 13v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ec592996eaa55324(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24A6.003 6.003 0 015 12a5.99 5.99 0 014-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24A6.003 6.003 0 0119 12a5.99 5.99 0 01-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af48655997d9822c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0020 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 004 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d879728db523c691(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$82f52586477a8166(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2a9 9 0 019 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$901bcf1188bb94fc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e1e4ceed49a54080(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3.54l1.53 1.53C1.65 5.28 1 6.06 1 7v12c0 1.1.9 2 2 2h15.46l2 2 1.26-1.27L2.27 2.27 1 3.54zM3 19V7h1.46l12 12H3zM21 5h-7.58l3.29-3.3L16 1l-4 4-4-4-.7.7L10.58 5H7.52l2 2H21v11.48l1.65 1.65c.22-.32.35-.71.35-1.13V7c0-1.11-.89-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$798637bca3f5a437(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$acd2a1de6fe2e282(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3 11l-2-1.99V13c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v1.99L17 7v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2b0bde2fdd09cc79(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 5h1.5v10h-1.5zM8.5 7H10v6H8.5zM6 9h1.5v2H6zM14 7h1.5v6H14zM16.5 9H18v2h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5b7610929cb1b94d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4v-.5a2.5 2.5 0 00-5 0V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$44a7ecf60594d5e9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63A2.01 2.01 0 0016.56 7h-.12a2 2 0 00-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2fc3322e6f4752f4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 .01c0-.01 0-.01 0 0L0 0v24h24V.01zM0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.99 9C19.15 5.16 13.8 3.76 8.84 4.78l2.52 2.52c3.47-.17 6.99 1.05 9.63 3.7l2-2zm-4 4a9.793 9.793 0 00-4.49-2.56l3.53 3.53.96-.97zM2 3.05L5.07 6.1C3.6 6.82 2.22 7.78 1 9l1.99 2c1.24-1.24 2.67-2.16 4.2-2.77l2.24 2.24A9.684 9.684 0 005 13v.01L6.99 15a7.042 7.042 0 014.92-2.06L18.98 20l1.27-1.26L3.29 1.79 2 3.05zM9 17l3 3 3-3a4.237 4.237 0 00-6 0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$34a69b9360ac9ac6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3a4.237 4.237 0 00-6 0zm-4-4l2 2a7.074 7.074 0 0110 0l2-2C15.14 9.14 8.87 9.14 5 13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b13015be24474c44(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c0b9015e49ef6c32(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H3a2 2 0 00-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$86552ef421262094(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2A5.37 5.37 0 005.4 6.62C2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12a5.386 5.386 0 003.82 1.57c2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f5abb7eaefabea18(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11V3H7v4H3v14h8v-4h2v4h8V11h-4zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm4 4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d2746e92117cacfd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8v2h-3L8.31 8.82 7 12.75V22H3V12l1.58-4.63A2.003 2.003 0 017.3 6.18l4.15 1.83L14 8zM8 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm1 18h12v-2H9v2zm10.5-3c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM13 12c0-.55-.45-1-1-1H9v2h2v1c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-3h-2v2h-2v-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$656fab77dcccc8d9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V8c0-1.86 1.28-3.41 3-3.86V2h3v2h4V2h3v2.14c1.72.45 3 2 3 3.86zM6 12v2h10v2h2v-4H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$726dc1171014913d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10v2H8v-2h2zm6 2v-2h-2v2h2zm5 2v8H3v-8h1v-4c0-4.42 3.58-8 8-8s8 3.58 8 8v4h1zM7 16H5v4h2v-4zm4 0H9v4h2v-4zm0-11.92C8.16 4.56 6 7.03 6 10v4h5V4.08zM13 14h5v-4c0-2.97-2.16-5.44-5-5.92V14zm2 2h-2v4h2v-4zm4 0h-2v4h2v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a01e4c73cffc4a6d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "7",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25a.828.828 0 011.41.59V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5A2.251 2.251 0 005 12.25V13H2v6c0 1.1.9 2 2 2 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 1.1 0 2-.9 2-2v-6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f2d1f8b73dc3f1f4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$83304f49ba7acad4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11V5h4c1.1 0 2 .9 2 2v4h-6zm4 8c1.1 0 2-.9 2-2v-4h-6v6h4zM14 5v14H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h10zm-4.5 7c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5.67 1.5 1.5 1.5 1.5-.67 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9c8d27e2ecd48bf2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L4.2 15.5l1.7 1.06L7 14.8V21h4v-5h2v5h4v-6.21l1.1 1.77 1.7-1.06L12 3zm1 11h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1a12c139a1de152(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm10 5h4v2h-4zm0 0h4v2h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eb25b4d9c34e7430(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 1c0 1.66-1.34 3-3 3-.55 0-1 .45-1 1H4c0-1.66 1.34-3 3-3 .55 0 1-.45 1-1h2zm2 2L6 7.58V6H4v3.11L1 11.4l1.21 1.59L4 11.62V21h16v-9.38l1.79 1.36L23 11.4 12 3zm1.94 4h-3.89L12 5.52 13.94 7zm-6.5 2h9.12L18 10.1v.9H6v-.9L7.44 9zM18 13v2H6v-2h12zM6 19v-2h12v2H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6dd3ee446e13496(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.73 14.23L7 1.5 3.11 5.39l8.13 11.67c-.78.78-.78 2.05 0 2.83l1.41 1.41c.78.78 2.05.78 2.83 0l4.24-4.24c.79-.78.79-2.05.01-2.83zm-5.66 5.65l-1.41-1.41 4.24-4.24 1.41 1.41-4.24 4.24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4b2a464d620c6279(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm21.02 19c0 1.1-.9 2-2 2h-14c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e69997e50fc3b6a7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7.5l7.5 7.5-1.41 1.41L15 15.33V20h-4v-5H9v5H5v-4.67l-1.09 1.09L2.5 15 10 7.5zm12-1h-1.19l.75-.75-.71-.71-1.46 1.46h-.89v-.89l1.45-1.45-.71-.71-.74.74V3h-1v1.19l-.75-.75-.71.71 1.45 1.45v.9h-.89l-1.45-1.45-.71.71.75.75H14v1h1.19l-.75.75.71.71 1.45-1.45h.89v.89l-1.45 1.45.71.71.75-.75V11h1V9.81l.75.75.71-.71-1.46-1.46V7.5h.89l1.45 1.45.71-.71-.74-.74H22v-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e0dd87ebfbee80af(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 11l-3 6v-4h-2l3-6v4h2zM7 1h10c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2zm0 5v12h10V6H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b872f82a002ac442(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.6 18.2L13 11.75v-.91a3.496 3.496 0 00-.18-6.75A3.51 3.51 0 008.5 7.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 .84-.69 1.52-1.53 1.5-.54-.01-.97.45-.97.99v1.76L2.4 18.2c-.77.58-.36 1.8.6 1.8h18c.96 0 1.37-1.22.6-1.8zM6 18l6-4.5 6 4.5H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd99f4409ed5300b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "10.5",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "10.5",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66a4.008 4.008 0 00-2.81-3.17 9.114 9.114 0 00-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91a3.994 3.994 0 00-2.81 3.17c-.04.21-.06.43-.06.66s.02.45.06.66a4.008 4.008 0 002.81 3.17 8.977 8.977 0 002.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89a3.998 3.998 0 002.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$47be45b2573277ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89A7.948 7.948 0 0021 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ba132938712ad58f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h20V7H12zm-2 12H4v-2h6v2zm0-4H4v-2h6v2zm0-4H4V9h6v2zm0-4H4V5h6v2zm10 12h-8V9h8v10zm-2-8h-4v2h4v-2zm0 4h-4v2h4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3910b792628194e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L6 7.58V6H4v3.11L1 11.4l1.21 1.59L4 11.62V21h7v-6h2v6h7v-9.38l1.79 1.36L23 11.4 12 3zm-2-2c0 1.66-1.34 3-3 3-.55 0-1 .45-1 1H4c0-1.66 1.34-3 3-3 .55 0 1-.45 1-1h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6fb25ded31a7f531(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10V7c0-1.66-1.34-3-3-3s-3 1.34-3 3h2c0-.55.45-1 1-1s1 .45 1 1v3H8c1.1 0 2-.9 2-2V4H4v4c0 1.1.9 2 2 2H2v2h2v8h16v-8h2v-2h-4zm-5 8h-2v-6h2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ead009423041438(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9h-6V4H8C5.79 4 4 5.79 4 8v6c0 1.1.9 2 2 2h2v2.93c-.61-.35-1.16-.78-1.65-1.27l-1.42 1.42C6.74 20.88 9.24 22 12 22c2.76 0 5.26-1.12 7.07-2.93l-1.42-1.42c-.49.49-1.05.92-1.65 1.27V16h2c1.1 0 2-.9 2-2v-3c0-1.1-.9-2-2-2zm-4 10.75c-.64.16-1.31.25-2 .25s-1.36-.09-2-.25V16h4v3.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8924ee8048d4333(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6v12h2V8h10v10h2v-2h4v2h2V6H2zm18 2v2h-4V8h4zm-4 6v-2h4v2h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$478df8070d92acfb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.39 4.22l7.9 7.9c.18.2.18.5-.01.7a.485.485 0 01-.7 0L6.87 11.1c-.11.4-.26.78-.45 1.12l1.4 1.4c.2.2.2.51 0 .71a.485.485 0 01-.7 0l-1.27-1.27c-.24.29-.5.56-.77.8l1.28 1.28c.2.2.2.51 0 .71-.1.1-.23.15-.36.15s-.26-.05-.35-.15l-1.38-1.38c-.69.46-1.39.79-1.97 1.02-.78.31-1.3 1.04-1.3 1.88V20h9.5l3.33-3.33 5.94 5.94 1.41-1.41L2.81 2.81 1.39 4.22zm17.12 11.46l-1.41-1.41 4.48-4.48L23 11.2l-4.49 4.48zm2.37-6.6l-4.48 4.48-7.1-7.09L13.8 2l7.08 7.08z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$43dd3242faff6a23(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10.17l-2.5-2.5V2.25a1.25 1.25 0 012.5 0v7.92zm7 2.58v-7.5a1.25 1.25 0 00-2.5 0V11h-1V3.25a1.25 1.25 0 00-2.5 0v7.92l6 6v-4.42zM9.5 4.25C9.5 3.56 8.94 3 8.25 3c-.67 0-1.2.53-1.24 1.18L9.5 6.67V4.25zm3.5 5.92l-2.5-2.5V2.25a1.25 1.25 0 012.5 0v7.92zm7 2.58v-7.5a1.25 1.25 0 00-2.5 0V11h-1V3.25a1.25 1.25 0 00-2.5 0v7.92l6 6v-4.42zM9.5 4.25C9.5 3.56 8.94 3 8.25 3c-.67 0-1.2.53-1.24 1.18L9.5 6.67V4.25zm11.69 16.94L2.81 2.81 1.39 4.22l5.63 5.63L7 9.83v4.3c-1.11-.64-2.58-1.47-2.6-1.48-.17-.09-.34-.14-.54-.14-.26 0-.5.09-.7.26-.04.01-1.16 1.11-1.16 1.11l6.8 7.18c.57.6 1.35.94 2.18.94H17c.62 0 1.18-.19 1.65-.52l-.02-.02 1.15 1.15 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2d54246baa34e481(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.65 4.86l-.07-.07c-.57-.62-.82-1.41-.67-2.2L15 2h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L19 2h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zM9.12 5l-7.18 6.79c-.6.56-.94 1.35-.94 2.18V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 000-2.5H12v-1h7.75a1.25 1.25 0 000-2.5H12v-1h8.75a1.25 1.25 0 000-2.5H12v-1h6.75a1.25 1.25 0 000-2.5H8.86c.64-1.11 1.48-2.58 1.49-2.61a1.065 1.065 0 00-.12-1.23C10.22 6.12 9.12 5 9.12 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f50b4caebc3258a3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8.5 6a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm2.5 8h-1v4H7v-4H6v-2.5c0-1.1.9-2 2-2h1c1.1 0 2 .9 2 2V14zm4.5 3L13 13h5l-2.5 4zM13 11l2.5-4 2.5 4h-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a975395a3b66b540(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S17.83 8 17 8s-1.5.67-1.5 1.5zm3 2.5h-2.84c-.58.01-1.14.32-1.45.86l-.92 1.32L9.72 8a2.02 2.02 0 00-1.71-1H5c-1.1 0-2 .9-2 2v6h1.5v7h5V11.61L12.03 16h2.2l.77-1.1V22h4v-5h1v-3.5c0-.82-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dc72a13f5ea34ab0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 6h-1.7l-5 9H7c-.83 0-1.5-.67-1.5-1.5S6.17 15 7 15h1.7l5-9H17c.83 0 1.5.67 1.5 1.5S17.83 9 17 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac327cbd1f52f765(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A2.01 2.01 0 0018.06 7h-.12a2 2 0 00-1.9 1.37l-.86 2.58c1.08.6 1.82 1.73 1.82 3.05v8h3zm-7.5-10.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S11 9.17 11 10s.67 1.5 1.5 1.5zM5.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm2 16v-7H9V9c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v6h1.5v7h4zm6.5 0v-4h1v-4c0-.82-.68-1.5-1.5-1.5h-2c-.82 0-1.5.68-1.5 1.5v4h1v4h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e0cadcf6bde0955a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v-2h-2V7l-3-3-2 2-2-2-2 2-2-2-3 3v3H3v2h2v2H3v2h2v4h14v-4h2v-2h-2v-2h2zm-5-5.17l1 1V10h-2V7.83l.41-.41.59-.59zm-4 0l.59.59.41.41V10h-2V7.83l.41-.41.59-.59zM11 14v-2h2v2h-2zm2 2v2h-2v-2h2zM7 7.83l1-1 .59.59.41.41V10H7V7.83zM7 12h2v2H7v-2zm0 4h2v2H7v-2zm10 2h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f1f5121c6953fcc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h10v1c0 1.1-.9 2-2 2H9c-1.1 0-2-.9-2-2v-1zm0-1h10v-5H7v5zM17 3v6l-3.15-.66c-.01 0-.01.01-.02.02 1.55.62 2.72 1.98 3.07 3.64H7.1c.34-1.66 1.52-3.02 3.07-3.64-.33-.26-.6-.58-.8-.95L5 6.5v-1l4.37-.91C9.87 3.65 10.86 3 12 3c.7 0 1.34.25 1.85.66L17 3zm-4 3c-.03-.59-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b1dd800c02207860(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$38eabaca65827d5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L4 9v12h16V9l-8-6zm.5 9.5c0 .83-.67 1.5-1.5 1.5v4h-1v-4c-.83 0-1.5-.67-1.5-1.5v-3h1v3h.5v-3h1v3h.5v-3h1v3zM15 18h-1v-3.5h-1v-3c0-1.1.9-2 2-2V18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$13df7a3df34042b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h3L12 3 2 12h3v3H3v2h2v3h2v-3h4v3h2v-3h4v3h2v-3h2v-2h-2v-3zM7 15v-4.81l4-3.6V15H7zm6 0V6.59l4 3.6V15h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a3372fa68e31843(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 002-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e98cb99e0c6fe19(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6H9V4H7v2H6l-4 4v9h20v-9l-4-4zM4 12h10v5H4v-5zm16 5h-4v-6.17l2-2 2 2V17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e26355aa585698d8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a7adb47f6feaada3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20H2v-2h5.75A8.032 8.032 0 002 12.26c.64-.16 1.31-.26 2-.26 4.42 0 8 3.58 8 8zm10-7.74c-.64-.16-1.31-.26-2-.26-2.93 0-5.48 1.58-6.88 3.93a9.82 9.82 0 01.87 4.07h8v-2h-5.75A8.061 8.061 0 0122 12.26zm-6.36-1.24a10.03 10.03 0 014.09-5C15.44 6.16 12 9.67 12 14v.02c.95-1.27 2.2-2.3 3.64-3zm-4.22-2.17A8.527 8.527 0 006.7 4C8.14 5.86 9 8.18 9 10.71c0 .21-.03.41-.04.61.43.24.83.52 1.22.82a9.91 9.91 0 011.24-3.29z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eecac70b410d3388(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20V8.35L13.65 4h-2.83L16 9.18V20h2zm4 0V6.69L19.31 4h-2.83L20 7.52V20h2zM8 4l-6 6v10h5v-5h2v5h5V10L8 4zm1 9H7v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ff4d5132bb3019df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$92e94e2338b34ba2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h3L12 3 2 12h3v8h2v-2h10v2h2v-8zM7.21 10h9.58l.21.19V12H7v-1.81l.21-.19zm7.36-2H9.43L12 5.69 14.57 8zM7 16v-2h10v2H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d31b80e3a405b6ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9.3V4h-3v2.6L12 3 2 12h3v8h5v-6h4v6h5v-8h3l-3-2.7zm-9 .7c0-1.1.9-2 2-2s2 .9 2 2h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8f0e8f17ca719cf3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c-1.95 0-2.1 1-3.34 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1 1.19 0 1.42 1 3.33 1 1.95 0 2.08-1 3.32-1s1.37 1 3.32 1c1.91 0 2.14-1 3.33-1 1.18 0 1.45 1 3.35 1v-2c-1.24 0-1.38-1-3.33-1-1.91 0-2.14 1-3.33 1-1.24 0-1.39-1-3.34-1zm8.34-4.66l-1.37 1.37c-.19.18-.45.29-.71.29H17V9.65l1.32.97L19.5 9 12 3.5 4.5 9l1.18 1.61L7 9.65V13H5.74c-.27 0-.52-.11-.71-.29l-1.37-1.37-1.41 1.41 1.37 1.37c.56.56 1.33.88 2.12.88h12.51c.8 0 1.56-.32 2.12-.88l1.37-1.37-1.4-1.41zM13 13h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$576d742427d2ed5c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6c-1.66 0-3 1.34-3 3v4c0 .55-.45 1-1 1v-4c0-1.66-1.34-3-3-3h-4c-1.66 0-3 1.34-3 3h2c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1H6c-2.21 0-4 1.79-4 4v3h15v-2c1.66 0 3-1.34 3-3V9c0-.55.45-1 1-1h1V6h-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c4f54567d22223be(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9V4c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v5h16zM8 5h2v3H8V5zm-4 6v9c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-9H4zm6 6H8v-5h2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1eb4213f90b39ceb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6h-3zm-4 5v2h2v-2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$adcfc82050c6eb2b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.8 10.61L5.37 9.19C5.73 8.79 6.59 8 7.75 8c.8 0 1.39.39 1.81.67.31.21.51.33.69.33.37 0 .8-.41.95-.61l1.42 1.42c-.36.4-1.22 1.19-2.37 1.19-.79 0-1.37-.38-1.79-.66-.33-.22-.52-.34-.71-.34-.37 0-.8.41-.95.61zM7.75 15c.19 0 .38.12.71.34.42.28 1 .66 1.79.66 1.16 0 2.01-.79 2.37-1.19l-1.42-1.42c-.15.2-.59.61-.95.61-.18 0-.38-.12-.69-.33-.42-.28-1.01-.67-1.81-.67-1.16 0-2.02.79-2.38 1.19l1.42 1.42c.16-.2.59-.61.96-.61zM22 6v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-8 0H4v12h10V6zm5 10c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zm0-4c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zm0-5h-2v2h2V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$65377732fabb8de5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L4 9v12h16V9l-8-6zm-2.25 9.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM17 18h-1v-1.5H8V18H7v-7h1v4.5h3.5V12H15c1.1 0 2 .9 2 2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5dfd4407ba888490(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l2.76 2.76C4.06 7.31 4 7.64 4 8v12c0 1.1.9 2 2 2h12c.34 0 .65-.09.93-.24l.85.85 1.41-1.42zM6 14v-2h3.17l2 2H6zm8.83-2L6.98 4.15c.01 0 .01-.01.02-.01V2h3v2h4V2h3v2.14c1.72.45 3 2 3 3.86v9.17l-2-2V12h-3.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8152a07aa4627c5b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.83 6l-3.7-3.7C5.42 1.55 6.15 1 7 1l10 .01c1.1 0 2 .89 2 1.99v13.17l-2-2V6H8.83zm10.95 16.61l-.91-.91c-.29.75-1.02 1.3-1.87 1.3H7c-1.1 0-2-.9-2-2V7.83L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM15.17 18L7 9.83V18h8.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$10ae45a5ccec421f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.83 3H21v2l-6.2 6.97L9.83 7h6.74l1.78-2H7.83l-2-2zm13.95 19.61L18 20.83V21H6v-2h5v-5l-1.37-1.54-8.24-8.24L2.8 2.81 3 3l18.19 18.19-1.41 1.42zM16.17 19L13 15.83V19h3.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$749bd65f36f59eda(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.93 13.93L2.45 2.45 1.04 3.87l5.3 5.3-.2.23H3.6c-.88 0-1.6.72-1.6 1.6v9.4c0 .88.72 1.6 1.6 1.6h12.8c.75 0 1.38-.52 1.55-1.22l2.18 2.18 1.41-1.41L18 18l-4.07-4.07zM10 20c-2.21 0-4-1.79-4-4 0-1.95 1.4-3.57 3.25-3.92l1.57 1.57c-.26-.09-.53-.15-.82-.15a2.5 2.5 0 000 5 2.5 2.5 0 002.5-2.5c0-.29-.06-.56-.15-.82l1.57 1.57A3.993 3.993 0 0110 20zm8-4.83L10.83 8h1.75l1.28 1.4h2.54c.88 0 1.6.72 1.6 1.6v4.17zm2.4-9.57H22L19 11V7h-1V2h4l-1.6 3.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6e2f14f4f0ea2066(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.35 8.52L11 5h5V1h2v4h5l-1.38 13.79L11.35 8.52zM1 21v1c0 .55.45 1 1 1h13c.55 0 1-.45 1-1v-1H1zm20.9.9L2.1 2.1.69 3.51l5.7 5.7C3.28 9.87 1 11.99 1 15h11.17l2 2H1v2h15v-.17l4.49 4.49 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$877e9f114376396(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11h-1v2h2v-1l9.73 9.73L20.46 23 14 16.54V21H3v-2h2V7.54l-4-4 1.27-1.27L11 11zm3 .49L5.51 3H14v1h5v12.49l-2-2V6h-3v5.49z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$675d0dbe16937cc0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.94 8.12L7.48 4.66 9 3h6l1.83 2H20c1.1 0 2 .9 2 2v12c0 .05-.01.1-.02.16l-5.1-5.1c.08-.35.12-.7.12-1.06 0-2.76-2.24-5-5-5-.36 0-.71.04-1.06.12zm9.55 15.19L18.17 21H4c-1.1 0-2-.9-2-2V7c0-.59.27-1.12.68-1.49l-2-2L2.1 2.1l19.8 19.8-1.41 1.41zm-6-5.99l-1.5-1.5c-.32.1-.64.18-.99.18-1.66 0-3-1.34-3-3 0-.35.08-.67.19-.98l-1.5-1.5A4.74 4.74 0 007 13c0 2.76 2.24 5 5 5 .91 0 1.76-.25 2.49-.68z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c2f3e6295debcf3d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM18.65 3c-1.66 0-2.54 1.27-3.18 2.03l-3.5 4.11L17 14.17v-7.9c.58-.68.97-1.27 1.65-1.27.77 0 1.35.66 1.35 1.48V7h2v-.52C22 4.56 20.52 3 18.65 3zm-7.98 7.67L2.81 2.81 1.39 4.22l7.97 7.97-2.66 3.12c-.55.65-.09 1.65.76 1.65h6.66l1.17 1.17C14.54 18.42 14 19.14 14 20c0 1.1.9 2 2 2 .86 0 1.58-.54 1.87-1.3l1.91 1.91 1.41-1.41-4.8-4.8-5.72-5.73zm2.8-5.64c.27-.32.58-.72.98-1.09a9.347 9.347 0 00-7.81-.13l4.25 4.25 2.58-3.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$52049c3876746872(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L1 11.4l1.21 1.59L4 11.62V21h16v-9.38l1.79 1.36L23 11.4 12 3zM8 15c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b5f51d2b57d0db9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "5.5",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ef7f1cf45a20f7e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 3.69 2.47 6.86 6 8.25V22h8v-1.75c3.53-1.39 6-4.56 6-8.25zm-2 0h-4V5.08c2.39 1.39 4 3.97 4 6.92zm-6-7.74V12h-4V4.26c.64-.16 1.31-.26 2-.26s1.36.1 2 .26zM4 12c0-2.95 1.61-5.53 4-6.92V12H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0d8f30358257bf9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18h-2v-2h2v2zm2-4H9v6h6v-6zm4-4.7V4h-3v2.6L12 3 2 12h3l7-6.31L19 12h3l-3-2.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e39126699da2c52a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11.26V6h3v4h2V4h-5V3H5v16H3v2h9.26A6.963 6.963 0 0111 17c0-2.38 1.19-4.47 3-5.74zM10 11h2v2h-2v-2zm11.69 5.37l1.14-1-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L19 12h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1c-.08.5-.08.76 0 1.26l-1.14 1 1 1.73 1.45-.49c.32.27.68.48 1.08.63L17 22h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1c.08-.51.08-.77 0-1.27zM18 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5d802fd6179e386f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17h20v2H2zm11.84-9.21A2.006 2.006 0 0012 5a2.006 2.006 0 00-1.84 2.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bd73653c1d5e4c4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M14 11h4v3h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ce04917c65f7949(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2a3.35 3.35 0 000 6.7zm2.5 7.23V13h-2.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2135f71205f2af8a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5a3.35 3.35 0 000 6.7h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$23b5f1984987501b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.12 5l-7.18 6.79c-.6.56-.94 1.35-.94 2.18V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 000-2.5H12v-1h7.75a1.25 1.25 0 000-2.5H12v-1h8.75a1.25 1.25 0 000-2.5H12v-1h6.75a1.25 1.25 0 000-2.5H8.86c.64-1.11 1.48-2.58 1.49-2.61a1.065 1.065 0 00-.12-1.23C10.22 6.12 9.12 5 9.12 5zM14 6.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75m0-1.5c-1.24 0-2.25 1.01-2.25 2.25S12.76 9.25 14 9.25 16.25 8.24 16.25 7 15.24 4.75 14 4.75zm5.75.75c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5m0-1.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM16.5 1c-.83 0-1.5.67-1.5 1.5S15.67 4 16.5 4 18 3.33 18 2.5 17.33 1 16.5 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$89f1d1f27f3e8311(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm13.97 21.49c-.63.23-1.29.4-1.97.51.68-.12 1.33-.29 1.97-.51zM12 22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.55 12zm10.43-1.61zM15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63a12.188 12.188 0 00-3.55 7.63c1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d424b0c8b2b04578(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-1.56c.35-.59.56-1.27.56-2 0-2.21-1.79-4-4-4-.34 0-.66.05-.98.13A4.707 4.707 0 0010 2.02c-1.89 0-3.51 1.11-4.27 2.71C4.15 5.26 3 6.74 3 8.5c0 1.86 1.28 3.41 3 3.86V21h11v-2h2c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2zM7 10.5c-1.1 0-2-.9-2-2 0-.85.55-1.6 1.37-1.88l.8-.27.36-.76C8 4.62 8.94 4.02 10 4.02c.79 0 1.39.35 1.74.65l.78.65S13.16 5 13.99 5c1.1 0 2 .9 2 2h-3C9.67 7 9.15 10.5 7 10.5zM19 17h-2v-6h2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$59e21a99538dbaab(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 5h-2.42v3.33H13v3.33h-2.58V18H6v-2h2.42v-3.33H11V9.33h2.58V6H18v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9fdf362758a5d563(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9 8.89l-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zm-2.99-3.9l1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01zM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5zM8.49 9.52L9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41a1.42 1.42 0 01-.33-1.07zm-4.45-.16L5.05 5h1.97l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17zM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c7a5b563de84089c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "20",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "20",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7v-.52C22 4.56 20.52 3 18.65 3c-1.66 0-2.54 1.27-3.18 2.03l-8.8 10.32C6.12 16 6.58 17 7.43 17H15c1.1 0 2-.9 2-2V6.27c.58-.68.97-1.27 1.65-1.27.77 0 1.35.66 1.35 1.48V7h2zM14.3 4.1a8.962 8.962 0 00-9.58.62l4.89 4.89L14.3 4.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$14f29f3ce404ebd6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V1h-8v9c0 1.86 1.28 3.41 3 3.86V21h-2v2h6v-2h-2v-7.14c1.72-.45 3-2 3-3.86zm-2-7v3h-4V3h4zm-7.5 8.5A2.5 2.5 0 0110 14H8v9H6v-9H4a2.5 2.5 0 010-5h2V8H4a2.5 2.5 0 010-5h2V1h2v2h2a2.5 2.5 0 010 5H8v1h2a2.5 2.5 0 012.5 2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3455fdcd6211abde(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4h2v2h-2V4zm-1 3h2v2h-2V7zm-2-3h2v2h-2V4zm7 5h-2V7h2v2zm1-3h-2V4h2v2zm2 3h-2V7h2v2zm1-3h-2V4h2v2zm-7.38 8.38L12.1 16.9c-2.5-1.43-4.57-3.5-6-6l2.52-2.52c.24-.24.34-.58.28-.9L8.16 3.8c-.09-.46-.5-.8-.98-.8H3.03c-.56 0-1.03.47-1 1.03.17 2.89 1.02 5.6 2.4 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.23 7.97 2.4.56.03 1.03-.44 1.03-1v-4.15c0-.48-.34-.89-.8-.98l-3.67-.73a.99.99 0 00-.91.27zM14 10h2v2h-2v-2zm-3 0h2v2h-2v-2zm8 2h-2v-2h2v2zm3 0h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1d395d688430ced(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 6.92L13 5.77V3.4c0-.26.22-.48.5-.48s.5.21.5.48V4h2v-.6C16 2.07 14.88 1 13.5 1S11 2.07 11 3.4v2.37L9.5 6.92 6 6.07l5.05 15.25c.15.45.55.68.95.68s.8-.23.95-.69L18 6.07l-3.5.85zM13.28 8.5l.76.58.92-.23L13 14.8V8.29l.28.21zm-3.32.59l.76-.58.28-.22v6.51L9.03 8.86l.93.23z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fdc33b9643466ac5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.5h1c1.33 0 2.71-.18 4-.5v3c-1.29-.32-2.67-.5-4-.5H2v-2zM16.17 19H8v-3h5.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-3.6-3.6zm2.66-3H22v3h-.17l-3-3zM11 17.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5zm11-4.74V15h-1.5v-2.23c0-2.24-1.76-4.07-4-4.07V7.2c1.02 0 1.85-.83 1.85-1.85S17.52 3.5 16.5 3.5V2c1.85 0 3.35 1.5 3.35 3.35 0 .93-.38 1.77-1 2.38 1.87.89 3.15 2.81 3.15 5.03zM11.15 8.32V8.3c0-1.85 1.5-3.35 3.35-3.35v1.5c-1.02 0-1.85.73-1.85 1.75s.83 2 1.85 2h1.53c1.87 0 3.47 1.35 3.47 3.16V15H18v-1.3c0-1.31-.92-2.05-1.97-2.05h-1.55l-3.33-3.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ce194a570d87661(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.5h1c1.33 0 2.71-.18 4-.5v3c-1.29-.32-2.67-.5-4-.5H2v-2zm20-.5v3H8v-3h14zm-11 1.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5zm11-4.74V15h-1.5v-2.23c0-2.24-1.76-4.07-4-4.07V7.2c1.02 0 1.85-.83 1.85-1.85S17.52 3.5 16.5 3.5V2c1.85 0 3.35 1.5 3.35 3.35 0 .93-.38 1.77-1 2.38 1.87.89 3.15 2.81 3.15 5.03zm-2.5.6V15H18v-1.3c0-1.31-.92-2.05-1.97-2.05H14.5a3.35 3.35 0 010-6.7v1.5c-1.02 0-1.85.73-1.85 1.75s.83 2 1.85 2h1.53c1.87 0 3.47 1.35 3.47 3.16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$67fe0664eb2307b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H3V8l13-5v7H7v11zm12-11c-1.1 0-2 .9-2 2H9v9h5v-5h2v5h5v-9c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e957e0fcb22133df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 8A2.5 2.5 0 0021 5.5C21 3.83 18.5 1 18.5 1S16 3.83 16 5.5A2.5 2.5 0 0018.5 8zm-5 1c.83 0 1.5-.67 1.5-1.5 0-.84-1.5-2.5-1.5-2.5S12 6.66 12 7.5c0 .83.67 1.5 1.5 1.5zM9.12 5l-7.18 6.79c-.6.56-.94 1.35-.94 2.18V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 000-2.5H12v-1h7.75a1.25 1.25 0 000-2.5H12v-1h8.75a1.25 1.25 0 000-2.5H12v-1h6.75a1.25 1.25 0 000-2.5H8.86c.64-1.11 1.48-2.58 1.49-2.61a1.065 1.065 0 00-.12-1.23C10.22 6.12 9.12 5 9.12 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2652972f0ac5ac4b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L2 12h3v8h14v-8h3L12 3zm0 13c-1.1 0-2-.9-2-2s2-4 2-4 2 2.9 2 4-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5abb693bac2c692(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm5.5 6.95V9c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v6h2v7h3.5v-.11c-1.24-1.26-2-2.99-2-4.89 0-2.58 1.41-4.84 3.5-6.05zM16.5 17c0 1.65-1.35 3-3 3s-3-1.35-3-3c0-1.11.61-2.06 1.5-2.58v-2.16c-2.02.64-3.5 2.51-3.5 4.74 0 2.76 2.24 5 5 5s5-2.24 5-5h-2zm3.04-3H15V8h-2v8h5.46l2.47 3.71 1.66-1.11-3.05-4.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fab04205ca8a2237(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-3H7v-1c0-2.76 2.24-5 5-5s5 2.24 5 5v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a655687d3031bfd9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.78V8c0-1.65-1.35-3-3-3h-4c-.77 0-1.47.3-2 .78-.53-.48-1.23-.78-2-.78H6C4.35 5 3 6.35 3 8v2.78c-.61.55-1 1.34-1 2.22v6h2v-2h16v2h2v-6c0-.88-.39-1.67-1-2.22zM14 7h4c.55 0 1 .45 1 1v2h-6V8c0-.55.45-1 1-1zM5 8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v2H5V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f4ed2704b4cd2d4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 16c-2.64 0-5.13-1.03-7-2.9l1.06-1.06c.34.34.71.65 1.1.92L8 13.5V9.51l-1.55.99-.95-1L7 7.76 6 7h3.65l1.73 3H17v1h-1v2.5l.84 1.46c.39-.28.76-.58 1.1-.92L19 15.1a9.842 9.842 0 01-7 2.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.69 14.24a7.72 7.72 0 01-5.4 0l-.81 1.41-.03.06c1.1.52 2.28.79 3.53.79s2.45-.28 3.55-.79l-.03-.06-.81-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$890c96d21e0bf61(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8.5h6v2H9zM15.64 12H8.37a.87.87 0 00-.87.87h.01V14h9v-1.13a.87.87 0 00-.87-.87z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 15h-1.5v-1.5h-9V17H6v-4.13c0-1 .62-1.85 1.5-2.2V9c0-1.1.9-2 2-2h5c1.1 0 2 .9 2 2v1.67c.88.35 1.5 1.2 1.5 2.2V17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d186c82228d1459b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12h-9c-.55 0-1 .45-1 1v1h11v-1c0-.55-.45-1-1-1zM7.25 8.5h4v2h-4zM12.75 8.5h4v2h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 15h-1.5v-1.5h-11V17H5v-3.83c0-.66.25-1.26.65-1.72V9c0-1.1.9-2 2-2H11c.37 0 .72.12 1 .32.28-.2.63-.32 1-.32h3.35c1.1 0 2 .9 2 2v2.45c.4.46.65 1.06.65 1.72V17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c7e09249776e73ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.13 15.13L18 3h-4V2h-4v1H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2.23l.64 4.13C6.74 16.05 6 17.43 6 19v1c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-1c0-1.57-.74-2.95-1.87-3.87zM5 9V5h1.31l.62 4H5zm7 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.29-5H9.72L8.33 5h7.34l-1.38 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ea4df48ba504e310(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L4 9v12h16V9l-8-6zm4 13.06L14 15v1c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1l2-1.06v4.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$412ba32e0f86db36(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1l2 1.06v-4.12L18 14v-1zM12 3L4 9v12h16v-2H6v-9l6-4.5 6 4.5v1h2V9l-8-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1452538da729b3e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h1v2H7c-1.1 0-2 .9-2 2v7h2v-3h10v3h2v-7c0-1.1-.9-2-2-2h-1v-2h1zM7 8V5h10v3H7zm10 8H7v-2h10v2zm-3-4h-4v-2h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c5e5530950efde50(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11v2h10v-2c0-1.86 1.28-3.41 3-3.86V6c0-1.65-1.35-3-3-3H7C5.35 3 4 4.35 4 6v1.14c1.72.45 3 2 3 3.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9c-1.1 0-2 .9-2 2v4H5v-4c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.65 1.35 3 3 3v1c0 .55.45 1 1 1s1-.45 1-1v-1h12v1c0 .55.45 1 1 1s1-.45 1-1v-1c1.65 0 3-1.35 3-3v-5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$626b1935b6b61735(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V4h2V2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14v-2h-4.03A4.966 4.966 0 0018 16v-5H8v5c0 1.64.81 3.09 2.03 4H6V4h2v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "9",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eb3b7ba0a3420aa2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 3H6c-1.1 0-2 .9-2 2v5.71c0 3.83 2.95 7.18 6.78 7.29 3.96.12 7.22-3.06 7.22-7v-1h.5c1.93 0 3.5-1.57 3.5-3.5S20.43 3 18.5 3zM16 5v3H6V5h10zm2.5 3H18V5h.5c.83 0 1.5.67 1.5 1.5S19.33 8 18.5 8zM4 19h16v2H4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a8e96a4efe35d68(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-9 8.3c0 .93-.64 1.71-1.5 1.93V19H8v-6.77c-.86-.22-1.5-1-1.5-1.93V6.5c0-.28.22-.5.5-.5s.5.22.5.5V9h.75V6.5c0-.28.22-.5.5-.5s.5.22.5.5V9H10V6.5c0-.28.23-.5.5-.5.28 0 .5.22.5.5v3.8zm4.58 2.29l-.08.03V19H14v-6.38l-.08-.04c-.97-.47-1.67-1.7-1.67-3.18 0-1.88 1.13-3.4 2.5-3.4 1.38 0 2.5 1.53 2.5 3.41 0 1.48-.7 2.71-1.67 3.18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b03406340ff71a04(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-8-6H9v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f6cc9a063b55c13b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-4-6h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3a20679891882f94(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V5c0-1.1-.9-2-2-2h-5.25v16h-1.5V3H6c-1.1 0-2 .9-2 2v14H3v2h18v-2h-1zm-10-6H8v-2h2v2zm6 0h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0e1146cd026a083(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L4 9v12h16V9l-8-6zm0 14.5c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1zm4-1.5H8v-1h1v-2.34c0-1.54.82-2.82 2.25-3.16v-.25c0-.41.34-.75.75-.75s.75.34.75.75v.25c1.44.34 2.25 1.62 2.25 3.16V15h1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5fbb76bb2cca656c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8l-5-5zM7 7h5v2H7V7zm10 10H7v-2h10v2zm0-4H7v-2h10v2zm-2-4V5l4 4h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c153c9b40fbe4fd8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7.08c0 1.77-.84 3.25-2 3.82V21h-2V10.9c-1.16-.57-2-2.05-2-3.82C10.01 4.83 11.35 3 13 3c1.66 0 3 1.83 3 4.08zM17 3v18h2v-8h2V7c0-1.76-1.24-4-4-4zM8.28 3c-.4 0-.72.32-.72.72V7h-.84V3.72C6.72 3.32 6.4 3 6 3s-.72.32-.72.72V7h-.84V3.72c0-.4-.32-.72-.72-.72S3 3.32 3 3.72V9c0 1.1.9 2 2 2v10h2V11c1.1 0 2-.9 2-2V3.72c0-.4-.32-.72-.72-.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db49d08086244765(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.33 7.5l-.66 2h8.66l-.66-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 15.69c0 .45-.35.81-.78.81h-.44c-.44 0-.78-.36-.78-.81V16.5H7v1.19c0 .45-.35.81-.78.81h-.44c-.43 0-.78-.36-.78-.81v-6.5c.82-2.47 1.34-4.03 1.56-4.69.05-.16.12-.29.19-.4.02-.02.03-.04.05-.06.38-.53.92-.54.92-.54h8.56s.54.01.92.53c.02.03.03.05.05.07.07.11.14.24.19.4.22.66.74 2.23 1.56 4.69v6.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e2806de495d704c3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.06V3h-2v3.06c-4.5.5-8 4.31-8 8.93C3 16.1 3.9 17 5.01 17H8c0 2.21 1.79 4 4 4s4-1.79 4-4h2.99c1.11 0 2.01-.9 2.01-2.01 0-4.62-3.5-8.43-8-8.93zM12 15H5c0-3.86 3.14-7 7-7s7 3.14 7 7h-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$895f1eefd807f5ca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 11.5c-.55 0-1 .45-1 1v2h-7v-2c0-.55-.45-1-1-1s-1 .45-1 1V16c0 .28.22.5.5.5h10c.28 0 .5-.22.5-.5v-3.5c0-.55-.45-1-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12.5v.5h4v-.5c0-1.3.99-2.35 2.25-2.47V9c0-.83-.67-1.5-1.5-1.5h-5.5c-.83 0-1.5.67-1.5 1.5v1.03A2.48 2.48 0 0110 12.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 14c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2v-3.5c0-.92.51-1.72 1.25-2.15V9c0-1.66 1.34-3 3-3h5.5c1.66 0 3 1.34 3 3v1.35c.74.43 1.25 1.23 1.25 2.15V16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c76f8c9aa92b9d43(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9H2V7h5v2zm0 3H2v2h5v-2zm13.59 7l-3.83-3.83c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L22 17.59 20.59 19zM17 11c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3zM2 19h10v-2H2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c74db7f9608eed0a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c0 .74-.4 1.38-1 1.72V22h-2v-8.28c-.6-.35-1-.98-1-1.72 0-1.1.9-2 2-2s2 .9 2 2zm-2-6c-3.31 0-6 2.69-6 6 0 1.74.75 3.31 1.94 4.4l1.42-1.42A3.957 3.957 0 018 12c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.19-.53 2.25-1.36 2.98l1.42 1.42A5.957 5.957 0 0018 12c0-3.31-2.69-6-6-6zm0-4C6.48 2 2 6.48 2 12c0 2.85 1.2 5.41 3.11 7.24l1.42-1.42A7.987 7.987 0 014 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 2.29-.98 4.36-2.53 5.82l1.42 1.42C20.8 17.41 22 14.85 22 12c0-5.52-4.48-10-10-10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$88072b919f1a0dcb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "17",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "17",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "17",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.08V3h-2v2.08C7.61 5.57 5 8.47 5 12v2h14v-2c0-3.53-2.61-6.43-6-6.92z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "20",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "20",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "20",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6f2ebda83a8db8bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.5C22 5.57 17.52 4 12 4S2 5.57 2 7.5c0 1.81 3.95 3.31 9 3.48V15H9.35c-.82 0-1.55.5-1.86 1.26L6 20h2l1.2-3h5.6l1.2 3h2l-1.5-3.74c-.3-.76-1.04-1.26-1.85-1.26H13v-4.02c5.05-.17 9-1.67 9-3.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$767ec46060706de8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.96 9.73l-1.43-5a.996.996 0 00-.96-.73H4.43c-.45 0-.84.3-.96.73l-1.43 5c-.18.63.3 1.27.96 1.27h2.2L4 20h2l.67-5h10.67l.66 5h2l-1.2-9H21c.66 0 1.14-.64.96-1.27zM6.93 13l.27-2h9.6l.27 2H6.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$38a9c6c39ded2909(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11V3H5c-1.1 0-2 .9-2 2v6h8zm2 0h8V5c0-1.1-.9-2-2-2h-6v8zm-2 2H3v6c0 1.1.9 2 2 2h6v-8zm2 0v8h6c1.1 0 2-.9 2-2v-6h-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$26d5f6b0e784e202(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 8.22a1.562 1.562 0 012.45-1.28l-.01-.12c0-.86.7-1.56 1.56-1.56s1.56.7 1.56 1.56l-.01.12A1.562 1.562 0 0116 8.22c0 .62-.37 1.16-.89 1.4.52.25.89.79.89 1.41 0 .86-.7 1.56-1.56 1.56-.33 0-.64-.11-.89-.28l.01.12c0 .86-.7 1.56-1.56 1.56s-1.56-.7-1.56-1.56l.01-.12A1.562 1.562 0 018 11.03c0-.62.37-1.16.89-1.4C8.37 9.38 8 8.84 8 8.22zM12 19c-3.31 0-6-2.69-6-6 3.31 0 6 2.69 6 6 0-3.31 2.69-6 6-6 0 3.31-2.69 6-6 6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "9.62",
                    "r": "1.56"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$15fd492ca89fe769(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12.5h1.5V14H13zM13 10h1.5v1.5H13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 12H8.5v-4.5H7V9h3v6zm6-1c0 .55-.45 1-1 1h-2.5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1H15c.55 0 1 .45 1 1v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16c8ee864c3096a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 002 9.43V10h8v-.57zM18 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 0014 9.43V10h8v-.57zM19 17v-2.01L5 15v2l-3-3 3-3v2.01L19 13v-2l3 3-3 3zm-9 2v-1H7.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h2c.28 0 .5-.22.5-.5V20c0-.28-.22-.5-.5-.5H8V19h2zm-1 1.5v.5H8v-.5h1zm8.5-1.5h-1v3h-1v-3h-1v-1h3v1zm-5 0v.5h1v1h-1V22h-1v-4H14v1h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a342a9b3857bdfc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.22 22.61c-.4.15-.8.29-1.22.39-5.16-1.26-9-6.45-9-12V5l9-4 9 4v6c0 .9-.11 1.78-.3 2.65-.81-.41-1.73-.65-2.7-.65-3.31 0-6 2.69-6 6 0 1.36.46 2.61 1.22 3.61zM19 20v2.99s-1.99.01-2 0V20h-3v-2h3v-3h2v3h3v2h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$59c955913642243e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9V7h-2V2.84A9.929 9.929 0 0011.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12c0-1.05-.17-2.05-.47-3H18zm-2.5-1c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm3.5 9.5c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5zM22 3h2v2h-2v2h-2V5h-2V3h2V1h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4a467305ccaafb52(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.36 18.78L6.61 21l1.62-1.54 2.77-7.6c-.68-.17-1.28-.51-1.77-.98l-2.87 7.9zM14.77 10.88c-.49.47-1.1.81-1.77.98l2.77 7.6L17.39 21l.26-2.22-2.88-7.9zM15 8c0-1.3-.84-2.4-2-2.82V3h-2v2.18C9.84 5.6 9 6.7 9 8c0 1.66 1.34 3 3 3s3-1.34 3-3zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3150a451a1a372c4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.5",
                    "cy": "4.5",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 17.72l-.64-6.37A1.49 1.49 0 0017.64 10H16c-1.5-.02-2.86-.54-3.76-1.44l-2-1.98A1.95 1.95 0 008.83 6c-.51 0-1.02.2-1.41.59L4.08 9.91c-.53.68-.51 1.57-.21 2.13l1.43 2.8-3.15 4.05 1.57 1.24L7.4 15.4l-.17-1.36.77.71V20h2v-6.12l-2.12-2.12 2.36-2.36c.94.94 1.72 1.82 3.59 2.32L13 20h1.5l.41-3.5h3.18l.14 1.22c-.44.26-.73.74-.73 1.28 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.54-.29-1.02-.73-1.28zM15.09 15l.41-3.5h2l.41 3.5h-2.82z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cf0afddda7e43393(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 24c-3.26 0-6.19-1.99-7.4-5.02l-3.03-7.61a1 1 0 011.24-1.32l.79.26c.56.18 1.02.61 1.24 1.16L7.25 15H8V3.25a1.25 1.25 0 012.5 0V12h1V1.25a1.25 1.25 0 012.5 0V12h1V2.75a1.25 1.25 0 012.5 0V12h1V5.75a1.25 1.25 0 012.5 0V16c0 4.42-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$27443f7dbac055e0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "3.5",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.13 7.12c-.17-.35-.44-.65-.8-.85a1.98 1.98 0 00-1.93-.03v-.01L4 9.3V14h2v-3.54l1.5-.85C7.18 10.71 7 11.85 7 13v5.33L4.4 21.8 6 23l3-4 .22-3.54L11 18v5h2v-6.5l-1.97-2.81c-.04-.52-.14-1.76.45-3.4.75 1.14 1.88 1.98 3.2 2.41L20.63 23l.87-.5-5.48-9.5H17v-2c-.49 0-2.88.17-4.08-2.21"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f0b38272dfc38fc5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.5c.97 0 1.75-.78 1.75-1.75S12.97 4 12 4s-1.75.78-1.75 1.75S11.03 7.5 12 7.5zM14 20v-5h1v-4.5c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2V15h1v5h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8b3fd1c045d3ec08(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a2 2 0 002-2c0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$52d049e35c72450a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 12a2.5 2.5 0 01-5 0 2.5 2.5 0 015 0zm7.5 0c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zm-2 0h-4c0-2.21-1.79-4-4-4s-4 1.79-4 4H4c0 4.41 3.59 8 8 8s8-3.59 8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ed1cbf62ba54d793(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.99 5l.63 1.37 1.37.63-1.37.63L16.99 9l-.63-1.37L14.99 7l1.37-.63.63-1.37M11 6.13V4h2c.57 0 1.1.17 1.55.45l1.43-1.43A4.899 4.899 0 0013 2H7.5v2H9v2.14A5.007 5.007 0 005.26 9.5h3.98L15 11.65v-.62a5 5 0 00-4-4.9zM1 22h4V11H1v11zm19-5h-7l-2.09-.73.33-.94L13 16h2.82c.65 0 1.18-.53 1.18-1.18 0-.49-.31-.93-.77-1.11L8.97 11H7v9.02L14 22l8-3c-.01-1.1-.89-2-2-2zm0-3c1.1 0 2-.9 2-2s-2-4-2-4-2 2.9-2 4 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6bb007a780e3c24(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-.5 4.5h-2v-3h2v3zM8 13v1c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1H6.5v-.5h-2v3h2V13H8zm12.5 2.5h-2v1h3V18H17v-2.5c0-.55.45-1 1-1h2v-1h-3V12h3.5c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a2e55815c02b3133(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.87 11.81A2.5 2.5 0 0115 8h1c1.51 0 2-1 2-1s.55 6-3 6c-.49 0-.94-.14-1.32-.38-.24.64-.59 1.76-.76 2.96 1.26.22 2.28.89 2.77 1.77A6.505 6.505 0 0018.5 12h3c0 5.24-4.26 9.5-9.5 9.5S2.5 17.24 2.5 12 6.76 2.5 12 2.5V0l4 4-4 4V5.5c-3.58 0-6.5 2.92-6.5 6.5 0 2.21 1.11 4.17 2.81 5.35.51-.92 1.63-1.62 2.98-1.8-.09-.69-.26-1.42-.49-2.03-.35.3-.8.48-1.3.48-1.1 0-2-.9-2-2v-.99c0-.56-.19-1.09-.5-1.51 0 0 4.45-.23 4.5 2.5 0 .29-.06.56-.17.8-.42-.32-.86-.6-1.33-.8.58.43 1.37 1.37 2 2.6.67-1.62 1.68-3.27 3-4.6-.76.52-1.47 1.12-2.13 1.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e34888649e793f7c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14H9a9 9 0 019-9v2c-3.87 0-7 3.13-7 7zm7-3V9c-2.76 0-5 2.24-5 5h2c0-1.66 1.34-3 3-3zM7 4c0-1.11-.89-2-2-2s-2 .89-2 2 .89 2 2 2 2-.89 2-2zm4.45.5h-2A2.99 2.99 0 016.5 7h-3C2.67 7 2 7.67 2 8.5V11h6V8.74a4.97 4.97 0 003.45-4.24zM19 17c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm1.5 1h-3a2.99 2.99 0 01-2.95-2.5h-2A4.97 4.97 0 0016 19.74V22h6v-2.5c0-.83-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$93899a23fd6a2f16(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.783 15.172l2.121-2.121 5.996 5.996-2.121 2.121zM17.5 10c1.93 0 3.5-1.57 3.5-3.5 0-.58-.16-1.12-.41-1.6l-2.7 2.7-1.49-1.49 2.7-2.7c-.48-.25-1.02-.41-1.6-.41C15.57 3 14 4.57 14 6.5c0 .41.08.8.21 1.16l-1.85 1.85-1.78-1.78.71-.71-1.41-1.41L12 3.49a3 3 0 00-4.24 0L4.22 7.03l1.41 1.41H2.81l-.71.71 3.54 3.54.71-.71V9.15l1.41 1.41.71-.71 1.78 1.78-7.41 7.41 2.12 2.12L16.34 9.79c.36.13.75.21 1.16.21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e0e912313666b3bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.95 10.99c-1.79-.03-3.7-1.95-2.68-4.22-2.98 1-5.77-1.59-5.19-4.56C6.95.71 2 6.58 2 12c0 5.52 4.48 10 10 10 5.89 0 10.54-5.08 9.95-11.01zM8.5 15c-.83 0-1.5-.67-1.5-1.5S7.67 12 8.5 12s1.5.67 1.5 1.5S9.33 15 8.5 15zm2-5C9.67 10 9 9.33 9 8.5S9.67 7 10.5 7s1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7649a1ed528e5b6f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.25 10.5c-.41 0-.75.34-.75.75h-1.54a6.978 6.978 0 00-1.52-3.65l1.09-1.09.01.01c.29.29.77.29 1.06 0s.29-.77 0-1.06L18.54 4.4a.754.754 0 00-1.06 0c-.29.29-.29.76-.01 1.05l-1.09 1.09a7.015 7.015 0 00-3.64-1.51V3.5h.01c.41 0 .75-.34.75-.75S13.16 2 12.75 2h-1.5c-.41 0-.75.34-.75.75s.33.74.74.75v1.55c-1.37.14-2.62.69-3.64 1.51L6.51 5.47l.01-.01c.29-.29.29-.77 0-1.06a.754.754 0 00-1.06 0L4.4 5.46c-.29.29-.29.77 0 1.06.29.29.76.29 1.05.01l1.09 1.09a6.89 6.89 0 00-1.5 3.63H3.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5c0 .41.34.75.75.75s.75-.34.75-.75h1.54c.15 1.37.69 2.61 1.5 3.63l-1.09 1.09a.742.742 0 00-1.05.01c-.29.29-.29.77 0 1.06l1.06 1.06c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06l-.01-.01 1.09-1.09c1.02.82 2.26 1.36 3.63 1.51v1.55c-.41.01-.74.34-.74.75s.34.75.75.75h1.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-.01v-1.54c1.37-.14 2.62-.69 3.64-1.51l1.09 1.09c-.29.29-.28.76.01 1.05.29.29.77.29 1.06 0l1.06-1.06c.29-.29.29-.77 0-1.06a.754.754 0 00-1.06 0l-.01.01-1.09-1.09a7.025 7.025 0 001.52-3.65h1.54c0 .41.34.75.75.75s.75-.34.75-.75v-1.5c.01-.4-.33-.74-.74-.74zM13.75 8c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM12 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1.75-5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM8.5 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1.75 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3.5 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm.75-4c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$705713c565c0eb0c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.84 14.52c-.26-.19-.62-.63-.79-.84C17.24 12.01 19 8.87 19 5c0-1.95-.74-3-2-3-1.54 0-3.96 2.06-5 5.97C10.96 4.06 8.54 2 7 2 5.74 2 5 3.05 5 5c0 3.87 1.76 7.01 2.95 8.68-.17.21-.53.65-.79.84-.5.41-1.66 1.37-1.66 2.98 0 2.21 1.79 4 4 4 1.55 0 2.5-.56 2.5-.56s.95.56 2.5.56c2.21 0 4-1.79 4-4 0-1.61-1.16-2.57-1.66-2.98zM9.35 12.2C8.34 10.7 7 8.12 7 5c0-.49.06-.8.12-.97.94.31 3.24 2.71 3.38 7.64-.47.12-.84.3-1.15.53zm1.15 4.55c-.28 0-.5-.34-.5-.75s.22-.75.5-.75.5.34.5.75-.22.75-.5.75zM12 19.5c-.55 0-1-.72-1-1s.45-.5 1-.5 1 .22 1 .5-.45 1-1 1zm1.5-2.75c-.28 0-.5-.34-.5-.75s.22-.75.5-.75.5.34.5.75-.22.75-.5.75zm0-5.08c.14-4.93 2.44-7.33 3.38-7.64.06.17.12.48.12.97 0 3.12-1.34 5.7-2.35 7.2-.31-.23-.68-.41-1.15-.53z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d8494b06050efce9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.47V5.35C20.05 4.77 16.56 4 12 4c-2.15 0-4.11.86-5.54 2.24.13-.85.4-2.4 1.01-4.24H5.35C4.77 3.95 4 7.44 4 12c0 2.15.86 4.11 2.24 5.54-.85-.14-2.4-.4-4.24-1.01v2.12C3.95 19.23 7.44 20 12 20c2.15 0 4.11-.86 5.54-2.24-.14.85-.4 2.4-1.01 4.24h2.12c.58-1.95 1.35-5.44 1.35-10 0-2.15-.86-4.11-2.24-5.54.85.13 2.4.4 4.24 1.01zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c1c46b39c19c292f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9L12 2 2 9h9v13h2V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.14 12l-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9zM19.1 16H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2f068fc8a3a30144(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13V5c0-1.66-1.34-3-3-3S6 3.34 6 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-2V5c0-.55.45-1 1-1s1 .45 1 1v1H9v1h1v2H9v1h1v1H8zm13-4.5c0-.84-1.5-2.5-1.5-2.5S18 5.66 18 6.5c0 .83.67 1.5 1.5 1.5S21 7.33 21 6.5zm-4 3c0-.84-1.5-2.5-1.5-2.5S14 8.66 14 9.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5zm4 3c0-.84-1.5-2.5-1.5-2.5S18 11.66 18 12.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2abdd6138ff6bc64(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "14",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.22 17.58A2.01 2.01 0 000 19.43V21h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "14",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.78 17.58A6.95 6.95 0 0020 17c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V21H24v-1.57c0-.81-.48-1.53-1.22-1.85zM16.24 16.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 19.39V21h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.48 10.86C2.17 10.1 2 9.36 2 8.6 2 6.02 4.02 4 6.6 4c2.68 0 3.82 1.74 5.4 3.59C13.57 5.76 14.7 4 17.4 4 19.98 4 22 6.02 22 8.6c0 .76-.17 1.5-.48 2.26.65.31 1.18.82 1.53 1.44.6-1.2.95-2.42.95-3.7C24 4.9 21.1 2 17.4 2c-2.09 0-4.09.97-5.4 2.51C10.69 2.97 8.69 2 6.6 2 2.9 2 0 4.9 0 8.6c0 1.28.35 2.5.96 3.7.35-.62.88-1.13 1.52-1.44z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$488f4415f3968a3b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1 15.9l1.42-1.42C8.79 12.05 7 10.41 7 8.85 7 7.8 7.8 7 8.85 7c1.11 0 1.54.65 2.68 2h.93c1.12-1.31 1.53-2 2.68-2 .87 0 1.55.54 1.77 1.32.35-.04.68-.06 1-.06.36 0 .7.03 1.03.08C18.7 6.43 17.13 5 15.15 5c-.12 0-.23.03-.35.04.12-.33.2-.67.2-1.04 0-1.66-1.34-3-3-3S9 2.34 9 4c0 .37.08.71.2 1.04-.12-.01-.23-.04-.35-.04C6.69 5 5 6.69 5 8.85c0 2.42 2.04 4.31 5.1 7.05z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.5 16.24c-.32-.18-.66-.29-1-.35.07-.1.15-.18.21-.28 1.08-1.87.46-4.18-1.41-5.26-2.09-1.21-4.76-.39-8.65.9l.52 1.94c3.47-1.14 5.79-1.88 7.14-1.1.91.53 1.2 1.61.68 2.53-.56.96-1.33 1-3.07 1.32l-.47.81c.58 1.62.97 2.33.39 3.32-.53.91-1.61 1.2-2.53.68-.06-.03-.11-.09-.17-.13-.3.67-.64 1.24-1.03 1.73.07.04.13.09.2.14 1.87 1.08 4.18.46 5.26-1.41.06-.1.09-.21.14-.32.22.27.48.51.8.69 1.43.83 3.27.34 4.1-1.1s.32-3.29-1.11-4.11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.32 14.01c-.74 3.58-1.27 5.95-2.62 6.73-.91.53-2 .24-2.53-.68-.56-.96-.2-1.66.39-3.32l-.46-.81c-1.7-.31-2.5-.33-3.07-1.32-.53-.91-.24-2 .68-2.53.09-.05.19-.08.29-.11-.35-.56-.64-1.17-.82-1.85-.16.07-.32.14-.48.23-1.87 1.08-2.49 3.39-1.41 5.26.06.1.14.18.21.28-.34.06-.68.17-1 .35-1.43.83-1.93 2.66-1.1 4.1s2.66 1.93 4.1 1.1c.32-.18.58-.42.8-.69.05.11.08.22.14.32 1.08 1.87 3.39 2.49 5.26 1.41 2.09-1.21 2.71-3.93 3.55-7.94l-1.93-.53z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$446779f19f2d1557(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.32 13.01c.96.02 1.85.5 2.45 1.34A3.961 3.961 0 0012 16c1.29 0 2.5-.62 3.23-1.66.6-.84 1.49-1.32 2.45-1.34-.72-1.22-3.6-2-5.68-2-2.07 0-4.96.78-5.68 2.01zM4 13c1.66 0 3-1.34 3-3S5.66 7 4 7s-3 1.34-3 3 1.34 3 3 3zM20 13c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zM12 10c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14h-3.27c-.77 0-1.35.45-1.68.92-.04.06-1.36 2.08-4.05 2.08-1.43 0-3.03-.64-4.05-2.08-.39-.55-1-.92-1.68-.92H3c-1.1 0-2 .9-2 2v4h7v-2.26c1.15.8 2.54 1.26 4 1.26s2.85-.46 4-1.26V20h7v-4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ccbadd06b9d573d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h14v-2h-4v-2h2v-2h-2v-2h2v-2h-2V9h8v6h2V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm14 12v2h-2v2h-2v-2h-2v-2h2v-2h2v2h2zm-6-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d72c0a324278813f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5b820ddf4df9574c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 4.5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2.72 16.4l.76.27a5.933 5.933 0 004.34-.17L22 22.13c-1.05.55-2.24.87-3.5.87-.86 0-1.68-.14-2.45-.41L2 17.47l.5-1.41 6.9 2.51 1.72-4.44-3.57-3.73c-.89-.94-.67-2.47.45-3.12l3.48-2.01c1.1-.64 2.52-.1 2.91 1.11l.33 1.08a5.017 5.017 0 002.83 3.14l.52-1.6 1.43.46-1.12 3.45A7.029 7.029 0 0113 8.59l-2.53 1.45 3.03 3.46-2.22 5.76 3.09 1.12 2.1-6.44c.46.18.94.31 1.44.41l-2.13 6.55z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$65fd773fdbf3207d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.58 6.25l1.77 1.77L14.37 13H12.6v-1.77l4.98-4.98zm3.27-.44l-1.06-1.06c-.2-.2-.51-.2-.71 0l-.85.85L20 7.37l.85-.85c.2-.2.2-.52 0-.71zM18 12.2V17h2v2H4v-2h2v-7c0-2.79 1.91-5.14 4.5-5.8v-.7c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.7c.82.21 1.57.59 2.21 1.09L10.6 10.4V15h4.6l2.8-2.8zM10 20h4c0 1.1-.9 2-2 2s-2-.9-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4ced2fd46a911632(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 11c-1.56 0-2.92-.9-3.58-2.21l-.79-1.67C14.12 7.1 13.63 6 12.34 6 8.72 6 6 16.69 6 19h2.5l-2.1 2.8L8 23l3-4h2v4h2v-4.03L13 13l.49-2.71A6.02 6.02 0 0017 12.81v.69h1v-1c0-.28.22-.5.5-.5s.5.22.5.5V23h1V12.5c0-.83-.67-1.5-1.5-1.5zM11.6 2.91c-.06.19-.1.38-.1.59 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2c-.21 0-.4.04-.59.1-.15-.35-.5-.6-.91-.6-.55 0-1 .45-1 1 0 .41.25.76.6.91z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9f35d53e2ccf7067(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6.5 7V23h-1V12.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v1h-1v-.69a6.02 6.02 0 01-3.51-2.52c-.31.87-.49 1.78-.49 2.71 0 .23.02.46.03.69L15 16.5V23h-2v-5l-1.78-2.54L11 19l-3 4-1.6-1.2L9 18.33V13c0-1.15.18-2.29.5-3.39l-1.5.85V14H6V9.3l5.4-3.07v.01a2 2 0 011.94.03c.36.21.63.51.8.85l.79 1.67A3.987 3.987 0 0018.5 11c.83 0 1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$357336c95e3f71b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM8.5 8c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zM12 18c-2.28 0-4.22-1.66-5-4h10c-.78 2.34-2.72 4-5 4zm3.5-7c-.83 0-1.5-.67-1.5-1.5S14.67 8 15.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$425e49ac01540bdb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94A5.01 5.01 0 0011 15.9V19H7v2h10v-2h-4v-3.1a5.01 5.01 0 003.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e0287b6fa6905a6a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9l-1-2H7V5.72c.6-.34 1-.98 1-1.72 0-1.1-.9-2-2-2s-2 .9-2 2c0 .74.4 1.38 1 1.72V21h2v-4h5l1 2h7V9h-6zm4 8h-4l-1-2H7V9h5l1 2h5v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$57f00b321a5f5d56(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H9v2.4l1.81 1.45c.12.09.19.24.19.39v4.26c0 .28-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5V7.24c0-.15.07-.3.19-.39L8 5.4V3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 002-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$747620bcb9d46d6a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.94 4.88A1.32 1.32 0 0020.68 4H19.6l-.31-.97C19.15 2.43 18.61 2 18 2s-1.15.43-1.29 1.04L16.4 4h-1.07c-.57 0-1.08.35-1.26.88-.19.56.04 1.17.56 1.48l.87.52-.4 1.24c-.23.58-.04 1.25.45 1.62.23.17.51.26.78.26.31 0 .61-.11.86-.32l.81-.7.81.7c.25.21.55.32.86.32.27 0 .55-.09.78-.26.5-.37.68-1.04.45-1.62l-.39-1.24.87-.52c.51-.31.74-.92.56-1.48zM18 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM13.49 10.51c-.43-.43-.94-.73-1.49-.93V8h-1v1.38c-.11-.01-.23-.03-.34-.03-1.02 0-2.05.39-2.83 1.17-.16.16-.3.34-.43.53L6 10.52a3.01 3.01 0 00-3.83 1.82c-.27.75-.23 1.57.12 2.29.23.48.58.87 1 1.16-.38 1.35-.06 2.85 1 3.91a3.981 3.981 0 003.91 1c.29.42.68.77 1.16 1 .42.2.85.3 1.29.3.34 0 .68-.06 1.01-.17a3.007 3.007 0 001.82-3.85l-.52-1.37c.18-.13.36-.27.53-.43.87-.87 1.24-2.04 1.14-3.17H16v-1h-1.59c-.19-.55-.49-1.06-.92-1.5zm-8.82 3.78c-.25-.09-.45-.27-.57-.51s-.13-.51-.04-.76c.19-.52.76-.79 1.26-.61l3.16 1.19c-1.15.6-2.63 1.11-3.81.69zm6.32 5.65c-.25.09-.52.08-.76-.04a.989.989 0 01-.51-.57c-.42-1.18.09-2.65.7-3.8l1.18 3.13c.18.52-.09 1.1-.61 1.28zm1.21-5.34l-.61-1.61c0-.01-.01-.02-.02-.03l-.06-.12a.673.673 0 00-.07-.11l-.09-.09-.09-.09c-.03-.03-.07-.05-.11-.07-.04-.02-.07-.05-.12-.06-.01 0-.02-.01-.03-.02l-1.6-.6a1.966 1.966 0 012.67.13c.73.73.77 1.88.13 2.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5893929652ed4791(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-.46 0-.93.04-1.4.14-2.76.53-4.96 2.76-5.48 5.52-.48 2.61.48 5.01 2.22 6.56.43.38.66.91.66 1.47V19c0 1.1.9 2 2 2h.28a1.98 1.98 0 003.44 0H14c1.1 0 2-.9 2-2v-2.31c0-.55.22-1.09.64-1.46A6.956 6.956 0 0019 10c0-3.87-3.13-7-7-7zm2 16h-4v-1h4v1zm0-2h-4v-1h4v1zm-1.5-5.59V14h-1v-2.59L9.67 9.59l.71-.71L12 10.5l1.62-1.62.71.71-1.83 1.82z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$63ea8052f3baa95c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.89 8.11C15.5 7.72 14.83 7 13.53 7h-2.54C8.24 6.99 6 4.75 6 2H4c0 3.16 2.11 5.84 5 6.71V22h2v-6h2v6h2V10.05L18.95 14l1.41-1.41-4.47-4.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da5cfe3c4d00425b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h8v2H3zM6 11h2V7h3V5H3v2h3zM12.404 20.182l7.778-7.778 1.414 1.414-7.778 7.778z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 11A2.5 2.5 0 0018 8.5V4h3V2h-4v4.51c-.42-.32-.93-.51-1.5-.51a2.5 2.5 0 000 5zM9.74 15.96l-1.41 1.41-.71-.71.35-.35a2.499 2.499 0 00-1.77-4.27 2.499 2.499 0 00-1.77 4.27l.35.35-1.06 1.06c-.98.98-.98 2.56 0 3.54.5.5 1.14.74 1.78.74s1.28-.24 1.77-.73l1.06-1.06 1.41 1.41 1.41-1.41-1.41-1.41 1.41-1.41-1.41-1.43zM5.85 14.2c.12-.12.26-.15.35-.15s.23.03.35.15c.19.2.19.51 0 .71l-.35.35-.35-.36a.501.501 0 010-.7zm0 5.65c-.12.12-.26.15-.35.15s-.23-.03-.35-.15a.513.513 0 010-.71l1.06-1.06.71.71-1.07 1.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0a130c19f45a665(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.57 10.66c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 14.77l.01 5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V19h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h1V3H7v5H2v13h1V9h5V4h6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h2v2H5zM10 5h2v2h-2zM5 15h2v2H5zM5 19h2v2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8f67a3aa80d8f15(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zM22.1 6.84c.01-.11.02-.22.02-.34 0-.12-.01-.23-.03-.34l.74-.58c.07-.05.08-.15.04-.22l-.7-1.21c-.04-.08-.14-.1-.21-.08l-.86.35c-.18-.14-.38-.25-.59-.34l-.13-.93A.182.182 0 0020.2 3h-1.4c-.09 0-.16.06-.17.15l-.13.93c-.21.09-.41.21-.59.34l-.87-.35c-.08-.03-.17 0-.21.08l-.7 1.21c-.04.08-.03.17.04.22l.74.58a1.953 1.953 0 000 .68l-.74.58c-.07.05-.08.15-.04.22l.7 1.21c.04.08.14.1.21.08l.87-.35c.18.14.38.25.59.34l.13.93c.01.09.08.15.17.15h1.4c.09 0 .16-.06.17-.15l.13-.93c.21-.09.41-.21.59-.34l.87.35c.08.03.17 0 .21-.08l.7-1.21c.04-.08.03-.17-.04-.22l-.73-.58zm-2.6.91a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM19.92 11.68l-.5-.87c-.03-.06-.1-.08-.15-.06l-.62.25c-.13-.1-.27-.18-.42-.24l-.09-.66A.15.15 0 0018 10h-1c-.06 0-.11.04-.12.11l-.09.66c-.15.06-.29.15-.42.24l-.62-.25c-.06-.02-.12 0-.15.06l-.5.87c-.03.06-.02.12.03.16l.53.41c-.01.08-.02.16-.02.24 0 .08.01.17.02.24l-.53.41c-.05.04-.06.11-.03.16l.5.87c.03.06.1.08.15.06l.62-.25c.13.1.27.18.42.24l.09.66c.01.07.06.11.12.11h1c.06 0 .12-.04.12-.11l.09-.66c.15-.06.29-.15.42-.24l.62.25c.06.02.12 0 .15-.06l.5-.87c.03-.06.02-.12-.03-.16l-.52-.41c.01-.08.02-.16.02-.24 0-.08-.01-.17-.02-.24l.53-.41c.05-.04.06-.11.04-.17zm-2.42 1.65c-.46 0-.83-.38-.83-.83 0-.46.38-.83.83-.83s.83.38.83.83c0 .46-.37.83-.83.83zM4.74 9h8.53c.27 0 .49-.22.49-.49v-.02a.49.49 0 00-.49-.49H13c0-1.48-.81-2.75-2-3.45v.95c0 .28-.22.5-.5.5s-.5-.22-.5-.5V4.14C9.68 4.06 9.35 4 9 4s-.68.06-1 .14V5.5c0 .28-.22.5-.5.5S7 5.78 7 5.5v-.95C5.81 5.25 5 6.52 5 8h-.26a.49.49 0 00-.49.49v.03c0 .26.22.48.49.48zM9 13c1.86 0 3.41-1.28 3.86-3H5.14c.45 1.72 2 3 3.86 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac5fefd4664ab7b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.97 13.52v-.04C23.21 12.38 24 10.78 24 9c0-3.31-2.69-6-6-6-.26 0-.52.02-.78.06a5.98 5.98 0 00-10.44 0C6.52 3.02 6.26 3 6 3 2.69 3 0 5.69 0 9c0 1.78.79 3.38 2.02 4.48v.04A6.008 6.008 0 000 18c0 3.31 2.69 6 6 6 1.39 0 2.67-.48 3.69-1.28.74.18 1.51.28 2.31.28s1.57-.1 2.31-.28c1.02.8 2.3 1.28 3.69 1.28 3.31 0 6-2.69 6-6 0-1.78-.79-3.38-2.03-4.48zM12 21c-4.41 0-8-3.59-8-8 0-3.72 2.56-6.85 6-7.74v.05c0 3.34 2.72 6.06 6.06 6.06 1.26 0 2.45-.39 3.45-1.09.31.86.49 1.77.49 2.72 0 4.41-3.59 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "14",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "14",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$43b9719498215db1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.91 11.96C22.39 6.32 17.66 2 12 2S1.61 6.32 1.09 11.96l-.9 9.86c-.1 1.17.82 2.18 2 2.18h19.62c1.18 0 2.1-1.01 1.99-2.18l-.89-9.86zM4.54 9.13c.87.55 1.89.87 2.96.87 1.86 0 3.5-.93 4.5-2.35C13 9.07 14.64 10 16.5 10c1.07 0 2.09-.32 2.96-.87.34.89.54 1.86.54 2.87 0 4.41-3.59 8-8 8s-8-3.59-8-8c0-1.01.2-1.98.54-2.87z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$754bfd117174efe4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-.96 0-1.88.14-2.75.39A4.986 4.986 0 005 0C2.24 0 0 2.24 0 5c0 1.8.96 3.37 2.39 4.25C2.14 10.12 2 11.04 2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.05.01-.1.01-.15 2.6-.98 4.68-2.99 5.74-5.55a9.942 9.942 0 009.92 3.46c.21.71.33 1.46.33 2.24 0 4.41-3.59 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3654694a5138403c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-1.12.23-2.18.65-3.15a.495.495 0 00.85-.35c0-.25-.19-.45-.43-.49.15-.26.32-.51.49-.75-.03.08-.06.15-.06.24 0 .28.22.5.5.5s.5-.22.5-.5S6.28 7 6 7c-.13 0-.25.05-.34.13.52-.68 1.15-1.28 1.86-1.76A.495.495 0 008 6a.495.495 0 00.1-.98c.16-.09.32-.17.49-.25.09.14.24.23.41.23.28 0 .5-.22.5-.5 0-.03-.01-.06-.02-.09.39-.13.79-.23 1.21-.3-.11.1-.19.23-.19.39 0 .28.22.5.5.5s.5-.22.5-.5a.51.51 0 00-.3-.46c.26-.03.53-.04.8-.04s.54.01.8.04c-.18.08-.3.25-.3.46 0 .28.22.5.5.5s.5-.22.5-.5c0-.16-.08-.29-.19-.38.41.07.82.17 1.21.3-.01.02-.02.05-.02.08 0 .28.22.5.5.5.17 0 .32-.09.41-.23.17.08.33.16.49.25A.495.495 0 0016 6c.28 0 .5-.22.5-.5 0-.05-.01-.09-.03-.13.71.48 1.34 1.08 1.86 1.76a.495.495 0 00-.83.37c0 .28.22.5.5.5s.5-.22.5-.5c0-.09-.03-.16-.07-.23.18.24.34.49.49.75-.23.03-.42.23-.42.48a.495.495 0 00.85.35c.42.97.65 2.03.65 3.15 0 4.41-3.59 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "5.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "5.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7bedc5da4eb85b73(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8v-.03c2.31-.22 3.43-1.59 4.34-3.41.17-.35.51-.56.9-.56h5.53c.38 0 .72.21.89.55.9 1.8 1.99 3.19 4.34 3.41v.03c0 4.42-3.59 8.01-8 8.01z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7cf7a7db0be0b836(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$10121d1b054e7bd0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 9.5C17.5 6.46 15.04 4 12 4S6.5 6.46 6.5 9.5c0 2.7 1.94 4.93 4.5 5.4V17H9v2h2v2h2v-2h2v-2h-2v-2.1c2.56-.47 4.5-2.7 4.5-5.4zm-9 0C8.5 7.57 10.07 6 12 6s3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$66d3d34657357b9a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2v20h20V2H2zm9.86 14.96c.76-.24 1.4-1.04 1.53-1.63.13-.56-.1-1.05-.2-1.6-.08-.46-.07-.85.08-1.28.54 1.21 2.15 1.64 1.98 3.18-.19 1.7-2.11 2.38-3.39 1.33zM20 20h-2v-2h-2.02A4.98 4.98 0 0017 15c0-1.89-1.09-2.85-1.85-3.37C12.2 9.61 13 7 13 7c-6.73 3.57-6.02 7.47-6 8 .03.96.49 2.07 1.23 3H6v2H4V4h16v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6a4e013fdf5f3f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.89 13.89c1.04 0 1.89-.85 1.89-1.89s-.85-1.89-1.89-1.89S18 10.96 18 12s.85 1.89 1.89 1.89zm-4.24-.21c.93 0 1.68-.75 1.68-1.68s-.75-1.68-1.68-1.68c-.93 0-1.68.75-1.68 1.68s.75 1.68 1.68 1.68zm0-4.26c.93 0 1.68-.75 1.68-1.68 0-.93-.75-1.68-1.68-1.68-.93 0-1.68.75-1.68 1.68 0 .93.75 1.68 1.68 1.68zm0 8.51c.93 0 1.68-.75 1.68-1.68 0-.93-.75-1.68-1.68-1.68-.93 0-1.68.75-1.68 1.68 0 .92.75 1.68 1.68 1.68zm-4.24-4.46c.81 0 1.47-.66 1.47-1.47s-.66-1.47-1.47-1.47c-.81 0-1.47.66-1.47 1.47s.65 1.47 1.47 1.47zm0-4.26c.81 0 1.47-.66 1.47-1.47s-.66-1.47-1.47-1.47c-.81 0-1.47.66-1.47 1.47s.65 1.47 1.47 1.47zm0 8.52c.81 0 1.47-.66 1.47-1.47 0-.81-.66-1.47-1.47-1.47-.81 0-1.47.66-1.47 1.47-.01.81.65 1.47 1.47 1.47zm0 4.27c.81 0 1.47-.66 1.47-1.47 0-.81-.66-1.47-1.47-1.47-.81 0-1.47.66-1.47 1.47-.01.81.65 1.47 1.47 1.47zm0-17.06c.81 0 1.47-.66 1.47-1.47S12.22 2 11.41 2c-.81 0-1.47.66-1.47 1.47s.65 1.47 1.47 1.47zm-4.25 8.32c.7 0 1.26-.57 1.26-1.26s-.57-1.26-1.26-1.26a1.261 1.261 0 000 2.52zm0 4.25a1.261 1.261 0 000-2.52 1.261 1.261 0 000 2.52zm0-8.49a1.261 1.261 0 000-2.52 1.261 1.261 0 000 2.52zm-3.87 4.03a1.05 1.05 0 100-2.1 1.05 1.05 0 000 2.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$780ee3a67eab2317(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.67 19c-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.1 1-3.34 1-1.24 0-1.38-1-3.33-1-1.95 0-2.1 1-3.34 1v2c1.95 0 2.11-1 3.34-1 1.24 0 1.38 1 3.33 1 1.95 0 2.1-1 3.34-1 1.22 0 1.4 1 3.33 1 1.93 0 2.1-1 3.33-1 1.22 0 1.4 1 3.33 1v-2c-1.24 0-1.38-1-3.33-1zM8.68 17.5c1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.31 1v-2c-.63 0-1-.28-1.48-.55l-2.02-7.53 2.09.85.74-1.86L9.78 2 2 11.61l1.57 1.23 1.39-1.78.93 3.48c-.18-.02-.35-.05-.56-.05-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1 1.19.01 1.42 1.01 3.33 1.01zm5.36-7.32l1.42 5.31c-1.34.09-1.47-.99-3.47-.99-.36 0-.65.04-.91.1l-.91-3.39 3.87-1.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6cf9f0d273c1e109(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75M13 2v7h3.75v14h1.5V9H22V2h-9zm5.01 6V6.25H14.5v-1.5h3.51V3l2.49 2.5L18.01 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a1ef134043ec756(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.75 8c-.69 0-1.25.56-1.25 1.25V15H18c-1.65 0-3 1.35-3 3h-1c0-2.04 1.53-3.72 3.5-3.97V3.25a1.25 1.25 0 00-2.5 0V11h-1V1.25a1.25 1.25 0 00-2.5 0V11h-1V2.75a1.25 1.25 0 00-2.5 0V12H7V5.75a1.25 1.25 0 00-2.5 0v10c0 4.56 3.69 8.25 8.25 8.25S21 20.31 21 15.75v-6.5C21 8.56 20.44 8 19.75 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a8c47e9e316d345e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.5c.97 0 1.75-.78 1.75-1.75S12.97 4 12 4s-1.75.78-1.75 1.75S11.03 7.5 12 7.5zm2 8.5v4h-4v-4H8l2.38-6.38a1.733 1.733 0 013.24 0L16 16h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d61eff0c21ce18e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9V7h-2v2h-2v2h2v2h2v-2h2V9zM8 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zM8 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zM12.51 4.05C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95zM16.53 13.83C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ee5842eadb56079(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8c0-1.42-.5-2.73-1.33-3.76.42-.14.86-.24 1.33-.24 2.21 0 4 1.79 4 4s-1.79 4-4 4h-.18l-.77-.77c.6-.94.95-2.05.95-3.23zm7.83 12H23v-3c0-2.18-3.58-3.47-6.34-3.87 1.1.75 1.95 1.71 2.23 2.94L22.83 20zM7.24 4.41a3.996 3.996 0 015.35 5.35L7.24 4.41zM9.17 12H9c-2.21 0-4-1.79-4-4v-.17L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41L17 19.83V20H1v-3c0-2.66 5.33-4 8-4 .37 0 .8.03 1.25.08L9.17 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0018e57c97a63db(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 9v2h-6V9h6zM8 4C5.79 4 4 5.79 4 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm4.51-8.95C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95zm4.02 9.78C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e908edf5c6c6e6b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bb9ca1b1f86e7117(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.27 12h3.46a1.5 1.5 0 001.48-1.75l-.3-1.79a2.951 2.951 0 00-5.82.01l-.3 1.79c-.15.91.55 1.74 1.48 1.74zM1.66 11.11c-.13.26-.18.57-.1.88.16.69.76 1.03 1.53 1h1.95c.83 0 1.51-.58 1.51-1.29 0-.14-.03-.27-.07-.4-.01-.03-.01-.05.01-.08.09-.16.14-.34.14-.53 0-.31-.14-.6-.36-.82-.03-.03-.03-.06-.02-.1.07-.2.07-.43.01-.65a1.12 1.12 0 00-.99-.74.09.09 0 01-.07-.03C5.03 8.14 4.72 8 4.37 8c-.3 0-.57.1-.75.26-.03.03-.06.03-.09.02a1.24 1.24 0 00-1.7 1.03c0 .02-.01.04-.03.06-.29.26-.46.65-.41 1.05.03.22.12.43.25.6.03.02.03.06.02.09zM16.24 13.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM1.22 14.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58zM22.78 14.58A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57c0-.81-.48-1.53-1.22-1.85zM22 11v-.5c0-1.1-.9-2-2-2h-2c-.42 0-.65.48-.39.81l.7.63c-.19.31-.31.67-.31 1.06 0 1.1.9 2 2 2s2-.9 2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae2248c7f8dbd19c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 13.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM1.22 14.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58zM22.78 14.58A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57c0-.81-.48-1.53-1.22-1.85zM12 12c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zM1.497 11L4 8.497 6.503 11 4 13.503zM20 9l-2.5 4h5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7b92adfe3c7d98b5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V18H6v-1.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91zM4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29zM20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57zM12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab97c2dded2b90ca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.48 10.41c-.39.39-1.04.39-1.43 0l-4.47-4.46-7.05 7.04-.66-.63a3 3 0 010-4.24l4.24-4.24a3 3 0 014.24 0L16.48 9c.39.39.39 1.02 0 1.41zm.7-2.12c.78.78.78 2.05 0 2.83-1.27 1.27-2.61.22-2.83 0l-3.76-3.76-5.57 5.57a.996.996 0 000 1.41c.39.39 1.02.39 1.42 0l4.62-4.62.71.71-4.62 4.62a.996.996 0 000 1.41c.39.39 1.02.39 1.42 0l4.62-4.62.71.71-4.62 4.62a.996.996 0 101.41 1.41l4.62-4.62.71.71-4.62 4.62a.996.996 0 101.41 1.41l8.32-8.34a3 3 0 000-4.24l-4.24-4.24a3.001 3.001 0 00-4.18-.06l4.47 4.47z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$108f19fabbe8976a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 13H8v-3h2.5V7.5h3V10H16v3h-2.5v2.5h-3V13zM12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f2a7e48aaca99c99(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3c-.96 0-1.9.25-2.73.69L12 9h3l-3 10 1-9h-3l1.54-5.39C10.47 3.61 9.01 3 7.5 3 4.42 3 2 5.42 2 8.5c0 4.13 4.16 7.18 10 12.5 5.47-4.94 10-8.26 10-12.5C22 5.42 19.58 3 16.5 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$18062c7ee760c272(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 5.28c-1.23-.37-2.22-1.17-2.8-2.18l-1-1.6c-.41-.65-1.11-1-1.84-1-.78 0-1.59.5-1.78 1.44S7 23 7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3c1 1.15 2.41 2.01 4 2.34V23H19V9h-1.5v1.78zM7.43 13.13l-2.12-.41a.999.999 0 01-.79-1.17l.76-3.93a2 2 0 012.34-1.58l1.16.23-1.35 6.86z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$14c8b891dcac317b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v1.38c-.83-.33-1.72-.5-2.61-.5-1.79 0-3.58.68-4.95 2.05l3.33 3.33h1.11v1.11c.86.86 1.98 1.31 3.11 1.36V15H6v3c0 1.1.9 2 2 2h10c1.66 0 3-1.34 3-3V4H9zm-1.11 6.41V8.26H5.61L4.57 7.22a5.07 5.07 0 011.82-.34c1.34 0 2.59.52 3.54 1.46l1.41 1.41-.2.2a2.7 2.7 0 01-1.92.8c-.47 0-.93-.12-1.33-.34zM19 17c0 .55-.45 1-1 1s-1-.45-1-1v-2h-6v-2.59c.57-.23 1.1-.57 1.56-1.03l.2-.2L15.59 14H17v-1.41l-6-5.97V6h8v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4cfae679d527c1ab(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.79 8l1.8-3-1.8-3h-3.58l-1.8 3 1.8 3zM10.21 9l-1.8 3 1.8 3h3.58l1.8-3-1.8-3zM16.45 11.51h3.59l1.79-3-1.79-3h-3.59l-1.8 3zM20.04 12.51h-3.59l-1.8 3 1.8 3h3.59l1.79-3zM7.55 11.51l1.8-3-1.8-3H3.96l-1.79 3 1.79 3zM7.55 12.51H3.96l-1.79 3 1.79 3h3.59l1.8-3zM10.21 16l-1.8 3 1.8 3h3.58l1.8-3-1.8-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac09b2af6f74530(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8.5c0-.28.22-.5.5-.5h2.52L11 7H8.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5H11V3H3v15h3v2H2v2h16c2.76 0 5-2.24 5-5h-2c0 1.66-1.34 3-3 3h-2v-2h3v-2.88c0-2.1-1.55-3.53-3.03-3.88l-2.7-.67c-.87-.22-1.57-.81-1.95-1.57H8.5c-.28 0-.5-.22-.5-.5zM14 20H8v-2h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d9760369828e51e4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.02 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zM13 13v8h8v-8h-8zM7 2l-5 9h10L7 2zm12.25.5c-1.06 0-1.81.56-2.25 1.17-.44-.61-1.19-1.17-2.25-1.17C13.19 2.5 12 3.78 12 5.25c0 2 2.42 3.42 5 5.75 2.58-2.33 5-3.75 5-5.75 0-1.47-1.19-2.75-2.75-2.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$18c59f84607f977b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6a2 2 0 01-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3a2 2 0 012 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$40cca245304aaf1e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 23c-1.03 0-2.06-.25-3-.75-1.89 1-4.11 1-6 0-1.89 1-4.11 1-6 0-.95.5-1.97.75-3 .75H2v-2h1c1.04 0 2.08-.35 3-1 1.83 1.3 4.17 1.3 6 0 1.83 1.3 4.17 1.3 6 0 .91.65 1.96 1 3 1h1v2h-1zM12 5.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 12s-1.52.71-3.93 1.37c-.82-.23-1.53-.75-2.07-1.37-.73.84-1.8 1.5-3 1.5s-2.27-.66-3-1.5c-.73.84-1.8 1.5-3 1.5s-2.27-.66-3-1.5c-.54.61-1.25 1.13-2.07 1.37C1.52 18.21 0 17.5 0 17.5s2.93-1.36 7.13-2.08l1.35-4.17c.31-.95 1.32-1.47 2.27-1.16.09.03.19.07.27.11l2.47 1.3 2.84-1.5 1.65-3.71-.51-1.32L18.8 2 22 3.43 20.67 6.4l-1.31.5-3.72 8.34c4.85.63 8.36 2.26 8.36 2.26zm-8.98-4.54l-1.52.8-1.75-.92-.71 2.17c.32 0 .64-.01.96-.01.71 0 1.4.03 2.07.08l.95-2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a5019ac2d7348ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M6 7h5v3H6zM13 7h5v3h-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V7c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L4 19h1l.67-2h12.67l.66 2h1l.67-2H22v-5c0-1.1-.9-2-2-2zm-9 0H6V7h5v3zm7 0h-5V7h5v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac3881bd6f675760(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm14.06-2h-2.12L15.5 3.44l1.06 1.06 3.5-3.5zM22 23v-2h-1c-1.04 0-2.08-.35-3-1-1.83 1.3-4.17 1.3-6 0-1.83 1.3-4.17 1.3-6 0-.91.65-1.96 1-3 1H2v2h1c1.03 0 2.05-.25 3-.75 1.89 1 4.11 1 6 0 1.89 1 4.11 1 6 0 .95.5 1.97.75 3 .75h1zm-1-9.72c0 1.44-2.19 3.62-5.04 5.58-.31.09-.63.14-.96.14-1.2 0-2.27-.66-3-1.5-.73.84-1.8 1.5-3 1.5-.94 0-1.81-.41-2.49-.99.46-.39.96-.78 1.49-1.17l-1.55-2.97A4.06 4.06 0 016 12V8c0-1.1.9-2 2-2h3c1.38 0 2.63-.56 3.54-1.46l1.41 1.41A7.018 7.018 0 0111 8H9.6v3.5h2.8l1.69 1.88c1.95-.84 3.77-1.38 5.06-1.38.84 0 1.85.25 1.85 1.28zm-8.8.99l-.7-.77-2.5.1.83 2.01c.59-.38 1.81-1.06 2.37-1.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2fafa2ccace41c67(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.47 13.79l-2.58-1.03L6 15.05l-4-1.54v2.1l4 1.34zM10.57 11.42L8 8H2v3.61l4 1.34zM6 19.05l-4-1.33V22h20l-4.97-6.62zM17 6V1l-5-1-3 2v4l3 2zM18.5 7L16 9v3l2.5 2 4.5-2V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a33a16ee08cf74aa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c07f864059fce11(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM9.5 18H8V9h1.5v9zm3.25 0h-1.5V9h1.5v9zm.75-12h-3V3.5h3V6zM16 18h-1.5V9H16v9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa4dfbe47d00704(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 11c1.93 0 3.5 1.57 3.5 3.5S11.43 18 9.5 18 6 16.43 6 14.5 7.57 11 9.5 11zm0-2C6.46 9 4 11.46 4 14.5S6.46 20 9.5 20s5.5-2.46 5.5-5.5c0-1.16-.36-2.23-.97-3.12L18 7.42V10h2V4h-6v2h2.58l-3.97 3.97C11.73 9.36 10.66 9 9.5 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a10ecd71eb9b6cfe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4c-1.1 0-2 .9-2 2v6h2.5v7h3v-7H16V9c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c0ae651feafefd6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2zM12 1.751L14.248 4 12 6.248 9.75 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c486951ab2edb3f4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.75 7h-3.5C9.04 7 8.11 8.07 8.27 9.26L10 22h4l1.73-12.74C15.89 8.07 14.96 7 13.75 7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$98902064ac56e3d5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$154532223606554b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 6c-1.31 0-2.37 1.01-2.48 2.3-1.88-.5-2.84-1.8-5.02-1.8-2.19 0-3.14 1.3-5.02 1.8C6.87 7.02 5.81 6 4.5 6A2.5 2.5 0 002 8.5V9c0 6 3.6 7.81 6.52 7.98C9.53 17.62 10.72 18 12 18s2.47-.38 3.48-1.02C18.4 16.81 22 15 22 9v-.5A2.5 2.5 0 0019.5 6zm-16 3v-.5c0-.55.45-1 1-1s1 .45 1 1v3c0 1.28.38 2.47 1.01 3.48C4.99 14.27 3.5 12.65 3.5 9zm17 0c0 3.65-1.49 5.27-3.01 5.98.64-1.01 1.01-2.2 1.01-3.48v-3c0-.55.45-1 1-1s1 .45 1 1V9zm-9.81 1.48c-.44.26-.96.56-1.69.76V10.2c.48-.17.84-.38 1.18-.58C10.72 9.3 11.23 9 12 9s1.27.3 1.8.62c.34.2.71.42 1.2.59v1.04c-.75-.21-1.26-.51-1.71-.78-.46-.27-.8-.47-1.29-.47s-.84.2-1.31.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$69512a78cfb76a65(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.43V2H7v8.43c0 .35.18.68.49.86l4.18 2.51-.99 2.34-3.41.29 2.59 2.24L9.07 22 12 20.23 14.93 22l-.78-3.33 2.59-2.24-3.41-.29-.99-2.34 4.18-2.51c.3-.18.48-.5.48-.86zm-4 1.8l-1 .6-1-.6V3h2v9.23z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$50997ddcc65732d5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2782897acdfedc7e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c9606865227ac06e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.1 12.08c-2.33-4.51-.5-8.48.53-10.07C6.27 2.2 1.98 6.59 1.98 12c0 .14.02.28.02.42.62-.27 1.29-.42 2-.42 1.66 0 3.18.83 4.1 2.15A4.01 4.01 0 0111 18c0 1.52-.87 2.83-2.12 3.51.98.32 2.03.5 3.11.5 3.5 0 6.58-1.8 8.37-4.52-2.36.23-6.98-.97-9.26-5.41z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h-.18C6.4 14.84 5.3 14 4 14c-1.66 0-3 1.34-3 3s1.34 3 3 3h3c1.1 0 2-.9 2-2s-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$94ef827e9f8855f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-1.85.63-3.54 1.69-4.9L7.59 9h2.83L7.1 5.69A7.924 7.924 0 0112 4c4.41 0 8 3.59 8 8 0 1.85-.63 3.54-1.69 4.9l-1.9-1.9h-2.83l3.31 3.31A7.874 7.874 0 0112 20c-4.41 0-8-3.59-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 14l-1.5-2 1.5-2h-1.5L12 11l-.75-1h-1.5l1.5 2-1.5 2h1.5l.75-1 .75 1zM8 10l-.75 1-.75-1H5l1.5 2L5 14h1.5l.75-1L8 14h1.5L8 12l1.5-2zM16 14l.75-1 .75 1H19l-1.5-2 1.5-2h-1.5l-.75 1-.75-1h-1.5l1.5 2-1.5 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b241ed1aae4254f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.75 9v.92l1.75 1.75V9H16v4.17l3 3V8c0-1.1-.9-2-2-2h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3h-.17l3 3h.92zM10.5 3.5h3V6h-3V3.5zm10.69 17.69L2.81 2.81 1.39 4.22l3.63 3.63c0 .05-.02.1-.02.15v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c.34 0 .65-.09.93-.24l1.85 1.85 1.41-1.42zM8 18v-7.17l1.5 1.5V18H8zm4.75 0h-1.5v-3.92l1.5 1.5V18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c7b331ef33a0d17a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 23h-1.5v-9H19v9zM7.53 14H6l-2 9h1.53l2-9zm5.97-8.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6a2.145 2.145 0 00-2.65-.84L6 8.3V13h2V9.6l1.8-.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df53e1a1a8649e5e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20h4c0 1.1-.9 2-2 2s-2-.9-2-2zm4-11c0 2.61 1.67 4.83 4 5.66V17h2v2H4v-2h2v-7c0-2.79 1.91-5.14 4.5-5.8v-.7c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.7c.71.18 1.36.49 1.95.9A5.902 5.902 0 0014 9zm10-1h-3V5h-2v3h-3v2h3v3h2v-3h3V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffc3b7025e5cf96b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2a8.445 8.445 0 013.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43a8.495 8.495 0 013.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6e408b315b81ab3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4b676ee3f3aabd53(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e10c4dc83213ae0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6d17f0a5cd0303f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$478df4f182b17397(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 22c1.66 0 3-1.34 3-3s-1.34-3-3-3c-1.3 0-2.4.84-2.82 2H9.14l1.99-3.06a6.36 6.36 0 001.74 0l1.02 1.57c.42-.53.96-.95 1.6-1.21l-.6-.93A6.992 6.992 0 0019 8H5c0 2.84 1.69 5.27 4.12 6.37l-3.95 6.08a1 1 0 00.29 1.38 1 1 0 001.38-.29l1-1.55h6.34C14.6 21.16 15.7 22 17 22zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04zM11.89 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.78-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.23.24.8.67.45 2.04zM14.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b8c079ee31ee4a98(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b65c8f205d272ad5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-3.48.94C8.04 17.55 7 16.76 7 14H5c0 2.7.93 4.41 2.3 5.5.5.4 1.1.7 1.7.9V24h6v-3.6c.6-.2 1.2-.5 1.7-.9 1.37-1.09 2.3-2.8 2.3-5.5h-2c0 2.76-1.04 3.55-1.52 3.94C14.68 18.54 14 19 12 19s-2.68-.46-3.48-1.06zM12 0C5.92 0 1 1.9 1 4.25v3.49c0 .81.88 1.26 1.56.83.14-.09.28-.18.44-.26L5 13h2l1.5-6.28a27.852 27.852 0 017 0L17 13h2l2-4.69c.16.09.3.17.44.26.68.43 1.56-.02 1.56-.83V4.25C23 1.9 18.08 0 12 0zM5.88 11.24L4.37 7.69c.75-.28 1.6-.52 2.53-.71l-1.02 4.26zm12.24 0L17.1 6.98c.93.19 1.78.43 2.53.71l-1.51 3.55z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dce8b6443d05e312(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1A5.002 5.002 0 0112 7zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08a5.002 5.002 0 01-4.9 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cb1f871a88f1ded6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.67 13.13C18.04 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.57-3.47-6.33-3.87z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "8",
                    "r": "4",
                    "fillRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24a5.98 5.98 0 010 7.52c.42.14.86.24 1.33.24zM9 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4889242c869aa627(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ec8e6c9803fb255(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db5c92a5480f71b5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM9.78 12h4.44c1.21 0 2.14-1.06 1.98-2.26l-.32-2.45C15.57 5.39 13.92 4 12 4S8.43 5.39 8.12 7.29L7.8 9.74c-.16 1.2.77 2.26 1.98 2.26z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab86309ba9500160(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM10 12h4c1.66 0 3-1.34 3-3 0-.73-.27-1.4-.71-1.92.13-.33.21-.7.21-1.08a3 3 0 00-1.86-2.77C14 2.48 13.06 2 12 2s-2 .48-2.64 1.23A3 3 0 007.5 6c0 .38.08.75.21 1.08C7.27 7.6 7 8.27 7 9c0 1.66 1.34 3 3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a05fae486f18072(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM12 12c2.21 0 4-1.79 4-4V4.5c0-.83-.67-1.5-1.5-1.5-.52 0-.98.27-1.25.67-.27-.4-.73-.67-1.25-.67s-.98.27-1.25.67c-.27-.4-.73-.67-1.25-.67C8.67 3 8 3.67 8 4.5V8c0 2.21 1.79 4 4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$45ba2447067b1417(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c0-2.21-1.79-4-4-4S5 5.79 5 8s1.79 4 4 4 4-1.79 4-4zm2 2v2h3v3h2v-3h3v-2h-3V7h-2v3h-3zM1 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f3ef1be0d842cf4f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c0-2.21-1.79-4-4-4S5 5.79 5 8s1.79 4 4 4 4-1.79 4-4zm-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM1 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4zm2 0c.2-.71 3.3-2 6-2 2.69 0 5.78 1.28 6 2H3zm17-3v-3h3v-2h-3V7h-2v3h-3v2h3v3h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab0c67592fbc654a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20c82ce53a3081a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.65 5.82a3.999 3.999 0 115.53 5.53L8.65 5.82zM20 17.17c-.02-1.1-.63-2.11-1.61-2.62-.54-.28-1.13-.54-1.77-.76L20 17.17zm1.19 4.02L2.81 2.81 1.39 4.22l8.89 8.89c-1.81.23-3.39.79-4.67 1.45A2.97 2.97 0 004 17.22V20h13.17l2.61 2.61 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1bdad4942f0c7491(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.9a2.1 2.1 0 110 4.2 2.1 2.1 0 010-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$75dd01be4429848d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4zm3 2v2h6v-2h-6zM2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$edbb7fe064343316(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4zm3 2v2h6v-2h-6zM2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae0c434667ec0da2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cfd10c2e782442df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4zm9 16h1c1.1 0 2-.9 2-2v-4.78c0-1.12-.61-2.15-1.61-2.66-.43-.22-.9-.43-1.39-.62V22zm-4.66-5L15 11.33c-.93-.21-1.93-.33-3-.33-2.53 0-4.71.7-6.39 1.56A2.97 2.97 0 004 15.22V22h2.34c-.22-.45-.34-.96-.34-1.5C6 18.57 7.57 17 9.5 17h2.84zM10 22l1.41-3H9.5c-.83 0-1.5.67-1.5 1.5S8.67 22 9.5 22h.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd7c768fa357f6c3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.42zM8.25 19H5V7.83l2 2v3.67c0 .55.45 1 1 1h.25V19zm1.5 0v-4.5H10c.46 0 .82-.31.94-.73l3.31 3.31V19h-4.5zM11 8.17L5.83 3H19c1.1 0 2 .9 2 2v13.17l-2-2V5h-2v8.5c0 .19-.07.36-.16.51L13 10.17V5h-2v3.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4088068adc282ee7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 11.5h.25V19h-4.5v-4.5H10c.55 0 1-.45 1-1V5h2v8.5c0 .55.45 1 1 1zM5 5h2v8.5c0 .55.45 1 1 1h.25V19H5V5zm14 14h-3.25v-4.5H16c.55 0 1-.45 1-1V5h2v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9ab902fbca38395e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.45 16.52l-3.01-3.01c-.11-.11-.24-.13-.31-.13s-.2.02-.31.13L8.8 16.53c-.34.34-.87.89-2.64.89l3.71 3.7a3 3 0 004.24 0l3.72-3.71c-.91 0-1.67-.18-2.38-.89zM8.8 7.47l3.02 3.02c.08.08.2.13.31.13s.23-.05.31-.13l2.99-2.99c.71-.74 1.52-.91 2.43-.91l-3.72-3.71a3 3 0 00-4.24 0l-3.71 3.7c1.76 0 2.3.58 2.61.89z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.11 9.85l-2.25-2.26H17.6c-.54 0-1.08.22-1.45.61l-3 3c-.28.28-.65.42-1.02.42a1.5 1.5 0 01-1.02-.42L8.09 8.17c-.38-.38-.9-.6-1.45-.6H5.17l-2.29 2.3a3 3 0 000 4.24l2.29 2.3h1.48c.54 0 1.06-.22 1.45-.6l3.02-3.02c.28-.28.65-.42 1.02-.42s.74.14 1.02.42l3.01 3.01c.38.38.9.6 1.45.6h1.26l2.25-2.26a3.042 3.042 0 00-.02-4.29z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d1c6e47688788ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$187700a5568c913d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$26747f0f702c4db6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.93 8.21l-3.6 1.68L14 7.7V6.3l2.33-2.19 3.6 1.68c.38.18.82.01 1-.36.18-.38.01-.82-.36-1L16.65 2.6a.993.993 0 00-1.13.2l-1.74 1.6A.975.975 0 0013 4c-.55 0-1 .45-1 1v1H8.82C8.34 4.65 6.98 3.73 5.4 4.07c-1.16.25-2.15 1.25-2.36 2.43-.22 1.32.46 2.47 1.48 3.08L7.08 18H4v3h13v-3h-3.62L8.41 8.77c.17-.24.31-.49.41-.77H12v1c0 .55.45 1 1 1 .32 0 .6-.16.78-.4l1.74 1.6c.3.3.75.38 1.13.2l3.92-1.83c.38-.18.54-.62.36-1a.753.753 0 00-1-.36zM6 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d34c701ddec04fac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.94 9.06C19.5 5.73 16.57 3 13 3 9.47 3 6.57 5.61 6.08 9l-1.93 3.48c-.41.66.07 1.52.85 1.52h1v2c0 1.1.9 2 2 2h1v3h7v-4.68a7.016 7.016 0 003.94-7.26zM12.5 14c-.41 0-.74-.33-.74-.74s.33-.73.74-.73.73.32.73.73-.31.74-.73.74zm1.76-4.32c-.44.65-.86.85-1.09 1.27-.09.17-.13.28-.13.82h-1.06c0-.29-.04-.75.18-1.16.28-.51.83-.81 1.14-1.26.33-.47.15-1.36-.8-1.36-.62 0-.92.47-1.05.86l-.96-.4c.27-.78.97-1.45 2.01-1.45.86 0 1.45.39 1.75.88.26.43.41 1.22.01 1.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$99149474fc7af1dd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8.57a1.43 1.43 0 100 2.86 1.43 1.43 0 000-2.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3C9.25 3 6.2 5.94 6.02 9.64L4.1 12.2a.5.5 0 00.4.8H6v3c0 1.1.9 2 2 2h1v3h7v-4.68A6.999 6.999 0 0013 3zm3 7c0 .13-.01.26-.02.39l.83.66c.08.06.1.16.05.25l-.8 1.39c-.05.09-.16.12-.24.09l-.99-.4c-.21.16-.43.29-.67.39L14 13.83c-.01.1-.1.17-.2.17h-1.6c-.1 0-.18-.07-.2-.17l-.15-1.06c-.25-.1-.47-.23-.68-.39l-.99.4c-.09.03-.2 0-.25-.09l-.8-1.39a.19.19 0 01.05-.25l.84-.66c-.01-.13-.02-.26-.02-.39s.02-.27.04-.39l-.85-.66c-.08-.06-.1-.16-.05-.26l.8-1.38c.05-.09.15-.12.24-.09l1 .4c.2-.15.43-.29.67-.39L12 6.17c.02-.1.1-.17.2-.17h1.6c.1 0 .18.07.2.17l.15 1.06c.24.1.46.23.67.39l1-.4c.09-.03.2 0 .24.09l.8 1.38a.2.2 0 01-.05.26l-.85.66c.03.12.04.25.04.39z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d19b3d299647b6bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.17L6.49 3.66A9.91 9.91 0 0112 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51l-1.46-1.46A7.842 7.842 0 0020 12c0-3.35-2.07-6.22-5-7.41V5c0 1.1-.9 2-2 2h-2v1.17zm10.19 13.02l-1.41 1.41-2.27-2.27A9.839 9.839 0 0112 22C6.48 22 2 17.52 2 12c0-2.04.61-3.93 1.66-5.51L1.39 4.22 2.8 2.81l18.39 18.38zM11 18c-1.1 0-2-.9-2-2v-1l-4.79-4.79C4.08 10.79 4 11.38 4 12c0 4.08 3.05 7.44 7 7.93V18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f4fcd871e8e79387(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$96defa1654030ad4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 22h4V11H1v11zm19-5h-7l-2.09-.73.33-.94L13 16h2.82c.65 0 1.18-.53 1.18-1.18 0-.49-.31-.93-.77-1.11L8.97 11H7v9.02L14 22l8-3c-.01-1.1-.89-2-2-2zM14 1.5l-7 5V9h2l8.14 3.26C18.26 12.71 19 13.79 19 15h2V6.5l-7-5zm-.5 8.5h-1V9h1v1zm0-2h-1V7h1v1zm2 2h-1V9h1v1zm0-2h-1V7h1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$718056aa67f247a6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1010 10A10 10 0 0012 2zm6 9.8a.9.9 0 01-.1.5l-2.1 4.9a1.34 1.34 0 01-1.3.8H9a2 2 0 01-2-2v-5a1.28 1.28 0 01.4-1L12 5l.69.69a1.08 1.08 0 01.3.7v.2L12.41 10H17a1 1 0 011 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5fec78b5a4f9643(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.77 7.15L7.2 4.78l1.03-1.71c.39-.65 1.33-.65 1.72 0l1.48 2.46-1.23 2.06-1 1.62-3.43-2.06zm15.95 5.82l-1.6-2.66-3.46 2L18.87 16H20a2 2 0 002-2c0-.36-.1-.71-.28-1.03zM16 21h1.5a2 2 0 001.79-1.11L20.74 17H16v-2l-4 4 4 4v-2zm-6-4H5.7l-.84 1.41c-.3.5-.32 1.12-.06 1.65.28.57.87.94 1.52.94H10v-4zm-3.88-2.65l1.73 1.04L6.48 9.9 1 11.27l1.7 1.02-.41.69c-.35.59-.38 1.31-.07 1.92l1.63 3.26 2.27-3.81zm10.9-9.21l-1.3-2.17C15.35 2.37 14.7 2 14 2h-3.53l3.12 5.2-1.72 1.03 5.49 1.37 1.37-5.49-1.71 1.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9aa0e3a9fa6e129e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58A6.95 6.95 0 0018 7c-.67 0-1.31.1-1.92.28.58.55.92 1.32.92 2.15V10h5v-.57c0-.81-.48-1.53-1.22-1.85zM6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.92 1.28C7.31 7.1 6.67 7 6 7c-.99 0-1.93.21-2.78.58A2.01 2.01 0 002 9.43V10h5v-.57c0-.83.34-1.6.92-2.15zM10 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0116 9.43V10zm-1 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6h-8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0121 21.43V22zM5 16c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H3v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0111 21.43V22zm1.75-9v-2h-1.5v2H9l3 3 3-3h-2.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cdfbd89347ba7acc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.27 21.73l-3.54-3.55L5.78 5.23 2.27 1.72 1 2.99 3.01 5H3v6c0 5.55 3.84 10.74 9 12 2.16-.53 4.08-1.76 5.6-3.41L21 23l1.27-1.27zM13 9.92l6.67 6.67C20.51 14.87 21 12.96 21 11V5l-9-4-5.48 2.44L11 7.92l2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$11da5a18091b2ec0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6.5c0-.28.22-.5.5-.5h2.52L12 5H9.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5H12V1H4v15h16v-2.88c0-2.1-1.55-3.53-3.03-3.88l-2.7-.67c-.87-.22-1.57-.81-1.95-1.57H9.5c-.28 0-.5-.22-.5-.5zM5 23c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm14 0c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm-7 0c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2e46198ad4422a27(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5h2v14h-2V5zm-6 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 001 15.43V16h8v-.57c0-.81-.48-1.53-1.22-1.85zM19 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 0015 15.43V16h8v-.57c0-.81-.48-1.53-1.22-1.85z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4a5083194fc17b01(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 6.5C15.5 5.66 17 4 17 4s1.5 1.66 1.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5zm4 8.5a2.5 2.5 0 002.5-2.5c0-1.67-2.5-4.5-2.5-4.5S17 10.83 17 12.5a2.5 2.5 0 002.5 2.5zM13 14h-2v-2H9v2H7v2h2v2h2v-2h2v-2zm3-2v10H4V12c0-2.97 2.16-5.43 5-5.91V4H7V2h6c1.13 0 2.15.39 2.99 1.01l-1.43 1.43C14.1 4.17 13.57 4 13 4h-2v2.09c2.84.48 5 2.94 5 5.91z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d458f92913972a19(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11V8c4.56-.58 8-3.1 8-6H2c0 2.9 3.44 5.42 8 6v3c-3.68.73-8 3.61-8 11h6v-2H4.13c.93-6.83 6.65-7.2 7.87-7.2s6.94.37 7.87 7.2H16v2h6c0-7.39-4.32-10.27-8-11zm-2 11c-1.1 0-2-.9-2-2 0-.55.22-1.05.59-1.41C11.39 17.79 16 16 16 16s-1.79 4.61-2.59 5.41c-.36.37-.86.59-1.41.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a0b86cc04a8fce42(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$17e7921367a558cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.8 18.4L14 10.67V6.5l1.35-1.69c.26-.33.03-.81-.39-.81H9.04c-.42 0-.65.48-.39.81L10 6.5v4.17L4.2 18.4c-.49.66-.02 1.6.8 1.6h14c.82 0 1.29-.94.8-1.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$147f18ebd20f6770(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 13.5H16v-3h1.5v3zM20 4h-3V2h-2v2H9V2H7v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM9.5 11.5c0 .55-.45 1-1 1h-2v1h3V15H5v-2.5c0-.55.45-1 1-1h2v-1H5V9h3.5c.55 0 1 .45 1 1v1.5zm3.25 6.5h-1.5v-1.5h1.5V18zm0-3.5h-1.5V13h1.5v1.5zm0-3.5h-1.5V9.5h1.5V11zm0-3.5h-1.5V6h1.5v1.5zM19 14c0 .55-.45 1-1 1h-2.5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1H18c.55 0 1 .45 1 1v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ff2f505ee1d23b4d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm7.89-2.89l4.53-1.21-.78-2.9-4.53 1.21c-.8.21-1.28 1.04-1.06 1.84.22.8 1.04 1.28 1.84 1.06zM20.5 5.9L23 3l-1-1-3 3-2 4-9.48 2.87c-.82.2-1.39.89-1.5 1.68L5.24 18 2.4 21.8 4 23l3-4 1.14-3.14L14 14l5-3.5 1.5-4.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1111d0332c3c24c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16v-2c-2.24 0-4.16-.96-5.6-2.68l-1.34-1.6A1.98 1.98 0 0012.53 9h-1.05c-.59 0-1.15.26-1.53.72l-1.34 1.6C7.16 13.04 5.24 14 3 14v2c2.77 0 5.19-1.17 7-3.25V15l-3.88 1.55c-.67.27-1.12.93-1.12 1.66C5 19.2 5.8 20 6.79 20H9v-.5a2.5 2.5 0 012.5-2.5h3c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.83 0-1.5.67-1.5 1.5v.5h7.21c.99 0 1.79-.8 1.79-1.79 0-.73-.45-1.39-1.12-1.66L14 15v-2.25c1.81 2.08 4.23 3.25 7 3.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$465459c1dddbcd9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-3.5c.73 0 1.39.19 1.97.53.12-.14.86-.98 1.01-1.14A5.39 5.39 0 0012 15c-1.11 0-2.13.33-2.99.88.97 1.09.01.02 1.01 1.14.59-.33 1.25-.52 1.98-.52z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$46efc4fcf44c2ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15.5h6v1H9v-1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa67e0e08cb3ffe2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-.73 0-1.38-.18-1.96-.52-.12.14-.86.98-1.01 1.15a5.49 5.49 0 005.95-.01c-.97-1.09-.01-.02-1.01-1.15-.59.35-1.24.53-1.97.53z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ecd6a29872311f23(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$48e089c14e225630(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-5-6c.78 2.34 2.72 4 5 4s4.22-1.66 5-4H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7bcfbbacbf77fddd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.41l4-4L14.59 5 12 7.59V4h-2v3.59L7.41 5 6 6.41l4 4V12H8.41l-4-4L3 9.41 5.59 12H2v2h3.59L3 16.59 4.41 18l4-4H10v1.59l-4 4L7.41 21 10 18.41V22h2v-3.59L14.59 21 16 19.59l-4-4V14h1.59l4 4L19 16.59 16.41 14H20v-2h-8zM19 2h2v5h-2zM19 8h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7343b75263a41fa6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bbb3cfb3abf1de62(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9c-1.1 0-2-.9-2-2s2-4 2-4 2 2.9 2 4-.9 2-2 2zm-3.5-2c0-.73.41-1.71.92-2.66A9.965 9.965 0 0011.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12c0-.55-.06-1.09-.14-1.62a3.5 3.5 0 01-.86.12c-1.93 0-3.5-1.57-3.5-3.5zm-1.88.38l1.06 1.06-1.06 1.06 1.06 1.06-1.06 1.06L13.5 9.5l2.12-2.12zm-8.3 1.06l1.06-1.06L10.5 9.5l-2.12 2.12-1.06-1.06L8.38 9.5 7.32 8.44zM15.44 17c-.69-1.19-1.97-2-3.44-2s-2.75.81-3.44 2H6.88c.3-.76.76-1.43 1.34-1.99L5.24 13.3c-.45.26-1.01.28-1.49 0a1.501 1.501 0 011.5-2.6c.48.28.74.78.74 1.29l3.58 2.07c.73-.36 1.55-.56 2.43-.56 2.33 0 4.32 1.45 5.12 3.5h-1.68z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c141791f728672a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.49 13l-.93-1.86c-.37-.74-.07-1.64.67-2.01l.26-.13 5.73 5.46c.5.47.78 1.13.78 1.81v5.23a2.5 2.5 0 01-2.5 2.5h-11c-.55 0-1-.45-1-1s.45-1 1-1H10v-1H4c-.55 0-1-.45-1-1s.45-1 1-1h6v-1H3c-.55 0-1-.45-1-1s.45-1 1-1h7v-1H4.5c-.55 0-1-.45-1-1s.45-1 1-1h7.99zm-.71-5.88c-.84.4-1.17.62-1.63 1.19l-2.7-2.85A.996.996 0 118.9 4.09l2.88 3.03zM9.64 9.21a3.46 3.46 0 00-.2 1.79h-.86L6.31 8.61a.987.987 0 01.04-1.41.996.996 0 011.41.04l1.88 1.97zm10.69 4.7l.88-.83c.5-.47.79-1.13.79-1.82V3.35l-.27-.1c-.78-.28-1.64.12-1.92.9l-.71 1.96-5.5-5.8a.996.996 0 10-1.45 1.37l3.79 3.99-.73.69-4.82-5.08a.996.996 0 10-1.45 1.37l3.78 3.98L15.38 9l3.61 3.43.61.58c.29.27.53.57.73.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6064b8062fbe395b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-1.1-.9-2-2-2V7c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L6 19h1l.67-2h8.67l.66 2h1l.67-2H20v-5zm-4-2h-3V7h3v3zM8 7h3v3H8V7zm-2 5h12v3H6v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$51475857681063eb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM7.25 22.5c-.41 0-.75.34-.75.75s.34.75.75.75.75-.34.75-.75-.34-.75-.75-.75zm8.5 0c-.41 0-.75.34-.75.75s.34.75.75.75.75-.34.75-.75-.34-.75-.75-.75zm3.49-3.5a.72.72 0 00-.59.3c-.55.73-1.42 1.2-2.4 1.2H16v-6l-4.32-2.67 1.8-2.89A6.507 6.507 0 0019 12v-2c-1.85 0-3.44-1.12-4.13-2.72l-.52-1.21C14.16 5.64 13.61 5 12.7 5H7L4.5 9l1.7 1.06L8.1 7h2.35l-2.4 3.84c-.31.5-.39 1.11-.21 1.67l1.34 4.15-3.12 3.76c-.7-.16-1.3-.57-1.71-1.12a.749.749 0 10-1.2.9c.82 1.1 2.13 1.8 3.6 1.8h9.5c1.47 0 2.78-.7 3.6-1.8.1-.14.15-.3.15-.45 0-.39-.32-.75-.76-.75zM14 20.5H8.6l2.9-3.5-1-3.3 3.5 2.2v4.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$71c6de6fc1f91a3f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm8.8 15.74a4.003 4.003 0 01-5.04 2.57L1 17.36l.46-1.43 3.93 1.28.46-1.43-3.92-1.28.46-1.43L4 13.6V9.5l5.47-2.35c.39-.17.84-.21 1.28-.07.95.31 1.46 1.32 1.16 2.27l-1.05 3.24 2.14-.34c.89-.15 1.76.32 2.14 1.14l2.08 4.51 1.93.63-.46 1.43-3.32-1.08-.47 1.42 3.32 1.08c1.31.43 2.72-.29 3.15-1.61.43-1.31-.29-2.72-1.61-3.15l.46-1.43c2.11.69 3.27 2.95 2.58 5.05zM6 14.25l1.01.33c-.22-.42-.28-.92-.12-1.4L7.92 10 6 10.82v3.43zm7.94 4.16l-6.66-2.16-.46 1.43 6.66 2.16.46-1.43zm.69-1.36l-1.18-2.56-3.97.89 5.15 1.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7dbc92fb93c618bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm7.4 17.09a.748.748 0 00-.64.17c-.69.6-1.64.88-2.6.67L17 20.69l-1-6.19-3.32-2.67 1.8-2.89A6.507 6.507 0 0020 12v-2c-1.85 0-3.44-1.12-4.13-2.72l-.52-1.21C15.16 5.64 14.61 5 13.7 5H8L5.5 9l1.7 1.06L9.1 7h2.35l-2.51 3.99c-.28.45-.37 1-.25 1.52L9.5 16 6 18.35l-.47-.1c-.96-.2-1.71-.85-2.1-1.67a.744.744 0 00-.51-.42c-.43-.09-.82.2-.9.58-.04.14-.02.31.05.46.58 1.24 1.71 2.2 3.15 2.51l12.63 2.69c1.44.31 2.86-.11 3.9-1.01.13-.11.21-.26.24-.41.07-.38-.16-.8-.59-.89zM8.73 18.93l3.02-2.03-.44-3.32 2.84 2.02.75 4.64-6.17-1.31z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e67af69960327e1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 3.5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM6.32 19.03l-1.14-1.47L4 18.5l2.38 3.04c.51.65 1.16 1.15 1.88 1.41.28.1.53.04.72-.11.3-.23.42-.7.12-1.07a.84.84 0 00-.31-.22 2.97 2.97 0 01-1.14-.83l-.08-.1L11 18.2l.89-3.22 2.11 2v4.52h-2V23h3.87c.82 0 1.61-.21 2.26-.61.26-.16.37-.39.37-.64 0-.38-.3-.75-.77-.75-.13 0-.26.04-.37.1-.4.23-.87.37-1.36.4v-6.02l-2.11-2 .6-3C15.79 11.98 17.8 13 20 13v-2c-1.9 0-3.51-1.02-4.31-2.42l-1-1.58c-.4-.6-1-1-1.7-1-.75 0-1.41.34-5.99 2.28V13h2V9.58l1.79-.7L9.2 17l-2.88 2.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f3d8fe7ea4ea8483(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 002 10.43V11h8v-.57c0-.81-.48-1.53-1.22-1.85zM18 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 0014 10.43V11h8v-.57c0-.81-.48-1.53-1.22-1.85zM22 17l-4-4v3H6v-3l-4 4 4 4v-3h12v3l4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b7588aa077725d04(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-1.95.7-3.74 1.87-5.13L9 10v1c0 1.1.9 2 2 2v5.59c0 .27.11.52.29.71l.71.7c-4.42 0-8-3.58-8-8zm9 7.94V18l3.75-5.62c.16-.25.25-.54.25-.83V10.5c0-.55-.45-1-1-1h-1.5l-1.4-1.75c-.38-.47-.95-.75-1.56-.75H8V5.07A7.971 7.971 0 0112 4c4.41 0 8 3.59 8 8 0 4.07-3.06 7.44-7 7.94z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$acffb86981ecdfd7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.81 6.28C2.67 7.9 2 9.87 2 12s.67 4.1 1.81 5.72C6.23 16.95 8 14.68 8 12S6.23 7.05 3.81 6.28zM20.19 6.28C17.77 7.05 16 9.32 16 12s1.77 4.95 4.19 5.72C21.33 16.1 22 14.13 22 12s-.67-4.1-1.81-5.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c0-3.28 1.97-6.09 4.79-7.33C17.01 3.02 14.63 2 12 2S6.99 3.02 5.21 4.67C8.03 5.91 10 8.72 10 12s-1.97 6.09-4.79 7.33C6.99 20.98 9.37 22 12 22s5.01-1.02 6.79-2.67A8.002 8.002 0 0114 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$78085dc2e9365d04(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.09 11h4.86a9.951 9.951 0 00-1.54-4.4 5.987 5.987 0 00-3.32 4.4zM6.91 11a5.987 5.987 0 00-3.32-4.4A9.951 9.951 0 002.05 11h4.86zM15.07 11a7.994 7.994 0 014.06-6A9.969 9.969 0 0013 2.05V11h2.07zM8.93 11H11V2.05A9.943 9.943 0 004.87 5a7.994 7.994 0 014.06 6zM15.07 13H13v8.95A9.943 9.943 0 0019.13 19a7.994 7.994 0 01-4.06-6zM3.59 17.4A6.029 6.029 0 006.91 13H2.05c.16 1.61.71 3.11 1.54 4.4zM17.09 13a5.987 5.987 0 003.32 4.4 9.951 9.951 0 001.54-4.4h-4.86zM8.93 13a7.994 7.994 0 01-4.06 6A9.969 9.969 0 0011 21.95V13H8.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$37b497ba2859bcd8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.05 12.81L6.56 4.32a.996.996 0 00-1.41 0L2.32 7.15a.996.996 0 000 1.41l8.49 8.49c.39.39 1.02.39 1.41 0l2.83-2.83a.996.996 0 000-1.41zM14.341 17.756l1.414-1.414 4.243 4.243-1.414 1.414z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "5.5",
                    "r": "3.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a5deeffcd4de3fcf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.58 16.09l-1.09-7.66A3.996 3.996 0 0016.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91zM11 11H9v2H8v-2H6v-1h2V8h1v2h2v1zm4-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e9f1ffb4a4011c2b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.02 15.62c-.08 2.42.32 4.34.67 4.69s2.28.76 4.69.67l-5.36-5.36zM13.08 3.28c-2.33.42-4.79 1.34-6.62 3.18s-2.76 4.29-3.18 6.62l7.63 7.63c2.34-.41 4.79-1.34 6.62-3.18s2.76-4.29 3.18-6.62l-7.63-7.63zM9.9 15.5l-1.4-1.4 5.6-5.6 1.4 1.4-5.6 5.6zM20.98 8.38c.08-2.42-.32-4.34-.67-4.69s-2.28-.76-4.69-.67l5.36 5.36z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$10804a4658865b62(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7 3.13 7 7 7zm0-12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "8",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h2c1.1 0 2 .9 2 2v1h2v-1c0-1.1.9-2 2-2h2v-2H7v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$70b3c4e6ece502f6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM1 9h6l7-5 1.31 1.52-4.17 2.98H14L21.8 4 23 5.4 14.5 12 14 22h-2l-.5-10L8 11H1V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$65d61b066d46b5d6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.27 6c-.55.95-.22 2.18.73 2.73.95.55 2.18.22 2.73-.73.55-.95.22-2.18-.73-2.73-.95-.55-2.18-.22-2.73.73z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.84 10.41l-2.6-1.5c-2.38-1.38-3.2-4.44-1.82-6.82l-1.73-1C8.1 3.83 8.6 7.21 10.66 9.4l-5.15 8.92 1.73 1 1.5-2.6 1.73 1-3 5.2 1.73 1 6.29-10.89a5.002 5.002 0 01.31 5.46l1.73 1c1.6-2.75 1.28-6.58-1.69-9.08zM12.75 3.8c.72.41 1.63.17 2.05-.55.41-.72.17-1.63-.55-2.05a1.501 1.501 0 00-1.5 2.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$64be636ea8ae64e1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17v3h2v-4H3c-.55 0-1 .45-1 1zM9 16H5v4l4.69-.01c.38 0 .72-.21.89-.55l.87-1.9-1.59-3.48L9 16zM21.71 16.29A.997.997 0 0021 16h-1v4h2v-3c0-.28-.11-.53-.29-.71zM13.6 12.84L17.65 4H14.3l-1.76 3.97-.49 1.1-.05.14L9.7 4H6.35l4.05 8.84 1.52 3.32.08.18 1.42 3.1c.17.34.51.55.89.55L19 20v-4h-4l-1.4-3.16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$502552afba2d637a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "2.38",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 11.88v-4.7l-5.05-2.14c-.97-.41-2.09-.06-2.65.84l-1 1.6c-.67 1.18-1.91 2.06-3.41 2.32l.06.06c.69.69 1.52 1.07 2.46 1.17.8-.42 1.52-.98 2.09-1.64l.6 3-1.16 1.1-.94.89v7.5h2v-6l2.1-2 1.8 8H23l-2.18-11-.62-3.1 1.8.7v3.4h2zM10.29 8.09c.22.15.47.24.72.29.13.02.25.04.38.04s.26-.01.38-.04c.13-.02.25-.06.37-.11.24-.1.47-.24.66-.44.49-.49.67-1.17.55-1.8-.07-.37-.25-.74-.55-1.03-.19-.19-.42-.34-.66-.44-.12-.05-.24-.09-.37-.11s-.25-.04-.38-.04c-.12 0-.23.01-.35.03-.14.02-.28.06-.41.11-.23.11-.46.26-.65.45-.3.29-.48.66-.55 1.03-.12.63.06 1.31.55 1.8.09.1.2.18.31.26z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.24 10.56l-2-2c-.1-.1-.2-.18-.31-.26a1.93 1.93 0 00-.72-.28c-.13-.03-.25-.04-.38-.04-.51 0-1.02.2-1.41.59l-3.34 3.34c-.41.41-.62.98-.58 1.54 0 .18.04.37.11.55l1.07 2.95-3.63 3.63L1.46 22l4.24-4.24v-2.22L7 16.75v5.13h2v-6l-2.12-2.12 2.36-2.36.71.71c1.29 1.26 2.97 2.04 5.03 2.04l-.14-2.07c-1.5-.02-2.7-.62-3.6-1.52z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$33a43895d17572bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.8 2l-8.2 6.7-1.21-1.04 3.6-2.08L9.41 1 8 2.41l2.74 2.74L5 8.46l-1.19 4.29L6.27 17 8 16l-2.03-3.52.35-1.3L9.5 13l.5 9h2l.5-10L21 3.4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "5",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4ad088fb022d8778(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-3H7v3zM18 7c-.55 0-1 .45-1 1V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v5.8c0 .13.01.26.04.39l.8 4c.09.47.5.8.98.8h10.36c.45 0 .89-.36.98-.8l.8-4c.03-.13.04-.26.04-.39V8c0-.55-.45-1-1-1zm-3 3H7V7h8v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d05574b14bf5955a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.39c0-.65-.39-1.23-.98-1.48L5.44 7.55c-1.48 1.68-2.32 3.7-2.8 5.45h7.75c.89 0 1.61-.72 1.61-1.61z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.96 11.22c-.41-4.41-4.56-7.49-8.98-7.2-2.51.16-4.44.94-5.93 2.04l4.74 2.01c1.33.57 2.2 1.87 2.2 3.32 0 1.99-1.62 3.61-3.61 3.61H2.21C2 16.31 2 17.2 2 17.2v.8c0 1.1.9 2 2 2h10c4.67 0 8.41-4.01 7.96-8.78z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c82207cdd6a5fdd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.49 3.51c-.56-.56-2.15-.97-4.16-.97-3.08 0-7.15.96-9.98 3.79-4.69 4.7-4.25 12.74-2.84 14.16.56.56 2.15.97 4.16.97 3.08 0 7.15-.96 9.98-3.79 4.69-4.7 4.25-12.74 2.84-14.16zM7.76 7.76c2.64-2.64 6.35-3.12 8.03-3.19-2.05.94-4.46 2.45-6.61 4.61a23.462 23.462 0 00-4.62 6.63c.1-2.48.88-5.74 3.2-8.05zm8.48 8.48c-2.64 2.64-6.35 3.12-8.03 3.19 2.05-.94 4.46-2.45 6.61-4.61 2.16-2.16 3.67-4.58 4.62-6.63-.1 2.48-.88 5.74-3.2 8.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8d48bb2d6cb603cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 3.3l1.35-.95a8.01 8.01 0 014.38 3.34l-.39 1.34-1.35.46L13 6.7V5.3zm-3.35-.95L11 5.3v1.4L7.01 9.49l-1.35-.46-.39-1.34a8.103 8.103 0 014.38-3.34zM7.08 17.11l-1.14.1A7.938 7.938 0 014 12c0-.12.01-.23.02-.35l1-.73 1.38.48 1.46 4.34-.78 1.37zm7.42 2.48c-.79.26-1.63.41-2.5.41s-1.71-.15-2.5-.41l-.69-1.49.64-1.1h5.11l.64 1.11-.7 1.48zM14.27 15H9.73l-1.35-4.02L12 8.44l3.63 2.54L14.27 15zm3.79 2.21l-1.14-.1-.79-1.37 1.46-4.34 1.39-.47 1 .73c.01.11.02.22.02.34 0 1.99-.73 3.81-1.94 5.21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7e3ad11626acd2a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.52 2.49C17.18.15 12.9.62 9.97 3.55c-1.6 1.6-2.52 3.87-2.54 5.46-.02 1.58.26 3.89-1.35 5.5l-4.24 4.24 1.42 1.42 4.24-4.24c1.61-1.61 3.92-1.33 5.5-1.35s3.86-.94 5.46-2.54c2.92-2.93 3.4-7.21 1.06-9.55zm-9.2 9.19c-1.53-1.53-1.05-4.61 1.06-6.72s5.18-2.59 6.72-1.06c1.53 1.53 1.05 4.61-1.06 6.72s-5.18 2.59-6.72 1.06zM18 17c.53 0 1.04.21 1.41.59.78.78.78 2.05 0 2.83-.37.37-.88.58-1.41.58s-1.04-.21-1.41-.59c-.78-.78-.78-2.05 0-2.83.37-.37.88-.58 1.41-.58m0-2a3.998 3.998 0 00-2.83 6.83c.78.78 1.81 1.17 2.83 1.17a3.998 3.998 0 002.83-6.83A3.998 3.998 0 0018 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7822b6a3a19398e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4.01C3.58 5.84 2 8.73 2 12c0 1.46.32 2.85.89 4.11L6 14.31V4.01zM11 11.42V2.05c-1.06.11-2.07.38-3 .79v10.32l3-1.74zM12 13.15l-8.11 4.68c.61.84 1.34 1.59 2.18 2.2L15 14.89l-3-1.74zM13 7.96v3.46l8.11 4.68c.42-.93.7-1.93.82-2.98L13 7.96zM8.07 21.2c1.21.51 2.53.8 3.93.8 3.34 0 6.29-1.65 8.11-4.16L17 16.04 8.07 21.2zM21.92 10.81c-.55-4.63-4.26-8.3-8.92-8.76v3.6l8.92 5.16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$453e9a46a0bb18db(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.23 6c-1.66 0-3.22.66-4.36 1.73C6.54 6.73 5.61 6 4.5 6a2.5 2.5 0 000 5c.21 0 .41-.03.61-.08-.05.25-.09.51-.1.78a6.006 6.006 0 006.68 6.27c2.55-.28 4.68-2.26 5.19-4.77.15-.71.15-1.4.06-2.06-.09-.6.38-1.13.99-1.13H22V6H11.23zM4.5 9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm6.5 6c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "12",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a0b613d5036b05d9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 23c-1.03 0-2.06-.25-3-.75-1.89 1-4.11 1-6 0-1.89 1-4.11 1-6 0-.95.5-1.97.75-3 .75H2v-2h1c1.04 0 2.08-.35 3-1 1.83 1.3 4.17 1.3 6 0 1.83 1.3 4.17 1.3 6 0 .91.65 1.96 1 3 1h1v2h-1zM17 1.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-2.57 6.98L12.18 10 16 13v3.84c.53.38 1.03.78 1.49 1.17-.68.58-1.55.99-2.49.99-1.2 0-2.27-.66-3-1.5-.73.84-1.8 1.5-3 1.5-.33 0-.65-.05-.96-.14C5.19 16.9 3 14.72 3 13.28 3 12.25 4.01 12 4.85 12c.98 0 2.28.31 3.7.83l-.53-3.1c-.11-.67.18-1.38.78-1.79l2.15-1.45-2-.37-2.82 1.93L5 6.4 8.5 4l5.55 1.03c.45.09.93.37 1.22.89l.88 1.55A5.007 5.007 0 0020.5 10v2a7.01 7.01 0 01-6.07-3.52zM10.3 11.1l.44 2.65c.92.42 2.48 1.27 3.26 1.75V14l-3.7-2.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2bb5a018908101c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H8v-1.5c0-1.99 4-3 6-3s6 1.01 6 3V16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$68bceda1bc26d48(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h2V4zM2.17 11.12c-.11.25-.17.52-.17.8V13c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66.23.45.52.86.88 1.22L10 22l6.41-6.41c.38-.38.59-.89.59-1.42V6.34C17 5.05 15.95 4 14.66 4h-8.1c-.71 0-1.36.37-1.72.97l-2.67 6.15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9bb7a3469da1f9d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1H2v11zm19.83-7.12c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66a4.8 4.8 0 00-.88-1.22L14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.84A2.34 2.34 0 009.34 20h8.11c.7 0 1.36-.37 1.72-.97l2.66-6.15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$76e47b62e6fc077c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.92 7.02C17.45 4.18 14.97 2 12 2 9.82 2 7.83 3.18 6.78 5.06 4.09 5.41 2 7.74 2 10.5 2 13.53 4.47 16 7.5 16h10c2.48 0 4.5-2.02 4.5-4.5a4.5 4.5 0 00-4.08-4.48zM14.8 17l-2.9 3.32 2 1L11.55 24h2.65l2.9-3.32-2-1L17.45 17zM8.8 17l-2.9 3.32 2 1L5.55 24H8.2l2.9-3.32-2-1L11.45 17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2618bd3bd1501bd9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.11 8L23 3H1l2.89 5zM7.95 15L12 22l4.05-7zM18.95 10H5.05l1.74 3h10.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6902df374ce30dc1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c1.93 0 3.5 1.57 3.5 3.5S13.93 15 12 15s-3.5-1.57-3.5-3.5S10.07 8 12 8zm4.53.38l3.97-3.96V7h2V1h-6v2h2.58l-3.97 3.97C14.23 6.36 13.16 6 12 6s-2.23.36-3.11.97l-.65-.65 1.41-1.41-1.41-1.42L6.82 4.9 4.92 3H7.5V1h-6v6h2V4.42l1.91 1.9-1.42 1.42L5.4 9.15l1.41-1.41.65.65c-.6.88-.96 1.95-.96 3.11a5.5 5.5 0 004.5 5.41V19H9v2h2v2h2v-2h2v-2h-2v-2.09a5.5 5.5 0 003.53-8.53z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f5db4ff08ad9741e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3 16.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S11 12 11 14.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l3.2 3.2 1.4-1.4-3.2-3.2zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zM12 20v2C6.48 22 2 17.52 2 12S6.48 2 12 2c4.84 0 8.87 3.44 9.8 8h-2.07A8 8 0 0015 4.59V5c0 1.1-.9 2-2 2h-2v2c0 .55-.45 1-1 1H8v2h2v3H9l-4.79-4.79C4.08 10.79 4 11.38 4 12c0 4.41 3.59 8 8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$17aa850a2be59d7c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.67 17.63c-3.8 2.8-6.12.4-6.67 0-.66.49-2.92 2.76-6.67 0C3.43 19.03 2.65 19 2 19v2c1.16 0 2.3-.32 3.33-.93a6.535 6.535 0 006.67 0 6.535 6.535 0 006.67 0c1.03.61 2.17.93 3.33.93v-2c-.66 0-1.5-.02-3.33-1.37zM19.33 12H22v-2h-2.67C17.5 10 16 8.5 16 6.67c0-1.02.38-1.74 1.09-3.34-1.37-.21-2-.33-3.09-.33C7.36 3 2.15 8.03 2.01 14.5l-.01 2c1.16 0 2.3-.32 3.33-.93a6.535 6.535 0 006.67 0 6.535 6.535 0 006.67 0c1.03.61 2.17.93 3.33.93v-2c-.66 0-1.5-.02-3.33-1.37-3.8 2.8-6.12.4-6.67 0-.9.67-.54.41-.91.63-.7-.94-1.09-2.06-1.09-3.26 0-2.58 1.77-4.74 4.21-5.33-.13.51-.21 1.02-.21 1.5C14 9.61 16.39 12 19.33 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2e3e7c8c7497fe62(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5.5H8V4h.5c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1H6v1.5H3c-.55 0-1 .45-1 1s.45 1 1 1V15c0 1.1.9 2 2 2h1v4l2 1.5V17h1c1.1 0 2-.9 2-2V7.5c.55 0 1-.45 1-1s-.45-1-1-1zM9 9H7.25c-.41 0-.75.34-.75.75s.34.75.75.75H9V12H7.25c-.41 0-.75.34-.75.75s.34.75.75.75H9V15H5V7.5h4V9zm10.5 1.5V10c.55 0 1-.45 1-1s-.45-1-1-1h-5c-.55 0-1 .45-1 1s.45 1 1 1v.5c0 .5-1.5 1.16-1.5 3V20c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-6.5c0-1.84-1.5-2.5-1.5-3zm-3 0V10h1v.5c0 1.6 1.5 2 1.5 3v.5h-4v-.5c0-1 1.5-1.4 1.5-3zM15 20v-1.5h4V20h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9e08b923f995ea4b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-7l-2 5H6l-4 9h20zM13 1h2v4h-2zM16.121 5.468L18.95 2.64l1.414 1.414-2.829 2.828zM7.64 4.05l1.414-1.414 2.828 2.828-1.414 1.415z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6f0ae78eea15804(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4H6C3.79 4 2 5.79 2 8v8c0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zm-1.86 9.77c-.24.2-.57.28-.88.2L4.15 11.25C4.45 10.52 5.16 10 6 10h12c.67 0 1.26.34 1.63.84l-3.49 2.93zM6 6h12c1.1 0 2 .9 2 2v.55c-.59-.34-1.27-.55-2-.55H6c-.73 0-1.41.21-2 .55V8c0-1.1.9-2 2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3913c7aacc9c4ad0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zM7.83 14c.37 0 .67.26.74.62.41 2.22 2.28 2.98 3.64 2.87.43-.02.79.32.79.75 0 .4-.32.73-.72.75-2.13.13-4.62-1.09-5.19-4.12a.75.75 0 01.74-.87z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c35678dd9e2d6b63(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 17c0 3.31-2.69 6-6 6v-1.5c2.48 0 4.5-2.02 4.5-4.5H23zM1 7c0-3.31 2.69-6 6-6v1.5C4.52 2.5 2.5 4.52 2.5 7H1zm7.01-2.68l-4.6 4.6c-3.22 3.22-3.22 8.45 0 11.67s8.45 3.22 11.67 0l7.07-7.07c.49-.49.49-1.28 0-1.77a1.25 1.25 0 00-1.77 0l-4.42 4.42-.71-.71 6.54-6.54c.49-.49.49-1.28 0-1.77s-1.28-.49-1.77 0l-5.83 5.83-.71-.71 6.89-6.89c.49-.49.49-1.28 0-1.77s-1.28-.49-1.77 0l-6.89 6.89-.69-.7 5.48-5.48c.49-.49.49-1.28 0-1.77s-1.28-.49-1.77 0l-7.62 7.62a4.003 4.003 0 01-.33 5.28l-.71-.71a3 3 0 000-4.24l-.35-.35 4.07-4.07c.49-.49.49-1.28 0-1.77a1.27 1.27 0 00-1.78.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b1964b3ab4824b0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.05 4.91A9.816 9.816 0 0012.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01zm-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.264 8.264 0 01-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 012.41 5.83c.02 4.54-3.68 8.23-8.22 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aeeb2cd9ab7eaef4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c08e6161568626ff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.94 8.31C13.62 7.52 12.85 7 12 7s-1.62.52-1.94 1.31L7 16h3.5v6h3v-6H17l-3.06-7.69z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$594e063b113b5030(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.94 8.31C13.62 7.52 12.85 7 12 7s-1.62.52-1.94 1.31L7 16h3v6h4v-6h3l-3.06-7.69z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6ef6d8ca878826(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.68 13.69L12 11.93l2.31 1.76-.88-2.85L15.75 9h-2.84L12 6.19 11.09 9H8.25l2.31 1.84-.88 2.85zM20 10c0-4.42-3.58-8-8-8s-8 3.58-8 8c0 2.03.76 3.87 2 5.28V23l6-2 6 2v-7.72A7.96 7.96 0 0020 10zm-8-6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2973b854002fab04(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f04875defa7d995a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d797b0e77bb161f1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$63aa31c30439556a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d7eb81daadcd4374(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af6ce83144860625(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.89l.94 3.11h2.82l-2.27 1.62.93 3.01L12 14.79l-2.42 1.84.93-3.01L8.24 12h2.82L12 8.89M12 2l-2.42 8H2l6.17 4.41L5.83 22 12 17.31 18.18 22l-2.35-7.59L22 10h-7.58L12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a5468684e436280(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$67134f8ee59d9d1a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f39073987d824517(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a6c6a33d7f9861a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.89l.94 3.11h2.82l-2.27 1.62.93 3.01L12 14.79l-2.42 1.84.93-3.01L8.24 12h2.82L12 8.89M12 2l-2.42 8H2l6.17 4.41L5.83 22 12 17.31 18.18 22l-2.35-7.59L22 10h-7.58L12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85d4a18412289d52(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6509cbce6966f76d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zM7 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b47959fdb1024ce2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$778e53d359fcd9b5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.25 13a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM15 11.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm7 .25c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zM10.66 4.12C12.06 6.44 14.6 8 17.5 8c.46 0 .91-.05 1.34-.12C17.44 5.56 14.9 4 12 4c-.46 0-.91.05-1.34.12zM4.42 9.47a8.046 8.046 0 003.66-4.44 8.046 8.046 0 00-3.66 4.44zM20 12c0-.78-.12-1.53-.33-2.24-.7.15-1.42.24-2.17.24a10 10 0 01-7.76-3.69A10.016 10.016 0 014 11.86c.01.04 0 .09 0 .14 0 4.41 3.59 8 8 8s8-3.59 8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a7739d4e51fd3d0e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cedd45bf25ffdea6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b57d338cb66c801(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5476eba247d53f27(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e4637f0ebffc97cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a00a070ed56fac26(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b03d1d9e53da9d7a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a97c24b6b70fa93(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$25c1481e3b3482f6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e9864b45ed45bab8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$39dddc0f05051e04(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$be73fd81e8404050(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e3e265d525c5060e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M2 22h20V2L2 22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12L2 22h10V12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$34aa48c4af95128e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M2 22h20V2L2 22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10L2 22h12V10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$70143124b96ce4d2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M2 22h20V2L2 22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7L2 22h15V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$40f9c3244a05c320(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M22 8V2L2 22h16V8h4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5d80143066c5992b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M22 8V2L2 22h16V8h4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$728ca056b7dc0994(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M22 8V2L2 22h16V8h4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22V6L2 22h16zm2-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9bd1425b5923621a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14.5c0-.23.04-.46.07-.68-.92-.43-2.14-.82-3.57-.82-3 0-5.1 1.7-5.3 1.9l5.3 6.6 3.5-4.36V14.5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f9e34478ab0895ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dcbf136dce0c52b9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14.5c0-1.34.51-2.53 1.34-3.42C15.62 10.51 13.98 10 12 10c-4.1 0-6.8 2.2-7.2 2.5l7.2 9 3.5-4.38V14.5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8beb01055b61916f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.79 12.52L12 21.5l7.21-8.99C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9b3c75105d899693(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5a4.92 4.92 0 013.27-4.68C17.29 8.98 14.94 8 12 8c-4.81 0-8.04 2.62-8.47 2.95L12 21.5l3.5-4.36V14.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$487cfd199a67ec76(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.53 10.95L12 21.5l8.47-10.55C20.04 10.62 16.81 8 12 8s-8.04 2.62-8.47 2.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$847e76a2f6f1d937(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21v-9h8.99L24 8.98z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.59 14l-2.09 2.09-.3-.3L15.41 14 14 15.41l1.79 1.79.3.3L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f08493d2c29f1a78(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M12 12h8.99L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36A7.932 7.932 0 0112 13v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21v-8c-2.21 0-4.2.89-5.65 2.34L12 21zm9-5.59L19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b177703a3799793(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M18.31 12h2.67L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l4.23 4.24A10.96 10.96 0 0112 10c2.35 0 4.52.74 6.31 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-3.03 0-5.78 1.23-7.77 3.22L12 21v-9h6.32c-1.8-1.26-3.97-2-6.32-2zm9 5.41L19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$115772406f32a822(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M21.18 11.8L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l2.82 2.82C5.17 9.45 8.41 8 12 8s6.83 1.45 9.18 3.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.18 11.8C18.83 9.45 15.59 8 12 8s-6.83 1.45-9.18 3.8L12 21v-9h8.99l.19-.2zM19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41 19.59 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91565ab8a237f55d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17.65 15.34L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36C7.8 13.89 9.79 13 12 13s4.2.89 5.65 2.34z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.65 15.34C16.2 13.89 14.21 13 12 13s-4.2.89-5.65 2.34L12 21l5.65-5.66z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e492b946ff18c540(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M19.77 13.22L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l4.23 4.24C6.22 11.23 8.97 10 12 10s5.78 1.23 7.77 3.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 13.22C17.78 11.23 15.03 10 12 10s-5.78 1.23-7.77 3.22L12 21l7.77-7.78z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b55dcc5577059a60(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M21.18 11.8L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l2.82 2.82C5.17 9.45 8.41 8 12 8s6.83 1.45 9.18 3.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.18 11.8C18.83 9.45 15.59 8 12 8s-6.83 1.45-9.18 3.8L12 21l9.18-9.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0c3f811757e45d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 14.76V8h5.92C19.97 5.51 16.16 4 12 4 7.31 4 3.07 5.9 0 8.98l6.35 6.36A7.95 7.95 0 0112 13c1.89 0 3.63.66 5 1.76z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.35 15.34L12 21l5-5.01v-1.23A7.963 7.963 0 0012 13c-2.21 0-4.2.89-5.65 2.34zM19 18h2v2h-2zM19 10h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3fbaeb6b1a21cd03(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 11.21V8h5.92C19.97 5.51 16.16 4 12 4 7.31 4 3.07 5.9 0 8.98l4.23 4.24A10.96 10.96 0 0117 11.21z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.23 13.22L12 21l5-5.01v-4.78a10.96 10.96 0 00-12.77 2.01zM19 18h2v2h-2zM19 10h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4185175b1094f152(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 9V8h5.92C19.97 5.51 16.16 4 12 4 7.31 4 3.07 5.9 0 8.98l2.82 2.82A12.93 12.93 0 0112 8c1.77 0 3.46.36 5 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.82 11.8L12 21l5-5.01V9c-1.54-.64-3.23-1-5-1-3.59 0-6.83 1.45-9.18 3.8zM19 18h2v2h-2zM19 10h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e603da3dc0d8aa3d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 18h2v2h-2zM19 10h2v6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8h5.92C19.97 5.51 16.16 4 12 4 7.31 4 3.07 5.9 0 8.98L12 21l5-5.01V8z",
                    "opacity": ".3"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e58831ca0001163(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.52 15.16c.41-.73 1.18-1.16 1.63-1.8.48-.68.21-1.94-1.14-1.94-.88 0-1.32.67-1.5 1.23l-1.37-.57C16.51 10.96 17.52 10 19 10c1.23 0 2.08.56 2.51 1.26.37.6.58 1.73.01 2.57-.63.93-1.23 1.21-1.56 1.81-.13.24-.18.4-.18 1.18h-1.52c0-.41-.07-1.08.26-1.66zm-.57 3.79c0-.59.47-1.04 1.05-1.04.59 0 1.04.45 1.04 1.04 0 .58-.44 1.05-1.04 1.05-.58 0-1.05-.47-1.05-1.05z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M14 13c0-2.76 2.24-5 5-5 1.63 0 3.07.79 3.98 2L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21l4.01-4.02C14.8 16.07 14 14.63 14 13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$837ab39f00b40185(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M16.49 4.5c1.79 0 3.42.73 4.59 1.91l1.06-1.06A7.94 7.94 0 0016.49 3c-2.21 0-4.21.9-5.66 2.34l1.06 1.06a6.545 6.545 0 014.6-1.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M16.49 6c-1.38 0-2.63.56-3.54 1.46l1.06 1.06c.63-.63 1.51-1.03 2.47-1.03s1.84.39 2.47 1.03l1.06-1.06A4.94 4.94 0 0016.49 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 9c-.55 0-1.05.22-1.41.59L16.49 11l1.41-1.41c-.36-.37-.86-.59-1.41-.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17.83c1.29.54 2.63.89 4 1.07v-2.23l-2.35-.47L15 17.83zM7.33 5H5.1c.18 1.37.53 2.7 1.07 4L7.8 7.35 7.33 5z",
                    "opacity": ".3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2 14.87l-3.67-.73c-.5-.1-.83.2-.9.27l-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.55.03 1.03-.43 1.03-1v-4.15c0-.48-.34-.89-.8-.98zM5.1 5h2.23l.47 2.35L6.17 9c-.54-1.3-.9-2.63-1.07-4zM19 18.9c-1.37-.18-2.7-.53-4-1.07l1.65-1.63 2.35.47v2.23z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c684ef5c39d7f35(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M16.49 4.5c1.79 0 3.42.73 4.59 1.91l1.06-1.06A7.94 7.94 0 0016.49 3c-2.21 0-4.21.9-5.66 2.34l1.06 1.06a6.545 6.545 0 014.6-1.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 6c-1.38 0-2.63.56-3.54 1.46l1.06 1.06c.63-.63 1.51-1.03 2.47-1.03s1.84.39 2.47 1.03l1.06-1.06A4.94 4.94 0 0016.49 6zM16.49 9c-.55 0-1.05.22-1.41.59L16.49 11l1.41-1.41c-.36-.37-.86-.59-1.41-.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17.83c1.29.54 2.63.89 4 1.07v-2.23l-2.35-.47L15 17.83zM7.33 5H5.1c.18 1.37.53 2.7 1.07 4L7.8 7.35 7.33 5z",
                    "opacity": ".3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2 14.87l-3.67-.73c-.5-.1-.83.2-.9.27l-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.55.03 1.03-.43 1.03-1v-4.15c0-.48-.34-.89-.8-.98zM5.1 5h2.23l.47 2.35L6.17 9c-.54-1.3-.9-2.63-1.07-4zM19 18.9c-1.37-.18-2.7-.53-4-1.07l1.65-1.63 2.35.47v2.23z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ece6c9139236bf55(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15H5.5v-4.5H4V9h3v6zm6.5-1.5h-3v-1h2c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1H9v1.5h3v1h-2c-.55 0-1 .45-1 1V15h4.5v-1.5zm6 .5v-4c0-.55-.45-1-1-1H15v1.5h3v1h-2v1h2v1h-3V15h3.5c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$778e0fcdde2c697e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.53 21.48A10.487 10.487 0 011.56 13H.06c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08a1.07 1.07 0 01-.4-.24c-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72.2-.61.2-.97c0-.19-.02-.38-.07-.56a1.67 1.67 0 00-.23-.51c-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31a2.098 2.098 0 00.89-.75c.1-.15.17-.3.22-.46s.07-.32.07-.48c0-.36-.06-.68-.18-.96s-.29-.51-.51-.69c-.2-.19-.47-.33-.77-.43C9.11 8.05 8.77 8 8.4 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34.23-.17.38-.22.3-.08.48-.08c.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49s-.14.27-.25.37c-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09h-.77v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4s.1.35.1.57c0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.44-.18-.93-.27-1.47-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27s.84-.43 1.16-.76c.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57s-.42-.87-.74-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12.01 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.45 4.84 18.3 0 12.01 0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ec6171612f8c4051(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11h-1.5v-.5h-2v3h2V13H21v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zM8 10v5H6.5v-1.5h-2V15H3v-5c0-.55.45-1 1-1h3c.55 0 1 .45 1 1zm-1.5.5h-2V12h2v-1.5zm7 1.5c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-4V9h4c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM11 10.5v.75h2v-.75h-2zm2 2.25h-2v.75h2v-.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bf6d3852864a89ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3307b60b309d9732(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6128c8f206cc953b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "4.54",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C18.42 8.5 17.44 7 15.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L8.22 10l1.92.53.65-1.53H13l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H18v5h2v-5.5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bfc787f3745d7bd9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-9 7c-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 105.9 5.9h-2.07c-.41 1.16-1.52 2-2.83 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$77c249477966cc3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7.28V5c0-1.1-.9-2-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-2.28A2 2 0 0022 15V9a2 2 0 00-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8d9a4928af69bccf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-6.74L16.71 6H6.29l5.21-2.74m0-2.26L2 6v2h19V6l-9.5-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa35faee957f6db4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 16H7v-.24C8.42 17.62 10.16 17 12 17s3.58.62 5 1.76V19zm2-1.14C17.2 16.09 14.73 15 12 15s-5.2 1.09-7 2.86V5h14v12.86zM12 13c1.93 0 3.5-1.57 3.5-3.5S13.93 6 12 6 8.5 7.57 8.5 9.5 10.07 13 12 13zm0-5c.83 0 1.5.67 1.5 1.5S12.83 11 12 11s-1.5-.67-1.5-1.5S11.17 8 12 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bdc85795d21db772(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.35 18.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5s-3.34-.56-4.65-1.5zm10.79-1.38a9.947 9.947 0 00-12.28 0A7.957 7.957 0 014 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.95-.7 3.73-1.86 5.12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$94ddecf71cfdbc36(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h10v-2H4v-6h18V6c0-1.11-.89-2-2-2zm0 4H4V6h16v2zm4 9v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$459c77f9ecd19d2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.5l6 4.5v1c.7 0 1.37.1 2 .29V9l-8-6-8 6v12h7.68c-.3-.62-.5-1.29-.6-2H6v-9l6-4.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm3 5.5h-2.5V21h-1v-2.5H15v-1h2.5V15h1v2.5H21v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f703ef46db9b1d14(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4l-3.87 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$608d7d0702b6fe66(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.18L10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10L22 5.18zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8c1.57 0 3.04.46 4.28 1.25l1.45-1.45A10.02 10.02 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10c1.73 0 3.36-.44 4.78-1.22l-1.5-1.5c-1 .46-2.11.72-3.28.72zm7-5h-3v2h3v3h2v-3h3v-2h-3v-3h-2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d22733193fdf6b77(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11c.17 0 .33.01.49.02L15 3H9l5.68 9.84A5.986 5.986 0 0119 11zM8.15 4.52L2 15.5 5 21l6.33-10.97zM13.2 15.5H9.9L6.73 21h7.81A5.93 5.93 0 0113 17c0-.52.07-1.02.2-1.5zM20 16v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$361c0e1daa39ae38(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5v2h-3v3h-2V7h-3V5h3V2h2v3h3zm-3 14H5V5h6V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6h-2v6zm-4-6v4h2v-4h-2zm-4 4h2V9h-2v8zm-2 0v-6H7v6h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c975fff46285dfc0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "circle",
                        "attr": {
                            "cx": "17",
                            "cy": "15.5",
                            "r": "1.12"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M17 17.5c-.73 0-2.19.36-2.24 1.08.5.71 1.32 1.17 2.24 1.17s1.74-.46 2.24-1.17c-.05-.72-1.51-1.08-2.24-1.08z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M18 11.09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55A5.973 5.973 0 0017 23c3.31 0 6-2.69 6-6 0-2.97-2.16-5.43-5-5.91zM11 17c0 .56.08 1.11.23 1.62-.24.11-.48.22-.73.3-3.17-1-5.5-4.24-5.5-7.74v-3.6l5.5-2.4 5.5 2.4v3.51c-2.84.48-5 2.94-5 5.91zm6 4c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b382084ca7c18e90(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.71 17.99A5.993 5.993 0 016 12c0-3.31 2.69-6 6-6 3.22 0 5.84 2.53 5.99 5.71l-2.1-.63a3.999 3.999 0 10-4.81 4.81l.63 2.1zM22 12c0 .3-.01.6-.04.9l-1.97-.59c.01-.1.01-.21.01-.31 0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8c.1 0 .21 0 .31-.01l.59 1.97c-.3.03-.6.04-.9.04-5.52 0-10-4.48-10-10S6.48 2 12 2s10 4.48 10 10zm-3.77 4.26L22 15l-10-3 3 10 1.26-3.77 4.27 4.27 1.98-1.98-4.28-4.26z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$712c699b6eed1a65(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.337 1.81l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4a9 9 0 10.001 18.001A9 9 0 0012 4zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$45bc1d35c9d7e7d4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.04 6.29C10.66 6.11 11.32 6 12 6c3.86 0 7 3.14 7 7 0 .68-.11 1.34-.29 1.96l1.56 1.56c.47-1.08.73-2.27.73-3.52A9 9 0 008.47 4.72l1.57 1.57zm7.297-4.48l4.607 3.845-1.28 1.535-4.61-3.843zM3.02 2.1L1.61 3.51l1.37 1.37-.92.77 1.28 1.54 1.06-.88.8.8A8.964 8.964 0 003 13a9 9 0 009 9c2.25 0 4.31-.83 5.89-2.2l2.1 2.1 1.41-1.41L3.02 2.1zM12 20c-3.86 0-7-3.14-7-7 0-1.7.61-3.26 1.62-4.47l9.85 9.85A6.956 6.956 0 0112 20zM7.48 3.73l.46-.38-1.28-1.54-.6.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d2b785f6e8bf0119(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.54 14.53L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06zm6.797-12.72l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4a9 9 0 10.001 18.001A9 9 0 0012 4zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e4431fa143511209(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 8H11v6l4.75 2.85.75-1.23-4-2.37zm4.837-6.19l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4a9 9 0 10.001 18.001A9 9 0 0012 4zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e2453edbfe76f03c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 10h3.13c.21.78.67 1.47 1.27 2H5v-2zm14 2h-4.4c.6-.53 1.06-1.22 1.27-2H19v2zm0-4h-5v1c0 1.07-.93 2-2 2s-2-.93-2-2V8H5V5h14v3zm-2 7h-3v1c0 .47-.19.9-.48 1.25-.37.45-.92.75-1.52.75s-1.15-.3-1.52-.75c-.29-.35-.48-.78-.48-1.25v-1H3v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4h-4zM5 17h3.13c.02.09.06.17.09.25.24.68.65 1.28 1.18 1.75H5v-2zm14 2h-4.4c.54-.47.95-1.07 1.18-1.75.03-.08.07-.16.09-.25H19v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b53f1eaae9e1be69(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v4l4-4zm12 0l4 4V4zm4 16v-4l-4 4zM4 20h4l-4-4zm15-8c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7 7-3.13 7-7zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$54a968cd3bbe9bde(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h2v5H7zM15 7h2v10h-2zM11 14h2v3h-2zM11 10h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f38ab0145676dc4e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15l1.55 1.55c-.96 1.69-3.33 3.04-5.55 3.37V11h3V9h-3V7.82C14.16 7.4 15 6.3 15 5c0-1.65-1.35-3-3-3S9 3.35 9 5c0 1.3.84 2.4 2 2.82V9H8v2h3v8.92c-2.22-.33-4.59-1.68-5.55-3.37L7 15l-4-3v3c0 3.88 4.92 7 9 7s9-3.12 9-7v-3l-4 3zM12 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19d14d747d60a633(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85a.637.637 0 00-.83.22l-1.88 3.24a11.463 11.463 0 00-8.94 0L5.65 5.67a.643.643 0 00-.87-.2c-.28.18-.37.54-.22.83L6.4 9.48A10.78 10.78 0 001 18h22a10.78 10.78 0 00-5.4-8.52zM7 15.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm10 0a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$399e9fa77d6385b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM11 5h2v6h-2zm0 8h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7fb296d5c2f28a78(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12l-2 2-2-2 2-2 2 2zm-2-6l2.12 2.12 2.5-2.5L12 1 7.38 5.62l2.5 2.5L12 6zm-6 6l2.12-2.12-2.5-2.5L1 12l4.62 4.62 2.5-2.5L6 12zm12 0l-2.12 2.12 2.5 2.5L23 12l-4.62-4.62-2.5 2.5L18 12zm-6 6l-2.12-2.12-2.5 2.5L12 23l4.62-4.62-2.5-2.5L12 18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4ef360993cb8c63b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-2.5 4A2.5 2.5 0 0118 9.5c.42 0 .8.11 1.15.29l-3.36 3.36c-.18-.35-.29-.73-.29-1.15zm2.5 2.5c-.42 0-.8-.11-1.15-.29l3.36-3.36c.18.35.29.73.29 1.15a2.5 2.5 0 01-2.5 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18H7V6h10v1h2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v1zM7 3h10v1H7V3zm10 18H7v-1h10v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5d9b7bf2d4e0016(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18H7V6h10v1h2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v1zM7 3h10v1H7V3zm10 18H7v-1h10v1zM20.38 9.62L21 11l.62-1.38L23 9l-1.38-.62L21 7l-.62 1.38L19 9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8l-1.25 2.75L12 12l2.75 1.25L16 16l1.25-2.75L20 12l-2.75-1.25zM21 13l-.62 1.38L19 15l1.38.62L21 17l.62-1.38L23 15l-1.38-.62z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$550016e0a5d45eb4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 10V8h-2v4H8l4 4 4-4h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7b5bf5dd51b6dae4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12zm18 0c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8 8 3.58 8 8zM8 12l4-4 1.41 1.41L11.83 11H16v2h-4.17l1.59 1.59L12 16l-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c1167e2ee6451822(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zM4 12c0-4.42 3.58-8 8-8s8 3.58 8 8-3.58 8-8 8-8-3.58-8-8zm12 0l-4 4-1.41-1.41L12.17 13H8v-2h4.17l-1.59-1.59L12 8l4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d084b9ba056091c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0 2c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm-1-10v4h2v-4h3l-4-4-4 4h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e2d1ea7bcc5884d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6v2h8.59L5 17.59 6.41 19 16 9.41V18h2V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$59f2f04955c6f879(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aaca84ff877183ef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$43960dd2a51c3db5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f15d246a13db0c3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$14f2154d7d813a55(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.22 0 .41.1.55.25.12.13.2.31.2.5 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-.19.08-.37.2-.5.14-.15.33-.25.55-.25zM19 19H5V5h14v14zM12 6c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-6 6.47V18h12v-1.53c0-2.5-3.97-3.58-6-3.58s-6 1.07-6 3.58zM8.31 16c.69-.56 2.38-1.12 3.69-1.12s3.01.56 3.69 1.12H8.31z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$82ad05ad4421142c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zm0-8h2v6h-2zm8-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fca3a6e6a36fac04(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14h4v-4h-4V7l-5 5 5 5zm7-11h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2316a093d8c36abd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h-3V8h-4v4H7l5 5zm2-9h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b17c615f38b3405(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9l-1.41-1.42L10 14.17l-2.59-2.58L6 13l4 4zm1-6h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d775552153d83cc5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d764d73b5a2fa0da(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h2v7H5zM11 10h2v7h-2zM22 6L12 1 2 6v2h20V6zM6.47 6L12 3.24 17.53 6H6.47zM2 19v2h12.4c-.21-.64-.32-1.31-.36-2H2zM19 12.26V10h-2v3.26zM20 14l-4 2v2.55c0 2.52 1.71 4.88 4 5.45 2.29-.57 4-2.93 4-5.45V16l-4-2zm-.72 7l-2.03-2.03 1.06-1.06.97.97 2.41-2.38 1.06 1.06L19.28 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f8358a87cb744f8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 016 12c0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc97251e49ca7ec0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6v14H6v2h14c1.1 0 2-.9 2-2V6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 16H4v-5h5v5zm7 0h-5v-5h5v5zm0-7H4V4h12v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de28d1a1bc763a09(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.469 5.469 0 0112 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0122 15c0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$be7af19f9e8fca05(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.83c.85-.3 1.53-.98 1.83-1.83H18l-3 7c0 1.66 1.57 3 3.5 3s3.5-1.34 3.5-3l-3-7h2V4h-6.17c-.41-1.17-1.52-2-2.83-2s-2.42.83-2.83 2H3v2h2l-3 7c0 1.66 1.57 3 3.5 3S9 14.66 9 13L6 6h3.17c.3.85.98 1.53 1.83 1.83V19H2v2h20v-2h-9V7.83zM20.37 13h-3.74l1.87-4.36L20.37 13zm-13 0H3.63L5.5 8.64 7.37 13zM12 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$603e3889ce59f897(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8H7c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-4 12.5h-2V19h2v1.5zm0-2.5h-2c0-1.5-2.5-3-2.5-5 0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 2-2.5 3.5-2.5 5zm5-11.5H6C6 5.67 6.67 5 7.5 5h9c.83 0 1.5.67 1.5 1.5zm-1-3H7C7 2.67 7.67 2 8.5 2h7c.83 0 1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$467ee5e3192bda57(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4H7V3h10v1zm0 17H7v-1h10v1zm0-20H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7 6h10v12H7V6zm9 5V9.14C16 8.51 15.55 8 15 8H9c-.55 0-1 .51-1 1.14v1.96c.55 0 1 .45 1 1s-.45 1-1 1v1.76c0 .63.45 1.14 1 1.14h6c.55 0 1-.51 1-1.14V13c-.55 0-1-.45-1-1s.45-1 1-1zm-3.5 3.5h-1v-1h1v1zm0-2h-1v-1h1v1zm0-2h-1v-1h1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$81707b58ddabe5c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$948bea057df9d6d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11v6.97l-5-2.14-5 2.14V5h6V3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V11h-2zm4-4h-2v2h-2V7h-2V5h2V3h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e8bddf41f6650c53(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11v6.97l-5-2.14-5 2.14V5h6V3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V11h-2zm.83-2L15 6.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41L17.83 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b7abffab7b2b990c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2feace24cb282986(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11v6.97l-5-2.14-5 2.14V5h6V3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V11h-2zm4-4h-6V5h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$72252144566e4bdc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e919f43951962bc0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7v12.97l-4.21-1.81-.79-.34-.79.34L5 19.97V7h10m4-6H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13l2 1V3c0-1.1-.9-2-2-2zm-4 4H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8baa666af85522b9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3a9 9 0 10.001 18.001A9 9 0 009 3zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7H8v5.41l3.79 3.8 1.42-1.42-3.21-3.2zM17.99 3.52v2.16A6.99 6.99 0 0122 12c0 2.79-1.64 5.2-4.01 6.32v2.16C21.48 19.24 24 15.91 24 12s-2.52-7.24-6.01-8.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6564319724b0590(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-2.81a5.985 5.985 0 00-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-4 4v3c0 .22-.03.47-.07.7l-.1.65-.37.65c-.72 1.24-2.04 2-3.46 2s-2.74-.77-3.46-2l-.37-.64-.1-.65A4.27 4.27 0 018 15v-4c0-.23.03-.48.07-.7l.1-.65.37-.65c.3-.52.72-.97 1.21-1.31l.57-.39.74-.18a3.787 3.787 0 011.89 0l.68.16.61.42c.5.34.91.78 1.21 1.31l.38.65.1.65c.04.22.07.47.07.69v1zm-6 2h4v2h-4zm0-4h4v2h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8b39200f8a900ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M13.49 11.38c.43-1.22.17-2.64-.81-3.62a3.468 3.468 0 00-4.1-.59l2.35 2.35-1.41 1.41-2.35-2.35c-.71 1.32-.52 2.99.59 4.1.98.98 2.4 1.24 3.62.81l3.41 3.41c.2.2.51.2.71 0l1.4-1.4c.2-.2.2-.51 0-.71l-3.41-3.41z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ccb7767ed39b056(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.61 18.99l-9.08-9.08c.93-2.34.45-5.1-1.44-7C9.79.61 6.21.4 3.66 2.26L7.5 6.11 6.08 7.52 2.25 3.69C.39 6.23.6 9.82 2.9 12.11c1.86 1.86 4.57 2.35 6.89 1.48l9.11 9.11c.39.39 1.02.39 1.41 0l2.3-2.3c.4-.38.4-1.01 0-1.41zm-3 1.6l-9.46-9.46c-.61.45-1.29.72-2 .82-1.36.2-2.79-.21-3.83-1.25C3.37 9.76 2.93 8.5 3 7.26l3.09 3.09 4.24-4.24-3.09-3.09c1.24-.07 2.49.37 3.44 1.31a4.469 4.469 0 011.24 3.96 4.35 4.35 0 01-.88 1.96l9.45 9.45-.88.89z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c5362adc74f3420f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8l-4 4h3c0 3.31-2.69 6-6 6a5.87 5.87 0 01-2.8-.7l-1.46 1.46A7.93 7.93 0 0012 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46A7.93 7.93 0 0012 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aacaa0a1260b5a43(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f0565356a7b3e245(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$560ced16b05f3bed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17h18v2H3zm16-5v1H5v-1h14m2-2H3v5h18v-5zM3 6h18v2H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b57325853421e410(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 11H4V6h4v5zm6 0h-4V6h4v5zm6 0h-4V6h4v5zM8 18H4v-5h4v5zm6 0h-4v-5h4v5zm6 0h-4v-5h4v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e3eed3b0699991e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 2h2.5v12H13V6zm-2 12H8.5V6H11v12zM4 6h2.5v12H4V6zm16 12h-2.5V6H20v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2e6915762dccd384(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10l-.94 2.06L9 13l2.06.94L12 16l.94-2.06L15 13l-2.06-.94zm8-5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l.59-.65L9.88 5h4.24l1.24 1.35.59.65H20v12zM12 8c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e749ea02d464e3c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 9c-.42 0-.83.04-1.24.11L1.01 3 1 10l10.06 1.34c-.42.44-.78.93-1.09 1.46L1 14l.01 7 8.07-3.46C9.59 21.19 12.71 24 16.5 24c4.14 0 7.5-3.36 7.5-7.5S20.64 9 16.5 9zM3 8.25l.01-2.22 7.51 3.22-7.52-1zm6.1 7.11L3 17.97v-2.22l6.17-.82c-.03.14-.05.28-.07.43zM16.5 22c-3.03 0-5.5-2.47-5.5-5.5s2.47-5.5 5.5-5.5 5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.27 14.03l-1.77 1.76-1.77-1.76-.7.7 1.76 1.77-1.76 1.77.7.7 1.77-1.76 1.77 1.76.7-.7-1.76-1.77 1.76-1.77z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dac702adde60fbf9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 00-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 12 7.4l3.38 4.6L17 10.83 14.92 8H20v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7e2173e2181a5bc1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$17c29cf25ba1b86a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9208ecd447faa75e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ca3441c0fb7c2e3f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f49c474e77cae0dd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4a6a3e2c4ffdfd67(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM3 19V6h8v13H3zm18 0h-8V6h8v13zm-7-9.5h6V11h-6zm0 2.5h6v1.5h-6zm0 2.5h6V16h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$affba608356ecd6b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18.5c.83 0 1.5-.67 1.5-1.5h-3c0 .83.67 1.5 1.5 1.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4-8.61c0-2.11-1.03-3.92-3-4.39v-.5c0-.57-.43-1-1-1s-1 .43-1 1V7c-1.97.47-3 2.27-3 4.39V14H7v2h10v-2h-1v-2.61zM14 14h-4v-3c0-1.1.9-2 2-2s2 .9 2 2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f26f5db603374a42(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$34e77acd888693(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3.41L16.71 8.7 20 12h-8V4l3.29 3.29L20.59 2 22 3.41zM3.41 22l5.29-5.29L12 20v-8H4l3.29 3.29L2 20.59 3.41 22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ff0243d3f52fd773(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.17 12l-4.58-4.59L16 6l6 6-3.59 3.59L17 14.17 19.17 12zM1.39 4.22l4.19 4.19L2 12l6 6 1.41-1.41L4.83 12 7 9.83l12.78 12.78 1.41-1.41L2.81 2.81 1.39 4.22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d487e75b94a8d95f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a6d8e9066e43862a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14V6h-5v8l2.5-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd18cb69454528c0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9 11a5 5 0 00-9.8 0H2v2h5.1a5 5 0 009.8 0H22v-2h-5.1zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$70b2a882f8c23fa2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4H5C3.34 4 2 5.34 2 7v8c0 1.66 1.34 3 3 3l-1 1v1h1l2-2h2v-5H4V6h9v2h2V7c0-1.66-1.34-3-3-3zM5 14c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm15.57-4.34c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66l-1.42 4.11v5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V18h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ecab9f74300afeda(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b5faa43941d710ab(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9v2h16V9H4zm12-5l-1.41-1.41L13 4.17V1h-2v3.19L9.39 2.61 8 4l4 4 4-4zM4 14h16v-2H4v2zm4 5l1.39 1.39L11 18.81V22h2v-3.17l1.59 1.59L16 19l-4-4-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$12646594a39fbfb9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.17 4L18 8.83V20H6V4h7.17M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-2 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 008 17.43V18h8v-.57z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20acc3e1657faa3c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 23.59v-3.6c-5.01-.26-9-4.42-9-9.49C2 5.26 6.26 1 11.5 1S21 5.26 21 10.5c0 4.95-3.44 9.93-8.57 12.4l-1.43.69zM11.5 3C7.36 3 4 6.36 4 10.5S7.36 18 11.5 18H13v2.3c3.64-2.3 6-6.08 6-9.8C19 6.36 15.64 3 11.5 3zm-1 11.5h2v2h-2zm2-1.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$533261714cc21857(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.1 10.18a4.384 4.384 0 010 3.66l1.37.62c.37-.81.55-1.65.54-2.5-.01-.84-.19-1.65-.54-2.4l-1.37.62zM13.33 7.33c.78 1.57 1.18 3.14 1.18 4.64 0 1.51-.4 3.09-1.18 4.69l1.35.66c.88-1.81 1.33-3.61 1.33-5.35 0-1.74-.45-3.53-1.33-5.31l-1.35.67zM10.2 8.72c.53 1.07.8 2.21.8 3.4 0 1.17-.26 2.23-.78 3.15l1.3.74c.65-1.15.98-2.45.98-3.89 0-1.42-.32-2.79-.96-4.07l-1.34.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$80287b05021e9727(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91c.48.22 1.05.34 1.7.34.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91d7e11603501f18(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.83 4H20c1.11 0 2 .89 2 2v12c0 .34-.08.66-.23.94L20 17.17V12h-5.17l-4-4H20V6H8.83l-2-2zm13.66 19.31L17.17 20H4c-1.11 0-2-.89-2-2l.01-12c0-.34.08-.66.23-.93L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM4 6.83V8h1.17L4 6.83zM15.17 18l-6-6H4v6h11.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd1bfad226f544c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$247efb55903caa2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 14v-1H11v.5h2v-1h-2.5c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1H13v-.5h-2v1h2.5c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1zm7.5 1h3c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1h-2.5v-1h2v.5H21v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1h2.5v1h-2V13H16v1c0 .55.45 1 1 1zm-9-5c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-1H6.5v.5h-2v-3h2v.5H8v-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$830579c54bf418af(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.89 11.1c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79.99 1.9 1.34l1.58-.67c-.15-.45-.82-1.92-2.54-2.24V5h-2v1.26c-2.48.56-2.49 2.86-2.49 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66.67c.63 2.19 2.28 2.78 2.9 2.96V19h2v-1.24c.4-.09 2.9-.59 2.9-3.22 0-1.39-.61-2.61-3.01-3.44zM3 21H1v-6h6v2H4.52c1.61 2.41 4.36 4 7.48 4a9 9 0 009-9h2c0 6.08-4.92 11-11 11-3.72 0-7.01-1.85-9-4.67V21zm-2-9C1 5.92 5.92 1 12 1c3.72 0 7.01 1.85 9 4.67V3h2v6h-6V7h2.48C17.87 4.59 15.12 3 12 3a9 9 0 00-9 9H1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4aee9ea740e1e317(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8zm-4.17-7.14L12 10.59 9.17 7.76 7.76 9.17 10.59 12l-2.83 2.83 1.41 1.41L12 13.41l2.83 2.83 1.41-1.41L13.41 12l2.83-2.83-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e3438cae3d6730b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h8V3H3v8zm2-6h4v4H5V5zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM18 13h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9b9ac12fb28eef89(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ca1866323e0a5cf1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.52-4.48-10-10-10zm0 18c-2.89 0-5.43-1.54-6.83-3.84l2.95-2.95L11.41 16 16 11.42V13h2V8h-5v2h1.58l-3.28 3.28L8 10.5l-3.69 3.7C4.11 13.5 4 12.76 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8zm7.5.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$591b6c2608dc0470(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-1.73L19 17.27V19zm0-3h-.85l-3 3h-1.62l3-3h-2.12l-3 3H9.8l3-3h-2.12l-3 3H5.84l3-3H6.72L5 17.72V5h14v11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.67 11l2 2 5.08-5.09-1.41-1.41-3.67 3.67-2-2-4.42 4.42L7.66 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$92826cc7ac088c87(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5a2 2 0 01-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c44e5ea9523411a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.12 10.47L12 12.59l-2.13-2.12-1.41 1.41L10.59 14l-2.12 2.12 1.41 1.41L12 15.41l2.12 2.12 1.41-1.41L13.41 14l2.12-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ff2890bcc985262(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9afcfcef1030457e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c298a6bb452667e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v2H3zM3 19h18v2H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a4e79393d13b260b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v2H3zM3 19h18v2H3zM3 11h18v2H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91595d9e6184d029(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h18v2H3zM3 20h18v2H3zM3 14h18v2H3zM3 8h18v2H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0dd40d4dfc620f4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df392790eaffddf1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h14v14zM3 3v18h18V3H3zm14 12.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b55543ee7cb08fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15c1.95 0 3.76.98 4.75 2.5-.99 1.52-2.8 2.5-4.75 2.5s-3.76-.98-4.75-2.5c.99-1.52 2.8-2.5 4.75-2.5zm0-2c-3.18 0-5.9 1.87-7 4.5 1.1 2.63 3.82 4.5 7 4.5s5.9-1.87 7-4.5c-1.1-2.63-3.82-4.5-7-4.5zm0 6c-.83 0-1.5-.67-1.5-1.5S16.17 16 17 16s1.5.67 1.5 1.5S17.83 19 17 19zm4.99-6.66c.01-.11.01-.23.01-.34 0-5.52-4.48-10-10-10S2 6.48 2 12c0 5.17 3.93 9.43 8.96 9.95a9.343 9.343 0 01-2.32-2.68A8.01 8.01 0 014 12c0-1.85.63-3.55 1.69-4.9l5.66 5.66c.56-.4 1.17-.73 1.82-1L7.1 5.69A7.902 7.902 0 0112 4c4.24 0 7.7 3.29 7.98 7.45.71.22 1.39.52 2.01.89z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$27c76d0dd2b27e35(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h4v2h8v-2h4c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 14H4V5h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8.25h8v1.5H6zM16.5 9.75H18v-1.5h-1.5V7H15v4h1.5zM10 12.25h8v1.5h-8zM7.5 15H9v-4H7.5v1.25H6v1.5h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2278a6ef193c31ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15v4H5v-4h14m1-2H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 18.5c-.82 0-1.5-.67-1.5-1.5s.68-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM19 5v4H5V5h14m1-2H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 8.5c-.82 0-1.5-.67-1.5-1.5S6.18 5.5 7 5.5s1.5.68 1.5 1.5S7.83 8.5 7 8.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3ee6667268faeb2d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c3f0e667c657a0d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 4.93l1.4 1.4L8.43 19.07l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 4.93m0-2.83L8.43 13.44l-4.2-4.2L0 13.47l8.43 8.43L24 6.33 19.77 2.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e1b31af2f0118e6c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a16e8037b4c2c78a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.08A7 7 0 0118.92 11h3.03c-.47-4.72-4.23-8.48-8.95-8.95v3.03zM18.92 13A7 7 0 0113 18.92v3.03c4.72-.47 8.48-4.23 8.95-8.95h-3.03zM11 18.92c-3.39-.49-6-3.4-6-6.92s2.61-6.43 6-6.92V2.05c-5.05.5-9 4.76-9 9.95 0 5.19 3.95 9.45 9 9.95v-3.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$395b55f5405fe23f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.82 11h7.13c-.47-4.72-4.23-8.48-8.95-8.95v7.13c.85.31 1.51.97 1.82 1.82zM15 4.58C17 5.4 18.6 7 19.42 9h-3.43c-.28-.37-.62-.71-.99-.99V4.58zM2 12c0 5.19 3.95 9.45 9 9.95v-7.13C9.84 14.4 9 13.3 9 12c0-1.3.84-2.4 2-2.82V2.05c-5.05.5-9 4.76-9 9.95zm7-7.42v3.44c-1.23.92-2 2.39-2 3.98 0 1.59.77 3.06 2 3.99v3.44C6.04 18.24 4 15.35 4 12c0-3.35 2.04-6.24 5-7.42zm4 10.24v7.13c4.72-.47 8.48-4.23 8.95-8.95h-7.13c-.31.85-.97 1.51-1.82 1.82zm2 1.17c.37-.28.71-.61.99-.99h3.43C18.6 17 17 18.6 15 19.42v-3.43z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2144b93dc430f61d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$683309a0a1da57a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h9v7zM4 9h7V6H4v3zm11 11H4c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h11v7zM4 18h9v-3H4v3zm18-9h-2l2-5h-7v7h2v9l5-11zM4.75 17.25h1.5v-1.5h-1.5v1.5zm0-9h1.5v-1.5h-1.5v1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7dbf07a4b26c52e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.05 8.05a7.007 7.007 0 000 9.9C7.42 19.32 9.21 20 11 20s3.58-.68 4.95-2.05C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05zm8.49 8.49c-.95.94-2.2 1.46-3.54 1.46-.89 0-1.73-.25-2.48-.68.92-2.88 2.62-5.41 4.88-7.32-2.63 1.36-4.84 3.46-6.37 6-1.48-1.96-1.35-4.75.44-6.54C9.21 7.72 14.04 6.65 17.8 6.2c-.45 3.76-1.52 8.59-3.26 10.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$463bf595829580c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h14v2h2V6c0-1.1-.9-2-2-2h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h7v-2H5V10zm0-4h14v2H5V6zm17.84 10.28l-.71.71-2.12-2.12.71-.71a.996.996 0 011.41 0l.71.71c.39.39.39 1.02 0 1.41zm-3.54-.7l2.12 2.12-5.3 5.3H14v-2.12l5.3-5.3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$42ac33e2176ddc26(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.06 9.02l.92.92-1.11 1.11 1.41 1.41 2.52-2.52-3.75-3.75-2.52 2.52 1.41 1.41 1.12-1.1zm6.65-1.98a.996.996 0 000-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83zM2.81 2.81L1.39 4.22l7.32 7.32L3 17.25V21h3.75l5.71-5.71 7.32 7.32 1.41-1.41L2.81 2.81zM5.92 19H5v-.92l5.13-5.13.92.92L5.92 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$73b68d2ee1b871ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17h14v2H5zm7-12L5.33 15h13.34L12 5zm0 3.6l2.93 4.4H9.07L12 8.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6feb3bd66da5b4fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18.5A6.48 6.48 0 019.24 15H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24A6.491 6.491 0 0115 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3A8.955 8.955 0 0015 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06a8.262 8.262 0 000 2H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b075d5c1787485fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12V6c0-1.1-.9-2-2-2h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V10h14v2h2zm-2-4H5V6h14v2zm-3.36 12a3.504 3.504 0 006.86-1c0-1.93-1.57-3.5-3.5-3.5-.95 0-1.82.38-2.45 1H18V18h-4v-4h1.5v1.43c.9-.88 2.14-1.43 3.5-1.43 2.76 0 5 2.24 5 5a5.002 5.002 0 01-9.9 1h1.54z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$29dd2f698b5db6ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5v7H9V5h6m0-2H9c-1.1 0-2 .9-2 2v9h10V5c0-1.1-.9-2-2-2zm7 7h-3v3h3v-3zM5 10H2v3h3v-3zm15 5H4v6h2v-4h12v4h2v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20e88384baef1445(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b7f15f671a3babcb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5a2 2 0 00-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7525edc07f28d39a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h16v2H4zM4 2h16v2H4zM9.41 13.59L8 15l4 4 4-4-1.41-1.41L13 15.17V8.83l1.59 1.58L16 9l-4-4-4 4 1.41 1.41L11 8.83v6.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b5eeb5b6d99a90db(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8 0 1.48-.41 2.86-1.12 4.06l1.46 1.46A9.967 9.967 0 0022 12c0-5.52-4.48-10-10-10-2.04 0-3.93.61-5.51 1.66l1.46 1.46A7.869 7.869 0 0112 4zm2.91 8.08L17.5 6.5l-5.58 2.59 2.99 2.99zM2.1 4.93l1.56 1.56A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l1.56 1.56 1.41-1.41L3.51 3.51 2.1 4.93zm3.02 3.01l3.98 3.98-2.6 5.58 5.58-2.59 3.98 3.98c-1.2.7-2.58 1.11-4.06 1.11-4.41 0-8-3.59-8-8 0-1.48.41-2.86 1.12-4.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ff800a50abf87277(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5.5-2.5l7.51-3.49L17.5 6.5 9.99 9.99 6.5 17.5zm5.5-6.6c.61 0 1.1.49 1.1 1.1s-.49 1.1-1.1 1.1-1.1-.49-1.1-1.1.49-1.1 1.1-1.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$baa9a8bd50a6e92f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.39 4.22l1.62 1.62c0 .05-.01.1-.01.16v3.8c2.7 0 3 2.16 3 2.7s-.29 2.7-3 2.7V19c0 1.1.9 2 2 2h3.8c0-2.71 2.16-3 2.7-3s2.7.29 2.7 3H18c.06 0 .11 0 .16-.01l1.61 1.61 1.41-1.41L2.81 2.81 1.39 4.22zM11.5 16c-1.5 0-3.57.83-4.37 3H5v-2.13c2.17-.8 3-2.87 3-4.37 0-.69-.18-1.5-.58-2.25l6.33 6.33A4.89 4.89 0 0011.5 16zM8.83 6l-2-2H9a2.5 2.5 0 015 0h4c1.1 0 2 .9 2 2v4a2.5 2.5 0 010 5v2.17l-2-2V13h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-2V6h-6V4c0-.28-.22-.5-.5-.5s-.5.22-.5.5v2H8.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d35a82b5b7ce63e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 4.5c.28 0 .5.22.5.5v2h6v6h2c.28 0 .5.22.5.5s-.22.5-.5.5h-2v6h-2.12c-.68-1.75-2.39-3-4.38-3s-3.7 1.25-4.38 3H4v-2.12c1.75-.68 3-2.39 3-4.38 0-1.99-1.24-3.7-2.99-4.38L4 7h6V5c0-.28.22-.5.5-.5m0-2A2.5 2.5 0 008 5H4c-1.1 0-1.99.9-1.99 2v3.8h.29c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-.3c0-1.49 1.21-2.7 2.7-2.7s2.7 1.21 2.7 2.7v.3H17c1.1 0 2-.9 2-2v-4a2.5 2.5 0 000-5V7c0-1.1-.9-2-2-2h-4a2.5 2.5 0 00-2.5-2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$22c7e30f0f9b9a6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.25 13a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM15 11.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm7 .25c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zM10.66 4.12C12.06 6.44 14.6 8 17.5 8c.46 0 .91-.05 1.34-.12C17.44 5.56 14.9 4 12 4c-.46 0-.91.05-1.34.12zM4.42 9.47a8.046 8.046 0 003.66-4.44 8.046 8.046 0 00-3.66 4.44zM20 12c0-.78-.12-1.53-.33-2.24-.7.15-1.42.24-2.17.24a10 10 0 01-7.76-3.69A10.016 10.016 0 014 11.86c.01.04 0 .09 0 .14 0 4.41 3.59 8 8 8s8-3.59 8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$698f0f422e472334(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.25 13a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM15 11.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm7 .25c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zM10.66 4.12C12.06 6.44 14.6 8 17.5 8c.46 0 .91-.05 1.34-.12C17.44 5.56 14.9 4 12 4c-.46 0-.91.05-1.34.12zM4.42 9.47a8.046 8.046 0 003.66-4.44 8.046 8.046 0 00-3.66 4.44zM20 12c0-.78-.12-1.53-.33-2.24-.7.15-1.42.24-2.17.24a10 10 0 01-7.76-3.69A10.016 10.016 0 014 11.86c.01.04 0 .09 0 .14 0 4.41 3.59 8 8 8s8-3.59 8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b45ece0721f1f88f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H4V5h16v14z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M19.41 10.42L17.99 9l-3.17 3.17-1.41-1.42L12 12.16 14.82 15zM5 7h5v2H5zM5 11h5v2H5zM5 15h5v2H5z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b708bb50e77a2536(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e68c0cc1f34b60b8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fad6d936735b65ca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-1V4H8v5h-.78C6.67 8.39 5.89 8 5 8c-1.66 0-3 1.34-3 3v7c0 1.66 1.34 3 3 3 .89 0 1.67-.39 2.22-1H22v-8c0-1.66-1.34-3-3-3zM6 18c0 .55-.45 1-1 1s-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1v7zm4-12h6v3h-6V6zm10 12H8v-7h11c.55 0 1 .45 1 1v6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12h4v5H9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3e0f7c6aed8a1076(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9ebf2ee62e3a5606(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h8v4h4v12zm-6-3c-1.1 0-2-.9-2-2V9.5c0-.28.22-.5.5-.5s.5.22.5.5V15h2V9.5a2.5 2.5 0 00-5 0V15c0 2.21 1.79 4 4 4s4-1.79 4-4v-4h-2v4c0 1.1-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$48a010ce5b8a2148(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.95 6l-3.57 4.55 1.43 1.43c1.03-1.31 4.98-6.37 4.98-6.37A.998.998 0 0019 4H6.83l2 2h8.12zM2.81 2.81L1.39 4.22 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.17l5.78 5.78 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$64e7d919b3ff773d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24m0 24H0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h10l-5.01 6.3L7 6zm-2.75-.39C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0018.95 4H5.04c-.83 0-1.3.95-.79 1.61z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa245f8befe43ba3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 4h7l5 5v8.58l-1.84-1.84a4.992 4.992 0 00-.64-6.28A4.96 4.96 0 0012 8a5 5 0 00-3.53 1.46 4.98 4.98 0 000 7.05 4.982 4.982 0 006.28.63L17.6 20H6V4zm8.11 11.1c-.56.56-1.31.88-2.11.88s-1.55-.31-2.11-.88c-.56-.56-.88-1.31-.88-2.11s.31-1.55.88-2.11c.56-.57 1.31-.88 2.11-.88s1.55.31 2.11.88c.56.56.88 1.31.88 2.11s-.31 1.55-.88 2.11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e9bda4ed8326488(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05A6.976 6.976 0 0011 4c-3.53 0-6.43 2.61-6.92 6H6.1A5 5 0 0111 6zm5.64 9.14A6.89 6.89 0 0017.92 12H15.9a5 5 0 01-4.9 4c-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05A6.976 6.976 0 0011 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8172568e7f942bf3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2a.506.506 0 01.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67a.49.49 0 01-.44.28zM3.5 9.72a.499.499 0 01-.41-.79c.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25a.5.5 0 01-.12.7c-.23.16-.54.11-.7-.12a9.388 9.388 0 00-3.39-2.94c-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07a.47.47 0 01-.35-.15c-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39s-4.66 1.97-4.66 4.39c0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1a7.297 7.297 0 01-2.17-5.22c0-1.62 1.38-2.94 3.08-2.94s3.08 1.32 3.08 2.94c0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29a11.14 11.14 0 01-.73-3.96c0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a58513ac090e064b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 16h12V8H6v8zm2-6h8v4H8v-4zm-4 5H2v3c0 1.1.9 2 2 2h3v-2H4v-3zm0-9h3V4H4c-1.1 0-2 .9-2 2v3h2V6zm16-2h-3v2h3v3h2V6c0-1.1-.9-2-2-2zm0 14h-3v2h3c1.1 0 2-.9 2-2v-3h-2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$99bc64036dfe36a6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.05 17.58l-.01.01-2.4-2.4 1.06-1.06 1.35 1.35L16.54 13l1.06 1.06-3.54 3.54-.01-.02zM12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM7.34 6.28l1.41 1.41 1.41-1.41 1.06 1.06-1.41 1.41 1.41 1.41-1.06 1.06-1.41-1.41-1.41 1.41-1.06-1.06 1.41-1.41-1.41-1.41 1.06-1.06zM12 20c-2.2 0-4.2-.9-5.7-2.3L17.7 6.3C19.1 7.8 20 9.8 20 12c0 4.4-3.6 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e49e82360e69ad7b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 19h19v2h-19v-2zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l16.57 4.44z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c7f82172bd0781a2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 19h19v2h-19v-2zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0d71f39578bdee2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8a2 2 0 00-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7a2 2 0 002 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12a2 2 0 002 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a043af5cd54e61a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3a2 2 0 002 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9a2 2 0 00-2 2v10a2 2 0 002 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8cf41a276e77cb31(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.07 11.7c.29-.39.81-.56 1.27-.37.17.07.32.18.43.33.22.28.25.59.22.85-.05.33-.25.63-.54.79 0 0-4.87 2.95-5.07 2.69s3.69-4.29 3.69-4.29zM22 10c0 2.5-1 3-1.5 3-.23 0-.44-.1-.62-.26-.48 3.32-2.36 5.31-5.33 5.99.11.44.48.77.95.77h.58c.22 0 .41.15.48.36.17.52.66 1.02 1.02 1.32.25.21.24.59-.03.78-.34.24-.9.49-1.79.53a.501.501 0 01-.45-.22c-.13-.2-.31-.56-.31-1.01 0-.3.04-.57.09-.8-.78-.16-1.39-.78-1.55-1.56-.49.06-1 .1-1.54.1-.88 0-1.7-.09-2.45-.25-.02.08-.05.16-.05.25 0 .55.45 1 1 1h.58c.22 0 .41.15.48.36.17.52.66 1.02 1.02 1.32.25.21.24.59-.03.78-.34.24-.9.49-1.79.53a.501.501 0 01-.45-.22c-.13-.2-.31-.56-.31-1.01 0-.3.04-.57.09-.8-.9-.19-1.59-1-1.59-1.96 0-.18.03-.36.08-.53-2.46-.86-4.03-2.78-4.46-5.74-.18.17-.38.27-.62.27C3 13 2 12.5 2 10c0-2.27 1.7-4.5 3-4.5.43 0 .49.49.5.85a7.989 7.989 0 015.55-3.29c.2-.96 1.08-1.56 1.95-1.56v1s.33-.5 1-.5c.67 0 1 .5 1 .5-.49 0-.85.35-.96.77 1.82.48 3.39 1.59 4.46 3.08.01-.36.07-.85.5-.85 1.3 0 3 2.23 3 4.5zM5 11c0 .81.1 1.53.25 2.21.18-.69.46-1.33.83-1.92a3.77 3.77 0 01-.34-1.54A3.766 3.766 0 019.5 6c.96 0 1.84.37 2.5.97.66-.6 1.54-.97 2.5-.97 2.07 0 3.75 1.68 3.75 3.75 0 .55-.12 1.07-.34 1.54.37.59.66 1.24.84 1.94.15-.68.25-1.41.25-2.23 0-3.86-3.14-7-7-7s-7 3.14-7 7zm12.98 4.29c0-.1.02-.19.02-.29 0-1.01-.26-1.95-.7-2.78-.69.78-1.68 1.28-2.8 1.28-.27 0-.54-.03-.79-.09.14-.23.23-.49.27-.77.01-.07.01-.13.02-.19.17.03.33.05.5.05 1.52 0 2.75-1.23 2.75-2.75S16.02 7 14.5 7c-.67 0-1.32.25-1.83.72l-.67.6-.67-.6C10.82 7.25 10.17 7 9.5 7 7.98 7 6.75 8.23 6.75 9.75c0 1.34.96 2.46 2.23 2.7l-.76.83c-.6-.22-1.12-.59-1.53-1.05A6.01 6.01 0 006 15c0 .08.01.15.01.24C7.13 17.06 9.14 18 12 18c2.88 0 4.88-.91 5.98-2.71zM16 9.75c0 .97-.67 1.75-1.5 1.75S13 10.72 13 9.75 13.67 8 14.5 8s1.5.78 1.5 1.75zm-.75-.87c0-.21-.17-.38-.38-.38s-.37.17-.37.38.17.38.38.38.37-.18.37-.38zM11 9.75c0 .97-.67 1.75-1.5 1.75S8 10.72 8 9.75 8.67 8 9.5 8s1.5.78 1.5 1.75zm-.75-.87c0-.21-.17-.38-.38-.38s-.37.17-.37.38.17.38.38.38.37-.18.37-.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6ba76932b4dd1b45(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.21 20H5V10h14v4.38l2-2V6c0-1.1-.9-2-2-2h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h8.21l-2-2zM5 6h14v2H5V6zm11.54 16.5L13 18.96l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41-5.64 5.66zM10.41 14L12 15.59 10.59 17 9 15.41 7.41 17 6 15.59 7.59 14 6 12.41 7.41 11 9 12.59 10.59 11 12 12.41 10.41 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3cc6bba993b93e2f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6ec0c0ee79bc8cd9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21h12v2H1v-2zM5.24 8.07l2.83-2.83 14.14 14.14-2.83 2.83L5.24 8.07zM12.32 1l5.66 5.66-2.83 2.83-5.66-5.66L12.32 1zM3.83 9.48l5.66 5.66-2.83 2.83L1 12.31l2.83-2.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$54a8cf3b8a5ec638(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm3-7.5h-2v5H8v-5H6V9h6v1.5zm8.25-6.75L23 5l-2.75 1.25L19 9l-1.25-2.75L15 5l2.75-1.25L19 1l1.25 2.75zm0 14L23 19l-2.75 1.25L19 23l-1.25-2.75L15 19l2.75-1.25L19 15l1.25 2.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$220d971debaf0d05(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5v6h1.17L12 13.17 9.83 11H11V5h2m2-2H9v6H5l7 7 7-7h-4V3zm4 15H5v2h14v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8390afcc76ac38d6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h14v14zM5 3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5zm6.5 11h1v-4h-1v4zm2 0h1v-1.5H16v-1h-1.5V11h2v-1h-3v4zm-4-2v1h-1v-2h2c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$400c17a5941866cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9H13v6h-1.5V9zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac72afa3bd1346d3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.13l.97 2.29.47 1.11 1.2.1 2.47.21-1.88 1.63-.91.79.27 1.18.56 2.41-2.12-1.28-1.03-.64-1.03.62-2.12 1.28.56-2.41.27-1.18-.91-.79-1.88-1.63 2.47-.21 1.2-.1.47-1.11.97-2.27M12 2L9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$992367f332eb9540(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h16v2H4V7zm0 6h16v-2H4v2zm0 4h7v-2H4v2zm0 4h7v-2H4v2zm11.41-2.83L14 16.75l-1.41 1.41L15.41 21 20 16.42 18.58 15l-3.17 3.17zM4 3v2h16V3H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db635b61eab5e3a2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "14",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "8",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "14",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e90d51d72b26650a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.25 16.74c0 .69-.53 1.26-1.25 1.26-.7 0-1.26-.56-1.26-1.26 0-.71.56-1.25 1.26-1.25.71 0 1.25.55 1.25 1.25zM11.99 6c-1.77 0-2.98 1.15-3.43 2.49l1.64.69c.22-.67.74-1.48 1.8-1.48 1.62 0 1.94 1.52 1.37 2.33-.54.77-1.47 1.29-1.96 2.16-.39.69-.31 1.49-.31 1.98h1.82c0-.93.07-1.12.22-1.41.39-.72 1.11-1.06 1.87-2.17.68-1 .42-2.36-.02-3.08-.51-.84-1.52-1.51-3-1.51zM19 5H5v14h14V5m0-2c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a8aa3e7131a3ac8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c21f756545d75cd8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d0dc409937fadec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l2.27 2.27A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l2.27 2.27 1.41-1.41L2.81 2.81zM12 20c-4.41 0-8-3.59-8-8 0-1.48.41-2.86 1.12-4.06l10.94 10.94C14.86 19.59 13.48 20 12 20zM7.94 5.12L6.49 3.66A9.91 9.91 0 0112 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51l-1.46-1.46A7.869 7.869 0 0020 12c0-4.41-3.59-8-8-8-1.48 0-2.86.41-4.06 1.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a237927c89e6df6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5h-2V3h2v2zm-2 10v6l2.29-2.29 2.3 2.29L21 19.59l-2.29-2.29L21 15h-6zm4-6h2V7h-2v2zm0 4h2v-2h-2v2zm-8 8h2v-2h-2v2zM7 5h2V3H7v2zM3 17h2v-2H3v2zm2 4v-2H3c0 1.1.9 2 2 2zM19 3v2h2c0-1.1-.9-2-2-2zm-8 2h2V3h-2v2zM3 9h2V7H3v2zm4 12h2v-2H7v2zm-4-8h2v-2H3v2zm0-8h2V3c-1.1 0-2 .9-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$390ca14bf01778fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fbdb336e972d2ff0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.1 19.37l1 1.74c-.96.44-2.01.73-3.1.84v-2.02c.74-.09 1.44-.28 2.1-.56zM4.07 13H2.05c.11 1.1.4 2.14.84 3.1l1.74-1c-.28-.66-.47-1.36-.56-2.1zM15.1 4.63l1-1.74c-.96-.44-2-.73-3.1-.84v2.02c.74.09 1.44.28 2.1.56zM19.93 11h2.02c-.11-1.1-.4-2.14-.84-3.1l-1.74 1c.28.66.47 1.36.56 2.1zM8.9 19.37l-1 1.74c.96.44 2.01.73 3.1.84v-2.02c-.74-.09-1.44-.28-2.1-.56zM11 4.07V2.05c-1.1.11-2.14.4-3.1.84l1 1.74c.66-.28 1.36-.47 2.1-.56zm7.36 3.1l1.74-1.01c-.63-.87-1.4-1.64-2.27-2.27l-1.01 1.74c.59.45 1.1.96 1.54 1.54zM4.63 8.9l-1.74-1c-.44.96-.73 2-.84 3.1h2.02c.09-.74.28-1.44.56-2.1zm15.3 4.1c-.09.74-.28 1.44-.56 2.1l1.74 1c.44-.96.73-2.01.84-3.1h-2.02zm-3.1 5.36l1.01 1.74c.87-.63 1.64-1.4 2.27-2.27l-1.74-1.01c-.45.59-.96 1.1-1.54 1.54zM7.17 5.64l-1-1.75c-.88.64-1.64 1.4-2.27 2.28l1.74 1.01a7.7 7.7 0 011.53-1.54zM5.64 16.83l-1.74 1c.63.87 1.4 1.64 2.27 2.27l1.01-1.74a7.7 7.7 0 01-1.54-1.53zM13 7h-2v5.41l4.29 4.29 1.41-1.41-3.7-3.7V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe3ad5e7bf172a9f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$31bad0058cddb90f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.83 15h1.67c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H17v-1h2v.5h1.5v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1H19v1h-2V13h-1.17l2 2zM8 10.83V15H6.5v-2.5h-2V15H3V9h1.5v2h2V9.33L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-7.6-7.6H10v-2.17l-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a53b7a12a79e168(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 9H8v6H6.5v-2.5h-2V15H3V9h1.5v2h2V9zm10 6h3c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H17v-1h2v.5h1.5v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1H19v1h-2V13h-1.5v1c0 .55.45 1 1 1zM14 15v-1.5h-2.5V9H10v6h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c6705788753a67e0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6885b4540eb85421(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15v2H5v-2h14m2-10H3v2h18V5zm0 4H3v2h18V9zm0 4H3v6h18v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$49f8b582186e50c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.89l.94 3.11h2.82l-2.27 1.62.93 3.01L11 14.79l-2.42 1.84.93-3.01L7.24 12h2.82L11 8.89zM8.58 10H1l6.17 4.41L4.83 22 11 17.31 17.18 22l-2.35-7.59L21 10h-7.58L11 2l-2.42 8zm12.78 12l-1.86-6.01L23.68 13h-3.44l-3.08 2.2 1.46 4.72L21.36 22zM17 8l-1.82-6-1.04 3.45.77 2.55H17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$88e51f1571716abb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4h8v3.5l-2.84 2.84 1.25 1.25L18 8.01 17.99 8H18V2H6v1.17l2 2zM2.1 2.1L.69 3.51l8.9 8.9L6 16l.01.01H6V22h12v-1.17l2.49 2.49 1.41-1.41L2.1 2.1zM16 20H8v-3.5l2.84-2.84L16 18.83V20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bff65b06c27a2792(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d7ffa111bbac1ea7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2cecddaa91289ae5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 9H5v6H3.5v-2.5h-2V15H0V9h1.5v2h2V9zm14 0H13c-.55 0-1 .45-1 1v5h1.5v-4.5h1V14H16v-3.51h1V15h1.5v-5c0-.55-.45-1-1-1zM11 9H6v1.5h1.75V15h1.5v-4.5H11V9zm13 6v-1.5h-2.5V9H20v6h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2b2af0f117f65c50(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a50d8bab5655d1ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$28f43cfc6057d190(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12a2 2 0 002 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4a2 2 0 00-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee468d5528c6b1c2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2f9b6a28a8db6460(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z",
                            "opacity": ".87"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14a2 2 0 00-2-2zM11 16l4-4-4-4v3H1v2h10v3zM21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14a2 2 0 00-2-2zM11 16l4-4-4-4v3H1v2h10v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9903f8135c979b20(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17H4V5h8V3H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h4v2h8v-2h4c1.1 0 2-.9 2-2v-3h-2v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14l5-5-1.41-1.41L18 10.17V3h-2v7.17l-2.59-2.58L12 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$80a6a1cd7bfbcace(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18H7V6h7V4H7V3h7V1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-5h-2v2zm0 3H7v-1h10v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14l5-5-1.41-1.41L19 10.17V3h-2v7.17l-2.59-2.58L13 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4fad5a9e0f17ae0d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "3.5",
                    "r": ".75",
                    "fill": "none"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "3.5",
                    "r": ".75",
                    "fill": "none"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M5 15v4h14V5H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14.17L8.83 12 11 9.83 9.59 8.41 6 12l3.59 3.59zM14.41 15.59L18 12l-3.59-3.59L13 9.83 15.17 12 13 14.17z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 15v4H5V5h14v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc2b39f23c02858(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.81V19c-3.31 0-6-2.63-6-5.87 0-1.56.62-3.03 1.75-4.14L12 4.81M12 2L6.35 7.56C4.9 8.99 4 10.96 4 13.13 4 17.48 7.58 21 12 21s8-3.52 8-7.87c0-2.17-.9-4.14-2.35-5.57L12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$652ba1e39708db7d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14v-1h1.5v.5h2v-1H13c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1h-1.5v-.5h-2v1H16c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1zM9 9v4.5H7.5v-1H6v1c0 .83.67 1.5 1.5 1.5H9c.83 0 1.5-.67 1.5-1.5V9H9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$524a11724e7b7d34(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 12c0-.97.23-4.16 3.03-6.5C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-2.8-2.34-3.03-5.53-3.03-6.5zM16 5c-.9 0-1.75.19-2.53.5 2.8 2.34 3.03 5.53 3.03 6.5 0 .97-.23 4.16-3.03 6.5.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$23f416a89e2dff3d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.04 16.87c-.33.08-.68.13-1.04.13-2.76 0-5-2.24-5-5s2.24-5 5-5c.36 0 .71.05 1.04.13.39-.56.88-1.12 1.49-1.63C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-.61-.51-1.1-1.07-1.49-1.63zM16 5c-.9 0-1.75.19-2.53.5.61.51 1.1 1.07 1.49 1.63.33-.08.68-.13 1.04-.13 2.76 0 5 2.24 5 5s-2.24 5-5 5c-.36 0-.71-.05-1.04-.13-.39.56-.88 1.12-1.49 1.63.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$757242218d01dc67(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 12c0-.97.23-4.16 3.03-6.5C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-2.8-2.34-3.03-5.53-3.03-6.5zM16 5c-.9 0-1.75.19-2.53.5.61.51 1.1 1.07 1.49 1.63.33-.08.68-.13 1.04-.13 2.76 0 5 2.24 5 5s-2.24 5-5 5c-.36 0-.71-.05-1.04-.13-.39.56-.88 1.12-1.49 1.63.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ce2bc2084416572(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12c0 .97-.23 4.16-3.03 6.5.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7c-.9 0-1.75.19-2.53.5 2.8 2.34 3.03 5.53 3.03 6.5zM8 19c.9 0 1.75-.19 2.53-.5-.61-.51-1.1-1.07-1.49-1.63-.33.08-.68.13-1.04.13-2.76 0-5-2.24-5-5s2.24-5 5-5c.36 0 .71.05 1.04.13.39-.56.88-1.12 1.49-1.63C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$575d61518733e6de(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18.99h11c.67 0 1.27-.32 1.63-.83L21 12l-4.37-6.16C16.27 5.33 15.67 5 15 5H4l5 7-5 6.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e4c9a328d36e739f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7l3.55 5-1.63 2.29 1.43 1.43L22 12l-4.37-6.16C17.27 5.33 16.67 5 16 5l-7.37.01 2 1.99H16zM2 4.03l1.58 1.58C3.22 5.96 3 6.46 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.28 0 .55-.07.79-.18L18.97 21l1.41-1.41L3.41 2.62 2 4.03zM14.97 17H5V7.03L14.97 17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a8f894f0bf5ea82(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d23201f928f182bf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 00-1.38-3.56A8.03 8.03 0 0118.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 015.08 16zm2.95-8H5.08a7.987 7.987 0 014.33-3.56A15.65 15.65 0 008.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 01-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ff78a816dfe49479(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8f286d334b392007(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11V3H8v6H2v12h20V11h-6zm-6-6h4v14h-4V5zm-6 6h4v8H4v-8zm16 8h-4v-6h4v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e94d5456bbab0b75(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19c.83 0 1.5-.67 1.5-1.5h-3c0 .83.67 1.5 1.5 1.5zM9 15h6v1.5H9zM12 5c-2.76 0-5 2.24-5 5 0 1.64.8 3.09 2.03 4h5.95A4.985 4.985 0 0017 10c0-2.76-2.24-5-5-5zm2.43 7.5H9.57A3.473 3.473 0 018.5 10c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 .95-.39 1.84-1.07 2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$41e0723188213e5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6A4.997 4.997 0 017 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7622a6254f00ce52(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$64267afd42964109(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$93527188d15f164b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z",
                            "opacity": ".87"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$65509fbfdbc9f18b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20V10h12v1c.7 0 1.37.1 2 .29V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6.26c-.42-.6-.75-1.28-.97-2H6zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L17.5 18.2V15h1v2.79l1.85 1.85-.7.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f2cd2040282638b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3ae28f406ee89653(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20V10h12v1c.7 0 1.37.1 2 .29V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6.26c-.42-.6-.75-1.28-.97-2H6zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 2c.83 0 1.5.67 1.5 1.5S18.83 18 18 18s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm0 6c-1.03 0-1.94-.52-2.48-1.32.73-.42 1.57-.68 2.48-.68s1.75.26 2.48.68c-.54.8-1.45 1.32-2.48 1.32z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fdc9a28ff835c2d1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3a9 9 0 00-9 9c0 .06.01.12.01.19l-1.84-1.84-1.41 1.41L5 16l4.24-4.24-1.41-1.41-1.82 1.82c0-.06-.01-.11-.01-.17 0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7c-1.9 0-3.62-.76-4.88-1.99L6.7 18.42A8.982 8.982 0 0013 21a9 9 0 000-18zm2 8v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3db5bfb46dbfee94(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z",
                            "opacity": ".87"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d96da2df0a408170(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5a418f7664d2da3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8l-1.41 1.41L17.17 11H9v2h8.17l-1.58 1.58L17 16l4-4-4-4zM5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d166aaca5c9d5263(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM13 20.01L4 11V4h7v-.01l9 9-7 7.02z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.9 12.55c0 .57.23 1.07.6 1.45l3.5 3.5 3.5-3.5a2.053 2.053 0 00-2.9-2.9l-.6.6-.6-.59c-.37-.38-.89-.61-1.45-.61-1.13 0-2.05.92-2.05 2.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3ab0644c885d59c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18v-.65c0-.34.16-.66.41-.81C6.1 15.53 8.03 15 10 15c.03 0 .05 0 .08.01.1-.7.3-1.37.59-1.98-.22-.02-.44-.03-.67-.03-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V20h9.26c-.42-.6-.75-1.28-.97-2H4zM10 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01 1 1.73 1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e3c3783920ca5003(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.69 18.37l1.14-1-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L20 14h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1c-.08.5-.08.76 0 1.26l-1.14 1 1 1.73 1.45-.49c.32.27.68.48 1.08.63L18 24h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1c.08-.51.08-.77 0-1.27zM19 21c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM11 7v5.41l2.36 2.36 1.04-1.79-1.4-1.39V7h-2zm10 5a9 9 0 00-9-9C9.17 3 6.65 4.32 5 6.36V4H3v6h6V8H6.26A7.01 7.01 0 0112 5c3.86 0 7 3.14 7 7h2zm-10.14 6.91c-2.99-.49-5.35-2.9-5.78-5.91H3.06c.5 4.5 4.31 8 8.94 8h.07l-1.21-2.09z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$116b61e5d001525(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.23 7h2.6c-.06-.47-.36-.94-.79-1.17L10.5 2 2.8 5.83c-.48.26-.8.81-.8 1.34V15c0 1.1.9 2 2 2V7.4L10.5 4l5.73 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8H7c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2zm0 11H7v-7l6.5 3.33L20 12v7zm-6.5-5.67L7 10h13l-6.5 3.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bccac6941f79c907(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6H10v2h10v12H4V8h2v4h2V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e220deef21e879d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v2H3V3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3eda8b2ed1395067(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16l4-4-4-4v3h-5.06A8.974 8.974 0 008 3.95 3.005 3.005 0 005 1C3.34 1 2 2.34 2 4s1.34 3 3 3c.95 0 1.78-.45 2.33-1.14C9.23 6.9 10.6 8.77 10.92 11h-3.1C7.4 9.84 6.3 9 5 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c1.3 0 2.4-.84 2.82-2h3.1c-.32 2.23-1.69 4.1-3.58 5.14C6.78 17.45 5.95 17 5 17c-1.66 0-3 1.34-3 3s1.34 3 3 3a2.99 2.99 0 002.99-2.95A8.974 8.974 0 0012.93 13H18v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1773e21dc4c21aa7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19h12v2H6v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$206454b92eba0136(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 13.5c0 2-2.5 3.5-2.5 5h-2c0-1.5-2.5-3-2.5-5 0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5zm-2.5 6h-2V21h2v-1.5zm6-6.5c0 1.68-.59 3.21-1.58 4.42l1.42 1.42a8.978 8.978 0 00-1-12.68l-1.42 1.42A6.993 6.993 0 0119 13zm-3-8l-4-4v3a9 9 0 00-9 9c0 2.23.82 4.27 2.16 5.84l1.42-1.42A6.938 6.938 0 015 13c0-3.86 3.14-7 7-7v3l4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$64fb718adeac8528(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14.67L3.41 6.09 2 7.5l8.5 8.5H4v2h16v-2h-6.5l5.15-5.15A2.5 2.5 0 1019.5 6 2.5 2.5 0 0017 8.5c0 .35.07.67.2.97l-5.2 5.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2409bd25bf8307ca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12l-4.37 6.16c-.37.52-.98.84-1.63.84h-3v-2h3l3.55-5L15 7H5v3H3V7c0-1.1.9-2 2-2h10c.65 0 1.26.31 1.63.84L21 12zm-11 3H7v-3H5v3H2v2h3v3h2v-3h3v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a0d3db40e798c82(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.97 11.03C14.87 9.79 13.28 9 11.5 9c-2.82 0-5.18 1.95-5.82 4.56l.96.32C7.15 11.66 9.13 10 11.5 10c1.51 0 2.85.68 3.76 1.74L13 14h5V9l-2.03 2.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c1915952e96e83a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 22c1.05 0 2.05-.16 3-.46-4.06-1.27-7-5.06-7-9.54s2.94-8.27 7-9.54c-.95-.3-1.95-.46-3-.46-5.52 0-10 4.48-10 10s4.48 10 10 10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$913b19526eb3643d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.18 10.94c.2-.44.32-.92.32-1.44C15.5 7.57 13.93 6 12 6c-.52 0-1 .12-1.44.32l4.62 4.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-1.85.63-3.55 1.69-4.9l2.86 2.86a3.47 3.47 0 002.99 2.99l2.2 2.2c-.57-.1-1.15-.15-1.74-.15-2.32 0-4.45.8-6.14 2.12A7.957 7.957 0 014 12zm8 8c-1.74 0-3.34-.56-4.65-1.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.54-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b8ea23f7a7ee62e9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15h-2a1.003 1.003 0 01-1.95.32c-.15-.44-.4-1.08-.93-1.61l-1.36-1.36C9.28 11.87 9 11.19 9 10.5a2.5 2.5 0 014.95-.5h2.02c-.25-2.25-2.16-4-4.47-4C9.02 6 7 8.02 7 10.5c0 1.22.49 2.41 1.35 3.27l1.36 1.36c.17.17.31.44.44.82A3.013 3.013 0 0013 18c1.65 0 3-1.35 3-3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.6 6.58l1.58 1.26c.35-.57.77-1.1 1.24-1.57L4.85 5.02c-.47.47-.88 1-1.25 1.56zM9.46 4.42l-.87-1.81c-.63.23-1.24.52-1.8.87l.87 1.81c.56-.36 1.16-.65 1.8-.87zM4.49 9.26l-1.96-.45c-.21.63-.36 1.28-.44 1.95l1.96.45a7.9 7.9 0 01.44-1.95zM20.4 6.58a9.4 9.4 0 00-1.25-1.56l-1.58 1.26c.48.47.89.99 1.24 1.57l1.59-1.27zM4.04 12.79l-1.96.45c.08.67.23 1.33.44 1.95l1.97-.45c-.22-.62-.38-1.27-.45-1.95zM17.21 3.48c-.57-.35-1.17-.64-1.8-.87l-.87 1.81c.64.22 1.24.51 1.8.87l.87-1.81zM13 4.07V2.05c-.33-.03-.66-.05-1-.05s-.67.02-1 .05v2.02c.33-.04.66-.07 1-.07s.67.03 1 .07zM11 19.93v2.02c.33.03.66.05 1 .05s.67-.02 1-.05v-2.02c-.33.04-.66.07-1 .07s-.67-.03-1-.07zM19.51 14.74l1.97.45c.21-.63.36-1.28.44-1.95l-1.96-.45c-.07.68-.23 1.33-.45 1.95zM19.96 11.21l1.96-.45a9.69 9.69 0 00-.44-1.95l-1.97.45c.22.62.38 1.27.45 1.95zM17.58 17.73l1.58 1.26c.47-.48.88-1 1.25-1.56l-1.58-1.26a9.4 9.4 0 01-1.25 1.56zM6.79 20.52c.57.35 1.17.64 1.8.87l.87-1.81c-.64-.22-1.24-.51-1.8-.87l-.87 1.81zM14.54 19.58l.87 1.81c.63-.23 1.24-.52 1.8-.87l-.87-1.81c-.56.36-1.16.65-1.8.87zM3.6 17.42a9.4 9.4 0 001.25 1.56l1.58-1.26a7.87 7.87 0 01-1.24-1.57L3.6 17.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7a2c117814e901c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c1.44 0 2.79.38 3.95 1.05L17.4 3.6C15.85 2.59 13.99 2 12 2s-3.85.59-5.41 1.59l1.45 1.45A8.034 8.034 0 0112 4zM20 12c0 1.44-.38 2.79-1.05 3.95l1.45 1.45c1.01-1.55 1.6-3.41 1.6-5.4s-.59-3.85-1.59-5.41l-1.45 1.45A8.034 8.034 0 0120 12zM12 20c-1.44 0-2.79-.38-3.95-1.05L6.6 20.4C8.15 21.41 10.01 22 12 22s3.85-.59 5.41-1.59l-1.45-1.45A8.034 8.034 0 0112 20zM4 12c0-1.44.38-2.79 1.05-3.95L3.59 6.59C2.59 8.15 2 10.01 2 12s.59 3.85 1.59 5.41l1.45-1.45A8.034 8.034 0 014 12zM11.5 6C9.02 6 7 8.02 7 10.5c0 1.22.49 2.41 1.35 3.27l1.36 1.36c.17.17.31.44.44.82A3.013 3.013 0 0013 18c1.65 0 3-1.35 3-3h-2a1.003 1.003 0 01-1.95.32c-.15-.44-.4-1.08-.93-1.61l-1.36-1.36C9.28 11.87 9 11.19 9 10.5a2.5 2.5 0 014.95-.5h2.02c-.25-2.25-2.16-4-4.47-4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c3aecde7b66a630(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm9 9v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.24-.24-.44-.36-.63-.46-.36-.19-.72-.3-1.2-.26-.49.04-.91.27-1.23.61L14 11.05c1.29 1.07 3.25 1.94 5 1.95zm-9 7c-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 105.9 5.9h-2.07c-.41 1.16-1.52 2-2.83 2zM2.81 2.81L1.39 4.22 10 12.83V15c0 1.1.9 2 2 2h2.17l5.61 5.61 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e87fafc69417e5c2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 6H9v8h2V8zm6 4l-5-4v8l5-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b264fa5a500593ab(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11h-2v3H8v2h3v3h2v-3h3v-2h-3zm1-9H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9cf4125016380ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zm0 17.96c-4.4 0-7.98-3.58-7.98-7.98S7.6 4.02 12 4.02 19.98 7.6 19.98 12 16.4 19.98 12 19.98zM12.75 5l-4.5 8.5h3.14V19l4.36-8.5h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1013427a7d8ef50e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-5h10v2H7zm3.3-3.8L8.4 9.3 7 10.7l3.3 3.3L17 7.3l-1.4-1.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$12f5472ccc332e95(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h2v1h-2zM12 11c-1.1 0-2 .9-2 2 0 .74.4 1.38 1 1.72v.78h2v-.78c.6-.35 1-.98 1-1.72 0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1.01L6 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM18 21H6v-1h12v1zm0-3H6V6h12v12zm0-14H6V3h12v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.01 15.95c.62-.83.99-1.84.99-2.95s-.37-2.12-.99-2.95l-1.07 1.07c.35.54.56 1.19.56 1.88s-.21 1.34-.56 1.88l1.07 1.07zM9.06 14.88c-.35-.54-.56-1.19-.56-1.88 0-1.93 1.57-3.5 3.5-3.5v1.25l2.25-2-2.25-2V8c-2.76 0-5 2.24-5 5 0 1.11.37 2.12.99 2.95l1.07-1.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3527aa2672816b95(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 11.5c0 2-2.5 3.5-2.5 5h-2c0-1.5-2.5-3-2.5-5C8.5 9.57 10.07 8 12 8s3.5 1.57 3.5 3.5zm-2.5 6h-2V19h2v-1.5zm9-5.5c0-2.76-1.12-5.26-2.93-7.07l-1.06 1.06A8.481 8.481 0 0120.5 12c0 2.34-.95 4.47-2.49 6.01l1.06 1.06A9.969 9.969 0 0022 12zM3.5 12c0-2.34.95-4.47 2.49-6.01L4.93 4.93A9.969 9.969 0 002 12c0 2.76 1.12 5.26 2.93 7.07l1.06-1.06A8.481 8.481 0 013.5 12zm14 0c0 1.52-.62 2.89-1.61 3.89l1.06 1.06A6.976 6.976 0 0019 12c0-1.93-.78-3.68-2.05-4.95l-1.06 1.06c.99 1 1.61 2.37 1.61 3.89zM7.05 16.95l1.06-1.06c-1-1-1.61-2.37-1.61-3.89s.62-2.89 1.61-3.89L7.05 7.05A6.976 6.976 0 005 12c0 1.93.78 3.68 2.05 4.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f6717a456ca78007(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0H0v24h24V0zm0 0H0v24h24V0zM0 24h24V0H0v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 8L12 2.35 6.34 8A8.02 8.02 0 004 13.64c0 2 .78 4.11 2.34 5.67a7.99 7.99 0 0011.32 0c1.56-1.56 2.34-3.67 2.34-5.67S19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ef71e28e67243f8a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f0b01fe0d210b8ca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$480eaed360c4fac9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.79 5.8L14 3h7v7l-2.79-2.8-4.09 4.09-1.41-1.41 4.08-4.08zM19 12v4.17l2 2V12h-2zm.78 10.61L18.17 21H5a2 2 0 01-2-2V5.83L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM16.17 19l-4.88-4.88-1.59 1.59-1.41-1.41 1.59-1.59L5 7.83V19h11.17zM7.83 5H12V3H5.83l2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5bda7cfea6a0b13b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b749c6e5eea6bacd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$231dc823d60f9caa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.88 9.54L8.92 16.5l-1.41-1.41 4.96-4.96L10.34 8l5.65.01.01 5.65-2.12-2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d4eb947e13fb2429(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.88 9.54L8.92 16.5l-1.41-1.41 4.96-4.96L10.34 8l5.65.01.01 5.65-2.12-2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$95d9c55aabb3cb9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9.83V14h2V9.83l1.59 1.58L16 10l-4-4-4 4 1.41 1.41z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-3h3.02c.91 1.21 2.35 2 3.98 2s3.06-.79 3.98-2H19v3zm0-5h-4.18c-.41 1.16-1.51 2-2.82 2s-2.4-.84-2.82-2H5V5h14v9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$690082679872ade1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 9V8c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1zm6 0V8c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1zm-2 5c0-1.1-.9-2-2-2s-2 .9-2 2v2h4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2d89808f92e1923f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17l5-5-5-5-1.41 1.41L18.17 11H9v2h9.17l-2.58 2.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h14v2h2V5a2 2 0 00-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14a2 2 0 002-2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7527520bb42a8d79(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.49 16c.88 0 1.7-.26 2.39-.7l2.44 2.44 1.42-1.42-2.44-2.43c.44-.7.7-1.51.7-2.39C16 9.01 13.99 7 11.5 7S7 9.01 7 11.5 9.01 16 11.49 16zm.01-7a2.5 2.5 0 010 5 2.5 2.5 0 010-5zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f985bbe60dbcff72(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.89-8.9c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79.99 1.9 1.34l1.58-.67c-.15-.44-.82-1.91-2.66-2.23V5h-1.75v1.26c-2.6.56-2.62 2.85-2.62 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66.67c.63 2.19 2.28 2.78 3.02 2.96V19h1.75v-1.24c.52-.09 3.02-.59 3.02-3.22.01-1.39-.6-2.61-3-3.44z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3bca3220883b6307(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.89 11.77l-3.8-1.67c-.13-.06-.28-.1-.44-.1H14V5.5a2.5 2.5 0 00-5 0v8.15l-1.87-.4c-.19-.03-1.02-.15-1.73.56L4 15.22l5.12 5.19c.37.38.88.59 1.41.59h6.55c.98 0 1.81-.7 1.97-1.67l.92-5.44a2 2 0 00-1.08-2.12zM17.08 19h-6.55l-3.7-3.78 4.17.89V5.5c0-.28.22-.5.5-.5s.5.22.5.5v6.18h1.76L18 13.56 17.08 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b2a1f27a9f24972b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 24h-6.55c-1.08 0-2.14-.45-2.89-1.23l-7.3-7.61 2.07-1.83c.62-.55 1.53-.66 2.26-.27L8 14.34V4.79a2.5 2.5 0 013.01-2.45C11.1 1.04 12.18.01 13.5.01c.86 0 1.61.43 2.06 1.09.29-.12.61-.18.94-.18a2.5 2.5 0 012.5 2.5v.28a2.5 2.5 0 013 2.45V20c0 2.21-1.79 4-4 4zM4.14 15.28l5.86 6.1c.38.39.9.62 1.44.62H18c1.1 0 2-.9 2-2V6.15c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V3.42c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V2.51c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V4.79c0-.28-.22-.5-.5-.5s-.5.23-.5.5v12.87l-5.35-2.83-.51.45z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5fb144132cd44384(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd76fa77f9720423(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L16.5 17.2V14h1v2.79l1.85 1.85-.7.71zM18 3h-3.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H6c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h6.11a6.743 6.743 0 01-1.42-2H6V5h2v3h8V5h2v5.08c.71.1 1.38.31 2 .6V5c0-1.1-.9-2-2-2zm-6 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$23fed172776e6a3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dfea21c75a429ae1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 4C5.57 4 4 5.57 4 7.5S5.57 11 7.5 11 11 9.43 11 7.5 9.43 4 7.5 4zm0 5C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm9 4c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5.41 20L4 18.59 18.59 4 20 5.41 5.41 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c1a118cdef38e13f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2s2-.9 2-2V8c0-1.1-.9-2-2-2zm8-1h-3.17l-1.86-2H8.96L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-7v-1.09c2.83-.48 5-2.94 5-5.91h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6c0 2.97 2.17 5.43 5 5.91V19H4V7h4.21l.59-.65L10.04 5h4.24l1.24 1.35.59.65H20v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c141af58829e8862(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.84 4.22c-.05-.12-.11-.23-.18-.34-.14-.21-.33-.4-.54-.54-.11-.07-.22-.13-.34-.18-.24-.1-.5-.16-.78-.16h-1V1h-2v2H8V1H6v2H5c-.42 0-.8.13-1.12.34-.21.14-.4.33-.54.54-.07.11-.13.22-.18.34-.1.24-.16.5-.16.78v14a2 2 0 002 2h14c.28 0 .54-.06.78-.16.12-.05.23-.11.34-.18.21-.14.4-.33.54-.54.21-.32.34-.71.34-1.12V5c0-.28-.06-.54-.16-.78zM5 19V5h14v14H5zm7-6.12c-2.03 0-6 1.08-6 3.58V18h12v-1.53c0-2.51-3.97-3.59-6-3.59zM8.31 16c.69-.56 2.38-1.12 3.69-1.12s3.01.56 3.69 1.12H8.31zM12 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a0e6f2c3963ada19(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.99 11.57H20V0L0 20h11.56v-2H4.83L17.99 4.83v6.74zm5.78 8.75l-1.07-.83c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83a.26.26 0 00.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83a3.908 3.908 0 000 .98l-1.06.83a.26.26 0 00-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73a.26.26 0 00-.06-.32zm-4.78.18c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7179d660e69bdee5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2h-2zm0 4h2v6h-2zm6-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zM7 4V3h10v1H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df7f10cfdf1de9bb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 9c2.7 0 5.8 1.29 6 2v1H6v-.99c.2-.72 3.3-2.01 6-2.01m0-11C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1fba682b75321411(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm5 9h14l-3.5-4.5-2.5 3.01L11.5 9zM22 4h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 12H6V4h5.17l1.41 1.41.59.59H22v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d71456a9d0bc1cb6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.074 15.074 0 01-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.46 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM12 3v10l3-3h6V3h-9zm7 5h-5V5h5v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9083b96e765dbeb7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zM2.92 7.65C5.8 5.85 8.74 5 12 5c3.25 0 6.18.85 9.08 2.67L12 18.83 2.92 7.65zM11 10h2v6h-2zm0-4h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7041a57869ce1883(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "9.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "5.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "5.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "9.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3968a944bcac6b78(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h1.5v6H13v-2.5h-2V15H9.5V9H11v2h2V9zm-5 1.5v1c0 .8-.7 1.5-1.5 1.5h-2v2H3V9h3.5c.8 0 1.5.7 1.5 1.5zm-1.5 0h-2v1h2v-1zm15 0v1c0 .8-.7 1.5-1.5 1.5h-2v2h-1.5V9H20c.8 0 1.5.7 1.5 1.5zm-1.5 0h-2v1h2v-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$38492c7e93620f8f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-8v6h8v-6zm-2 4h-4v-2h4v2zm4-12H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4.98C23 3.88 22.1 3 21 3zm0 16.02H3V4.97h18v14.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b00f6db21d529e35(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-8v6h8V7zm-2 4h-4V9h4v2zm4-8H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$864f840874293e9e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12V6H4v12h10v2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v6h-2zm-1 2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm-4.34-6H9v5.66h2v-2.24l2.95 2.95 1.41-1.41L12.41 10h2.24V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b6634dcf611a3173(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10v2H4v12h16v-6h2zm0-5c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zM9.34 12h2.24l-2.95 2.95 1.41 1.41L13 13.42v2.24h2V10H9.34v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$73f289cc3b8889c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2.5V1h5v5H9.5V3.56L3.56 9.5H6V11H1V6h1.5v2.44L8.44 2.5H6zm15.89 11.27l-3.8-1.67c-.13-.06-.28-.1-.44-.1H17V7.5a2.5 2.5 0 00-5 0v8.15l-1.87-.4c-.19-.03-1.02-.15-1.73.56L7 17.22l5.12 5.19c.37.38.88.59 1.41.59h6.55c.98 0 1.81-.7 1.97-1.67l.92-5.44a2 2 0 00-1.08-2.12zM20.08 21h-6.55l-3.7-3.78 4.17.89V7.5c0-.28.22-.5.5-.5s.5.22.5.5v6.18h1.76L21 15.56 20.08 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7dac3bbd0ab28870(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.03 11.03a3.495 3.495 0 000 4.95 3.48 3.48 0 004.13.59l1.88 1.88 1.41-1.41-1.88-1.88c.71-1.33.53-3.01-.59-4.13a3.495 3.495 0 00-4.95 0zm3.53 3.53c-.59.59-1.54.59-2.12 0a1.49 1.49 0 010-2.12 1.49 1.49 0 012.12 0c.59.59.59 1.53 0 2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9f9eba3c64a5f840(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eb7c62341eb55d11(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8L19 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a8f7f8ab46bd0507(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42A6.92 6.92 0 0119 12c0 3.87-3.13 7-7 7A6.995 6.995 0 017.58 6.58L6.17 5.17A8.932 8.932 0 003 12a9 9 0 0018 0c0-2.74-1.23-5.18-3.17-6.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1d7249c039cf726(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9a3.285 3.285 0 00-2-3c0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3155a768a55f7e8c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 16H5V7h14v12zm-7-8.5c1.84 0 3.48.96 4.34 2.5-.86 1.54-2.5 2.5-4.34 2.5s-3.48-.96-4.34-2.5c.86-1.54 2.5-2.5 4.34-2.5M12 9c-2.73 0-5.06 1.66-6 4 .94 2.34 3.27 4 6 4s5.06-1.66 6-4c-.94-2.34-3.27-4-6-4zm0 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f4e9e84e71104e8e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 12v2H8v-4h8v2zm2-2v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "11.5",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e4259f7653482851(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.19l7 3.11V11c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 6h2v2h-2V7zm0 4h2v6h-2v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dc9df1c864c7bf89(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zm-6.93 6c.49 3.39 3.4 6 6.93 6s6.44-2.61 6.93-6H22v-2h-3.07c-.49-3.39-3.4-6-6.93-6s-6.44 2.61-6.93 6H2v2h3.07zM14 10.5v-.89c0-1-.68-1.92-1.66-2.08A2 2 0 0010 9.5v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-2 3.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.34.75.75-.34.75-.75.75zm1-3.25h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$99ddfb5e45c73023(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2V8h2v2zm0-4h-2V1h2v5zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03L21 4.96 19.25 4l-3.7 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f6bea2446a045771(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.6 19.5H21v2h-6v-6h2v2.73c1.83-1.47 3-3.71 3-6.23 0-4.07-3.06-7.44-7-7.93V2.05c5.05.5 9 4.76 9 9.95 0 2.99-1.32 5.67-3.4 7.5zM4 12c0-2.52 1.17-4.77 3-6.23V8.5h2v-6H3v2h2.4A9.966 9.966 0 002 12c0 5.19 3.95 9.45 9 9.95v-2.02c-3.94-.49-7-3.86-7-7.93zm12.24-3.89l-5.66 5.66-2.83-2.83-1.41 1.41 4.24 4.24 7.07-7.07-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7fba41466ae79e79(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d222e2117454c5c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4v7H5.17l-.59.59-.58.58V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$14976bbd76d10ad1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.07 12.85c.77-1.39 2.25-2.21 3.11-3.44.91-1.29.4-3.7-2.18-3.7-1.69 0-2.52 1.28-2.87 2.34L6.54 6.96C7.25 4.83 9.18 3 11.99 3c2.35 0 3.96 1.07 4.78 2.41.7 1.15 1.11 3.3.03 4.9-1.2 1.77-2.35 2.31-2.97 3.45-.25.46-.35.76-.35 2.24h-2.89c-.01-.78-.13-2.05.48-3.15zM14 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1a33c80434642767(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17.17V4h16v6h2V4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h9v-2H5.17L4 17.17z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.5 16h-2.2l1.7-4h-5v6h2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a06cd2b6bcdf4df0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6zm0-4h12v2H6zm0-4h12v2H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$90968dfdc0fe8784(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H3zM15.08 7.05c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27l-1.68 1.69zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffb7a8b1bef105ea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 00-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a0df78f55aad8eaf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.84 1.98L3.43 3.39l10.38 10.38-1.41 1.41-4.24-4.24-1.41 1.41 5.66 5.66 2.83-2.83 6.6 6.6 1.41-1.41L4.84 1.98zm13.21 10.38L23 7.4 21.57 6l-4.94 4.94 1.42 1.42zm-.71-4.96l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM1.08 12.35l5.66 5.66 1.41-1.41-5.66-5.66-1.41 1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$891e5176ccd77107(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.41 1.13L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38A1.997 1.997 0 0017 22c.67 0 1.26-.33 1.62-.84L21.46 24l1.41-1.41L1.41 1.13zM7 15l1.1-2h2.36l2 2H7zM20 4H7.12l2 2h9.19l-2.76 5h-1.44l1.94 1.94c.54-.14.99-.49 1.25-.97l3.58-6.49C21.25 4.82 20.76 4 20 4zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$30539b0bb6867ff6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3df9a60fbc0484b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-6H3v6zm7.33-2v-2h3.33v2h-3.33zM19 19h-3.33v-2H19v2zM5 17h3.33v2H5v-2zM6 10l1.42-1.42L5.83 7H17c1.1 0 2 .9 2 2s-.9 2-2 2H3v2h14c2.21 0 4-1.79 4-4s-1.79-4-4-4H5.83l1.59-1.59L6 2 2 6l4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8ec5b6180de05967(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8be77835c94fe2c0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.17 4L18 8.83V20H6V4h7.17M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm1 9h-4v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1h-2v-1H9v-2h4v-1h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1V8h2v1h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$369434f5a39b7950(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2-5V9h8v10H8v-5zm2 4h4v-4h2l-4-4-4 4h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5817ff07487f7829(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7.17L18 8.83V20zm-9.55-9.43L7.28 9.4V13h3.6l-1.44-1.44a3.15 3.15 0 012.79-1.71 3.15 3.15 0 110 6.3 3.14 3.14 0 01-2.58-1.35H8.1a4.51 4.51 0 004.12 2.7c2.48 0 4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5c-1.59 0-2.97.83-3.77 2.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ce12328b863e2326(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3a9 9 0 00-9 9H1l4 3.99L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$251e78ad4cdd1042(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15c-.83 0-1.58.34-2.12.88C2.7 17.06 2 22 2 22s4.94-.7 6.12-1.88A2.996 2.996 0 006 15zm.71 3.71c-.28.28-2.17.76-2.17.76s.47-1.88.76-2.17c.17-.19.42-.3.7-.3a1.003 1.003 0 01.71 1.71zm10.71-5.06c6.36-6.36 4.24-11.31 4.24-11.31S16.71.22 10.35 6.58l-2.49-.5a2.03 2.03 0 00-1.81.55L2 10.69l5 2.14L11.17 17l2.14 5 4.05-4.05c.47-.47.68-1.15.55-1.81l-.49-2.49zM7.41 10.83l-1.91-.82 1.97-1.97 1.44.29c-.57.83-1.08 1.7-1.5 2.5zm6.58 7.67l-.82-1.91c.8-.42 1.67-.93 2.49-1.5l.29 1.44-1.96 1.97zM16 12.24c-1.32 1.32-3.38 2.4-4.04 2.73l-2.93-2.93c.32-.65 1.4-2.71 2.73-4.04 4.68-4.68 8.23-3.99 8.23-3.99s.69 3.55-3.99 8.23zM15 11c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$250df16191d53c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-6.02 7.25c-.29-.9-.57-1.94-.76-3L6 16.07v2.98l1.98-.8zM12 2s5 2 5 11l2.11 1.41c.56.37.89 1 .89 1.66V22l-5-2H9l-5 2v-5.93c0-.67.33-1.29.89-1.66L7 13c0-9 5-11 5-11zm0 2.36S9 6.38 9 13c0 2.25 1 5 1 5h4s1-2.75 1-5c0-6.62-3-8.64-3-8.64zm6 14.69v-2.98l-1.22-.81c-.19 1.05-.47 2.1-.76 3l1.98.79z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e008094d06bbc8e1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "9",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$606135c18f10d770(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$61eeebd8fc2a15da(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1c737d26660c6c9d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.54 11L13 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L16.54 11zM11 7H2v2h9V7zm10 6.41L19.59 12 17 14.59 14.41 12 13 13.41 15.59 16 13 18.59 14.41 20 17 17.41 19.59 20 21 18.59 18.41 16 21 13.41zM11 15H2v2h9v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$14c4c6c01908b5b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14h2a9 9 0 01-9 9v-2c3.87 0 7-3.13 7-7zm-7 3v2c2.76 0 5-2.24 5-5h-2c0 1.66-1.34 3-3 3zM18.26.59l3.54 3.54c.78.78.78 2.05 0 2.83l-3.18 3.18c-.78.78-2.05.78-2.83 0L14.55 8.9l-.71.7 1.24 1.24c.78.78.78 2.05 0 2.83l-1.41 1.41c-.78.78-2.05.78-2.83 0L9.6 13.84l-.71.71 1.24 1.24c.78.78.78 2.05 0 2.83L6.95 21.8c-.78.78-2.05.78-2.83 0L.58 18.26c-.78-.78-.78-2.05 0-2.83l3.18-3.18c.78-.78 2.05-.78 2.83 0l1.24 1.24.71-.71-1.24-1.23c-.78-.78-.78-2.05 0-2.83L8.72 7.3c.78-.78 2.05-.78 2.83 0l1.24 1.24.71-.71-1.25-1.23c-.78-.78-.78-2.05 0-2.83L15.43.59c.79-.79 2.05-.79 2.83 0zm-15.2 15.2L2 16.85l3.54 3.54 1.06-1.06-3.54-3.54zm2.12-2.12l-1.06 1.06 3.54 3.54 1.06-1.06-3.54-3.54zm4.95-4.95l-1.41 1.41 3.54 3.54 1.41-1.41-3.54-3.54zm4.6-4.6l-1.06 1.06 3.54 3.54 1.06-1.06-3.54-3.54zM16.85 2l-1.06 1.06 3.54 3.54 1.06-1.06L16.85 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7c219d69121cf73b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.73 13.31A6.388 6.388 0 0016 9.5 6.5 6.5 0 109.5 16c1.43 0 2.74-.48 3.81-1.27L19.59 21 21 19.59l-6.27-6.28zM9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.29 8.44L9.5 6l-.79 2.44H6.25l2.01 1.59-.77 2.47 2.01-1.53 2.01 1.53-.77-2.47 2.01-1.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c2dd545ff9d35719(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zM8 9h5V7H8v2zm14-1.5v6.97l-2.82.94L17.5 21H12v-2h-2v2H4.5S2 12.54 2 9.5 4.46 4 7.5 4h5c.91-1.21 2.36-2 4-2a1.498 1.498 0 011.38 2.08c-.14.34-.26.73-.32 1.15l2.27 2.27H22zm-2 2h-1L15.5 6c0-.65.09-1.29.26-1.91-.97.25-1.76.97-2.09 1.91H7.5C5.57 6 4 7.57 4 9.5c0 1.88 1.22 6.65 2.01 9.5H8v-2h6v2h2.01l1.55-5.15 2.44-.82V9.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$51a78c2c076bac9c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L16.5 17.2V14h1v2.79l1.85 1.85-.7.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12l-6-1.5V7.01l8.87 3.74c.94-.47 2-.75 3.13-.75.1 0 .19.01.28.01L3 4v16l7-2.95V17c0-.8.14-1.56.39-2.28L5 16.99V13.5l6-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4018d5d94b2711aa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$115499642bd09e6e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 009.5 3C6.08 3 3.28 5.64 3.03 9h2.02C5.3 6.75 7.18 5 9.5 5 11.99 5 14 7.01 14 9.5S11.99 14 9.5 14c-.17 0-.33-.03-.5-.05v2.02c.17.02.33.03.5.03 1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.47 10.82L4 13.29l-2.47-2.47-.71.71L3.29 14 .82 16.47l.71.71L4 14.71l2.47 2.47.71-.71L4.71 14l2.47-2.47z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$202d89f353fa203d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e8b309f0b1e6014(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18h12v-2H9v2zM3 6v2h18V6H3zm6 7h12v-2H9v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2882cb42ef497ebe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12l-6-1.5V7.01l8.87 3.73c.94-.47 2-.75 3.13-.75.1 0 .19.01.28.01L3 4v16l7-2.95V17c0-.8.14-1.56.39-2.28L5 16.99V13.5l6-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8l-3-3 .71-.71 1.79 1.79V14h1v4.09l1.79-1.79.71.7-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d19c71f148f17232(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.14 10.96c-.09.33-.14.68-.14 1.04 0 1.1.45 2.1 1.17 2.83l-1.42 1.42A6.018 6.018 0 016 12c0-.93.21-1.8.58-2.59L5.11 7.94A7.897 7.897 0 004 12c0 2.21.9 4.21 2.35 5.65l-1.42 1.42A9.969 9.969 0 012 12c0-2.04.61-3.93 1.66-5.51L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41L8.14 10.96zm9.28 3.63c.37-.79.58-1.66.58-2.59 0-1.66-.67-3.16-1.76-4.24l-1.42 1.42a3.951 3.951 0 011.04 3.86l1.56 1.55zM20 12c0 1.48-.4 2.87-1.11 4.06l1.45 1.45A9.91 9.91 0 0022 12c0-2.76-1.12-5.26-2.93-7.07l-1.42 1.42A7.94 7.94 0 0120 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7656a34eb38b8980(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.76 16.24C6.67 15.16 6 13.66 6 12s.67-3.16 1.76-4.24l1.42 1.42C8.45 9.9 8 10.9 8 12c0 1.1.45 2.1 1.17 2.83l-1.41 1.41zm8.48 0C17.33 15.16 18 13.66 18 12s-.67-3.16-1.76-4.24l-1.42 1.42C15.55 9.9 16 10.9 16 12c0 1.1-.45 2.1-1.17 2.83l1.41 1.41zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm8 2c0 2.21-.9 4.21-2.35 5.65l1.42 1.42C20.88 17.26 22 14.76 22 12s-1.12-5.26-2.93-7.07l-1.42 1.42A7.94 7.94 0 0120 12zM6.35 6.35L4.93 4.93C3.12 6.74 2 9.24 2 12s1.12 5.26 2.93 7.07l1.42-1.42C4.9 16.21 4 14.21 4 12s.9-4.21 2.35-5.65z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a96085eca9c372c4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 4c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 6c1.86.5 4 .83 6 1v12h2v-6h2v6h2V7c2-.17 4.14-.5 6-1l-.5-2zM12 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$45b1ea334358e942(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.21 13.97l1.2 2.07c.08.13.23.18.37.13l1.49-.6c.31.24.64.44 1.01.59l.22 1.59c.03.14.15.25.3.25h2.4c.15 0 .27-.11.3-.26l.22-1.59c.36-.15.7-.35 1.01-.59l1.49.6c.14.05.29 0 .37-.13l1.2-2.07c.08-.13.04-.29-.07-.39l-1.27-.99c.03-.19.04-.39.04-.58 0-.2-.02-.39-.04-.59l1.27-.99c.11-.09.15-.26.07-.39l-1.2-2.07a.306.306 0 00-.37-.13l-1.49.6c-.31-.24-.64-.44-1.01-.59l-.22-1.59a.31.31 0 00-.3-.25h-2.4a.31.31 0 00-.3.26l-.22 1.59c-.36.15-.71.34-1.01.58l-1.49-.6c-.14-.05-.29 0-.37.13l-1.2 2.07c-.08.13-.04.29.07.39l1.27.99c-.03.2-.05.39-.05.59 0 .2.02.39.04.59l-1.27.99c-.11.1-.14.26-.06.39zM12 10.29c.94 0 1.71.77 1.71 1.71s-.77 1.71-1.71 1.71-1.71-.77-1.71-1.71.77-1.71 1.71-1.71zM19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3df88bc24bfce9c1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9a9 9 0 00-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7a6.995 6.995 0 01-11.06 5.7l-1.42 1.44A9 9 0 1012 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$52f71d553719a65a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c29177dd1c00d2d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2eacfb86e460530e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 18H8v-1h8v1zm0-3H8V5h8v10zm0-12H8V2h8v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$30d593c5c9bc1030(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc325158d5d6cc19(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29a2.5 2.5 0 00-5 0c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2a9 9 0 0118 0h2c0-6.07-4.93-11-11-11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e478d6e4dd385aea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v10c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16V6H5V2zM4 17c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4H3zM13 2c0-.55-.45-1-1-1s-1 .45-1 1v4H9v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2V2zm-1 15c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4h-2zm10-6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2zm-1 11c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fbd718815f97cc4a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v10c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16V6H5V2zM4 17c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4H3zM13 2c0-.55-.45-1-1-1s-1 .45-1 1v4H9v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2V2zm-1 15c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4h-2zm10-6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2zm-1 11c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b8cfd6f94246820e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2.01V5h-1v2H11V5h-1v2H8V4zm9 8.53l-3 6V20h-4v-1.47l-3-6V9h10v3.53z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$319ced6eb5e3e7c8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$44ed9d0a31365e98(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f1a3643ca47c6ed0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v2h-2zm4 0h2v2h-2zm5 6.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.074 15.074 0 01-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.46 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM19 9h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c4db854ba52d76b1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45A5.969 5.969 0 0118 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44A7.961 7.961 0 004 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e07feee3d7b1592(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-1 12h-4V11h4v10z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.05 6.05l1.41 1.41a5.022 5.022 0 017.08 0l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c59a44e307836029(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22h2v2H7zm5-9c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .56-.44 1-1 1-.55 0-1-.45-1-1V4zm0 18h2v2h-2zm4 0h2v2h-2zm4-12h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$392ba6ddc06fd74c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46a.5.5 0 00-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0014 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1a.566.566 0 00-.18-.03c-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46a.5.5 0 00.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$22c916a148d5d11a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9H1v11c0 1.11.89 2 2 2h16v-2H3V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm9 13H7V7h14v9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v7l5.5-3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffcf4d55184077a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm9 13H7V7h14v9zm-9-1l5.5-4L12 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eeb0bb916681e6ea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zm10 15H4V8h16v11zM9 18l7.5-5L9 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$853bd2b44f911507(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h-2c0-2.21-1.79-4-4-4S8 3.79 8 6H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6-2c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2zm6 16H6V8h2v2c0 .55.45 1 1 1s1-.45 1-1V8h4v2c0 .55.45 1 1 1s1-.45 1-1V8h2v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$51e43a0c3f86a845(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9h-4.79l-4.38-6.56c-.19-.28-.51-.42-.83-.42s-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1zM12 4.8L14.8 9H9.2L12 4.8zM18.5 19l-12.99.01L3.31 11H20.7l-2.2 8zM12 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$113fcc5551adb8df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03L21 4.96 19.25 4l-3.7 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2zM12 2l4 4-4 4-1.41-1.41L12.17 7H8V5h4.17l-1.59-1.59L12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a9f37f1b45ed5b8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49A.996.996 0 0020.01 4H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91f2e4e77b5a9ec5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9v6c0 1.1-.9 2-2 2h-1v-2h1V9H4v6h6v2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-7.5 10l1.09-2.41L18 15.5l-2.41-1.09L14.5 12l-1.09 2.41L11 15.5l2.41 1.09L14.5 19zm2.5-5l.62-1.38L19 12l-1.38-.62L17 10l-.62 1.38L15 12l1.38.62L17 14zm-2.5 5l1.09-2.41L18 15.5l-2.41-1.09L14.5 12l-1.09 2.41L11 15.5l2.41 1.09L14.5 19zm2.5-5l.62-1.38L19 12l-1.38-.62L17 10l-.62 1.38L15 12l1.38.62L17 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dde4cc23db34d8e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-2-6H6v-2h12v2zm-4 4H6v-2h8v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ff1555f561c1720(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 19V5h6v14H5zm14 0h-6v-7h6v7zm0-9h-6V5h6v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2e020579e9c2f958(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 002 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM16 19H4v-.78c0-.38.2-.72.52-.88C5.71 16.73 7.63 16 10 16c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V19zM20.36 1l-1.41 1.41a7.007 7.007 0 010 9.9l1.41 1.41a8.98 8.98 0 000-12.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.54 10.9a5.003 5.003 0 000-7.07l-1.41 1.41a3 3 0 010 4.24l1.41 1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$80549523dc6e9211(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 002 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM16 19H4v-.78c0-.38.2-.72.52-.88C5.71 16.73 7.63 16 10 16c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V19zM16 1h-2a9 9 0 009 9V8c-3.86 0-7-3.14-7-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 1h-2c0 2.76 2.24 5 5 5V4c-1.65 0-3-1.35-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$301a3f9b05333261(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 002 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM16 19H4v-.78c0-.38.2-.72.52-.88C5.71 16.73 7.63 16 10 16c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V19zM20.05 2.41L18.64 1c-3.51 3.51-3.51 9.21 0 12.73l1.41-1.41c-2.73-2.74-2.73-7.18 0-9.91z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.88 5.24l-1.41-1.41a5.003 5.003 0 000 7.07l1.41-1.41a3.012 3.012 0 010-4.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fafa8d726e84a855(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v12h-1.34l1.91 1.91A2.01 2.01 0 0022 16V4c0-1.1-.9-2-2-2H4.66l2 2H20zM6 12h2v2H6zm12-3h-6.34l2 2H18zm0-3h-8v1.34l.66.66H18zM1.41 1.59L0 3l2.01 2.01L2 22l4-4h9l5.73 5.73 1.41-1.41L1.41 1.59zM5.17 16L4 17.17V7l2 2v2h2l5 5H5.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bcf17bff598bf7a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zM6 12h2v2H6zm0-3h2v2H6zm0-3h2v2H6zm4 6h5v2h-5zm0-3h8v2h-8zm0-3h8v2h-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d83b5fb3573293ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$be4d05f2b1dd33b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.89l.94 3.11h2.82l-2.27 1.62.93 3.01L12 14.79l-2.42 1.84.93-3.01L8.24 12h2.82L12 8.89M12 2l-2.42 8H2l6.17 4.41L5.83 22 12 17.31 18.18 22l-2.35-7.59L22 10h-7.58L12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a2873689932b051(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm7.48 7.16l-5.01-.43-2-4.71c3.21.19 5.91 2.27 7.01 5.14zm-5.07 6.26L12 13.98l-2.39 1.44.63-2.72-2.11-1.83 2.78-.24L12 8.06l1.09 2.56 2.78.24-2.11 1.83.64 2.73zm-2.86-11.4l-2 4.72-5.02.43c1.1-2.88 3.8-4.97 7.02-5.15zM4 12c0-.64.08-1.26.23-1.86l3.79 3.28-1.11 4.75A7.982 7.982 0 014 12zm3.84 6.82L12 16.31l4.16 2.5A7.924 7.924 0 0111.99 20c-1.52 0-2.94-.44-4.15-1.18zm9.25-.65l-1.11-4.75 3.79-3.28c.14.59.23 1.22.23 1.86 0 2.48-1.14 4.7-2.91 6.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$900dabd8ef1bcb64(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v9h-5v5H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10l6-6V5c0-1.1-.9-2-2-2zm-7 11H7v-2h5v2zm5-4H7V8h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d063ac574a80810f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.36 9l.6 3H5.04l.6-3h12.72M20 4H4v2h16V4zm0 3H4l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5zM6 18v-4h6v4H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7320607704f75b62(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4eb7c46a74ea3f95(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H6.83l2 2H20v11.17l1.76 1.76c.15-.28.24-.59.24-.93V6c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10h-5.17l2 2H18zM1.04 3.87l1.2 1.2C2.09 5.35 2 5.66 2 6v12c0 1.1.9 2 2 2h13.17l2.96 2.96 1.41-1.41L2.45 2.45 1.04 3.87zM4 6.83L7.17 10H6v2h2v-1.17L11.17 14H6v2h7.17l2 2H4V6.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f8fccf2a3e733315(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 10c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6.5 2c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2.01.89-2 2 0 1.11.89 2 2 2zM11.99 2.01c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zM5.84 17.12c.68-.54 2.27-1.11 3.66-1.11.07 0 .15.01.23.01.24-.64.67-1.29 1.3-1.86A9.05 9.05 0 009.5 14c-1.3 0-3.39.45-4.73 1.43-.5-1.04-.78-2.2-.78-3.43 0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.2-.27 2.34-.75 3.37-1-.59-2.36-.87-3.24-.87-1.52 0-4.5.81-4.5 2.7v2.78a7.935 7.935 0 01-5.66-2.86z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b25d8a926e92b4eb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm.05 10H4.77c.99-.5 2.7-1 4.23-1 .11 0 .23.01.34.01.34-.73.93-1.33 1.64-1.81-.73-.13-1.42-.2-1.98-.2-2.34 0-7 1.17-7 3.5V19h7v-1.5c0-.17.02-.34.05-.5zm7.45-2.5c-1.84 0-5.5 1.01-5.5 3V19h11v-1.5c0-1.99-3.66-3-5.5-3zm1.21-1.82c.76-.43 1.29-1.24 1.29-2.18a2.5 2.5 0 00-5 0c0 .94.53 1.75 1.29 2.18.36.2.77.32 1.21.32s.85-.12 1.21-.32z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cf64794c7bebb046(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.46 7.12l-2.78 1.15a4.982 4.982 0 00-2.95-2.94l1.15-2.78c2.1.8 3.77 2.47 4.58 4.57zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM9.13 4.54l1.17 2.78a5 5 0 00-2.98 2.97L4.54 9.13a7.984 7.984 0 014.59-4.59zM4.54 14.87l2.78-1.15a4.968 4.968 0 002.97 2.96l-1.17 2.78a7.996 7.996 0 01-4.58-4.59zm10.34 4.59l-1.15-2.78a4.978 4.978 0 002.95-2.97l2.78 1.17a8.007 8.007 0 01-4.58 4.58z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$92db3ce7384a91a0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5dafb8f073d8c9a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-13.5V9h-4v2h4v2.5l3.5-3.5zm-6 4L5.5 14 9 17.5V15h4v-2H9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1fad540fdec84125(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2d4a3ac36b718227(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM6.5 9L10 5.5 13.5 9H11v4H9V9zm11 6L14 18.5 10.5 15H13v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b59f25ac2ccb5cc6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13.9a5 5 0 10-2 0v4.27l-1.59-1.59L8 18l4 4 4-4-1.41-1.41L13 18.17V13.9zM15 9c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f881aa23e5020b92(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.22 10l-4.15.01a.975.975 0 00-.45.08l-.59.26-1.83-4.1c-.56-1.26-2.04-1.83-3.3-1.27s-1.83 2.04-1.27 3.3l3.3 7.45-1.87.39c-.19.05-.99.27-1.36 1.21L8 19.19l6.78 2.67c.49.19 1.05.18 1.53-.04l5.99-2.65c.89-.4 1.37-1.38 1.13-2.32l-1.36-5.34c-.22-.86-.97-1.47-1.85-1.51zm1.27 7.34L15.5 20l-4.92-1.96 4.18-.88-4.3-9.7c-.11-.25 0-.55.25-.66.25-.11.55 0 .66.25l2.5 5.65 1.61-.71 4.65.01 1.36 5.34zM3.8 12.18c-.2-.86-.3-1.76-.3-2.68 0-2.84.99-5.45 2.63-7.5L7.2 3.07a10.457 10.457 0 00-1.88 8.99l1.62-1.62L8 11.5 4.5 15 1 11.5l1.06-1.06 1.74 1.74z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$957c37d829c47195(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1 13a5 5 0 100-2H5.83l1.59-1.59L6 8l-4 4 4 4 1.41-1.41L5.83 13h4.27zm4.9 2c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3813f4977c2cdc64(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.89 13.77l-3.8-1.67c-.13-.06-.28-.1-.44-.1H14V7.5a2.5 2.5 0 00-5 0v8.15l-1.87-.4c-.19-.03-1.02-.15-1.73.56L4 17.22l5.12 5.19c.37.38.88.59 1.41.59h6.55c.98 0 1.81-.7 1.97-1.67l.92-5.44a2 2 0 00-1.08-2.12zM17.08 21h-6.55l-3.7-3.78 4.17.89V7.5c0-.28.22-.5.5-.5s.5.22.5.5v6.18h1.76L18 15.56 17.08 21zM4.09 5.5H7V7H2V2h1.5v2.02C5.82 2.13 8.78 1 12 1c5.49 0 9.27 3.12 10 6h-1.57c-.76-1.98-3.69-4.5-8.43-4.5-3.03 0-5.79 1.14-7.91 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19f0a4578b911b95(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9 11a5 5 0 100 2h4.27l-1.59 1.59L18 16l4-4-4-4-1.41 1.41L18.17 11H13.9zM9 9c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7c5d609196afa06a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.89 13.77l-3.8-1.67c-.13-.06-.28-.1-.44-.1H14V7.5a2.5 2.5 0 00-5 0v8.15l-1.87-.4c-.19-.03-1.02-.15-1.73.56L4 17.22l5.12 5.19c.37.38.88.59 1.41.59h6.55c.98 0 1.81-.7 1.97-1.67l.92-5.44a2 2 0 00-1.08-2.12zM17.08 21h-6.55l-3.7-3.78 4.17.89V7.5c0-.28.22-.5.5-.5s.5.22.5.5v6.18h1.76L18 15.56 17.08 21zM12 2.5C7.26 2.5 4.33 5.02 3.57 7H2c.73-2.88 4.51-6 10-6 3.22 0 6.18 1.13 8.5 3.02V2H22v5h-5V5.5h2.91c-2.12-1.86-4.88-3-7.91-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$28f93e030b4749bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.83l1.59 1.59L16 6l-4-4-4 4 1.41 1.41L11 5.83v4.27a5 5 0 102 0V5.83zM12 18c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7c76e20982c7ff50(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.22 10l-4.15.01a.975.975 0 00-.45.08l-.59.26-1.83-4.1c-.56-1.26-2.04-1.83-3.3-1.27s-1.83 2.04-1.27 3.3l3.3 7.45-1.87.39c-.19.05-.99.27-1.36 1.21L8 19.19l6.78 2.67c.49.19 1.05.18 1.53-.04l5.99-2.65c.89-.4 1.37-1.38 1.13-2.32l-1.36-5.34c-.22-.86-.97-1.47-1.85-1.51zm1.27 7.34L15.5 20l-4.92-1.96 4.18-.88-4.3-9.7c-.11-.25 0-.55.25-.66.25-.11.55 0 .66.25l2.5 5.65 1.61-.71 4.65.01 1.36 5.34zM2.06 5.56L1 4.5 4.5 1 8 4.5 6.94 5.56 5.32 3.94a10.457 10.457 0 001.88 8.99L6.13 14A11.974 11.974 0 013.5 6.5c0-.92.1-1.82.3-2.68L2.06 5.56z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$faa84e9509993c45(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2h5v5H4.5V4.09c-1.86 2.11-3 4.88-3 7.91s1.14 5.79 3 7.91V17H6v5H1v-1.5h2.02C1.13 18.18 0 15.22 0 12s1.13-6.18 3.02-8.5H1V2zm19.22 8l-4.15.01a.975.975 0 00-.45.08l-.59.26-1.83-4.1c-.56-1.26-2.04-1.83-3.3-1.27s-1.83 2.04-1.27 3.3l3.3 7.45-1.87.39c-.19.05-.99.27-1.36 1.21L8 19.19l6.78 2.67c.49.19 1.05.18 1.53-.04l5.99-2.65c.89-.4 1.37-1.38 1.13-2.32l-1.36-5.34c-.22-.86-.97-1.47-1.85-1.51zm1.27 7.34L15.5 20l-4.92-1.96 4.18-.88-4.3-9.7c-.11-.25 0-.55.25-.66.25-.11.55 0 .66.25l2.5 5.65 1.61-.71 4.65.01 1.36 5.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$232cde33f89fb8a2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 2v2.02C18.18 2.13 15.22 1 12 1S5.82 2.13 3.5 4.02V2H2v5h5V5.5H4.09c2.11-1.86 4.88-3 7.91-3s5.79 1.14 7.91 3H17V7h5V2h-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.89 13.77l-3.8-1.67c-.13-.06-.28-.1-.44-.1H14V7.63c0-1.32-.96-2.5-2.27-2.62A2.508 2.508 0 009 7.5v8.15l-1.87-.4c-.19-.03-1.02-.15-1.73.56L4 17.22l5.12 5.19c.37.38.88.59 1.41.59h6.55c.98 0 1.81-.7 1.97-1.67l.92-5.44a2 2 0 00-1.08-2.12zM18 15.56L17.08 21h-6.55l-3.7-3.78 4.17.89V7.5c0-.28.22-.5.5-.5s.5.22.5.5v6.18h1.76L18 15.56z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1378343614b8f4a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.06 8.94L5 8l2.06-.94L8 5l.94 2.06L11 8l-2.06.94L8 11l-.94-2.06zM8 21l.94-2.06L11 18l-2.06-.94L8 15l-.94 2.06L5 18l2.06.94L8 21zm-3.63-8.63L3 13l1.37.63L5 15l.63-1.37L7 13l-1.37-.63L5 11l-.63 1.37zM12 12c0-3.09 1.38-5.94 3.44-8H12V2h7v7h-2V5.28c-1.8 1.74-3 4.2-3 6.72 0 3.32 2.1 6.36 5 7.82V22c-4.09-1.59-7-5.65-7-10zm12 2h-2v-2h-2v2h-2v2h2v2h2v-2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$48bff405b4ac9065(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.06 8.94L5 8l2.06-.94L8 5l.94 2.06L11 8l-2.06.94L8 11l-.94-2.06zM8 21l.94-2.06L11 18l-2.06-.94L8 15l-.94 2.06L5 18l2.06.94L8 21zm-3.63-8.63L3 13l1.37.63L5 15l.63-1.37L7 13l-1.37-.63L5 11l-.63 1.37zM12 12c0-3.09 1.38-5.94 3.44-8H12V2h7v7h-2V5.28c-1.8 1.74-3 4.2-3 6.72 0 3.32 2.1 6.36 5 7.82V22c-4.09-1.59-7-5.65-7-10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a6fda54474e0e177(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 13.41L6 12l-4 4 4 4 1.41-1.41L5.83 17H21v-2H5.83zM16.59 10.59L18 12l4-4-4-4-1.41 1.41L18.17 7H3v2h15.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c1f2fd8da615db0a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16l4-4h-3V3h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V4.99h6V3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 13l4-4h-3V3h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V4.99h6V3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a3a8895133a8451e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cc98198674a45271(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$139c54485c86e37(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7H9c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 2v2H9V9h10zm-6 6v-2h2v2h-2zm2 2v2h-2v-2h2zm-4-2H9v-2h2v2zm6-2h2v2h-2v-2zm-8 4h2v2H9v-2zm8 2v-2h2v2h-2zM6 17H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v1h-2V5H5v10h1v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b2c4ca49141d8ee5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.18L10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10L22 5.18zm-2.21 5.04c.13.57.21 1.17.21 1.78 0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8c1.58 0 3.04.46 4.28 1.25l1.44-1.44A9.9 9.9 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-1.19-.22-2.33-.6-3.39l-1.61 1.61z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$10ce7e755a694fcb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm0 14H4V8h16v10zm-2-1h-6v-2h6v2zM7.5 17l-1.41-1.41L8.67 13l-2.59-2.59L7.5 9l4 4-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cec9d8fbe67597d8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4l-3 3h2v13h2V7h2l-3-3zm-6.2 11.5v-5l2.2-.9V7.5L3 12.25v1.5l11 4.75v-2.1l-2.2-.9zM4.98 13L10 11.13v3.74L4.98 13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20eba49d6ef75189(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.75 5h-1.5L9.5 16h2.1l.9-2.2h5l.9 2.2h2.1L15.75 5zm-2.62 7L15 6.98 16.87 12h-3.74zM6 20l3-3H7V4H5v13H3l3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f04706fd5bd9e75d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21v-4.24l-1.41 1.41-9.2-9.19-1.41 1.41 9.19 9.19L10.76 21H15zM11.25 8.48l3.54 3.54-.92 2.19 1.48 1.48 4.42-11.14-1.06-1.05L7.57 7.92 9.06 9.4l2.19-.92zm6.59-3.05l-2.23 4.87-2.64-2.64 4.87-2.23z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$972da4428401ad80(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.76 9l1.41 1.41-9.19 9.19 1.41 1.41 9.19-9.19L21 13.24V9h-4.24zm-8.28 3.75l3.54-3.54 2.19.92 1.48-1.48L4.56 4.23 3.5 5.29l4.42 11.14 1.48-1.48-.92-2.2zm-.82-1.72L5.43 6.16l4.87 2.23-2.64 2.64z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9dcb6af07cf3f9f8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20l3-3H7V4H5v13H3l3 3zm6.2-11.5v5l-2.2.9v2.1l11-4.75v-1.5L10 5.5v2.1l2.2.9zm6.82 2.5L14 12.87V9.13L19.02 11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e17b0311f03653e0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18l-3-3v2H5v2h13v2l3-3zM9.5 11.8h5l.9 2.2h2.1L12.75 3h-1.5L6.5 14h2.1l.9-2.2zM12 4.98L13.87 10h-3.74L12 4.98z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$44a9991cb041a639(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm6 10h-4V5h4v14zm4-2h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6be800bae20704b0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L12 14H3v-2l3-7h9v10zm4-12h4v12h-4V3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9446ddcf165ef29f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L12 14H3v-2l3-7h9v10zm4-12h4v12h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae8de8df55abd956(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2zM9 9l4.34-4.34L12 10h9v2l-3 7H9V9zM1 9h4v12H1V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ebbfa2c802ab16ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2zM9 9l4.34-4.34L12 10h9v2l-3 7H9V9zM1 9h4v12H1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4c5930e43d1fbce6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm-2 1.13L7.92 12H2V6.21l1.93-1.93L3.36 7H10v.13zM22.5 10h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5zm-.5 7.79l-1.93 1.93.57-2.72H14v-.13L16.08 12H22v5.79z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56ad30a0be9d91dd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 8c0 1.1-.9 2-2 2a1.7 1.7 0 01-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56A1.7 1.7 0 0119 8c0-1.1.9-2 2-2s2 .9 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b34eef9aa6ab8dd3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20h4c0 1.1-.9 2-2 2s-2-.9-2-2zm-2-1h8v-2H5v2zm11.5-9.5c0 3.82-2.66 5.86-3.77 6.5H5.27c-1.11-.64-3.77-2.68-3.77-6.5C1.5 5.36 4.86 2 9 2s7.5 3.36 7.5 7.5zm-2 0C14.5 6.47 12.03 4 9 4S3.5 6.47 3.5 9.5c0 2.47 1.49 3.89 2.35 4.5h6.3c.86-.61 2.35-2.03 2.35-4.5zm6.87-2.13L20 8l1.37.63L22 10l.63-1.37L24 8l-1.37-.63L22 6l-.63 1.37zM19 6l.94-2.06L22 3l-2.06-.94L19 0l-.94 2.06L16 3l2.06.94L19 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df9fa9e1c541b568(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a035003d57aa33ae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zM7 11h5v5H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9c0f94edc5fd4788(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7l-9-5-9 5v10l9 5 9-5V7zm-9-2.71l5.91 3.28-3.01 1.67C14.17 8.48 13.14 8 12 8s-2.17.48-2.9 1.24L6.09 7.57 12 4.29zm-1 14.87l-6-3.33V9.26L8.13 11c-.09.31-.13.65-.13 1 0 1.86 1.27 3.43 3 3.87v3.29zM10 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm3 7.16v-3.28c1.73-.44 3-2.01 3-3.87 0-.35-.04-.69-.13-1.01L19 9.26v6.57l-6 3.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9d79a437c8ebd9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12a5.99 5.99 0 014-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09A5.99 5.99 0 013 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b38c354fdd575de1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.19 12.44l-3.24-1.62c1.29-1 2.12-2.56 2.12-4.32 0-3.03-2.47-5.5-5.5-5.5s-5.5 2.47-5.5 5.5c0 2.13 1.22 3.98 3 4.89v3.26c-2.15-.46-2.02-.44-2.26-.44-.53 0-1.03.21-1.41.59L4 16.22l5.09 5.09c.43.44 1.03.69 1.65.69h6.3c.98 0 1.81-.7 1.97-1.67l.8-4.71c.22-1.3-.43-2.58-1.62-3.18zm-.35 2.85l-.8 4.71h-6.3c-.09 0-.17-.04-.24-.1l-3.68-3.68 4.25.89V6.5c0-.28.22-.5.5-.5s.5.22.5.5v6h1.76l3.46 1.73c.4.2.62.63.55 1.06zM8.07 6.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 .95-.38 1.81-1 2.44V6.5a2.5 2.5 0 00-5 0v2.44c-.62-.63-1-1.49-1-2.44z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a77f06e621153dfb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H7V2H5v20h2v-8h14l-2-5 2-5zm-3.86 5.74l.9 2.26H7V6h11.05l-.9 2.26-.3.74.29.74zM14 9c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$78cd37bd670cb072(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.07 4.93l-1.41 1.41A8.014 8.014 0 0120 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6399fc2ed5e5dcdb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm6.39 8.56C13.71 14.7 11.53 14 9 14s-4.71.7-6.39 1.56A2.97 2.97 0 001 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM15 19H3v-.78c0-.38.2-.72.52-.88C4.71 16.73 6.63 16 9 16c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V19zm2.93-3l1.63-1.63c-2.77-3.02-2.77-7.56 0-10.74L17.93 2c-3.9 3.89-3.91 9.95 0 14zm4.99-5.05a3.317 3.317 0 010-3.89l-1.68-1.69c-2.02 2.02-2.02 5.07 0 7.27l1.68-1.69z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a083144cd4ba4482(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0014.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c8991b32846487d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$592f3770f4e1865e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12l-4-4v3H3v2h15v3l4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b22672976e79ca8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d9c7c5a5e46eb28(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20.59l-4.69-4.69A7.902 7.902 0 0019 11c0-4.42-3.58-8-8-8-4.08 0-7.44 3.05-7.93 7h2.02C5.57 7.17 8.03 5 11 5c3.31 0 6 2.69 6 6s-2.69 6-6 6c-2.42 0-4.5-1.44-5.45-3.5H3.4C4.45 16.69 7.46 19 11 19c1.85 0 3.55-.63 4.9-1.69L20.59 22 22 20.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.43 9.69L9.65 15h1.64l1.26-3.78.95 2.28h2V12h-1l-1.25-3h-1.54l-1.12 3.37L9.35 7H7.7l-1.25 4H1v1.5h6.55z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$99e176f9c50c4cef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15l1.57-3.43L17 10l-3.43-1.57L12 5l-1.57 3.43L7 10l3.43 1.57z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e8820eafbe541ad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1449340a756ebdfb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac27781a66be18bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.58 1.41L15.16 0l-3.17 3.17L8.82 0 7.41 1.41 11.99 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.58 6.41L15.16 5l-3.17 3.17L8.82 5 7.41 6.41 11.99 11zM7.42 17.59L8.84 19l3.17-3.17L15.18 19l1.41-1.41L12.01 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.42 22.59L8.84 24l3.17-3.17L15.18 24l1.41-1.41L12.01 18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa9d3927c0c9320d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.83L15.17 11l1.41-1.41L12 5 7.41 9.59 8.83 11 12 7.83zm0-5L15.17 6l1.41-1.41L12 0 7.41 4.59 8.83 6 12 2.83zm0 18.34L8.83 18l-1.41 1.41L12 24l4.59-4.59L15.17 18 12 21.17zm0-5L8.83 13l-1.41 1.41L12 19l4.59-4.59L15.17 13 12 16.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bddb7a29b61b817c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.94 5.12L6.49 3.66A9.91 9.91 0 0112 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51l-1.46-1.46A7.869 7.869 0 0020 12c0-4.41-3.59-8-8-8-1.48 0-2.86.41-4.06 1.12zm9.72 4.41l-1.41-1.41-2.65 2.65 1.41 1.41 2.65-2.65zm2.12 13.08l-2.27-2.27A9.91 9.91 0 0112 22C6.48 22 2 17.52 2 12c0-2.04.61-3.93 1.66-5.51L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zm-3.72-3.73L12.18 15l-1.59 1.59-4.24-4.24 1.41-1.41 2.83 2.83.18-.18-5.65-5.65A7.932 7.932 0 004 12c0 4.41 3.59 8 8 8 1.48 0 2.86-.41 4.06-1.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$728941af4fc78c51(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 13a8.865 8.865 0 01-1.33 3.79l-1.47-1.47c.38-.71.65-1.49.77-2.32h2.03zM8.67 5.84A7.06 7.06 0 0112 5a7.01 7.01 0 015.74 3H15v2h6V4h-2v2.36C17.35 4.32 14.83 3 12 3c-1.76 0-3.4.51-4.78 1.39l1.45 1.45zM11 7v1.17l2 2V7h-2zm8.78 15.61l-3-3A8.973 8.973 0 0112 21a9 9 0 01-9-9c0-1.76.51-3.4 1.39-4.78l-3-3L2.8 2.81l18.38 18.38-1.4 1.42zm-4.46-4.46L5.84 8.67A7.06 7.06 0 005 12c0 3.86 3.14 7 7 7 1.2 0 2.34-.31 3.32-.85z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$25b7329a2984ef44(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8v5l4.25 2.52.77-1.28-3.52-2.09V8H11zm10 2V3l-2.64 2.64A8.937 8.937 0 0012 3a9 9 0 109 9h-2c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7c1.93 0 3.68.79 4.95 2.05L14 10h7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b18698e4590b9642(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18v2H8v-2h8zM11 7.99V16h2V7.99h3L12 4 8 7.99h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1088ad620e455dc8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11 7 3.11V11zm-11.59.59L6 13l4 4 8-8-1.41-1.42L10 14.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d18d9fe396e03fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 11.99L20.56 9.2l.34-3.69-3.61-.82L15.4 1.5 12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 11.99l2.44 2.79-.34 3.7 3.61.82 1.89 3.2 3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69 2.44-2.8zm-3.95 1.48l-.56.65.08.85.18 1.95-1.9.43-.84.19-.44.74-.99 1.68-1.78-.77-.8-.34-.79.34-1.78.77-.99-1.67-.44-.74-.84-.19-1.9-.43.18-1.96.08-.85-.56-.65L3.67 12l1.29-1.48.56-.65-.09-.86-.18-1.94 1.9-.43.84-.19.44-.74.99-1.68 1.78.77.8.34.79-.34 1.78-.77.99 1.68.44.74.84.19 1.9.43-.18 1.95-.08.85.56.65 1.29 1.47-1.28 1.48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.09 13.75l-2.32-2.33-1.48 1.49 3.8 3.81 7.34-7.36-1.48-1.49z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$64f38b2376f62916(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h8v2H3zm0 4h8v2H3zm0-8h8v2H3zm0-4h8v2H3zm16 2v10h-4V7h4m2-2h-8v14h8V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$915d65485ea414be(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm0 6H5v-4h14v4zM19 3H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 6H5V5h14v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$46e2662a28ce0c91(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7v10H9V7h6zm6-2h-3v14h3V5zm-4 0H7v14h10V5zM6 5H3v14h3V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3119d44344f757f1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7h4v10H2V7zm5 12h10V5H7v14zM9 7h6v10H9V7zm9 0h4v10h-4V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2dc4b7bb2973e4ad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14h18V5H3zm5.33 12H5V7h3.33v10zm5.34 0h-3.33V7h3.33v10zM19 17h-3.33V7H19v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ea79981dd184d696(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h4v4H7zM13 7h4v4h-4zM7 13h4v4H7zM13 13h4v4h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a4c122e039bdbbb2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 7.5h4v4h-4zM12.5 7.5h4v4h-4zM7.5 12.5h4v4h-4zM12.5 12.5h4v4h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$551f4ffa22822287(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.25 7.25h4v4h-4zM12.75 7.25h4v4h-4zM7.25 12.75h4v4h-4zM12.75 12.75h4v4h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f19fd54ec2404203(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18H2v2h19v-2zm-2-8v4H4v-4h15m1-2H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm1-4H2v2h19V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f5bf136578d598df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e01c889433eecf16(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4c0-.55.45-1 1-1h2V1H4C2.34 1 1 2.34 1 4v2h2V4zM3 20v-2H1v2c0 1.66 1.34 3 3 3h2v-2H4c-.55 0-1-.45-1-1zM20 1h-2v2h2c.55 0 1 .45 1 1v2h2V4c0-1.66-1.34-3-3-3zM21 20c0 .55-.45 1-1 1h-2v2h2c1.66 0 3-1.34 3-3v-2h-2v2zM19 14.87V9.13c0-.72-.38-1.38-1-1.73l-5-2.88c-.31-.18-.65-.27-1-.27s-.69.09-1 .27L6 7.39c-.62.36-1 1.02-1 1.74v5.74c0 .72.38 1.38 1 1.73l5 2.88c.31.18.65.27 1 .27s.69-.09 1-.27l5-2.88c.62-.35 1-1.01 1-1.73zm-8 2.3l-4-2.3v-4.63l4 2.33v4.6zm1-6.33L8.04 8.53 12 6.25l3.96 2.28L12 10.84zm5 4.03l-4 2.3v-4.6l4-2.33v4.63z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a73559ae78492bec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h2v10H7zM11 7h2v5h-2zM15 7h2v8h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f9ff1b51505e62f3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14h18V5H3zm4 2v2H5V7h2zm-2 6v-2h2v2H5zm0 2h2v2H5v-2zm14 2H9v-2h10v2zm0-4H9v-2h10v2zm0-4H9V7h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e866f8c066c9c9f8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14h18V5H3zm16 6h-3.33V7H19v4zm-5.33 0h-3.33V7h3.33v4zM8.33 7v4H5V7h3.33zM5 17v-4h3.33v4H5zm5.33 0v-4h3.33v4h-3.33zm5.34 0v-4H19v4h-3.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f1f620b70e60afb7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14h18V5H3zm5.33 12H5V7h3.33v10zm5.34 0h-3.33v-4h3.33v4zM19 17h-3.33v-4H19v4zm0-6h-8.67V7H19v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4afdc23570e0baee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v16h20V4H2zm18 4.67h-2.5V6H20v2.67zm-2.5 2H20v2.67h-2.5v-2.67zM4 6h11.5v12H4V6zm13.5 12v-2.67H20V18h-2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a02958a5b572a40d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm16 10H5v-4h14v4zM5 11V7h14v4H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$957a62d600c9d96d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15h6v2H6zM12 7h6v2h-6zM9 11h6v2H9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b7a2391eaf61380(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 18H4V6h4v12zm6 0h-4V6h4v12zm6 0h-4V6h4v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$97833bc79980dc35(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a9.77 9.77 0 018.82 5.5 9.647 9.647 0 01-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68A11.738 11.738 0 001 11.5C2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02a2.5 2.5 0 01-2.5-2.5c0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75a4.6 4.6 0 00-.36 1.78 4.507 4.507 0 006.27 4.14l.98.98c-.88.24-1.8.38-2.75.38a9.77 9.77 0 01-8.82-5.5c.7-1.43 1.72-2.61 2.93-3.53z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$18e20e728d3cfb8c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a9.77 9.77 0 018.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5A9.77 9.77 0 0112 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5a2.5 2.5 0 010 5 2.5 2.5 0 010-5m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e18e0ec32af1346(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.76 5.36l-1.68 1.69c.8 1.13.83 2.58.09 3.74l1.7 1.7c1.9-2.02 1.87-4.98-.11-7.13zM20.07 2l-1.63 1.63c2.72 2.97 2.76 7.39.14 10.56l1.64 1.64c3.74-3.89 3.71-9.84-.15-13.83zM9.43 5.04l3.53 3.53a3.979 3.979 0 00-3.53-3.53zM4.41 2.86L3 4.27l2.62 2.62C5.23 7.5 5 8.22 5 9c0 2.21 1.79 4 4 4 .78 0 1.5-.23 2.11-.62l4.4 4.4C13.74 15.6 10.78 15 9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-.37-.11-.7-.29-1.02L19.73 21l1.41-1.41L4.41 2.86zM3 19c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H3zm6-8c-1.1 0-2-.9-2-2 0-.22.04-.42.11-.62l2.51 2.51c-.2.07-.4.11-.62.11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3c22f0c04262c22c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5443f77a760a6e44(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15h5.88c.27-.31.67-.5 1.12-.5.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.44 0-.84-.19-1.12-.5H11.9A5 5 0 116 11.1v2.07c-1.16.41-2 1.53-2 2.83 0 1.65 1.35 3 3 3s3-1.35 3-3v-1zm2.5-11c1.65 0 3 1.35 3 3h2c0-2.76-2.24-5-5-5a5.002 5.002 0 00-3.45 8.62l-2.35 3.9c-.68.14-1.2.75-1.2 1.48 0 .83.67 1.5 1.5 1.5a1.498 1.498 0 001.43-1.95l3.38-5.63A3.003 3.003 0 019.5 7c0-1.65 1.35-3 3-3zm4.5 9c-.64 0-1.23.2-1.72.54l-3.05-5.07C11.53 8.35 11 7.74 11 7c0-.83.67-1.5 1.5-1.5S14 6.17 14 7c0 .15-.02.29-.06.43l2.19 3.65c.28-.05.57-.08.87-.08 2.76 0 5 2.24 5 5s-2.24 5-5 5a5 5 0 01-4.33-2.5h2.67c.48.32 1.05.5 1.66.5 1.65 0 3-1.35 3-3s-1.35-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ea10b4694f15189e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h1v12H4zm3 0V6h10v12H7zm13 0h-1V6h1v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f6e67853387a70c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h4v12H4zm6 0V6h4v12h-4zm10 0h-4V6h4v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f36f708022b5f396(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h2v12H4zm4 0V6h8v12H8zm12 0h-2V6h2v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$780f2ab6507701cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.71 5.29L19 3h-8v8l2.3-2.3c1.97 1.46 3.25 3.78 3.25 6.42 0 1.31-.32 2.54-.88 3.63 2.33-1.52 3.88-4.14 3.88-7.13 0-2.52-1.11-4.77-2.84-6.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.46 8.88c0-1.31.32-2.54.88-3.63a8.479 8.479 0 00-3.88 7.13c0 2.52 1.1 4.77 2.84 6.33L5 21h8v-8l-2.3 2.3c-1.96-1.46-3.24-3.78-3.24-6.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4acdd1c3856eae28(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19V8h16v3.29c.72.22 1.4.54 2 .97V8c0-1.11-.89-2-2-2h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h7.68c-.3-.62-.5-1.29-.6-2H4zm6-15h4v2h-4V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L17.5 18.2V15h1v2.79l1.85 1.85-.7.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2503e53b8d4b2f8b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4h4v2h-3.6l2 2H20v7.6l2 2V8c0-1.11-.89-2-2-2h-4V4c0-1.11-.89-2-2-2h-4c-.99 0-1.8.7-1.96 1.64L10 5.6V4zM3.4 1.84L1.99 3.25 4.74 6H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h15.74l2 2 1.41-1.41L3.4 1.84zM4 19V8h2.74l11 11H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d9517626594eb7d7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6V4h-4v2h4zM4 8v11h16V8H4zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ef9d0f36af10a1c2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a7f129f01dacafdc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 16H5V7h14v12zm-2-7H7v-2h10v2zm-4 4H7v-2h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3e249e7e5ff688bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.01 14h-.8l-.27-.27a6.451 6.451 0 001.57-4.23c0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51a4.5 4.5 0 019 0 4.507 4.507 0 01-6.32 4.12L7.71 15.1a6.474 6.474 0 007.52-.67l.27.27v.79l5.01 4.99L22 19l-4.99-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bdff4be8afe8d942(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm.5-7H9v2H7v1h2v2h1v-2h2V9h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$965d9eed503b73fc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3f4a68a4b36ee61d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zM12 6c2.76 0 5 2.24 5 5v7H7v-7c0-2.76 2.24-5 5-5zm0-4.5c-.83 0-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5zM13 8h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e3382e93a3eca5ca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2h-3.5l-1-1h-5l-1 1H1v2h14zM16 9c-.7 0-1.37.1-2 .29V5H2v12c0 1.1.9 2 2 2h5.68A6.999 6.999 0 0023 16c0-3.87-3.13-7-7-7zm-7 7c0 .34.03.67.08 1H4V7h8v3.26c-1.81 1.27-3 3.36-3 5.74zm7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12H15v5l3.6 2.1.8-1.2-2.9-1.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a7be9adeaaeace42(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84fc5e2df785ebb9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c355e5977b5ae8e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zM12 6c2.76 0 5 2.24 5 5v7H7v-7c0-2.76 2.24-5 5-5zm0-4.5c-.83 0-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5zM11 8h2v4h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$394724d1760a95c4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84416243d7b7c881(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ca96a47e44880b1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 6v10H5v-8.5h1V15h1.5V9H5V5h14v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 11.25V9H14v6h1.5v-2.25L17.25 15H19l-2.25-3L19 9h-1.75zM9.5 15H12c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H9.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-4.5h1.5v3H10v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e480885531c87f52(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 15H9V9H6v1.5h1.5zM12 12.75L13.75 15h1.75l-2.25-3 2.25-3h-1.75L12 11.25V9h-1.5v6H12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f236c05093104a1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 15H10V9H7v1.5h1.5zM13.5 12.75L15.25 15H17l-2.25-3L17 9h-1.75l-1.75 2.25V9H12v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5519679c592d4a65(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13.5H7.5v-1H9c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1H6v1.5h2.5v1H7c-.55 0-1 .45-1 1V15h4v-1.5zM12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f400026346254f10(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13.5H8v-1h2c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1H6.5v1.5h3v1h-2c-.55 0-1 .45-1 1V15H11v-1.5zM14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4590b3821f19bcc3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14v-4c0-.55-.45-1-1-1H5.5v1.5h3v1h-2v1h2v1h-3V15H9c.55 0 1-.45 1-1zM12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5b86d456e42f063c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14v-4c0-.55-.45-1-1-1H6.5v1.5h3v1h-2v1h2v1h-3V15H10c.55 0 1-.45 1-1zM14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4cedb9e03c50fa31(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 15H10v-1.5h1V12h-1V9H8.5v3H7V9H5.5v4.5h3zM13 12.75L14.75 15h1.75l-2.25-3 2.25-3h-1.75L13 11.25V9h-1.5v6H13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd91622de36d078b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 16H5V5h14v14zm-9.5-4H11v-1.49h1V12h-1V9H9.5v3H8V9H6.5v4.5h3zm8.7 0l-2-3 2-3h-1.7l-2 3 2 3zm-3.7-3V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d96790589a7bd42e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 13H19v2h-5V9h7c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4.5v2zM3 13h5v2H3v2h5c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2H5V9h5V7H3v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1c26c009364a0952(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14v-1.5c0-.55-.45-1-1-1H7.5v-1H10V9H6v3.5h2.5v1H6V15h3c.55 0 1-.45 1-1zM12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d789a8d776ed1bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14v-1.5c0-.55-.45-1-1-1H8v-1h3V9H6.5v3.5h3v1h-3V15H10c.55 0 1-.45 1-1zM14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$68fa0e35c0b0901c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5zM7 15h2c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H7.5v-1H10V9H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-2.5h1V14h-1v-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$413e29cc8cfb21bb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5zM7.5 15H10c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H8v-1h3V9H7.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-2.5h1.5V14H8v-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ec6ad361fad4f26e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.75 15H8.5l1.46-4.71C10.15 9.65 9.67 9 9 9H5.5v1.5h2.63L6.75 15zM12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$890e99d50b8969d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75 15H9.5l1.46-4.71C11.15 9.65 10.67 9 10 9H6.5v1.5h2.63L7.75 15zM14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$42c49d85e2a74419(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h2c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-5h1v1.5h-1V10zm0 2.5h1V14h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$348f4c6f4830d7be(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 15H10c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H7.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-5h1.5v1.5H8V10zm0 2.5h1.5V14H8v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e8f35a0414a671a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14v-4c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1h1.5v1H6V15h3c.55 0 1-.45 1-1zm-1.5-2.5h-1V10h1v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ef4ac86edc2afafe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14v-4c0-.55-.45-1-1-1H7.5c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1h2v1h-3V15H10c.55 0 1-.45 1-1zm-1.5-2.5H8V10h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d15347c0fa4b5ef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v-3h3v-2h-3V7h-2v3H8v2h3zM21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 14H3V5h18v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c525d0aa41cd2ab7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12l-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ef2ccf4a9ec368f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-12.5c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 5.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$406fa799daabdaa9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$faeb0708495de067(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6zm10-9h-4v3.88a2.247 2.247 0 00-3.5 1.87c0 1.24 1.01 2.25 2.25 2.25S13 17.99 13 16.75V13h3v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f4846d6a54ecc61d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9a9 9 0 000-18h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da2519a8e51fed7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zm-10-7h9v6h-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a81fb1d2858765ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 15h14v3H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3ca4ed8e57f90d51(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1h-1.5v-.5h-2v1L13 10zm3.5 3.5l1.21 1.21c.18-.19.29-.44.29-.71v-1h-1.5v.5zM8.83 6H19v10.17l1.98 1.98c0-.05.02-.1.02-.16V6c0-1.1-.9-2-2-2H6.83l2 2zm10.95 16.61L17.17 20H5a2 2 0 01-2-2V6c0-.05.02-.1.02-.15L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM7.5 13.5h2V13h.67l-2.5-2.5H7.5v3zm7.67 4.5L11 13.83V14c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.32.16-.59.4-.78L5 7.83V18h10.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$236fe13ef4ecba6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h3c.55 0 1-.45 1-1v-1H9.5v.5h-2v-3h2v.5H11v-1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zM14 15h3c.55 0 1-.45 1-1v-1h-1.5v.5h-2v-3h2v.5H18v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b54597f328c84be3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12zM7 15h3c.55 0 1-.45 1-1v-1H9.5v.5h-2v-3h2v.5H11v-1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm7 0h3c.55 0 1-.45 1-1v-1h-1.5v.5h-2v-3h2v.5H18v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85cb60168cc43525(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.54 8.46L2 12l3.54 3.54 1.76-1.77L5.54 12l1.76-1.77zm6.46 10l-1.77-1.76-1.77 1.76L12 22l3.54-3.54-1.77-1.76zm6.46-10l-1.76 1.77L18.46 12l-1.76 1.77 1.76 1.77L22 12zm-10-2.92l1.77 1.76L12 5.54l1.77 1.76 1.77-1.76L12 2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee026d19e51911a0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4394d832f882d69c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4h-4v-2h4v-2h-4V9h4V7H9v10h6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$97d6afc3d400007a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.86L18.03 12 15 14.14V9.86m-9 0L9.03 12 6 14.14V9.86M13 6v12l8.5-6L13 6zM4 6v12l8.5-6L4 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$48df0c7874d62c02(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9.86v4.28L14.97 12 18 9.86m-9 0v4.28L5.97 12 9 9.86M20 6l-8.5 6 8.5 6V6zm-9 0l-8.5 6 8.5 6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3865c9d1211574e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 10h9v2H5zm0-3h9v2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$946706868356b1aa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM4 6h9v7H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$551f500aa16dfdb7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.87 12.43l-1-3.43h-1.5l1.75 6h1.5l1.75-6h-1.5zM21 11.5v-1c0-.85-.65-1.5-1.5-1.5H16v6h1.5v-2h1.15l.85 2H21l-.9-2.1c.5-.25.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zM6.5 9H3v6h3.5c.85 0 1.5-.65 1.5-1.5v-3C8 9.65 7.35 9 6.5 9zm0 4.5h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16b74f2c3973892a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6m0-2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$364b1cc9e5232392(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.25 12.5L4.75 9H3.5v6h1.25v-3.5L7.3 15h1.2V9H7.25zM9.5 15h4v-1.25H11v-1.11h2.5v-1.26H11v-1.12h2.5V9h-4zm9.75-6v4.5h-1.12V9.99h-1.25v3.52h-1.13V9H14.5v5c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V9h-1.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$64e5206b56881a0d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h1.5V9H11v6zm7.75-6v3.5L16.25 9H15v6h1.25v-3.5L18.8 15H20V9h-1.25zM7.5 9H4v6h1.5v-2h2c.85 0 1.5-.65 1.5-1.5v-1C9 9.65 8.35 9 7.5 9zm0 2.5h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e64a29d6e830438e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm8-13.74v2.09a5.99 5.99 0 010 11.3v2.09c3.45-.89 6-4.01 6-7.74 0-3.73-2.55-6.85-6-7.74z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$524e711372dbdf11(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9 16v-4.27h-.09l-1.77.63v.69l1.01-.31V16zM14.32 11.78c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.29-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ba9571639b0b7697(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2zm-7.46 2.22c-.06.05-.12.09-.2.12s-.17.04-.27.04a.69.69 0 01-.45-.15c-.06-.05-.1-.1-.13-.17s-.05-.14-.05-.22h-.85c0 .21.04.39.12.55s.19.28.33.38.29.18.46.23.35.07.53.07c.21 0 .41-.03.6-.08s.34-.14.48-.24.24-.24.32-.39.12-.33.12-.53c0-.23-.06-.44-.18-.61s-.3-.3-.54-.39c.1-.05.2-.1.28-.17s.15-.14.2-.22.1-.16.13-.25.04-.18.04-.27c0-.2-.04-.37-.11-.53s-.17-.28-.3-.38-.28-.18-.46-.23-.37-.08-.59-.08c-.19 0-.38.03-.54.08s-.32.13-.44.23-.23.22-.3.37-.11.3-.11.48h.85a.455.455 0 01.17-.35c.05-.04.11-.07.18-.1s.14-.03.22-.03c.1 0 .18.01.25.04s.13.06.18.11.08.11.11.17.04.14.04.22c0 .18-.05.32-.16.43s-.26.16-.48.16h-.43v.66h.45c.11 0 .2.01.29.04s.16.06.22.11.11.12.14.2.05.18.05.29c0 .09-.01.17-.04.24s-.08.11-.13.17zm3.9-3.44c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.28-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d788b749a2ec7e81(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.95 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2zm-5.52 2.15c-.05.07-.11.13-.18.17s-.17.06-.27.06c-.17 0-.31-.05-.42-.15s-.17-.24-.19-.41h-.84c.01.2.05.37.13.53s.19.28.32.39.29.19.46.24.35.08.53.08c.24 0 .46-.04.64-.12s.33-.18.45-.31.21-.28.27-.45.09-.35.09-.54c0-.22-.03-.43-.09-.6s-.14-.33-.25-.45-.25-.22-.41-.28-.34-.1-.55-.1c-.07 0-.14.01-.2.02s-.13.02-.18.04-.1.03-.15.05-.08.04-.11.05l.11-.92h1.7v-.71H10.9l-.25 2.17.67.17c.03-.03.06-.06.1-.09s.07-.05.12-.07.1-.04.15-.05.13-.02.2-.02c.12 0 .22.02.3.05s.16.09.21.15.1.14.13.24.04.19.04.31-.01.22-.03.31-.06.17-.11.24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$220c6da1b8a2b3fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4v2.67l-1 1-1-1V4h2m7 7v2h-2.67l-1-1 1-1H20M6.67 11l1 1-1 1H4v-2h2.67M12 16.33l1 1V20h-2v-2.67l1-1M15 2H9v5.5l3 3 3-3V2zm7 7h-5.5l-3 3 3 3H22V9zM7.5 9H2v6h5.5l3-3-3-3zm4.5 4.5l-3 3V22h6v-5.5l-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8d05b6ec33974cbf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7.5 13h2v2H11V9H9.5v2.5h-2V9H6v6h1.5zM18 14v-4c0-.55-.45-1-1-1h-4v6h4c.55 0 1-.45 1-1zm-1.5-.5h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3a7b76583115ebb4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.03 3.2C7.15 2.44 8.51 2 10 2c3.93 0 7 3.07 7 7 0 1.26-.38 2.65-1.07 3.9-.02.04-.05.08-.08.13l-1.48-1.48c.4-.86.63-1.75.63-2.55 0-2.8-2.2-5-5-5-.92 0-1.76.26-2.5.67L6.03 3.2zm11.18 11.18l1.43 1.43C20.11 13.93 21 11.57 21 9c0-3.04-1.23-5.79-3.22-7.78l-1.42 1.42A8.937 8.937 0 0119 9c0 2.02-.67 3.88-1.79 5.38zM10 6.5c-.21 0-.4.03-.59.08l3.01 3.01c.05-.19.08-.38.08-.59A2.5 2.5 0 0010 6.5zm11.19 14.69L2.81 2.81 1.39 4.22l2.13 2.13C3.19 7.16 3 8.05 3 9h2c0-.36.05-.71.12-1.05l6.61 6.61c-.88.68-1.78 1.41-2.27 2.9-.5 1.5-1 2.01-1.71 2.38-.19.1-.46.16-.75.16-1.1 0-2-.9-2-2H3a3.999 3.999 0 005.64 3.65c1.36-.71 2.13-1.73 2.73-3.55.32-.98.9-1.43 1.71-2.05.03-.02.05-.04.08-.06l6.62 6.62 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$94a90db748fe4348(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55A3.999 3.999 0 0021 18h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9a2.5 2.5 0 005 0 2.5 2.5 0 00-5 0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8c27b78080a774a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12zM7.5 13h2v2H11V9H9.5v2.5h-2V9H6v6h1.5zm6.5 2h.75v1.5h1.5V15H17c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-4.5h2v3h-2v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cc93abca14cb0d42(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 16.5c-.83 0-1.5-.67-1.5-1.5v-2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V15c0 .83-.67 1.5-1.5 1.5zM20 20h1v-1.54c1.69-.24 3-1.7 3-3.46h-1a2.5 2.5 0 01-5 0h-1c0 1.76 1.31 3.22 3 3.46V20zM9 12c-2.21 0-4-1.79-4-4a3.999 3.999 0 015.34-3.77A5.938 5.938 0 009 8c0 1.43.5 2.74 1.34 3.77-.42.15-.87.23-1.34.23zm-1.89 1.13A4.965 4.965 0 005 17.22V20H1v-2.78c0-1.12.61-2.15 1.61-2.66 1.24-.64 2.76-1.19 4.5-1.43zM11 8c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4zm2 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm2 7c-2.37 0-4.29.73-5.48 1.34-.32.16-.52.5-.52.88V18h7.17c.5.86 1.25 1.56 2.15 2H7v-2.78c0-1.12.61-2.15 1.61-2.66C10.29 13.7 12.47 13 15 13c.39 0 .77.02 1.14.05-.33.59-.55 1.26-.62 1.96-.17-.01-.34-.01-.52-.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7a2dca96d8f09f70(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41 12.47 14zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$558accbb5d063756(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-2h2v-3h3V9h-3V6h-2v3h-3v2h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa594089c21ec1fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM10 9h8v2h-8zm0 3h4v2h-4zm0-6h8v2h-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7cdf1b5ee7409f21(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7.5-1a2.5 2.5 0 002.5-2.5V7h3V5h-4v5.51c-.42-.32-.93-.51-1.5-.51a2.5 2.5 0 000 5zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$12a2b4ee48a9daae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0020 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 004 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cddc37652d961f29(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h7v2H6zM6 12h4v2H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11.97V16H6l-2 2V4h11v2.03c.52-.69 1.2-1.25 2-1.6V4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h9c1.1 0 2-.9 2-2v-2.42a5.16 5.16 0 01-2-1.61z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9h7v2H6zM20 6.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V3h2V1h-4v5.18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3fa22f7ba722ee27(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19690ad16441c1b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.8 4.9c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2l-.01 3.91L15 10.6V5c0-1.66-1.34-3-3-3-1.54 0-2.79 1.16-2.96 2.65l1.76 1.76V4.9zM19 11h-1.7c0 .58-.1 1.13-.27 1.64l1.27 1.27c.44-.88.7-1.87.7-2.91zM4.41 2.86L3 4.27l6 6V11c0 1.66 1.34 3 3 3 .23 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28a7.13 7.13 0 002.55-.9l4.2 4.2 1.41-1.41L4.41 2.86z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$643e78bacc7e59af(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$83b91d639654e419(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zm-2-1.83V16H5V8h10v.67zm-7.89 2.44L11 15l3.77-3.79-.78-.79L11 13.43l-3.11-3.1h2.55V9.22H6v4.44h1.11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2623baec22f1b402(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6.47L5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e24b59e8f7b91ff4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03A3.003 3.003 0 0111 18c-1.66 0-3-1.34-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ecaefe60ff20c908(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-4.51 2.11l.26 2.79-2.74.62-1.43 2.41L12 18.82l-2.58 1.11-1.43-2.41-2.74-.62.26-2.8L3.66 12l1.85-2.12-.26-2.78 2.74-.61 1.43-2.41L12 5.18l2.58-1.11 1.43 2.41 2.74.62-.26 2.79L20.34 12l-1.85 2.11zM11 15h2v2h-2zm0-8h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$44a8870322f710c2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a70dac20f5661661(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99h16c1.1 0 2-.9 2-2v-8l-6-6zM4 18.01V6h11v5h5v7.01H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f5146079f6cf9bf3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$761e47b628400587(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ea9b8ab57d3fd847(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6028fde61b681bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$55967a06fb307c7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$afb0816eb2accbcc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$783a129987a149a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16.5l6-4.5-6-4.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$282c0bc5cf9d7940(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-2.5-3.5l7-4.5-7-4.5v9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3498f9607122555c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.45 13.62L19 12 8 5v.17zM2.81 2.81L1.39 4.22 8 10.83V19l4.99-3.18 6.78 6.78 1.41-1.41L2.81 2.81zM10 15.36v-2.53l1.55 1.55-1.55.98z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a802e94b1e18417(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2 8H7v2h7v-2zm0-3H7v2h7V7zm-7 8h3v-2H7v2zm12-1.59L17.59 12l-3.54 3.54-1.41-1.41-1.41 1.41 2.83 2.83L19 13.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5103bf353a106b43(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h11v2H3zM3 6h11v2H3zM3 14h7v2H3zM20.59 11.93l-4.25 4.24-2.12-2.12-1.41 1.41L16.34 19 22 13.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$51a015535c4d83d6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm2-10H7v2h7v-2zm0-3H7v2h7V7zm-7 8h3v-2H7v2zm12-2v2h-2v2h-2v-2h-2v-2h2v-2h2v2h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ceff24fd6e73849(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H3v2h11v-2zm0-4H3v2h11V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM3 16h7v-2H3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e0b3f0b774ab3131(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h11v2H3zM3 6h11v2H3zM3 14h7v2H3zM16 13v8l6-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d8a3e564b85fd704(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H3v2h11v-2zm0-4H3v2h11V6zM3 16h7v-2H3v2zm11.41 6L17 19.41 19.59 22 21 20.59 18.41 18 21 15.41 19.59 14 17 16.59 14.41 14 13 15.41 15.59 18 13 20.59 14.41 22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bd49084fd77309f2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6h-5v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6zm-7 0H3v2h12V6zm0 4H3v2h12v-2zm-4 4H3v2h8v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5992a2f5186ca7c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h2v-2H3V5h18v8h2V5a2 2 0 00-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$571fea58a195a6af(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-1h2v-4h4V9h-4V5h-2v4H9v2h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$77b85805ce2cb953(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6H8.3l8.26-3.34L15.88 1 3.24 6.15C2.51 6.43 2 7.17 2 8v12a2 2 0 002 2h16a2 2 0 002-2V8c0-1.11-.89-2-2-2zm0 2v3h-2V9h-2v2H4V8h16zM4 20v-7h16v7H4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16.48",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6e655d17b117cb0f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5h2v14h-2zm-4 0h2v14h-2zm-3 0H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 12H3V7h10v10z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "9.94",
                    "r": "1.95"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.89 15.35c0-1.3-2.59-1.95-3.89-1.95s-3.89.65-3.89 1.95V16h7.78v-.65z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3b9698ea35576dd5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f277b593587dd690(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-2 18H6.83l1.58 1.58L7 22l-4-4 4-4 1.41 1.42L6.83 17H17v-4h2v6zm-2-9l-1.41-1.42L17.17 7H7v4H5V5h12.17l-1.58-1.58L17 2l4 4-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0107c1206781e75(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-2 18H6.83l1.58 1.58L7 22l-4-4 4-4 1.41 1.42L6.83 17H17v-4h2v6zm-9-8.5V9h3v6h-1.5v-4.5H10zm7-.5l-1.41-1.42L17.17 7H7v4H5V5h12.17l-1.58-1.58L17 2l4 4-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$161364964283aa13(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e8d526f32745afe4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$41fc06a4134be974(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.1 11h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zm4.28-1.76c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$298587508c2617a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-2.44 8.49h.45c.21 0 .37-.05.48-.16s.16-.25.16-.43a.538.538 0 00-.15-.39c-.05-.05-.11-.09-.18-.11s-.16-.04-.25-.04c-.08 0-.15.01-.22.03s-.13.05-.18.1-.09.09-.12.15-.05.13-.05.2h-.85a1.06 1.06 0 01.41-.85c.13-.1.27-.18.44-.23s.35-.08.54-.08c.21 0 .41.03.59.08s.33.13.46.23.23.23.3.38.11.33.11.53a.842.842 0 01-.17.52 1.1 1.1 0 01-.48.39c.24.09.42.21.54.39s.18.38.18.61c0 .2-.04.38-.12.53s-.18.29-.32.39-.29.19-.48.24-.38.08-.6.08c-.18 0-.36-.02-.53-.07s-.33-.12-.46-.23-.25-.23-.33-.38-.12-.34-.12-.55h.85c0 .08.02.15.05.22s.07.12.13.17.12.09.2.11.16.04.25.04c.1 0 .19-.01.27-.04s.15-.07.2-.12.1-.11.13-.18.04-.15.04-.24c0-.11-.02-.21-.05-.29s-.08-.15-.14-.2-.13-.09-.22-.11-.18-.04-.29-.04h-.47v-.65zm5.74.75c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32c.03-.13.04-.29.04-.48v-.97z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$61c228d9c259e9ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.31 8.9l.25-2.17h2.39v.71h-1.7l-.11.92c.03-.02.07-.03.11-.05s.09-.04.15-.05.12-.03.18-.04.13-.02.2-.02c.21 0 .39.03.55.1s.3.16.41.28.2.27.25.45.09.38.09.6c0 .19-.03.37-.09.54s-.15.32-.27.45-.27.24-.45.31-.39.12-.64.12c-.18 0-.36-.03-.53-.08s-.32-.14-.46-.24-.24-.24-.32-.39-.13-.33-.13-.53h.84c.02.18.08.32.19.41s.25.15.42.15a.49.49 0 00.45-.23c.04-.07.08-.15.11-.25s.03-.2.03-.31-.01-.21-.04-.31-.07-.17-.13-.24-.13-.12-.21-.15-.19-.05-.3-.05c-.08 0-.15.01-.2.02s-.11.03-.15.05-.08.05-.12.07-.07.06-.1.09l-.67-.16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$edebabfce5572a72(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 16.5c-3.31 0-6-2.69-6-6h2c0 2.21 1.79 4 4 4s4-1.79 4-4c0-2.24-1.85-4.09-4.16-3.99l1.57 1.57L12 11.5l-4-4 4-4 1.41 1.41-1.6 1.6C15.28 6.4 18 9.18 18 12.5c0 3.31-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$134912ae8afba5a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$49e25aed1fccfeb3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h3c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H7.5v-1h2v.5H11v-1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1h2.5v1h-2V13H6v1c0 .55.45 1 1 1zM18 14v-4c0-.55-.45-1-1-1h-4v6h4c.55 0 1-.45 1-1zm-1.5-.5h-2v-3h2v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d7d7f29304cc7e3b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM5.41 4l5.18 5.17-1.41 1.42L4 5.42 5.41 4zM20 20h-6v-2h2.61l-3.2-3.2 1.42-1.42 3.13 3.13.04.04V14h2v6zm0-10h-2V7.42L5.41 20 4 18.59 16.58 6H14V4h6v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4bdabb12537d2d17(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eeed8a17b911674f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18l8.5-6L6 6v12zm2-8.14L11.03 12 8 14.14V9.86zM16 6h2v12h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$356731fe9e769991(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h2v12H6zm3.5 6l8.5 6V6l-8.5 6zm6.5 2.14L12.97 12 16 9.86v4.28z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$17a5c13a1b88bf07(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.05 9.79L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zm0 0L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zm0 0L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0111 4.07zM5.69 7.1L4.26 5.68A9.949 9.949 0 002.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 014.07 13zm1.61 6.74A9.981 9.981 0 0011 21.95v-2.02a7.941 7.941 0 01-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d685dd605561ca5e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2zm7.056-7.654l1.282-1.535 4.607 3.85-1.28 1.54zM3.336 7.19l-1.28-1.536L6.662 1.81l1.28 1.536zM12 6c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-2a9 9 0 10.001 18.001A9 9 0 0012 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8efe83e764cd135b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.94 4.66h-4.72l2.36-2.36 2.36 2.36zm-4.69 14.71h4.66l-2.33 2.33-2.33-2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b8b98b39f8a5cf7a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.38 8.57l-1.23 1.85a8 8 0 01-.22 7.58H5.07A8 8 0 0115.58 6.85l1.85-1.23A10 10 0 003.35 19a2 2 0 001.72 1h13.85a2 2 0 001.74-1 10 10 0 00-.27-10.44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.59 15.41a2 2 0 002.83 0l5.66-8.49-8.49 5.66a2 2 0 000 2.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d48d7efae6daccf1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4-4H8V8h8v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7314af995251c5ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v8H8V8h8m2-2H6v12h12V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$32daaf1bfc59758a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h16v2H4zm2-4h12v2H6zm14 8H4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm0 10H4v-8h16v8zm-10-7.27v6.53L16 16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ccf63b7bf35ef70c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12zM6 10h2v2H6zm0 4h8v2H6zm10 0h2v2h-2zm-6-4h8v2h-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bb43c1e50a235fc6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.29 15.71A5.233 5.233 0 016.75 12c0-1.35.52-2.69 1.53-3.72L7.05 7.05C5.68 8.41 5 10.21 5 12s.68 3.59 2.06 4.94l1.23-1.23zM12 15.5c1.93 0 3.5-1.57 3.5-3.5S13.93 8.5 12 8.5 8.5 10.07 8.5 12s1.57 3.5 3.5 3.5zm0-5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM15.72 15.72l1.23 1.23C18.32 15.59 19 13.79 19 12s-.68-3.59-2.06-4.94l-1.23 1.23A5.233 5.233 0 0117.25 12c0 1.35-.52 2.69-1.53 3.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6121cad5ed8e4f15(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM15 16H5V8h10v8zm-6-1h2v-2h2v-2h-2V9H9v2H7v2h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bd0a7bdd9dea1b1d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6zm8-6l2-1.06v4.12L14 16v1c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$10b01a50b2741dad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$13db6aeef09b7e47(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM12 5.5v9l6-4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$29145f0826c41858(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18v5h2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H3V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12L9 8v8zM22.71 18.43c.03-.29.04-.58.01-.86l1.07-.85c.1-.08.12-.21.06-.32l-1.03-1.79c-.06-.11-.19-.15-.31-.11l-1.28.5a3.44 3.44 0 00-.75-.42l-.2-1.36a.249.249 0 00-.25-.22h-2.07c-.12 0-.23.09-.25.21l-.2 1.36c-.26.11-.51.26-.74.42l-1.28-.5c-.12-.05-.25 0-.31.11l-1.03 1.79c-.06.11-.04.24.06.32l1.07.86c-.03.29-.04.58-.01.86l-1.07.85c-.1.08-.12.21-.06.32l1.03 1.79c.06.11.19.15.31.11l1.27-.5c.23.17.48.31.75.42l.2 1.36c.02.12.12.21.25.21h2.07c.12 0 .23-.09.25-.21l.2-1.36c.26-.11.51-.26.74-.42l1.28.5c.12.05.25 0 .31-.11l1.03-1.79c.06-.11.04-.24-.06-.32l-1.06-.85zM19 19.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$648eae91436a98ff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.56 8l-2-2-4.15-4.14L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.55-.18L19.73 21l1.41-1.41-8.86-8.86L9.56 8zM5 16V8h1.73l8 8H5zm10-8v2.61l6 6V6.5l-4 4V7c0-.55-.45-1-1-1h-5.61l2 2H15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b526b446a4053b5a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8v8H5V8h10m1-2H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a8a2d5957a2b7b47(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02A4.5 4.5 0 0016 7.97zM5 9v6h4l5 5V4L9 9H5zm7-.17v6.34L9.83 13H7v-2h2.83L12 8.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ad4d6b66fa6f195e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8.83v6.34L11.83 13H9v-2h2.83L14 8.83M16 4l-5 5H7v6h4l5 5V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$58334f95df0e69b1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.34 2.93L2.93 4.34 7.29 8.7 7 9H3v6h4l5 5v-6.59l4.18 4.18c-.65.49-1.38.88-2.18 1.11v2.06a8.94 8.94 0 003.61-1.75l2.05 2.05 1.41-1.41L4.34 2.93zM10 15.17L7.83 13H5v-2h2.83l.88-.88L10 11.41v3.76zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-7-8l-1.88 1.88L12 7.76zm4.5 8A4.5 4.5 0 0014 7.97v1.79l2.48 2.48c.01-.08.02-.16.02-.24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4787f33743fee18c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9v6h4l5 5V4L7 9H3zm7-.17v6.34L7.83 13H5v-2h2.83L10 8.83zM16.5 12A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f52789b188d9ef8f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.83 4H20a2 2 0 012 2v12c0 .34-.09.66-.23.94L20 17.17V8h-9.17l-4-4zm13.66 19.31L17.17 20H4a2 2 0 01-2-2V6c0-.34.08-.66.23-.94L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM15.17 18l-10-10H4v10h11.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$584d4015f85cf6fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm0 14H5V8h14v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$387cf8725a322d67(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 9h10.5v3.5H4V9zm0 5.5h10.5V18H4v-3.5zM20 18h-3.5V9H20v9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d7b61cdff84df09a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4.01c-1.1 0-2 .9-2 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-8-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 008 13.43V14h8v-.57z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$678bd311c507f1f1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.45c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1 11.36 11.36 0 01-.57-3.57c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 4.95h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.92c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM18 5.95v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cb604150cf154fed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1.95c-5.52 0-10 4.48-10 10s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57v-1.43c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57v-1.43c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd6c1884d9a5e21c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4h4v4h-4zM4 16h4v4H4zM4 10h4v4H4zM4 4h4v4H4zM16 4h4v4h-4zM11 17.86V20h2.1l5.98-5.97-2.12-2.12zM14 12.03V10h-4v4h2.03zM20.85 11.56l-1.41-1.41c-.2-.2-.51-.2-.71 0l-1.06 1.06 2.12 2.12 1.06-1.06c.2-.2.2-.51 0-.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e8c5a21e53da4d9e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8c4be70c73655d97(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.59 10.52c1.05.51 2.04 1.15 2.96 1.91l-1.07 1.07c-.58-.47-1.21-.89-1.88-1.27v-1.71m-13.2 0v1.7c-.65.37-1.28.79-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.38 2.94-1.9M12 7C7.46 7 3.34 8.78.29 11.67c-.18.18-.29.43-.29.71s.11.53.29.7l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.1.7-.28.79-.73 1.68-1.36 2.66-1.85.33-.16.56-.51.56-.9v-3.1C8.85 9.25 10.4 9 12 9s3.15.25 4.59.73v3.1c0 .4.23.74.56.9.98.49 1.88 1.11 2.67 1.85.18.17.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.11-.53-.29-.71A16.971 16.971 0 0012 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a7783333018a3096(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2238e1126b31b244(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2cc5d7157ab08610(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4e343cf2ad7540b9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9L19.59 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cf02f8a2fd6beb04(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41L20 5.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f38b15d6b9152ee1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4h-6zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3L10 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8f9b2ccf5e8293aa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57a.84.84 0 00-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4da63d5fe6c14274(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM9.41 15.95L12 13.36l2.59 2.59L16 14.54l-2.59-2.59L16 9.36l-1.41-1.41L12 10.54 9.41 7.95 8 9.36l2.59 2.59L8 14.54z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5d2f850310e4edf1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.3 14.7l1.2-1.2c-1-1-1.5-2.3-1.5-3.5 0-1.3.5-2.6 1.5-3.5L7.3 5.3c-1.3 1.3-2 3-2 4.7s.7 3.4 2 4.7zM19.1 2.9l-1.2 1.2c1.6 1.6 2.4 3.8 2.4 5.9 0 2.1-.8 4.3-2.4 5.9l1.2 1.2c2-2 2.9-4.5 2.9-7.1 0-2.6-1-5.1-2.9-7.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.1 4.1L4.9 2.9C3 4.9 2 7.4 2 10c0 2.6 1 5.1 2.9 7.1l1.2-1.2c-1.6-1.6-2.4-3.8-2.4-5.9 0-2.1.8-4.3 2.4-5.9zM16.7 14.7c1.3-1.3 2-3 2-4.7-.1-1.7-.7-3.4-2-4.7l-1.2 1.2c1 1 1.5 2.3 1.5 3.5 0 1.3-.5 2.6-1.5 3.5l1.2 1.2zM14.5 10a2.5 2.5 0 00-5 0c0 .76.34 1.42.87 1.88L7 22h2l.67-2h4.67l.66 2h2l-3.37-10.12c.53-.46.87-1.12.87-1.88zm-4.17 8L12 13l1.67 5h-3.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d7133c4197592f52(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h16V5.97L6 22zm14-2h-2v-7.22l2-2V20zM5.22 7.22L3.93 5.93c3.9-3.91 10.24-3.91 14.15 0l-1.29 1.29c-3.19-3.19-8.38-3.19-11.57 0zm7.71 3.85L11 13l-1.93-1.93a2.74 2.74 0 013.86 0zm1.29-1.28c-1.78-1.77-4.66-1.77-6.43 0L6.5 8.5a6.374 6.374 0 019 0l-1.28 1.29z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dabc736eca11b030(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9009e27f402637cb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$57d29926d7e3b96d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h8v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d48686fc6e8213de(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$642331dd418dfd88(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v8h2V5h18v16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10c0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4 4-1.79 4-4zm-6 0c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM15.39 16.56C13.71 15.7 11.53 15 9 15s-4.71.7-6.39 1.56A2.97 2.97 0 001 19.22V22h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM15 20H3c0-.72-.1-1.34.52-1.66C4.71 17.73 6.63 17 9 17c2.37 0 4.29.73 5.48 1.34.63.32.52.95.52 1.66z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$25ea327e7a58dea3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM20 4v13.17L18.83 16H4V4h16zM6 12h12v2H6zm0-3h12v2H6zm0-3h12v2H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1233c3e6f16cb41c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.83 16H20V4H6.83l-2-2H20c1.1 0 2 .9 2 2v15.17L18.83 16zM18 6H8.83l2 2H18V6zm0 3h-6.17l2 2H18V9zm0 5v-2h-3.17l2 2H18zm3.9 7.9l-1.41 1.41L15.17 18H4c-1.1 0-2-.9-2-2V4.83L.69 3.51 2.1 2.1l19.8 19.8zM13.17 16l-2-2H6v-2h3.17l-1-1H6V9h.17L4 6.83V16h9.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4f5a190675bd66cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 14c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.54 0 1 .46 1 1s-.46 1-1 1-1-.46-1-1 .46-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM4.54 19c1.1-1.22 2.69-2 4.46-2s3.36.78 4.46 2H4.54zM22 19h-6.08c-1.38-2.39-3.96-4-6.92-4s-5.54 1.61-6.92 4H2V5h20v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.78 11.15l1.47-.85V12h1.5v-1.7l1.47.85.75-1.3L19.5 9l1.47-.85-.75-1.3-1.47.85V6h-1.5v1.7l-1.47-.85-.75 1.3L16.5 9l-1.47.85z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$48faf10e54ef637d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zm0 16H2V5h20v14zM21 6h-7v5h7V6zm-1 2l-2.5 1.75L15 8V7l2.5 1.75L20 7v1zM9 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.59c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.41zM5.48 16c.74-.5 2.22-1 3.52-1s2.77.49 3.52 1H5.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$12451d9b5d843eda(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zm0 16H2V5h20v14zm-2.99-1.01L21 16l-1.51-2h-1.64c-.22-.63-.35-1.3-.35-2s.13-1.37.35-2h1.64L21 8l-1.99-1.99A7.474 7.474 0 0016.28 10c-.18.64-.28 1.31-.28 2s.1 1.36.28 2a7.512 7.512 0 002.73 3.99zM9 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.59c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.41zM5.48 16c.74-.5 2.22-1 3.52-1s2.77.49 3.52 1H5.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9b51258934168d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12zM4 0h16v2H4zm0 22h16v2H4zm8-10a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm0-3.5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 7.49C17 13.9 13.69 13 12 13s-5 .9-5 2.99V17h10v-1.01zm-8.19-.49c.61-.52 2.03-1 3.19-1 1.17 0 2.59.48 3.2 1H8.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4a007afd69e02f48(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.41 1.69L0 3.1l1 .99V16c0 1.1.89 2 1.99 2H10v2H8v2h8v-2h-2v-2h.9l6 6 1.41-1.41-20.9-20.9zM2.99 16V6.09L12.9 16H2.99zM4.55 2l2 2H21v12h-2.45l2 2h.44c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4.55z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$55b813e5c703f7d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3h1v5h-1zm-1 2h-2V4h2V3h-3v3h2v1h-2v1h3zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57a.984.984 0 00-1.01.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.46 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8zM19 18.97c-1.32-.09-2.59-.35-3.8-.75l1.2-1.2c.85.24 1.71.39 2.59.45v1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8980af36ed7ae5e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a2b0f59fbb4e81b0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3H4v3H2V1h5v2zm15 3V1h-5v2h3v3h2zM7 21H4v-3H2v5h5v-2zm13-3v3h-3v2h5v-5h-2zM17 6H7v12h10V6zm2 12c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v12zM15 8H9v2h6V8zm0 3H9v2h6v-2zm0 3H9v2h6v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b8d8bed3793c7804(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.41 1.69L0 3.1l2 2V21h15.9l3 3 1.41-1.41-20.9-20.9zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm-2-4V9h2v2H4zm6 8H8v-2h2v2zm-2-4v-2h2v2H8zm4 4v-2h1.9l2 2H12zM8 5h2v2h-.45L12 9.45V9h8v8.45l2 2V7H12V3H5.55L8 5.45zm8 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a86c5baf3ae5a25e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.6 10.88l-1.42-1.42-4.24 4.25-2.12-2.13L7.4 13l3.54 3.54z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm0 14H5V8h14v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ba287d08432f09b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h-8C6.38 2 2 6.66 2 12.28 2 17.5 6.49 22 11.72 22 17.39 22 22 17.62 22 12V4c0-1.1-.9-2-2-2zm-3 13l-3-2v2H7V9h7v2l3-2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f4e3dc09124b3b0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e17a151513dea951(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4v7H5.17L4 12.17V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$97f8f437f0384a08(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H4V8l8 5 8-5v5h2V6c0-1.1-.9-2-2-2zm-8 7L4 6h16l-8 5zm7 4l4 4-4 4v-3h-4v-2h4v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$81287ba7e47d6a47(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22l-.01-6L14 12l3.99-4.01L18 2H6v6l4 4-4 3.99V22h12zM8 7.5V4h8v3.5l-4 4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e6da2c0e660c00c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2l.01 6L10 12l-3.99 4.01L6 22h12v-6l-4-4 4-3.99V2H6zm10 14.5V20H8v-3.5l4-4 4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$80246c719321b63f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6.5a2.996 2.996 0 00-2.99 3.21l-2.03.68a4.468 4.468 0 00-3.22-2.32V5.91A3.018 3.018 0 0015 3c0-1.66-1.34-3-3-3S9 1.34 9 3c0 1.4.96 2.57 2.25 2.91v2.16c-1.4.23-2.58 1.11-3.22 2.32l-2.04-.68C6 9.64 6 9.57 6 9.5c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3c1.06 0 1.98-.55 2.52-1.37l2.03.68c-.2 1.29.17 2.66 1.09 3.69l-1.41 1.77C6.85 17.09 6.44 17 6 17c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3c0-.68-.22-1.3-.6-1.8l1.41-1.77c1.36.76 3.02.75 4.37 0l1.41 1.77c-.37.5-.59 1.12-.59 1.8 0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3c-.44 0-.85.09-1.23.26l-1.41-1.77a4.49 4.49 0 001.09-3.69l2.03-.68c.53.82 1.46 1.37 2.52 1.37 1.66 0 3-1.34 3-3S22.66 6.5 21 6.5zm-18 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM6 21c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm5-18c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm1 12a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm6 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm3-8.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2dce73c7db98e12d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d25f03c21bb2c350(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a6ce071b1e3e080(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l4.2 4.2a7.73 7.73 0 00-1.6 4.7C4 17.48 7.58 21 12 21c1.75 0 3.36-.56 4.67-1.5l3.1 3.1 1.42-1.41zM12 19c-3.31 0-6-2.63-6-5.87 0-1.19.36-2.32 1.02-3.28L12 14.83V19zM8.38 5.56L12 2l5.65 5.56C19.1 8.99 20 10.96 20 13.13c0 1.18-.27 2.29-.74 3.3L12 9.17V4.81L9.8 6.97 8.38 5.56z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$acfe54a263802693(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.7 13.53l-1.71-1.71c.01.06.01.12.01.18 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.06 0 .12 0 .18.01L5.47 8.3C4.02 8.9 3 10.33 3 12c0 2.21 1.79 4 4 4 1.67 0 3.1-1.02 3.7-2.47zm1.49 1.49A6.012 6.012 0 017 18c-3.31 0-6-2.69-6-6 0-2.21 1.2-4.15 2.98-5.19L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-7.58-7.58zm4.07-1.59l1.24-.93 1.81 1.36L21.17 12l-1-1h-6.34l-2-2H21l3 3-4.5 4.5-.69-.51-2.55-2.56z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b6d4bba47ed94a2d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10h-8.35A5.99 5.99 0 007 6c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 005.65-4H13l2 2 2-2 2 2 4-4.04L21 10zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cb6b4808408a05ad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h6v2h-6zm0 4h6v2h-6zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7zM20.1 3H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM19 19H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$93cffee09d10951b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5a2 2 0 00-2 2v14a2 2 0 002 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-8-3h2v2h-2zm1-8c1.1 0 2 .9 2 2 0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4S8 6.79 8 9h2c0-1.1.9-2 2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0b372b643d90268(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c2.76 0 5 2.24 5 5 0 1.06-.39 2.32-1 3.62l1.49 1.49C18.37 12.36 19 10.57 19 9c0-3.87-3.13-7-7-7-1.84 0-3.5.71-4.75 1.86l1.43 1.43C9.56 4.5 10.72 4 12 4zm0 2.5c-.59 0-1.13.21-1.56.56l3.5 3.5c.35-.43.56-.97.56-1.56A2.5 2.5 0 0012 6.5zM3.41 2.86L2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21l1.41-1.41L3.41 2.86zM12 18.88c-2.01-2.58-4.8-6.74-4.98-9.59l6.92 6.92c-.65.98-1.33 1.89-1.94 2.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$67483463f195c5f1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "9",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$34d5451de2c23c90(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8l8 5 8-5v2h2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h12v-2H4V8zm16-2l-8 5-8-5h16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 15v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-3 0v-1c0-.55.45-1 1-1s1 .45 1 1v1h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f1a55b8e4f7f5975(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$31cfc0dc6ffef9f4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18H6l-4 4V4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v7h-2V4H4v12h8v2zm11-3.66l-1.41-1.41-4.24 4.24-2.12-2.12-1.41 1.41L17.34 20 23 14.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1c636e582dbdd123(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6.98V16c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2h10.1c-.06.32-.1.66-.1 1s.04.68.1 1H4v12h16V7.9c.74-.15 1.42-.48 2-.92zM16 3c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ea331112eaeb31d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h8v-2H4V8l8 5 8-5v5h2V6c0-1.1-.9-2-2-2zm-8 7L4 6h16l-8 5zm5.34 11l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L23 16.34 17.34 22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b7f1cb96bce09e4c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8.98V18c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2h10.1c-.06.32-.1.66-.1 1s.04.68.1 1H4l8 5 3.67-2.29c.47.43 1.02.76 1.63.98L12 13 4 8v10h16V9.9c.74-.15 1.42-.48 2-.92zM16 5c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d9f2ac33bc5876f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16H4V4h10.1a5 5 0 010-2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V6.98c-.58.44-1.26.77-2 .92V16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "3",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h8v2H6zM6 9h12v2H6zM6 8h12v-.1A5.013 5.013 0 0115.03 6H6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$43e4aa4a4dd0da1b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h12v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$88bbea5dfa40b175(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-1.99.85-1.99 1.95v18C5.01 22.05 5.9 23 7 23h10c1.1 0 2-.95 2-2.05v-18C19 1.85 18.1 1 17 1zm0 18H7V5h10v14zm-4.2-5.76v1.75L16 12l-3.2-2.98v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a56d40c631eeb1e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8v6l4.7 2.9.8-1.2-4-2.4V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.92 12A6.957 6.957 0 0111 20c-3.9 0-7-3.1-7-7s3.1-7 7-7c.7 0 1.37.1 2 .29V4.23c-.64-.15-1.31-.23-2-.23-5 0-9 4-9 9s4 9 9 9a8.963 8.963 0 008.94-10h-2.02z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5V2h-2v3h-3v2h3v3h2V7h3V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9c323ddddf98792(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.82 13H11v-2H6.82C6.4 9.84 5.3 9 4 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c1.3 0 2.4-.84 2.82-2zM4 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12l-4-3v2h-4.05c-.5-5.05-4.76-9-9.95-9v2c4.42 0 8 3.58 8 8s-3.58 8-8 8v2c5.19 0 9.45-3.95 9.95-9H19v2l4-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4595c8440215de47(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.26 21.21L3.79 3.74 2.38 5.15l2.74 2.74-.12.12V19c0 1.1.9 2 2 2h10c.35 0 .68-.1.97-.26l1.88 1.88 1.41-1.41zM7 19V9.77L16.23 19H7zm3.84-14H17v9.11l2 2V5c0-1.1-.9-2-2-2h-6.99L7.95 5.06l1.41 1.41L10.84 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab8769d9a968ef11(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .85-2 1.95v14c0 1.1.9 2.05 2 2.05h18c1.1 0 2-.95 2-2.05v-14C23 3.85 22.1 3 21 3zm0 16H3V5h18v14zM9 8h2v8H9zm4 0h2v8h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$292d76a61ef9e974(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6c1.1 0 2 .9 2 2a2 2 0 01-1.67 1.97l-2.31-2.31C13.19 6.72 14.01 6 15 6m0-2c-2.21 0-4 1.79-4 4 0 .18.03.35.05.52l3.43 3.43c.17.02.34.05.52.05 2.21 0 4-1.79 4-4s-1.79-4-4-4zm1.69 10.16L22.53 20H23v-2c0-2.14-3.56-3.5-6.31-3.84zm-3.68 1.97L14.88 18H9c.08-.24.88-1.01 2.91-1.57l1.1-.3M1.41 1.71L0 3.12l4 4V10H1v2h3v3h2v-3h2.88l2.51 2.51C9.19 15.11 7 16.3 7 18v2h9.88l4 4 1.41-1.41L1.41 1.71zM6 10v-.88l.88.88H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a463c0042392daa2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM4 18c.22-.72 3.31-2 6-2 0-.7.13-1.37.35-1.99C7.62 13.91 2 15.27 2 18v2h9.54c-.52-.58-.93-1.25-1.19-2H4zM19.43 18.02c.36-.59.57-1.28.57-2.02 0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4c.74 0 1.43-.22 2.02-.57L20.59 22 22 20.59c-1.5-1.5-.79-.8-2.57-2.57zM16 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7acafb90d4822cad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 14.54l-1.43-1.43c.56-.73 1.05-1.5 1.47-2.32l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1H20c.55 0 1 .45 1 1 0 3.98-1.37 7.64-3.66 10.54zm-2.82 2.81A16.884 16.884 0 014 21c-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.1-.04.21-.05.31-.05.26 0 .51.1.71.29l2.2 2.2c.81-.42 1.58-.9 2.3-1.46L1.39 4.22l1.42-1.41L21.19 21.2l-1.41 1.41-5.26-5.26zm-6.92-.33c-.85.24-1.72.39-2.6.45v1.49c1.32-.09 2.59-.35 3.8-.75l-1.2-1.19zM17.46 5c-.06.89-.21 1.76-.45 2.59l1.2 1.2c.41-1.2.67-2.47.76-3.79h-1.51z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b53481f02ac1d60b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.46 5c-.06.89-.21 1.76-.45 2.59l1.2 1.2c.41-1.2.67-2.47.76-3.79h-1.51zM7.6 17.02c-.85.24-1.72.39-2.6.45v1.49c1.32-.09 2.59-.35 3.8-.75l-1.2-1.19zM16.5 3H20c.55 0 1 .45 1 1 0 9.39-7.61 17-17 17-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.1-.04.21-.05.31-.05.26 0 .51.1.71.29l2.2 2.2c2.83-1.45 5.15-3.76 6.59-6.59l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e0dfed611586fa90(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57a.84.84 0 00-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b379c20a4173e73f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3b5d43320dacc7a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eaf141a65aa65239(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$840ee2794a532cdd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2zm2.5 12.5c.29-.12.55-.29.8-.48l-.02.03 1.01.39c.23.09.49 0 .61-.22l.84-1.46c.12-.21.07-.49-.12-.64l-.85-.68-.02.03c.02-.16.05-.32.05-.48s-.03-.32-.05-.48l.02.03.85-.68c.19-.15.24-.43.12-.64l-.84-1.46a.499.499 0 00-.61-.22l-1.01.39.02.03c-.25-.17-.51-.34-.8-.46l-.17-1.08A.488.488 0 008.84 7H7.16c-.25 0-.46.18-.49.42L6.5 8.5c-.29.12-.55.29-.8.48l.02-.03-1.02-.39c-.23-.09-.49 0-.61.22l-.84 1.46c-.12.21-.07.49.12.64l.85.68.02-.03c-.02.15-.05.31-.05.47s.03.32.05.48l-.02-.03-.85.68c-.19.15-.24.43-.12.64l.84 1.46c.12.21.38.31.61.22l1.01-.39-.01-.04c.25.19.51.36.8.48l.17 1.07c.03.25.24.43.49.43h1.68c.25 0 .46-.18.49-.42l.17-1.08zM6 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3ad730f3fd12b07b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.42 2.36L2.01 3.78 4.1 5.87C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02 7.52 7.52 1.41-1.41L3.42 2.36zm14.29 11.46c.18-.57.29-1.19.29-1.82 0-3.31-2.69-6-6-6-.63 0-1.25.11-1.82.29l1.72 1.72c.03 0 .06-.01.1-.01 2.21 0 4 1.79 4 4 0 .04-.01.07-.01.11l1.72 1.71zM12 4c4.42 0 8 3.58 8 8 0 1.2-.29 2.32-.77 3.35l1.49 1.49A9.82 9.82 0 0022 12c0-5.52-4.48-10-10-10-1.76 0-3.4.48-4.84 1.28l1.48 1.48C9.66 4.28 10.8 4 12 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$39bfaf16688305b5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f8d2fe27c34a3711(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.41 1.6L0 3.01 5 8c-1.66 0-3 1.34-3 3v6h4v4h12l2.95 2.96 1.41-1.41L1.41 1.6zM6 15H4v-4c0-.55.45-1 1-1h2l3 3H6v2zm2 4v-4h4l4 4H8zM8 5h8v3h-5.34l2 2H19c.55 0 1 .45 1 1v4l-2 .01V13h-2.34l4 4H22v-6c0-1.66-1.34-3-3-3h-1V3H6v.36l2 2V5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "11.51",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$70641be0c1d6a283(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21h-2v-2h2v2zm-2-7h-2v5h2v-5zm8-2h-2v4h2v-4zm-2-2h-2v2h2v-2zM7 12H5v2h2v-2zm-2-2H3v2h2v-2zm7-5h2V3h-2v2zm-7.5-.5v3h3v-3h-3zM9 9H3V3h6v6zm-4.5 7.5v3h3v-3h-3zM9 21H3v-6h6v6zm7.5-16.5v3h3v-3h-3zM21 9h-6V3h6v6zm-2 10v-3h-4v2h2v3h4v-2h-2zm-2-7h-4v2h4v-2zm-4-2H7v2h2v2h2v-2h2v-2zm1-1V7h-2V5h-2v4h4zM6.75 5.25h-1.5v1.5h1.5v-1.5zm0 12h-1.5v1.5h1.5v-1.5zm12-12h-1.5v1.5h1.5v-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae6e81005df274fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 6.5v3h-3v-3h3M11 5H5v6h6V5zm-1.5 9.5v3h-3v-3h3M11 13H5v6h6v-6zm6.5-6.5v3h-3v-3h3M19 5h-6v6h6V5zm-6 8h1.5v1.5H13V13zm1.5 1.5H16V16h-1.5v-1.5zM16 13h1.5v1.5H16V13zm-3 3h1.5v1.5H13V16zm1.5 1.5H16V19h-1.5v-1.5zM16 16h1.5v1.5H16V16zm1.5-1.5H19V16h-1.5v-1.5zm0 3H19V19h-1.5v-1.5zM22 7h-2V4h-3V2h5v5zm0 15v-5h-2v3h-3v2h5zM2 22h5v-2H4v-3H2v5zM2 2v5h2V4h3V2H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$87222eb1cbec4086(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM19 19h2v2h-2zM13 13h2v2h-2zM15 15h2v2h-2zM13 17h2v2h-2zM15 19h2v2h-2zM17 17h2v2h-2zM17 13h2v2h-2zM19 15h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$30920b0b946cc991(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h9v2h-9zM13 15h9v2h-9zM16 11h6v2h-6zM13 12L8 7v4H2v2h6v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b02e2f36ef74c926(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.71 16.67A16.971 16.971 0 0012 12C7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71a.99.99 0 00-.29-.7zm-18.31.56c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7zm15.07 1.26c-.59-.48-1.21-.9-1.87-1.27v-1.7c1.04.51 2.03 1.15 2.94 1.9l-1.07 1.07zm.69-12.23l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM11 2h2v5h-2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bd787557fc07f998(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.18",
                    "cy": "17.82",
                    "r": "2.18"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f781cd1e890cf80c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.03 3l-1.11 7.07h2.62l.7-4.5h2.58L11.8 18.43H9.47L9.06 21h7.27l.4-2.57h-2.35l2-12.86h2.58l-.71 4.5h2.65L22 3H9.03zM8 5H4l-.31 2h4L8 5zm-.61 4h-4l-.31 2h4l.31-2zm.92 8h-6L2 19h6l.31-2zm.62-4h-6l-.31 2h6.01l.3-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$331ca548748724f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 6a2 2 0 00-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 002 2H0v2h24v-2h-4zM4 16V6h16v10.01L4 16zm9-6.87c-3.89.54-5.44 3.2-6 5.87 1.39-1.87 3.22-2.72 6-2.72v2.19l4-3.74L13 7v2.13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da69e1f14c98abc0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6v6.26l2 1V6c0-1.1-.9-2-2-2h-4a2.5 2.5 0 00-5 0H5.01c-1.1 0-2 .9-2 2v3.8C5.7 9.8 6 11.96 6 12.5s-.29 2.7-3 2.7V19c0 1.1.9 2 2 2h3.8c0-2.16 1.37-2.78 2.2-2.94v-2.03c-1.43.17-3.15 1.04-3.87 2.97H5v-2.13c2.17-.8 3-2.87 3-4.37 0-1.49-.83-3.56-2.99-4.37V6H11V4c0-.28.22-.5.5-.5s.5.22.5.5v2h6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12v4l4 1-4 1v4l10-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$442bd8d12e31a738(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c-1.48 0-2.75-.81-3.45-2H6.88a5.495 5.495 0 0010.24 0h-1.67c-.69 1.19-1.97 2-3.45 2zm-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$58e095b9ca022731(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zm0 2v12h16V6H4zm7 3h2v6h-2V9zm3 0h4c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-2.5v2H14V9zm3.5 1.5h-2v1h2v-1zm-11 .75H9c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H5v-1.5h3.5v-.75H6c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h4v1.5H6.5v.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c0a85abc3e79d72(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41A10.963 10.963 0 0012 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$81ebd658fc57c4b8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7c0-2.21-1.79-4-4-4S8 4.79 8 7s1.79 4 4 4 4-1.79 4-4zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-5 4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm10-6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ee0e2f593210ae9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dc8cf5b87aaec637(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8ee1089a47ce8672(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ddbd5d092a12d96f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$10270a364b4959ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.79 18l2 2H24v-2h-2.21zM1.11 2.98l1.55 1.56c-.41.37-.66.89-.66 1.48V16c0 1.1.9 2 2.01 2H0v2h18.13l2.71 2.71 1.41-1.41L2.52 1.57 1.11 2.98zM4 6.02h.13l4.95 4.93C7.94 12.07 7.31 13.52 7 15c.96-1.29 2.13-2.08 3.67-2.46l3.46 3.48H4v-10zm16 0v10.19l1.3 1.3c.42-.37.7-.89.7-1.49v-10a2 2 0 00-2-2H7.8l2 2H20zm-7.07 3.13l2.79 2.78 1.28-1.2L13 7v2.13l-.07.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e3be24c540b556bb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c41490c363bcd0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12zM7 9h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$301081223778ee6a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.99 14.04V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10.05c.28 1.92 2.1 3.35 4.18 2.93 1.34-.27 2.43-1.37 2.7-2.71.25-1.24-.16-2.39-.94-3.18zm-2-9.04L12 8.5 5 5h13.99zm-3.64 10H5V7l7 3.5L19 7v6.05c-.16-.02-.33-.05-.5-.05-1.39 0-2.59.82-3.15 2zm5.15 2h-4v-1h4v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$290ec4d305d9fe42(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$773b6bf54ecd53dc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l2.59 2.59A6.012 6.012 0 001 12c0 3.31 2.69 6 6 6 2.22 0 4.15-1.21 5.19-3l7.59 7.61 1.41-1.41L2.81 2.81zM7 16c-2.21 0-4-1.79-4-4 0-1.67 1.02-3.1 2.47-3.7l1.71 1.71C7.12 10 7.06 10 7 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.06 0-.12-.01-.18l1.74 1.74C10.22 14.48 9.14 16 7 16zm10-1.83V13h-1.17L17 14.17zM13.83 11H21v2h-2v3l2 2v-3h2V9H11.83l2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56cdea70ec5928f3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19h-6v-4h-2.68c-1.14 2.42-3.6 4-6.32 4-3.86 0-7-3.14-7-7s3.14-7 7-7c2.72 0 5.17 1.58 6.32 4H24v6h-2v4zm-4-2h2v-4h2v-2H11.94l-.23-.67C11.01 8.34 9.11 7 7 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c2.11 0 4.01-1.34 4.71-3.33l.23-.67H18v4zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c815de1e2cccbe9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.51c-1.24 0-2.45-.2-3.57-.57a.84.84 0 00-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1zM5.03 5h1.5a13 13 0 00.46 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79zM19 18.97c-1.32-.09-2.59-.35-3.8-.75l1.19-1.19c.85.24 1.72.39 2.6.45v1.49z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4.95C21.79 4.78 19.67 3 16.5 3c-3.18 0-5.29 1.78-5.5 1.95L16.5 12 22 4.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b68ac546060e3c07(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8-2h2v-4h4v-2h-4V7h-2v4H7v2h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$77d1566b9c7ee5d2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d624d23ad2570c56(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9fab79ab1ae50a79(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8v-2zm12.1 1H22c0-2.76-2.24-5-5-5h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1zM3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM19 12h-2v3h-3v2h3v3h2v-3h3v-2h-3v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$635224311e625ea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$79799d82e985527(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h10V4H7v15zM9 6h6v11H9V6zM3 6h2v11H3zM19 6h2v11h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e843981311e249ad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.81.97H5.44l.8-.97zM5 19V8h14v11H5zm8.45-9h-2.9v3H8l4 4 4-4h-2.55z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c4f9113d212939a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.5c-.91 0-2.75.46-2.75 1.38v4.62h1.5V19h2.5v-4.5h1.5V9.88c0-.91-1.84-1.38-2.75-1.38zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7527dbd8384affd4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7.07L2.4 12l4.66-7H22v14zm-11.59-2L14 13.41 17.59 17 19 15.59 15.41 12 19 8.41 17.59 7 14 10.59 10.41 7 9 8.41 12.59 12 9 15.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$475f6372060388bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.5h5v2h-5zm0 7h5v2h-5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM11 6H6v5h5V6zm-1 4H7V7h3v3zm1 3H6v5h5v-5zm-1 4H7v-3h3v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ec650357a1e93bb1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19c-1.1 0-2 .9-2 2h14c0-1.1-.9-2-2-2h-4v-2h3c1.1 0 2-.9 2-2h-8c-1.66 0-3-1.34-3-3a3 3 0 011.47-2.57c.41.59 1.06 1 1.83 1.06.7.06 1.36-.19 1.85-.62l.59 1.61.94-.34.34.94 1.88-.68-.34-.94.94-.34-2.74-7.52-.94.34-.34-.94-1.88.68.34.94-.94.35.56 1.55c-1.17-.04-2.19.75-2.48 1.86A5.01 5.01 0 005 12c0 2.76 2.24 5 5 5v2H7zm5.86-14.48l1.71 4.7-.94.34-1.71-4.7.94-.34zM10.5 7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a0830f3b4da9635(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 014 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0120 12c0 4.42-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ee32cf2dd97b877(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21h-1l1-7H7.5c-.88 0-.33-.75-.31-.78C8.48 10.94 10.42 7.54 13.01 3h1l-1 7h3.51c.4 0 .62.19.4.66C12.97 17.55 11 21 11 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8433999b3797ed23(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.25 7.72h5v1.5h-5zM13 15.75h5v1.5h-5zM13 13.25h5v1.5h-5zM8 18h1.5v-2h2v-1.5h-2v-2H8v2H6V16h2zM14.09 10.95l1.41-1.41 1.41 1.41 1.06-1.06-1.41-1.42 1.41-1.41L16.91 6 15.5 7.41 14.09 6l-1.06 1.06 1.41 1.41-1.41 1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$753471fb0a48cb49(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.17-5.24l-1.1-1.1c.71-1.33.53-3.01-.59-4.13A3.482 3.482 0 0012 8.5c-.03 0-.06.01-.09.01L13 9.6l-1.06 1.06-2.83-2.83L11.94 5 13 6.06l-.96.96c1.27.01 2.53.48 3.5 1.44 1.7 1.71 1.91 4.36.63 6.3zm-1.28 1.41L12.06 19 11 17.94l.95-.95a4.97 4.97 0 01-3.48-1.46 5.006 5.006 0 01-.64-6.29l1.1 1.1c-.71 1.33-.53 3.01.59 4.13.7.7 1.63 1.04 2.56 1.01L11 14.4l1.06-1.06 2.83 2.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a3859d13ad1cd508(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$371146ce6d7da42b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$280fe407031a4e63(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee97d2b3674c641f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v3h10V5h2v6h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.01 13l-1.42 1.41 1.58 1.58H12v2h6.17l-1.58 1.59 1.42 1.41 3.99-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bab5e387225ce15a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.42zM5 19V7.83L16.17 19H5zM17 8V5h2v11.17l2 2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5.83l5 5H17zm-5-5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd3054da228c0091(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v3h10V5h2v5h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.3 18.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S12 14 12 16.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l2.7 2.7 1.4-1.4-2.7-2.7zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b6297b1cc44b65c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2h-4.18C14.4.84 13.3 0 12 0S9.6.84 9.18 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56f4de2df560e5c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H9V4h9v12zM3 15v-2h2v2H3zm0-5.5h2v2H3v-2zM10 20h2v2h-2v-2zm-7-1.5v-2h2v2H3zM5 22c-1.1 0-2-.9-2-2h2v2zm3.5 0h-2v-2h2v2zm5 0v-2h2c0 1.1-.9 2-2 2zM5 6v2H3c0-1.1.9-2 2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$248c4cc0ed90e0cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20565c89c27317bf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zm2-8h6v8H5v-8zm5-6H6L5 5H2v2h12V5h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4cba057ac74aff29(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h2v-2H3v2zm4 8h2v-2H7v2zm6-18h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zm8 4h2v-2h-2v2zm8-8h2v-2h-2v2zm0-4h2V7h-2v2zm-4-4h2V3h-2v2zM7.83 5L7 4.17V3h2v2H7.83zm12 12l-.83-.83V15h2v2h-1.17zm1.36 4.19L2.81 2.81 1.39 4.22 4.17 7H3v2h2V7.83l2 2V17h7.17l2 2H15v2h2v-1.17l2.78 2.78 1.41-1.42zM9 15v-3.17L12.17 15H9zm6-2.83V9h-3.17l-2-2H17v7.17l-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c1628f5a6b76bf1d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zm-2 0v.01L12 13 4 8l8-4.68L19.99 8zM4 18v-7.66l8 5.02 7.99-4.99L20 18H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ba45315f7dd04ef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8H6v7c0 1.1.9 2 2 2h9v-2H8V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8h-8V7h8v4zM4 12H2v7c0 1.1.9 2 2 2h9v-2H4v-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$83299fd01d2c833e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11l-6-6zM8 21V7h6v5h5v9H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d64888a70d17822b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.83 8H21V6H8.83l2 2zm5 5H18v-2h-4.17l2 2zM14 16.83V18h-4v-2h3.17l-3-3H6v-2h2.17l-3-3H3V6h.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41L14 16.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a1bcea1a4eb6c36b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$37390015386d5a27(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9l-1-2H8v11h1.5v-5H12l1 2h5V9h-3zm1.5 4.5h-2.57l-1-2H9.5v-3h3.57l1 2h2.43v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$48ddd74534bc53c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.36 6l.4 2H18v6h-3.36l-.4-2H7V6h5.36M14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6L14 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6e4f801d4a31024b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.83 2H20c1.1 0 2 .9 2 2v15.17l-2-2V4H6.83l-2-2zm6.09 4l-.57 1.52 1.36 1.36.23-.66h.1l.54 1.52 3.04 3.04L13.07 6h-2.15zm9.57 17.31L19.17 22H4c-1.1 0-2-.9-2-2V4.83L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM17.17 20l-5.07-5.07H9.58L8.49 18H6.41l2.39-6.37L4 6.83V20h13.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5c3592ded6a571d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 15.5h5.64l1.14 3h2.09l-5.11-13h-1.86l-5.11 13h2.09l1.12-3zM12 7.98l2.07 5.52H9.93L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c041e54e99b527ad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8.83L17.17 12 14 15.17V14H6v-4h8V8.83M12 4v4H4v8h8v4l8-8-8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$699d1c4e92cb0189(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$356d6742b5e50870(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM5 18c.2-.63 2.57-1.68 4.96-1.94l2.04-2a9.34 9.34 0 00-1-.06c-2.67 0-8 1.34-8 4v2h9l-2-2H5zm15.6-5.5l-5.13 5.17-2.07-2.08L12 17l3.47 3.5L22 13.91z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae84c76f5674331f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4c0 1.1.89 2 1.99 2H19a2 2 0 002-2v-4l-3-3zm1 7H5v-1h14v1zm-7.66-4.98c.39.39 1.02.39 1.41 0l6.36-6.36a.996.996 0 000-1.41L14.16 2.3a.975.975 0 00-1.4-.01L6.39 8.66a.996.996 0 000 1.41l4.95 4.95zm2.12-10.61L17 7.95l-4.95 4.95-3.54-3.54 4.95-4.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a94d1b34da0ac90(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-3h3.56c.69 1.19 1.97 2 3.45 2s2.75-.81 3.45-2H19v3zm0-5h-4.99c0 1.1-.9 2-2 2s-2-.9-2-2H5V5h14v9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$12a927e145124945(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8c-1.45 0-2.26 1.44-1.93 2.51l-3.55 3.56c-.3-.09-.74-.09-1.04 0l-2.55-2.55C12.27 10.45 11.46 9 10 9c-1.45 0-2.27 1.44-1.93 2.52l-4.56 4.55C2.44 15.74 1 16.55 1 18c0 1.1.9 2 2 2 1.45 0 2.26-1.44 1.93-2.51l4.55-4.56c.3.09.74.09 1.04 0l2.55 2.55C12.73 16.55 13.54 18 15 18c1.45 0 2.27-1.44 1.93-2.52l3.56-3.55c1.07.33 2.51-.48 2.51-1.93 0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9l.94-2.07L18 6l-2.06-.93L15 3l-.92 2.07L12 6l2.08.93zM3.5 11L4 9l2-.5L4 8l-.5-2L3 8l-2 .5L3 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84e1164a0956f784(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-1 18H5V9h14v11zm1-13H4V4h16v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12h6v2H9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$90fd92e23d63ff34(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v3h10V5h2v5h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.5L15.51 17l-3.01-3-1.5 1.5 4.51 4.5 6.99-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e4538721782dfe99(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.39 11L16 12.61V11zM17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4A4.986 4.986 0 0022 12c0-2.76-2.24-5-5-5zM2 4.27l3.11 3.11A4.991 4.991 0 002 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86 2 4.27z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9ecb0c7f2a550751(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5006b73c1ff8ad89(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5h8v2h-8V5zm0 5.5h8v2h-8v-2zm0 5.5h8v2h-8v-2zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$98e146d8fd06b389(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 4.99L4 6h16zm0 12H4V8l8 5 8-5v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cbeb3525bc74f2ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f96f38b08083877f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9h-2.55V6h-2.9v3H8l4 4zm3-6H4.99C3.88 3 3 3.9 3 5v14c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-3h3.56c.69 1.19 1.97 2 3.45 2s2.75-.81 3.45-2H19v3zm0-5h-4.99c0 1.1-.9 2-2 2s-2-.9-2-2H5l-.01-9H19v9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3abdfa1b1e5c007(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18.5l4-4-4-4-1 1 3 3-3 3zM20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm10 15H4V9h16v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c878ba6093abe075(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac99618871826473(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 1.85-.51 3.65-1.38 5.21l-1.45-1.45a4.994 4.994 0 00-.64-6.29 5.003 5.003 0 00-7.07 0 5.003 5.003 0 000 7.07 5.006 5.006 0 006.29.64l1.72 1.72c-1.19 1.42-2.73 2.51-4.47 3.04-4.02-1.25-7-5.42-7-9.94V6.3l7-3.11 7 3.11V11zm-7 4c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2efaef4f80d7f89c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4v5c0 1.12.37 2.16 1 3H9c.65-.86 1-1.9 1-3V4h4m3-2H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3V4h1c.55 0 1-.45 1-1s-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dcdd1639948cc2f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16a8.002 8.002 0 017.6-5.5c1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8faa01cc4f25ec7f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2141bf06c80f0ec2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8c28c985ca8c5940(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13H5v-2h14v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3e1347be60d1bbf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$95f33f83a7da312c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$64cd952996fb1765(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v7h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b63564f471a4fe38(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.1 5h5.8L19 9.1v5.8l-.22.22 1.42 1.41.8-.8V8.27L15.73 3H8.27l-.8.8 1.41 1.42z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9.33V7h-2v.33zM2.41 1.58L1 2.99l3.64 3.64L3 8.27v7.46L8.27 21h7.46l1.64-1.64L21.01 23l1.41-1.41L2.41 1.58zM14.9 19H9.1L5 14.9V9.1l1.05-1.05 9.9 9.9L14.9 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$28bf9357827fcfb9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v7h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9d02e08065c4f45(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2a74e24f2649579b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.4V7l-4-4H5a2 2 0 00-2 2v14a2 2 0 002 2h7.4l2-2H5V5h11.17L19 7.83v6.57l2-2zM15 15c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zM6 6h9v4H6V6zm13.99 10.25l1.77 1.77L16.77 23H15v-1.77l4.99-4.98zm3.26.26l-.85.85-1.77-1.77.85-.85c.2-.2.51-.2.71 0l1.06 1.06c.2.2.2.52 0 .71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$10ba68fe670ff0f6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM6 6h9v4H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2d03eee5387f4bb7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7cbe0709c6b1645b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.01 6.03l7.51 3.22-7.52-1 .01-2.22m7.5 8.72L4 17.97v-2.22l7.51-1M2.01 3L2 10l15 2-15 2 .01 7L23 12 2.01 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ed265c8eab967c63(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ac171ecc42a971e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f7d91de82ad5da00(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 17.66l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L9.7 9.7l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L4 4v14c0 1.1.9 2 2 2h14l-2.34-2.34zM7 17v-5.76L12.76 17H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6ccb405ac78ddcae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h4v11H4zM4 4h4v4H4zM10 7h4v4h-4zM16 10h4v4h-4zM16 15h4v5h-4zM10 12h4v8h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4618f0b800439974(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "20",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.943 8.619l4.404-4.392 1.413 1.416-4.405 4.392zM8.32 9.68l.31.32 1.42-1.41-4.02-4.04h-.01l-.31-.32-1.42 1.41 4.02 4.05zM15.41 13.94L14 15.35l3.99 4.01.35.35 1.42-1.41-3.99-4.01zM8.59 13.95l-4.03 4.01-.32.33 1.41 1.41 4.03-4.02.33-.32z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bb7ee685a15db3a2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4h4zm-6 4h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$13ac994e24c17e10(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$747c78c649f1d19e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.83 1H5.42l.82-1zM5 19V8h14v11H5zm3-5h2.55v3h2.9v-3H16l-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$60c4a2c63767b144(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84429c58c833962b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6 10.81L16.19 9.4l3.56-3.55 1.41 1.41c-.11.03-3.56 3.55-3.56 3.55zM13 3h-2v5h2V3zm-6.6 7.81L7.81 9.4 4.26 5.84 2.84 7.26c.11.03 3.56 3.55 3.56 3.55zM20 14h-3.42c-.77 1.76-2.54 3-4.58 3s-3.81-1.24-4.58-3H4v5h16v-5m0-2c1.1 0 2 .9 2 2v5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-5c0-1.1.9-2 2-2h5c0 1.66 1.34 3 3 3s3-1.34 3-3h5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6af1fcb34f964c72(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16.99c-1.35 0-2.2.42-2.95.8-.65.33-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.95c1.35 0 2.2-.42 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.42 2.95-.8c.65-.33 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm0-4.45c-1.35 0-2.2.43-2.95.8-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.32-1.17.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm2.95-8.08c-.75-.38-1.58-.8-2.95-.8s-2.2.42-2.95.8c-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.37-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.93c1.35 0 2.2-.43 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V5.04c-.9 0-1.4-.25-2.05-.58zM17 8.09c-1.35 0-2.2.43-2.95.8-.65.35-1.15.6-2.05.6s-1.4-.25-2.05-.6c-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.35-1.15.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.32 1.18-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V9.49c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3b69dccd4a3fb79(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4v16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM13 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h9v16zM21 6v12c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7e456adc640e76c0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9V7c0-1.65-1.35-3-3-3H6C4.35 4 3 5.35 3 7v2c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3zM5 7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v2.78c-.61.55-1 1.34-1 2.22v2H6v-2c0-.88-.39-1.67-1-2.22V7zm17 10c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v4h16v-4c0-.55.45-1 1-1s1 .45 1 1v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bb4a58bc1915262(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1C7.59 1 4 4.59 4 9c0 5.57 6.96 13.34 7.26 13.67l.74.82.74-.82C13.04 22.34 20 14.57 20 9c0-4.41-3.59-8-8-8zm0 19.47C9.82 17.86 6 12.54 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 3.83-4.25 9.36-6 11.47zm-1.53-9.3L8.71 9.4l-1.42 1.42L10.47 14l6.01-6.01-1.41-1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4eb21e07ab64df03(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h4v10H6V9H4V7zm11.83 4.72L18.66 7h-2.33l-1.66 2.77L13 7h-2.33l2.83 4.72L10.33 17h2.33l2-3.34 2 3.34H19l-3.17-5.28z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4b1b25cfdaabf63f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5v3h6v2.5H3v3h5V16H2v3h6c1.66 0 3-1.34 3-3v-1.9A2.1 2.1 0 008.9 12 2.1 2.1 0 0011 9.9V8c0-1.66-1.34-3-3-3H2zm17 3v8h-4V8h4m0-3h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$63140ca63d32b620(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7v2h5v2H4v2h4v2H3v2h5c1.1 0 2-.9 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V9c0-1.1-.9-2-2-2H3zm18 4v4c0 1.1-.9 2-2 2h-5c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h5c1.1 0 2 .9 2 2h-7v6h5v-2h-2.5v-2H21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae1ca5f8bbf1d105(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H7v5H5V7H3v7h4v3h2v-3h2v-2H9V7zm8 4v2h2v2h-5V9h7c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a50b7f173b8ae64(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11v2h2v2h-4V9h6c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-4h-4zm11 0h-2V9h-2v2h-2v2h2v2h2v-2h2v-2zM7 7H5v5H3V7H1v7h4v3h2v-3h1v-2H7V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$522923e1e9dcc146(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8v8h-4V8h4m0-3h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3zm-9 3V5H5C3.34 5 2 6.34 2 8v8c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3v-3c0-1.66-1.34-3-3-3H5V8h5zm-2 5v3H5v-3h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3bf4179937f49d4e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f0201a61e7731f68(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4fb32c39dbe1e3b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm3.3 14.71L11 12.41V7h2v4.59l3.71 3.71-1.42 1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3214df912c7581ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6e55d1c7976c471c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7 4V3h10v1H7zm0 14V6h10v12H7zm0 3v-1h10v1H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7H8v2h8V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e1feff9421ea051b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9f44667cd435eb34(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1.01L8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM10 15h2V8H5v2h3.59L3 15.59 4.41 17 10 11.41V15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df28dc0de4383e29(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 17c0 1.65-1.35 3-3 3s-3-1.35-3-3h2c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1H2v-2h9.5c1.65 0 3 1.35 3 3zM19 6.5C19 4.57 17.43 3 15.5 3S12 4.57 12 6.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S16.33 8 15.5 8H2v2h13.5c1.93 0 3.5-1.57 3.5-3.5zm-.5 4.5H2v2h16.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5v2c1.93 0 3.5-1.57 3.5-3.5S20.43 11 18.5 11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3f8ea684c02da6a5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.19 4H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.81-2-1.81-2zM20 18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v12zM8.87 15.66l-1.66-2.88.93-.25 1.26.99 2.39-.64-2.4-4.16 1.4-.38 4.01 3.74 2.44-.65a.967.967 0 011.18.68.988.988 0 01-.69 1.19l-8.86 2.36z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f9c86cb6d14e6545(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da313c07c53df25d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 7.67V3.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V9l8.5 5v2l-4.49-1.32-7.01-7.01zm9.28 14.94l1.41-1.41-7.69-7.7-3.94-3.94-6.75-6.75-1.42 1.41 6.38 6.38L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-2.67l6.28 6.28z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$88904e14ac9cd8dc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1zm-9 6h8v1.5H8V10zm1 3h6v1.5H9V13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9d57763c062e0e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v14h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aec5af343253a519(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v12h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$34c2fa74a1321564(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v10h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$487e96dfc7bee57b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v8h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fbaecd27ffecfe8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v6h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ea0b7909cd1f9a00(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v4h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a72f59824b6a3268(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v2h6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$36945b6efd88496(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c61a7f810ff4356(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6794e46855b5475(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$335db74affabbf7d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h-2V2h-4v2H8c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 10h-2v2h-2v-2H9v-2h2v-2h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$74c0a3c960045b71(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e304d307464af39a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm1.3-5.31s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94A1.498 1.498 0 0012 9.5c-.83 0-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$97ae0bd2397ad97a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h6v2H9zM13 9h-2v2H9v2h2v2h2v-2h2v-2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zm0 18c-3.35 0-6-2.57-6-6.2 0-2.34 1.95-5.44 6-9.14 4.05 3.7 6 6.79 6 9.14 0 3.63-2.65 6.2-6 6.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$595dd7c46ef4baa8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6f1fb87d4f1f7e56(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dceaffc817979698(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17H4v-5h11v-2H4.81l1.04-3H15V5H5.5c-.66 0-1.21.42-1.42 1.01L2 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8h-2v5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3.85L19.15 1h-.5v3.79l-2.3-2.29-.7.7L18.44 6l-2.79 2.79.7.71 2.3-2.3V11h.5L22 8.14 19.85 6 22 3.85zm-2.35-.94l.94.94-.94.94V2.91zm.94 5.23l-.94.94V7.2l.94.94z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f973d03f2147fe31(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33s-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2a9.936 9.936 0 001.54-5.31c-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe71ab6a8914cacb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$21104f07de67b292(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L13 7h-2zm-.15 5.65L12 9l1.15 3.65h-2.3zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$991bc85cabd1d2c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d3a1be95f898d8e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$86c65d274dfc6580(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6v12c3.31 0 6-2.69 6-6s-2.69-6-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$22e742cfcc72e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5V4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1h-1v4c0 .55.45 1 1 1h1v7c0 1.1-.9 2-2 2s-2-.9-2-2V7c0-2.21-1.79-4-4-4S5 4.79 5 7v7H4c-.55 0-1 .45-1 1v4h1v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h1v-4c0-.55-.45-1-1-1H7V7c0-1.1.9-2 2-2s2 .9 2 2v10c0 2.21 1.79 4 4 4s4-1.79 4-4v-7h1c.55 0 1-.45 1-1V5h-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c52437c8cf599ca6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h-1l-1-1h-4L9 7H8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H8V9h1.83l1-1h2.34l1 1H16v6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.57.52L13.05 5l1.41-1.41-1.54-1.54C17.7 2.46 21.53 6.24 22 11h2C23.36 3.3 15.79-1.67 8.57.52zM9.54 20.41l1.54 1.54C6.3 21.54 2.47 17.76 2 13H0c.64 7.7 8.21 12.67 15.43 10.48L10.95 19l-1.41 1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91946d559c4231e8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h5v-2H4v-6h18V6c0-1.11-.89-2-2-2zm0 4H4V6h16v2zm-5.07 11.17l-2.83-2.83-1.41 1.41L14.93 22 22 14.93l-1.41-1.41-5.66 5.65z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5afe6511d0949b6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.37 5.51A7.35 7.35 0 009.1 7.5c0 4.08 3.32 7.4 7.4 7.4.68 0 1.35-.09 1.99-.27A7.014 7.014 0 0112 19c-3.86 0-7-3.14-7-7 0-2.93 1.81-5.45 4.37-6.49zM12 3a9 9 0 109 9c0-.46-.04-.92-.1-1.36a5.389 5.389 0 01-4.4 2.26 5.403 5.403 0 01-3.14-9.8c-.44-.06-.9-.1-1.36-.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2af15c92504d012b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0112 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a6f3f25e12c25fc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8v3H8v2h3v3h2v-3h3v-2h-3V8h-2zm2-5.95v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0112 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$69d716d115a08a90(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0112 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$97ab9e2616983613(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17h1.09c.28-1.67 1.24-3.1 2.6-4H7v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 19V5h14v7h1c.34 0 .67.04 1 .09V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h3.81c-.35-.61-.6-1.28-.72-2H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h4v4H7zM13 7h4v4h-4zM16 20h-2c-1.1 0-2-.9-2-2s.9-2 2-2h2v-2h-2c-2.21 0-4 1.79-4 4s1.79 4 4 4h2v-2zM20 14h-2v2h2c1.1 0 2 .9 2 2s-.9 2-2 2h-2v2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19v-2h-6v2h5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b2a98840d03543f4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13h4v4H7zM13 13h4v4h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h4v4H7zM13 7h4v4h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91ed7928c5f3ac89(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4678ca074dd84516(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-2V5c0-.55.45-1 1-1s1 .45 1 1v1h-1v1h1v2h-1v1h1v1h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ef1b3a5174161a66(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-3c0-1.44-1.47-2.4-2.79-1.84l-3 1.29C10.48 2.76 10 3.49 10 4.29V19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 13.68l-3 1.29V4.29L15 3v13.68zM20 19h-5.33l1.12-.48c.73-.32 1.21-1.04 1.21-1.84V5h3v14zM2 3h2v2H2zM2 19h2v2H2zM2 15h2v2H2zM2 11h2v2H2zM2 7h2v2H2zM6 3h2v2H6zM6 19h2v2H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$45c3d2f49cb440fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e51be63e4a521f7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.79 21L3 11.21v2c0 .53.21 1.04.59 1.41l7.79 7.79c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83L12.79 21z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.38 17.41c.39.39.9.59 1.41.59.51 0 1.02-.2 1.41-.59l6.21-6.21c.78-.78.78-2.05 0-2.83L12.62.58C12.25.21 11.74 0 11.21 0H5C3.9 0 3 .9 3 2v6.21c0 .53.21 1.04.59 1.41l7.79 7.79zM5 2h6.21L19 9.79 12.79 16 5 8.21V2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.25",
                    "cy": "4.25",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b0732800d6ab458f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.6-6-6-6zm3 7H9v-2h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f683e7748edda4f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4f6abbcd2b63027c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9V7H8v10h8v-2h-6v-2h6v-2h-6V9h6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19239f7b61a1f3f7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7h2v7H3V7zm-3 3h2v7H0v-7zm22-3h2v7h-2V7zm-3 3h2v7h-2v-7zm-3-7.99L8 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-1.99-2-1.99zM16 20H8v-1h8v1zm0-3H8V7h8v10zM8 5V4h8v1H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4a7305eb2b3eff82(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7h2v7H2V7zm18 3h2v7h-2v-7zm-4-7.99L8 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-1.99-2-1.99zM16 20H8v-1h8v1zm0-3H8V7h8v10zM8 5V4h8v1H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d01918d1debe8495(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22 8 10.83V22h8v-3.17l3.78 3.78 1.41-1.41L2.81 2.81zM14 20h-4v-7.17l4 4V20zM16 4v1H7.83l2 2H16v.39l-2 3.01v.77l2 2V11l2-3V2H6v1.17l.83.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bff1eb3ff94bda52(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6v6l2 3v11h8V11l2-3V2zm-2 2v1H8V4h8zm-2 6.4V20h-4v-9.61l-2-3V7h8v.39l-2 3.01z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee77f1e85994942c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h14V9H5v6zm2-4h10v2H7v-2zM11 2h2v3h-2zM17.286 6.399l1.79-1.803 1.42 1.41-1.79 1.802zM11 19h2v3h-2zM17.29 17.71l1.79 1.8 1.42-1.42-1.8-1.79zM3.495 6.01l1.407-1.408L6.69 6.391 5.284 7.798zM3.492 18.076l1.803-1.79 1.409 1.42-1.803 1.79z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8ed205a01618b7ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h14V9H5v6zm2-4h10v2H7v-2zM11 2h2v3h-2zM17.286 6.399l1.79-1.803 1.42 1.41-1.79 1.802zM11 19h2v3h-2zM17.29 17.71l1.79 1.8 1.42-1.42-1.8-1.79zM3.495 6.01l1.407-1.408L6.69 6.391 5.284 7.798zM3.492 18.076l1.803-1.79 1.409 1.42-1.803 1.79z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffb31c13c32fb350(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8C20 5.22 16.2 2 12 2zm0 17.33c-4.05-3.7-6-6.79-6-9.14C6 6.57 8.65 4 12 4s6 2.57 6 6.2c0 2.34-1.95 5.44-6 9.13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v5h-2zM11 13h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ff1670d54ddfb85a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$425f78f0d5b74ef3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11v2h2v2H9V9h7c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f606f079784d00be(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7zM9.91 8.5L8.5 9.91 10.59 12 8.5 14.09l1.41 1.41L12 13.42l2.09 2.08 1.41-1.41L13.42 12l2.08-2.09-1.41-1.41L12 10.59 9.91 8.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$988d189e53a5de96(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83V6.31l6-2.12 6 2.12v4.78zm-9.18-.5L7.4 12l3.54 3.54 5.66-5.66-1.41-1.41-4.24 4.24-2.13-2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ab99624173c68b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v2h-2zM11 7h2v5h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d9057c313862a24a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b5f1d63c59ab48e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6e3b4e3ac7d42920(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06c-.98.11-1.91.38-2.77.78l1.53 1.53a6.995 6.995 0 018.87 8.87l1.53 1.53c.4-.86.67-1.79.78-2.77H23v-2h-2.06zM3 4.27l2.04 2.04A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21l1.41-1.41L4.41 2.86 3 4.27zm13.27 13.27a6.995 6.995 0 01-9.81-9.81l9.81 9.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fd422e75975e30cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac25e3849f27f782(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4h4zm-6 4h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d737bbaf1b7a18a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7V5h-3V2h-2v3h-4V2h-2v3H7V2H5v3H2v2h3v4H2v2h3v4H2v2h3v3h2v-3h4v3h2v-3h4v3h2v-3h3v-2h-3v-4h3v-2h-3V7h3zM7 7h4v4H7V7zm0 10v-4h4v4H7zm10 0h-4v-4h4v4zm0-6h-4V7h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b427869ddca528a3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V9h-7V2h-2v7h-2V2H9v7H2v2h7v2H2v2h7v7h2v-7h2v7h2v-7h7v-2h-7v-2h7zm-9 2h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc781e2d6384f5c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11H9V7H7v10h2v-4h6v4h2V7h-2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fcf19952f2444bb0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11H6V7H4v10h2v-4h6v4h2V7h-2v4zm10 0h-2V9h-2v2h-2v2h2v2h2v-2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$74a5a33725ff5652(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16H6.5v6H10c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5H8v-3h2v3zM3.5 18h-2v-2H0v6h1.5v-2.5h2V22H5v-6H3.5zM22 18.5v-2h-1.5v2h-2V20h2v2H22v-2h2v-1.5zM16.5 16H13v6h1.5v-2h1.1l.9 2H18l-.9-2.1c.5-.3.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1zM11.97 5.3l-1.02 2.89h2.1L12.03 5.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.69 2 6 4.69 6 8s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm2.04 9l-.63-1.79h-2.83L9.96 11H8.74l2.63-7h1.25l2.63 7h-1.21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$78ce756777448149(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-.99-14L6.88 17h1.9l1-2.81h4.44l.99 2.81h1.9L12.98 6h-1.97zm-.66 6.59l1.6-4.55h.09l1.6 4.55h-3.29z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5b5c16c20d78c0fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18.5v-1c0-.8-.7-1.5-1.5-1.5H13v6h1.5v-2h1.1l.9 2H18l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2v-2H0v6h1.5v-2.5h2V22H5v-6H3.5v2zm6.5-2H6.5v6H10c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5H8v-3h2v3zm14-.5h-2v2h-1.5v-2h-2v-1.5h2v-2H22v2h2V20zM10.98 4.15L9.42 2.59c5.1-2.42 10.41 2.89 7.99 7.99l-1.56-1.56c.81-2.96-1.91-5.68-4.87-4.87zM6.34 2.34L4.93 3.76l1.66 1.66c-2.42 5.1 2.89 10.41 7.99 7.99l1.66 1.66 1.41-1.41L6.34 2.34zm1.81 4.64l4.87 4.87c-2.96.81-5.68-1.91-4.87-4.87z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$501e07c8ba10e093(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18.5v-1c0-.8-.7-1.5-1.5-1.5H13v6h1.5v-2h1.1l.9 2H18l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2v-2H0v6h1.5v-2.5h2V22H5v-6H3.5v2zm6.5-2H6.5v6H10c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5H8v-3h2v3zm14-.5h-2v2h-1.5v-2h-2v-1.5h2v-2H22v2h2V20zM12 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4m0-2C8.69 2 6 4.69 6 8s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d236fa25667dd6f5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 22h8v-7h-3v-4h-5V9h3V2H8v7h3v2H6v4H3v7h8v-7H8v-2h8v2h-3v7zM10 7V4h4v3h-4zM9 17v3H5v-3h4zm10 0v3h-4v-3h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$60ba6a390eba91c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d60d7da27356571b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58a.996.996 0 00-1.41 0 .996.996 0 000 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37a.996.996 0 00-1.41 0 .996.996 0 000 1.41l1.06 1.06c.39.39 1.03.39 1.41 0a.996.996 0 000-1.41l-1.06-1.06zm1.06-10.96a.996.996 0 000-1.41.996.996 0 00-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36a.996.996 0 000-1.41.996.996 0 00-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c6ddc0e3cb8b1341(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 13v-2h-2.06A8.994 8.994 0 0013 3.06V1h-2v2.06c-.98.11-1.91.38-2.77.78l1.53 1.53a6.995 6.995 0 018.87 8.87l1.53 1.53c.4-.86.67-1.79.78-2.77H23zM4.41 2.86L3 4.27l2.04 2.04A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21l1.41-1.41L4.41 2.86zM12 19A6.995 6.995 0 016.46 7.73l9.81 9.81A6.972 6.972 0 0112 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab4a33f3956a51ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a33ff3e80dc76558(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h3v2H4V8h2v6zm3-4h2v6h2v-6h2V8H9v2zm12 0V8h-5v8h5v-2h-3v-1h3v-2h-3v-1h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$32fe56608ceb76d6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h3v2H1V8h2v6zm2-4h2v6h2v-6h2V8H5v2zm7 6h5v-2h-3v-1h3v-2h-3v-1h3V8h-5v8zm12-5h-2V9h-2v2h-2v2h2v2h2v-2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$310d31f613d3cefc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.66 4.93c.24 0 .46.07.64.2l.81.56c-.29.24-.54.54-.72.87l1.66 1.66C11.03 8.14 11 8.08 11 8c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1c-.08 0-.14-.03-.22-.04l4.06 4.06a3.13 3.13 0 002.63-3.09c0-.71-.25-1.39-.67-1.93.43-.54.67-1.22.67-1.93a3.145 3.145 0 00-3.57-3.11C14.44 1.81 13.31 1 12 1s-2.44.81-2.91 1.96a3.132 3.132 0 00-2.52.78l1.42 1.42c.2-.13.42-.23.67-.23zm6.68 6.14c-.24 0-.46-.07-.64-.2l-.81-.57c.55-.45.94-1.09 1.06-1.83l.88.42c.4.19.66.59.66 1.03 0 .64-.52 1.15-1.15 1.15zm-.65-5.94c.2-.13.42-.2.65-.2.63 0 1.14.51 1.14 1.14 0 .44-.25.83-.66 1.03l-.88.42c-.12-.74-.51-1.38-1.07-1.83l.82-.56zM12 3c.62 0 1.12.49 1.14 1.1l-.11 1.09C12.71 5.07 12.36 5 12 5s-.7.07-1.02.19l-.12-1.09c.02-.61.52-1.1 1.14-1.1zM19.98 17.15A8.909 8.909 0 0021 13c-1.5 0-2.91.37-4.15 1.02l3.13 3.13zM3 13a9 9 0 009 9 9 9 0 00-9-9zm2.44 2.44c1.9.71 3.42 2.22 4.12 4.12a7.04 7.04 0 01-4.12-4.12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l4.42 4.42c-.19.4-.3.84-.3 1.29a3.147 3.147 0 003.58 3.11A3.15 3.15 0 0012 15c.05 0 .11-.01.16-.01l1.64 1.64A8.853 8.853 0 0012 22c2.02 0 3.88-.67 5.38-1.8l2.4 2.4 1.41-1.41L2.81 2.81zm11.63 16.75c.2-.54.47-1.04.79-1.5l.72.72c-.47.31-.97.58-1.51.78z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da5f84ebaf827a71(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6.17V3h6v4h-4v1.17l-2-2zM19.42 15L22 17.57l-.8.8-6.78-6.78.8-.8 2.75 2.75V9h.6L22 12.43 19.42 15zm-.25-1.45l1.13-1.13-1.13-1.13v2.26zm2.02 7.64l-1.41 1.41-3.98-3.98-.58.58-.85-.85.58-.58L11 13.83V17c0 2.21-1.78 4-3.99 4S3 19.21 3 17s1.79-4 4.01-4c.73 0 1.41.21 2 .55v-1.72L1.39 4.22 2.8 2.81l18.39 18.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$70faa56fb9e4e3f1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3l.01 10.55c-.6-.34-1.28-.55-2-.55a4.001 4.001 0 100 8C9.23 21 11 19.21 11 17V7h4V3H9zm12 9.43L17.57 9h-.6v4.55l-2.75-2.75-.85.85L16.73 15l-3.35 3.35.85.85 2.75-2.75V21h.6L21 17.57 18.42 15 21 12.43zm-2.83-1.13l1.13 1.13-1.13 1.13V11.3zm1.13 6.27l-1.13 1.13v-2.26l1.13 1.13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$47f8005cbdf5c9de(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h12v2H3zM2 21h14V6H2v15zm3-9h2.5V9.5h3V12H13v3h-2.5v2.5h-3V15H5v-3zM20 6c-1.68 0-3 1.76-3 4 0 1.77.83 3.22 2 3.76V21h2v-7.24c1.17-.54 2-1.99 2-3.76 0-2.24-1.32-4-3-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f4836c40a8cde2f0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 15H8v-3h2.5V9.5h3V12H16v3h-2.5v2.5h-3V15zM19 8v11c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2zm-2 0H7v11h10V8zm1-5H6v2h12V3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d091701025358778(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7.01 13.47l-2.55-2.55-1.27 1.27L7 16l7.19-7.19-1.27-1.27-5.91 5.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e4a57ff742f977ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v8.61l2 2V3c0-1.1-.9-2-2-2H7c-.71 0-1.33.37-1.68.93L8.39 5H17zM1.49 3.76L5 7.27V21c0 1.1.9 2 2 2h10c1.02 0 1.85-.77 1.98-1.75l1.72 1.72 1.41-1.41L2.9 2.35 1.49 3.76zM7 9.27L16.73 19H7V9.27z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1dc6c546d995ba0d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.82l1.59 1.59L19 7l-4-4-4 4 1.41 1.41L14 6.82v4.35l2 2zM1.39 4.22L8 10.83v6.35l-1.59-1.59L5 17l4 4 4-4-1.41-1.41L10 17.18v-4.35l9.78 9.78 1.41-1.42L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$35373ef39518d23f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 4c4.41 0 8 3.59 8 8s-3.59 8-8 8c-.34 0-.68-.02-1.01-.07 1.91-2.16 3.01-4.98 3.01-7.93s-1.1-5.77-3.01-7.93C8.82 4.02 9.16 4 9.5 4m0-2c-1.82 0-3.53.5-5 1.35 2.99 1.73 5 4.95 5 8.65s-2.01 6.92-5 8.65c1.47.85 3.18 1.35 5 1.35 5.52 0 10-4.48 10-10S15.02 2 9.5 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8bae207d8fde7661(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$66145e0eb37ff6c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v3h2V6h16v3h2V6c0-1.1-.9-2-2-2zM20 18H4v-3H2v3c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-3h-2v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.89 7.55c-.34-.68-1.45-.68-1.79 0L10 13.76l-1.11-2.21A.988.988 0 008 11H2v2h5.38l1.72 3.45c.18.34.52.55.9.55s.72-.21.89-.55L14 10.24l1.11 2.21c.17.34.51.55.89.55h6v-2h-5.38l-1.73-3.45z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$465b5d153086bc3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM12 6c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm-1 3.5h-1v-1h1v1zm1.5 0h-1v-1h1v1zm1.5 0h-1v-1h1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a956c3e4f4782b85(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.57l4.42 4.42L12 16.41l-4.42-4.42L12 7.57zm0 11.62l-7.2-7.2 7.2-7.2 6 6V7.16l-4.58-4.58c-.78-.78-2.05-.78-2.83 0l-8.01 8c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0L18 16.82v-3.63l-6 6zm8 .81h2v2h-2v-2zm2-10h-2v8h2v-8"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f898b8fa6a5ba9ef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 13.42L18.83 16l-1.81-1.81L19.2 12 12 4.8 9.81 6.99 8 5.17l2.58-2.58c.78-.78 2.05-.78 2.83 0l8 8c.79.78.79 2.04 0 2.83zm-.22 7.77l-1.41 1.41L16 18.83l-2.58 2.58c-.78.78-2.05.78-2.83 0l-8-8c-.78-.78-.78-2.05 0-2.83L5.17 8 1.39 4.22 2.8 2.81l18.39 18.38zm-7-4.17l-1.39-1.39-.8.8L7.58 12l.8-.8-1.4-1.39L4.8 12l7.2 7.2 2.19-2.18zM16.42 12L12 7.58l-.8.8 4.42 4.42.8-.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d364517c8884d0b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20V2L2 22zm18-2h-3V9.83l3-3V20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c59f5391b8c5464d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zm3.32 10.84C14.34 14.3 13.2 14 12 14c-1.2 0-2.34.3-3.32.84L2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-5.76 5.77z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d9c61988f60266b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zm4.78 9.38A8.853 8.853 0 0012 12c-1.76 0-3.4.5-4.78 1.38l-4.3-4.3C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-4.3 4.31z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$31a060ab7542c016(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zM2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-2.85 2.86A10.945 10.945 0 0012 10c-2.31 0-4.46.71-6.23 1.93L2.92 9.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3600513e1d18d87(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zm0 4c-2.86 0-5.5.94-7.65 2.51L2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-1.43 1.43A12.99 12.99 0 0012 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d657e1386c40e95(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3ebad221fb99c063(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4c.34 0 .68.02 1.01.07C13.1 6.23 12 9.05 12 12s1.1 5.77 3.01 7.93c-.33.05-.67.07-1.01.07-4.41 0-8-3.59-8-8s3.59-8 8-8m0-2C8.48 2 4 6.48 4 12s4.48 10 10 10c1.82 0 3.53-.5 5-1.35-2.99-1.73-5-4.95-5-8.65s2.01-6.92 5-8.65A9.973 9.973 0 0014 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$432986f6bbde3b97(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.08 11.03l-2.12-2.12L7 14.86V17h2.1zM16.85 9.27c.2-.2.2-.51 0-.71l-1.41-1.41c-.2-.2-.51-.2-.71 0l-1.06 1.06 2.12 2.12 1.06-1.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9059854ebae65b3e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17h20v2H2v-2zm1.15-4.05L4 11.47l.85 1.48 1.3-.75-.85-1.48H7v-1.5H5.3l.85-1.47L4.85 7 4 8.47 3.15 7l-1.3.75.85 1.47H1v1.5h1.7l-.85 1.48 1.3.75zm6.7-.75l1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H15v-1.5h-1.7l.85-1.47-1.3-.75L12 8.47 11.15 7l-1.3.75.85 1.47H9v1.5h1.7l-.85 1.48zM23 9.22h-1.7l.85-1.47-1.3-.75L20 8.47 19.15 7l-1.3.75.85 1.47H17v1.5h1.7l-.85 1.48 1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H23v-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1fe2b983d4121b42(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm2 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-.02 6c-.74 0-1.37.4-1.72 1h-2.54a1.98 1.98 0 00-3.44 0H8.41l3.07-3.07c.17.04.34.07.52.07 1.1 0 2-.9 2-2 0-.18-.03-.35-.07-.51l3.56-3.56c.16.04.33.07.51.07 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .18.03.35.07.51l-3.56 3.56c-.16-.04-.33-.07-.51-.07-1.1 0-2 .9-2 2 0 .18.03.35.07.51l-3.56 3.56C6.35 16.03 6.18 16 6 16c-1.1 0-2 .9-2 2s.9 2 2 2c.74 0 1.37-.4 1.72-1h2.57a1.98 1.98 0 003.44 0h2.55c.34.6.98 1 1.72 1 1.1 0 2-.9 2-2-.02-1.1-.92-2-2.02-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a736ab7449f2aab(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6.18V2h-2v4.18C13.84 6.6 13 7.7 13 9s.84 2.4 2 2.82V15c0 2.21-1.79 4-4 4s-4-1.79-4-4v-1.17l1.59 1.59L10 14 5 9v6c0 3.31 2.69 6 6 6s6-2.69 6-6v-3.18c1.16-.41 2-1.51 2-2.82s-.84-2.4-2-2.82zM16 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4c07196a3b4a8b76(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.49 10.5V15h1.15V9h-.87l-1.76 1.27.58.89zM11.47 10.05c.5 0 .81.32.81.72 0 .37-.14.64-.54 1.06-.36.38-1.06 1.08-2.13 2.15V15h3.89v-.99h-2.37l-.03-.05c.68-.68 1.15-1.14 1.4-1.39.61-.6.92-1.22.92-1.86 0-.24-.05-1.04-.91-1.48-.47-.23-1.26-.36-1.95-.03-.82.39-.99 1.13-1 1.15l1.01.42c.1-.33.38-.72.9-.72zM16.99 13.94c-.83 0-.99-.76-1.02-.86l-1.03.41c.45 1.59 2.01 1.51 2.05 1.51 1.2 0 1.68-.72 1.76-.85.32-.49.36-1.24-.01-1.76-.17-.24-.4-.41-.68-.52v-.07c.2-.1.37-.26.52-.48.26-.41.31-1.07-.02-1.57-.08-.11-.53-.75-1.62-.75-1.26 0-1.74.9-1.85 1.24l.99.41c.11-.32.35-.64.85-.64.44 0 .75.26.75.65 0 .58-.55.72-.88.72h-.46v1h.5c.56 0 1.04.24 1.04.79 0 .49-.48.77-.89.77z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$82242f92e9234779(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20V4h2v7l2.5-1.5L12 11V4h5v7.08c.33-.05.66-.08 1-.08s.67.03 1 .08V4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h7.26c-.42-.6-.75-1.28-.97-2H5zm13-7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm-1.25 7.5v-5l4 2.5-4 2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a060fdc06fda6824(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1H8v-1h4V8h-2V7H8v1H7c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H6v2h2v1zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12zm-6-8l2-2 2 2m0 4.25l-2 2-2-2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3dbc7215bc0bfa92(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13V9c0-.55-.45-1-1-1H6V6h5V4H8.5V3h-2v1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4v2H4v2h2.5v1h2v-1H10c.55 0 1-.45 1-1zM19.59 12.52l-5.66 5.65-2.83-2.83-1.41 1.42L13.93 21 21 13.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3a26886e0d5bbc41(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6h-1V1H6v5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM8 3h8v3H8V3zm11 17H5V8h14v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 11.5h-1v2.71l1.64 1.64.71-.71-1.35-1.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$48a1042998a0e40c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-6.49-5.84c.41-.73 1.18-1.16 1.63-1.8.48-.68.21-1.94-1.14-1.94-.88 0-1.32.67-1.5 1.23l-1.37-.57C11.51 5.96 12.52 5 13.99 5c1.23 0 2.08.56 2.51 1.26.37.6.58 1.73.01 2.57-.63.93-1.23 1.21-1.56 1.81-.13.24-.18.4-.18 1.18h-1.52c.01-.41-.06-1.08.26-1.66zm-.56 3.79c0-.59.47-1.04 1.05-1.04.59 0 1.04.45 1.04 1.04 0 .58-.44 1.05-1.04 1.05-.58 0-1.05-.47-1.05-1.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9cf2455efe5eb8db(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.8 7.2L9 10H7L5.87 7.33H4V10H2V2h5c1.13 0 2 .87 2 2v1.33c0 .8-.53 1.54-1.2 1.87zM7 4H4v1.33h3V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d9db081e36c90898(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.74 18.33A9.984 9.984 0 0022 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10a9.984 9.984 0 007.11-2.97c.03-.03.05-.06.07-.08.2-.2.39-.41.56-.62zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8c0 1.85-.63 3.54-1.69 4.9l-1.43-1.43c.69-.98 1.1-2.17 1.1-3.46 0-3.31-2.69-6-6-6s-6 2.69-6 6 2.69 6 6 6c1.3 0 2.51-.42 3.49-1.13l1.42 1.42A7.822 7.822 0 0112 20zm1.92-7.49c.17-.66.02-1.38-.49-1.9l-.02-.02c-.77-.77-2-.78-2.78-.04-.01.01-.03.02-.05.04-.78.78-.78 2.05 0 2.83l.02.02c.52.51 1.25.67 1.91.49l1.51 1.51c-.6.36-1.29.58-2.04.58-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4c0 .73-.21 1.41-.56 2l-1.5-1.51z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3084b60e2221f32a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 20H7v-1h10v1zm0-3H7v-.48c1.47-.99 3.22-1.52 5-1.52s3.53.53 5 1.52V18zm0-2.79c-1.5-.77-3.2-1.21-5-1.21s-3.5.44-5 1.21V6h10v9.21zM17 4H7V3h10v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9c922949b3a5a068(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v2h8v-2h4c1.1 0 1.99-.9 1.99-2v-5H22c0-1.1-.9-2-2-2h-7.17l1.83-1.83-1.41-1.41C9.69 10.31 10.88 9.12 9 11l4.24 4.24 1.41-1.41L12.83 12H20v5H4V5h16v3h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc17d7ff072ebbc2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c0-1.65.67-3.15 1.76-4.24L6.34 7.34A8.014 8.014 0 004 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91zm14 0c0-4.42-3.58-8-8-8-.06 0-.12.01-.18.01l1.09-1.09L11.5 2.5 8 6l3.5 3.5 1.41-1.41-1.08-1.08c.06 0 .12-.01.17-.01 3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9483fcd92437d605(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15l1.57-3.43L17 10l-3.43-1.57L12 5l-1.57 3.43L7 10l3.43 1.57z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa7c0c3c9ed09ee6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9h1.5l-1.75 6h-1.5L12.5 9H14l1 3.43L16 9zM5.1 12.9L6 15H4.5l-.85-2H2.5v2H1V9h3.5c.85 0 1.5.65 1.5 1.5v1c0 .6-.4 1.15-.9 1.4zm-.6-2.4h-2v1h2v-1zm17 2.5h-2v2H18V9h3.5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5zm0-2.5h-2v1h2v-1zM11.5 9v1.5h-3v.75h2c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H7v-1.5h3v-.75H7.75c-.41 0-.75-.34-.75-.75v-2c0-.55.45-1 1-1h3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a75f11d2bb61246e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1a2 2 0 10-4 0v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe4de74227ff6ab2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1a2 2 0 10-4 0v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa1dfb8d6e0d5d5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.3 13.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L3.56 9.17l5.66-5.66 2.1 2.1 1.41-1.41-2.45-2.45a1.49 1.49 0 00-2.12 0L1.8 8.11a1.49 1.49 0 000 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM7.52 21.48A10.487 10.487 0 011.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.82-1.33 1.33zM15.05 10h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1v-.5a2.5 2.5 0 00-5 0V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4h-3.4v-.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f23e0ec7caaea7e4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77a1.49 1.49 0 00-2.12 0L1.75 8.11a1.49 1.49 0 000 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29A10.487 10.487 0 011.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d88f3d99e3196e3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h16c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2zM4 5h16v11H4V5zM1 19h22v2H1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.97 7.53c-1.37-1.37-3.58-1.37-4.95 0s-1.37 3.58 0 4.95c1.18 1.18 3 1.34 4.36.47l2.09 2.09 1.06-1.06-2.09-2.09c.87-1.36.72-3.18-.47-4.36zm-1.06 3.88c-.78.78-2.05.78-2.83 0-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0c.78.79.78 2.05 0 2.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c5722c726cc440c7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h4v2h8v-2h4c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 14H4V5h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 7.5H9V6H5v4h1.5zM19 12h-1.5v2.5H15V16h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$45523341573094f1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1zM9.5 8.5H12V7H8v4h1.5V8.5zM12 17h4v-4h-1.5v2.5H12V17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4686e16e5fe58b19(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4v16H6V8.83L10.83 4H18m0-2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 7h2v4H9zm3 0h2v4h-2zm3 0h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$790b4abe984089d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1zm-1 6.05l-1.41-1.41-3.54 3.54-1.41-1.41-1.41 1.41L11.05 15 16 10.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bd263314325d4dd8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zM11 7h2v6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bf4ce2847fc41f57(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zM7 4V3h10v1H7zm9 8l-4 4-4-4 1.41-1.41L11 12.17V8h2v4.17l1.59-1.59L16 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$21ae33b382e196e6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 11.41l-8.83-8.83c-.37-.37-.88-.58-1.41-.58H4c-1.1 0-2 .9-2 2v7.17c0 .53.21 1.04.59 1.41l8.83 8.83c.78.78 2.05.78 2.83 0l7.17-7.17c.78-.78.78-2.04-.01-2.83zM12.83 20L4 11.17V4h7.17L20 12.83 12.83 20z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bf9ca92be8a10de2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8l4 4-4 4-1.41-1.41L18.17 13H13v-2h5.17l-1.59-1.59L18 8zM7 1.01L17 1c1.1 0 2 .9 2 2v4h-2V6H7v12h10v-1h2v4c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-1.99 2-1.99zM7 21h10v-1H7v1zM7 4h10V3H7v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a5c7af7168304556(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m0-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm8.5-2l1.09-2.41L22 5.5l-2.41-1.09L18.5 2l-1.09 2.41L15 5.5l2.41 1.09L18.5 9zm2.78 3.72L20.5 11l-.78 1.72-1.72.78 1.72.78.78 1.72.78-1.72L23 13.5l-1.72-.78zM16.25 14c0-.12 0-.25-.01-.37l1.94-1.47-2.5-4.33-2.24.94c-.2-.13-.42-.26-.64-.37L12.5 6h-5l-.3 2.41c-.22.11-.43.24-.64.37l-2.24-.95-2.5 4.33 1.94 1.47c-.01.12-.01.25-.01.37s0 .25.01.37l-1.94 1.47 2.5 4.33 2.24-.94c.2.13.42.26.64.37l.3 2.4h5l.3-2.41c.22-.11.43-.23.64-.37l2.24.94 2.5-4.33-1.94-1.47c.01-.11.01-.24.01-.36zm-1.42 3.64l-1.73-.73c-.56.6-1.3 1.04-2.13 1.23L10.73 20H9.27l-.23-1.86c-.83-.19-1.57-.63-2.13-1.23l-1.73.73-.73-1.27 1.49-1.13c-.12-.39-.18-.8-.18-1.23 0-.43.06-.84.18-1.23l-1.49-1.13.73-1.27 1.73.73c.56-.6 1.3-1.04 2.13-1.23L9.27 8h1.47l.23 1.86c.83.19 1.57.63 2.13 1.23l1.73-.73.73 1.27-1.49 1.13c.12.39.18.8.18 1.23 0 .43-.06.84-.18 1.23l1.49 1.13-.73 1.29z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b96a277c78ba3cc2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 17H9c-2.21 0-4-1.79-4-4a3.98 3.98 0 013.22-3.92A4.514 4.514 0 0112 7c1.95 0 3.66 1.28 4.26 3.09 1.58.36 2.74 1.75 2.74 3.41 0 1.93-1.57 3.5-3.5 3.5zm-6.76-5.98C7.74 11.15 7 11.99 7 13c0 1.1.9 2 2 2h6.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.87l-.17-.86A2.496 2.496 0 0012 9c-.96 0-1.84.57-2.26 1.45l-.27.57h-.73zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$501fb34b7f608756(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.02 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.42-1.43a7.941 7.941 0 01-3.9 1.62zM4.03 12c0-4.05 3.03-7.41 6.95-7.93V2.05C5.95 2.58 2.03 6.84 2.03 12c0 5.16 3.92 9.42 8.95 9.95v-2.02c-3.92-.52-6.95-3.88-6.95-7.93zM19.95 11h2.02c-.2-2.01-1-3.84-2.21-5.32l-1.43 1.43c.86 1.1 1.44 2.43 1.62 3.89zM18.34 4.26a9.981 9.981 0 00-5.32-2.21v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM18.33 16.9l1.43 1.42A9.949 9.949 0 0021.97 13h-2.02a7.941 7.941 0 01-1.62 3.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11.1C16 8.61 14.1 7 12 7s-4 1.61-4 4.1c0 1.66 1.33 3.63 4 5.9 2.67-2.27 4-4.24 4-5.9zm-4 .9a1.071 1.071 0 010-2.14A1.071 1.071 0 0112 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$72fd2f5216d9cc0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5l-1.41 1.41L15 7.83 17.17 10H8c-2.76 0-5 2.24-5 5v4h2v-4c0-1.65 1.35-3 3-3h9.17L15 14.17l-1.41 1.41L15 17l6-6-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fcca36727bff2b39(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20V2L2 22zm18-2H6.83L20 6.83V20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$13d7842bb1a58e48(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20V2L2 22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$279ad7613240dda8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14h3v6H5v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$657b5555c380964b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14h3v6H5v-6zm6-5h3v11h-3V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2b49f39c00edcf24(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4h3v16h-3V4zM5 14h3v6H5v-6zm6-5h3v11h-3V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ecdf2eadb38a922(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zm-2-2v2H2L22 2v6h-2V6.83L6.83 20H18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1fe28318dbfcbf72(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$69d68d300ad82968(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.83 5H17v9.11l2 2V5c0-1.1-.9-2-2-2h-7L7.94 5.06l1.42 1.42L10.83 5zm10.43 16.21L3.79 3.74 2.38 5.15 5 7.77V19a2 2 0 002 2h11.23l1.62 1.62 1.41-1.41zM7 19V9.79L16.23 19H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$227db2ea181ab683(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13h-9v9H2L22 2v11zm-1 2.41L19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1fc15684efaeaa82(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c641aa6c3c84678(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1l-8.31 8.31 8.31 8.3zM4.91 4.36L3.5 5.77l6.36 6.37L1 21h17.73l2 2 1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b70ae639ff573a88(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zM2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07L12 18.17l-9.08-9.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b6bc0a082a05d5af(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.98 11L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36L12 21l3.05-3.05V15c0-.45.09-.88.23-1.29.54-1.57 2.01-2.71 3.77-2.71h2.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$61ce6539ab459d5b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$78ea0fdf70d89d61(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21v-9h8.99L24 8.98zM19.59 14l-2.09 2.09-.3-.3L15.41 14 14 15.41l1.79 1.79.3.3L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41 19.59 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d8665f21cce496b9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21v-9h8.99L24 8.98zM19.59 14l-2.09 2.09-.3-.3L15.41 14 14 15.41l1.79 1.79.3.3L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41 19.59 14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c419dddea75fb33e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.64 7c-.45-.34-4.93-4-11.64-4-1.32 0-2.55.14-3.69.38L18.43 13.5 23.64 7zM3.41 1.31L2 2.72l2.05 2.05C1.91 5.76.59 6.82.36 7L12 21.5l3.91-4.87 3.32 3.32 1.41-1.41L3.41 1.31z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$51649bd868f7b941(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6531b3fc8736f341(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21l5-5.01V8h5.92C19.97 5.51 16.16 4 12 4zM19 18h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$470d5fe9cf0a6fc9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zM2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07L12 18.17l-9.08-9.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$75fa6c46f3df9358(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v16H6V8.83L10.83 4H18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13l-4 4-4-4 1.41-1.41L11 13.17V9.02L13 9v4.17l1.59-1.59L16 13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e2703e5aefc3bcff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4v5H6V4h12m0-2H6c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 13v5H6v-5h12m0-2H6c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a916db83519e32(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6H9V4h2v2zm4-2h-2v2h2V4zM9 14h2v-2H9v2zm10-4V8h-2v2h2zm0 4v-2h-2v2h2zm-6 0h2v-2h-2v2zm6-10h-2v2h2V4zm-6 4V6h-2v2h2zm-6 2V8h2V6H7V4H5v16h2v-8h2v-2H7zm8 2h2v-2h-2v2zm-4-2v2h2v-2h-2zM9 8v2h2V8H9zm4 2h2V8h-2v2zm2-4v2h2V6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c5091e017980fc7d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5.47L12 12 7.62 7.62 3 11V8.52L7.83 5l4.38 4.38L21 3v2.47zM21 15h-4.7l-4.17 3.34L6 12.41l-3 2.13V17l2.8-2 6.2 6 5-4h4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3f0c8fa41929d6fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd8f63fa5343e18(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.93 8C16.72 4.18 11.82 2.87 8 5.07c-1.41.82-2.48 2-3.16 3.37-.13-2.2.22-4.4 1.02-6.44H3.74C2.2 6.49 2.52 11.58 5.07 16a7.96 7.96 0 004.86 3.72c1.98.53 4.16.31 6.07-.79 1.41-.82 2.48-2 3.16-3.37.13 2.2-.21 4.4-1.01 6.44h2.11c1.53-4.49 1.22-9.58-1.33-14zM15 17.2A6.012 6.012 0 016.8 15c-.11-.2-.21-.4-.3-.6-1.2-2.76-.17-6.06 2.5-7.6 2.86-1.65 6.54-.67 8.2 2.2.11.2.21.4.3.6 1.2 2.76.17 6.06-2.5 7.6zM12 10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fd1eb098fd2d1256(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V9l-6-6zM5 19V5h9v5h5v9H5zM9 8c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm0 4c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm0 4c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffe247773142533a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1zm-1 6.05l-1.41-1.41-3.54 3.54-1.41-1.41-1.41 1.41L11.05 15 16 10.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1fe4cedbec69d96b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zM11 7h2v6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$21fda70fbce59494(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zM7 4V3h10v1H7zm9 8l-4 4-4-4 1.41-1.41L11 12.17V8h2v4.17l1.59-1.59L16 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16495ec4722d7a5e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zm-9.18-6.95L7.4 14.46 10.94 18l5.66-5.66-1.41-1.41-4.24 4.24-2.13-2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$47d04466fbbf47c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-8c0-.55.45-1 1-1s1 .45 1 1h-1v1h1v2h-1v1h1v2h-2V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aef478f051bda0ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8v8h-3V8h3m0-3h-3C8.34 5 7 6.34 7 8v8c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3zM1 8h2v11h3V5H1v3zm17.5 3c-.83 0-1.5.68-1.5 1.5v2c0 .82.67 1.5 1.5 1.5H21v1h-4v2h4.5c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H19v-1h4v-2h-4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$32d6d70880805a0c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11v2h-4v1h2.5c.83 0 1.5.68 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5H15v-2h4v-1h-2.5c-.82 0-1.5-.68-1.5-1.5v-2c0-.82.68-1.5 1.5-1.5H21zM4 5v3h6v2.5H4v3h6V16H4v3h6c1.66 0 3-1.34 3-3v-1.9a2.1 2.1 0 00-2.1-2.1A2.1 2.1 0 0013 9.9V8c0-1.66-1.34-3-3-3H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$777dca6cfa82bd7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19h2v3h-2zM2 11h3v2H2zM19 11h3v2h-3zM15.894 17.801l1.407-1.407 2.122 2.122-1.408 1.407zM4.584 18.509l2.121-2.122 1.408 1.407-2.122 2.122zM15 8.02V3H9v5.02c-1.21.92-2 2.35-2 3.98 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.06-2-3.98zM11 5h2v2.1c-.32-.06-.66-.1-1-.1s-.68.04-1 .1V5zm1 10c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$799761f162373c99(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8h4v4h-1v2c0 .34-.08.66-.23.94L16 13.17V12h-1V8zm-4 .17l2 2V6h2l-3-4-3 4h2v2.17zM13 16v2.28c.6.34 1 .98 1 1.72 0 1.1-.9 2-2 2s-2-.9-2-2c0-.74.4-1.37 1-1.72V16H8c-1.11 0-2-.89-2-2v-2.28c-.6-.34-1-.98-1-1.72 0-.59.26-1.13.68-1.49L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-6.6-6.6H13zm-2-2v-.17l-2.51-2.51c-.14.16-.31.29-.49.4V14h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1023f37f621b6a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2S4.8 7.79 4.8 9c0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95a2.2 2.2 0 004.4 0c0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$afcb28e593663017(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a623ddd0e2c95cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.98 14H22h-.02zM5.35 13c1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.31 1v-2c-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1zm13.32 2c-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.1 1-3.34 1-1.24 0-1.38-1-3.33-1-1.95 0-2.1 1-3.34 1v2c1.95 0 2.11-1 3.34-1 1.24 0 1.38 1 3.33 1 1.95 0 2.1-1 3.34-1 1.19 0 1.42 1 3.33 1 1.94 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1v-2c-1.24 0-1.38-1-3.33-1zM5.35 9c1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.31 1V8c-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1C3.38 7 3.24 8 2 8v2c1.9 0 2.17-1 3.35-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$867141a0e71dac88(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.66 4.52l2.83 2.83-2.83 2.83-2.83-2.83 2.83-2.83M9 5v4H5V5h4m10 10v4h-4v-4h4M9 15v4H5v-4h4m7.66-13.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65zM11 3H3v8h8V3zm10 10h-8v8h8v-8zm-10 0H3v8h8v-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4ecff7b03f7e255b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.53 17.46L12 21l-3.53-3.54c.9-.9 2.15-1.46 3.53-1.46s2.63.56 3.53 1.46z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bae1563c613400e9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c3.03 0 5.78 1.23 7.76 3.22l-2.12 2.12A7.967 7.967 0 0012 13c-2.2 0-4.2.9-5.64 2.35l-2.12-2.12C6.22 11.23 8.97 10 12 10zm0 6c-1.38 0-2.63.56-3.53 1.46L12 21l3.53-3.54A4.98 4.98 0 0012 16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$be58025fd9ce4fb9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 4.5c1.79 0 3.42.73 4.59 1.91l1.06-1.06A7.94 7.94 0 0016.49 3c-2.21 0-4.21.9-5.66 2.34l1.06 1.06a6.545 6.545 0 014.6-1.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 6c-1.38 0-2.63.56-3.54 1.46l1.06 1.06c.63-.63 1.51-1.03 2.47-1.03s1.84.39 2.47 1.03l1.06-1.06A4.94 4.94 0 0016.49 6zM16.49 9c-.55 0-1.05.22-1.41.59L16.49 11l1.41-1.41c-.36-.37-.86-.59-1.41-.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2 14.87l-3.67-.73c-.5-.1-.83.2-.9.27l-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.55.03 1.03-.43 1.03-1v-4.15c0-.48-.34-.89-.8-.98zM5.1 5h2.23l.47 2.35L6.17 9c-.54-1.3-.9-2.63-1.07-4zM19 18.9c-1.37-.18-2.7-.53-4-1.07l1.65-1.63 2.35.47v2.23z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f27e1efb9ba25162(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3c-2.51 0-3.77 5.61-4.4 10.57C10.79 10.66 9.61 8 8 8 4.43 8 3 21 3 21h2.01c.61-5.27 2-9.82 2.99-10.87.98 1.05 2.38 5.61 2.99 10.87H13c.5-2.53 2-6 3-6s2.5 3.53 3 6h2s-.5-18-5-18zm0 10c-.99 0-1.82.62-2.5 1.5.57-4.77 1.54-8.62 2.5-9.44.97.81 1.91 4.67 2.49 9.43C17.81 13.62 16.98 13 16 13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$81f52561f067d74a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c4.14 0 7.88 1.68 10.59 4.39L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21l1.41-1.42L2.93 9.08C5.45 7.16 8.59 6 12 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14c0-2.24-1.76-4-4-4s-4 1.76-4 4 1.76 4 4 4c.75 0 1.44-.21 2.03-.56L21.59 20 23 18.59l-2.56-2.56c.35-.59.56-1.28.56-2.03zm-4 2c-1.12 0-2-.88-2-2s.88-2 2-2 2 .88 2 2-.88 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16846218d8f295e6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.98 11L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36L12 21l3.05-3.05V15c0-.45.09-.88.23-1.29.54-1.57 2.01-2.71 3.77-2.71h2.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4ac20877b2de3c20(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 8.98l-2.12 2.13C19.35 8.57 15.85 7 12 7s-7.35 1.57-9.88 4.11L0 8.98C3.07 5.9 7.31 4 12 4s8.93 1.9 12 4.98zM4.24 13.22l2.12 2.12A7.967 7.967 0 0112 13c2.2 0 4.2.9 5.64 2.35l2.12-2.12C17.78 11.23 15.03 10 12 10c-3.03 0-5.78 1.23-7.76 3.22zM24 20v3c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1v-1c0-1.1.9-2 2-2s2 .9 2 2v1c.55 0 1 .45 1 1zm-2-2c0-.55-.45-1-1-1s-1 .45-1 1v1h2v-1zm-10-2c-1.38 0-2.63.56-3.53 1.46L12 21l3.53-3.54A4.98 4.98 0 0012 16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cf34e1edbd98089c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-3.31 0-6 2.69-6 6 0 1.66.68 3.15 1.76 4.24l1.42-1.42A3.934 3.934 0 018 13c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.11-.45 2.1-1.18 2.82l1.42 1.42A6.003 6.003 0 0018 13c0-3.31-2.69-6-6-6zm0-4C6.48 3 2 7.48 2 13c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42A7.94 7.94 0 014 13c0-4.42 3.58-8 8-8 2.53 0 4.78 1.17 6.24 3h2.42C18.93 5.01 15.7 3 12 3zm0 8c-1.1 0-2 .9-2 2 0 .55.23 1.05.59 1.41.36.36.86.59 1.41.59s1.05-.23 1.41-.59c.36-.36.59-.86.59-1.41 0-1.1-.9-2-2-2zm8-1h2v6h-2v-6zm0 8h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c73798261e9c1785(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-3.31 0-6 2.69-6 6 0 1.66.68 3.15 1.76 4.24l1.42-1.42A3.934 3.934 0 018 13c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.11-.45 2.1-1.18 2.82l1.42 1.42A6.003 6.003 0 0018 13c0-3.31-2.69-6-6-6zm0-4C6.48 3 2 7.48 2 13c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42A7.94 7.94 0 014 13c0-4.42 3.58-8 8-8 2.53 0 4.78 1.17 6.24 3h2.42C18.93 5.01 15.7 3 12 3zm0 8c-1.1 0-2 .9-2 2 0 .55.23 1.05.59 1.41.36.36.86.59 1.41.59s1.05-.23 1.41-.59c.36-.36.59-.86.59-1.41 0-1.1-.9-2-2-2zm8-1h2v6h-2v-6zm0 8h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$344bbd7e56c4703b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l2.69 2.69A9.958 9.958 0 002 13c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42a7.957 7.957 0 01-.84-10.31l1.43 1.43a6.003 6.003 0 00.82 7.47l1.42-1.42A3.934 3.934 0 018 13c0-.63.15-1.23.41-1.76l1.61 1.61c0 .05-.02.1-.02.15 0 .55.23 1.05.59 1.41.36.36.86.59 1.41.59.05 0 .1-.01.16-.02l7.62 7.62 1.41-1.41L2.81 2.81zM17.7 14.87c.19-.59.3-1.22.3-1.87 0-3.31-2.69-6-6-6-.65 0-1.28.1-1.87.3l1.71 1.71C11.89 9 11.95 9 12 9c2.21 0 4 1.79 4 4 0 .05 0 .11-.01.16l1.71 1.71zM12 5c4.42 0 8 3.58 8 8 0 1.22-.27 2.37-.77 3.4l1.49 1.49A9.953 9.953 0 0022 13c0-5.52-4.48-10-10-10-1.78 0-3.44.46-4.89 1.28l1.48 1.48C9.63 5.27 10.78 5 12 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$27dec67f2cfe6be3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$17e2060eb6332941(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h9V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13h2v4h-2zM7 10h2v7H7zM11 7h2v10h-2zM19 5V3h-2v2h-2v2h2v2h2V7h2V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$392232895e5d5552(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4zm-2 13.17L18.83 16H4V4h16v13.17zM13 5h-2v4H7v2h4v4h2v-4h4V9h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a32f8ba5aaa2b7f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h2v5h8v3h-8v4h5v3h-5v5h-2v-5H6v-3h5v-4H3V7h8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$242e0b70f16870cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22H2V2h2v20zM22 7H6v3h16V7zm-6 7H6v3h10v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cb9f18d3f4cc71c3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h2v20h-2V2zM2 10h16V7H2v3zm6 7h10v-3H8v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$449dc44a78098ba8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22H2v-2h20v2zM10 2H7v16h3V2zm7 6h-3v10h3V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8709946aaa7d1974(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11h-5V6h-3v5h-4V3H7v8H1.84v2H7v8h3v-8h4v5h3v-5h5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$66aa066af4cadc1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2v2H2V2h20zM7 22h3V6H7v16zm7-6h3V6h-3v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f196f29e2e095e9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7l-5-4-5 7-4-3v13h18V7h-4zm2 9.95l-7-5.45L8 17l-3-2.4V11l2.44 1.83 4.96-6.95L16.3 9H19v7.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$82a1f9d1afe00d71(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 015 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 005 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8dedfebb1abe1786(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2bd216e82c25554b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.06 9.94L12 9l2.06-.94L15 6l.94 2.06L18 9l-2.06.94L15 12l-.94-2.06zM4 14l.94-2.06L7 11l-2.06-.94L4 8l-.94 2.06L1 11l2.06.94L4 14zm4.5-5l1.09-2.41L12 5.5 9.59 4.41 8.5 2 7.41 4.41 5 5.5l2.41 1.09L8.5 9zm-4 11.5l6-6.01 4 4L23 8.93l-1.41-1.41-7.09 7.97-4-4L3 19l1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1011929bfe9f5959(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ce35359405082cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8dab2800fd606599(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$caca2de7c90b2593(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$93a309d33be51c43(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.81 8.94l-3.75-3.75L4 14.25V18h3.75l9.06-9.06zM6 16v-.92l7.06-7.06.92.92L6.92 16H6zM19.71 6.04a.996.996 0 000-1.41l-2.34-2.34a1.001 1.001 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83zM2 20h20v4H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$71f239a2f12db2f0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$985bf948a3d5bcf8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e219943d665ada59(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$34703ef62da9f9f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee13bdab7a0d109e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f30165671063c770(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f04d2a3697165069(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ba81e7a501140497(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$201deab286c81e5a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm8.01-1c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM16.5 3C13.47 3 11 5.47 11 8.5s2.47 5.5 5.5 5.5S22 11.53 22 8.5 19.53 3 16.5 3zm0 9c-1.93 0-3.5-1.57-3.5-3.5S14.57 5 16.5 5 20 6.57 20 8.5 18.43 12 16.5 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d7f623d3cacb5b2e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4H7v2H5v12h2v2h2v-2h2V6H9V4zm0 12H7V8h2v8zM19 8h-2V4h-2v4h-2v7h2v5h2v-5h2V8zm-2 5h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$68673e20e6cc246d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H2v2h9V7zm0 8H2v2h9v-2zm5.34-4L12.8 7.46l1.41-1.41 2.12 2.12 4.24-4.24L22 5.34 16.34 11zm0 8l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L22 13.34 16.34 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a00028069061eae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7h-9v2h9V7zm0 8h-9v2h9v-2zM5.54 11L2 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 11zm0 8L2 15.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$54a14a0ec802fd2a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4v2h3v12h-3v2h5V4zM4 20h5v-2H6V6h3V4H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a34ce9be2421c4ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7v2c0 .55-.45 1-1 1H2v4h1c.55 0 1 .45 1 1v2c0 1.65 1.35 3 3 3h3v-2H7c-.55 0-1-.45-1-1v-2c0-1.3-.84-2.42-2-2.83v-.34C5.16 11.42 6 10.3 6 9V7c0-.55.45-1 1-1h3V4H7C5.35 4 4 5.35 4 7zM21 10c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3h-3v2h3c.55 0 1 .45 1 1v2c0 1.3.84 2.42 2 2.83v.34c-1.16.41-2 1.52-2 2.83v2c0 .55-.45 1-1 1h-3v2h3c1.65 0 3-1.35 3-3v-2c0-.55.45-1 1-1h1v-4h-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$deef0922d18f021e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a42455e20af987b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.85 10.39l1.06-1.06c.78-.78.78-2.05 0-2.83L18.5 5.09c-.78-.78-2.05-.78-2.83 0l-1.06 1.06 4.24 4.24zm-4.24 1.42L7.41 19H6v-1.41l7.19-7.19 1.42 1.41zm-1.42-4.25L4 16.76V21h4.24l9.19-9.19-4.24-4.25zM19 17.5c0 2.19-2.54 3.5-5 3.5-.55 0-1-.45-1-1s.45-1 1-1c1.54 0 3-.73 3-1.5 0-.47-.48-.87-1.23-1.2l1.48-1.48c1.07.63 1.75 1.47 1.75 2.68zM4.58 13.35C3.61 12.79 3 12.06 3 11c0-1.8 1.89-2.63 3.56-3.36C7.59 7.18 9 6.56 9 6c0-.41-.78-1-2-1-1.26 0-1.8.61-1.83.64-.35.41-.98.46-1.4.12a.992.992 0 01-.15-1.38C3.73 4.24 4.76 3 7 3s4 1.32 4 3c0 1.87-1.93 2.72-3.64 3.47C6.42 9.88 5 10.5 5 11c0 .31.43.6 1.07.86l-1.49 1.49z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee89667cbca30fdc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h11v2H3v-2zm0-2h11V6H3v2zm0 8h7v-2H3v2zm15.01-3.13l.71-.71a.996.996 0 011.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.71-2.12-2.12zm-.71.71l-5.3 5.3V21h2.12l5.3-5.3-2.12-2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d0326c3747570a69(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7dba3c7c4395c5e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fdefa35573037878(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6c7dfe9c1ae74a6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2379ea33c861a426(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eb0690d16dce86e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8V5H6.39l3 3h1.83l-.55 1.28 2.09 2.1L14.21 8zM3.41 4.86L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21l1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1acfa1c74d115b57(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 000 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5zM2 20h20v4H2v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bfdde08a8fa45dbb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.36c1.53 2 3.08 4.43 3.71 6.24l2.23 2.23c.03-.27.06-.55.06-.83 0-3.98-6-10.8-6-10.8s-1.18 1.35-2.5 3.19l1.44 1.44c.34-.51.7-1 1.06-1.47zM5.41 5.14L4 6.55l3.32 3.32C6.55 11.33 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.95-1.5l2.63 2.63L20 19.72 5.41 5.14zM12 18c-2.21 0-4-1.79-4-4 0-.69.32-1.62.81-2.64l5.72 5.72c-.7.56-1.57.92-2.53.92z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$82c5a4cc6045f17f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v4H2v-4zm3.49-3h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5L5.49 17zm4.42-5.61l2.03-5.79h.12l2.03 5.79H9.91z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$35d45d4f1544463e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$789d2e3d159b7903(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$49ee669f30421638(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4h-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$afd08cc727299295(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91fe0e0e3e455e92(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f1b4aa106be0f5db(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17h2v.5h-1v1h1v.5h-2v1h3v-4h-3v1zm1-9h1V4h-2v1h1v3zm-1 3h1.8L18 13.1v.9h3v-1h-1.8l1.8-2.1V10h-3v1zM2 5h14v2H2V5zm0 12h14v2H2v-2zm0-6h14v2H2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eb23ae5e2a993700(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$feb75d2c6aa50d10(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3zm-2 2H6V4h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7e310a1b9a5e7702(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.62 18h-5.24l2-4H13V6h8v7.24L18.62 18zm-2-2h.76L19 12.76V8h-4v4h3.62l-2 4zm-8 2H3.38l2-4H3V6h8v7.24L8.62 18zm-2-2h.76L9 12.76V8H5v4h3.62l-2 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$54561e6c15b02a83(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e1809fe878839d5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$87d9cbd2b74f7b2c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$619ab09cdb2dd9fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v4c-1.1 0-2-.9-2-2s.9-2 2-2m8-2H9C6.79 2 5 3.79 5 6s1.79 4 4 4v5h2V4h2v11h2V4h2V2zm0 12v3H5v2h12v3l4-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$accac11ed57debb2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4v4c-1.1 0-2-.9-2-2s.9-2 2-2m8-2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4v5h2V4h2v11h2V4h2V2zM8 14l-4 4 4 4v-3h12v-2H8v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bfb73dbc26ca9354(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2488e3d529bc20f2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa5571ccd3181fb0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f51c89c10261fc3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 3H6.8l-5.2 9 5.2 9h10.4l5.2-9-5.2-9zm-1.15 16h-8.1l-4.04-7 4.04-7h8.09l4.04 7-4.03 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$309a975983d33125(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14l3 3v5h6v-5l3-3V9H6v5zm2-3h8v2.17l-3 3V20h-2v-3.83l-3-3V11zm3-9h2v3h-2zM3.502 5.874L4.916 4.46l2.122 2.12-1.414 1.415zm13.458.708l2.123-2.12 1.413 1.416-2.123 2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3dfcb7fee9525c16(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22H2V2h2v20zM22 2h-2v20h2V2zm-8.5 5h-3v10h3V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffa76baba5f72a7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 11h16v2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd59e89973fd7cbe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2 2H5V5h14v14zm0-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b893c82f8c36194f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$121c2d00ecb2ded2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v13.17L18.83 16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 10H6v2h12v-2zm0-3H6v2h12V9zm0-3H6v2h12V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91820331af923d4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6aaa56ac821d43ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cc956f2cd7f8427e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zm-2 5h-5v5h5v-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d0ac2df7e1e4abeb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4da973b78cd79ac3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2v3zM6 4h7v5h5v2h2V8l-6-6H6c-1.1 0-2 .9-2 2v7h2V4zM9 13h6v2H9zM17 13h6v2h-6zM1 13h6v2H1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bdcc4ce5ad8d040(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b5cf38b4d6708a36(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.43l-1.41-1.41-4.03 4.53L9.5 4 2 11.51l1.5 1.5 6.14-6.15 5.59 5.18-1.73 1.95-4-4L2 17.5 3.5 19l6-6.01 4 4 3.19-3.59 3.9 3.61L22 15.6l-3.98-3.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b9b244b91e19f9ea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5a2.5 2.5 0 000 5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5a2.5 2.5 0 000-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc547bae6b15fbef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm16 16H5V5h14v14zM11 7h2v2h-2V7zM7 7h2v2H7V7zm8 0h2v2h-2V7zm-8 4h2v2H7v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f213d2034195913d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6a0a8c598ff6533a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17.17L18.83 16H4V4h16v13.17zM20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$92c226438f44cd7e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h3.75L17.81 9.94l-3.75-3.75L3 17.25V21zm2-2.92l9.06-9.06.92.92L5.92 19H5v-.92zM18.37 3.29a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41l-2.34-2.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae08a3dbae004f32(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h3.75L17.81 9.94l-3.75-3.75L3 17.25V21zm2-2.92l9.06-9.06.92.92L5.92 19H5v-.92zM18.37 3.29a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41l-2.34-2.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e071ee3b85b694ef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7a04670351dc32a6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aefadec61dcb3a58(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.39.08-.75.21-1.1.36l1.51 1.51c.32-.08.69-.13 1.09-.13zM5.47 3.92L4.06 5.33 7.5 8.77c0 2.08 1.56 3.22 3.91 3.91l3.51 3.51c-.34.49-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.83-.55 2.46-1.12l2.22 2.22 1.41-1.41L5.47 3.92z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9ede772ae97d6bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.39.08-.75.21-1.1.36l1.51 1.51c.32-.08.69-.13 1.09-.13zM5.47 3.92L4.06 5.33 7.5 8.77c0 2.08 1.56 3.22 3.91 3.91l3.51 3.51c-.34.49-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.83-.55 2.46-1.12l2.22 2.22 1.41-1.41L5.47 3.92z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6ef281f1e6647a5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11c0 2.45 1.76 4.47 4.08 4.91l-1.49-1.49L7 13l4 4.01L7 21l-1.41-1.41 1.58-1.58v-.06A7.007 7.007 0 011 11c0-3.87 3.13-7 7-7h3v2H8c-2.76 0-5 2.24-5 5zM22 11V4h-9v7h9zm-2-2h-5V6h5v3zM13 13h9v7h-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56d79646209ffb46(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13c0-2.45 1.76-4.47 4.08-4.91l-1.49 1.5L7 11l4-4.01L7 3 5.59 4.41l1.58 1.58v.06A7.007 7.007 0 001 13c0 3.87 3.13 7 7 7h3v-2H8c-2.76 0-5-2.24-5-5zM13 13v7h9v-7h-9zm7 5h-5v-3h5v3zM13 4h9v7h-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e09b07412608dfd4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$97465424a1127b90(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.01L3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e61a7cc43e71eff2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 10l.5-2h-4l1-4h-2l-1 4h-4l1-4h-2L9 8H5l-.5 2h4l-1 4h-4L3 16h4l-1 4h2l1-4h4l-1 4h2l1-4h4l.5-2h-4l1-4h4zm-7 4h-4l1-4h4l-1 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4f0c5e4d0c961430(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm16 14H5V5h14v14zM11 7h2v2h-2V7zM7 7h2v2H7V7zm8 0h2v2h-2V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$758939785464187e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.63 9.78L16.56 19H7.44L4.37 9.78 12 4.44l7.63 5.34zM2 9l4 12h12l4-12-10-7L2 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b7894f7f4d6c236a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93A8.002 8.002 0 0113 19.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$31a8461b412d0e39(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.93 9H13V4.07c3.61.45 6.48 3.32 6.93 6.93zM4 12c0-4.07 3.06-7.44 7-7.93v15.86c-3.94-.49-7-3.86-7-7.93zm9 7.93V13h6.93A8.002 8.002 0 0113 19.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f572363d51abe299(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16v1.26l-6-3v-3.17L11.7 8H16V2h-6v4.9L7.3 10H3v6h5l7 3.5V22h6v-6h-6zM12 4h2v2h-2V4zM7 14H5v-2h2v2zm12 6h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d352c88342c87954(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zM7 12v2h8v-2h-3zM7 15h8v2H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$83702037c205c09b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4h14v2H5zm0 10h4v6h6v-6h4l-7-7-7 7zm8-2v6h-2v-6H9.83L12 9.83 14.17 12H13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$105a10becef1e464(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.88 18.47c.44-.7.7-1.51.7-2.39 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21.58 23 23 21.58l-3.12-3.11zm-3.8.11a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm-.36-8.5c-.74.02-1.45.18-2.1.45l-.55-.83-3.8 6.18-3.01-3.52-3.63 5.81L1 17l5-8 3 3.5L13 6l2.72 4.08zm2.59.5c-.64-.28-1.33-.45-2.05-.49L21.38 2 23 3.18l-4.69 7.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4b9d2bb5e1396726(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v16h20V4H2zm18 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$691e2bf90a94a1f6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-2c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm5.6 17.6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ce8229e3db0b1465(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9v2h-3V9H8.5V7H11V1H4v6h2.5v2H4v6h2.5v2H4v6h7v-6H8.5v-2H11v-2h3v2h7V9h-7zM6 3h3v2H6V3zm3 18H6v-2h3v2zm0-8H6v-2h3v2zm10 0h-3v-2h3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6fd1be1c38162865(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5l4-4 4 4 6-6v6zm0-8.5l-6 6-4-4-4 4V5h14v5.5zM13.5 9V6H12v6h1.5zm3.7 3l-2-3 2-3h-1.7l-2 3 2 3zM11 10.5H8.5v-.75H11V6H7v1.5h2.5v.75H7V12h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$63c49d09ad893405(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11c2.76 0 5-2.24 5-5S8.76 1 6 1 1 3.24 1 6s2.24 5 5 5zm0-8c1.65 0 3 1.35 3 3S7.65 9 6 9 3 7.65 3 6s1.35-3 3-3zM21 14h-5c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm0 7h-5v-5h5v5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.71 7.7c.4.19.83.3 1.29.3 1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3c0 .46.11.89.3 1.29L6.29 16.3c-.4-.19-.83-.3-1.29-.3-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3c0-.46-.11-.89-.3-1.29L17.71 7.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa7cbe8a93bb6ee8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h16v2H4V9zm0 4h10v2H4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a26cbb5afc4d4af(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99l1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe267fb26458c25a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9v4H6V9H4v6h16V9h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f812fa996e22f3ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm16 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7232798da0d41786(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19.99l7.5-7.51 4 4 7.09-7.97L22 9.92l-8.5 9.56-4-4-6 6.01-1.5-1.5zm1.5-4.5l6-6.01 4 4L22 3.92l-1.41-1.41-7.09 7.97-4-4L2 13.99l1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$51bdd60cec4797c3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29a5.73 5.73 0 011.7-.83c.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43s.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13s-.53.21-.72.36c-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51s.35.36.43.57c.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75s-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58s.37.85.65 1.21c.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21V12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c2c3b04b1a35a320(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18h-2v1h3v1h-4v-2c0-.55.45-1 1-1h2v-1h-3v-1h3c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM5.88 18h2.66l3.4-5.42h.12l3.4 5.42h2.66l-4.65-7.27L17.81 4h-2.68l-3.07 4.99h-.12L8.85 4H6.19l4.32 6.73L5.88 18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$14a66b9509f8e553(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7h-2v1h3v1h-4V7c0-.55.45-1 1-1h2V5h-3V4h3c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM5.88 20h2.66l3.4-5.42h.12l3.4 5.42h2.66l-4.65-7.27L17.81 6h-2.68l-3.07 4.99h-.12L8.85 6H6.19l4.32 6.73L5.88 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8183c698001b00b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2v3H5V5h15zm-5 14h-5v-9h5v9zM5 10h3v9H5v-9zm12 9v-9h3v9h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc6b6c368d392fea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2v3H5V5h14zm0 5v4H5v-4h14zM5 19v-3h14v3H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$35f9b2ede8051dbc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.99 19h2.42l1.27-3.58h5.65L11.59 19h2.42L8.75 5h-2.5L.99 19zm4.42-5.61L7.44 7.6h.12l2.03 5.79H5.41zM23 11v2h-8v-2h8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2631351217230264(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20f940f89a8a24c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.99 19h2.42l1.27-3.58h5.65L11.59 19h2.42L8.75 5h-2.5L.99 19zm4.42-5.61L7.44 7.6h.12l2.03 5.79H5.41zM20 11h3v2h-3v3h-2v-3h-3v-2h3V8h2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4ac8f11673d1690b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4v3h5.5v12h3V7H19V4H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ff6d6eff87607fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.19 12.2h3.63l.8 2.3h1.56l-3.38-9h-1.6l-3.38 9h1.56l.81-2.3zm1.77-5.03h.08l1.31 3.72h-2.69l1.3-3.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b747edf35b69f89d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$28ee3061fe2d20dd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$afae071f06218290(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f38576404d68f6b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2v2H2V2h20zM7 10.5v3h10v-3H7zM2 20v2h20v-2H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$51af6cbc3487cde(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$53027235baec1990(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16v6h16v-6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2zm14 2H6v-2h12v2zM12 2C9.24 2 7 4.24 7 7l5 7 5-7c0-2.76-2.24-5-5-5zm0 9L9 7c0-1.66 1.34-3 3-3s3 1.34 3 3l-3 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2df4369b070a3e3c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6l8 5 8-5v3h2V4c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2L1 16c0 1.1.9 2 2 2h10v-2H3V6zm16-2l-8 5-8-5h16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14v4c0 1.1-.9 2-2 2s-2-.9-2-2v-4.5c0-.28.22-.5.5-.5s.5.22.5.5V18h2v-4.5a2.5 2.5 0 00-5 0V18c0 2.21 1.79 4 4 4s4-1.79 4-4v-4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffa02df8e26032c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 16H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h12.5a2.5 2.5 0 010 5H9c-.55 0-1-.45-1-1s.45-1 1-1h9.5V9.5H9a2.5 2.5 0 000 5h10.5c2.21 0 4-1.79 4-4s-1.79-4-4-4H7c-3.04 0-5.5 2.46-5.5 5.5s2.46 5.5 5.5 5.5h11.5V16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85154913f47cf5dd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.29-9.81a4.373 4.373 0 00-8.17-1.16A3.483 3.483 0 005 12.5C5 14.43 6.57 16 8.5 16h7.58c1.61 0 2.92-1.31 2.92-2.92 0-1.54-1.2-2.79-2.71-2.89zM16 14H8.5c-.83 0-1.5-.67-1.5-1.5S7.67 11 8.5 11h.9l.49-1.05a2.377 2.377 0 014.44.63l.28 1.42H16c.55 0 1 .45 1 1s-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$374f5144def3eadb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.469 5.469 0 0112 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0122 15c0 1.65-1.35 3-3 3zm-9-3.82l-2.09-2.09L6.5 13.5 10 17l6.01-6.01-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$291518f2a89c38c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.469 5.469 0 0112 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0122 15c0 1.65-1.35 3-3 3zm-5.55-8h-2.9v3H8l4 4 4-4h-2.55z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$661705f6e71dc593(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 15c0-2.64-2.05-4.78-4.65-4.96A7.49 7.49 0 0012 4c-1.33 0-2.57.36-3.65.97l1.49 1.49C10.51 6.17 11.23 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19a2.996 2.996 0 011.79 5.4l1.41 1.41c1.09-.92 1.8-2.27 1.8-3.81zM4.41 3.86L3 5.27l2.77 2.77h-.42A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h11.73l2 2 1.41-1.41L4.41 3.86zM6 18c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73l8 8H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d48d8812685bb5e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a00371bfed9b4fef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.5 14.98c-.02 0-.03 0-.05.01A3.49 3.49 0 0018 12c-1.4 0-2.6.83-3.16 2.02A2.988 2.988 0 0012 17c0 1.66 1.34 3 3 3l6.5-.02a2.5 2.5 0 000-5zm.01 3.02H15c-.55 0-1-.45-1-1s.45-1 1-1h1.25v-.25c0-.97.78-1.75 1.75-1.75s1.75.78 1.75 1.75V17h1.76c.28 0 .5.22.5.5-.01.27-.23.5-.5.5zM10 4.26v2.09C7.67 7.18 6 9.39 6 12c0 1.77.78 3.34 2 4.44V14h2v6H4v-2h2.73A7.942 7.942 0 014 12c0-3.73 2.55-6.85 6-7.74zM20 6h-2.73a7.98 7.98 0 012.66 5h-2.02c-.23-1.36-.93-2.55-1.91-3.44V10h-2V4h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91c1a78a60d8430e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.469 5.469 0 0112 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0122 15c0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$53fad9f4b62a7722(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0122 15c0 1.65-1.35 3-3 3H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.469 5.469 0 0112 6m0-2C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96A7.49 7.49 0 0012 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2df8c2bef1019c22(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-8-4h2v2h2v-2h2v-2h-2v-2h-2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b25a3329f0c1301d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 23H4c-1.1 0-2-.9-2-2V7h2v14h14v2zM14.5 7V5h-2v2h-2v2h2v2h2V9h2V7h-2zm2 6h-6v2h6v-2zM15 1H8c-1.1 0-1.99.9-1.99 2L6 17c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V7l-6-6zm4 16H8V3h6.17L19 7.83V17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$340844d14403d995(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18h14v2H5v-2zm4.6-2.7L5 10.7l2-1.9 2.6 2.6L17 4l2 2-9.4 9.3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f5618c3f73f5fc65(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm2.59-11.41L16 10l-4 4-4-4 1.41-1.41L11 10.17V6h2v4.17l1.59-1.58zM17 17H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bbc04ed247d2fba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.17L12 13.17 9.83 11H11zm-6 7h14v2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4554187c74d05533(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.32 4.26A9.949 9.949 0 0013 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1a7.941 7.941 0 011.62 3.9zm-1.62 5.9l1.43 1.43a9.981 9.981 0 002.21-5.32h-2.02a7.945 7.945 0 01-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm2.59-9.34L13 13.17V7h-2v6.17l-2.59-2.59L7 12l5 5 5-5-1.41-1.41zM11 19.93v2.02c-5.05-.5-9-4.76-9-9.95s3.95-9.45 9-9.95v2.02C7.05 4.56 4 7.92 4 12s3.05 7.44 7 7.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4f953279ec45ff40(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.59-2.41L12 17l-4-4 4-4 1.41 1.41L11.83 12H16v2h-4.17l1.58 1.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fbfbae2730ce0261(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l1.41 1.41.59.59H20v10zm-7.84-6H8v2h4.16l-1.59 1.59L11.99 17 16 13.01 11.99 9l-1.41 1.41L12.16 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aeac204f27b2c256(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16l-4 4h10v-4zM12.06 7.19L3 16.25V20h3.75l9.06-9.06-3.75-3.75zM5.92 18H5v-.92l7.06-7.06.92.92L5.92 18zM18.71 8.04a.996.996 0 000-1.41l-2.34-2.34a1.001 1.001 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b254a4b64bf2b8d3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zM9.41 14.42L11 12.84V17h2v-4.16l1.59 1.59L16 13.01 12.01 9 8 13.01l1.41 1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5ea58f51dd63322(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.13 5.41L18.72 4l-9.19 9.19-4.25-4.24-1.41 1.41 5.66 5.66zM5 18h14v2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$625c7874a0ece321(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15.17V15h2v2.17l-2-2zm-2.59-2.58L17 11l-1.41-1.41L14 11.17l1.41 1.42zM13 10.17V4h-2v4.17l2 2zm8.19 11.02l-1.78-1.78-16.6-16.6-1.42 1.41 6.19 6.19L7 11l5 5 .59-.59L15.17 18H6v-3H4v3c0 1.1.9 2 2 2h11.17l2.61 2.61 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d7686a2a1958f6aa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zm-1-4l-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5 5-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e3269b61d0f77ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 22H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8l6 6v6h-2V9h-5V4H6v16h9v2zm4-.34v-2.24l2.95 2.95 1.41-1.41L20.41 18h2.24v-2H17v5.66h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9c5b250d990757cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zM7 9l1.41 1.41L11 7.83V16h2V7.83l2.59 2.58L17 9l-5-5-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d3de621cf929b84c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19h17v2H3c-1.1 0-2-.9-2-2V6h2v13zM23 6v9c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2l.01-11c0-1.1.89-2 1.99-2h5l2 2h7c1.1 0 2 .9 2 2zM7 15h14V6h-7.83l-2-2H7v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c01da7acd690390(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 10V9h-2v1H12v1.5h1v4c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-4h1V10h-2.5zm0 5.5h-2v-4h2v4zM20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm0 12H4V6h5.17l2 2H20v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c3dd3e2cd8e64c3c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H7.17l4 4H20v9.17l1.76 1.76c.15-.28.24-.59.24-.93V8c0-1.1-.9-2-2-2zM2.1 2.1L.69 3.51l1.56 1.56c-.15.28-.24.59-.24.93L2 18c0 1.1.9 2 2 2h13.17l3.31 3.31 1.41-1.41L2.1 2.1zM4 18V6.83L15.17 18H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b24bfe6dfa01303e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c0656adaae1a49bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-5-5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 4h8v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cb0ac7830968b35a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-4 10h2v-2h-2v-2h2v-2h-2V8h4v10h-4v-2zm0 0h-2v2H4V6h5.17l2 2H14v2h2v2h-2v2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$edbe14e75f8d9c69(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 6l2 2H20v10H4V6h5.17M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e91f04343858e78c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3v2H5V3h14zm-7 4c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm0 11.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 9.5 12 9.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae7b30db7cc66468(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v8h8V3H3zm6 6H5V5h4v4zm-6 4v8h8v-8H3zm6 6H5v-4h4v4zm4-16v8h8V3h-8zm6 6h-4V5h4v4zm-6 4v8h8v-8h-8zm6 6h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e5e31cfe3720c855(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3l-1.67 1.67L18.67 3 17 4.67 15.33 3l-1.66 1.67L12 3l-1.67 1.67L8.67 3 7 4.67 5.33 3 3.67 4.67 2 3v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V3zM11 19H4v-6h7v6zm9 0h-7v-2h7v2zm0-4h-7v-2h7v2zm0-4H4V8h16v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c049eba309a23f59(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v4h5v12H6zm5-1h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4v-2h-2V9h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7cc367ab55652bff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.83 16L5 13.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41L7.83 16zm9.58-3L19 14.59 17.59 16 16 14.41 14.41 16 13 14.59 14.59 13 13 11.41 14.41 10 16 11.59 17.59 10 19 11.41 17.41 13zM20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dbc254f0c5b66722(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-2.5-5.88v3.38h-3v-5h1.38l1.62 1.62zM13 9v8h6v-5.5L16.5 9H13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$66c38f5ce6f88ee4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.17 5L19 9.83V19H5V5h9.17m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9.83c0-.53-.21-1.04-.59-1.41l-4.83-4.83c-.37-.38-.88-.59-1.41-.59zM7 15h10v2H7v-2zm0-4h10v2H7v-2zm0-4h7v2H7V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6644e71294676427(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16.77c.68 0 1.23-.56 1.23-1.23V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-2-6H6v-2h12v2zm-4 4H6v-2h8v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b17aca3b4efb08f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11 8 15.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c77472a901212aac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h6v-6h4l-7-7-7 7h4v6zm3-10.17L14.17 8H13v6h-2V8H9.83L12 5.83zM5 18h14v2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e873d5f51cff679e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6-8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2C9.8 3 8 4.8 8 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6 12c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e15d905035418b11(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h-1V4H6v8H5c-1.66 0-3 1.34-3 3v5h20v-5c0-1.66-1.34-3-3-3zM8 6h8v6H8V6zm12 12H4v-3c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "16",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4aadd450d777c560(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v10.5l1.95 1.95c.03-.15.05-.3.05-.45V6c0-1.1-.9-2-2-2H6.5l2 2H19zM3.22 3.32L1.95 4.59 3 5.64V18c0 1.1.9 2 2 2h12.36l2.06 2.06 1.27-1.27L3.22 3.32zM15 18H5V7.64L15.36 18H15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af33555a3b6ef977(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13v3c0 1.1-.9 2-2 2h-3l1 1v2H6v-2l1-1H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h8v2H4v11h16v-3h2zm-7 2l-5-5 1.41-1.41L14 11.17V3h2v8.17l2.59-2.58L20 10l-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$29487cf94e957019(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2a9 9 0 019 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 7v2h12v6h-3v2h5V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f10652c64efbf271(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2a9 9 0 019 9h2c0-6.08-4.93-11-11-11zm10 1.09v2L14.5 15l3.5-1.91v-2L14.5 13 11 11.09zM14.5 6L9 9l5.5 3L20 9l-5.5-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$112164607a502c5a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2a9 9 0 019 9h2c0-6.08-4.93-11-11-11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$147f5e1319082f27(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2eba77c1fcd03c8a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v2h8v-2h4c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2zm0 14H4V5h16v12zM5 14v2h2c0-1.11-.89-2-2-2zm0-3v1.43c1.97 0 3.57 1.6 3.57 3.57H10c0-2.76-2.24-5-5-5zm0-3v1.45c3.61 0 6.55 2.93 6.55 6.55H13c0-4.42-3.59-8-8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7a9ce4beeb43cdad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df377126308337fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$65c1fbeb94e73ba1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.83 5H18v10.17L19.83 17H22v-2h-2v-2h2v-2h-2V9h2V7h-2V5c0-1.1-.9-2-2-2H5.83l2 2zM12 9.17V7h4v3h-3.17L12 9.17zM9.83 7H11v1.17L9.83 7zm4 4H16v2.17L13.83 11zM18 21c.06 0 .11 0 .16-.01l2.32 2.32 1.41-1.41L2.1 2.1.69 3.51l1.32 1.32C2 4.89 2 4.94 2 5v14c0 1.1.9 2 2 2h14zM4 19V6.83l2 2V12h3.17l1 1H6v4h5v-3.17l1 1V17h2.17l2 2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b038723cf39e3d94(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6v-4zm6-6h4v3h-4V7zM6 7h5v5H6V7zm6 4h4v6h-4v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a97c12367d76da1a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$30f56e6080d77192(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zM12 6.72c-1.96 0-3.5 1.52-3.5 3.47h1.75c0-.93.82-1.75 1.75-1.75s1.75.82 1.75 1.75c0 1.75-2.63 1.57-2.63 4.45h1.76c0-1.96 2.62-2.19 2.62-4.45 0-1.96-1.54-3.47-3.5-3.47zM11 16h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1fe3044aba79dc16(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22 0 .89.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b283276e676a83e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$68c936c97036eb73(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-1V6h-2v1h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 9h-2V9h2v7zm-6-6.62C14 7.51 12.49 6 10.62 6S7.25 7.51 7.25 9.38v5.25c0 1.04-.84 1.88-1.88 1.88s-1.87-.85-1.87-1.89v-4.7c.16.05.33.08.5.08 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2v6.62C2 16.49 3.51 18 5.38 18s3.38-1.51 3.38-3.38V9.38c0-1.04.84-1.88 1.88-1.88s1.88.84 1.88 1.88v4.7c-.18-.05-.35-.08-.52-.08-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2V9.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$409befc0367a926f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3c-2.76 0-5 2.24-5 5v8c0 1.66-1.34 3-3 3s-3-1.34-3-3V9h.83C7.44 9 8.89 7.82 9 6.21A3 3 0 006.2 3C4.44 2.89 3 4.42 3 6.19V16c0 2.76 2.24 5 5 5s5-2.24 5-5V8c0-1.66 1.34-3 3-3s3 1.34 3 3v7h-.83c-1.61 0-3.06 1.18-3.17 2.79A3 3 0 0017.8 21c1.76.12 3.2-1.42 3.2-3.18V8c0-2.76-2.24-5-5-5zM5 6c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1H5V6zm14 12c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1h1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d6d3c1df3f66619(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4v2.67l-1 1-1-1V4h2m7 7v2h-2.67l-1-1 1-1H20M6.67 11l1 1-1 1H4v-2h2.67M12 16.33l1 1V20h-2v-2.67l1-1M15 2H9v5.5l3 3 3-3V2zm7 7h-5.5l-3 3 3 3H22V9zM7.5 9H2v6h5.5l3-3-3-3zm4.5 4.5l-3 3V22h6v-5.5l-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e64a7528786b71b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-1V6h-2v1h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 9h-2V9h2v7zM8 6c-3.31 0-6 2.69-6 6v4c0 1.1.9 2 2 2h2v-5H3.5v-1c0-2.48 2.02-4.5 4.5-4.5s4.5 2.02 4.5 4.5v1H10v5h2c1.1 0 2-.9 2-2v-4c0-3.31-2.69-6-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c5ec34124bfd409b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3a9 9 0 00-9 9v7c0 1.1.9 2 2 2h4v-8H5v-1c0-3.87 3.13-7 7-7s7 3.13 7 7v1h-4v8h4c1.1 0 2-.9 2-2v-7a9 9 0 00-9-9zM7 15v4H5v-4h2zm12 4h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f60e9c3e72022e42(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14v4h-2v-4h2M7 14v4H6c-.55 0-1-.45-1-1v-3h2m5-13a9 9 0 00-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10a9 9 0 00-9-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19313bc66c4723c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c3.87 0 7 3.13 7 7v1h-4v.17L16.83 14H19v2.17l2 2V11a9 9 0 00-9-9c-2.02 0-3.88.67-5.38 1.8l1.43 1.43A6.878 6.878 0 0112 4zM2.1 2.1L.69 3.51l3.33 3.33A8.98 8.98 0 003 11v7c0 1.1.9 2 2 2h4v-8H5v-1c0-.94.19-1.83.52-2.65L15 17.83V20h2.17l1 1H12v2h7c.34 0 .65-.09.93-.24l.55.55 1.41-1.41L2.1 2.1zM7 14v4H5v-4h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e0fc317439e23265(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14v3c0 .55-.45 1-1 1h-1v-4h2M7 14v4H6c-.55 0-1-.45-1-1v-3h2m5-13a9 9 0 00-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7a9 9 0 00-9-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$97e3d4f31f1ad921(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H5C2.79 5 1 6.79 1 9v5c0 2.21 1.79 4 4 4h2v1h10v-1h2c2.21 0 4-1.79 4-4V9c0-2.21-1.79-4-4-4zm2 9c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc92d1f97a955685(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5C4.19 5 2 9.48 2 12c0 3.86 3.13 7 6.99 7h6.02C17.7 19 22 16.92 22 12c0 0 0-7-10-7zm0 2c7.64 0 7.99 4.51 8 5H4c0-.2.09-5 8-5zm2.86 10H9.14c-2.1 0-3.92-1.24-4.71-3h15.15c-.8 1.76-2.62 3-4.72 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8d3595da92727005(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15H3V6h18v13zM9 8h2v2H9V8zM5 8h2v2H5V8zm3 8h8v1H8v-1zm5-8h2v2h-2V8zm-4 4h2v2H9v-2zm-4 0h2v2H5v-2zm8 0h2v2h-2v-2zm4-4h2v2h-2V8zm0 4h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$40aef06534e1f13(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8229e515c96ac553(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ecce7a0a4b23505(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9edb94eda5985648(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d2055d0138cf76c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b613881c9e2d28f0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$98ae31f724c68cc5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 3C15.57 3 14 4.57 14 6.5V8h-4V6.5C10 4.57 8.43 3 6.5 3S3 4.57 3 6.5 4.57 10 6.5 10H8v4H6.5C4.57 14 3 15.57 3 17.5S4.57 21 6.5 21s3.5-1.57 3.5-3.5V16h4v1.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5H16v-4h1.5c1.93 0 3.5-1.57 3.5-3.5S19.43 3 17.5 3zM16 8V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S18.33 8 17.5 8H16zM6.5 8C5.67 8 5 7.33 5 6.5S5.67 5 6.5 5 8 5.67 8 6.5V8H6.5zm3.5 6v-4h4v4h-4zm7.5 5c-.83 0-1.5-.67-1.5-1.5V16h1.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zm-11 0c-.83 0-1.5-.67-1.5-1.5S5.67 16 6.5 16H8v1.5c0 .83-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cee5c9d9a943e478(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12l1.41 1.41L12 7.83l5.59 5.58L19 12l-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7885a07e18ede736(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6.41L16.59 5 12 9.58 7.41 5 6 6.41l6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13l-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d47bd33ddc84d99b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.59 18L19 16.59 14.42 12 19 7.41 17.59 6l-6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18l1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9e11f8eeb9bd3e8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.41 6L5 7.41 9.58 12 5 16.59 6.41 18l6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6l-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6177e43e25f096d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 17.59L7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11l1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$32f369019e6d7df9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H4V5h16v10zm-9-9h2v2h-2zm0 3h2v2h-2zM8 6h2v2H8zm0 3h2v2H8zM5 9h2v2H5zm0-3h2v2H5zm3 6h8v2H8zm6-3h2v2h-2zm0-3h2v2h-2zm3 3h2v2h-2zm0-3h2v2h-2zm-5 17l4-4H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b10305e87198e56(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5h6v2h-6zM9 5H3v2h4.85l6.92 12H21v-2h-5.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e1753bbe1f1b88d5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c57f5537527078a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$43a11e2ad798ebc6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2s-1.2-.54-1.2-1.2V5.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.41 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eb8f27773da27ebd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7v10H4V7h16m0-2H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2zm0 3h2v2h-2zM8 8h2v2H8zm0 3h2v2H8zm-3 0h2v2H5zm0-3h2v2H5zm3 6h8v2H8zm6-3h2v2h-2zm0-3h2v2h-2zm3 3h2v2h-2zm0-3h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ecf2f99204fb8430(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20e202ad91c11e58(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$92be313a6df25ec4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$280692f44ddd191b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5291bb5db6425224(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$412080bb73142806(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v2h12v-2l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9b2c38eddb7f7020(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9c-.04-4.39-3.6-7.93-8-7.93S4.04 4.61 4 9v6c0 4.42 3.58 8 8 8s8-3.58 8-8V9zm-2 0h-5V3.16c2.81.47 4.96 2.9 5 5.84zm-7-5.84V9H6a6.005 6.005 0 015-5.84zM18 15c0 3.31-2.69 6-6 6s-6-2.69-6-6v-4h12v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$66bbb0599c226374(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm1 17H7V4h10v14zm-3 3h-4v-1h4v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$742a81d9b4b7aa52(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 1h-8A2.5 2.5 0 005 3.5v17A2.5 2.5 0 007.5 23h8a2.5 2.5 0 002.5-2.5v-17A2.5 2.5 0 0015.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$463f316a69d4eeee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6V4H7.39l2 2zm2 13V9c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v3.61l2 2V10h4v7h-1.61l2.93 2.93c.39-.13.68-.49.68-.93zM2.06 1.51L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.41-1.41L2.06 1.51zM4 17V6.27L14.73 17H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$225cd389e476bed5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f8384632c60ab903(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 4H7V4h10v2zm3 16H4c-1.1 0-2-.9-2-2v-1h20v1c0 1.1-.9 2-2 2zm-1.47-11.81A2.008 2.008 0 0016.7 9H7.3c-.79 0-1.51.47-1.83 1.19L2 18h20l-3.47-7.81zM9.5 16h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm3 4h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm3 4h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$33210732111d1c06(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ea8d49e7d8e06450(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4.2c1.5 0 3 .6 4.2 1.7l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2zm-3.3 2.5l.8.8c.7-.7 1.6-1 2.5-1s1.8.3 2.5 1l.8-.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm0 6H5v-4h14v4zM6 16h2v2H6zm3.5 0h2v2h-2zm3.5 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$509a5d29851629b9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM19 18H5v-4h14v4zM6 15h2v2H6zm4 0h8v2h-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a35b7b1b9be8746(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dc3d525b022d9f63(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v16H6V8.83L10.83 4H18zM7 17h2v2H7zm8 0h2v2h-2zm-8-6h2v4H7zm4 4h2v4h-2zm0-4h2v2h-2zm4 0h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$12b14f2823ebfed4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 7.5v9l7-4.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14.01H4V5.99h16v12.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c6d16f17aef4c852(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 11.25H14v1.5h-1.5zM15 11.25h1.5v1.5H15zM10 11.25h1.5v1.5H10zM7.5 11.25H9v1.5H7.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM4 17H3V7h1v10zm14 0H6V7h12v10zm3 0h-1V7h1v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$72ddc4d1eb9378d9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zm-2 10H6V7h12v12zm-9-6c-.83 0-1.5-.67-1.5-1.5S8.17 10 9 10s1.5.67 1.5 1.5S9.83 13 9 13zm7.5-1.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zM8 15h8v2H8v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$22bb8f6ca787fcaa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e7abd384a883bdb3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM18 17l-8-.01V3h8v14zm-4-9c1.1 0 2-.89 2-2s-.9-2-2-2-2 .89-2 2 .9 2 2 2zm0 8c1.93 0 3.5-1.57 3.5-3.5S15.93 9 14 9s-3.5 1.57-3.5 3.5S12.07 16 14 16zm0-5c.83 0 1.5.67 1.5 1.5S14.83 14 14 14s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM6 5H4v16a2 2 0 002 2h10v-2H6V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d91d799d96a293f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM7 20V4h10v16H7zm5-11c1.1 0 2-.9 2-2s-.9-2-2-2a2 2 0 100 4zm0 2c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c52d3ccc3eb923bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 7.41L18.17 11H6v2h12.17l-3.59 3.59L16 18l6-6-6-6-1.41 1.41zM2 6v12h2V6H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6f7bf070d17bf2b7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2af60fd4fcb92d1e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 0h-14A2.5 2.5 0 002 2.5v19A2.5 2.5 0 004.5 24h14a2.5 2.5 0 002.5-2.5v-19A2.5 2.5 0 0018.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9260db973c05ea60(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e81843c23fd90712(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.75 10.08L17.4 6.05A2.978 2.978 0 0014.56 4H9.44C8.15 4 7 4.82 6.6 6.05L5.81 8.4 4.41 7l.29-.29A.996.996 0 103.29 5.3l-2 2A.996.996 0 102.7 8.71l.3-.3 1.79 1.79C3.18 10.72 2 12.22 2 14c0 1.49.83 2.78 2.05 3.47A2.991 2.991 0 007 20c1.3 0 2.4-.84 2.82-2h4.37c.41 1.16 1.51 2 2.82 2 1.49 0 2.73-1.1 2.95-2.53C21.17 16.78 22 15.49 22 14c0-1.95-1.4-3.57-3.25-3.92zM13 6h1.56a1 1 0 01.95.68l1.1 3.32H13V6zm-4.51.68A1 1 0 019.44 6H11v4H7.41l-.02-.02 1.1-3.3zM7 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm10 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.49-2.68A3.028 3.028 0 0017 14c-1.3 0-2.4.84-2.82 2H9.82C9.4 14.84 8.3 14 7 14c-1.03 0-1.95.53-2.49 1.32C4.2 14.97 4 14.51 4 14c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2 0 .51-.2.97-.51 1.32z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c0ac517067f4d73f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$900d522ff945ebb0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 9c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-6.67-1H20v8h-1.17l1.87 1.87c.75-.29 1.3-1.02 1.3-1.87V8c0-1.1-.9-2-2-2H8.83l2 2zm8.95 14.61L15.17 18H4c-1.1 0-2-.9-2-2V8c0-.85.55-1.58 1.3-1.87L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM13.17 16l-3-3H9v2H7v-2H5v-2h2V9.83L5.17 8H4v8h9.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3c2859af3a5723c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h18v8zM6 15h2v-2h2v-2H8V9H6v2H4v2h2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$97489d897881c801(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c2.76 0 5 2.24 5 5 0 .64-.13 1.25-.35 1.82l1.5 1.5a6.963 6.963 0 00-1.79-8.79L15 2H9l-.96 3.21 2.14 2.14C10.75 7.13 11.36 7 12 7zm-1.51-3h3.02l.38 1.27c-.55-.16-1.97-.51-3.78 0L10.49 4zM2.81 2.81L1.39 4.22l4.46 4.46a6.963 6.963 0 001.79 8.79L9 22h6l.96-3.21 3.82 3.82 1.41-1.41L2.81 2.81zM13.51 20h-3.02l-.38-1.27c.55.15 1.97.51 3.78 0L13.51 20zM12 17c-2.76 0-5-2.24-5-5 0-.64.13-1.25.35-1.82l6.47 6.47c-.57.22-1.18.35-1.82.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$918ce476d3427281(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.31 2l.41 2.48C13.87 4.17 12.96 4 12 4c-.95 0-1.87.17-2.71.47L9.7 2h4.61m.41 17.52L14.31 22H9.7l-.41-2.47c.84.3 1.76.47 2.71.47.96 0 1.87-.17 2.72-.48M16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12s-1.19-4.81-3.04-6.27L16 0zm-4 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5711d33609a33785(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.03 3.56c-1.67-1.39-3.74-2.3-6.03-2.51v2.01c1.73.19 3.31.88 4.61 1.92l1.42-1.42zM11 3.06V1.05c-2.29.2-4.36 1.12-6.03 2.51l1.42 1.42A8.928 8.928 0 0111 3.06zM4.98 6.39L3.56 4.97C2.17 6.64 1.26 8.71 1.05 11h2.01c.19-1.73.88-3.31 1.92-4.61zM20.94 11h2.01c-.21-2.29-1.12-4.36-2.51-6.03l-1.42 1.42A8.928 8.928 0 0120.94 11zM7 12l3.44 1.56L12 17l1.56-3.44L17 12l-3.44-1.56L12 7l-1.56 3.44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21a8.96 8.96 0 01-7.46-4H7v-2H1v6h2v-2.7c1.99 2.84 5.27 4.7 9 4.7 4.87 0 9-3.17 10.44-7.56l-1.96-.45C19.25 18.48 15.92 21 12 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9135f5167f076559(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h11.25c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75H22v-2h-2zm-2-8h-2V9h2v2zm-4 0H6V9h8v2zm0 2v2H6v-2h8zm2 0h2v2h-2v-2zm2-6h-2V5h2v2zm-4-2v2H6V5h8zM6 19v-2h8v2H6zm10 0v-2h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$552df6ae35cdcec2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM16 9h2v2h-2V9zm-2 2H6V9h8v2zm4-4h-2V5h2v2zm-4-2v2H6V5h8zM6 19v-6h8v1.82A1.746 1.746 0 0015 18a1.746 1.746 0 001-3.18V13h2v6H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5907ceb3edec7a8e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6c0-1.1-.9-2-2-2H4v2h16v2.59c.73.29 1.4.69 2 1.17V6zM8 9H3c-.5 0-1 .5-1 1v9c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-9c0-.5-.5-1-1-1zm-1 9H4v-7h3v7zM17.75 16.97c.3-.23.5-.57.5-.97a1.25 1.25 0 00-2.5 0c0 .4.2.75.5.97V22h1.5v-5.03z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13.5a2.5 2.5 0 012.5 2.5c0 .69-.28 1.31-.73 1.76l1.06 1.06C20.55 18.1 21 17.1 21 16c0-2.21-1.79-4-4-4s-4 1.79-4 4c0 1.1.45 2.1 1.17 2.83l1.06-1.06A2.5 2.5 0 0117 13.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9.5a6.5 6.5 0 00-6.5 6.5c0 1.79.73 3.42 1.9 4.6l1.06-1.06C12.56 18.63 12 17.38 12 16c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.37-.56 2.62-1.46 3.52l1.07 1.06A6.5 6.5 0 0017 9.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7073f79a57e0af4d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19v-9l6-4.5 4.08 3.06c.81-.32 1.69-.51 2.61-.54L10 3 2 9v12h8.76c-.48-.6-.88-1.27-1.17-2H4zM17 14.75c-.69 0-1.25.56-1.25 1.25 0 .4.2.75.5.97V22h1.5v-5.03c.3-.23.5-.57.5-.97 0-.69-.56-1.25-1.25-1.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.21 0-4 1.79-4 4 0 1.1.45 2.1 1.17 2.83l1.06-1.06A2.5 2.5 0 1119.5 16c0 .69-.28 1.31-.73 1.76l1.06 1.06C20.55 18.1 21 17.1 21 16c0-2.21-1.79-4-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9.5a6.5 6.5 0 00-6.5 6.5c0 1.79.73 3.42 1.9 4.6l1.06-1.06C12.56 18.63 12 17.38 12 16c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.37-.56 2.62-1.46 3.52l1.07 1.06A6.5 6.5 0 0017 9.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$36442fdea2ca9777(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM13 5v14h-2V5h2zM6 5h3v14H6V5zm9 14V5h3v14h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$67042d794046d2e8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zm-2-8.14c-2.05-.58-3.64-2.93-3.94-5.86H18v5.86zM15.81 12c-2.04 1.35-3.5 3.94-3.76 7h-.09c-.26-3.06-1.72-5.65-3.76-7 2.04-1.35 3.5-3.94 3.76-7h.09c.26 3.06 1.72 5.65 3.76 7zM9.94 5c-.3 2.93-1.89 5.27-3.94 5.86V5h3.94zM6 13.14c2.05.58 3.64 2.93 3.94 5.86H6v-5.86zM14.06 19c.3-2.93 1.89-5.27 3.94-5.86V19h-3.94z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3e5017f8038c2160(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.69 2.21L4.33 11.49c-.64.58-.28 1.65.58 1.73L13 14l-4.85 6.76c-.22.31-.19.74.08 1.01.3.3.77.31 1.08.02l10.36-9.28c.64-.58.28-1.65-.58-1.73L11 10l4.85-6.76c.22-.31.19-.74-.08-1.01a.77.77 0 00-1.08-.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f1d6e241fc57be59(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11a9 9 0 00-18 0c0 3.92 2.51 7.24 6 8.48V22h2v-2.06a8.262 8.262 0 002 0V22h2v-2.52c3.49-1.24 6-4.56 6-8.48zm-9 7c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h8v2H8zM12.75 10l-3 3L11 14.25 9.75 15.5l1.5 1.5 3-3L13 12.75l1.25-1.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d8d0029b2d170c0f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.8 0-9 3.86-9 9 0 2.12.74 4.07 1.97 5.61L3 19.59 4.41 21l1.97-1.97A9.012 9.012 0 0012 21c2.3 0 4.61-.88 6.36-2.64A8.95 8.95 0 0021 12V3h-9zm7 9c0 1.87-.73 3.63-2.05 4.95A6.96 6.96 0 0112 19c-3.86 0-7-3.14-7-7 0-1.9.74-3.68 2.1-4.99A6.94 6.94 0 0112 5h7v7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.46 12.63l4.05.4-2.44 3.33c-.11.16-.1.38.04.52.15.15.4.16.56.01l5.16-4.63c.33-.3.15-.85-.3-.89l-4.05-.4 2.44-3.33c.11-.16.1-.38-.04-.52a.405.405 0 00-.56-.01l-5.16 4.63c-.32.3-.14.85.3.89z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$299d784b102600f3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h-1V2h-2v2h-2V2H9v2H8C5.79 4 4 5.79 4 8v10c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zm2 14c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 15.54C9.5 16.9 10.62 18 12 18s2.5-1.1 2.5-2.46c0-1.09-.45-1.41-2.5-3.79-2.07 2.4-2.5 2.71-2.5 3.79zM8 8h8v2H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df1a07eaf9f38d98(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm-.75-2.08c-.55-.1-1.05-.32-1.5-.62l1.5-1.5v2.12zm1.5 0v-2.11l1.5 1.5c-.45.3-.95.51-1.5.61zm2.56-1.67l-1.5-1.5h2.11c-.1.55-.31 1.05-.61 1.5zm.61-3h-2.11l1.5-1.5c.3.45.51.95.61 1.5zm-3.17-3.17c.55.1 1.05.32 1.5.62l-1.5 1.5V8.08zM12 11c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-.75-2.92v2.11l-1.5-1.5c.45-.3.95-.51 1.5-.61zM8.69 9.75l1.5 1.5H8.08c.1-.55.31-1.05.61-1.5zm1.5 3l-1.5 1.5c-.3-.44-.51-.95-.62-1.5h2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$61cac4b9037ab64b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c-1.06 0-1.64.29-3.91 1.19-.19-.14-.4-.27-.62-.37.25-1.03.61-1.53 1.33-2.04.81-.57 1.2-1.34 1.2-2.28 0-1.22-.95-2.5-2.6-2.5-3.08 0-4.92 1.47-5.32 3.26l2.33 2.33C10.07 6.69 10 6.38 10 6c0-1.18 1.4-2 3.4-2 .57 0 .6.42.6.5 0 .27-.05.43-.35.65-1.27.9-1.83 1.91-2.16 3.39l-.02.1 7.25 7.25c.24.06.5.11.78.11 1.22 0 2.5-.95 2.5-2.6C22 9.91 20.11 8 18 8zm1.5 6c-.27 0-.43-.05-.65-.35-.9-1.27-1.91-1.83-3.39-2.16a3.12 3.12 0 00-.15-.62c1.8-.75 2.18-.87 2.69-.87 1.18 0 2 1.4 2 3.4 0 .57-.42.6-.5.6zM1.39 4.22l3.89 3.89C5.04 8.05 4.78 8 4.5 8 3.28 8 2 8.95 2 10.6 2 14.09 3.89 16 6 16c1.06 0 1.64-.29 3.91-1.19.19.14.4.27.62.37-.25 1.03-.61 1.53-1.33 2.04-.81.57-1.2 1.34-1.2 2.28 0 1.22.95 2.5 2.6 2.5 3.08 0 4.92-1.47 5.32-3.26l3.86 3.86 1.41-1.41L2.81 2.81 1.39 4.22zm11.13 11.24c.03 0 .06-.02.09-.02l.97.97c.35.9.42 1.21.42 1.59 0 1.18-1.4 2-3.4 2-.57 0-.6-.42-.6-.5 0-.27.05-.43.35-.65 1.28-.89 1.83-1.91 2.17-3.39zm-3.98-2.94c.03.22.08.42.15.62-1.8.74-2.18.86-2.69.86-1.18 0-2-1.4-2-3.4 0-.57.42-.6.5-.6.27 0 .43.05.65.35.89 1.28 1.91 1.83 3.39 2.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a7f9aec8e87f570(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1c-.15 0 .11-.02-4.28.42C8.47 1.75 6 4.48 6 7.75s2.47 6 5.72 6.33l1.9.19-.56.85c-.35-.08-.7-.12-1.06-.12-2.76 0-5 2.24-5 5v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-2c0-1.67-.83-3.15-2.09-4.06l.97-1.45c.04 0 .09.01.13.01 1.09 0 2-.89 2-2V3C18 1.89 17.09 1 16 1zm-1 20H9v-1c0-1.65 1.35-3 3-3s3 1.35 3 3v1zM8 7.75c0-2.25 1.69-4.11 3.92-4.34L16 3l.03 9.5-4.11-.42A4.336 4.336 0 018 7.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e64d61bd2e8f74ef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13.05C9 14.68 10.34 16 12 16s3-1.32 3-2.95c0-1.31-.53-1.69-3-4.55-2.48 2.88-3 3.25-3 4.55z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c.55 0 1-.45 1-1s-.45-1-1-1h-1V5h1c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h1v6H4c-.55 0-1 .45-1 1s.45 1 1 1h1v6H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1h-1v-6h1zm-3 6H7v-6c.55 0 1-.45 1-1s-.45-1-1-1V5h10v6c-.55 0-1 .45-1 1s.45 1 1 1v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$66978482fdce3c04(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6.14V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2.14c-1.72.45-3 2-3 3.86v8c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4v-8c0-1.86-1.28-3.41-3-3.86zM9 4h6v2h-2c0-.55-.45-1-1-1s-1 .45-1 1H9V4zM8 8h8c1.1 0 2 .9 2 2v3H6v-3c0-1.1.9-2 2-2zm8 12H8c-1.1 0-2-.9-2-2v-3h12v3c0 1.1-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4fdb0aaa3688b7df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6h-1V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v1H7c-3.31 0-6 2.69-6 6s2.69 6 6 6v3h2v-3h6v3h2v-3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm-7-1h4v1h-4V5zm7 11H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$21f2888d4ca60e62(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h8.25c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75H22v-2h-2zM18 5v10H6V5h12zM6 19v-2h5v2H6zm7 0v-2h5v2h-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a54a3d95169ab95d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM18 5v6H6V5h12zM6 19v-6h5v1.82A1.746 1.746 0 0012 18a1.746 1.746 0 001-3.18V13h5v6H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cb00a799fea6f1ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4v16H6V4h12m0-2H6c-1.1 0-2 .9-2 2v18h16V4c0-1.1-.9-2-2-2zm-2.5 8.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S17 12.83 17 12s-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$87be8e4bb3d072e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM12 12c-1.84 0-3.56.5-5.03 1.37-.61.35-.97 1.02-.97 1.72V17h12v-1.91c0-.7-.36-1.36-.97-1.72A9.844 9.844 0 0012 12zm-3.86 3c1.18-.65 2.51-1 3.86-1s2.68.35 3.85 1H8.14zM21.23 8.15l1.85-.77A12.056 12.056 0 0016.62.92l-.77 1.85c2.42 1.02 4.36 2.96 5.38 5.38zM8.15 2.77L7.38.92A12.089 12.089 0 00.92 7.38l1.85.77c1.02-2.42 2.96-4.36 5.38-5.38zM2.77 15.85l-1.85.77c1.22 2.91 3.55 5.25 6.46 6.46l.77-1.85a10.117 10.117 0 01-5.38-5.38zM15.85 21.23l.77 1.85c2.91-1.22 5.25-3.55 6.46-6.46l-1.85-.77a10.117 10.117 0 01-5.38 5.38z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7adc4bf928616246(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v7h-4v-1h-4v1H6V4h12zM6 20v-7h12v7H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6534be3c49da9f02(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.01 14.33c1.75 2.17 5.12 2.24 6.96.07.23-.27.08-.68-.26-.74a4.491 4.491 0 01-3.18-2.2 4.503 4.503 0 01-.32-3.86.453.453 0 00-.51-.6c-3.34.62-4.89 4.61-2.69 7.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$49f5784f0f1b28f2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12H4L2 22h20l-2-10zm-1.64 2l.4 2H13v-2h5.36zM11 14v2H5.24l.4-2H11zm-6.16 4H11v2H4.44l.4-2zM13 20v-2h6.16l.4 2H13zM11 8h2v3h-2zM15.764 7.205l1.415-1.414L19.3 7.912l-1.414 1.414zM4.705 7.913L6.826 5.79 8.24 7.206 6.12 9.327zM3 2h3v2H3zM18 2h3v2h-3zM12 7c2.76 0 5-2.24 5-5h-2c0 1.65-1.35 3-3 3S9 3.65 9 2H7c0 2.76 2.24 5 5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e1973b42a95e0751(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM13 5h1.5v14H13V5zm-2 14H9.5V5H11v14zM6 5h1.5v14H6V5zm10.5 14V5H18v14h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$faf209e6b5f0ce31(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM14 5v14h-4V5h4zM6 5h2v14H6V5zm10 14V5h2v14h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f4bfa27678b2abb6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h6v2H4zM1 7h5v2H1zM3 19h5v2H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.21 18.61l-2.28-4.1a2.05 2.05 0 00-1.26-.97l-2.69-.67a2.95 2.95 0 00-.37-1.33l3.96-6.59c.65-1.08.3-2.48-.78-3.13a2.288 2.288 0 00-2.73.3l-3.43 3.21c-.4.37-.63.9-.63 1.45v3.4c-.47.17-.89.45-1.23.82H3.28a2.279 2.279 0 00-.63 4.47l4.51 1.29c.18.05.37.08.55.08.36 0 .72-.1 1.03-.29l2.24-1.34c.29.26.63.47 1.02.61V21c-1.1 0-2 .9-2 2h6c0-1.1-.9-2-2-2v-4.28l4.61 4.61c.45.45 1.03.67 1.61.67.58 0 1.17-.22 1.61-.67.72-.72.88-1.83.38-2.72zM7.72 14.84L3.2 13.55a.279.279 0 01-.2-.27c0-.15.13-.28.28-.28h6.73c0 .15.01.3.03.44l-2.32 1.4zM13 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1-3.86V6.78l3.43-3.21c.05-.05.19-.12.34-.04.13.08.18.25.1.38l-3.74 6.24-.13-.01zm6.42 9.78c-.05.05-.24.16-.4 0l-4.85-4.85c.08-.09.16-.18.24-.28l2.78.69 2.28 4.1c.06.11.04.25-.05.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4c97287b359dfea5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11.5h2.5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H13c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-4.5H15v3h-1.5V7zM7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM8.5 11.5H10v-6H7V7h1.5zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$49334ea7a4c322e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 11.5H11v-6H8V7h1.5zM14.5 11.5H16v-6h-3V7h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56e961e0ebed701e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM16.5 10h-3V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H12V7h3v1h-2c-.55 0-1 .45-1 1v2.5h4.5V10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$69525d26ae1e3e03(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM16.5 10.5v-4c0-.55-.45-1-1-1H12V7h3v1h-2v1h2v1h-3v1.5h3.5c.55 0 1-.45 1-1zM7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e8e8b320dbb58da8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 12.5v6H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5zm3 3H15V14h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM15 11.5h1.5V10h1V8.5h-1v-3H15v3h-1.5v-3H12V10h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ede21fddd637479e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM16.5 10.5V9c0-.55-.45-1-1-1h-2V7h3V5.5H12V9h3v1h-3v1.5h3.5c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bf90a8fce026d5bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11.5h2.5c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-2V7h3V5.5H13c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-2.5H15v1.5h-1.5V9zM8.5 11.5H10v-6H7V7h1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe3859b05f52e6d1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM13.25 11.5H15l1.46-4.71c.19-.64-.29-1.29-.96-1.29H12V7h2.62l-1.37 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6f3025f2ac82dfea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM13 11.5h2.5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H13c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-5H15V8h-1.5V6.5zm0 2.5H15v1.5h-1.5V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f5b7cf4a334754d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM16.5 10.5v-4c0-.55-.45-1-1-1H13c-.55 0-1 .45-1 1V8c0 .55.45 1 1 1h2v1h-3v1.5h3.5c.55 0 1-.45 1-1zM15 8h-1.5V6.5H15V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$630d192c70c009c7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 12.5v6H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5zm3 3H15V14h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11.5h2.5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H14c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-4.5H16v3h-1.5V7zM11 10H8V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H6.5V7h3v1h-2c-.55 0-1 .45-1 1v2.5H11V10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e620dce7073e17fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 11.5H16v-6h-3V7h1.5zM12 10H9V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H7.5V7h3v1h-2c-.55 0-1 .45-1 1v2.5H12V10zM7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM15 17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6H15V17zm0-3h1.5v1.5H15V14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$455797b0bafe8208(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 12.5v6H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5zm3 3H15V14h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10H8V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H6.5V7h3v1h-2c-.55 0-1 .45-1 1v2.5H11V10zM17.5 10h-3V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H13V7h3v1h-2c-.55 0-1 .45-1 1v2.5h4.5V10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$419f5622aa99efcc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 12.5v6H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5zm3 3H15V14h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10H8V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H6.5V7h3v1h-2c-.55 0-1 .45-1 1v2.5H11V10zM17.5 10.5v-4c0-.55-.45-1-1-1H13V7h3v1h-2v1h2v1h-3v1.5h3.5c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$78544ef959f4aeff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM17 12.5h-3.5v6H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1zm-.5 3H15V14h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10H8V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H6.5V7h3v1h-2c-.55 0-1 .45-1 1v2.5H11V10zM16 11.5h1.5V10h1V8.5h-1v-3H16v3h-1.5v-3H13V10h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c6cc9fd653d63884(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 10h-3V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H10V7h3v1h-2c-.55 0-1 .45-1 1v2.5h4.5V10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$674bfb702fc251a5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v2h5v2H5v2h4v2H4v2h5c1.1 0 2-.9 2-2v-1.5c0-.83-.17-1.5-1-1.5.83 0 1-.67 1-1.5V6c0-1.1-.9-2-2-2H4zm14 0c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h3zm0 2h-3v6h3V6zM5 22H3v-5h2v5zm4 0H7v-5h2v5zm4 0h-2v-5h2v5zm8 0h-6v-5h6v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f81d7da3d7d60ff8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 12.5v6H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5zm3 3H15V14h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 10.5v-4c0-.55-.45-1-1-1H10V7h3v1h-2v1h2v1h-3v1.5h3.5c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$89a5ee22092984ca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 11.5H14V10h1V8.5h-1v-3h-1.5v3H11v-3H9.5V10h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d19b50af2ec19ce6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 10.5V9c0-.55-.45-1-1-1h-2V7h3V5.5H10V9h3v1h-3v1.5h3.5c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$938a493396307e61(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6v6h-3V6h3zm0-2h-3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 2V4H6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2H6V6h5zm-2 4v2H6v-2h3zM5 22H3v-5h2v5zm4 0H7v-5h2v5zm4 0h-2v-5h2v5zm8 0h-6v-5h6v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$952660019ff3178d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11.5h2.5c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-2V7h3V5.5H11c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-2.5H13v1.5h-1.5V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$64bfe4e7ed0df542(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 11.5H13l1.46-4.71c.19-.64-.29-1.29-.96-1.29H10V7h2.62l-1.37 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$41bfbb675fbf57b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11.5h2.5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H11c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-5H13V8h-1.5V6.5zm0 2.5H13v1.5h-1.5V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ab4dc7d7cbe6973(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 10.5v-4c0-.55-.45-1-1-1H11c-.55 0-1 .45-1 1V8c0 .55.45 1 1 1h2v1h-3v1.5h3.5c.55 0 1-.45 1-1zM13 8h-1.5V6.5H13V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e9a05d5c79199f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-3.17L16 4h-6v2h5.12l1.83 2H21v12H5v-9H3v9c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM8 14c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5zm5-3c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zM5 6h3V4H5V1H3v3H0v2h3v3h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$845478652c07c0bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$26ba92fdad0ca8ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-1h2v-4h4V9h-4V5h-2v4H9v2h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ff4e8a2d74f45b8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$620c0943cd2236c2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2c-2.71 0-5.05 1.54-6.22 3.78a7.062 7.062 0 00-3 3A7.014 7.014 0 002 15c0 3.87 3.13 7 7 7 2.71 0 5.05-1.54 6.22-3.78a7.062 7.062 0 003-3A7.014 7.014 0 0022 9c0-3.87-3.13-7-7-7zM9 20a5.002 5.002 0 01-4-8c0 3.87 3.13 7 7 7-.84.63-1.88 1-3 1zm3-3a5.002 5.002 0 01-4-8c0 3.86 3.13 6.99 7 7-.84.63-1.88 1-3 1zm4.7-3.3c-.53.19-1.1.3-1.7.3-2.76 0-5-2.24-5-5 0-.6.11-1.17.3-1.7.53-.19 1.1-.3 1.7-.3 2.76 0 5 2.24 5 5 0 .6-.11 1.17-.3 1.7zM19 12c0-3.86-3.13-6.99-7-7a5.002 5.002 0 017 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$183212576fd26edf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.36 6l.08.39.32 1.61H18v6h-3.36l-.08-.39-.32-1.61H7V6h5.36M14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6L14 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56211fb94e684c09(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-7-1l1.88-4.12L18 11l-4.12-1.88L12 5l-1.88 4.12L6 11l4.12 1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$24a351ef72a92cb7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6zm-2 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2d4832030a9968c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a2 2 0 002 2h6V3H5a2 2 0 00-2 2zm6 14H5V5h4v14zM19 3h-6v8h8V5c0-1.1-.9-2-2-2zm0 6h-4V5h4v4zM13 21h6c1.1 0 2-.9 2-2v-6h-8v8zm2-6h4v4h-4v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc0f22809aada0df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H4c-1.1 0-2 .9-2 2v10h2V4h10V2zm4 4H8c-1.1 0-2 .9-2 2v10h2V8h10V6zm2 4h-8c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm0 10h-8v-8h8v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$877806aba1e1d4c8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25zM11.5 9.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zm-1.51 3.49L9 15.17l-.99-2.18L5.83 12l2.18-.99L9 8.83l.99 2.18 2.18.99-2.18.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b7cb93b373730eb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7l.94-2.06L23 4l-2.06-.94L20 1l-.94 2.06L17 4l2.06.94zM8.5 7l.94-2.06L11.5 4l-2.06-.94L8.5 1l-.94 2.06L5.5 4l2.06.94zM20 12.5l-.94 2.06-2.06.94 2.06.94.94 2.06.94-2.06L23 15.5l-2.06-.94zM17.71 9.12l-2.83-2.83c-.2-.19-.45-.29-.71-.29-.26 0-.51.1-.71.29L2.29 17.46a.996.996 0 000 1.41l2.83 2.83c.2.2.45.3.71.3s.51-.1.71-.29l11.17-11.17c.39-.39.39-1.03 0-1.42zm-3.54-.7l1.41 1.41L14.41 11 13 9.59l1.17-1.17zM5.83 19.59l-1.41-1.41L11.59 11 13 12.41l-7.17 7.18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$99b34fd573153cc0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7l.94-2.06L23 4l-2.06-.94L20 1l-.94 2.06L17 4l2.06.94zM17.71 9.12l-2.83-2.83c-.2-.19-.45-.29-.71-.29-.26 0-.51.1-.71.29L2.29 17.46a.996.996 0 000 1.41l2.83 2.83c.2.2.45.3.71.3s.51-.1.71-.29l11.17-11.17c.39-.39.39-1.03 0-1.42zm-3.54-.7l1.41 1.41L14.41 11 13 9.59l1.17-1.17zM5.83 19.59l-1.41-1.41L11.59 11 13 12.41l-7.17 7.18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3e1fddaae4a0f883(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7l.94-2.06L23 4l-2.06-.94L20 1l-.94 2.06L17 4l2.06.94zM14.17 8.42l1.41 1.41-1.46 1.46 1.41 1.41 2.17-2.17a.996.996 0 000-1.41l-2.83-2.83a.984.984 0 00-.7-.29c-.26 0-.51.1-.71.29l-2.17 2.17 1.41 1.41 1.47-1.45zM1.39 4.22l7.07 7.07-6.17 6.17a.996.996 0 000 1.41l2.83 2.83c.2.2.45.3.71.3s.51-.1.71-.29l6.17-6.17 7.07 7.07 1.41-1.41L2.81 2.81 1.39 4.22zm9.9 9.9l-5.46 5.46-1.41-1.41 5.46-5.46 1.41 1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$82db193f77ee4c2c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.47 5.2c-.47-.24-.96-.44-1.47-.61v12.03c-1.14-.41-2.31-.62-3.5-.62-1.9 0-3.78.54-5.5 1.58V5.48C10.38 4.55 8.51 4 6.5 4c-1.79 0-3.48.44-4.97 1.2-.33.16-.53.51-.53.88v12.08c0 .58.47.99 1 .99.16 0 .32-.04.48-.12C3.69 18.4 5.05 18 6.5 18c2.07 0 3.98.82 5.5 2 1.52-1.18 3.43-2 5.5-2 1.45 0 2.81.4 4.02 1.04.16.08.32.12.48.12.52 0 1-.41 1-.99V6.08c0-.37-.2-.72-.53-.88zM10 16.62C8.86 16.21 7.69 16 6.5 16s-2.36.21-3.5.62V6.71C4.11 6.24 5.28 6 6.5 6c1.2 0 2.39.25 3.5.72v9.9zM19 .5l-5 5V15l5-4.5V.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f1d6612dcc197eb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.03 6.3h-.06l-1.02 2.89h2.1zM3 17h2v5H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm-.63-10h1.25l2.63 7h-1.21l-.63-1.79h-2.83L9.96 12H8.74l2.63-7zM7 17h2v5H7zM11 17h2v5h-2zM15 17h6v5h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f0dd05ff6365acfe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.27 4.49c-.13.59-.2 1.15-.24 1.71l2.05 2.05c-.27-2.05.1-4.22 1.26-6.23-.12 0-.23-.01-.35-.01a9.9 9.9 0 00-5.5 1.65l1.46 1.46c.42-.24.86-.46 1.32-.63zm-7.88-.27l2.27 2.27A9.934 9.934 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.92-.63 5.5-1.67l2.28 2.28 1.41-1.41L2.81 2.81 1.39 4.22zm3.74 3.74l10.92 10.92C14.84 19.6 13.45 20 12 20c-4.41 0-8-3.59-8-8 0-1.48.42-2.85 1.13-4.04z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4e02fd00daffa5ea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.27 4.49c-1.63 7.54 3.75 12.41 7.66 13.8A7.993 7.993 0 0112 20c-4.41 0-8-3.59-8-8 0-3.45 2.2-6.4 5.27-7.51m2.72-2.48C6.4 2.01 2 6.54 2 12c0 5.52 4.48 10 10 10 3.71 0 6.93-2.02 8.66-5.02-7.51-.25-12.09-8.43-8.32-14.97h-.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa6a6ea7d566da98(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa2c3ae782f4917f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e6c31b74f3dfd59(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.8 11.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "10",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "14",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 20.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7-7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-18 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "18",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "14",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 5.27L6 8.77l.28.28L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81A.875.875 0 0014 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78h.01l1.41-1.41L3.91 3.86 2.5 5.27z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$61e1cc066653a824(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$486134f7875e22b6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1d78b17544d31704(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4c4.41 0 8 3.59 8 8s-3.59 8-8 8c-.34 0-.68-.02-1.01-.07C10.9 17.77 12 14.95 12 12s-1.1-5.77-3.01-7.93C9.32 4.02 9.66 4 10 4m0-2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cc5f63c05d262f36(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.7 4.91A8 8 0 0117 12a8 8 0 01-4.3 7.09c1.46-2 2.3-4.46 2.3-7.09s-.84-5.09-2.3-7.09M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54s-2.94 8.27-7 9.54c.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$98563e90b293535e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12.29 7c-.74 0-1.45.17-2.08.46 1.72.79 2.92 2.53 2.92 4.54s-1.2 3.75-2.92 4.54c.63.29 1.34.46 2.08.46 2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d302590bd2bafaf5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5c-3.03 0-5.5 2.47-5.5 5.5s2.47 5.5 5.5 5.5 5.5-2.47 5.5-5.5-2.47-5.5-5.5-5.5zm0 9c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85c56d955303a6e6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5v11c3.03 0 5.5-2.47 5.5-5.5S15.03 6.5 12 6.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ecacd9be30c954f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5c-3.03 0-5.5 2.47-5.5 5.5s2.47 5.5 5.5 5.5 5.5-2.47 5.5-5.5-2.47-5.5-5.5-5.5zm0 9c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c5826f77325cefc8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-4.58l.99.99 4-4 4 4 4-3.99L19 12.43V19zm0-9.41l-1.01-1.01-4 4.01-4-4-4 4-.99-1V5h14v4.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b1519170b1cc865(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96a.996.996 0 000-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$14dfb44cc0591870(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 12H11V7h10v10zm-3.57-4.38l-2 2.57L14 13.47l-2 2.52h8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$62be3125c9ef9d82(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l1.83-2h4.24l1.83 2H20v12zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$29c8c56295ce218a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20v2h5v2l3-3-3-3v2zm9 0h5v2h-5zM11.99 8C13.1 8 14 7.1 14 6s-.9-2-2.01-2S10 4.9 10 6s.89 2 1.99 2zM17 0H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 16H7v-2h10v2zm0-3.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2h10v10.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c42890f5db4e23fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20v2h5v2l3-3-3-3v2zm9 0h5v2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 16H7V2h10v14zm-5-9c1.1 0 2-.9 1.99-2 0-1.1-.9-2-2-2S10 3.9 10 5s.89 2 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d012c085e089f724(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm6 13h-8v2H4V5h3V3h2v2h3v2h8v11zM9 15h2v2H9zm0-7h2v2H9zm4 7h2v2h-2zm0-7h2v2h-2zm4 7h2v2h-2zm0-7h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$108c6dba5034a184(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 2.26l-.08-.04-.01.02C13.46 2.09 12.74 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-4.75-3.31-8.72-7.75-9.74zM19.41 9h-7.99l2.71-4.7c2.4.66 4.35 2.42 5.28 4.7zM13.1 4.08L10.27 9l-1.15 2L6.4 6.3A7.958 7.958 0 0112 4c.37 0 .74.03 1.1.08zM5.7 7.09L8.54 12l1.15 2H4.26C4.1 13.36 4 12.69 4 12c0-1.85.64-3.55 1.7-4.91zM4.59 15h7.98l-2.71 4.7A8.033 8.033 0 014.59 15zm6.31 4.91L14.89 13l2.72 4.7A8 8 0 0112 20c-.38 0-.74-.04-1.1-.09zm7.4-3l-4-6.91h5.43c.17.64.27 1.31.27 2 0 1.85-.64 3.55-1.7 4.91z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac60416c721e1d80(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9H1v11c0 1.11.89 2 2 2h17v-2H3V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5V3c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H5v11c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5h-5zm-6-2h4v2h-4V3zm9 13H7V7h14v9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ee48a763a1473c8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5zm-5 3c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm-7 0H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$693f5a9ccc70da58(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm7 3c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm7-11h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1f90be7c47bc699d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$240fc91355904fe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3 2v5l-1-.75L15 9V4h2zm3 12H8V4h5v9l3-2.25L19 13V4h1v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de22e2f541b36c3d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 9.67l1.69 2.26 2.48-3.1L19 15H9zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$22bd73dd37801150(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67A2.5 2.5 0 0112 22zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5a.54.54 0 00-.14-.35c-.41-.46-.63-1.05-.63-1.65a2.5 2.5 0 012.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f53069f86d1db4bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 5.41l.92.92-2.69 2.69-.92-.92 2.69-2.69M17.67 3c-.26 0-.51.1-.71.29l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42l-2.34-2.34c-.2-.19-.45-.29-.7-.29zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$34d2ecf59a8aca28(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$908222a9a99a2ad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm1-17.93c3.94.49 7 3.85 7 7.93s-3.05 7.44-7 7.93V4.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5d7ef8e457084fa8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3V8zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16A6.99 6.99 0 012 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2eb6d774437e9435(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5bf9d89ec26710e6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16ce26b25cd9ff7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d4f45ab3e8ec485d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d647a4631b915d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e98d0bd9fbfaa55a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$faf505849a8425f0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3f7e06536be07a3b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$73b5f0f1a511ccca(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1698ec2f098fd734(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5acb0ada98adcc9a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8a2 2 0 00-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8a2 2 0 002 2h8v2h2v-2h2v-2H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a37f3c3ee6ac8818(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19b693f749f145ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eb9a9451bfa0f465(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.06 11.57c.59-.69.94-1.59.94-2.57 0-1.86-1.27-3.43-3-3.87V3h-2v2h-2V3H9v2H6v2h2v10H6v2h3v2h2v-2h2v2h2v-2c2.21 0 4-1.79 4-4 0-1.45-.78-2.73-1.94-3.43zM10 7h4c1.1 0 2 .9 2 2s-.9 2-2 2h-4V7zm5 10h-5v-4h5c1.1 0 2 .9 2 2s-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8aa306b03e201069(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5V3H7v13H5v2h2v3h2v-3h4v-2H9v-3h8v-2H9V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d69758fe7961bcb9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8.76V3h2v4.51L15 5v2.36l-4 2.51.01 2.35L15 9.72v2.36l-4 2.51V19c2.76 0 5-2.24 5-5h2c0 3.87-3.13 7-7 7H9v-5.16l-3 1.88v-2.36l3-1.88v-2.36L6 13v-2.36l3-1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6df49098aa5b561(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21c1.93 0 3.62-1.17 4-3l-1.75-.88C16 18.21 15.33 19 14 19H9.1c.83-1 1.5-2.34 1.5-4 0-.35-.03-.69-.08-1H14v-2H9.82C9 10.42 8 9.6 8 8a3.5 3.5 0 016.78-1.22L16.63 6c-.8-2.05-2.79-3.5-5.13-3.5C8.46 2.5 6 4.96 6 8c0 1.78.79 2.9 1.49 4H6v2h2.47c.08.31.13.64.13 1 0 2.7-2.6 4-2.6 4v2h8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f96b99034fdf7f8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 3H7v9H5v2h2v2H5v2h2v3h2v-3h4v-2H9v-2h4.5c3.04 0 5.5-2.46 5.5-5.5S16.54 3 13.5 3zm0 9H9V5h4.5C15.43 5 17 6.57 17 8.5S15.43 12 13.5 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6da35b9c09e58dad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.66 7c-.56-1.18-1.76-2-3.16-2H6V3h12v2h-3.26c.48.58.84 1.26 1.05 2H18v2h-2.02c-.25 2.8-2.61 5-5.48 5h-.73l6.73 7h-2.77L7 14v-2h3.5c1.76 0 3.22-1.3 3.46-3H6V7h7.66z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b94481415b224e65(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.92 11H18v2h-5v2h5v2h-5v4h-2v-4H6v-2h5v-2H6v-2h4.08L5 3h2.37L12 10.29 16.63 3H19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$61133721ab016f38(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.28 12H18v2h-5v7h-2v-7H6v-2h4.72L5 3h2.37L12 10.29 16.63 3H19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eadf3e6004fa59ef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "14",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "10",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3",
                    "cy": "10",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3",
                    "cy": "14",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "21",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "3",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "14",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "10",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "18",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v2c3.86 0 7 3.14 7 7s-3.14 7-7 7v2c4.96 0 9-4.04 9-9s-4.04-9-9-9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9569dd2b03cf2f76(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20V6H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$69abfd6b7c5342ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L2 21h20L12 3zm1 5.92L18.6 19H13V8.92zm-2 0V19H5.4L11 8.92z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$16059024e2fdb2e6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-7.02c-.22-.84-.52-1.76-.13-2.33.81-1.12 2.67 1.77 3.81-.09.77-1.57-1.58-1.29-1.64-2.12-.05-.84 3.68.17 3.04-1.66-.61-1.73-2.42.48-2.76-.53-.58-1.74 4.7-1.68 2.85-4.01-1.76-2.22-2.47 2.85-4.41 2.33-1.34-.36-1.01-2.88-2.65-2.44-1.88.51 1.03 2.2 0 2.86-.96.63-1.72-.92-2.51-1.19-.2-.07-.69-.05-.91.19-.78.86.28 1.16.25 1.91-.02.75-1.59.49-1.51 1.49.12 1.6 2.18.45 2.4 1.24.55 1.98-1.89 2.15-.5 3.27 1.53.71 1.91-1.94 2.8-1.35.58.38.3 1.45.16 2.43H4V7h4.05l1.83-2h4.24l1.83 2H20v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.28 17.15c0 .48.39.86.86.86.48 0 .86-.38.86-.86s-.39-.86-.86-.86c-.48 0-.86.38-.86.86z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$170b741d5fff5c47(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5cf1a32b950eb9c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18.5A6.48 6.48 0 019.24 15H15l1-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15l1-2H9.24A6.491 6.491 0 0115 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3A8.955 8.955 0 0015 3c-3.92 0-7.24 2.51-8.48 6H3l-1 2h4.06a8.262 8.262 0 000 2H3l-1 2h4.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$58cf223ca48e2ad2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c297284f0c8eef20(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17s.41-.78.54-1.17.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71A5.72 5.72 0 0016.47 5c-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49s.6-.18.96-.18c.31 0 .58.05.81.15s.43.25.59.43.28.4.37.65c.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f619712e5e9bb0d7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ae5e366fb7bf130(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17s.41-.78.54-1.17c.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71A5.72 5.72 0 0017.47 5c-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49s.6-.18.96-.18c.31 0 .58.05.81.15s.43.25.59.43.28.4.37.65c.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$81910964e79a8416(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.14 12.5c0 1-.1 1.85-.3 2.55s-.48 1.27-.83 1.7c-.36.44-.79.75-1.3.95s-1.07.3-1.7.3c-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95s-.65-1.01-.85-1.7c-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04h-.01zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19s-.61.06-.86.18-.47.31-.64.58-.31.62-.4 1.06-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19.62-.06.87-.19.46-.33.63-.61.3-.64.39-1.09.13-.99.13-1.62v-2.66h-.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$960d5ebb9dd1ea30(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1.41 2L5 17.59V5h12.59zM6.41 19L19 6.41V19H6.41zM6 7h5v1.5H6zm10 5.5h-1.5v2h-2V16h2v2H16v-2h2v-1.5h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f92ecca70cedcbb9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.89 10.75c.07.41.11.82.11 1.25 0 4.41-3.59 8-8 8s-8-3.59-8-8c0-.05.01-.1 0-.14 2.6-.98 4.69-2.99 5.74-5.55 3.38 4.14 7.97 3.73 8.99 3.61l-.89-1.93c-.13.01-4.62.38-7.18-3.86 1.01-.16 1.71-.15 2.59-.01 2.52-1.15 1.93-.89 2.76-1.26A9.62 9.62 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-1.43-.3-2.78-.84-4.01l-1.27 2.76zM8.08 5.03a8.046 8.046 0 01-3.66 4.44 8.046 8.046 0 013.66-4.44z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 4.5l-2.4-1.1L19.5 1l-1.1 2.4L16 4.5l2.4 1.1L19.5 8l1.1-2.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$abe95991138a83d8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 10c.75 0 1.47-.09 2.17-.24.21.71.33 1.46.33 2.24 0 1.22-.28 2.37-.77 3.4l1.49 1.49A9.981 9.981 0 0022 12c0-5.52-4.48-10-10-10-1.78 0-3.44.47-4.89 1.28l5.33 5.33c1.49.88 3.21 1.39 5.06 1.39zm-6.84-5.88c.43-.07.88-.12 1.34-.12 2.9 0 5.44 1.56 6.84 3.88-.43.07-.88.12-1.34.12-2.9 0-5.44-1.56-6.84-3.88zM1.89 3.72l2.19 2.19A9.958 9.958 0 002 12c0 5.52 4.48 10 10 10 2.29 0 4.4-.78 6.09-2.08l2.19 2.19 1.41-1.41L3.31 2.31 1.89 3.72zm14.77 14.77A7.91 7.91 0 0112 20c-4.41 0-8-3.59-8-8 0-.05.01-.1 0-.14a9.946 9.946 0 003.64-2.39l9.02 9.02zM6.23 8.06c-.53.55-1.14 1.03-1.81 1.41.26-.77.63-1.48 1.09-2.13l.72.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4bbe7a4174ee7491(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af4bb24e9d256c19(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2a2 2 0 002-2V7a2 2 0 00-2-2h-4v2h4v2h-2a2 2 0 00-2 2v4h6v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a18a5c6253ca46db(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 00-2-2h-4v2h4v2h-2v2h2v2h-4v2h4a2 2 0 002-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$acbd1057c0ea77ff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4add4e776140879(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2a2 2 0 00-2-2h-2V7h4V5h-6v6h4v2h-4v2h4a2 2 0 002-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$329a4876b0f3df98(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2a2 2 0 002-2v-2a2 2 0 00-2-2h-2V7h4V5h-4a2 2 0 00-2 2v6a2 2 0 002 2zm0-4h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7807f3bfccb3095c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$43fb8eed20449b33(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2a2 2 0 002-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 00-2-2h-2a2 2 0 00-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13a2 2 0 002 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3756c13f7c984864(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8a2 2 0 00-2-2h-1a2 2 0 00-2 2v1a2 2 0 002 2h1v1H9v2h3a2 2 0 002-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ccd89ac6ccbf688c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2a2 2 0 00-2 2v2a2 2 0 002 2h2v2h-4v2h4a2 2 0 002-2V7a2 2 0 00-2-2zm0 4h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8684955f6c1b8f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4cb6c21c64376b91(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a06fde057a20fc3e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4a7.48 7.48 0 00-6.64 4.04A5.996 5.996 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d820f90e69eb08ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM6 18h12V8H6v10zm2-8h8v6H8v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$30f318617a761d19(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$69bc2e4e07d5a40b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cc59a291925a669(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0111 4.07zm7.32.19A9.949 9.949 0 0013 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1a7.941 7.941 0 011.62 3.9zM5.69 7.1L4.26 5.68A9.949 9.949 0 002.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 014.07 13zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43a9.981 9.981 0 002.21-5.32h-2.02a7.945 7.945 0 01-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19A9.981 9.981 0 0011 21.95v-2.02a7.941 7.941 0 01-3.9-1.62l-1.42 1.43z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f79744a1e8ca892c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.7 12.4a6.06 6.06 0 00-.86-.4c.29-.11.58-.24.86-.4a6.012 6.012 0 003-5.19c-.91-.52-1.95-.8-3.01-.8-1.02 0-2.05.26-2.99.8-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-.94-.54-1.97-.8-2.99-.8-1.05 0-2.1.28-3.01.8a5.97 5.97 0 003 5.19c.28.16.57.29.86.4-.29.11-.58.24-.86.4a6.012 6.012 0 00-3 5.19c.91.52 1.95.8 3.01.8 1.02 0 2.05-.26 2.99-.8.28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54.94.54 1.97.8 2.99.8 1.05 0 2.1-.28 3.01-.8a6.012 6.012 0 00-3-5.19zm-2.54-3.88c.21-.17.38-.29.54-.37.61-.35 1.3-.54 2-.54.27 0 .53.03.79.08-.31.91-.94 1.69-1.78 2.18-.17.1-.36.18-.58.27l-1.38.52c-.17-.46-.41-.87-.72-1.24l1.13-.9zM12 3.37c.63.72 1 1.66 1 2.63 0 .19-.02.41-.05.63l-.23 1.44C12.48 8.03 12.24 8 12 8s-.48.03-.71.07l-.23-1.44C11.02 6.41 11 6.19 11 6c0-.98.37-1.91 1-2.63zM4.51 7.68c.26-.06.53-.08.8-.08.69 0 1.38.18 1.99.54.15.09.32.2.49.35l1.15.96c-.3.36-.53.76-.7 1.2l-1.38-.52c-.21-.09-.4-.18-.56-.27-.87-.5-1.49-1.27-1.79-2.18zm3.33 7.79c-.21.17-.38.29-.54.37-.61.35-1.3.54-2 .54-.27 0-.53-.03-.79-.08.31-.91.94-1.69 1.78-2.18.17-.1.36-.18.58-.27l1.38-.52c.16.46.41.88.72 1.24l-1.13.9zM12 20.63c-.63-.72-1-1.66-1-2.63 0-.2.02-.41.06-.65l.22-1.42c.23.04.47.07.72.07.24 0 .48-.03.71-.07l.23 1.44c.04.22.06.44.06.63 0 .98-.37 1.91-1 2.63zm6.69-4.24a3.916 3.916 0 01-2.48-.88l-1.15-.96c.3-.36.54-.76.7-1.21l1.38.52c.22.08.41.17.57.26.85.49 1.47 1.27 1.78 2.18-.27.07-.54.09-.8.09z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19563a48c5c43eea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da6bb704b6bf560e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e61898a06e347031(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$424c8905ef08f999(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10h-3.61l2.28 2.28zm0-8H7v1.61l6.13 6.13zm-13.59.86L2 4.27l5 5V13h3v9l3.58-6.15L17.73 20l1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c715bc31f95805c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2v11h3v9l7-12h-4l3-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8ccfb300de839b28(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3zm4 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10V8H5.09C6.47 5.61 9.05 4 12 4c3.72 0 6.85 2.56 7.74 6h2.06c-.93-4.56-4.96-8-9.8-8-3.27 0-6.18 1.58-8 4.01V4H2v6h6zM16 14v2h2.91c-1.38 2.39-3.96 4-6.91 4-3.72 0-6.85-2.56-7.74-6H2.2c.93 4.56 4.96 8 9.8 8 3.27 0 6.18-1.58 8-4.01V20h2v-6h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$62b757859f9b871(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l.59-.65L9.88 5h4.24l1.24 1.35.59.65H20v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c-2.21 0-4-1.79-4-4h2l-2.5-2.5L5 13h2c0 2.76 2.24 5 5 5 .86 0 1.65-.24 2.36-.62l-.74-.74c-.49.23-1.04.36-1.62.36zM12 8c-.86 0-1.65.24-2.36.62l.74.73C10.87 9.13 11.42 9 12 9c2.21 0 4 1.79 4 4h-2l2.5 2.5L19 13h-2c0-2.76-2.24-5-5-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9cadcebb3c65453e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$35d6d3bfacd59208(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v2h-2V9zm-2 2h2v2H9v-2zm4 0h2v2h-2v-2zm2-2h2v2h-2V9zM7 9h2v2H7V9zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1155d4eeee9167b8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$86d81321cf8edcea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4v.89l2 2V4h4v4h-2.89l2 2H14v.89l2 2V10h4v4h-2.89l2 2H20v.89l2 2V4c0-1.1-.9-2-2-2H5.11l2 2H8zm8 0h4v4h-4V4zM1.41 1.14L0 2.55l2 2V20c0 1.1.9 2 2 2h15.45l2.01 2.01 1.41-1.41L1.41 1.14zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.55V20zm2 0v-1.45L17.45 20H16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7d0efaacf2c7d6ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a59c5fe66ef74fdc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm0 2C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm1 7h-2V9H9V7h2V5h2v2h2v2h-2v2zm11 9h-2v2h-1.5v-2h-2v-1.5h2v-2H22v2h2V20zm-6-1.5c0 .6-.4 1.1-.9 1.4L18 22h-1.5l-.9-2h-1.1v2H13v-6h3.5c.8 0 1.5.7 1.5 1.5v1zm-1.5 0v-1h-2v1h2zm-13-.5v-2H5v6H3.5v-2.5h-2V22H0v-6h1.5v2h2zm6.5-2c.8 0 1.5.7 1.5 1.5v3c0 .8-.7 1.5-1.5 1.5H6.5v-6H10zm0 4.5v-3H8v3h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9765de4967480976(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.86L17.14 15h.36zm0-4.5h2v1h-2v-1zm-4.5 0v.36l1.5 1.5V10.5c0-.8-.7-1.5-1.5-1.5h-1.86l1.5 1.5H13zM2.51 2.49L1.45 3.55 6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.06-1.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1d438b2ce6eba9c8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8327dbe29a8045fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.13 19c1.15.64 2.47 1 3.87 1 4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8c0 2.52 1.17 4.77 3 6.24V13h3.5c.8 0 1.5.7 1.5 1.5v1c0 .6-.4 1.1-.9 1.4L12 19h-1.5l-.9-2H8.5v2h-.37zM12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm5.5 14H16v1.5h-1.5V16H13v-1.5h1.5V13H16v1.49h1.5V16zm-7-.5v-1h-2v1h2zm0-7.5V6H12v6h-1.5V9.5h-2V12H7V6h1.5v2h2zM16 6c.8 0 1.5.7 1.5 1.5v3c0 .8-.7 1.5-1.5 1.5h-3V6h3zm0 4.5v-3h-1.5v3H16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cbcabac07a380a6d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d2ff53e2bbc18487(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f75d970d26cd3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.73 12.02l3.98-3.98a.996.996 0 000-1.41l-4.34-4.34a.996.996 0 00-1.41 0l-3.98 3.98L8 2.29a1.001 1.001 0 00-1.41 0L2.25 6.63a.996.996 0 000 1.41l3.98 3.98L2.25 16a.996.996 0 000 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34a.996.996 0 000-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e471314aa7d5776(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 11h-1V9H3v6h1.5v-2.5h1V15H7V9H5.5zM21 11v-1c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h-1.5v.5h-1v-3h1v.5H21zM14.25 13.5L13.5 9H12l1 6h2.5l1-6H15zM8 9v6h3.5v-1.5h-2v-1h2V11h-2v-.5h2V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f20b5d0ca6bc6099(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v11.17l2 2V5c0-1.1-.9-2-2-2H5.83l2 2H19zM2.81 2.81L1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.41L2.81 2.81zM5 19V7.83l7.07 7.07-.82 1.1L9 13l-3 4h8.17l2 2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$43b72401c8656ceb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$882d8ddd2041a196(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9 21.9l-6.1-6.1-2.69-2.69L5 5 3.59 3.59 2.1 2.1.69 3.51 3 5.83V19c0 1.1.9 2 2 2h13.17l2.31 2.31 1.42-1.41zM5 19V7.83l6.84 6.84-.84 1.05L9 13l-3 4h8.17l2 2H5zM7.83 5l-2-2H19c1.1 0 2 .9 2 2v13.17l-2-2V5H7.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b18df6de74d8d22d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13v7H4V6h5.02c.05-.71.22-1.38.48-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5l-2-2zm-1.5 5h-11l2.75-3.53 1.96 2.36 2.75-3.54L16.5 18zm2.8-9.11c.44-.7.7-1.51.7-2.39C20 4.01 17.99 2 15.5 2S11 4.01 11 6.5s2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21 13.42 22.42 12 19.3 8.89zM15.5 9a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4344a24ff6cce4d8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cfe6dcce12948e43(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-2.76 1.12-5.26 2.93-7.07L12 12V2c5.52 0 10 4.48 10 10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$891e25fb3f95cce4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4151d2d8586c483e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f38da26e542e70af(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2a9 9 0 01-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2a9 9 0 019-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$99bdf40d24cb618c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3h-2c0 1.35-.31 2.63-.84 3.77l1.49 1.49C13.51 6.7 14 4.91 14 3zm7 9v-2c-1.91 0-3.7.49-5.27 1.35l1.49 1.49c1.15-.53 2.43-.84 3.78-.84zm0 4v-2c-.79 0-1.54.13-2.24.37l1.68 1.68c.19-.01.37-.05.56-.05zM10 3H8c0 .19-.04.37-.06.56l1.68 1.68c.25-.7.38-1.46.38-2.24zm-5.59-.14L3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97A8.99 8.99 0 013 12v2c2.72 0 5.2-.99 7.11-2.62l2.51 2.51C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.7l1.43 1.43A6.972 6.972 0 0014 21h2c0-1.06.33-2.03.89-2.84L19.73 21l1.41-1.41L4.41 2.86z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a6c2eb9eef1e2e1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de439d8427cdc496(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9v11H4V8h4.05l1.83-2H15V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-2zm.67-1.01H22A6.003 6.003 0 0016 2v1.33c2.58 0 4.66 2.08 4.67 4.66zm-2.67 0h1.33A3.327 3.327 0 0016 4.67V6c1.11 0 1.99.89 2 1.99zM7 14c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5zm8 0c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2523ff9736311590(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.68 14.98H6V9h1.71c1.28 0 1.71 1.03 1.71 1.71v2.56c0 .68-.42 1.71-1.74 1.71zm4.7-3.52v1.07H11.2v1.39h1.93v1.07h-2.25c-.4.01-.74-.31-.75-.71V9.75c-.01-.4.31-.74.71-.75h2.28v1.07H11.2v1.39h1.18zm4.5 2.77c-.48 1.11-1.33.89-1.71 0L13.77 9h1.18l1.07 4.11L17.09 9h1.18l-1.39 5.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.77 10.12h-.63v3.77h.63c.14 0 .28-.05.42-.16.14-.1.21-.26.21-.47v-2.52c0-.21-.07-.37-.21-.47a.72.72 0 00-.42-.15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6ffd43037d9eaa6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V9a2 2 0 00-2-2H9v2h4v2h-2v2h2v2H9v2h4a2 2 0 002-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8fc34e759f1e48f0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M.04 0h24v24h-24V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.04 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-14V5h14v14zm-6-2h2V7h-2v4h-2V7h-2v6h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc5ec21c3fe28ddf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4v-2a2 2 0 00-2-2h-2V9h4V7H9v6h4v2H9v2h4a2 2 0 002-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$881e972289be785d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17h2a2 2 0 002-2v-2a2 2 0 00-2-2h-2V9h4V7h-4a2 2 0 00-2 2v6a2 2 0 002 2zm0-4h2v2h-2v-2zm8-10H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$71df6c763bef721c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-7-2h2V7h-4v2h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e9be37f797186d15(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4h-4v-2h2a2 2 0 002-2V9a2 2 0 00-2-2H9v2h4v2h-2a2 2 0 00-2 2v4h6v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ace42b0dc55af70f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$54329288083d15e1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5694bb5014ff2b7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5c0-1.66-1.34-3-3-3-.62 0-1.19.19-1.67.5l4.15 4.15C9.8 6.18 10 5.61 10 5zM14 6c0-1.1.9-2 2-2s2 .9 2 2v9.17l2 2V6c0-2.21-1.79-4-4-4s-4 1.79-4 4v3.17l2 2V6zM2.1 2.1L.69 3.51 5.17 8H4l1 10h1c0 2.21 1.79 4 4 4s4-1.79 4-4v-1.17l6.49 6.49 1.41-1.41L2.1 2.1zM7.19 16h-.38l-.6-6h.96l.56.56L7.19 16zM12 18c0 1.1-.9 2-2 2s-2-.9-2-2h1l.56-5.61L12 14.83V18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b2a3e463c207a5d8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.22 7c.48-.53.78-1.23.78-2 0-1.66-1.34-3-3-3S4 3.34 4 5c0 .77.3 1.47.78 2h4.44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2c-2.21 0-4 1.79-4 4v12c0 1.1-.9 2-2 2s-2-.9-2-2h1l1-10H4l1 10h1c0 2.21 1.79 4 4 4s4-1.79 4-4V6c0-1.1.9-2 2-2s2 .9 2 2v16h2V6c0-2.21-1.79-4-4-4zM7.19 16h-.38l-.6-6h1.58l-.6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd0847952255ea2f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f66ab40579c70491(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.88 7.88l1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM7 5.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5zm5.03 3.49h-.07L10.8 12.3h2.39l-1.16-3.31zm-.74-1.49h1.43l3.01 8h-1.39l-.72-2.04h-3.23l-.73 2.04H8.28l3.01-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af06b61bda80fe61(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l2.27 2.27A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l2.27 2.27 1.41-1.42L2.81 2.81zM12 20c-4.41 0-8-3.59-8-8 0-1.48.41-2.86 1.12-4.06l10.93 10.94A7.869 7.869 0 0112 20zM12 4c4.41 0 8 3.59 8 8 0 1.48-.41 2.86-1.12 4.05l1.45 1.45A9.782 9.782 0 0022 12c0-5.52-4.48-10-10-10-2.04 0-3.93.61-5.51 1.66l1.45 1.45C9.14 4.41 10.52 4 12 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$54562c81bebb788(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.88 7.88l1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM7 5.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b6463f350b7df019(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.88 7.88l1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM7 5.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5zm4 9.5H9V9h2v6zm4 0h-2V9h2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$38d333887174d9d5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-1.19.22-2.32.6-3.38l1.88.68C4.17 10.14 4 11.05 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.95 0-1.85.17-2.69.48l-.68-1.89C9.69 2.22 10.82 2 12 2c5.52 0 10 4.48 10 10zM5.5 4C4.67 4 4 4.67 4 5.5S4.67 7 5.5 7 7 6.33 7 5.5 6.33 4 5.5 4zM11 16V8H9v8h2zm4 0V8h-2v8h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8321a434c5bf79df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4f59feb0fe74ae8b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11l-.94 2.06L7 14l2.06.94L10 17l.94-2.06L13 14l-2.06-.94zm8.01-7l2 4h-3l-2-4h-2l2 4h-3l-2-4h-2l2 4h-3l-2-4h-1c-1.1 0-1.99.9-1.99 2l-.01 12c0 1.1.9 2 2 2h16c1.1 0 1.99-.9 1.99-2V4h-3.99zm2 14h-16V6.47L5.77 10H16l-.63 1.37L14 12l1.37.63L16 14l.63-1.37L18 12l-1.37-.63L16 10h4.01v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d0eedd1301acf1fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9h-3.5v6H15v-1.5h2c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-.5 3H15v-1.5h1.5V12zM11.5 9H7c-.55 0-1 .45-1 1v5h1.5v-4.5h1v3H10v-3h1V15h1.5v-5c0-.55-.45-1-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 19V5h14v14H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$90d396a2e617e07c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3l.01 10.55c-.59-.34-1.27-.55-2-.55a4.001 4.001 0 100 8c2.22 0 3.99-1.79 3.99-4V7h4V3h-6zm-1.99 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19ef6bd02b336faa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h4V3h-6v4.61l2 2zm-2 3.44L4.41 2.86 3 4.27l9 9v.28c-.94-.54-2.1-.75-3.33-.32-1.34.48-2.37 1.67-2.61 3.07a4.007 4.007 0 004.59 4.65c1.96-.31 3.35-2.11 3.35-4.1v-1.58L19.73 21l1.41-1.41L12 10.44zM10 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dde07ac627b4e555(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7A6.98 6.98 0 0014 16.06V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88a7 7 0 006.17-6.95zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b06f94178a615f76(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16.12h-.03c3.49-.4 6.2-3.36 6.2-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7A6.98 6.98 0 0011 16.06V20H5v2h14v-2h-6v-3.88zM7.17 9.17c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5-5-2.24-5-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3e29fd53cbfaf2d8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.61 7.41L14.2 6l-6 6 6 6 1.41-1.41L11.03 12l4.58-4.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de157d91528656d6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.02 6L8.61 7.41 13.19 12l-4.58 4.59L10.02 18l6-6-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3e2b32d621a7da4a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67A2.5 2.5 0 0112 22zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5a.54.54 0 00-.14-.35c-.41-.46-.63-1.05-.63-1.65a2.5 2.5 0 012.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$820734334992852d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$937aab26d87bb662(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.5c-3.89 0-6.95-.84-8.69-1.43A.993.993 0 002 5.02V19c0 .68.66 1.17 1.31.95C5.36 19.26 8.1 18.5 12 18.5c3.87 0 6.66.76 8.69 1.45A.999.999 0 0022 19V5c0-.68-.66-1.17-1.31-.95-2.03.68-4.83 1.45-8.69 1.45z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4019d655b023f4cb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16s-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7s-6.18-.55-9.12-1.64A.94.94 0 002.57 4c-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64s6.18.55 9.12 1.64c.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6f2153806d793a1a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.95 8.15c-.29-.16-.61-.31-.93-.46C19.4 4.33 15.98 2 12 2 8.02 2 4.6 4.33 2.99 7.68c-.33.15-.64.3-.93.46C1.41 8.5 1 9.17 1 9.91v4.18c0 .74.41 1.41 1.05 1.77.29.16.61.31.93.46C4.6 19.67 8.02 22 12 22c3.98 0 7.4-2.33 9.01-5.68.33-.15.64-.3.93-.46.65-.36 1.06-1.03 1.06-1.77V9.91c0-.74-.41-1.41-1.05-1.76zM12 4c2.37 0 4.49 1.04 5.95 2.68C16.17 6.25 14.15 6 12 6c-2.15 0-4.17.25-5.95.68A7.943 7.943 0 0112 4zm0 16c-2.37 0-4.49-1.04-5.95-2.68 1.78.43 3.8.68 5.95.68s4.17-.25 5.95-.68A7.943 7.943 0 0112 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9b006b2e3b71876c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.95 8.15c-.29-.16-.61-.31-.93-.46C19.4 4.33 15.98 2 12 2 8.02 2 4.6 4.33 2.99 7.68c-.33.15-.64.3-.93.46C1.41 8.5 1 9.17 1 9.91v4.18c0 .74.41 1.41 1.05 1.77.29.16.61.31.93.46C4.6 19.67 8.02 22 12 22c3.98 0 7.4-2.33 9.01-5.68.33-.15.64-.3.93-.46.65-.36 1.06-1.03 1.06-1.77V9.91c0-.74-.41-1.41-1.05-1.76zM21 9.91v4.19c-2.19 1.21-5.47 1.9-9 1.9-3.53 0-6.81-.7-9-1.91V9.91C5.2 8.69 8.47 8 12 8c3.53 0 6.81.7 9 1.91zM12 4c2.37 0 4.49 1.04 5.95 2.68C16.17 6.25 14.15 6 12 6c-2.15 0-4.17.25-5.95.68A7.943 7.943 0 0112 4zm0 16c-2.37 0-4.49-1.04-5.95-2.68 1.78.43 3.8.68 5.95.68s4.17-.25 5.95-.68A7.943 7.943 0 0112 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a0557b5ca28db520(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 12c0-3.89.84-6.95 1.43-8.69A.993.993 0 0018.98 2H5c-.68 0-1.16.66-.95 1.31C4.74 5.36 5.5 8.1 5.5 12c0 3.87-.76 6.66-1.45 8.69-.21.65.27 1.31.95 1.31h14c.68 0 1.17-.66.95-1.31-.68-2.03-1.45-4.83-1.45-8.69z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a82737a97ec0465d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12s.55-6.18 1.64-9.12a.94.94 0 00.06-.31c0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12s-.55 6.18-1.64 9.12c-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8s-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8s.39 5.4 1.16 8H6.54z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2855b93c7e96f1e0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-3.97 0-6.85.63-9 1-.55 1.97-1 3.92-1 7 0 3.03.45 5.05 1 7 2.15.37 4.98 1 9 1 3.97 0 6.85-.63 9-1 .57-2.02 1-3.99 1-7 0-3.03-.45-5.05-1-7-2.15-.37-4.98-1-9-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2f46bc0a8e763775(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36s-.24 3.58-.71 5.36c-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12s.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d881ea8c74fe497c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H3V6h18v12zm-6.5-7L11 15.51 8.5 12.5 5 17h14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4c012896d6c2a8a7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V4h5v7l2.5-1.5L16 11V4h2v16zm-4.38-6.5L17 18H7l2.38-3.17L11 17l2.62-3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa7f74581dfd26cb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l1.83-2h4.24l1.83 2H20v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 16L9 13l-3 4h12l-3.75-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6806213c51cdb97(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l1.83-2h4.24l1.83 2H20v12z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.78 14.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 008 16.43V17h8v-.57c0-.81-.48-1.53-1.22-1.85z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$62d2b5a0bcd51fed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.12 4l1.83 2H20v12H4V6h4.05l1.83-2h4.24M15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2zm-3 7c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9e1fb0a55a76e89d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10v9H4.98V5h9V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zm-2.94-2.06L17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7zM12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12l-2.75-1.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$428fe47f141feb9c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 9.67l1.69 2.26 2.48-3.1L19 15H9zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9f5041fcb5cd1f5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zm0 15.92c-.02.03-.06.06-.08.08H3V5.08L3.08 5h17.83c.03.02.06.06.08.08v13.84zm-10-3.41L8.5 12.5 5 17h14l-4.5-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$66623383179f6d56(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$15f9ba388bb04d2c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e2f677b0a92c34ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d918bbe6c53fabb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm12 6V9c0-.55-.45-1-1-1h-2v5h2c.55 0 1-.45 1-1zm-2-3h1v3h-1V9zm4 2h1v-1h-1V9h1V8h-2v5h1zm-8 0h1c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9v5h1v-2zm0-2h1v1h-1V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$49a613be268c885e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.58c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.42zM8.48 16c.74-.51 2.23-1 3.52-1s2.78.49 3.52 1H8.48zM19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b8bff34aa7ca1532(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.15 14.32l.59-2.36.76 3.04h1.48l1.5-6h-1.5l-.74 3-.74-3h-1.52l-.74 3-.74-3H14l.72 2.9zM1.39 4.22L6.17 9H3v6h1.5v-2h1.1l.9 2H8l-.9-2.1c.5-.3.9-.8.9-1.4v-.67l1.43 1.43L8.75 15h1.5l.38-1.5h.04l9.11 9.11 1.41-1.41L2.81 2.81 1.39 4.22zM6.5 11.5h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de18d9aff1a72f49(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 9H3v6h1.5v-2h1.1l.9 2H8l-.9-2.1c.5-.3.9-.8.9-1.4v-1C8 9.7 7.3 9 6.5 9zm0 2.5h-2v-1h2v1zM10.25 9l-1.5 6h1.5l.38-1.5h1.75l.37 1.5h1.5l-1.5-6h-2.5zm.75 3l.25-1h.5l.25 1h-1zM19.98 9l-.74 3-.74-3h-1.52l-.74 3-.74-3H14l1.5 6h1.48l.76-3.04.76 3.04h1.48l1.5-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f151687769ee0b09(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2v14H3v3c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V2l-1.5 1.5zM15 20H6c-.55 0-1-.45-1-1v-1h10v2zm4-1c0 .55-.45 1-1 1s-1-.45-1-1v-3H8V5h11v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7h6v2H9zM16 7h2v2h-2zM9 10h6v2H9zM16 10h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$21ed40eaf295f36b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.5a9.77 9.77 0 018.82 5.5c-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12A9.77 9.77 0 0112 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 5a2.5 2.5 0 010 5 2.5 2.5 0 010-5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7c08e828cabef532(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26A8.95 8.95 0 0013 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05a7.007 7.007 0 010 9.9 6.973 6.973 0 01-7.79 1.44l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64a8.98 8.98 0 000-12.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b82d74d1ac97e619(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13a9 9 0 0013.79 7.62l-1.46-1.46c-.99.53-2.13.84-3.33.84-3.86 0-7-3.14-7-7s3.14-7 7-7h.17L9.59 7.59 11 9l4-4-4-4-1.42 1.41L11.17 4H11a9 9 0 00-9 9zm9 0l6 6 6-6-6-6-6 6zm6 3.17L13.83 13 17 9.83 20.17 13 17 16.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4a844881a8f452a3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$939adf346256ec91(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11a7.906 7.906 0 00-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$20f1bd7771a7163e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 1H9v2h6V1zm4.03 6.39l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a8.994 8.994 0 007.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-.32-5H6.35a5.992 5.992 0 003.41 3.56l-.11-.06 2.03-3.5zm5.97-4a6.012 6.012 0 00-3.34-3.54L12.26 11h5.39zm-7.04 7.83c.45.11.91.17 1.39.17 1.34 0 2.57-.45 3.57-1.19l-2.11-3.9-2.85 4.92zM7.55 8.99A5.965 5.965 0 006 13c0 .34.04.67.09 1h4.72L7.55 8.99zm8.79 8.14A5.94 5.94 0 0018 13c0-.34-.04-.67-.09-1h-4.34l2.77 5.13zm-3.01-9.98C12.9 7.06 12.46 7 12 7c-1.4 0-2.69.49-3.71 1.29l2.32 3.56 2.72-4.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$52797306d94527f2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$62fe0b0f2a4f224b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc1099fbbfa73a8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98a2.013 2.013 0 00-1.81-1.23c-.26 0-.53.04-.79.15L7.1 5.95a1.999 1.999 0 00-1.08 2.6l4.96 11.97a1.998 1.998 0 002.6 1.08l7.36-3.05a1.994 1.994 0 001.09-2.6zm-9.2 3.8L7.87 7.79l7.35-3.04h.01l4.95 11.95-7.35 3.05z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "9",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.88 19.75c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$73d2080ae7a742e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM9.88 4h4.24l1.83 2H20v12H4V6h4.05"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11H9V8.5L5.5 12 9 15.5V13h6v2.5l3.5-3.5L15 8.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$607395c70400071e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h4v2l3-3-3-3v2H8V9l-3 3 3 3zm10-3.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zM16 17H4V7h12v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a3796508b0a5d123(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$31319a2432680563(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$171a0015ce40bd60(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12V6c0-1.66-1.34-3-3-3S5 4.34 5 6v6c-1.21.91-2 2.37-2 4 0 1.12.38 2.14 1 2.97V19h.02c.91 1.21 2.35 2 3.98 2s3.06-.79 3.98-2H12v-.03c.62-.83 1-1.85 1-2.97 0-1.63-.79-3.09-2-4zm-6 4c0-.94.45-1.84 1.2-2.4L7 13V6c0-.55.45-1 1-1s1 .45 1 1v7l.8.6c.75.57 1.2 1.46 1.2 2.4H5zM18.62 4h-1.61l-3.38 9h1.56l.81-2.3h3.63l.8 2.3H22l-3.38-9zm-2.15 5.39l1.31-3.72h.08l1.31 3.72h-2.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a8a8603e1b008ebb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 7.75A5.974 5.974 0 0012 5.99v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0a5.99 5.99 0 00-.01-8.48zM12 1.99c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da3b826dcc3c6c19(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M-.01 7.72V9.4l3-1V18h2V6h-.25L-.01 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38a6.64 6.64 0 01-.87-.23c-.23-.08-.41-.16-.55-.25s-.23-.19-.28-.3a.978.978 0 01.01-.8c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11s.35.17.48.29.22.26.29.42c.06.16.1.32.1.49h1.95A2.517 2.517 0 0023 9.81c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21s-.77.33-1.06.57c-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77s-.66.29-1.17.29c-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24a1.333 1.333 0 01-.59-1.11h-1.89c0 .36.08.71.24 1.05s.39.65.7.93c.31.27.69.49 1.15.66s.98.25 1.58.25c.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27s-1.11.09-1.59.27c-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89s1.01.28 1.59.28c.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89s.6-.94.78-1.6c.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53s-.2.76-.36 1.02c-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02s-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52s.21-.74.38-1c.16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99s.13.92.13 1.52v2.51h-.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7391e434f7aa0557(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.61 12.97c-.16-.24-.36-.46-.62-.65a3.38 3.38 0 00-.93-.48c.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33s.46-.12.73-.12c.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57s-.38.28-.63.37-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36s-.3-.34-.39-.56c-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23s.91-.38 1.26-.68c.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38a6.64 6.64 0 01-.87-.23c-.23-.08-.41-.16-.55-.25s-.23-.19-.28-.3c-.05-.11-.08-.24-.08-.39s.03-.28.09-.41.15-.25.27-.34c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11s.35.17.48.29.22.26.29.42c.06.16.1.32.1.49h1.95a2.517 2.517 0 00-.93-1.97c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21s-.77.33-1.06.57c-.29.24-.51.52-.67.84s-.23.65-.23 1.01.08.68.23.96.37.52.64.73c.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77s-.66.29-1.17.29c-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24a1.333 1.333 0 01-.59-1.11h-1.89c0 .36.08.71.24 1.05s.39.65.7.93c.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$276c9cef2fa8bdaa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1h6v2H9zM12 6c3.87 0 7 3.13 7 7 0 .94-.19 1.83-.52 2.65l1.5 1.5a8.963 8.963 0 00-.95-9.76l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42a8.962 8.962 0 00-9.77-.96l1.5 1.5A7.07 7.07 0 0112 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.17l2 2V8h-2zM2.81 2.81L1.39 4.22l3.4 3.4a8.994 8.994 0 0012.59 12.59l2.4 2.4 1.41-1.41L2.81 2.81zM12 20c-3.87 0-7-3.13-7-7 0-1.47.45-2.83 1.22-3.95l9.73 9.73A6.945 6.945 0 0112 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3e038ad6efba654d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a8.994 8.994 0 007.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac13fd104025f3c3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dfee56fcc7acbf4b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$23b8ee09209fe66e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$58258b26bfb6d59c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM16 18H4V6h12v12zm-4.38-6.5L9 15l-1.62-2.17L5 16h10l-3.38-4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85ee406e82cb5c3a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zm-2-.79V18H4V6h12v3.69z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "10",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 15.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 006 15.43V16h8v-.57z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db521dd26da608ab(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h2.95l-2.33 8.73L16.82 18H4zm11.62-2.39l-8.55-2.29L8.38 8.4l8.56 2.29-1.32 4.92zM20 18h-2.95l2.34-8.73L7.18 6H20v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2abaf269290d7250(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v16h20V4H2zm2 2h16v5H4V6zm0 12v-5h4v5H4zm6 0v-5h10v5H10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$490593cc94a4d846(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v16h20V4H2zm4.5 14H4v-2.5h2.5V18zm0-4.75H4v-2.5h2.5v2.5zm0-4.75H4V6h2.5v2.5zM11 18H8.5v-2.5H11V18zm0-4.75H8.5v-2.5H11v2.5zm0-4.75H8.5V6H11v2.5zm4.5 9.5H13v-2.5h2.5V18zm0-4.75H13v-2.5h2.5v2.5zm0-4.75H13V6h2.5v2.5zM20 18h-2.5v-2.5H20V18zm0-4.75h-2.5v-2.5H20v2.5zm0-4.75h-2.5V6H20v2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c741c03b99e64f8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5v14H3V5h18m0-2H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 5c3.25 0 6 1.83 6 4s-2.75 4-6 4-6-1.83-6-4 2.75-4 6-4m0-2c-4.42 0-8 2.69-8 6s3.58 6 8 6 8-2.69 8-6-3.58-6-8-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$829944e64ba396aa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.01 4C20.45 4 17.4 5.5 12 5.5c-5.31 0-8.49-1.49-9.01-1.49-.53 0-.99.44-.99 1.01V19c0 .57.46 1 .99 1 .57 0 3.55-1.5 9.01-1.5 5.42 0 8.44 1.5 9.01 1.5.53 0 .99-.43.99-1V5c0-.57-.46-1-.99-1zM20 17.63c-2.01-.59-4.62-1.13-8-1.13-3.39 0-5.99.54-8 1.13V6.38c2.58.73 5.32 1.12 8 1.12 3.38 0 5.99-.54 8-1.13v11.26z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 10.99l-3.69 4.42c2-.26 4.18-.41 6.52-.41 2.3 0 4.52.15 6.51.4L14 10l-2.83 3.39-2-2.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5fa2ac40cea60a7d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L9 7H7zm-.15 5.65L8 9l1.15 3.65h-2.3zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76l-.01.01C12.76 5.18 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c2.96 0 5.55-1.61 6.93-4 .03-.06.05-.12.08-.18.05-.08.09-.17.14-.25l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-8.63 7.67C12.38 16.64 10.35 18 8 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6c0 .96-.23 1.86-.63 2.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c1aa27b08abd65d1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 6c2.61 0 4.89 1.86 5.4 4.43l.3 1.5 1.52.11c1.56.11 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3h-13c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.457 5.457 0 0112.01 6m0-2C9.12 4 6.6 5.64 5.35 8.04 2.35 8.36.01 10.91.01 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96C18.68 6.59 15.65 4 12.01 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d0e8d77de6d33e37(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.55 19.09l1.41 1.41 1.79-1.8-1.41-1.41zM11 20h2v3h-2zM1 11h3v2H1zm12-6.95v3.96l1 .58c1.24.72 2 2.04 2 3.46 0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.42.77-2.74 2-3.46l1-.58V4.05h2m2-2H9v4.81C7.21 7.9 6 9.83 6 12.05c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19V2.05zM20 11h3v2h-3zm-2.76 7.71l1.79 1.8 1.41-1.41-1.8-1.79z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df9403ff2d9077cd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h14V9H5v6zm2-4h10v2H7v-2zm4-10h2v3h-2zm9.46 4.01L19.04 3.6l-1.79 1.79 1.41 1.41zM11 20h2v3h-2zm6.24-1.29l1.79 1.8 1.42-1.42-1.8-1.79zM4.96 3.595l1.788 1.79L5.34 6.79 3.553 5.003zM3.55 19.08l1.41 1.42 1.79-1.8-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5bf41eea2b9a4547(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12v2.5l5.5 5.5H22l-8-8zm0 8h3l-3-3v3zM8 4l-6 6h2v10h8V10h2L8 4zm1 10H7v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5d3e403173f64ce6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79zM1 10.5h3v2H1zM11 .55h2V3.5h-2zm8.04 2.495l1.408 1.407-1.79 1.79-1.407-1.408zm-1.8 15.115l1.79 1.8 1.41-1.41-1.8-1.79zM20 10.5h3v2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm-1 4h2v2.95h-2zm-7.45-.96l1.41 1.41 1.79-1.8-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dcb21e5c03dee6a7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.955 8.662l2.12-2.122 1.416 1.414-2.121 2.122zM2 18h20v2H2zM11 4h2v3h-2zM3.543 7.925L4.957 6.51l2.121 2.12-1.414 1.415zM5 16h14c0-3.87-3.13-7-7-7s-7 3.13-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7daaafc4c05f8354(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7C6.48 7 2 9.24 2 12c0 2.24 2.94 4.13 7 4.77V20l4-4-4-4v2.73c-3.15-.56-5-1.9-5-2.73 0-1.06 3.04-3 8-3s8 1.94 8 3c0 .73-1.46 1.89-4 2.53v2.05c3.53-.77 6-2.53 6-4.58 0-2.76-4.48-5-10-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2e6c0d68b8bc565c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4h15v2H2zM15 17h2v-3h1v-2l-1-5H2l-1 5v2h1v6h9v-6h4v3zm-6 1H4v-4h5v4zm-5.96-6l.6-3h11.72l.6 3H3.04z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 18h-3v-3h-2v3h-3v2h3v3h2v-3h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb58680f2b27387b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 1v3h3v2h-3v3h-2V6h-3V4h3V1h2zm-8 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm1-9.94v2.02A6.53 6.53 0 0012 5c-3.35 0-6 2.57-6 6.2 0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.79 6-9.14V11h2v.2c0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 6.22 7.8 3 12 3c.34 0 .67.02 1 .06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b5c66c645bead356(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6v3h3v2h-3v3h-2v-3H8V9h3V6h2zm5 4.2C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d8dec4e481786c26(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2zM18 4h2v9h-2zM4 4h2v16H4zM11 4h2v4h-2zM11 10h2v4h-2zM11 16h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ba646d09ea8dfdc8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h5c0-1.1-.9-2-2-2H4c-.55 0-1 .45-1 1s.45 1 1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 14.06V8c0-1.1-.9-2-2-2h-6.29l-1.06-1.06 1.41-1.41-.71-.71-3.53 3.53.71.71 1.41-1.41L13 6.71V9c0 1.1-.9 2-2 2H8.96c-.22-.16-.45-.3-.69-.43l-.4.89-.46-.21.4-.9C7.26 10.13 6.64 10 6 10c-.53 0-1.04.11-1.52.26l.34.91-.47.18-.35-.93a4.92 4.92 0 00-2.43 2.31l.89.4-.21.46-.9-.4C1.13 13.74 1 14.36 1 15c0 .53.11 1.04.26 1.52l.91-.34.18.47-.93.35a4.92 4.92 0 002.31 2.43l.4-.89.46.21-.4.9c.55.22 1.17.35 1.81.35.53 0 1.04-.11 1.52-.26l-.34-.91.47-.18.35.93a4.92 4.92 0 002.43-2.31l-.89-.4.21-.46.9.4c.1-.26.18-.54.24-.82h5.16c-.02.17-.05.34-.05.51 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-.95-.38-1.81-1-2.44zM6 18c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm4.87-4c-.04-.18-.08-.35-.13-.52l-.91.34-.18-.47.93-.35H11c2.21 0 4-1.79 4-4V8h5v5.05c-.16-.02-.33-.05-.5-.05-.95 0-1.81.38-2.44 1h-6.19zm8.63 4c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d52602e7863d978f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8.7c-2.46 1.5-5.5 4.17-6 8.3h2v2H9v-2h2c-.5-4.5-4.37-8-9-8V7c4.39 0 8.22 2.55 10 6.3 1.38-2.97 3.86-5.03 5.96-6.31L14 7V5h7v7h-2V8.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a91eea44e09275e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 18H5.8l8.25-12h5.54l-2.25 12zM13 4L2 20h17l3-16h-9zm1.5 5a2.5 2.5 0 000 5 2.5 2.5 0 000-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9ff539994eb989c1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.78 11.16l-1.42 1.42a7.282 7.282 0 01-1.79-2.94l1.94-.49c.32.89.77 1.5 1.27 2.01zM11 6L7 2 3 6h3.02c.02.81.08 1.54.19 2.17l1.94-.49C8.08 7.2 8.03 6.63 8.02 6H11zm10 0l-4-4-4 4h2.99c-.1 3.68-1.28 4.75-2.54 5.88-.5.44-1.01.92-1.45 1.55-.34-.49-.73-.88-1.13-1.24L9.46 13.6c.93.85 1.54 1.54 1.54 3.4v5h2v-5c0-2.02.71-2.66 1.79-3.63 1.38-1.24 3.08-2.78 3.2-7.37H21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fca6e6d0f14ec88c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9v1.5h2.25V15h1.5v-4.5H14V9H8zM6 9H3c-.55 0-1 .45-1 1v5h1.5v-1.5h2V15H7v-5c0-.55-.45-1-1-1zm-.5 3h-2v-1.5h2V12zM21 9h-4.5c-.55 0-1 .45-1 1v5H17v-4.5h1V14h1.5v-3.51h1V15H22v-5c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a8c2dc8e24e7474c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.15 14.42c.23-.77.35-1.58.35-2.42s-.12-1.65-.35-2.42c.78-.6 1.02-1.7.51-2.58s-1.58-1.23-2.49-.85a8.53 8.53 0 00-4.18-2.42C13.85 2.75 13.01 2 12 2s-1.85.75-1.98 1.73a8.561 8.561 0 00-4.19 2.42c-.91-.38-1.98-.03-2.49.85s-.27 1.98.51 2.58c-.23.77-.35 1.58-.35 2.42s.12 1.65.35 2.42c-.78.6-1.02 1.7-.51 2.58s1.58 1.23 2.49.85c.4.42.83.79 1.3 1.12L5.78 22h1.88l.98-2.19c.44.19.9.34 1.38.46.13.98.97 1.73 1.98 1.73s1.85-.75 1.98-1.73c.46-.11.91-.26 1.34-.44L16.3 22h1.88l-1.34-3c.48-.34.93-.72 1.34-1.15.91.38 1.99.03 2.49-.85.5-.88.26-1.98-.52-2.58zm-6.59 4.33c-.37-.46-.93-.75-1.56-.75s-1.2.29-1.57.75c-.4-.09-.79-.21-1.16-.37l1.43-3.19a3.522 3.522 0 002.56.02l1.42 3.18c-.36.15-.73.27-1.12.36zm-3.08-6.73c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zm8.23 1.99c-.61.07-1.18.41-1.52.99-.32.56-.34 1.2-.12 1.75-.28.29-.58.55-.9.79l-1.5-3.35c.49-.59.78-1.34.78-2.16 0-1.89-1.55-3.41-3.46-3.41s-3.46 1.53-3.46 3.41c0 .8.28 1.54.75 2.13l-1.52 3.39c-.31-.23-.6-.48-.87-.76.26-.56.24-1.22-.09-1.79-.34-.59-.93-.94-1.56-.99-.22-.68-.33-1.4-.33-2.15 0-.64.09-1.26.25-1.85.66-.03 1.3-.38 1.65-1 .37-.63.35-1.38.01-1.98.92-.98 2.11-1.69 3.45-2.03.34.59.99 1 1.73 1s1.39-.4 1.73-1c1.34.34 2.53 1.07 3.44 2.05-.32.59-.33 1.33.03 1.95.35.6.96.95 1.6 1 .16.59.25 1.21.25 1.86 0 .75-.12 1.47-.34 2.15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7249657f66833dc7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12h4v1.5h-4zM14 15h4v1.5h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-9 0V4h2v5h-2V7zm9 13H4V9h5c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2h5v11z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.08 16.18c-.64-.28-1.34-.43-2.08-.43s-1.44.15-2.08.43c-.56.24-.92.78-.92 1.39V18h6v-.43c0-.61-.36-1.15-.92-1.39z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a8a27feecf2ecf15(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 10.94c.13-.32.1-.23.15-.39.3-1.21-.34-2.47-1.5-2.93l-2.01-.8c-.46-.18-.95-.21-1.41-.12-.11-.33-.29-.63-.52-.89-.48-.52-1.15-.81-1.85-.81h-2.71c-.71 0-1.38.29-1.85.81-.24.26-.42.56-.53.88-.46-.09-.95-.06-1.41.12l-2.01.8c-1.16.46-1.8 1.72-1.5 2.93l.15.38C1.1 15.55 1 15.55 1 16.38c0 .91.46 1.74 1.24 2.22 1.42.88 2.49.14 4-.61h11.53c1.52.76 1.86 1.01 2.63 1.01 1 0 2.61-.77 2.61-2.61-.01-.85-.13-.88-2.51-5.45zm-.38 5.99l-1.68-.84 1.08-2.7 1.41 2.71c.28.53-.29 1.09-.81.83zm-5.03-.94l.62-6.9c.03-.33.37-.54.68-.42l2.01.8c.22.09.34.31.31.54l-2.4 5.98h-1.22zm-7.41 0l-2.4-5.98c-.03-.23.09-.45.31-.54l2.01-.8c.31-.12.65.08.68.42l.62 6.9H7.68zm-4.61.11l1.41-2.72 1.08 2.71-1.68.84c-.52.26-1.09-.3-.81-.83zm7.08-8.56a.5.5 0 01.5-.54h2.71a.5.5 0 01.5.54l-.77 8.45h-2.17l-.77-8.45z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$53c5fce4229082d2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-7 19.6l-7-4.66V3h14v12.93l-7 4.67zm-2.01-7.42l-2.58-2.59L6 12l4 4 8-8-1.42-1.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b18a255724496363(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14h.74L8.82 5.56A2.009 2.009 0 006.87 4H3v2h3.87l1.42 6.25h-.01A6.008 6.008 0 004.09 17H0v2h6v-1c0-2.21 1.79-4 4-4zM19 8h-.82l-1.35-3.69A1.976 1.976 0 0014.96 3H11v2h3.96l1.1 3H10.4l.46 2H15c-.43.58-.75 1.25-.9 2h-2.79l.46 2h2.33c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5C24 10.2 21.8 8 19 8zm0 8c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.03 0 .06-.01.09-.01 1.68 0 3 1.32 3 3s-1.33 3-3.01 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7661877eb5972561(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3H6C3.79 3 2 4.79 2 7c0 1.48.81 2.75 2 3.45V19c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8.55c1.19-.69 2-1.97 2-3.45 0-2.21-1.79-4-4-4zm1 5.72l-1 .58V19H6V9.31l-.99-.58C4.38 8.35 4 7.71 4 7c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2 0 .71-.38 1.36-1 1.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.71 9.29C12.51 9.1 12.26 9 12 9s-.51.1-.71.29l-3 3a.996.996 0 000 1.41l3 3c.2.2.45.3.71.3s.51-.1.71-.29l3-3a.996.996 0 000-1.41l-3-3.01zM12 14.58L10.41 13 12 11.41 13.59 13 12 14.58z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5c703ab9880132f6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21.5c0 .28.22.5.49.5h13.02c.27 0 .49-.22.49-.5V20H2v1.5zM15.5 16H11v-2H7v2H2.5c-.28 0-.5.22-.5.5V18h14v-1.5c0-.28-.22-.5-.5-.5zM20.47 15.45A5.796 5.796 0 0022 11.51V2h-6v9.47c0 1.48.58 2.92 1.6 4l.4.42V22h4v-2h-2v-4.03l.47-.52zM18 4h2v4h-2V4zm1.03 10.07a3.893 3.893 0 01-1.03-2.6V10h2v1.51c0 .95-.34 1.85-.97 2.56z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1582b096b10d3409(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11V8h7.29C11.1 7.37 11 6.7 11 6H4.43c.83-.71 2.98-1.09 6.65-.98.1-.7.3-1.37.59-1.99C2.97 2.67 2 5.02 2 7v9.5c0 .95.38 1.81 1 2.44V21c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-2.06c.62-.63 1-1.49 1-2.44V13c-1.91 0-3.63-.76-4.89-2H4zm12 5c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-3h12v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 8h-1V8h1v1zm0-2h-1V3h1v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c9d78a55d80bfaf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 6h-1V3h1v4zm0 1v1h-1V8h1zM6 13.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S8.33 15 7.5 15 6 14.33 6 13.5zm13-.57a6.72 6.72 0 002-.6V19c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1H6v1c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-8l2.08-5.99C5.29 4.42 5.84 4 6.5 4h4.79c-.19.63-.29 1.31-.29 2H6.85L5.81 9h5.86c.36.75.84 1.43 1.43 2H5v5h14v-3.07zm-1.09.07a6.92 6.92 0 01-2.53-.51c-.23.27-.38.62-.38 1.01 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.18-.03-.34-.09-.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eed691bd16b04cb8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "16.5",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "16.5",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.25 9.6c-.02-.02-.03-.04-.05-.07-.38-.52-.92-.53-.92-.53H7.72s-.54.01-.92.54c-.02.02-.03.04-.05.06-.07.11-.14.24-.19.4-.22.66-.74 2.22-1.56 4.69v6.5c0 .45.35.81.78.81h.44c.43 0 .78-.36.78-.81V20h10v1.19c0 .45.34.81.78.81h.44c.43 0 .78-.36.78-.81v-6.5c-.82-2.46-1.34-4.03-1.56-4.69-.05-.16-.12-.29-.19-.4zM8.33 11h7.34l.23.69.43 1.31H7.67l.66-2zM17 18H7v-3h10v3zM10.83 3A3.01 3.01 0 008 1C6.34 1 5 2.34 5 4c0 1.65 1.34 3 3 3 1.3 0 2.41-.84 2.83-2H16v2h2V5h1V3h-8.17zM8 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$123fb97abfecd43b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10.5",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10.5",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.78 16h.44c.43 0 .78-.36.78-.81V14h10v1.19c0 .45.34.81.78.81h.44c.43 0 .78-.36.78-.81v-6.5L17.44 4c-.05-.16-.12-.29-.19-.4-.02-.02-.03-.04-.05-.07-.38-.52-.92-.53-.92-.53H7.72s-.54.01-.92.54c-.02.02-.03.04-.05.06-.07.11-.14.24-.19.4L5 8.69v6.5c0 .45.35.81.78.81zM8.33 5h7.34l.23.69.43 1.31H7.67l.66-2zM7 9.01V9h10v3H7V9.01zM4 17.01V19h7v3h2v-3h7v-1.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$47db74d2d6180568(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9v2h-2V3h-2v2h-2V3h-2v2h-2V3H9v2H7V3H5v8H3V9H1v12h9v-3c0-1.1.9-2 2-2s2 .9 2 2v3h9V9h-2zm0 10h-5v-1c0-2.21-1.79-4-4-4s-4 1.79-4 4v1H3v-6h4V7h10v6h4v6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h2v3H9zM13 9h2v3h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7e31089626f138c0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7a2.5 2.5 0 010-5 2.5 2.5 0 010 5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$beb321b198bf703e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22l14-5-9-9-5 14zm10.35-5.82L5.3 18.7l2.52-7.05 4.53 4.53zM14.53 12.53l5.59-5.59a1.25 1.25 0 011.77 0l.59.59 1.06-1.06-.59-.59a2.758 2.758 0 00-3.89 0l-5.59 5.59 1.06 1.06zM10.06 6.88l-.59.59 1.06 1.06.59-.59a2.758 2.758 0 000-3.89l-.59-.59-1.06 1.07.59.59c.48.48.48 1.28 0 1.76zM17.06 11.88l-1.59 1.59 1.06 1.06 1.59-1.59a1.25 1.25 0 011.77 0l1.61 1.61 1.06-1.06-1.61-1.61a2.758 2.758 0 00-3.89 0zM15.06 5.88l-3.59 3.59 1.06 1.06 3.59-3.59a2.758 2.758 0 000-3.89l-1.59-1.59-1.06 1.06 1.59 1.59c.48.49.48 1.29 0 1.77z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a4e3f2c432963554(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12.22V9l-5-2.5V5h2V3h-2V1h-2v2H9v2h2v1.5L6 9v3.22L2 14v8h9v-4c0-.55.45-1 1-1s1 .45 1 1v4h9v-8l-4-1.78zM20 20h-5v-2.04c0-1.69-1.35-3.06-3-3.06s-3 1.37-3 3.06V20H4v-4.79l4-1.81v-3.35L12 8l4 2.04v3.35l4 1.81V20z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$be02eb9451a23bd4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11h-1V3c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v8H8c-2.76 0-5 2.24-5 5v7h18v-7c0-2.76-2.24-5-5-5zm-5-8h2v8h-2V3zm8 18h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H9v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H5v-5c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fc3d85896472aeb9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-17C8.1 3 4.56 4.59 2 7.15l5 5a7.06 7.06 0 0110-.01l5-5C19.44 4.59 15.9 3 12 3zm4.84 6.47c-1.44-.91-3.1-1.4-4.84-1.4-1.74 0-3.41.49-4.85 1.41L4.94 7.26C6.99 5.79 9.44 5 12 5c2.56 0 5 .79 7.05 2.26l-2.21 2.21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3c0ba6bce4525a2f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4 17l1.3 4.4h-1.1L13 17h-3c-.55 0-1-.45-1-1s.45-1 1-1h3l2.6-4.4h1.1L15.4 15h2.85l.75-1h1l-.6 2 .6 2h-1l-.75-1H15.4zM5.75 7L5 6H4l.6 2-.6 2h1l.75-1H8.6l-1.3 4.4h1.1L11 9h3c.55 0 1-.45 1-1s-.45-1-1-1h-3L8.4 2.6H7.3L8.6 7H5.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1105ac3ce7a7d1a1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2.5c0 1.5-1.5 6-1.5 6h-2S9.5 4 9.5 2.5a2.5 2.5 0 015 0zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4.08-4.89c.18-.75.33-1.47.39-2.06A9.996 9.996 0 0122 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-3.92 2.25-7.31 5.53-8.95.07.59.21 1.32.39 2.06A8.028 8.028 0 004 12c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.93-1.58-5.49-3.92-6.89zM18 12c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2 .98-3.77 2.48-4.86.23.81.65 2.07.65 2.07C8.43 9.93 8 10.92 8 12c0 2.21 1.79 4 4 4s4-1.79 4-4c0-1.08-.43-2.07-1.13-2.79 0 0 .41-1.22.65-2.07A5.998 5.998 0 0118 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$37996055e052187c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 14H10V9H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 10.35V7zM4 14v-1c0-1.1.9-2 2-2h2v3H4zm3 3c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6h5v2H5zM19 13c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$60b5867589e6df5b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1a6.98 6.98 0 00-5.75 3.02C9.84 4.01 9.43 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V22c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22v-3.08c3.39-.49 6-3.39 6-6.92 0-3.87-3.13-7-7-7zM9 6h.29c-.09.32-.16.66-.21.99H3.34C3.89 6.46 5.31 6 9 6zM3 8.99h6.08c.16 1.11.57 2.13 1.18 3.01H3V8.99zM15 18c0 .37-.21.62-.34.73l-.29.27H3.63l-.29-.27A.968.968 0 013 18v-4h9.41c.78.47 1.65.79 2.59.92V18zm1-5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm.5-9H15v5l3.62 2.16.75-1.23-2.87-1.68z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$729679d236be338c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.97 7.27a.996.996 0 000-1.41l-2.83-2.83a.996.996 0 00-1.41 0l-4.49 4.49-3.89-3.89c-.78-.78-2.05-.78-2.83 0l-1.9 1.9c-.78.78-.78 2.05 0 2.83l3.89 3.89L3 16.76V21h4.24l4.52-4.52 3.89 3.89c.95.95 2.23.6 2.83 0l1.9-1.9c.78-.78.78-2.05 0-2.83l-3.89-3.89 4.48-4.48zM5.04 6.94l1.89-1.9L8.2 6.31 7.02 7.5l1.41 1.41 1.19-1.19 1.2 1.2-1.9 1.9-3.88-3.88zm11.23 7.44l-1.19 1.19 1.41 1.41 1.19-1.19 1.27 1.27-1.9 1.9-3.89-3.89 1.9-1.9 1.21 1.21zM6.41 19H5v-1.41l9.61-9.61 1.3 1.3.11.11L6.41 19zm9.61-12.44l1.41-1.41 1.41 1.41-1.41 1.41-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85f1cf68b6348a48(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5L2 9l10 12L22 9l-3-6zM9.62 8l1.5-3h1.76l1.5 3H9.62zM11 10v6.68L5.44 10H11zm2 0h5.56L13 16.68V10zm6.26-2h-2.65l-1.5-3h2.65l1.5 3zM6.24 5h2.65l-1.5 3H4.74l1.5-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f28251f3faf73e2e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19l2 2h16l2-2zM3 18h16.97c.29-3.26-2.28-6-5.48-6-2.35 0-4.35 1.48-5.14 3.55-.41-.23-.87-.38-1.35-.47V9h1.75C10.99 9 12 7.99 12 6.75h9v-1.5h-9C12 4.01 10.99 3 9.75 3H3v1.5h1v.75H3v1.5h1v.75H3V9h1v7.39c-.44.46-.78 1-1 1.61zm11.5-4c.99 0 1.91.4 2.58 1.14.24.26.44.55.58.86h-6.32c.58-1.21 1.81-2 3.16-2zM8 4.5h2v.75H8V4.5zm0 2.25h2v.75H8v-.75zM5.5 4.5h1v.75h-1V4.5zm0 2.25h1v.75h-1v-.75zM5.5 9h1v6.06c-.35.06-.68.17-1 .3V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5802fcf8f9fb631(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1f4ff203985024c2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 12.66l-1.12 3.97c-.78-.43-1.07-.86-2.65-2.67-1.6 1.82-2.43 3.04-4 3.04-1.53 0-2.34-1.15-4-3.04-1.6 1.82-1.87 2.21-2.65 2.65l-1.13-3.96L12 10.11l7.77 2.55zM15 1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.63.19-.81.84-.66 1.28L3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.91-6.68c.11-.37.04-1.06-.66-1.28l-1.3-.42V6c0-1.1-.9-2-2-2h-3V1zM6 9.97V6h12v3.97L12 8 6 9.97zm10 9.71c-1.22.85-2.61 1.28-4 1.28s-2.78-.43-4-1.28C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 1.26.64 2.63.97 4 .97s2.74-.32 4-.97c1.26.65 2.62.99 4 .99h2v-2h-2c-1.39 0-2.78-.47-4-1.32z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91fd4064687b6784(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3v1h-2V3h2m-1 7.11l5.38 1.77 2.39.78-1.12 3.97c-.54-.3-.94-.71-1.14-.94L16 13.96l-1.51 1.72c-.34.4-1.28 1.32-2.49 1.32s-2.15-.92-2.49-1.32L8 13.96l-1.51 1.72c-.2.23-.6.63-1.14.93l-1.13-3.96 2.4-.79L12 10.11M15 1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42a1.007 1.007 0 00-.66 1.28L3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1zM6 9.97V6h12v3.97L12 8 6 9.97zm10 9.71c-1.22.85-2.61 1.28-4 1.28s-2.78-.43-4-1.28C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 1.26.64 2.63.97 4 .97s2.74-.32 4-.97c1.26.65 2.62.99 4 .99h2v-2h-2c-1.39 0-2.78-.47-4-1.32z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b4e5749310493dbc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5c0 .95.38 1.81 1 2.44V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-2.06c.62-.63 1-1.49 1-2.44V6c0-3.5-3.58-4-8-4zm0 2c3.71 0 5.13.46 5.67 1H6.43c.6-.52 2.05-1 5.57-1zm6 11c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2v-3h12v3zm0-5H6V7h12v3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a701b35684d97bbc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4zm5.66 2.99H6.34C6.89 4.46 8.31 4 12 4s5.11.46 5.66.99zm.34 2V10H6V6.99h12zm-.34 9.74l-.29.27H6.63l-.29-.27A.968.968 0 016 16v-4h12v4c0 .37-.21.62-.34.73z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5015c8b61151c6f4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.04 3H5.81l1.04-3zM19 17H5v-5h14v5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2808f3864a434978(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee81d847d6b9de41(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm0 2c3.71 0 5.13.46 5.67 1H6.43c.6-.52 2.05-1 5.57-1zm6 11.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5H6V7h12v3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9270bbaef59292aa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1c-4.42 0-8 .5-8 4v10.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4zm0 2c6 0 6 1.2 6 2H6c0-.8 0-2 6-2zm6 4v3H6V7h12zm-1.5 10h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5c0 .83-.67 1.5-1.5 1.5zM12 12.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5d43c5f0652e8d26(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b8d2c9fe581fb932(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm0 2c3.71 0 5.13.46 5.67 1H6.43c.6-.52 2.05-1 5.57-1zM6 7h5v3H6V7zm12 8.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5h-5V7h5v3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4449987efe162db8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm5.66 3H6.43c.61-.52 2.06-1 5.57-1 3.71 0 5.12.46 5.66 1zM11 7v3H6V7h5zm2 0h5v3h-5V7zm3.5 10h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5c0 .83-.67 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f2f7fb92dd4fa5c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm0 2c3.71 0 5.13.46 5.67 1H6.43c.6-.52 2.05-1 5.57-1zM6 7h5v3H6V7zm12 8.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5h-5V7h5v3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3a65005e84f1fcbd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm5.66 3H6.43c.61-.52 2.06-1 5.57-1 3.71 0 5.12.46 5.66 1zM11 7v3H6V7h5zm2 0h5v3h-5V7zm3.5 10h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5c0 .83-.67 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b8c144f00b3ceec9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6a2.145 2.145 0 00-2.65-.84L6 8.3V13h2V9.6l1.8-.7"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$780cbf6ceb2e5707(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.43 10.59l-9.01-9.01c-.75-.75-2.07-.76-2.83 0l-9 9c-.78.78-.78 2.04 0 2.82l9 9c.39.39.9.58 1.41.58.51 0 1.02-.19 1.41-.58l8.99-8.99c.79-.76.8-2.02.03-2.82zm-10.42 10.4l-9-9 9-9 9 9-9 9zM8 11v4h2v-3h4v2.5l3.5-3.5L14 7.5V10H9c-.55 0-1 .45-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6f755a3a10a26c09(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.56 11.36L13 8.44V7c0-.55-.45-1-1-1s-1-.45-1-1 .45-1 1-1 1 .45 1 1h2c0-1.84-1.66-3.3-3.56-2.95-1.18.22-2.15 1.17-2.38 2.35-.3 1.56.6 2.94 1.94 3.42v.63l-6.56 2.92c-.88.38-1.44 1.25-1.44 2.2v.01C3 14.92 4.08 16 5.42 16H7v6h10v-6h1.58c1.34 0 2.42-1.08 2.42-2.42v-.01c0-.95-.56-1.82-1.44-2.21zM15 20H9v-5h6v5zm3.58-6H17v-1H7v1H5.42c-.46 0-.58-.65-.17-.81l6.75-3 6.75 3c.42.19.28.81-.17.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2aea17cb6e629665(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.63 7H6.37C3.96 7 2 9.24 2 12s1.96 5 4.37 5h11.26c2.41 0 4.37-2.24 4.37-5s-1.96-5-4.37-5zm0 8H6.37C5.09 15 4 13.63 4 12s1.09-3 2.37-3h11.26C18.91 9 20 10.37 20 12s-1.09 3-2.37 3zM7.24 13.06l-1.87-1.87-.7.7 2.57 2.57 4.22-4.22-.7-.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8dd85ae81b7a8607(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11h2.12l6.16-6.16-2.12-2.12L11 8.88V11zm9.71-9L20 1.29a.996.996 0 00-1.41 0l-.72.72 2.12 2.12.72-.72a.996.996 0 000-1.41zM17.9 9.05c.06.36.1.74.1 1.15 0 1.71-1.08 4.64-6 9.14-4.92-4.49-6-7.43-6-9.14C6 6.17 9.09 4 12 4c.32 0 .65.03.97.08l1.65-1.65A8.56 8.56 0 0012 2c-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8 0-1.01-.16-1.94-.45-2.8L17.9 9.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$abfae00d8b6f4667(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.17 4.91L17.1 3.84l-5.55 5.55v1.08h1.08l5.54-5.56zM16 2.74l1.29-1.29a1.49 1.49 0 012.12 0l1.15 1.15c.59.59.59 1.54 0 2.12l-.68.68-.02.02-.58.58-6 6H10V8.74l6-6zm-2.28-.55l-.55.55-1.27 1.27c-3.3.05-5.9 2.6-5.9 6.2 0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.79 6-9.14v-.1l1.8-1.8c.13.6.2 1.24.2 1.9 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8 0-4.98 3.8-8.2 8-8.2.58 0 1.16.06 1.72.18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$69b8d95a7ca55145(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h-2v7.9l2-2zM4 4h2v16H4zM10 4h2v4h-2zM10 10h2v4h-2zM10 16h2v4h-2zM22.56 12.59l-1.15-1.15a1.49 1.49 0 00-2.12 0L14 16.73V20h3.27l5.29-5.29c.59-.59.59-1.54 0-2.12zm-5.98 5.86h-1.03v-1.03L19 13.97 20.03 15l-3.45 3.45z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$82a0afa89c2c016e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9c-2-2-3.01-7-9.03-7C4.95 2 1.94 6 2 11.52 2.06 17.04 6.96 19 9.97 19c2.01 0 2.01 3 6.02 3C19 22 22 19 22 15.02 22 12 21.01 11 19 9zm-3.01 11c-1.49 0-1.96-.5-2.68-1.26-.65-.69-1.65-1.74-3.34-1.74-1.64 0-5.92-.99-5.97-5.5-.03-2.51.68-4.62 1.99-5.95C7.01 4.52 8.35 4 9.97 4c3.34 0 4.51 1.86 5.86 4.02.55.88 1.07 1.71 1.76 2.39 1.9 1.89 2.41 2.4 2.41 4.61 0 2.85-2.12 4.98-4.01 4.98z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c51fcaf2692b0e55(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C8.5 3 5 9.33 5 14c0 3.87 3.13 7 7 7s7-3.13 7-7c0-4.67-3.5-11-7-11zm0 16c-2.76 0-5-2.24-5-5 0-4.09 3.07-9 5-9s5 4.91 5 9c0 2.76-2.24 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16c-.58 0-3-.08-3-3 0-.55-.45-1-1-1s-1 .45-1 1c0 3 1.99 5 5 5 .55 0 1-.45 1-1s-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9f94685c9f0f2aec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-.82l-1.7-4.68A2.008 2.008 0 0014.6 1H12v2h2.6l1.46 4h-4.81l-.36-1H12V4H7v2h1.75l1.82 5H9.9c-.44-2.23-2.31-3.88-4.65-3.99C2.45 6.87 0 9.2 0 12c0 2.8 2.2 5 5 5 2.46 0 4.45-1.69 4.9-4h4.2c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5C24 9.2 21.8 7 19 7zM7.82 13c-.4 1.17-1.49 2-2.82 2-1.68 0-3-1.32-3-3s1.32-3 3-3c1.33 0 2.42.83 2.82 2H5v2h2.82zm6.28-2h-1.4l-.73-2H15c-.44.58-.76 1.25-.9 2zm4.9 4c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.02 0 .05-.01.08-.01 1.68 0 3 1.32 3 3s-1.32 3-3 3zM11 20H7l6 3v-2h4l-6-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$72d57307261b0d47(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 2.01C18.72 1.42 18.16 1 17.5 1h-11c-.66 0-1.21.42-1.42 1.01L3 8v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8l-2.08-5.99zM6.85 3h10.29l1.08 3.11H5.77L6.85 3zM19 13H5V8h14v5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20h4v-2l6 3h-4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f4f865d8fabbff4f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 12H10V7H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 8.35V5zM4 12v-1c0-1.1.9-2 2-2h2v3H4zm3 3c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4h5v2H5zM19 11c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM7 20h4v-2l6 3h-4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$44f85d9c02ada263(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.18V9.72c0-.47-.16-.92-.46-1.28L16.6 3.72c-.38-.46-.94-.72-1.54-.72H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h.18C3.6 16.16 4.7 17 6 17s2.4-.84 2.82-2h8.37a2.996 2.996 0 005.82-1c-.01-1.3-.85-2.4-2.01-2.82zM6 15c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1-3.83A3.014 3.014 0 003.17 13H3v-3h4v1.17zM7 8H3V5h4v3zm7 5H9v-3h3V8H9V5h5v8zm2-6.88L18.4 9H16V6.12zM17.17 13H16v-2h3v.17c-.85.3-1.53.98-1.83 1.83zM20 15c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM7 20h4v-2l6 3h-4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4fc24b0ed35d89fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.82 16H15v-1c0-2.21 1.79-4 4-4h.74l-1.9-8.44A2.009 2.009 0 0015.89 1H12v2h3.89l1.4 6.25h-.01A6.008 6.008 0 0013.09 14H7.82a2.996 2.996 0 00-3.42-1.94c-1.18.23-2.13 1.2-2.35 2.38A3.002 3.002 0 005 18c1.3 0 2.4-.84 2.82-2zM5 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM11 20H7l6 3v-2h4l-6-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a673886a6364088b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14c0-.55-.45-1-1-1h-2v2h2c.55 0 1-.45 1-1zM20 17h-2v2h2c.55 0 1-.45 1-1s-.45-1-1-1zM12 14h-2v4h2c0 1.1.9 2 2 2h3v-8h-3c-1.1 0-2 .9-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13c0-1.1.9-2 2-2h1.5c1.93 0 3.5-1.57 3.5-3.5S10.43 4 8.5 4H5c-.55 0-1 .45-1 1s.45 1 1 1h3.5c.83 0 1.5.67 1.5 1.5S9.33 9 8.5 9H7c-2.21 0-4 1.79-4 4s1.79 4 4 4h2v-2H7c-1.1 0-2-.9-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$207c1553c04b374a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM16 18H4V6h12v12zm-4-6l3 1.73-1 1.73-3-1.73V17H9v-3.27l-3 1.73-1-1.73L8 12l-3-1.73 1-1.73 3 1.73V7h2v3.27l3-1.73 1 1.73L12 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cbd1b20aeaa486fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c1.93 0 3.68.78 4.95 2.05l-1.41 1.41a5.022 5.022 0 00-7.08 0L7.05 6.05A6.976 6.976 0 0112 4zm7.78-.77l-1.41 1.41C16.74 3.01 14.49 2 12.01 2S7.27 3.01 5.64 4.63L4.22 3.22C6.22 1.23 8.97 0 12.01 0s5.78 1.23 7.77 3.23zM12 11c1.94 0 4 1.45 4 4.15 0 .94-.55 2.93-4 6.17-3.45-3.24-4-5.23-4-6.17 0-2.7 2.06-4.15 4-4.15zm0-2c-3.15 0-6 2.41-6 6.15 0 2.49 2 5.44 6 8.85 4-3.41 6-6.36 6-8.85C18 11.41 15.15 9 12 9zm1.5 6c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5.67 1.5 1.5 1.5 1.5-.67 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d79d5ba4cd48cfe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.29 13.9L18 12l3.29-1.9c.48-.28.64-.89.37-1.37l-2-3.46a1.01 1.01 0 00-1.37-.37L15 6.8V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3.8L5.71 4.9a1.01 1.01 0 00-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37L6 12l-3.29 1.9c-.48.28-.64.89-.37 1.37l2 3.46c.28.48.89.64 1.37.37L9 17.2V21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3.8l3.29 1.9c.48.28 1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm-2.86 2.97l-4.68-2.7c-.33-.2-.75.04-.75.43V20h-2v-5.4c0-.38-.42-.63-.75-.43l-4.68 2.7-1-1.73 4.68-2.7c.33-.19.33-.67 0-.87l-4.68-2.7 1-1.73 4.68 2.7c.33.19.75-.05.75-.44V4h2v5.4c0 .38.42.63.75.43l4.68-2.7 1 1.73-4.68 2.7c-.33.19-.33.67 0 .87l4.68 2.7-1 1.74z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b42a449ff17acea1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 002.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 005 0V9c0-.69-.28-1.32-.73-1.77zM12 11v8H6V5h6v6zm6-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-8-4l-4 7.5h2V18l4-7h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4a288b9990be729a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22H2V10l7-3v2l5-2v3h3l1-8h3l1 8v12zM12 9.95l-5 2V10l-3 1.32V20h16v-8h-8V9.95zM11 18h2v-4h-2v4zm-4 0h2v-4H7v4zm10-4h-2v4h2v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$efa3c21b68244128(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21.98c0 .56.45 1.01 1.01 1.01H15c.56 0 1.01-.45 1.01-1.01V21H1v.98zM8.5 8.99C4.75 8.99 1 11 1 15h15c0-4-3.75-6.01-7.5-6.01zM3.62 13c1.11-1.55 3.47-2.01 4.88-2.01s3.77.46 4.88 2.01H3.62zM1 17h15v2H1zM18 5V1h-2v4h-5l.23 2h9.56l-1.4 14H18v2h1.72c.84 0 1.53-.65 1.63-1.47L23 5h-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1a968bbfee95a2a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 11V9c-6-2-11-7-11-7S7 7 1 9v2c0 1.49.93 2.75 2.24 3.26C3.2 16.76 2.92 19.69 2 22h20c-.92-2.31-1.2-5.24-1.24-7.74A3.496 3.496 0 0023 11zM12 4.71c1.33 1.14 3.49 2.84 6.11 4.29H5.89C8.51 7.55 10.67 5.85 12 4.71zM13 11h3c0 .83-.67 1.5-1.5 1.5S13 11.83 13 11zm-3.5 1.5c-.83 0-1.5-.67-1.5-1.5h3c0 .83-.67 1.5-1.5 1.5zM6 11c0 .83-.67 1.5-1.5 1.5S3 11.83 3 11h3zm-1.34 9c.39-1.86.54-3.82.57-5.58.68-.15 1.29-.49 1.76-.98.25.25.54.45.85.62-.1 1.87-.26 4-.52 5.93H4.66zm4.69 0c.24-1.83.39-3.78.48-5.53.84-.08 1.61-.45 2.17-1.02.56.57 1.32.94 2.17 1.02.1 1.75.24 3.7.48 5.53h-5.3zm7.32 0c-.27-1.94-.43-4.07-.52-5.93.31-.17.61-.37.85-.62.47.48 1.08.83 1.76.98.03 1.76.18 3.72.57 5.58h-2.66zm2.83-7.5c-.83 0-1.5-.67-1.5-1.5h3c0 .83-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$136de7a330089e02(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-1V8h2V6h-2.35a5.99 5.99 0 00-11.3 0H4v2h2v3H5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v3H4v2h16v-2h-2v-3h1c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm-7-7c1.47 0 2.75.81 3.44 2H8.56c.69-1.19 1.97-2 3.44-2zm7 11h-3v5H8v-5H5v-2h3V8h8v5h3v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab78bc04737bfac1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.9 10.69l-1.44-4.32A2.01 2.01 0 0019.56 5H19V4c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1h-2c-1.1 0-2 .9-2 2v4H1v5c0 1.1.9 2 2 2h1c0 1.66 1.34 3 3 3s3-1.34 3-3h4c0 1.66 1.34 3 3 3s3-1.34 3-3h3v-6.68c0-.21-.03-.42-.1-.63zM14 7h5.56l1.33 4H14V7zM7 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm5-3H9.22c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3v-3h9v3zm5 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.34-1-2.22-1s-1.67.39-2.22 1H14v-3h7v3h-1.78z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.5h-1v-2h1V5H1v1.5h1v2H1V10h10V8.5zm-2.5 0H6.75v-2H8.5v2zm-5-2h1.75v2H3.5v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f7a3d7072f2ebe17(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h-2c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 7h-2V6h2v5zm-6.5 5H18v2H9.49c-.88 0-1.66-.58-1.92-1.43L5 8V4h2v4l2.5 8zM8 19h10v2H8v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ad7d26342699c2d2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$46620b958b25c522(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 18l-3.86-6H22L15 2l-3 4.29L9 2 2 12h1.86L0 18h7v4h4v-4h2v4h4v-4h7zM15 5.49L18.16 10h-1.68l3.86 6h-3.62l-2.57-4H16l-2.78-3.97L15 5.49zM3.66 16l3.86-6H5.84L9 5.49 12.16 10h-1.68l3.86 6H3.66z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$686a817c33806257(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.41 15.59L8 17l-4-4 4-4 1.41 1.41L7.83 12c1.51-.33 3.73.08 5.17 1.36V6.83l-1.59 1.59L10 7l4-4 4 4-1.41 1.41L15 6.83V21h-2v-4c-.73-2.58-3.07-3.47-5.17-3l1.58 1.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac6d8c269d8889dc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 15.59L16 17l4-4-4-4-1.41 1.41L16.17 12c-1.51-.33-3.73.08-5.17 1.36V6.83l1.59 1.59L14 7l-4-4-4 4 1.41 1.41L9 6.83V21h2v-4c.73-2.58 3.07-3.47 5.17-3l-1.58 1.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d230cbadb47a0cc6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3v2h-2V3h-2v2h-2V3h-2v4l2 2v1H9V9l2-2V3H9v2H7V3H5v2H3V3H1v4l2 2v6l-2 2v4h9v-3c0-1.1.9-2 2-2s2 .9 2 2v3h9v-4l-2-2V9l2-2V3h-2zm0 16h-5v-1c0-2.21-1.79-4-4-4s-4 1.79-4 4v1H3v-1.17l2-2V8.17L3.83 7h4.34L7 8.17V12h10V8.17L15.83 7h4.34L19 8.17v7.66l2 2V19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2cf3eda680185fae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm5-4h2c0 2.7-.93 4.41-2.3 5.5-.5.4-1.1.7-1.7.9V22h-2v-6h-2v6H9V10.1c-.3.1-.5.2-.6.3-.53.41-1.4 1.03-1.4 3.6H5c0-2.06.35-3.78 2.11-5.29C8.21 7.81 10 7 12 7s2.68-.46 3.48-1.06C15.96 5.55 17 4.76 17 2zM4 16h3v6H4v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9c03851e885b4338(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.67 18.17l-5.3-5.3h-.99l-2.54 2.54v.99l5.3 5.3c.39.39 1.02.39 1.41 0l2.12-2.12a.996.996 0 000-1.41zm-2.83 1.42l-4.24-4.24.71-.71 4.24 4.24-.71.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 10.19l1.41-1.41 2.12 2.12a3 3 0 000-4.24l-3.54-3.54-1.41 1.41V1.71l-.7-.71-3.54 3.54.71.71h2.83l-1.41 1.41 1.06 1.06-2.89 2.89-4.13-4.13V5.06L4.83 2.04 2 4.87 5.03 7.9h1.41l4.13 4.13-.85.85H7.6l-5.3 5.3a.996.996 0 000 1.41l2.12 2.12c.39.39 1.02.39 1.41 0l5.3-5.3v-2.12l5.15-5.15 1.06 1.05zm-7.98 5.15l-4.24 4.24-.71-.71 4.24-4.24.71.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af96efa1f6cf3969(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3l-3 3V3H9C6.24 3 4 5.24 4 8h5v12c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V8l3 3h2V3h-2zm-5 16h-2v-6h2v6zm-2-8V6H6.77C7.32 5.39 8.11 5 9 5h4v6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c891fd1a15281128(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-3V6c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v10h20V10c0-1.1-.9-2-2-2zM9 6h6v2H9V6zm11 12H4v-3h2v1h2v-1h8v1h2v-1h2v3zm-2-5v-1h-2v1H8v-1H6v1H4v-3h16v3h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4694287a2400896e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1f4f26c110420c50(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm3.44-8c.26.45.44.96.51 1.5h-7.9c.07-.54.24-1.05.51-1.5h6.88zm.51 2.5c-.07.54-.24 1.05-.51 1.5H8.56c-.26-.45-.44-.96-.51-1.5h7.9zM9.38 15h5.24c-.7.61-1.61 1-2.62 1s-1.91-.39-2.62-1zm5.24-6H9.38c.7-.61 1.61-1 2.62-1s1.91.39 2.62 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$de38bfcf9aadbf5f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.38 6.24C17.79 3.24 15.14 1 12 1S6.21 3.24 5.62 6.24A4.014 4.014 0 003 10c0 2.21 1.79 4 4 4 .12 0 .23-.02.34-.02L12.07 23l4.61-9.03c.11.01.21.03.32.03 2.21 0 4-1.79 4-4 0-1.71-1.08-3.19-2.62-3.76zm-6.33 12.39l-2.73-5.21a6.468 6.468 0 005.4-.02l-2.67 5.23zM17 12c-.52 0-1.01-.2-1.39-.56l-.56-.54-.66.42a4.52 4.52 0 01-4.78-.01l-.66-.41-.56.54c-.38.35-.87.56-1.39.56a1.999 1.999 0 01-.32-3.97l.77-.13.06-.78C7.71 4.8 9.66 3 12 3s4.29 1.8 4.48 4.12l.06.78.77.12c.97.16 1.69.99 1.69 1.98 0 1.1-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a8c3cc5c64ae530a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.75 7h.75a2.5 2.5 0 000-5h-.75V1h-1.5v1h-.75a2.5 2.5 0 000 5h.75v1H13v5h3.25v1h-.75a2.5 2.5 0 000 5h.75v4h1.5v-4h.75a2.5 2.5 0 000-5h-.75v-1H21V8h-3.25V7zM15.5 5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3c.28 0 .5.22.5.5s-.22.5-.5.5h-3zm3 11c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3zm.5-6v1h-4v-1h4zM7.75 7h.75a2.5 2.5 0 000-5h-.75V1h-1.5v1H5.5a2.5 2.5 0 000 5h.75v1H3v5h3.25v1H5.5a2.5 2.5 0 000 5h.75v4h1.5v-4h.75a2.5 2.5 0 000-5h-.75v-1H11V8H7.75V7zM5.5 5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3c.28 0 .5.22.5.5s-.22.5-.5.5h-3zm3 11c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3zm.5-6v1H5v-1h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ec301adb35b37f0f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.53L17.74 9l-1.89 1.47 1.43 1.42L21 9l-9-7-2.59 2.02 1.42 1.42zm9 9.54l-1.63-1.27-.67.52 1.43 1.43zM3.41.86L2 2.27l4.22 4.22L3 9l9 7 2.1-1.63 1.42 1.42-3.53 2.75-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21l1.41-1.41L3.41.86zM12 13.47L6.26 9l1.39-1.08 5.02 5.02-.67.53z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$97a36863f49d746b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16zm0-11.47L17.74 9 12 13.47 6.26 9 12 4.53z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$184fe684f05c9b62(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14c0 1.3.84 2.4 2 2.82V20H3v2h6v-2H7v-3.18C8.16 16.4 9 15.3 9 14V6H3v8zm2-6h2v3H5V8zm0 5h2v1c0 .55-.45 1-1 1s-1-.45-1-1v-1zM20.64 8.54l-.96-.32a1 1 0 01-.68-.95V3c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4.28a1 1 0 01-.68.95l-.96.32c-.81.28-1.36 1.04-1.36 1.9V20c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2v-9.56c0-.86-.55-1.62-1.36-1.9zM16 4h1v1h-1V4zm4 16h-7v-2h7v2zm0-4h-7v-2h7v2zm0-4h-7v-1.56l.95-.32C15.18 9.72 16 8.57 16 7.28V7h1v.28a3 3 0 002.05 2.85l.95.31V12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a1477d190c1435f6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM9.07 16L12 14.12 14.93 16l-.89-3.36 2.69-2.2-3.47-.21L12 7l-1.27 3.22-3.47.21 2.69 2.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$30b763b704fc3549(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e5f8514b4fb8b1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8bddee68b6d3de94(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.77 9L12 12.11 9.23 9h5.54M21 3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9V3zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c490686f3ef7baa1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5v8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5h10m4-2H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm-2 5V5h2v3h-2zm2 11H2v2h18v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$96348c9469c016e7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 9h10.29l1.04 3H5.81l1.04-3zM19 19H5v-4.66l.12-.34h13.77l.11.34V19z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b5e0abe83f641cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm1 11h-4v-4H8v4H4V9h3V6h10v3h3v9zM8 8h2v1H8v3h3v-1H9v-1h2V7H8zm7 1h-1V7h-1v3h2v2h1V7h-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$674f2df1b164792a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 000 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f0410ee778cb9411(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm14 18l-10 .01L5.89 10H18.1L17 20zm1.33-12H5.67l-.44-4h13.53l-.43 4zM12 19c1.66 0 3-1.34 3-3 0-2-3-5.4-3-5.4S9 14 9 16c0 1.66 1.34 3 3 3zm0-5.09c.59.91 1 1.73 1 2.09 0 .55-.45 1-1 1s-1-.45-1-1c0-.37.41-1.19 1-2.09z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1d2cbdb2436283ac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6l-.44.55c-.42.52-.98.75-1.54.75C13 7.3 12 6.52 12 5.3V2S4 6 4 13c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.96-1.61-5.62-4-7zm-4 13c-1.1 0-2-.87-2-1.94 0-.51.2-.99.58-1.36L12 14.3l1.43 1.4c.37.37.57.85.57 1.36 0 1.07-.9 1.94-2 1.94zm3.96-1.5c.04-.36.22-1.89-1.13-3.22L12 11.5l-2.83 2.78C7.81 15.62 8 17.16 8.04 17.5A5.982 5.982 0 016 13c0-3.16 2.13-5.65 4.03-7.25a4.024 4.024 0 003.99 3.55c.78 0 1.54-.23 2.18-.66A6.175 6.175 0 0118 13c0 1.79-.79 3.4-2.04 4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$96d666c49d747483(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.66 13.07c.15 0 .29-.01.43-.03C9.56 14.19 10.69 15 12 15s2.44-.81 2.91-1.96a3.145 3.145 0 003.57-3.11c0-.71-.25-1.39-.67-1.93.43-.54.67-1.22.67-1.93a3.145 3.145 0 00-3.57-3.11C14.44 1.81 13.31 1 12 1s-2.44.81-2.91 1.96a3.145 3.145 0 00-3.57 3.11c0 .71.25 1.39.67 1.93-.43.54-.68 1.22-.68 1.93 0 1.73 1.41 3.14 3.15 3.14zM12 13c-.62 0-1.12-.49-1.14-1.1l.12-1.09c.32.12.66.19 1.02.19s.71-.07 1.03-.19l.11 1.09c-.02.61-.52 1.1-1.14 1.1zm3.34-1.93c-.24 0-.46-.07-.64-.2l-.81-.57c.55-.45.94-1.09 1.06-1.83l.88.42c.4.19.66.59.66 1.03 0 .64-.52 1.15-1.15 1.15zm-.65-5.94c.2-.13.42-.2.65-.2.63 0 1.14.51 1.14 1.14 0 .44-.25.83-.66 1.03l-.88.42c-.12-.74-.51-1.38-1.07-1.83l.82-.56zM12 3c.62 0 1.12.49 1.14 1.1l-.11 1.09C12.71 5.07 12.36 5 12 5s-.7.07-1.02.19l-.12-1.09c.02-.61.52-1.1 1.14-1.1zM8.66 4.93c.24 0 .46.07.64.2l.81.56c-.55.45-.94 1.09-1.06 1.83l-.88-.42c-.4-.2-.66-.59-.66-1.03 0-.63.52-1.14 1.15-1.14zM8.17 8.9l.88-.42c.12.74.51 1.38 1.07 1.83l-.81.55c-.2.13-.42.2-.65.2-.63 0-1.14-.51-1.14-1.14-.01-.43.25-.82.65-1.02zM12 22a9 9 0 009-9 9 9 0 00-9 9zm2.44-2.44c.71-1.9 2.22-3.42 4.12-4.12a7.04 7.04 0 01-4.12 4.12zM3 13a9 9 0 009 9 9 9 0 00-9-9zm2.44 2.44c1.9.71 3.42 2.22 4.12 4.12a7.04 7.04 0 01-4.12-4.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4fecc0854780c686(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 002.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 005 0V9c0-.69-.28-1.32-.73-1.77zM12 13.5V19H6v-7h6v1.5zm0-3.5H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af58e31f65388965(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-1.45-5c.75 0 1.41-.41 1.75-1.03l3.58-6.49A.996.996 0 0020.01 4H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dcc6c3f7c783cbe8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8.5-2h3v-3.5H17v-3h-3.5V7h-3v3.5H7v3h3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1f29bb8b7ff68ab9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$83ce71178fd20d6a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM18 20H6L5.99 4H18v16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm2.36-7.36c1.3 1.3 1.3 3.42 0 4.72-1.3 1.3-3.42 1.3-4.72 0l4.72-4.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a1d3ce91c70725e6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zm7 5.58c-2.53.34-4.93 1.3-7 2.82a15.2 15.2 0 00-7-2.83v-6.95c2.1.38 4.05 1.35 5.64 2.83L12 14.28l1.36-1.27A11.18 11.18 0 0119 10.18v6.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$54596a664f669774(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm7 17H5V8h14v12zm-7-8c-1.66 0-3-1.34-3-3H7c0 2.76 2.24 5 5 5s5-2.24 5-5h-2c0 1.66-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cf213a84ae837a4f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5v14h-4V5h4m6-2h-2v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3zm-4 6V7h2v2h-2zM6 9V7h2v2H6zm10 4v-2h2v2h-2zM6 13v-2h2v2H6zm10 4v-2h2v2h-2zM6 17v-2h2v2H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$abcd0d88ea40dbbe(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM13 20.01L4 11V4h7v-.01l9 9-7 7.02z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffa03eec713341c2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$57137628d68a6e90(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-3.9 8.63L18.89 19H5.11l1.79-5.37.21-.63-.21-.63L5.11 7h13.78l-1.79 5.37-.21.63.21.63zM13 9h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b187c6bf76b4078f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57a.84.84 0 00-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d8f6b16f36d9022b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zm0 15.92L5.51 6.36C7.32 4.85 9.62 4 12 4s4.68.85 6.49 2.36L12 17.92zM9 5.5c-.83 0-1.5.67-1.5 1.5S8.17 8.5 9 8.5s1.5-.67 1.5-1.5S9.82 5.5 9 5.5zm1.5 7.5c0 .83.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5s-.68-1.5-1.5-1.5-1.5.67-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7da0d6079e04a373(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM9.07 16L12 14.12 14.93 16l-.89-3.36 2.69-2.2-3.47-.21L12 7l-1.27 3.22-3.47.21 2.69 2.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4153e29d788191d7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 12.59l.9 3.88-3.4-2.05-3.4 2.05.9-3.87-3-2.59 3.96-.34L12 6.02l1.54 3.64 3.96.34-3 2.59zM12 3.19l7 3.11V11c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e334766734447a1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1596e0b0782a8e82(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 14H8v-4h8v4zm2-4v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "11.5",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f9fb2934bef30f17(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l.59-.65L9.88 4h4.24l1.24 1.35.59.65H20v12zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8.2c-1.77 0-3.2-1.43-3.2-3.2 0-1.77 1.43-3.2 3.2-3.2s3.2 1.43 3.2 3.2c0 1.77-1.43 3.2-3.2 3.2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f44870d3c7029617(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zm-.5 1.5l1.96 2.5H17V9.5h2.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9H8.22zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6d0568155212c025(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.04 3H5.81l1.04-3zM19 17H5v-4.66l.12-.34h13.77l.11.34V17z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4502dcd83e69512e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-3H2v3zm2-1h16v1H4v-1zM18.66 11.5c-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.32 1l-.01-1.98c-1.61-.33-1.62-1.02-3.33-1.02zM22 9c.02-4-4.28-6-10-6C6.29 3 2 5 2 9v1h20V9zM4.18 8C5.01 5.81 8.61 5 12 5c3.31 0 5.93.73 7.19 1.99.3.31.52.64.65 1.01H4.18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$585eeb24e5225bd7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM10 5.47l4 1.4v11.66l-4-1.4V5.47zm-5 .99l3-1.01v11.7l-3 1.16V6.46zm14 11.08l-3 1.01V6.86l3-1.16v11.84z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9d003508547497d9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8c-1.18 0-2.34-.26-3.43-.78-.27-.13-.56-.19-.86-.19-.19 0-.38.03-.56.08l-3.2.94.94-3.2c.14-.47.1-.98-.11-1.42A7.925 7.925 0 014 12c0-4.41 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12c0 1.54.36 2.98.97 4.29L1 23l6.71-1.97c1.31.61 2.75.97 4.29.97 5.52 0 10-4.48 10-10S17.52 2 12 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13 8h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$43536e132c332ffd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-9-3h2v5h-2V4zm9 16H4V9h5c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2h5v11zm-9-4H9v2H7v-2H5v-2h2v-2h2v2h2v2zm2-1.5V13h6v1.5h-6zm0 3V16h4v1.5h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$82d69026c44606cf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM10 4h4v2h-4V4zm10 16H4V8h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2dcd9de5d9ee30a6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99zM13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zM17.5 14.33c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1c2514fee3ba46df(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.41 21L5 19.59l4.83-4.83c.75-.75 1.17-1.77 1.17-2.83v-5.1L9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83v5.1c0 1.06.42 2.08 1.17 2.83L19 19.59 17.59 21 12 15.41 6.41 21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a330e58c0020276c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 9.01C18.72 8.42 18.16 8 17.5 8h-11c-.66 0-1.21.42-1.42 1.01L3 15v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 10h10.29l1.04 3H5.81l1.04-3zM19 20H5v-5h14v5zM6 17.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S8.33 19 7.5 19 6 18.33 6 17.5zm9 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zM9.41 5L8 6.41l-3-3L6.41 2l3 3zM16 6.41L14.59 5l3-3L19 3.41l-3 3zM13 5h-2V0h2v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$40fc8c520b3bd07d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.17 13.71l1.4-2.42c.09-.15.05-.34-.08-.45l-1.48-1.16c.03-.22.05-.45.05-.68s-.02-.46-.05-.69l1.48-1.16c.13-.11.17-.3.08-.45l-1.4-2.42c-.09-.15-.27-.21-.43-.15l-1.74.7c-.36-.28-.75-.51-1.18-.69l-.26-1.85a.364.364 0 00-.35-.29h-2.8c-.17 0-.32.13-.35.3L6.8 4.15c-.42.18-.82.41-1.18.69l-1.74-.7c-.16-.06-.34 0-.43.15l-1.4 2.42c-.09.15-.05.34.08.45l1.48 1.16c-.03.22-.05.45-.05.68s.02.46.05.69l-1.48 1.16c-.13.11-.17.3-.08.45l1.4 2.42c.09.15.27.21.43.15l1.74-.7c.36.28.75.51 1.18.69l.26 1.85c.03.16.18.29.35.29h2.8c.17 0 .32-.13.35-.3l.26-1.85c.42-.18.82-.41 1.18-.69l1.74.7c.16.06.34 0 .43-.15zM8.81 11c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM21.92 18.67l-.96-.74c.02-.14.04-.29.04-.44 0-.15-.01-.3-.04-.44l.95-.74c.08-.07.11-.19.05-.29l-.9-1.55c-.05-.1-.17-.13-.28-.1l-1.11.45c-.23-.18-.48-.33-.76-.44l-.17-1.18a.216.216 0 00-.21-.2h-1.79c-.11 0-.21.08-.22.19l-.17 1.18c-.27.12-.53.26-.76.44l-1.11-.45a.23.23 0 00-.28.1l-.9 1.55c-.05.1-.04.22.05.29l.95.74a3.145 3.145 0 000 .88l-.95.74c-.08.07-.11.19-.05.29l.9 1.55c.05.1.17.13.28.1l1.11-.45c.23.18.48.33.76.44l.17 1.18c.02.11.11.19.22.19h1.79c.11 0 .21-.08.22-.19l.17-1.18c.27-.12.53-.26.75-.44l1.12.45c.1.04.22 0 .28-.1l.9-1.55c.06-.09.03-.21-.05-.28zm-4.29.16a1.35 1.35 0 11.001-2.701 1.35 1.35 0 01-.001 2.701z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$932d878602db855(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.31 18.9c-.96 1-2.06 2.03-3.31 3.1-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2c4.19 0 7.99 3.21 8 8.17l2.09-2.09L23.5 9.5 19 14l-4.5-4.5 1.41-1.41L18 10.17C17.99 6.55 15.34 4 12 4c-3.35 0-6 2.57-6 6.2 0 2.34 1.95 5.44 6 9.14.64-.59 1.23-1.16 1.77-1.71a2.5 2.5 0 01-.27-1.12 2.5 2.5 0 015 0 2.492 2.492 0 01-3.19 2.39z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$31690c34dd4e0eb4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm1-6h1v4h-1v-4zm-7 6h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm1-6h1v4h-1v-4zM5 8h2v8H5zM2 4v16h20V4H2zm18 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$24b5c173cab5565d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 14H10V9H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 10.35V7zM4 14v-1c0-1.1.9-2 2-2h2v3H4zm3 3c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6h5v2H5zM19 13c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f2c8054e02c61353(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 7c0-1.1-2-3-2-3s-2 1.9-2 3c0 .74.4 1.38 1 1.72V13h-2v-2c0-.95-.66-1.74-1.55-1.94.34-.58.55-1.25.55-1.97 0-1.31-.65-2.53-1.74-3.25L12 1 7.74 3.84A3.887 3.887 0 006 7.09c0 .72.21 1.39.55 1.96C5.66 9.26 5 10.05 5 11v2H3V8.72c.6-.34 1-.98 1-1.72 0-1.1-2-3-2-3S0 5.9 0 7c0 .74.4 1.38 1 1.72V21h10v-4c0-.55.45-1 1-1s1 .45 1 1v4h10V8.72c.6-.34 1-.98 1-1.72zM8.85 5.5L12 3.4l3.15 2.1c.53.36.85.95.85 1.59C16 8.14 15.14 9 14.09 9H9.91C8.86 9 8 8.14 8 7.09c0-.64.32-1.23.85-1.59zM21 19h-6v-2c0-1.65-1.35-3-3-3s-3 1.35-3 3v2H3v-4h4v-4h10v4h4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa89582e39f01040(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9.42V12h2V6h-6v2h2.58l-4.46 4.46a.996.996 0 01-1.41 0l-1.17-1.17a3 3 0 00-4.24 0L2 16.59 3.41 18l5.29-5.29a.996.996 0 011.41 0l1.17 1.17a3 3 0 004.24 0L20 9.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a39235f0b8b3c45(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4l4 4-4 4V9h-4V7h4V4zm-7 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM6 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm1 10h4v-2H7v-3l-4 4 4 4v-3zm7 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bab0893fc3156178(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9h2zm-4 9H6V9h12v11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14l2 3 2-3v4h2v-7h-2l-2 3-2-3H8v7h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$47e385885888cb1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c700978fb8a65a38(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.27l4.28 10.43-3.47-1.53-.81-.36-.81.36-3.47 1.53L12 7.27M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b86fd3c95aa4fb3b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.34L21 3l-3.34 9-1.56-1.56 1.5-4.05-4.05 1.5L12 6.34zm9.19 14.85l-5.07-5.07L14.31 21H12.9l-2.83-7.07L3 11.1V9.69l4.88-1.81-5.07-5.07L4.22 1.4 22.6 19.78l-1.41 1.41zm-6.62-6.62L9.43 9.43l-2.71 1.01 4.89 1.95 1.95 4.89 1.01-2.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da8dbe98eea8bb76(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.27 6.73l-4.24 10.13-1.32-3.42-.32-.83-.82-.32-3.43-1.33 10.13-4.23M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3172fea5aba0f4dd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5h14l-6 9v4h2v2H5v-2h2v-4L1 5zm9.1 4l1.4-2H4.49l1.4 2h4.21zM17 5h5v3h-3v9c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3a3 3 0 011 .17V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6fbb88d7c71800b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 9.01C18.72 8.42 18.16 8 17.5 8h-11c-.66 0-1.21.42-1.42 1.01L3 15v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 10h10.29l1.04 3H5.81l1.04-3zM19 20H5v-5h14v5zM6 17.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S8.33 19 7.5 19 6 18.33 6 17.5zm9 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zM12 6.36L9.17 3.54l1.41-1.41L12 3.54 15.54 0l1.41 1.41L12 6.36z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f963a094a204b7e7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14V6c0-1.76 2.24-4 5-4v16.17l-2-2V14h-3zm4.49 9.31L10.02 12.85c-.33.09-.66.15-1.02.15v9H7v-9c-2.21 0-4-1.79-4-4V5.83L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM6.17 9L5 7.83V9h1.17zM9 2H7v2.17l2 2V2zm4 7V2h-2v6.17l1.85 1.85c.09-.33.15-.66.15-1.02z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a8519b95116268e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 13c.83 0 1.5.67 1.5 1.5S9.33 16 8.5 16 7 15.33 7 14.5 7.67 13 8.5 13zm11.28 9.61l-1.64-1.64c-.05.01-.09.03-.14.03h-1c-.55 0-1-.45-1-1v-1H8v1c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-1.78c-.61-.55-1-1.34-1-2.22V6.83L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM6 8.83V10h1.17L6 8.83zM14.17 17l-5-5H6v4c0 .37.21.62.34.73l.29.27h7.54zM12 4c3.69 0 5.11.46 5.66.99H7.82l2 2H18V10h-5.17l2 2H18v3.17l1.81 1.81c.11-.31.19-.63.19-.98V6c0-3.5-3.58-4-8-4-2.52 0-4.76.16-6.22.95l1.53 1.53C8.17 4.2 9.6 4 12 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1dad06e7bc013d81(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 16a.99.99 0 01-.71-.29.95.95 0 01-.29-.71c-.01-.55.43-.99.98-1h.02c.28 0 .51.1.71.29.18.19.28.43.28.7s-.1.51-.29.71-.43.3-.7.3zm-.88-3.66c0-.45.1-.84.29-1.16.19-.33.53-.7 1-1.12.28-.25.48-.47.61-.66s.19-.4.19-.64c0-.29-.11-.53-.32-.74-.21-.2-.5-.3-.85-.3-.37 0-.74.1-.96.3-.21.2-.4.45-.4.98H9c0-1.01.46-1.73.97-2.21C10.53 6.28 11.25 6 12 6c.59 0 1.11.12 1.57.35s.79.55 1.05.96.38.86.38 1.35-.1.9-.31 1.25-.48.71-.89 1.09c-.32.3-.53.56-.65.77s-.18.49-.18.81V13h-1.85v-.66h.01zM18 10.2C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$94384ec2109ea946(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h2L12 2 5.05 12H7l-3.9 6h6.92v4h3.95v-4H21l-4-6zM6.79 16l3.9-6H8.88l3.13-4.5 3.15 4.5h-1.9l4 6H6.79z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ba2820cabb3a25c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.18 10l-1.7-4.68A2.008 2.008 0 0014.6 4H12v2h2.6l1.46 4h-4.81l-.36-1H12V7H7v2h1.75l1.82 5H9.9c-.44-2.23-2.31-3.88-4.65-3.99C2.45 9.87 0 12.2 0 15c0 2.8 2.2 5 5 5 2.46 0 4.45-1.69 4.9-4h4.2c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5 0-2.8-2.2-5-5-5h-.82zM7.82 16c-.4 1.17-1.49 2-2.82 2-1.68 0-3-1.32-3-3s1.32-3 3-3c1.33 0 2.42.83 2.82 2H5v2h2.82zm6.28-2h-1.4l-.73-2H15c-.44.58-.76 1.25-.9 2zm4.9 4c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.03 0 .06-.01.09-.01 1.68 0 3 1.32 3 3s-1.33 3-3.01 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4bb3a92e370bf7ae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c1.33 0 4 .67 4 2v.16c-.97 1.12-2.4 1.84-4 1.84s-3.03-.72-4-1.84V13c0-1.33 2.67-2 4-2zm0-1c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6 .2C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$29125a89615b5ff3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5a2 2 0 00-2 2v14a2 2 0 002 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-7-7c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.58c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V17h12v-1.42zM8.48 15c.74-.51 2.23-1 3.52-1s2.78.49 3.52 1H8.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c39fc1ec0daaea0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "17",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.86 14.97l-.93-.84c.48-3.45-2.87-6.04-6.05-4.82A5.79 5.79 0 0012 9c-4.26 0-5.65 3.58-5.89 4.85A2.983 2.983 0 014 11c0-1.66 1.34-3 3-3h2.5a2.5 2.5 0 000-5H8c-.55 0-1 .45-1 1s.45 1 1 1h1.5c.28 0 .5.22.5.5s-.22.5-.5.5H7c-2.76 0-5 2.24-5 5 0 2.44 1.76 4.47 4.07 4.91A5.998 5.998 0 0012 21h6.53c3.11 0 4.7-3.89 2.33-6.03zM18.53 19H12c-1.21 0-2.34-.54-3.11-1.48-.78-.95-1.06-2.16-.8-3.41a3.95 3.95 0 012.99-3.01c.22-.05.45-.06.67-.07-.47.71-.75 1.55-.75 2.47 0 1.24.5 2.37 1.32 3.18l1.41-1.41c-.45-.45-.73-1.08-.73-1.77 0-1.42 1.2-2.5 2.5-2.5a2.5 2.5 0 012.5 2.5c0 .46-.13.88-.35 1.25l1.87 1.7c.31.28.48.67.48 1.09 0 .8-.66 1.46-1.47 1.46z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$baaf25cb60c4dea7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v-2h-3.07c-.05-.39-.12-.77-.22-1.14l2.58-1.49-1-1.73L16.92 10c-.28-.48-.62-.91-.99-1.29.1-.56.2-1.69-.58-2.89L17 4.17l-1.41-1.41-1.72 1.72c-1.68-.89-3.1-.33-3.73 0L8.41 2.76 7 4.17l1.65 1.65c-.78 1.2-.68 2.34-.58 2.89-.37.39-.71.82-.99 1.29L4.71 8.63l-1 1.73 2.58 1.49c-.1.37-.17.75-.22 1.14H3v2h3.07c.05.39.12.77.22 1.14l-2.58 1.49 1 1.73L7.08 18c1.08 1.81 2.88 3 4.92 3s3.84-1.19 4.92-3l2.37 1.37 1-1.73-2.58-1.49c.1-.37.17-.75.22-1.14H21zm-9-9c.88 0 1.62.57 1.88 1.36C13.29 7.13 12.66 7 12 7s-1.29.13-1.88.36C10.38 6.57 11.12 6 12 6zm0 13c-2.21 0-4-2.24-4-5s1.79-5 4-5 4 2.24 4 5-1.79 5-4 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f3819b45ab4b818d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c1.93 0 5 1.4 5 5.15 0 2.16-1.72 4.67-5 7.32-3.28-2.65-5-5.17-5-7.32C7 5.4 10.07 4 12 4m0-2C8.73 2 5 4.46 5 9.15c0 3.12 2.33 6.41 7 9.85 4.67-3.44 7-6.73 7-9.85C19 4.46 15.27 2 12 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-1.1 0-2 .9-2 2s.9 2 2 2a2 2 0 100-4zM5 20h14v2H5v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$784e85df6a51bcaf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ba64f48f6292764c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.28 4.93l-2.12-2.12c-.78-.78-2.05-.78-2.83 0L11.5 5.64l2.12 2.12 2.12-2.12 3.54 3.54a3.012 3.012 0 000-4.25zM5.49 13.77c.59.59 1.54.59 2.12 0l2.47-2.47-2.12-2.13-2.47 2.47c-.59.59-.59 1.54 0 2.13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.04 7.76l-.71.71-.71.71L10.44 6c-.59-.6-1.54-.6-2.12-.01a1.49 1.49 0 000 2.12l3.18 3.18-.71.71-6.36 6.36c-.78.78-.78 2.05 0 2.83.78.78 2.05.78 2.83 0L16.45 12a.996.996 0 101.41-1.41l-2.82-2.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a62fceb3853f553b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11V8h7.29C11.1 7.37 11 6.7 11 6H4.43c.9-.77 3.28-1.08 6.65-.98.1-.7.3-1.37.59-1.99C2.97 2.67 2 5.02 2 7v9.5C2 18.43 3.57 20 5.5 20L4 21v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V13c-1.91 0-3.63-.76-4.89-2H4zm12 5.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V13h12v3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 8h-1V8h1v1zm0-2h-1V3h1v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$65745ad147f5f2db(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.66 14c-.66 1.92-2.24 3.54-4.4 4.39l-1.26.5V20h-4v-1.11l-1.27-.5c-2.16-.85-3.74-2.47-4.4-4.39h15.33M22 2L4 3.99V12H2c0 3.69 2.47 6.86 6 8.25V22h8v-1.75c3.53-1.39 6-4.56 6-8.25H10.5V8H22V6.5H10.5V4.78L22 3.51V2zM8 6.5V5.06l1-.11V6.5H8zm-2.5 0V5.34l1-.11V6.5h-1zM8 12V8h1v4H8zm-2.5 0V8h1v4h-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e2a362cdceed822d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21h-2V6.83L9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83V9c0 4.27 4.03 7.13 6 8.27l-1.46 1.46c-1.91-1.16-3.44-2.53-4.54-4.02V21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$27a0311ab2e32735(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21h2V6.83l1.59 1.59L16 7l-4-4-4 4 1.41 1.41L11 6.83V9c0 4.27-4.03 7.13-6 8.27l1.46 1.46C8.37 17.56 9.9 16.19 11 14.7V21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c7d5e6bb0e1eefd1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9.5-2H18v-2h-5.5zm3.86-5.87c.2-.2.2-.51 0-.71l-1.77-1.77c-.2-.2-.51-.2-.71 0L6 11.53V14h2.47l5.89-5.87z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19a86d695e42582a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h2v9h-2zM4 4h2v16H4zM11 4h2v4h-2zM11 10h2v4h-2zM11 16h2v4h-2zM22.5 16.41L21.09 15 19 17.09 16.91 15l-1.41 1.41 2.09 2.09-2.09 2.09L16.91 22 19 19.91 21.09 22l1.41-1.41-2.09-2.09z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c4421a58d2f62252(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 000 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5cc24cb8b14b2364(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6v8h3v8h2V2c-2.76 0-5 2.24-5 4zm-5 3H9V2H7v7H5V2H3v7c0 2.21 1.79 4 4 4v9h2v-9c2.21 0 4-1.79 4-4V2h-2v7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b490be7c9a7ec53b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.08 8A6 6 0 0116 3c3.31 0 6 2.69 6 6 0 2.97-2.16 5.44-5 5.92V21h-2v-6.09c0-.98.71-1.8 1.67-1.97a3.999 3.999 0 10-4.61-4.61c-.17.96-.99 1.67-1.97 1.67H5.83l1.59 1.59L6 13 2 9l4-4 1.41 1.41L5.83 8h4.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$45636329f130d60d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.92 8C13.44 5.16 10.97 3 8 3 4.69 3 2 5.69 2 9c0 2.97 2.16 5.44 5 5.92V21h2v-6.09c0-.98-.71-1.8-1.67-1.97a3.999 3.999 0 114.61-4.61c.17.96.99 1.67 1.97 1.67h4.26l-1.59 1.59L18 13l4-4-4-4-1.41 1.41L18.17 8h-4.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e5f95c878a67c715(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15.18V7c0-2.21-1.79-4-4-4s-4 1.79-4 4v10c0 1.1-.9 2-2 2s-2-.9-2-2V8.82C8.16 8.4 9 7.3 9 6c0-1.66-1.34-3-3-3S3 4.34 3 6c0 1.3.84 2.4 2 2.82V17c0 2.21 1.79 4 4 4s4-1.79 4-4V7c0-1.1.9-2 2-2s2 .9 2 2v8.18A2.996 2.996 0 0018 21c1.66 0 3-1.34 3-3 0-1.3-.84-2.4-2-2.82zM6 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$58092f153983c702(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.54 8.97c-.23-.47-.76-.71-1.26-.53L9 9.65V12h1v-1.65l1.54-.57-.96 4.89-2.78-.57-.2.98 3.76.77.52-2.64L13 14.42V18h1v-3.97l-1.32-1.44.41-2.35C13.99 11.46 15.3 12 16 12v-1c-.41 0-1.63-.33-2.46-2.03z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "7",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6e57ad03edc1f944(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L11.5 12.2V9h1v2.79l1.85 1.85-.7.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$91d946e1a3d24571(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13.5V2L3 13.5h8zm-2-2H6.83L9 8.38v3.12zm12 2C21 6.5 14.5 1 12.5 1c0 0 1 3 1 6.5s-1 6-1 6H21zm-5.62-8.26c1.42 1.52 2.88 3.72 3.41 6.26h-3.68c.21-1.1.39-2.46.39-4 0-.79-.05-1.55-.12-2.26zM22 15H2a6.233 6.233 0 002.33 3.73c.65-.27 1.22-.72 1.67-1.23.73.84 1.8 1.5 3 1.5s2.27-.66 3-1.5c.73.84 1.8 1.5 3 1.5s2.26-.66 3-1.5c.45.51 1.02.96 1.67 1.23 1.17-.89 2.02-2.2 2.33-3.73zm0 8v-2h-1c-1.04 0-2.08-.35-3-1-1.83 1.3-4.17 1.3-6 0-1.83 1.3-4.17 1.3-6 0-.91.65-1.96 1-3 1H2v2h1c1.03 0 2.05-.25 3-.75 1.89 1 4.11 1 6 0 1.89 1 4.11 1 6 0 .95.5 1.97.75 3 .75h1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5eb3861cbdf6fbb4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM8.57 6H6v2.58c1.42 0 2.57-1.16 2.57-2.58zM12 6h-1.71c0 2.36-1.92 4.29-4.29 4.29V12c3.32 0 6-2.69 6-6zm2.14 5.86l-3 3.87L9 13.15 6 17h12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ba05c88d1b6969f1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7.59l5-5c.78-.78 2.05-.78 2.83 0L20.24 11h-2.83L10.4 4 5.41 9H8v2H2V5h2v2.59zM20 19h2v-6h-6v2h2.59l-4.99 5-7.01-7H3.76l8.41 8.41c.78.78 2.05.78 2.83 0l5-5V19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d573f786bdc5479b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.05 17.56l-17.97.94L3 17l17.98-.94.07 1.5zM21 19.48H3v1.5h18v-1.5zM23 13V4c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 0H3V4h18v9zm-1-7c-1.68 0-3.04.98-3.21 2.23-.64-.73-2.73-2.73-6.54-2.73-4.67 0-6.75 3-6.75 3s2.08 3 6.75 3c3.81 0 5.9-2 6.54-2.73C16.96 10.02 18.32 11 20 11V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fedf7077a4cb789f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h5l3-3-3-3h-5V2h-2v2H4v6h7v2H6l-3 3 3 3h5v4h2v-4h7v-6h-7v-2zM6 6h11.17l1 1-1 1H6V6zm12 10H6.83l-1-1 1-1H18v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f7f57bb8af771e34(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17c0 .55-.45 1-1 1h-.17l-2.2-2.2C20.58 15.37 22 14.4 22 13c0-1-8-8-8-8h-3v2h2.25l.8.72L11 10 2 9l-2 4 4.54 1.36-3.49 1.88C-.77 17.22-.07 20 2 20h6c2.21 0 4-1.79 4-4h4l2 2h-3v2h6c1.66 0 3-1.34 3-3h-2zM8 18H2l5.25-2.83L10 16a2 2 0 01-2 2zm9-4h-6.7l-7.45-2.23.31-.62 8.44.85 3.93-2.94s3.77 3.44 4.27 4.14c0 0-1.1.8-2.8.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2dc35284de9a4cae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 7h-3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8h-3V9h3v6zM1 15h4v-2H3c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h4v2H3v2h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H1v-2zm16 0h4v-2h-2c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h4v2h-4v2h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$87269fe274107120(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.4 7c-.34.55-.4.97-.4 1.38C6 9.15 7 11 7 12c0 .95-.4 1.5-.4 1.5H5.1s.4-.55.4-1.5c0-1-1-2.85-1-3.62 0-.41.06-.83.4-1.38h1.5zm5 0c-.34.55-.4.97-.4 1.38 0 .77 1 2.62 1 3.62 0 .95-.4 1.5-.4 1.5h1.5s.4-.55.4-1.5c0-1-1-2.85-1-3.62 0-.41.06-.83.4-1.38h-1.5zM8.15 7c-.34.55-.4.97-.4 1.38 0 .77 1 2.63 1 3.62 0 .95-.4 1.5-.4 1.5h1.5s.4-.55.4-1.5c0-1-1-2.85-1-3.62 0-.41.06-.83.4-1.38h-1.5zM18.6 2c-1.54 0-2.81 1.16-2.98 2.65L14.53 15H4.01c-.6 0-1.09.53-1 1.13C3.53 19.46 6.39 22 9.75 22c3.48 0 6.34-2.73 6.71-6.23L17.61 4.9c.05-.51.47-.9.99-.9.55 0 1 .45 1 1 0 .3-.1 1.25-.1 1.25l1.97.25s.13-1.06.13-1.5c0-1.65-1.35-3-3-3zM9.75 20c-1.94 0-3.67-1.23-4.43-3h8.79c-.72 1.78-2.42 3-4.36 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3aa789be82fb96a6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5L3 7V3l4 2zm11-2v4l4-2-4-2zm-7-1v4l4-2-4-2zm2 16h-2v4c-5.05-.15-9-1.44-9-3v-9c0-1.66 4.48-3 10-3s10 1.34 10 3v9c0 1.56-3.95 2.85-9 3v-4zm-8-7.96c1.38.49 3.77.96 7 .96s5.62-.47 7-.96C19 9.86 16.22 9 12 9s-7 .86-7 1.04zm15 1.76c-1.82.73-4.73 1.2-8 1.2s-6.18-.47-8-1.2v6.78c.61.41 2.36 1.01 5 1.28V16h6v3.86c2.64-.27 4.39-.87 5-1.28V11.8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c76fe1e64396dbc7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.36 9l.6 3H5.04l.6-3h12.72M20 4H4v2h16V4zm0 3H4l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5zM6 18v-4h6v4H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$11fdbe8d89f8a4d3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.83L9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83V21h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fcff52022944512a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82A6.435 6.435 0 0111.5 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dbc6ed8ae39878d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.8 2.8C16 2.09 13.86 2 12 2s-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zM9.17 20l1.5-1.5h2.66l1.5 1.5H9.17zm-2.16-6V9h10v5h-10zm9.49 2c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm-8-1c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM20 20h-3.5v-.38l-1.15-1.16A2.979 2.979 0 0018 15.5V9c0-2.63-3-3-6-3s-6 .37-6 3v6.5c0 1.54 1.16 2.79 2.65 2.96L7.5 19.62V20H4V8.86c0-2 1.01-3.45 2.93-4.2C8.41 4.08 10.32 4 12 4s3.59.08 5.07.66c1.92.75 2.93 2.2 2.93 4.2V20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$80cdebbf4265f38a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4c-1.66 0-3 1.34-3 3v.29L12 3 7 7.29V7c0-1.66-1.34-3-3-3S1 5.34 1 7v14h10v-5c0-.55.45-1 1-1s1 .45 1 1v5h10V7c0-1.66-1.34-3-3-3zm0 2c.55 0 1 .45 1 1v1h-2V7c0-.55.45-1 1-1zM4 6c.55 0 1 .45 1 1v1H3V7c0-.55.45-1 1-1zM3 19v-9h2v9H3zm14 0h-2v-3c0-1.65-1.35-3-3-3s-3 1.35-3 3v3H7V9.92l5-4.29 5 4.29V19zm2 0v-9h2v9h-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b7b0c6095b572ca7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.79 18l-.51-7h9.46l-.51 7H7.79zM9.83 5h4.33l2.8 2.73L16.87 9H7.12l-.09-1.27L9.83 5zM22 7.46l-1.41-1.41L19 7.63l.03-.56L14.98 3H9.02L4.97 7.07l.03.5-1.59-1.56L2 7.44l3.23 3.11.7 9.45h12.14l.7-9.44L22 7.46z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b5ac75af7745ebf7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13v5H4v-5h14c-1.91 0-3.63-.76-4.89-2h-8.3l1.04-3h5.44C11.1 7.37 11 6.7 11 6s.1-1.37.29-2H8v2H5.5c-.66 0-1.21.42-1.42 1.01L2 13v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-.09-.27c-.61.17-1.25.27-1.91.27z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 8h-1V8h1v1zm0-2h-1V3h1v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$90ee1c746859650b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9.02c0 1.09-.89 1.98-1.98 1.98H18V8.86c1.72-.44 3-1.99 3-3.84V5l-2 .02C19 6.11 18.11 7 17.02 7h-.52L12 1 7.5 7h-.52C5.89 7 5 6.11 5 5.02H3c0 1.86 1.28 3.4 3 3.84V11H4.98C3.89 11 3 10.11 3 9.02H1c0 1.86 1.28 3.4 3 3.84V22h7v-4c0-.55.45-1 1-1s1 .45 1 1v4h7v-9.14c1.72-.44 3-1.99 3-3.84V9l-2 .02zm-9-4.69L14 7h-4l2-2.67zM8 9h8v2H8V9zm10 11h-3v-2c0-1.65-1.35-3-3-3s-3 1.35-3 3v2H6v-7h12v7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b06d5bc01562167(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11v2h-2L15 3V1h-2v2h-2.03V1h-2v2.12L6 13H4v-2H2v11h9v-5h2v5h9V11h-2zm-4.69 0H8.69l.6-2h5.42l.6 2zm-1.2-4H9.89l.6-2h3.02l.6 2zM20 20h-5v-5H9v5H4v-5h3.49l.6-2h7.82l.6 2H20v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3ee5acd3e1d8fb3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2fdfe162b46aae6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "6.5",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "6.5",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.99 9c-1.38 0-2.5.84-2.5 1.88h5c0-1.04-1.12-1.88-2.5-1.88zM1 16c0 3.31 2.69 6 6 6s6-2.69 6-6V9H1v7zm2-5h8v5c0 2.21-1.79 4-4 4s-4-1.79-4-4v-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2v5.5h2V4h8v5c0 2.21-1.79 4-4 4-.95 0-1.81-.35-2.5-.9v2.35c.76.35 1.61.55 2.5.55 3.31 0 6-2.69 6-6V2H11z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "13.5",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13.5",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17.88c1.38 0 2.5-.84 2.5-1.88h-5c0 1.04 1.12 1.88 2.5 1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$88f96b356fef9c48(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8a1.003 1.003 0 01-.71-1.71c.4-.4 2.46-1.04 2.46-1.04s-.64 2.06-1.04 2.46c-.18.18-.43.29-.71.29zm1 5v5c0 1.65-1.35 3-3 3s-3-1.35-3-3v-2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8.17A3.009 3.009 0 0116 16v2c0 .55.45 1 1 1s1-.45 1-1v-5h-1v-1.42c-1.77-.77-3-2.53-3-4.58 0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.05-1.23 3.81-3 4.58V13h-1zm2-6c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zM10 7L8 9V6.17L9.17 5H4.83L6 6.17V9L4 7v2.17l2 2V14l-2-2v2.17l2 2V19l-2-2v2h6v-2l-2 2v-2.83l2-2V12l-2 2v-2.83l2-2V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8d9416ccb600432c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-5 9H9V5h6v14zm-3-1c.83 0 1.5-.67 1.5-1.5S12.83 15 12 15s-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm0-4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM12 9c.83 0 1.5-.67 1.5-1.5S12.83 6 12 6s-1.5.67-1.5 1.5S11.17 9 12 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3bbbe371b2b3412e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2l2-2h4l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-4-4-8-4zm0 2c3.51 0 4.96.48 5.57 1H6.43c.61-.52 2.06-1 5.57-1zM6 7h5v3H6V7zm12 8.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5h-5V7h5v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$def412077750ab16(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5l.75-1.5H17V2H7v1.5h4.75L11 5c-3.13.09-6 .73-6 3.5V17c0 1.5 1.11 2.73 2.55 2.95L6 21.5v.5h2l2-2h4l2 2h2v-.5l-1.55-1.55h-.01.01C17.89 19.73 19 18.5 19 17V8.5c0-2.77-2.87-3.41-6-3.5zm-1.97 2h1.94c2.75.08 3.62.58 3.9 1H7.13c.28-.42 1.15-.92 3.9-1zm-.18 10.95H7.74A.974.974 0 017 17v-1h3.89c-.24.27-.39.61-.39 1 0 .36.13.69.35.95zM17 17c0 .45-.3.84-.74.95h-3.11c.22-.26.35-.59.35-.95 0-.39-.15-.73-.39-1H17v1zm0-3H7v-4h10v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4c1febf04922e673(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5h-5.51zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18v1.75zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a00a0ca88b7f4860(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18H6V8h3v4.77L15.98 6 18 8.03 11.15 15H16v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5d952076ad0a1db1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm10 6c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4355be30aa82f746(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.83 11l1.59 1.59L7 14l-4-4 4-4 1.41 1.41L6.83 9H15c1.1 0 2 .9 2 2v9h-2v-9H6.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f626ac09fa19ec9f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.17 11l-1.59 1.59L17 14l4-4-4-4-1.41 1.41L17.17 9H9c-1.1 0-2 .9-2 2v9h2v-9h8.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f16a617e6871afc7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.83L4.41 8.41 3 7l4-4 4 4-1.41 1.41L8 6.83V13h8c1.1 0 2 .9 2 2v6h-2v-6H8c-1.1 0-2-.9-2-2V6.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$578d27eb0f1a66ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6.83l1.59 1.59L21 7l-4-4-4 4 1.41 1.41L16 6.83V13H8c-1.1 0-2 .9-2 2v6h2v-6h8c1.1 0 2-.9 2-2V6.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fdbd2ca77efb8021(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.66 6V4H6v5.66h2V7.41l5 5V20h2v-7.58c0-.53-.21-1.04-.59-1.41l-5-5h2.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c1da8167d27fff7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.34 6V4H18v5.66h-2V7.41l-5 5V20H9v-7.58c0-.53.21-1.04.59-1.41l5-5h-2.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$49d7302b75f552bf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.17 11H4h.17m9.24-6H9v2h3.59l2 2H11l-4 2-2-2H0v2h4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4l2 2h3l3.49-6.1 1.01 1.01c-.91.73-1.5 1.84-1.5 3.09 0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4c-.18 0-.36.03-.53.05L17.41 9H20V6l-3.72 1.86L13.41 5zM20 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM4 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$15f3d1cd5653f356(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9v12h-2V9c0-2.21-1.79-4-4-4S8 6.79 8 9v4.17l1.59-1.59L11 13l-4 4-4-4 1.41-1.41L6 13.17V9c0-3.31 2.69-6 6-6s6 2.69 6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$edb1a530e9f15e99(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9v12h2V9c0-2.21 1.79-4 4-4s4 1.79 4 4v4.17l-1.59-1.59L13 13l4 4 4-4-1.41-1.41L18 13.17V9c0-3.31-2.69-6-6-6S6 5.69 6 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ea8be65fafeeeaac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13c3.09-2.81 6-5.44 6-7.7C22 3.45 20.55 2 18.7 2c-1.04 0-2.05.49-2.7 1.25C15.34 2.49 14.34 2 13.3 2 11.45 2 10 3.45 10 5.3c0 2.26 2.91 4.89 6 7.7zm-2.7-9c.44 0 .89.21 1.18.55L16 6.34l1.52-1.79c.29-.34.74-.55 1.18-.55.74 0 1.3.56 1.3 1.3 0 1.12-2.04 3.17-4 4.99-1.96-1.82-4-3.88-4-4.99 0-.74.56-1.3 1.3-1.3zM19 16h-2c0-1.2-.75-2.28-1.87-2.7L8.97 11H1v11h6v-1.44l7 1.94 8-2.5v-1c0-1.66-1.34-3-3-3zM3 20v-7h2v7H3zm10.97.41L7 18.48V13h1.61l5.82 2.17c.34.13.57.46.57.83 0 0-1.99-.05-2.3-.15l-2.38-.79-.63 1.9 2.38.79c.51.17 1.04.26 1.58.26H19c.39 0 .74.23.9.56l-5.93 1.84z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$911b2565ad8c0a59(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.35V19h-2v-8H6v8H4V8.35l8-3.2 8 3.2zM22 21V7L12 3 2 7v14h6v-8h8v8h6zm-11-2H9v2h2v-2zm2-3h-2v2h2v-2zm2 3h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$474827c4d0102f56(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v6c0 2.97 2.16 5.43 5 5.91V19H8v2h8v-2h-3v-4.09c2.84-.48 5-2.94 5-5.91V3H6zm6 10c-1.86 0-3.41-1.28-3.86-3h7.72c-.45 1.72-2 3-3.86 3zm4-5H8V5h8v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a432c30d47cf868b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11v.2c0 2.34-1.95 5.44-6 9.14-4.05-3.7-6-6.79-6-9.14C6 7.57 8.65 5 12 5c.34 0 .68.03 1 .08V3.06c-.33-.04-.66-.06-1-.06-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8V11h-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.54 2.88l-1.42-1.42L19 3.59l-2.12-2.13-1.42 1.42L17.59 5l-2.13 2.12 1.42 1.42L19 6.41l2.12 2.13 1.42-1.42L20.41 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$854f76c95397c5d1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9V3H7v2.59L3.91 2.5 2.5 3.91 5.59 7H3v2h6zm12 0V7h-2.59l3.09-3.09-1.41-1.41L17 5.59V3h-2v6h6zM3 15v2h2.59L2.5 20.09l1.41 1.41L7 18.41V21h2v-6H3zm12 0v6h2v-2.59l3.09 3.09 1.41-1.41L18.41 17H21v-2h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8da3ffb613bd68bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3v6zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6v-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a102e78d7fb25278(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14H5v5H3v-6.97l5-3.57 5 3.57v1.08c.57-.59 1.25-1.07 2-1.42V11L8 6l-7 5v10h6v-5h2v5h2.68c-.43-.91-.68-1.92-.68-3v-4zM17 7h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 13.11V3H10v1.97l2 1.43V5h9v6.68c.75.36 1.43.84 2 1.43zM23 18c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5zm-5.5 3v-2.5H15v-1h2.5V15h1v2.5H21v1h-2.5V21h-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b1697e1f357ced4e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M7 20h10v1H7zM7 3h10v1H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.81 12.74l-.82-.63v-.22l.8-.63c.16-.12.2-.34.1-.51l-.85-1.48a.395.395 0 00-.35-.2c-.05 0-.1.01-.15.03l-.95.38c-.08-.05-.11-.07-.19-.11l-.15-1.01a.408.408 0 00-.4-.36h-1.71c-.2 0-.37.15-.4.34l-.14 1.01c-.03.02-.07.03-.1.05l-.09.06-.95-.38a.401.401 0 00-.5.17l-.85 1.48c-.1.17-.06.39.1.51l.8.63v.23l-.8.63a.39.39 0 00-.1.51l.85 1.48c.07.13.21.2.35.2.05 0 .1-.01.15-.03l.95-.37c.08.05.12.07.2.11l.15 1.01c.03.2.2.34.4.34h1.71c.2 0 .37-.15.4-.34l.15-1.01c.03-.02.07-.03.1-.05l.09-.06.95.38a.401.401 0 00.5-.17l.85-1.48a.39.39 0 00-.1-.51zM18 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM17 18H7V6h10v1h2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v1zM7 3h10v1H7V3zm10 18H7v-1h10v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$832698e70525a398(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6 6h4v-4h-4v4zm3-20c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 8h-1V7h1v1zm0-2h-1V2h1v4zM16 14h4v-2.07c-.33.05-.66.07-1 .07-1.07 0-2.09-.24-3-.68V14zM10 4v4h2.68c-.44-.91-.68-1.93-.68-3 0-.34.02-.67.07-1H10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dda02cff8ed067e4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$520ac330612b6b13(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.77 3.77L16 2 6 12l10 10 1.77-1.77L9.54 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4710676bed82d22c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ddaee0ff65b229fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$631e6cc1d1db61f4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab7367299ac7ce96(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 13l-4-4h8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$18a36838945a9099(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10l5 5 5-5H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eaa389cadd096bf5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14l5-5 5 5H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$710c8db0bee22f6e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.23 20.23L8 22l10-10L8 2 6.23 3.77 14.46 12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$243368c5e798a547(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$92d454c2e3c37020(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0v24H0V0h24z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7l-5 5 5 5V7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$27a4ff8b4d4b9e6b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17l5-5-5-5v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fced0c68d35ebb48(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9d91b35211bf847(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm0 20c-4.99 0-9-4.01-9-9s4.01-9 9-9 9 4.01 9 9-4.01 9-9 9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.73 11.42L12.54 4.2c-.36-.27-.8-.27-1.15 0L4.2 11.42c-.27.36-.27.8 0 1.16l7.19 7.22c.36.27.8.27 1.15 0l7.19-7.22c.36-.36.36-.89 0-1.16zM13.5 14.5l-1.41-1.41L13.17 12H10v3H8v-4c0-.6.4-1 1-1h4.17l-1.09-1.09L13.5 7.5 17 11l-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e7364bbd35831e49(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11v2h4v-2h-4zM16 17.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm5.03 1.71L11 9.53v4.94l-1.97-1.18-.48-.29H4v-2h4.55l.48-.29zM15.5 12c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3e15ce77c8c84427(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$35f804fec403305a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$770a06900b62264e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b63447889d7e9a80(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$620750af8a910769(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$62af402f7a097c9b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 5H11l5 7-5 7h4.5l5-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5H4l5 7-5 7h4.5l5-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4ac5542b77280e10(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5l-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e7ab97cf810c0577(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.08 9.59L12 12.67 8.92 9.59 7.5 11l4.5 4.5 4.5-4.5-1.42-1.41zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3c1b1738f4e99087(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5095bc7e88fbda69(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a1c6991dc307886b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0v24H0V0h24z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e3f8e90b24d0cca0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6cc0d010112cd760(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$550fcea7faa9c6a9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11v10h6v-5h2v5h6V11L8 6l-7 5zm12 8h-2v-5H5v5H3v-6.97l5-3.57 5 3.57V19zM17 7h2v2h-2zM17 11h2v2h-2zM17 15h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3v1.97l2 1.43V5h9v14h-4v2h6V3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cad33a102bc57e01(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6-1.41 1.41zM16 6h2v12h-2V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$668d58beb019e090(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15H4v-2h16v2zm0 2H4v2h16v-2zm-5-6l5-3.55V5l-5 3.55L10 5 4 8.66V11l5.92-3.61L15 11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5fc6966e1be8d819(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7h2v2h-2zM17 11h2v2h-2zM17 15h2v2h-2zM1 11v10h6v-5h2v5h6V11L8 6l-7 5zm12 8h-2v-5H5v5H3v-7l5-3.5 5 3.5v7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3v1.97l2 1.43V5h9v14h-4v2h6V3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$546ebf4c217a1cdb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19e74e98d4056458(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$92ee101fea2a7d52(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f7d659b5919d9442(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bfdf042f31bf211d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$665df632c3a3073e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h2V8.41L18.59 20 20 18.59 8.41 7H15V5H5v10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fd14205535868e4b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9l1.41 1.41L11 5.83V22h2V5.83l4.59 4.59L19 9l-7-7-7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b39c167471d75cdb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5H4v16c0 1.1.9 2 2 2h10v-2H6V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1h-8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16h-8v-1h8v1zm0-3h-8V6h8v8zm0-10h-8V3h8v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 10.25h1.63l-.69.69L14.5 12 17 9.5 14.5 7l-1.06 1.06.69.69H12c-.55 0-1 .45-1 1V12h1.5v-1.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$75219824b6d08c03(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-2 0H3V6h14v8zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm13 0v11c0 1.1-.9 2-2 2H4v-2h17V7h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a96417cc5dea86a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c0-1.1-.9-2-2-2h-9v5h11V5zM3 19c0 1.1.9 2 2 2h3V10H3v9zM3 5v3h5V3H5c-1.1 0-2 .9-2 2zm15 3.99L14 13l1.41 1.41 1.59-1.6V15c0 1.1-.9 2-2 2h-2.17l1.59-1.59L13 14l-4 4 4 4 1.41-1.41L12.83 19H15c2.21 0 4-1.79 4-4v-2.18l1.59 1.6L22 13l-4-4.01z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ceebede24f9277d0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$39d72c15f4e9f821(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-2v6.59L5.41 4 4 5.41 15.59 17H9v2h10V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1de2328ad6542cdc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19v-2H8.41L20 5.41 18.59 4 7 15.59V9H5v10h10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$14a324c48555a264(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15l-1.41-1.41L13 18.17V2h-2v16.17l-4.59-4.59L5 15l7 7 7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3a32f822af2effd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8a30072d31b65973(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9f0e3d50646b9baf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 8.62v6.76L5.12 12 8.5 8.62M10 5l-7 7 7 7V5zm4 0v14l7-7-7-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$24e38f23f2f5b87c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 15.38V8.62L18.88 12l-3.38 3.38M14 19l7-7-7-7v14zm-4 0V5l-7 7 7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b104adba27ecedc3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0v24H0V0h24z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6f74e8452dd04bc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c24bf27a54a2d81e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h3v16h-3V4zM3 13h3v7H3v-7zm11-9h3v3h-3V4zm-4 1h3v4h-3V5zm-3 5h3v4H7v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$583fe2fd9bf8f868(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19l1.41-1.41L5.83 13H22v-2H5.83l4.59-4.59L9 5l-7 7 7 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$851a67bc46713504(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3h7zM7 9H4V5h3v4zm10 6h3v4h-3v-4zm0-10h3v4h-3V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ad6f4f9180114bac(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$41452e8b1aac2965(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.5c.31 0 .7.15.9.56.24.5.02 1.1-.47 1.34a.979.979 0 01-1.32-.46.986.986 0 01.46-1.34c.14-.06.28-.1.43-.1m6.47 2.11l6.69 2.41c.52.19.93.56 1.15 1.05.22.48.25 1.03.06 1.53l-.01.02-8.59-3.11.7-1.9M10 15.19l4 1.44V17h-4v-1.81M6 4.5c-.44 0-.88.1-1.3.3a2.99 2.99 0 00-1.4 4 2.988 2.988 0 004 1.4 3.01 3.01 0 001.41-4A3.013 3.013 0 006 4.5zm5.28 1.55L9.2 11.71l12.36 4.47.69-1.89a4 4 0 00-2.41-5.15l-8.56-3.09zm-9.09 4.2l-.69 1.89L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f791d52ad6f8c30(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13a3 3 0 002.1-5.14C6.51 7.29 5.75 7 5 7a3 3 0 00-2.1 5.14c.59.57 1.35.86 2.1.86zm-.71-3.7a1 1 0 011.41-.02c.4.39.4 1.01.02 1.41-.2.2-.45.31-.72.31-.26 0-.51-.1-.7-.28-.4-.4-.4-1.02-.01-1.42zM18 7H9v6h13v-2c0-2.21-1.79-4-4-4zm-7 4V9h7c1.1 0 2 .9 2 2h-9zm-9 5h6v2h8v-2h6v-2H2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ad8951f5028da9e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V7H1v10h22v-6c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a9100e604906b09(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98A2.019 2.019 0 0014.51 9H11V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cf33d33aa868ac7d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7fe9d84492081b57(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ecdd61f2a8e959a9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76A5.01 5.01 0 008.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38a2.21 2.21 0 00-.99-.06h-.02a2.268 2.268 0 00-1.84 2.61l1.35 5.92A3.008 3.008 0 009.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb08265f07ddb5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.59 5.41c-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0 .78 2.05 0 2.83c-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3d3b6563780cdf2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33s-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2a9.936 9.936 0 001.54-5.31c-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2befcc66df4e8cb5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V6a2 2 0 00-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM11 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d7160d64fa0e62c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.71 11.29l-9-9a.996.996 0 00-1.41 0L8.21 5.38l1.41 1.41L12 4.42 19.58 12l-2.38 2.38 1.41 1.41 3.09-3.09c.4-.37.4-1 .01-1.41z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.5v2.67l2.17 2.17L16.5 11zM1.39 4.22l3.99 3.99-3.09 3.09a.996.996 0 000 1.41l9 9c.39.39 1.02.39 1.41 0l3.09-3.09 3.99 3.99 1.41-1.41L2.81 2.81 1.39 4.22zm6.64 6.63c-.01.05-.04.1-.04.15v4h2v-2.18l4.38 4.38L12 19.58 4.42 12 6.8 9.62l1.23 1.23z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a4a7fb5390cdea(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h2v5h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm10-4h2v2h-2zm-10-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c1f262933b5f0519(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f747ab03492eaf9b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8 0 1.41-.37 2.73-1.01 3.88l1.46 1.46A9.96 9.96 0 0022 12c0-5.52-4.48-10-10-10a9.9 9.9 0 00-5.33 1.55l1.46 1.46A7.883 7.883 0 0112 4zm5 7h-2.88l2 2H17zM2.41 2.13L1 3.54l2.78 2.78A9.92 9.92 0 002 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.41-1.41L2.41 2.13zM12 20c-4.41 0-8-3.59-8-8 0-1.56.45-3 1.23-4.23L8.46 11H7v2h3.46l5.77 5.77A7.846 7.846 0 0112 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e330384136b4993a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-9h10v2H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ebe336fd63e39daf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e970aca0547c389(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3b5965f120916c1d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.94 5.12C9.14 4.41 10.52 4 12 4c4.41 0 8 3.59 8 8 0 1.48-.41 2.86-1.12 4.06l1.46 1.46A9.967 9.967 0 0022 12c0-5.52-4.48-10-10-10-2.04 0-3.93.61-5.51 1.66l1.45 1.46zM2.81 2.81L1.39 4.22l2.27 2.27A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l2.27 2.27 1.41-1.41L2.81 2.81zM12 20c-4.41 0-8-3.59-8-8 0-1.48.41-2.86 1.12-4.06L8.17 11H7v2h3.17l5.88 5.88A7.869 7.869 0 0112 20z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.83 11l2 2H17v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bf4af08302be60fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$929140c554d968fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$da93e5611eb9c199(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 6h10.29l1.04 3H5.81l1.04-3zM19 16H5v-4.66l.12-.34h13.77l.11.34V16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cfc3871f964ae3cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10zm-5-9h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$88bbda53e0fa6f69(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm5.56 10.46l5.93-5.93-1.06-1.06-4.87 4.87-2.11-2.11-1.06 1.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$77b3705a7b43415c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm3.23 9.41l1.06 1.06 2.44-2.44 2.44 2.44 1.06-1.06-2.44-2.44 2.44-2.44-1.06-1.06-2.44 2.44-2.44-2.44-1.06 1.06 2.44 2.44z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4ea3694c80b03be(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm2 4h10v2H7zm0 4h7v2H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$47407efa4caed211(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$25ff879892cb99f0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7V3c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h8v3h-1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1h-1v-3c0-1.1-.9-2-2-2H4V6h2v1c0 .55.45 1 1 1h12c.55 0 1-.45 1-1zM8 4h10v2H8V4zm6 17h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$51cd9ed40e6b8a17(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10v8l7-4zm12-4h-7.58l3.29-3.29L16 2l-4 4h-.03l-4-4-.69.71L10.56 6H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 14H3V8h18v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b93af3061c37d0f2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-5.5-8L11 12.51 8.5 9.5 5 14h14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fed711e7335b6533(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7.07L2.4 12l4.66-7H22v14z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6ee2718dcdef29c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2a15.367 15.367 0 00-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2a7.1 7.1 0 014.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8b3af56f4c0c88b1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-.5a2.5 2.5 0 00-5 0v.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5zM18 5.83v5.43c.47-.16.97-.26 1.5-.26.17 0 .33.03.5.05V1L1 20h13v-2H5.83L18 5.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$611d3699dda2db28(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.66l2 2H18v5.56l2 2V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.32 0-4.26 1.59-4.82 3.74L8.9 6.46V6zM4.41 4.81L3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12.78l1 1 1.41-1.41L4.41 4.81zM6 20V10h.78l10 10H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ca49f89154f53808(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.66l2 2H18v5.56l2 2V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.32 0-4.26 1.59-4.82 3.74L8.9 6.46V6zM4.41 4.81L3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12.78l1 1 1.41-1.41L4.41 4.81zM6 20V10h.78l10 10H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9bc7cf2a9bce837c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7v8l7-4zm12-4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e38e5ab1b3b9a791(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 00-2-2zm0 14H3V5h18v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$632dc37b4ec88e92(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4a04b5cab2a733ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.51c-1.24 0-2.45-.2-3.57-.57a.84.84 0 00-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1zM5.03 5h1.5a13 13 0 00.46 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79zM19 18.97c-1.32-.09-2.59-.35-3.8-.75l1.19-1.19c.85.24 1.72.39 2.6.45v1.49zM18 9h-2.59l5.02-5.02-1.41-1.41L14 7.59V5h-2v6h6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eaa5dccd37cc0778(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM18 11l5-5-5-5v3h-4v4h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56b708c9d5017464(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3zm4 0h2a9 9 0 00-9-9v2c3.87 0 7 3.13 7 7zm1 3.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3d8267a06b23096b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5V4c0-1.1-.9-2-2-2s-2 .9-2 2v1h-1v5h6V5h-1zm-1 0h-2V4c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2 14.87l-3.67-.73c-.5-.1-.83.2-.9.27l-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.55.03 1.03-.43 1.03-1v-4.15c0-.48-.34-.89-.8-.98zM5.1 5h2.23l.47 2.35L6.17 9c-.54-1.3-.9-2.63-1.07-4zM19 18.9c-1.37-.18-2.7-.53-4-1.07l1.65-1.63 2.35.47v2.23z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d2ce525734013367(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.71 16.67C20.66 13.78 16.54 12 12 12S3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.28-.12-.52-.3-.7zm-18.31.56c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7zm15.08 1.26c-.6-.48-1.22-.9-1.88-1.27v-1.7c1.05.51 2.03 1.15 2.95 1.9l-1.07 1.07zM7 6.43l4.94 4.94 7.07-7.07-1.41-1.42-5.66 5.66L8.4 5H11V3H5v6h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe876b6dd62b2b5c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.54 5c.06.88.21 1.75.44 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79h1.51m9.86 12.01c.85.24 1.72.39 2.6.45v1.5c-1.32-.09-2.6-.35-3.8-.76l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1zM15 3h2v7h-2zm4 0h2v7h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$79d36c850069f107(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H8v1.88l2 2zm6 6v3.88l1.8 1.8.2-.2V9c0-1.1-.9-2-2-2V3h-2v4h-3.88l2 2H16zM4.12 3.84L2.71 5.25 6 8.54v5.96L9.5 18v3h5v-3l.48-.48 4.47 4.47 1.41-1.41L4.12 3.84zm8.38 13.33V19h-1v-1.83L8 13.65v-3.11l5.57 5.57-1.07 1.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$804be1bbe9bf6e5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9v4.66l-3.5 3.51V19h-1v-1.83L8 13.65V9h8m0-6h-2v4h-4V3H8v4h-.01C6.9 6.99 6 7.89 6 8.98v5.52L9.5 18v3h5v-3l3.5-3.51V9c0-1.1-.9-2-2-2V3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$300893d2b11f68ae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "19",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3h4v12h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$691b3f5159ad3ef2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10v8h-2v-8h2zm-2 10v2h2v-2h-2zm-2-2.71A7.99 7.99 0 0112 20c-4.41 0-8-3.59-8-8s3.59-8 8-8v9l7.55-7.55A9.965 9.965 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10c2.25 0 4.33-.74 6-2v-2.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$abc71b20b5afb8a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V8.83L10.83 4H18v16zm-7-5h2v2h-2zm0-7h2v5h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc7c21dc0f3744fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V8.83L10.83 4H18v16zM9 7h2v4H9zm3 0h2v4h-2zm3 0h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2be2f41bd15f0b5b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V8.83L10.83 4H18v16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zM11 8h2v5h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$18dc776a994066f1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e1928ef098392ca5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM7 9h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bb9bf4f025176ea4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.22C21 6.73 16.74 3 12 3c-4.69 0-9 3.65-9 9.28-.6.34-1 .98-1 1.72v2c0 1.1.9 2 2 2h1v-6.1c0-3.87 3.13-7 7-7s7 3.13 7 7V19h-8v2h8c1.1 0 2-.9 2-2v-1.22c.59-.31 1-.92 1-1.64v-2.3c0-.7-.41-1.31-1-1.62z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11.03A6.04 6.04 0 0012.05 6c-3.03 0-6.29 2.51-6.03 6.45a8.075 8.075 0 004.86-5.89c1.31 2.63 4 4.44 7.12 4.47z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$287088a359badbc5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6.35V4.26c-.66.17-1.29.43-1.88.75l1.5 1.5c.13-.05.25-.11.38-.16zM20 12c0-2.21-.91-4.2-2.36-5.64L20 4h-6v6l2.24-2.24A6.003 6.003 0 0118 12c0 .85-.19 1.65-.51 2.38l1.5 1.5A7.921 7.921 0 0020 12zM4.27 4L2.86 5.41l2.36 2.36a7.925 7.925 0 001.14 9.87L4 20h6v-6l-2.24 2.24A6.003 6.003 0 016 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.24-.76.34v2.09c.8-.21 1.55-.54 2.23-.96l2.58 2.58 1.41-1.41L4.27 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$313d97461c1279e5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4.26v2.09C7.67 7.18 6 9.39 6 12c0 1.77.78 3.34 2 4.44V14h2v6H4v-2h2.73A7.942 7.942 0 014 12c0-3.73 2.55-6.85 6-7.74zM20 4h-6v6h2V7.56c1.22 1.1 2 2.67 2 4.44h2c0-2.4-1.06-4.54-2.73-6H20V4zm0 13v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1378a3f5da9eaa19(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24A6.003 6.003 0 015 12a5.99 5.99 0 014-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24A6.003 6.003 0 0119 12a5.99 5.99 0 01-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cc3639ff206c6158(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M.01 0h24v24h-24V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0020 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 004 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6433abe847dc3bff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9e0069b88f6b12ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2a9 9 0 019 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f3d942c49680af1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 6h10.29l1.04 3H5.81l1.04-3zM19 16H5v-4.66l.12-.34h13.77l.11.34V16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c4f50d4ef4bf5cf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7v10.88l1.85 1.85c.09-.23.15-.47.15-.73V7c0-1.11-.89-2-2-2h-7.58l3.29-3.3L16 1l-4 4-4-4-.7.7L10.58 5H8.12l2 2H21zm-.54 16l1.26-1.27-1.26 1.26zM2.41 2.13l-.14.14L1 3.54l1.53 1.53C1.65 5.28 1 6.06 1 7v12c0 1.1.9 2 2 2h15.46l1.99 1.99 1.26-1.26.15-.15L2.41 2.13zM3 19V7h1.46l12 12H3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b34094e50fb83578(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b3b00033ff9841b6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14h6c.55 0 1-.45 1-1v-1.99L17 13V7l-2 1.99V7c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$17da0fb494c21c1b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-6-5.4l3 2.4V7l-3 2.4V7H7v6h7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e496fb6cba2371b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 12c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93zM22 4v-.5a2.5 2.5 0 00-5 0V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b491bfa6363ee1ec(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M.01 0h24v24h-24V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63A2.01 2.01 0 0016.56 7h-.12a2 2 0 00-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c14a42a5ef4d0276(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11l2-2c-3.73-3.73-8.87-5.15-13.7-4.31l2.58 2.58c3.3-.02 6.61 1.22 9.12 3.73zm-2 2a9.895 9.895 0 00-3.72-2.33l3.02 3.02.7-.69zM9 17l3 3 3-3a4.237 4.237 0 00-6 0zM3.41 1.64L2 3.05 5.05 6.1C3.59 6.83 2.22 7.79 1 9l2 2c1.23-1.23 2.65-2.16 4.17-2.78l2.24 2.24A9.823 9.823 0 005 13l2 2a6.999 6.999 0 014.89-2.06l7.08 7.08 1.41-1.41L3.41 1.64z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$239c599af997795f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3a4.237 4.237 0 00-6 0zm-4-4l2 2a7.074 7.074 0 0110 0l2-2C15.14 9.14 8.87 9.14 5 13z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$200f7f6ef64fac74(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ceea17ae3fd5a3c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H3a2 2 0 00-2 2v9h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-6-6zm-2 2h1l3 3h-4V7zM9 7h4v3H9V7zM3 7h4v3H3V7zm3 10.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm12 0a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM21 14h-.78c-.55-.61-1.34-1-2.22-1s-1.67.39-2.22 1H8.22c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3v-2h18v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e5d237bb3bf32825(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2A5.37 5.37 0 005.4 6.62C2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l7.03-6.24c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12a5.386 5.386 0 003.82 1.57c2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4527a054890029a5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11V3H7v4H3v14h8v-4h2v4h8V11h-4zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm4 4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19fbbf71eeb33591(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8v2h-3L8.31 8.82 7 12.75V22H3V12l1.58-4.63A2.003 2.003 0 017.3 6.18l4.15 1.83L14 8zM8 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm1 18h12v-2H9v2zm10.5-3c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM13 12c0-.55-.45-1-1-1H9v2h2v1c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-3h-2v2h-2v-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5165d862dce9a5f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4.14V2h-3v2h-4V2H7v2.14c-1.72.45-3 2-3 3.86v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.86-1.28-3.41-3-3.86zM18 20H6V8c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v12zm-1.5-8v4h-2v-2h-7v-2h9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0v24h24V0H0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa6113f751a96a0e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10v2H8v-2h2zm6 2v-2h-2v2h2zm5 2v8H3v-8h1v-4c0-4.42 3.58-8 8-8s8 3.58 8 8v4h1zM7 16H5v4h2v-4zm4 0H9v4h2v-4zm0-11.92C8.16 4.56 6 7.03 6 10v4h5V4.08zM13 14h5v-4c0-2.97-2.16-5.44-5-5.92V14zm2 2h-2v4h2v-4zm4 0h-2v4h2v-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bed105cc0929b660(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "7",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25a.828.828 0 011.41.59V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5A2.251 2.251 0 005 12.25V13H2v6c0 1.1.9 2 2 2 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 1.1 0 2-.9 2-2v-6h-2zm0 6H4v-4h16v4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f9f9c1f758f2276b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.57l-1.427 1.428-6.442-6.442 1.43-1.428zM13.12 3c-2.58 0-5.16.98-7.14 2.95l-.01.01c-3.95 3.95-3.95 10.36 0 14.31l14.3-14.31A10.086 10.086 0 0013.12 3zM6.14 17.27a8.063 8.063 0 01-.68-6.82c.19 1.91.89 3.79 2.07 5.44l-1.39 1.38zm2.84-2.84C7.63 12.38 7.12 9.93 7.6 7.6c.58-.12 1.16-.18 1.75-.18 1.8 0 3.55.55 5.08 1.56l-5.45 5.45zm1.47-8.97a8.063 8.063 0 016.82.68l-1.39 1.39a11.25 11.25 0 00-5.43-2.07z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d84d80394b8de3b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 6h-6V7h6v4zM4 7h8v10H4V7zm10 10v-4h6v4h-6zm-4.5-5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e8b2a73c9e956b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14h-2v-2h2v2zm5.1 2.56L17 14.79V21H7v-6.2l-1.1 1.76-1.7-1.06L12 3l7.8 12.5-1.7 1.06zM15 11.59l-3-4.8-3 4.8V19h2v-3h2v3h2v-7.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$512f1431ad734a36(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-4V5l-2-2h-4L8 5v2H4c-1.1 0-2 .9-2 2v5c0 .75.4 1.38 1 1.73V19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-3.28c.59-.35 1-.99 1-1.72V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zM4 9h16v5h-5v-3H9v3H4V9zm9 6h-2v-2h2v2zm6 4H5v-3h4v1h6v-1h4v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3334f988a7abc98c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 1c0 1.66-1.34 3-3 3-.55 0-1 .45-1 1H4c0-1.66 1.34-3 3-3 .55 0 1-.45 1-1h2zm2 2L6 7.58V6H4v3.11L1 11.4l1.21 1.59L4 11.62V21h16v-9.38l1.79 1.36L23 11.4 12 3zm1.94 4h-3.89L12 5.52 13.94 7zm-6.5 2h9.12L18 10.1v.9H6v-.9L7.44 9zM18 13v2H6v-2h12zM6 19v-2h12v2H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$27d64063871653a9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.73 14.23L7 1.5 3.11 5.39l8.13 11.67c-.78.78-.78 2.05 0 2.83l1.41 1.41c.78.78 2.05.78 2.83 0l4.24-4.24c.79-.78.79-2.05.01-2.83zM5.71 5.62L7 4.33l8.49 8.49-2.81 2.81L5.71 5.62zm8.36 14.26l-1.41-1.41 4.24-4.24 1.41 1.41-4.24 4.24z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5574745dd8b2f48e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4755742cf363e49d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 15L10 7.5 2.5 15l1.41 1.41L5 15.33V20h10v-4.67l1.09 1.09L17.5 15zM13 18h-2v-3H9v3H7v-4.67l3-3 3 3V18zm9-10.5h-1.19l.75.75-.71.71-1.46-1.46h-.89v.89l1.45 1.45-.71.71-.74-.74V11h-1V9.81l-.75.75-.71-.71 1.45-1.45v-.9h-.89l-1.45 1.45-.71-.71.75-.75H14v-1h1.19l-.75-.75.71-.71 1.45 1.45h.89v-.87l-1.45-1.45.71-.71.75.75V3h1v1.19l.75-.75.71.71-1.46 1.46v.89h.89l1.45-1.45.71.71-.74.74H22v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c7773f4e47089616(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 11l-3 6v-4h-2l3-6v4h2zM17 3H7v1h10V3m0 17H7v1h10v-1m0-19c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h10zM7 18h10V6H7v12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$76453e65321f175b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.6 18.2L13 11.75v-.91a3.496 3.496 0 00-.18-6.75A3.51 3.51 0 008.5 7.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 .84-.69 1.52-1.53 1.5-.54-.01-.97.45-.97.99v1.76L2.4 18.2c-.77.58-.36 1.8.6 1.8h18c.96 0 1.37-1.22.6-1.8zM6 18l6-4.5 6 4.5H6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1a417c34fcc08d6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "10.5",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "10.5",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.94 11.34a4.008 4.008 0 00-2.81-3.17 9.114 9.114 0 00-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91a3.994 3.994 0 00-2.81 3.17c-.04.21-.06.43-.06.66 0 .23.02.45.06.66a4.008 4.008 0 002.81 3.17 8.977 8.977 0 002.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89a3.998 3.998 0 002.8-3.17c.04-.21.06-.43.06-.66 0-.23-.02-.45-.06-.66zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zm-7 3c2.01 0 3.74-1.23 4.5-3h-9c.76 1.77 2.49 3 4.5 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85bef30325bed149(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2v8h8c0-4.42-3.58-8-8-8zm2 6V4.34c1.7.6 3.05 1.95 3.66 3.66H15zm-8.56 3l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61A7.948 7.948 0 0021 11H6.44zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20zm.74-5.34l-.29.37A3.505 3.505 0 0013.84 17h-2.68c-.5-1.04-1.5-1.8-2.68-1.97l-.44-.67c-.1-.17-.34-.69-.67-1.36h11.29c-.21.59-.52 1.15-.92 1.66z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b4dbd41b6e72b815(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h20V7H12zm-2 12H4v-2h6v2zm0-4H4v-2h6v2zm0-4H4V9h6v2zm0-4H4V5h6v2zm10 12h-8V9h8v10zm-2-8h-4v2h4v-2zm0 4h-4v2h4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e031cd824816e641(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L6 7.58V6H4v3.11L1 11.4l1.21 1.59L4 11.62V21h16v-9.38l1.79 1.36L23 11.4 12 3zm6 16h-5v-4h-2v4H6v-8.9l6-4.58 6 4.58V19zM10 1c0 1.66-1.34 3-3 3-.55 0-1 .45-1 1H4c0-1.66 1.34-3 3-3 .55 0 1-.45 1-1h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$821e09d610dfea1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10h-4V7c0-1.66-1.34-3-3-3s-3 1.34-3 3h2c0-.55.45-1 1-1s1 .45 1 1v3H8c1.1 0 2-.9 2-2V4H4v4c0 1.1.9 2 2 2H2v2h2v8h16v-8h2v-2zM6 6h2v2H6V6zm0 12v-6h5v6H6zm12 0h-5v-6h5v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a742ae8c7392e7b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9h-6V4H8C5.79 4 4 5.79 4 8v6c0 1.1.9 2 2 2h2v2.93c-.61-.35-1.16-.78-1.65-1.27l-1.42 1.42C6.74 20.88 9.24 22 12 22c2.76 0 5.26-1.12 7.07-2.93l-1.42-1.42c-.49.49-1.05.92-1.65 1.27V16h2c1.1 0 2-.9 2-2v-3c0-1.1-.9-2-2-2zm-4 10.75c-.64.16-1.31.25-2 .25s-1.36-.09-2-.25V16h4v3.75zM18 14H6V8c0-1.1.9-2 2-2h2v5h8v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6cb9bf1e2684cca0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6v12h2V8h10v10h2v-2h4v2h2V6H2zm18 2v2h-4V8h4zm-4 6v-2h4v2h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$682f70ccdc71754d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.51 15.68l-1.41-1.41 4.48-4.48L23 11.2l-4.49 4.48zm-3.53-3.53l3.07-3.07-4.25-4.26-3.08 3.07L9.3 6.47 13.8 2l7.08 7.08-4.48 4.48-1.42-1.41zm6.2 9.05l-1.41 1.41-5.94-5.94L10.5 20H1v-2.63c0-.84.52-1.57 1.3-1.88.58-.23 1.28-.56 1.97-1.02l1.38 1.38c.09.1.22.15.35.15s.26-.05.36-.15c.2-.2.2-.51 0-.71l-1.28-1.28c.27-.24.53-.51.77-.8l1.27 1.27a.485.485 0 00.7 0c.2-.2.2-.51 0-.71l-1.4-1.4c.19-.34.34-.72.45-1.12l1.71 1.72a.485.485 0 00.7 0c.19-.2.19-.5.01-.7l-7.9-7.9 1.42-1.41L21.18 21.2zm-8.76-5.94l-1.67-1.68-3.33 3.32c-.78.78-2.05.78-2.83-.01l-.19-.17-.47.24c-.29.14-.59.27-.89.39l-.01.65h6.64l2.75-2.74z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee44ad4878a35901(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22 7 9.83v4.3l-2.6-1.48c-.17-.09-.34-.14-.54-.14-.26 0-.5.09-.7.26L2 13.88l6.8 7.18c.57.6 1.35.94 2.18.94H17c.62 0 1.18-.19 1.66-.52l1.12 1.12 1.41-1.41L2.81 2.81zM17 20h-6c-.39 0-.64-.23-.75-.36L6.87 16H9v-4.17l8.14 8.14c-.05.01-.09.03-.14.03zm-3.17-9H14V3.25a1.25 1.25 0 012.5 0V11h1V5.25a1.25 1.25 0 012.5 0v11.92l-2-2V13h-2.17l-2-2zm-.83-.83V2.25a1.25 1.25 0 00-2.5 0v5.42l2.5 2.5zm-3.5-3.5V4.25C9.5 3.56 8.94 3 8.25 3c-.67 0-1.2.53-1.24 1.18L9.5 6.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$644273c3f058854d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.75 16a1.25 1.25 0 000-2.5H12v-1h6.75c.69 0 1.25-.56 1.25-1.25 0-.67-.53-1.2-1.18-1.24L8.87 10l1.48-2.6c.09-.17.14-.34.14-.54 0-.26-.09-.5-.26-.7L9.12 5l-7.18 6.8c-.6.56-.94 1.35-.94 2.17V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 000-2.5H12v-1h7.75a1.25 1.25 0 000-2.5H12v-1h8.75zM10 21H4c-.55 0-1-.45-1-1v-6c0-.39.23-.64.36-.75L7 9.87V12h3v9zm5.65-16.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L15 2h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L19 2h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e7834494cf7a04c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15v-4h1v-2.5c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2V14h1v4h3zM8.5 8.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM18 11l-2.5-4-2.5 4h5zm-5 2l2.5 4 2.5-4h-5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$34d6d6cf4ab55323(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S17.83 8 17 8s-1.5.67-1.5 1.5zm3 2.5h-2.84c-.58.01-1.14.32-1.45.86l-.92 1.32L9.72 8a2.02 2.02 0 00-1.71-1H5c-1.1 0-2 .9-2 2v6h1.5v7h5V11.61L12.03 16h2.2l.77-1.1V22h4v-5h1v-3.5c0-.82-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$17e8dbf56eaf9157(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 3h-3.3l-5 9H7c-.83 0-1.5.67-1.5 1.5S6.17 18 7 18h3.3l5-9H17c.83 0 1.5-.67 1.5-1.5S17.83 6 17 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c5567e7835be5c4f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A2.01 2.01 0 0018.06 7h-.12a2 2 0 00-1.9 1.37l-.86 2.58c1.08.6 1.82 1.73 1.82 3.05v8h3zm-7.5-10.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S11 9.17 11 10s.67 1.5 1.5 1.5zM5.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm2 16v-7H9V9c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v6h1.5v7h4zm6.5 0v-4h1v-4c0-.82-.68-1.5-1.5-1.5h-2c-.82 0-1.5.68-1.5 1.5v4h1v4h3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e90552b879f15d31(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v-2h-2V7l-3-3-2 2-2-2-2 2-2-2-3 3v3H3v2h2v2H3v2h2v4h14v-4h2v-2h-2v-2h2zm-5-5.17l1 1V10h-2V7.83l.41-.41.59-.59zm-4 0l.59.59.41.41V10h-2V7.83l.41-.41.59-.59zM11 14v-2h2v2h-2zm2 2v2h-2v-2h2zM7 7.83l1-1 .59.59.41.41V10H7V7.83zM7 12h2v2H7v-2zm0 4h2v2H7v-2zm10 2h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$367f555ba8da5691(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h10v1c0 1.1-.9 2-2 2H9c-1.1 0-2-.9-2-2v-1zm0-1h10v-5H7v5zM17 3v6l-3.15-.66c-.01 0-.01.01-.02.02 1.55.62 2.72 1.98 3.07 3.64H7.1c.34-1.66 1.52-3.02 3.07-3.64-.33-.26-.6-.58-.8-.95L5 6.5v-1l4.37-.91C9.87 3.65 10.86 3 12 3c.7 0 1.34.25 1.85.66L17 3zm-4 3c-.03-.59-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$44c83885208347b4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29l-1.43-1.43z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4e8ceca6d965ae4c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.5l6 4.5v9H6v-9l6-4.5M12 3L4 9v12h16V9l-8-6zm-.5 6.5v3H11v-3h-1v3h-.5v-3h-1v3c0 .83.67 1.5 1.5 1.5v4h1v-4c.83 0 1.5-.67 1.5-1.5v-3h-1zm1.5 2v3h1V18h1V9.5c-1.1 0-2 .9-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$937b91c6a007c3a5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h3L12 3 2 12h3v3H3v2h2v3h2v-3h4v3h2v-3h4v3h2v-3h2v-2h-2v-3zM7 15v-4.81l4-3.6V15H7zm6 0V6.59l4 3.6V15h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84c487f59b1c8815(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h16v2H4zM20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 002-2V5c0-1.11-.89-2-2-2zm-4 10c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5h10v8zm4-5h-2V5h2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$607a77876bc67a84(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6H9V4H7v2H6l-4 4v9h20v-9l-4-4zM4 12h10v5H4v-5zm16 5h-4v-6.17l2-2 2 2V17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$951804a068a51beb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b6bc0a4d960db478(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20H2v-2h5.75A8.032 8.032 0 002 12.26c.64-.16 1.31-.26 2-.26 4.42 0 8 3.58 8 8zm10-7.74c-.64-.16-1.31-.26-2-.26-2.93 0-5.48 1.58-6.88 3.93a9.82 9.82 0 01.87 4.07h8v-2h-5.75A8.061 8.061 0 0122 12.26zm-6.36-1.24a10.03 10.03 0 014.09-5C15.44 6.16 12 9.67 12 14v.02c.95-1.27 2.2-2.3 3.64-3zm-4.22-2.17A8.527 8.527 0 006.7 4C8.14 5.86 9 8.18 9 10.71c0 .21-.03.41-.04.61.43.24.83.52 1.22.82a9.91 9.91 0 011.24-3.29z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$efb40e1d285e10f6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4l-6 6v10h12V10L8 4zm4 14H9v-3H7v3H4v-7.17l4-4 4 4V18zm-3-5H7v-2h2v2zm9 7V8.35L13.65 4h-2.83L16 9.18V20h2zm4 0V6.69L19.31 4h-2.83L20 7.52V20h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ffcaaef9103d5c5d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zM17.42 7.21c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06zm-4 0c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f55e6e231e332248(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h3L12 3 2 12h3v8h2v-2h10v2h2v-8zM7.21 10h9.58l.21.19V12H7v-1.81l.21-.19zm7.36-2H9.43L12 5.69 14.57 8zM7 16v-2h10v2H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8e2cebcaeb036685(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9.3V4h-3v2.6L12 3 2 12h3v8h6v-6h2v6h6v-8h3l-3-2.7zM17 18h-2v-6H9v6H7v-7.81l5-4.5 5 4.5V18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10h4c0-1.1-.9-2-2-2s-2 .9-2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d19d7339093024f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c-1.95 0-2.1 1-3.34 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1 1.19 0 1.42 1 3.33 1 1.95 0 2.08-1 3.32-1s1.37 1 3.32 1c1.91 0 2.14-1 3.33-1 1.18 0 1.45 1 3.35 1v-2c-1.24 0-1.38-1-3.33-1-1.91 0-2.14 1-3.33 1-1.24 0-1.39-1-3.34-1zm8.34-4.66l-1.37 1.37c-.19.18-.45.29-.71.29H17V9.65l1.32.97L19.5 9 12 3.5 4.5 9l1.18 1.61L7 9.65V13H5.74c-.27 0-.52-.11-.71-.29l-1.37-1.37-1.41 1.41 1.37 1.37c.56.56 1.33.88 2.12.88h12.51c.8 0 1.56-.32 2.12-.88l1.37-1.37-1.4-1.41zM13 13v-2h-2v2H9V8.18l3-2.2 3 2.2V13h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6f2401ca74ab14eb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6c-1.66 0-3 1.34-3 3v4c0 .55-.45 1-1 1v-4c0-1.66-1.34-3-3-3h-4c-1.66 0-3 1.34-3 3h2c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1H6c-2.21 0-4 1.79-4 4v3h15v-2c1.66 0 3-1.34 3-3V9c0-.55.45-1 1-1h1V6h-1zm-6 10H4v-1c0-1.1.9-2 2-2h9v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4051f6fce17d891d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5h2v3H8zm0 7h2v5H8zm10-9.99L6 2a2 2 0 00-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$66c5907c9aeb1f75(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19V4h-4V3H5v16H3v2h12V6h2v15h4v-2h-2zm-6 0H7V5h6v14zm-3-8h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8bcb4f21cfb3ee0e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 6h10v12H4V6zm16 12h-4V6h4v12zm-1-9h-2V7h2v2zm-1 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-7.75-1c-.79 0-1.37-.38-1.79-.66-.33-.22-.52-.34-.71-.34-.37 0-.8.41-.95.61l-1.42-1.42c.35-.4 1.21-1.19 2.37-1.19.8 0 1.39.39 1.81.67.31.21.51.33.69.33.37 0 .8-.41.95-.61l1.42 1.42c-.36.4-1.21 1.19-2.37 1.19zm0-5c-.79 0-1.37-.38-1.79-.66-.33-.22-.52-.34-.71-.34-.37 0-.8.41-.95.61L5.37 9.19C5.73 8.79 6.59 8 7.75 8c.8 0 1.39.39 1.81.67.31.21.51.33.69.33.37 0 .8-.41.95-.61l1.42 1.42c-.36.4-1.21 1.19-2.37 1.19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cf95634d0a88ad50(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.5l6 4.5v9H6v-9l6-4.5M12 3L4 9v12h16V9l-8-6zm3 9h-3.5v3.5H8V11H7v7h1v-1.5h8V18h1v-4c0-1.1-.9-2-2-2zm-5.25.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$86f11d44da0a3ddf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.98 4.15c.01 0 .01-.01.02-.01V2h3v2h4V2h3v2.14c1.72.45 3 2 3 3.86v9.17l-2-2V8c0-1.1-.9-2-2-2H8.83L6.98 4.15zM14.83 12l1.67 1.67V12h-1.67zm4.95 10.61l-.85-.85c-.28.15-.59.24-.93.24H6c-1.1 0-2-.9-2-2V8c0-.36.06-.69.15-1.02L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM17.17 20l-6-6H7.5v-2h1.67L6 8.83V20h11.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe317505bcf8da1b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6v8.17l2 2V3c0-1.1-.9-1.99-2-1.99L7 1c-.85 0-1.58.55-1.87 1.3L8.83 6H17zM7 3h10v1H7V3zm14.19 18.19L19 19l-2-2L7 7 5 5 2.81 2.81 1.39 4.22 5 7.83V21c0 1.1.9 2 2 2h10c.85 0 1.58-.55 1.87-1.3l.91.91 1.41-1.42zM17 21H7v-1h10v1zM7 18V9.83L15.17 18H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3eb1c8c6b1e1d0c3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l8.23 8.23L11 14v5H6v2h12v-.17l1.78 1.78 1.41-1.42zM13 19v-3.17L16.17 19H13zM7.83 5l-2-2H21v2l-6.2 6.97-1.42-1.42L14.77 9h-2.94l-2-2h6.74l1.78-2H7.83z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$67af170de6c8f8af(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.4 5.6H22L19 11V7h-1V2h4l-1.6 3.6zM16 11.4v1.77l2 2V11c0-.88-.72-1.6-1.6-1.6h-2.54L12.58 8h-1.75l3.4 3.4H16zM2.1 2.1L.69 3.51l5.66 5.66-.21.23H3.6c-.88 0-1.6.72-1.6 1.6v9.4c0 .88.72 1.6 1.6 1.6h12.8c.75 0 1.38-.52 1.55-1.22l2.54 2.54 1.41-1.41L2.1 2.1zm9.4 13.4c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5S9.17 14 10 14s1.5.67 1.5 1.5zm4.46 4.5H4v-8.6h3.02l.59-.65.15-.16 1.5 1.5A3.486 3.486 0 006.5 15.5c0 1.93 1.57 3.5 3.5 3.5 1.68 0 3.07-1.18 3.42-2.76l2.55 2.55-.01 1.21z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c04d195525e227b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21h15.01v.98c0 .56-.45 1.01-1.01 1.01H2.01c-.56 0-1.01-.45-1.01-1.01V21zm19.49 2.31L16 18.83V19H1v-2h13.17l-2-2H1c0-3.24 2.46-5.17 5.38-5.79l-5.7-5.7L2.1 2.1 13 13l2 2 6.9 6.9-1.41 1.41zM10.17 13l-2-2c-1.42.06-3.52.56-4.55 2h6.55zM23 5h-5V1h-2v4h-5l.23 2h9.56l-1 9.97 1.83 1.83L23 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$41f24283beb02c1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5v3.88l2 2V6h3v7.88l2 2V4h-5V3H6.12l2 2zM2.41 2.13L1 3.54l4 4V19H3v2h11v-4.46L20.46 23l1.41-1.41L2.41 2.13zM12 19H7V9.54l5 5V19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2f03ffe6011cf706(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.9 6.07L7.48 4.66 9 3h6l1.83 2H20c1.1 0 2 .9 2 2v12c0 .05-.01.1-.02.16L20 17.17V7h-4.05l-1.83-2H9.88L8.9 6.07zm11.59 17.24L18.17 21H4c-1.1 0-2-.9-2-2V7c0-.59.27-1.12.68-1.49l-2-2L2.1 2.1l19.8 19.8-1.41 1.41zM9.19 12.02c-.11.31-.19.63-.19.98 0 1.66 1.34 3 3 3 .35 0 .67-.08.98-.19l-3.79-3.79zM16.17 19l-1.68-1.68c-.73.43-1.58.68-2.49.68-2.76 0-5-2.24-5-5 0-.91.25-1.76.68-2.49L4.17 7H4v12h12.17zm-1.36-7.02l2.07 2.07c.08-.34.12-.69.12-1.05 0-2.76-2.24-5-5-5-.36 0-.71.04-1.06.12l2.07 2.07c.84.3 1.5.96 1.8 1.79z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a3768869efbdc56f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm7-11.34v3.51l2 2v-7.9c.58-.68.97-1.27 1.65-1.27.77 0 1.35.66 1.35 1.48V7h2v-.52C22 4.56 20.52 3 18.65 3c-1.66 0-2.54 1.27-3.18 2.03l-3.5 4.11 1.42 1.42L15 8.66zm4.78 13.95l-1.91-1.91c-.29.76-1.01 1.3-1.87 1.3-1.1 0-2-.9-2-2 0-.86.54-1.58 1.3-1.87L14.17 17H7.43c-.85 0-1.31-1-.76-1.65l2.69-3.16-7.97-7.97L2.8 2.81l7.86 7.86 1.42 1.42 9.11 9.11-1.41 1.41zM12.17 15l-1.39-1.39L9.6 15h2.57zM10 5c.29 0 .58.02.86.05L9.49 6.67l1.42 1.42L14.3 4.1C13.03 3.4 11.56 3 10 3c-1.23 0-2.4.25-3.47.7L8.1 5.27A7.09 7.09 0 0110 5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$86cb50cac2f08b19(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L1 11.4l1.21 1.59L4 11.62V21h16v-9.38l1.79 1.36L23 11.4 12 3zm6 16H6v-8.9l6-4.58 6 4.58V19zm-9-5c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm3-1c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm3 1c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$529ed396689d682b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8l-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36s.78-.13 1.15-.36c.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.55 0 .78-.13 1.15-.36.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1zm12 8.5h-.02.02zm-16.65-1c.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.06.63 2.16.64v-2c-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.2-.64.37-.23.6-.36 1.15-.36zM18.67 18c-1.11 0-1.73.37-2.18.64-.37.23-.6.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36s-.78-.13-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.19-.64.37-.23.6-.36 1.15-.36.55 0 .78.13 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.19-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.72-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64v-2c-.56 0-.78-.13-1.15-.36-.45-.27-1.07-.64-2.18-.64z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "5.5",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bcf735dfb2bc6219(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.66 14c-.66 1.92-2.24 3.54-4.4 4.39l-1.26.49V20h-4v-1.12l-1.27-.5c-2.16-.85-3.74-2.47-4.4-4.39h15.33M12 2C6.48 2 2 6.48 2 12c0 3.69 2.47 6.86 6 8.25V22h8v-1.75c3.53-1.39 6-4.56 6-8.25 0-5.52-4.48-10-10-10zm-2 10V4.26c.64-.16 1.31-.26 2-.26s1.36.1 2 .26V12h-4zm6 0V5.08c2.39 1.39 4 3.96 4 6.92h-4zM4 12c0-2.95 1.61-5.53 4-6.92V12H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$274f9521b66a2ef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18h-2v-2h2v2zm2-4H9v6h6v-6zm4-4.7V4h-3v2.6L12 3 2 12h3l7-6.31L19 12h3l-3-2.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b14c9f3302963b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.69 16.37l1.14-1-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L19 12h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1c-.08.5-.08.76 0 1.26l-1.14 1 1 1.73 1.45-.49c.32.27.68.48 1.08.63L17 22h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1c.08-.51.08-.77 0-1.27zM18 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm1-15v6h-2V6h-2v6h-2V5H7v14h5v2H3v-2h2V3h10v1h4zm-7 9h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8ffaaef186691487(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.98 17H2v2h20v-2zM21 16c-.27-4.07-3.25-7.4-7.16-8.21A2.006 2.006 0 0012 5a2.006 2.006 0 00-1.84 2.79C6.25 8.6 3.27 11.93 3 16h18zm-9-6.42c2.95 0 5.47 1.83 6.5 4.41h-13A7.002 7.002 0 0112 9.58z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$82b63b673bdd3e78(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d3575ed963c185d7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 13H22v3h-1.5zM18 13h1.5v3H18zm-1 0h-2.34L17 15.34zm-2.5-4.35h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5a3.35 3.35 0 000 6.7zm4.35-3.92c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.76c0-2.22-1.28-4.14-3.15-5.03zM3.41 4.59L2 6l7 7H2v3h10l7 7 1.41-1.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9f87811e140d877b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16h1.5v3H18zM2 16h15v3H2zm14.03-5.8H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5a3.35 3.35 0 000 6.7h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16zM20.5 16H22v3h-1.5zm-1.65-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e10eb49debeab574(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 6c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75m0-1.5C13.01 4.5 12 5.51 12 6.75S13.01 9 14.25 9s2.25-1.01 2.25-2.25-1.01-2.25-2.25-2.25zm5.75 1c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5M20 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-3.5-3c-.83 0-1.5.67-1.5 1.5S15.67 4 16.5 4 18 3.33 18 2.5 17.33 1 16.5 1zm4.25 15a1.25 1.25 0 000-2.5H12v-1h6.75c.69 0 1.25-.56 1.25-1.25 0-.67-.53-1.2-1.18-1.24L8.87 10l1.48-2.6c.09-.17.14-.34.14-.54 0-.26-.09-.5-.26-.7L9.12 5l-7.18 6.8c-.6.56-.94 1.35-.94 2.17V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 000-2.5H12v-1h7.75a1.25 1.25 0 000-2.5H12v-1h8.75zM10 21H4c-.55 0-1-.45-1-1v-6c0-.39.23-.64.36-.75L7 9.87V12h3v9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c29ad1165b376df1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63a12.188 12.188 0 00-3.55 7.63c1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-3.44-4.44c.63 1.03 1.07 2.18 1.3 3.38-.47.3-.91.63-1.34.98-.42-.34-.87-.67-1.33-.97.25-1.2.71-2.35 1.37-3.39zM12 15.45a12.11 12.11 0 00-3.06-3.2c-.13-.09-.27-.16-.4-.26.13.09.27.17.39.25A11.777 11.777 0 002 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45zm1.32 4.15c-.44.15-.88.27-1.33.37-.44-.09-.87-.21-1.28-.36-3.29-1.18-5.7-3.99-6.45-7.35 1.1.26 2.15.71 3.12 1.33l-.02.01c.13.09.26.18.39.25l.07.04c.99.72 1.84 1.61 2.51 2.65L12 19.1l1.67-2.55a10.19 10.19 0 012.53-2.66l.07-.05c.09-.05.18-.11.27-.17l-.01-.02c.98-.65 2.07-1.13 3.21-1.4-.75 3.37-3.15 6.18-6.42 7.35zm-4.33-7.32c-.02-.01-.04-.03-.05-.04 0 0 .01 0 .01.01.01.01.02.02.04.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$38aec01b0f42e353(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19H8v-6.63c1.26-.34 2.11-1.27 2.77-1.99C11.6 9.47 12.08 9 13 9h2v10zM10 2.02c-1.89 0-3.51 1.11-4.27 2.71C4.15 5.26 3 6.74 3 8.5c0 1.86 1.28 3.41 3 3.86V21h11v-2h2c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2h-1.56c.35-.59.56-1.27.56-2 0-2.21-1.79-4-4-4-.34 0-.66.05-.98.13A4.707 4.707 0 0010 2.02zM7 10.5c-1.1 0-2-.9-2-2 0-.85.55-1.6 1.37-1.88l.8-.27.36-.76C8 4.62 8.94 4.02 10 4.02c.79 0 1.39.35 1.74.65l.78.65S13.16 5 13.99 5c1.1 0 2 .9 2 2h-3C9.67 7 9.15 10.5 7 10.5zM17 17v-6h2v6h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a16bdb3b78277c6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 3h-4.42v3.33H11v3.33H8.42V16H6v2h4.42v-3.33H13v-3.33h2.58V8H18V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9962d0cae491508f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9 8.89l-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zm-2.99-3.9l1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01zM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5zM8.49 9.52L9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41a1.42 1.42 0 01-.33-1.07zm-4.45-.16L5.05 5h1.97l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17zM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e6fcb99245c1b4ba(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM6 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm9-9.34L9.6 15H15V8.66M18.65 3C20.52 3 22 4.56 22 6.48V7h-2v-.52C20 5.66 19.42 5 18.65 5c-.68 0-1.07.59-1.65 1.27V15c0 1.1-.9 2-2 2H7.43c-.85 0-1.31-1-.76-1.65l8.8-10.32C16.11 4.27 16.99 3 18.65 3zM10 5c-.65 0-1.29.09-1.91.27l1.4 1.4 1.37-1.61A6.11 6.11 0 0010 5m0-2c1.56 0 3.03.4 4.3 1.1L9.6 9.61 4.72 4.72A8.962 8.962 0 0110 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$86ebe4bd6f595b13(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V1h-8v9c0 1.86 1.28 3.41 3 3.86V21h-2v2h6v-2h-2v-7.14c1.72-.45 3-2 3-3.86zm-2-7v3h-4V3h4zm-4 7V8h4v2c0 1.1-.9 2-2 2s-2-.9-2-2zm-6-1H8V8h2a2.5 2.5 0 000-5H8V1H6v2H4a2.5 2.5 0 000 5h2v1H4a2.5 2.5 0 000 5h2v9h2v-9h2a2.5 2.5 0 000-5zM4 6c-.28 0-.5-.22-.5-.5S3.72 5 4 5h6c.28 0 .5.22.5.5s-.22.5-.5.5H4zm6 6H4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h6c.28 0 .5.22.5.5s-.22.5-.5.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$636f65dd73808f2e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6h-2V4h2v2zm2 1h-2v2h2V7zm1 2h2V7h-2v2zm0-5h-2v2h2V4zm-4 3h-2v2h2V7zm4 3h-2v2h2v-2zm-3 0h-2v2h2v-2zm-3-6h-2v2h2V4zm7 11.82v4.15c0 .56-.47 1.03-1.03 1-2.89-.17-5.6-1.03-7.97-2.4A17.999 17.999 0 014.43 12a17.89 17.89 0 01-2.4-7.97C2 3.47 2.47 3 3.03 3h4.15c.48 0 .89.34.98.8l.74 3.68a.99.99 0 01-.27.9L6.1 10.9c1.43 2.5 3.5 4.57 6 6l2.52-2.52a.98.98 0 01.9-.27l3.67.73c.47.09.81.5.81.98zM5.18 8.99l1.65-1.65L6.36 5H4.13c.17 1.37.53 2.71 1.05 3.99zM18 16.64l-2.34-.47-1.65 1.65c1.28.52 2.63.87 3.99 1.05v-2.23zM20 4v2h2V4h-2zm0 8h2v-2h-2v2zm-7-2h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fcb370091262cd0c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 6.92L13 5.77V3.4c0-.26.22-.48.5-.48s.5.21.5.48V4h2v-.6C16 2.07 14.88 1 13.5 1S11 2.07 11 3.4v2.37L9.5 6.92 6 6.07l5.05 15.25c.15.45.55.68.95.68s.8-.23.95-.69L18 6.07l-3.5.85zM13.28 8.5l.76.58.92-.23L13 14.8V8.29l.28.21zm-3.32.59l.76-.58.28-.22v6.51L9.03 8.86l.93.23z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cd24e1dc267b192a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.5h1c1.33 0 2.71-.18 4-.5v3c-1.29-.32-2.67-.5-4-.5H2v-2zM16.17 19H8v-3h5.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-3.6-3.6zm2.66-3H22v3h-.17l-3-3zM11 17.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5zm11-4.74V15h-1.5v-2.23c0-2.24-1.76-4.07-4-4.07V7.2c1.02 0 1.85-.83 1.85-1.85S17.52 3.5 16.5 3.5V2c1.85 0 3.35 1.5 3.35 3.35 0 .93-.38 1.77-1 2.38 1.87.89 3.15 2.81 3.15 5.03zM11.15 8.32V8.3c0-1.85 1.5-3.35 3.35-3.35v1.5c-1.02 0-1.85.73-1.85 1.75s.83 2 1.85 2h1.53c1.87 0 3.47 1.35 3.47 3.16V15H18v-1.3c0-1.31-.92-2.05-1.97-2.05h-1.55l-3.33-3.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bb62aa06107952a4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.5h1c1.33 0 2.71-.18 4-.5v3c-1.29-.32-2.67-.5-4-.5H2v-2zm20-.5v3H8v-3h14zm-11 1.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5zm11-4.74V15h-1.5v-2.23c0-2.24-1.76-4.07-4-4.07V7.2c1.02 0 1.85-.83 1.85-1.85S17.52 3.5 16.5 3.5V2c1.85 0 3.35 1.5 3.35 3.35 0 .93-.38 1.77-1 2.38 1.87.89 3.15 2.81 3.15 5.03zm-2.5.6V15H18v-1.3c0-1.31-.92-2.05-1.97-2.05H14.5a3.35 3.35 0 010-6.7v1.5c-1.02 0-1.85.73-1.85 1.75s.83 2 1.85 2h1.53c1.87 0 3.47 1.35 3.47 3.16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2de00be003554ff1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10c-1.1 0-2 .9-2 2h-1V3L3 8v13h18v-9c0-1.1-.9-2-2-2zM5 9.37l9-3.46V12H9v7H5V9.37zM19 19h-3v-3h-2v3h-3v-5h8v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ae98be5f2ea5981(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.75 16a1.25 1.25 0 000-2.5H12v-1h6.75c.69 0 1.25-.56 1.25-1.25 0-.67-.53-1.2-1.18-1.24L8.87 10l1.48-2.6c.09-.17.14-.34.14-.54 0-.26-.09-.5-.26-.7L9.12 5l-7.18 6.8c-.6.56-.94 1.35-.94 2.17V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 000-2.5H12v-1h7.75a1.25 1.25 0 000-2.5H12v-1h8.75zM10 21H4c-.55 0-1-.45-1-1v-6c0-.39.23-.64.36-.75L7 9.87V12h3v9zm3.5-12c.83 0 1.5-.67 1.5-1.5 0-.84-1.5-2.5-1.5-2.5S12 6.66 12 7.5c0 .83.67 1.5 1.5 1.5zm5-8S16 3.83 16 5.5a2.5 2.5 0 005 0C21 3.83 18.5 1 18.5 1zm0 5.5c-.55 0-1-.45-1-1 0-.4.43-1.22 1-2.05.57.83 1 1.65 1 2.05 0 .55-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a6bf902f3ddef4d2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L2 12h3v8h14v-8h3L12 3zM7 18v-7.81l5-4.5 5 4.5V18H7zm7-4c0 1.1-.9 2-2 2s-2-.9-2-2 2-4 2-4 2 2.9 2 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$120016bcdc8a4d6b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm5.5 6.95V9c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v6h2v7h3.5v-.11c-1.24-1.26-2-2.99-2-4.89 0-2.58 1.41-4.84 3.5-6.05zM16.5 17c0 1.65-1.35 3-3 3s-3-1.35-3-3c0-1.11.61-2.06 1.5-2.58v-2.16c-2.02.64-3.5 2.51-3.5 4.74 0 2.76 2.24 5 5 5s5-2.24 5-5h-2zm3.04-3H15V8h-2v8h5.46l2.47 3.71 1.66-1.11-3.05-4.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$460fa267ea380b79(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm4 1c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm3 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-3-7.5c-1.76 0-3.22 1.31-3.46 3h6.93a3.52 3.52 0 00-3.47-3M12 6c2.76 0 5 2.24 5 5v1H7v-1c0-2.76 2.24-5 5-5zM9 18c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm3 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm3 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm5-14H4v16h16V4m0-2c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$12d06f5b1f63045e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.78V8c0-1.65-1.35-3-3-3h-4c-.77 0-1.47.3-2 .78-.53-.48-1.23-.78-2-.78H6C4.35 5 3 6.35 3 8v2.78c-.61.55-1 1.34-1 2.22v6h2v-2h16v2h2v-6c0-.88-.39-1.67-1-2.22zM14 7h4c.55 0 1 .45 1 1v2h-6V8c0-.55.45-1 1-1zM5 8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v2H5V8zm-1 7v-2c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v2H4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa14756b5ded8872(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.94 14.04c-.34.34-.71.64-1.1.92L16 13.5V11h1v-1h-5.62L9.65 7H6l1 .76L5.5 9.5l.95 1L8 9.51v3.99l-.84 1.46c-.39-.27-.76-.58-1.1-.92L5 15.1c1.87 1.87 4.36 2.9 7 2.9s5.13-1.03 7-2.9l-1.06-1.06zm-9.49 1.67l.03-.06.81-1.41c1.74.65 3.66.65 5.4 0l.81 1.41.03.06c-1.1.51-2.3.79-3.55.79s-2.43-.27-3.53-.79zM20 4v16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$28169eba5b502907(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3.5 8.67V9c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v1.67c-.88.35-1.5 1.2-1.5 2.2V17h1.5v-1.5h9V17H18v-4.13c0-1-.62-1.85-1.5-2.2zM15 8.5v2H9v-2h6zm-7.5 4.37c0-.48.39-.87.87-.87h7.27c.48 0 .87.39.87.87V14h-9v-1.13H7.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4685cd2b7352bd54(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.35 11.45V9c0-1.1-.9-2-2-2H13c-.37 0-.72.12-1 .32-.28-.2-.63-.32-1-.32H7.65c-1.1 0-2 .9-2 2v2.45c-.4.46-.65 1.06-.65 1.72V17h1.5v-1.5h11V17H19v-3.83c0-.66-.25-1.26-.65-1.72zm-1.6-.95h-4v-2h4v2zm-9.5-2h4v2h-4v-2zM17.5 14h-11v-1c0-.55.45-1 1-1h9c.55 0 1 .45 1 1v1zM20 4v16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fe7d74e1651b3c9d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.13 15.13L18 3h-4V2h-4v1H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2.23l.64 4.13C6.74 16.05 6 17.43 6 19v1c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-1c0-1.57-.74-2.95-1.87-3.87zM5 9V5h1.31l.62 4H5zm10.67-4l-1.38 9H9.72L8.33 5h7.34zM16 20H8v-1c0-1.65 1.35-3 3-3h2c1.65 0 3 1.35 3 3v1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f3fc227ad8388ee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13v-1c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1l2 1.06v-4.12L14 13zm-2-7.5l6 4.5v9H6v-9l6-4.5M12 3L4 9v12h16V9l-8-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d971b8a8ecc555b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1l2 1.06v-4.12L18 14v-1zM12 3L4 9v12h16v-2H6v-9l6-4.5 6 4.5v1h2V9l-8-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d56a691dd76894e0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h1v2H7c-1.1 0-2 .9-2 2v7h2v-3h10v3h2v-7c0-1.1-.9-2-2-2h-1v-2h1zM7 8V5h10v3H7zm10 8H7v-2h10v2zm-3-4h-4v-2h4v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$613f9e8ea0620017(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8V6c0-1.65-1.35-3-3-3H7C5.35 3 4 4.35 4 6v2c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3v1c0 .55.45 1 1 1s1-.45 1-1v-1h12v1c0 .55.45 1 1 1s1-.45 1-1v-1c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3zM6 6c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v2.78c-.61.55-1 1.34-1 2.22v2H7v-2c0-.88-.39-1.67-1-2.22V6zm15 10c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v4h14v-4c0-.55.45-1 1-1s1 .45 1 1v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8b7323184be46d05(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V4h2V2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14v-2h-4.03A4.966 4.966 0 0018 16v-5H8v5c0 1.64.81 3.09 2.03 4H6V4h2v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1zm-8 10v-3h6v3c0 1.65-1.35 3-3 3s-3-1.35-3-3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "9",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d80242f0b783ff53(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 3H6c-1.1 0-2 .9-2 2v5.71c0 3.83 2.95 7.18 6.78 7.29 3.96.12 7.22-3.06 7.22-7v-1h.5c1.93 0 3.5-1.57 3.5-3.5S20.43 3 18.5 3zM16 5v3H6V5h10zm0 5v1c0 2.76-2.24 5-5 5s-5-2.24-5-5v-1m12.5-2H18V5h.5c.83 0 1.5.67 1.5 1.5S19.33 8 18.5 8zM4 19h16v2H4v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d3b0b03c1d5b1294(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.75 6c-1.37 0-2.5 1.52-2.5 3.4 0 1.48.7 2.71 1.67 3.18l.08.04V19h1.5v-6.38l.08-.03c.97-.47 1.67-1.7 1.67-3.18 0-1.88-1.12-3.41-2.5-3.41M10.5 6c-.27 0-.5.22-.5.5V9h-.75V6.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V9H7.5V6.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v3.8c0 .93.64 1.71 1.5 1.93V19h1.5v-6.77c.86-.22 1.5-1 1.5-1.93V6.5c0-.28-.22-.5-.5-.5zM20 4H4v16h16V4m0-2c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dd67e5cb960b5b77(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-2 0H7V5h10v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11h2v2H9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$932ee508d42a5e30(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-2 0H7V5h10v14zm-4-8h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a46710fe7c47eed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13H8v-2h2v2zm6-2h-2v2h2v-2zm5 8v2H3v-2h1V5c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v14h1zM11 5H6v14h5V5zm7 0h-5v14h5V5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f74d93db80ae3e38(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16.5h2c0 .55-.45 1-1 1s-1-.45-1-1zm4-1.5v-2.34c0-1.54-.81-2.82-2.25-3.16v-.25c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.25C9.82 9.84 9 11.12 9 12.66V15H8v1h8v-1h-1zm-3-9.5L6 10v9h12v-9l-6-4.5M12 3l8 6v12H4V9l8-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c252a3621c958527(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8l-5-5zm3 16H5V5h10v4h4v10zM7 17h10v-2H7v2zm5-10H7v2h5V7zm-5 6h10v-2H7v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c1360d21778397(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7.08c0 1.77-.84 3.25-2 3.82V21h-2V10.9c-1.16-.57-2-2.05-2-3.82C10.01 4.83 11.35 3 13 3c1.66 0 3 1.83 3 4.08zM17 3v18h2v-8h2V7c0-1.76-1.24-4-4-4zM8.28 3c-.4 0-.72.32-.72.72V7h-.84V3.72C6.72 3.32 6.4 3 6 3s-.72.32-.72.72V7h-.84V3.72c0-.4-.32-.72-.72-.72S3 3.32 3 3.72V9c0 1.1.9 2 2 2v10h2V11c1.1 0 2-.9 2-2V3.72c0-.4-.32-.72-.72-.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$73e387cb77ee05ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.78 18.5h.44c.43 0 .78-.36.78-.81V16.5h10v1.19c0 .45.34.81.78.81h.44c.43 0 .78-.36.78-.81v-6.5c-.82-2.46-1.34-4.03-1.56-4.69-.05-.16-.12-.29-.19-.4-.02-.02-.03-.04-.05-.07-.38-.52-.92-.53-.92-.53H7.72s-.54.01-.92.54c-.02.02-.03.04-.05.06-.07.11-.14.24-.19.4-.22.66-.74 2.22-1.56 4.69v6.5c0 .45.35.81.78.81zm2.55-11h7.34l.23.69.43 1.31H7.67l.66-2zM7 11.51v-.01h10v3H7v-2.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cb0c136a3917a724(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.06V3h-2v3.06c-4.5.5-8 4.31-8 8.93C3 16.1 3.9 17 5.01 17H8c0 2.21 1.79 4 4 4s4-1.79 4-4h2.99c1.11 0 2.01-.9 2.01-2.01 0-4.62-3.5-8.43-8-8.93zM12 19c-1.1 0-2-.9-2-2h4c0 1.1-.9 2-2 2zm0-4H5c0-3.86 3.14-7 7-7s7 3.14 7 7h-7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9908e69679ba2e84(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.75 10.35V9c0-1.66-1.34-3-3-3h-5.5c-1.66 0-3 1.34-3 3v1.35C5.51 10.78 5 11.58 5 12.5V16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-3.5c0-.92-.51-1.72-1.25-2.15zM9.25 7.5h5.5c.83 0 1.5.67 1.5 1.5v1.03A2.48 2.48 0 0014 12.5v.5h-4v-.5c0-1.3-.99-2.35-2.25-2.47V9c0-.83.67-1.5 1.5-1.5zM17.5 16c0 .28-.22.5-.5.5H7c-.28 0-.5-.22-.5-.5v-3.5c0-.55.45-1 1-1s1 .45 1 1v2h7v-2c0-.55.45-1 1-1s1 .45 1 1V16zM20 4v16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$89138a7513c5aa17(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9H2V7h5v2zm0 3H2v2h5v-2zm13.59 7l-3.83-3.83c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L22 17.59 20.59 19zM17 11c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3zM2 19h10v-2H2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cddc75ef19f65827(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c0 .74-.4 1.38-1 1.72V22h-2v-8.28c-.6-.35-1-.98-1-1.72 0-1.1.9-2 2-2s2 .9 2 2zm-2-6c-3.31 0-6 2.69-6 6 0 1.74.75 3.31 1.94 4.4l1.42-1.42A3.957 3.957 0 018 12c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.19-.53 2.25-1.36 2.98l1.42 1.42A5.957 5.957 0 0018 12c0-3.31-2.69-6-6-6zm0-4C6.48 2 2 6.48 2 12c0 2.85 1.2 5.41 3.11 7.24l1.42-1.42A7.987 7.987 0 014 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 2.29-.98 4.36-2.53 5.82l1.42 1.42C20.8 17.41 22 14.85 22 12c0-5.52-4.48-10-10-10z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d8a9dfc86e33d283(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm3-1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3-4v2H5v-2c0-3.53 2.61-6.43 6-6.92V3h2v2.08c3.39.49 6 3.39 6 6.92zm-2 0c0-2.76-2.24-5-5-5s-5 2.24-5 5h10zm-9 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a949cdc8108095b6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.5C22 5.57 17.52 4 12 4S2 5.57 2 7.5c0 1.81 3.95 3.31 9 3.48V15H9.35c-.82 0-1.55.5-1.86 1.26L6 20h2l1.2-3h5.6l1.2 3h2l-1.5-3.74c-.3-.76-1.04-1.26-1.85-1.26H13v-4.02c5.05-.17 9-1.67 9-3.48zM12 6c4.05 0 6.74.86 7.72 1.5C18.74 8.14 16.05 9 12 9s-6.74-.86-7.72-1.5C5.26 6.86 7.95 6 12 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2c0cf025d3c7e3ae(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.96 9.73l-1.43-5a.996.996 0 00-.96-.73H4.43c-.45 0-.84.3-.96.73l-1.43 5c-.18.63.3 1.27.96 1.27h2.2L4 20h2l.67-5h10.67l.66 5h2l-1.2-9H21c.66 0 1.14-.64.96-1.27zM6.93 13l.27-2h9.6l.27 2H6.93zm-2.6-4l.86-3h13.63l.86 3H4.33z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a744ad2bf3093b27(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8h-6V5h6v6zm-8-6v6H5V5h6zm-6 8h6v6H5v-6zm8 6v-6h6v6h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9ea4c4f1904f9e0d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-3.31 0-6 2.69-6 6 3.31 0 6-2.69 6-6zM6 13c0 3.31 2.69 6 6 6 0-3.31-2.69-6-6-6zm2-1.97a1.562 1.562 0 002.45 1.28l-.01.12c0 .86.7 1.56 1.56 1.56s1.56-.7 1.56-1.56l-.01-.12c.25.17.56.28.89.28.86 0 1.56-.7 1.56-1.56 0-.62-.37-1.16-.89-1.41.52-.24.89-.78.89-1.4a1.562 1.562 0 00-2.45-1.28l.01-.12c0-.86-.7-1.56-1.56-1.56s-1.56.7-1.56 1.56l.01.12A1.562 1.562 0 008 8.22c0 .62.37 1.16.89 1.41-.52.24-.89.78-.89 1.4zm4-2.97c.86 0 1.56.7 1.56 1.56s-.7 1.56-1.56 1.56-1.56-.7-1.56-1.56.7-1.56 1.56-1.56zM20 4v16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5b70ce0b0e22cb1a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 15H10V9H7v1.5h1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 15H15c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-2.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-5h1.5v1.5H13V10zm0 2.5h1.5V14H13v-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b1fa5ea6c779e8e7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 002 9.43V10h8v-.57zM18 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 0014 9.43V10h8v-.57zM19 17v-2.01L5 15v2l-3-3 3-3v2.01L19 13v-2l3 3-3 3zm-9 2v-1H7.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h2c.28 0 .5-.22.5-.5V20c0-.28-.22-.5-.5-.5H8V19h2zm-1 1.5v.5H8v-.5h1zm8.5-1.5h-1v3h-1v-3h-1v-1h3v1zm-5 0v.5h1v1h-1V22h-1v-4H14v1h-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$94982120732270f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11.09v-4.7l6-2.25 6 2.25v3.69c.71.1 1.38.31 2 .6V5l-8-3-8 3v6.09c0 5.05 3.41 9.76 8 10.91.03-.01.05-.02.08-.02-.79-.78-1.4-1.76-1.75-2.84C7.76 17.53 6 14.42 6 11.09z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm3 5.5h-2.5V20h-1v-2.5H14v-1h2.5V14h1v2.5H20v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$51be158ae36d0445(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9.5C7 8.67 7.67 8 8.5 8s1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5zm5 8c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5zm3.5-6.5c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zM22 1h-2v2h-2v2h2v2h2V5h2V3h-2V1zm-2 11c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8c1.46 0 2.82.4 4 1.08V2.84A9.929 9.929 0 0011.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12c0-1.05-.17-2.05-.47-3H19.4c.38.93.6 1.94.6 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5da0d5e1afda80b5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.36 18.78L6.61 21l1.62-1.54 2.77-7.6c-.68-.17-1.28-.51-1.77-.98l-2.87 7.9zM14.77 10.88c-.49.47-1.1.81-1.77.98l2.77 7.6L17.39 21l.26-2.22-2.88-7.9zM15 8c0-1.3-.84-2.4-2-2.82V3h-2v2.18C9.84 5.6 9 6.7 9 8c0 1.66 1.34 3 3 3s3-1.34 3-3zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f25eb7c78d4c3a7b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.5",
                    "cy": "4.5",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 17.72l-.64-6.37A1.49 1.49 0 0017.64 10H16c-1.5-.02-2.86-.54-3.76-1.44l-2-1.98A1.95 1.95 0 008.83 6c-.51 0-1.02.2-1.41.59L4.08 9.91c-.53.68-.51 1.57-.21 2.13l1.43 2.8-3.15 4.05 1.57 1.24L7.4 15.4l-.17-1.36.77.71V20h2v-6.12l-2.12-2.12 2.36-2.36c.94.94 1.72 1.82 3.59 2.32L13 20h1.5l.41-3.5h3.18l.14 1.22c-.44.26-.73.74-.73 1.28 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.54-.29-1.02-.73-1.28zM15.09 15l.41-3.5h2l.41 3.5h-2.82z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d23d7fa5387bc7b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7a2.5 2.5 0 00-3-2.45V4a2.5 2.5 0 00-3.17-2.41A2.509 2.509 0 0012.5 0c-1.23 0-2.25.89-2.46 2.06A2.5 2.5 0 007 4.5v5.89c-.34-.31-.76-.54-1.22-.66l-.77-.21c-.83-.23-1.7.09-2.19.83-.38.57-.4 1.31-.15 1.95l2.56 6.43A8.354 8.354 0 0013 24c4.42 0 8-3.58 8-8V7zm-2 9c0 3.31-2.69 6-6 6-2.61 0-4.95-1.59-5.91-4.01l-2.6-6.54.53.14c.46.12.83.46 1 .9L7 15h2V4.5c0-.28.22-.5.5-.5s.5.22.5.5V12h2V2.5c0-.28.22-.5.5-.5s.5.22.5.5V12h2V4c0-.28.22-.5.5-.5s.5.22.5.5v8h2V7c0-.28.22-.5.5-.5s.5.22.5.5v9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$42ab31671632f1e0(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "3.5",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.13 7.12c-.17-.35-.44-.65-.8-.85a1.98 1.98 0 00-1.93-.03v-.01L4 9.3V14h2v-3.54l1.5-.85C7.18 10.71 7 11.85 7 13v5.33L4.4 21.8 6 23l3-4 .22-3.54L11 18v5h2v-6.5l-1.97-2.81c-.04-.52-.14-1.76.45-3.4.75 1.14 1.88 1.98 3.2 2.41L20.63 23l.87-.5-5.48-9.5H17v-2c-.49 0-2.88.17-4.08-2.21"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3dc73e24e20f120(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.5c.97 0 1.75-.78 1.75-1.75S12.97 4 12 4s-1.75.78-1.75 1.75S11.03 7.5 12 7.5zM14 20v-5h1v-4.5c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2V15h1v5h4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3f923604ec3682b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a2 2 0 002-2c0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm6 3h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v9c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-9c0-1.66-1.34-3-3-3zm1 11H5v-3c.9-.01 1.76-.37 2.4-1.01l1.09-1.07 1.07 1.07c1.31 1.31 3.59 1.3 4.89 0l1.08-1.07 1.07 1.07c.64.64 1.5 1 2.4 1.01v3zm0-4.5c-.51-.01-.99-.2-1.35-.57l-2.13-2.13-2.14 2.13c-.74.74-2.03.74-2.77 0L8.48 12.8l-2.14 2.13c-.35.36-.83.56-1.34.57V12c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c676d838f3401e70(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 12a2.5 2.5 0 01-5 0 2.5 2.5 0 015 0zm7.5 0c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zm-2 0h-4c0-2.21-1.79-4-4-4s-4 1.79-4 4H4c0 4.41 3.59 8 8 8s8-3.59 8-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$929a7e9cc0a5b978(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.99 5l.63 1.37 1.37.63-1.37.63L16.99 9l-.63-1.37L14.99 7l1.37-.63.63-1.37M20 14c1.1 0 2-.9 2-2s-2-4-2-4-2 2.9-2 4 .9 2 2 2zm-9-7.9V4h2c.57 0 1.1.17 1.55.45l1.43-1.43A4.899 4.899 0 0013 2H7.5v2H9v2.11c-1.78.37-3.2 1.68-3.75 3.39h2.16C7.94 8.61 8.89 8 10 8c1.62 0 2.94 1.29 2.99 2.9l2.01.75V11a5 5 0 00-4-4.9zM22 19v1l-8 2.5-7-1.94V22H1V11h7.97l6.16 2.3A2.89 2.89 0 0117 16h2c1.66 0 3 1.34 3 3zM5 20v-7H3v7h2zm14.9-1.43c-.16-.33-.51-.56-.9-.56h-5.35c-.54 0-1.07-.09-1.58-.26l-2.38-.79.63-1.9 2.38.79c.31.1 2.3.15 2.3.15 0-.37-.23-.7-.57-.83L8.61 13H7v5.48l6.97 1.93 5.93-1.84z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a3516e5d28dd2111(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-.5 4.5h-2v-3h2v3zM8 13v1c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1H6.5v-.5h-2v3h2V13H8zm12.5 2.5h-2v1h3V18H17v-2.5c0-.55.45-1 1-1h2v-1h-3V12h3.5c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e7e8cded00951afc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.87 11.81A2.5 2.5 0 0115 8h1c1.51 0 2-1 2-1s.55 6-3 6c-.49 0-.94-.14-1.32-.38-.24.64-.59 1.76-.76 2.96 1.26.22 2.28.89 2.77 1.77A6.505 6.505 0 0018.5 12h3c0 5.24-4.26 9.5-9.5 9.5S2.5 17.24 2.5 12 6.76 2.5 12 2.5V0l4 4-4 4V5.5c-3.58 0-6.5 2.92-6.5 6.5 0 2.21 1.11 4.17 2.81 5.35.51-.92 1.63-1.62 2.98-1.8-.09-.69-.26-1.42-.49-2.03-.35.3-.8.48-1.3.48-1.1 0-2-.9-2-2v-.99c0-.56-.19-1.09-.5-1.51 0 0 4.45-.23 4.5 2.5 0 .29-.06.56-.17.8-.42-.32-.86-.6-1.33-.8.58.43 1.37 1.37 2 2.6.67-1.62 1.68-3.27 3-4.6-.76.52-1.47 1.12-2.13 1.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bbf92755a3d8af08(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14H9a9 9 0 019-9v2c-3.87 0-7 3.13-7 7zm7-3V9c-2.76 0-5 2.24-5 5h2c0-1.66 1.34-3 3-3zM7 4c0-1.11-.89-2-2-2s-2 .89-2 2 .89 2 2 2 2-.89 2-2zm4.45.5h-2A2.99 2.99 0 016.5 7h-3C2.67 7 2 7.67 2 8.5V11h6V8.74a4.97 4.97 0 003.45-4.24zM19 17c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm1.5 1h-3a2.99 2.99 0 01-2.95-2.5h-2A4.97 4.97 0 0016 19.74V22h6v-2.5c0-.83-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b5b54910c71ee503(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.783 15.172l2.121-2.121 5.996 5.996-2.121 2.121zM17.5 10c1.93 0 3.5-1.57 3.5-3.5 0-.58-.16-1.12-.41-1.6l-2.7 2.7-1.49-1.49 2.7-2.7c-.48-.25-1.02-.41-1.6-.41C15.57 3 14 4.57 14 6.5c0 .41.08.8.21 1.16l-1.85 1.85-1.78-1.78.71-.71-1.41-1.41L12 3.49a3 3 0 00-4.24 0L4.22 7.03l1.41 1.41H2.81l-.71.71 3.54 3.54.71-.71V9.15l1.41 1.41.71-.71 1.78 1.78-7.41 7.41 2.12 2.12L16.34 9.79c.36.13.75.21 1.16.21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ab5b68c6f2f2ea8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "8.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "15",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.95 10.99c-1.79-.03-3.7-1.95-2.68-4.22-2.97 1-5.78-1.59-5.19-4.56C7.11.74 2 6.41 2 12c0 5.52 4.48 10 10 10 5.89 0 10.54-5.08 9.95-11.01zM12 20c-4.41 0-8-3.59-8-8 0-3.31 2.73-8.18 8.08-8.02.42 2.54 2.44 4.56 4.99 4.94.07.36.52 2.55 2.92 3.63C19.7 16.86 16.06 20 12 20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84435501f33f9acb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm4.25-2c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-3.5 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM22 11.25v1.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75h-1.54a6.978 6.978 0 01-1.52 3.65l1.09 1.09.01-.01c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-1.06 1.06c-.29.29-.77.29-1.06 0a.752.752 0 01-.01-1.05l-1.09-1.09a7.015 7.015 0 01-3.64 1.51v1.54h.01c.41 0 .75.34.75.75s-.34.75-.75.75h-1.5c-.41 0-.75-.34-.75-.75s.33-.74.74-.75v-1.55a6.948 6.948 0 01-3.63-1.51l-1.09 1.09.01.01c.29.29.29.77 0 1.06-.29.29-.77.29-1.06 0L4.4 18.54a.754.754 0 010-1.06c.29-.29.76-.29 1.05-.01l1.09-1.09a6.89 6.89 0 01-1.5-3.63H3.5c0 .41-.34.75-.75.75S2 13.16 2 12.75v-1.5c0-.41.34-.75.75-.75s.75.34.75.75h1.54c.15-1.37.69-2.61 1.5-3.63L5.45 6.53c-.29.28-.76.28-1.05-.01a.754.754 0 010-1.06L5.46 4.4c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-.01.01L7.6 6.56a6.982 6.982 0 013.63-1.51V3.5a.753.753 0 01-.74-.75.77.77 0 01.76-.75h1.5c.41 0 .75.34.75.75s-.34.75-.75.75h-.01v1.54c1.37.14 2.62.69 3.64 1.51l1.09-1.09a.742.742 0 01.01-1.05c.29-.29.77-.29 1.06 0l1.06 1.06c.29.29.29.77 0 1.06s-.77.29-1.06 0l-.01-.01-1.09 1.08a7.025 7.025 0 011.52 3.65h1.54c0-.41.34-.75.75-.75s.75.34.75.75zM17 12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5zm-5-1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3.5 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-1.75 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f18838c6f4a016f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14c-.24-.24-.44-.49-.65-.75C17.51 11.5 19 8.56 19 5c0-1.95-.74-3-2-3-1.54 0-3.96 2.06-5 5.97C10.96 4.06 8.54 2 7 2 5.74 2 5 3.05 5 5c0 3.56 1.49 6.5 2.65 8.25-.21.26-.41.51-.65.75-.25.25-2 1.39-2 3.5C5 19.98 7.02 22 9.5 22c1.5 0 2.5-.5 2.5-.5s1 .5 2.5.5c2.48 0 4.5-2.02 4.5-4.5 0-2.11-1.75-3.25-2-3.5zm-.12-9.97c.06.17.12.48.12.97 0 2.84-1.11 5.24-2.07 6.78-.38-.26-.83-.48-1.4-.62.24-4.52 2.44-6.83 3.35-7.13zM7 5c0-.49.06-.8.12-.97.91.3 3.11 2.61 3.36 7.13-.58.14-1.03.35-1.4.62C8.11 10.24 7 7.84 7 5zm7.5 15c-1 0-1.8-.33-2.22-.56.42-.18.72-.71.72-.94 0-.28-.45-.5-1-.5s-1 .22-1 .5c0 .23.3.76.72.94-.42.23-1.22.56-2.22.56A2.5 2.5 0 017 17.5c0-.7.43-1.24 1-1.73.44-.36.61-.52 1.3-1.37.76-.95 1.09-1.4 2.7-1.4s1.94.45 2.7 1.4c.69.85.86 1.01 1.3 1.37.57.49 1 1.03 1 1.73a2.5 2.5 0 01-2.5 2.5zm-.5-4c0 .41-.22.75-.5.75s-.5-.34-.5-.75.22-.75.5-.75.5.34.5.75zm-3 0c0 .41-.22.75-.5.75s-.5-.34-.5-.75.22-.75.5-.75.5.34.5.75z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$93d50b45c033fa6e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.47V5.35C20.05 4.77 16.56 4 12 4c-2.15 0-4.11.86-5.54 2.24.13-.85.4-2.4 1.01-4.24H5.35C4.77 3.95 4 7.44 4 12c0 2.15.86 4.11 2.24 5.54-.85-.14-2.4-.4-4.24-1.01v2.12C3.95 19.23 7.44 20 12 20c2.15 0 4.11-.86 5.54-2.24-.14.85-.4 2.4-1.01 4.24h2.12c.58-1.95 1.35-5.44 1.35-10 0-2.15-.86-4.11-2.24-5.54.85.13 2.4.4 4.24 1.01zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d6968beafa497c1a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9L12 2 2 9h9v13h2V9h9zM12 4.44L15.66 7H8.34L12 4.44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.14 12l-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9zM19.1 16H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af4f46c9c11e742(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "14",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.22 17.58A2.01 2.01 0 000 19.43V21h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "14",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.78 17.58A6.95 6.95 0 0020 17c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V21H24v-1.57c0-.81-.48-1.53-1.22-1.85zM16.24 16.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 19.39V21h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM8.07 19a.96.96 0 01.49-.52c1.1-.49 2.26-.73 3.43-.73 1.18 0 2.33.25 3.43.73.23.1.4.29.49.52H8.07zM9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3zm4 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.48 10.86C2.17 10.1 2 9.36 2 8.6 2 6.02 4.02 4 6.6 4c2.68 0 3.82 1.74 5.4 3.59C13.57 5.76 14.7 4 17.4 4 19.98 4 22 6.02 22 8.6c0 .76-.17 1.5-.48 2.26.65.31 1.18.82 1.53 1.44.6-1.2.95-2.42.95-3.7C24 4.9 21.1 2 17.4 2c-2.09 0-4.09.97-5.4 2.51C10.69 2.97 8.69 2 6.6 2 2.9 2 0 4.9 0 8.6c0 1.28.35 2.5.96 3.7.35-.62.88-1.13 1.52-1.44z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$84e65678f6fd22ed(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1 15.9l1.42-1.42C8.79 12.05 7 10.41 7 8.85 7 7.8 7.8 7 8.85 7c1.11 0 1.54.65 2.68 2h.93c1.12-1.31 1.53-2 2.68-2 .87 0 1.55.54 1.77 1.32.35-.04.68-.06 1-.06.36 0 .7.03 1.03.08C18.7 6.43 17.13 5 15.15 5c-.12 0-.23.03-.35.04.12-.33.2-.67.2-1.04 0-1.66-1.34-3-3-3S9 2.34 9 4c0 .37.08.71.2 1.04-.12-.01-.23-.04-.35-.04C6.69 5 5 6.69 5 8.85c0 2.42 2.04 4.31 5.1 7.05z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.5 16.24c-.32-.18-.66-.29-1-.35.07-.1.15-.18.21-.28 1.08-1.87.46-4.18-1.41-5.26-2.09-1.21-4.76-.39-8.65.9l.52 1.94c3.47-1.14 5.79-1.88 7.14-1.1.91.53 1.2 1.61.68 2.53-.56.96-1.33 1-3.07 1.32l-.47.81c.58 1.62.97 2.33.39 3.32-.53.91-1.61 1.2-2.53.68-.06-.03-.11-.09-.17-.13-.3.67-.64 1.24-1.03 1.73.07.04.13.09.2.14 1.87 1.08 4.18.46 5.26-1.41.06-.1.09-.21.14-.32.22.27.48.51.8.69 1.43.83 3.27.34 4.1-1.1s.32-3.29-1.11-4.11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.32 14.01c-.74 3.58-1.27 5.95-2.62 6.73-.91.53-2 .24-2.53-.68-.56-.96-.2-1.66.39-3.32l-.46-.81c-1.7-.31-2.5-.33-3.07-1.32-.53-.91-.24-2 .68-2.53.09-.05.19-.08.29-.11-.35-.56-.64-1.17-.82-1.85-.16.07-.32.14-.48.23-1.87 1.08-2.49 3.39-1.41 5.26.06.1.14.18.21.28-.34.06-.68.17-1 .35-1.43.83-1.93 2.66-1.1 4.1s2.66 1.93 4.1 1.1c.32-.18.58-.42.8-.69.05.11.08.22.14.32 1.08 1.87 3.39 2.49 5.26 1.41 2.09-1.21 2.71-3.93 3.55-7.94l-1.93-.53z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aa52a6d14588b73(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.32 13.01c.96.02 1.85.5 2.45 1.34A3.961 3.961 0 0012 16c1.29 0 2.5-.62 3.23-1.66.6-.84 1.49-1.32 2.45-1.34-.72-1.22-3.6-2-5.68-2-2.07 0-4.96.78-5.68 2.01zM4 13c1.66 0 3-1.34 3-3S5.66 7 4 7s-3 1.34-3 3 1.34 3 3 3zM20 13c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zM12 10c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14h-3.27c-.77 0-1.35.45-1.68.92-.04.06-1.36 2.08-4.05 2.08-1.43 0-3.03-.64-4.05-2.08-.39-.55-1-.92-1.68-.92H3c-1.1 0-2 .9-2 2v4h7v-2.26c1.15.8 2.54 1.26 4 1.26s2.85-.46 4-1.26V20h7v-4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$efe0b91fcaca92f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h14v-2h-4v-2h2v-2h-2v-2h2v-2h-2V9h8v6h2V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm14 12v2h-2v2h-2v-2h-2v-2h2v-2h2v2h2zm-6-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a33ba4278a08dcc2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$36da8cee301b314(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 4.5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2.72 16.4l.76.27a5.933 5.933 0 004.34-.17L22 22.13c-1.05.55-2.24.87-3.5.87-.86 0-1.68-.14-2.45-.41L2 17.47l.5-1.41 6.9 2.51 1.72-4.44-3.57-3.73c-.89-.94-.67-2.47.45-3.12l3.48-2.01c1.1-.64 2.52-.1 2.91 1.11l.33 1.08a5.017 5.017 0 002.83 3.14l.52-1.6 1.43.46-1.12 3.45A7.029 7.029 0 0113 8.59l-2.53 1.45 3.03 3.46-2.22 5.76 3.09 1.12 2.1-6.44c.46.18.94.31 1.44.41l-2.13 6.55z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$10e4a9bf1c60b9e4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.58 6.25l1.77 1.77L14.37 13H12.6v-1.77l4.98-4.98zm3.27-.44l-1.06-1.06c-.2-.2-.51-.2-.71 0l-.85.85L20 7.37l.85-.85c.2-.2.2-.52 0-.71zM18 12.2V17h2v2H4v-2h2v-7c0-2.79 1.91-5.14 4.5-5.8v-.7c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.7c.82.21 1.57.59 2.21 1.09l-1.43 1.43A3.89 3.89 0 0012 6c-2.21 0-4 1.79-4 4v7h8v-2.8l2-2zM10 20h4c0 1.1-.9 2-2 2s-2-.9-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3aac4296c0614e1a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 11c-1.56 0-2.92-.9-3.58-2.21l-.79-1.67C14.12 7.1 13.63 6 12.34 6 8.72 6 6 16.69 6 19h2.5l-2.1 2.8L8 23l3-4h2v4h2v-4.03L13 13l.49-2.71A6.02 6.02 0 0017 12.81v.69h1v-1c0-.28.22-.5.5-.5s.5.22.5.5V23h1V12.5c0-.83-.67-1.5-1.5-1.5zM11.6 2.91c-.06.19-.1.38-.1.59 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2c-.21 0-.4.04-.59.1-.15-.35-.5-.6-.91-.6-.55 0-1 .45-1 1 0 .41.25.76.6.91z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$359e575fc9db8f13(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6.5 7V23h-1V12.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v1h-1v-.69a6.02 6.02 0 01-3.51-2.52c-.31.87-.49 1.78-.49 2.71 0 .23.02.46.03.69L15 16.5V23h-2v-5l-1.78-2.54L11 19l-3 4-1.6-1.2L9 18.33V13c0-1.15.18-2.29.5-3.39l-1.5.85V14H6V9.3l5.4-3.07v.01a2 2 0 011.94.03c.36.21.63.51.8.85l.79 1.67A3.987 3.987 0 0018.5 11c.83 0 1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$eb0e0c25d871f381(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c2.28 0 4.22-1.66 5-4H7c.78 2.34 2.72 4 5 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ac34fd3929a13355(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94A5.01 5.01 0 0011 15.9V19H7v2h10v-2h-4v-3.1a5.01 5.01 0 003.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm7 6c-1.65 0-3-1.35-3-3V5h6v6c0 1.65-1.35 3-3 3zm7-6c0 1.3-.84 2.4-2 2.82V7h2v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f7a7f62484db067d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9l-1-2H7V5.72c.6-.34 1-.98 1-1.72 0-1.1-.9-2-2-2s-2 .9-2 2c0 .74.4 1.38 1 1.72V21h2v-4h5l1 2h7V9h-6zm4 8h-4l-1-2H7V9h5l1 2h5v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1b65d4c78f9b36a9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19h18v2H2zM20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm-4 10c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5h3v1.4L7.19 7.85c-.12.09-.19.24-.19.39v4.26c0 .28.22.5.5.5h4c.28 0 .5-.22.5-.5V8.24c0-.15-.07-.3-.19-.39L10 6.4V5h6v8zM9.5 7.28l1.5 1.2V12H8V8.48l1.5-1.2zM20 8h-2V5h2v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e2ccd570bfb7624(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.94 4.88A1.32 1.32 0 0020.68 4H19.6l-.31-.97C19.15 2.43 18.61 2 18 2s-1.15.43-1.29 1.04L16.4 4h-1.07c-.57 0-1.08.35-1.26.88-.19.56.04 1.17.56 1.48l.87.52-.4 1.24c-.23.58-.04 1.25.45 1.62.23.17.51.26.78.26.31 0 .61-.11.86-.32l.81-.7.81.7c.25.21.55.32.86.32.27 0 .55-.09.78-.26.5-.37.68-1.04.45-1.62l-.39-1.24.87-.52c.51-.31.74-.92.56-1.48zM18 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM13.49 10.51c-.43-.43-.94-.73-1.49-.93V8h-1v1.38c-.11-.01-.23-.03-.34-.03-1.02 0-2.05.39-2.83 1.17l-.5.5-1.33-.5a3.01 3.01 0 00-3.83 1.82c-.27.75-.23 1.57.12 2.29.23.48.58.87 1 1.16-.38 1.35-.06 2.85 1 3.91.78.78 1.8 1.17 2.83 1.17.37 0 .73-.07 1.09-.17.29.42.68.77 1.16 1 .41.2.84.3 1.28.3.34 0 .68-.06 1.01-.17a3.007 3.007 0 001.82-3.85l-.49-1.3.5-.5c.87-.87 1.24-2.04 1.14-3.17H16v-1h-1.59c-.19-.55-.49-1.06-.92-1.5zm-5.91 8.31c-.15.04-.3.06-.46.06-.53 0-1.04-.21-1.41-.59-.38-.38-.59-.88-.59-1.41 0-.16.03-.32.06-.47.14.01.28.03.42.03.85 0 1.68-.2 2.44-.48-.32.89-.54 1.87-.46 2.86zm-2.91-4.53c-.25-.09-.45-.27-.57-.51s-.13-.51-.04-.76c.19-.52.76-.79 1.26-.61l3.16 1.19c-1.15.6-2.63 1.11-3.81.69zm6.32 5.65c-.25.09-.52.08-.76-.04a.989.989 0 01-.51-.57c-.42-1.18.09-2.65.7-3.8l1.18 3.13c.18.52-.09 1.1-.61 1.28zm1.21-5.34l-.61-1.61c0-.01-.01-.02-.02-.03l-.06-.12a.673.673 0 00-.07-.11l-.09-.09-.09-.09c-.03-.03-.07-.05-.11-.07-.04-.02-.07-.05-.12-.06-.01 0-.02-.01-.03-.02l-1.6-.6a1.966 1.966 0 012.67.13c.73.73.77 1.88.13 2.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$31cb44aaa49a6d20(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-.46 0-.93.04-1.4.14-2.76.53-4.96 2.76-5.48 5.52-.48 2.61.48 5.01 2.22 6.56.43.38.66.91.66 1.47V19c0 1.1.9 2 2 2h.28a1.98 1.98 0 003.44 0H14c1.1 0 2-.9 2-2v-2.31c0-.55.22-1.09.64-1.46A6.956 6.956 0 0019 10c0-3.87-3.13-7-7-7zm2 14h-4v-1h4v1zm-4 2v-1h4v1h-4zm5.31-5.26c-.09.08-.16.18-.24.26H8.92c-.08-.09-.15-.19-.24-.27-1.32-1.18-1.91-2.94-1.59-4.7.36-1.94 1.96-3.55 3.89-3.93.34-.07.68-.1 1.02-.1 2.76 0 5 2.24 5 5 0 1.43-.61 2.79-1.69 3.74z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 11h1v3h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.672 9.58l.707-.706 2.122 2.121-.707.707z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.208 11.712l-.707-.707 2.121-2.121.707.707z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$461a3c75b81d9eb4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.89 8.11C15.5 7.72 14.83 7 13.53 7h-2.54C8.24 6.99 6 4.75 6 2H4c0 3.16 2.11 5.84 5 6.71V22h2v-6h2v6h2V10.05L18.95 14l1.41-1.41-4.47-4.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$12d4105a5783f212(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h8v2H3zM6 11h2V7h3V5H3v2h3zM12.404 20.182l7.778-7.778 1.414 1.414-7.778 7.778z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 11A2.5 2.5 0 0018 8.5V4h3V2h-4v4.51c-.42-.32-.93-.51-1.5-.51a2.5 2.5 0 000 5zM9.74 15.96l-1.41 1.41-.71-.71.35-.35a2.499 2.499 0 00-1.77-4.27 2.499 2.499 0 00-1.77 4.27l.35.35-1.06 1.06c-.98.98-.98 2.56 0 3.54.5.5 1.14.74 1.78.74s1.28-.24 1.77-.73l1.06-1.06 1.41 1.41 1.41-1.41-1.41-1.41 1.41-1.41-1.41-1.43zM5.85 14.2c.12-.12.26-.15.35-.15s.23.03.35.15c.19.2.19.51 0 .71l-.35.35-.35-.36a.501.501 0 010-.7zm0 5.65c-.12.12-.26.15-.35.15s-.23-.03-.35-.15a.513.513 0 010-.71l1.06-1.06.71.71-1.07 1.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$69889510bbc86a3b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.57 10.66c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 14.77l.01 5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V19h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h1V3H7v5H2v13h1V9h5V4h6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h2v2H5zM10 5h2v2h-2zM5 15h2v2H5zM5 19h2v2H5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$99466ffddd9759d8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H3zM4.74 9H5c0 2.21 1.79 4 4 4s4-1.79 4-4h.26c.27 0 .49-.22.49-.49v-.02a.49.49 0 00-.49-.49H13c0-1.48-.81-2.75-2-3.45v.95c0 .28-.22.5-.5.5s-.5-.22-.5-.5V4.14C9.68 4.06 9.35 4 9 4s-.68.06-1 .14V5.5c0 .28-.22.5-.5.5S7 5.78 7 5.5v-.95C5.81 5.25 5 6.52 5 8h-.26a.49.49 0 00-.49.49v.03c0 .26.22.48.49.48zM11 9c0 1.1-.9 2-2 2s-2-.9-2-2h4zM21.98 6.23l.93-.83-.75-1.3-1.19.39c-.14-.11-.3-.2-.47-.27L20.25 3h-1.5l-.25 1.22c-.17.07-.33.16-.48.27l-1.18-.39-.75 1.3.93.83c-.02.17-.02.35 0 .52l-.93.85.75 1.3 1.2-.38c.13.1.28.18.43.25l.28 1.23h1.5l.27-1.22c.16-.07.3-.15.44-.25l1.19.38.75-1.3-.93-.85c.03-.19.02-.36.01-.53zM19.5 7.75a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM19.4 10.79l-.85.28c-.1-.08-.21-.14-.33-.19l-.18-.88h-1.07l-.18.87c-.12.05-.24.12-.34.19l-.84-.28-.54.93.66.59c-.01.13-.01.25 0 .37l-.66.61.54.93.86-.27c.1.07.2.13.31.18l.18.88h1.07l.19-.87c.11-.05.22-.11.32-.18l.85.27.54-.93-.66-.61c.01-.13.01-.25 0-.37l.66-.59-.53-.93zm-1.9 2.6c-.49 0-.89-.4-.89-.89s.4-.89.89-.89.89.4.89.89-.4.89-.89.89z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d52c9bb4d0eb09ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.97 13.52v-.04C23.21 12.38 24 10.78 24 9c0-3.31-2.69-6-6-6-.26 0-.52.02-.78.06a5.98 5.98 0 00-10.44 0C6.52 3.02 6.26 3 6 3 2.69 3 0 5.69 0 9c0 1.78.79 3.38 2.02 4.48v.04A6.008 6.008 0 000 18c0 3.31 2.69 6 6 6 1.39 0 2.67-.48 3.69-1.28.74.18 1.51.28 2.31.28s1.57-.1 2.31-.28c1.02.8 2.3 1.28 3.69 1.28 3.31 0 6-2.69 6-6 0-1.78-.79-3.38-2.03-4.48zM22 9c0 .55-.12 1.07-.32 1.54A10 10 0 0017.98 5H18c2.21 0 4 1.79 4 4zm-9.97-4c2.73.01 5.13 1.39 6.57 3.48-.71.57-1.6.89-2.53.89A4.059 4.059 0 0112 5.31c0-.1.02-.2.03-.31zM12 2c1.25 0 2.36.59 3.1 1.5-.98-.32-2.02-.5-3.1-.5s-2.12.18-3.1.5C9.64 2.59 10.75 2 12 2zM6 5h.02a10 10 0 00-3.7 5.54C2.12 10.07 2 9.55 2 9c0-2.21 1.79-4 4-4zm0 17c-2.21 0-4-1.79-4-4 0-.69.19-1.32.5-1.88.8 2.44 2.52 4.47 4.74 5.68-.39.13-.8.2-1.24.2zm-2-9c0-3.72 2.56-6.85 6-7.74v.05c0 3.34 2.72 6.06 6.06 6.06 1.26 0 2.45-.39 3.45-1.09.31.86.49 1.77.49 2.72 0 4.41-3.59 8-8 8s-8-3.59-8-8zm14 9c-.44 0-.85-.07-1.25-.2 2.23-1.21 3.94-3.24 4.74-5.68.31.56.5 1.2.5 1.88.01 2.21-1.78 4-3.99 4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "14",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "14",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$552969022004f13f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.91 11.96C22.39 6.32 17.66 2 12 2S1.61 6.32 1.09 11.96l-.9 9.86c-.1 1.17.82 2.18 2 2.18h19.62c1.18 0 2.1-1.01 1.99-2.18l-.89-9.86zM13 4.07c2.26.28 4.22 1.51 5.49 3.28-.58.4-1.26.65-1.99.65C14.57 8 13 6.43 13 4.5v-.43zm-2 0v.43C11 6.43 9.43 8 7.5 8c-.73 0-1.41-.25-1.99-.65 1.27-1.77 3.23-3 5.49-3.28zM4.54 9.13c.87.55 1.89.87 2.96.87 1.86 0 3.5-.93 4.5-2.35C13 9.07 14.64 10 16.5 10c1.07 0 2.09-.32 2.96-.87.34.89.54 1.86.54 2.87 0 4.41-3.59 8-8 8s-8-3.59-8-8c0-1.01.2-1.98.54-2.87zM12 22H2.19l.56-6.2C4.25 19.44 7.82 22 12 22s7.75-2.56 9.25-6.2l.56 6.2H12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb0a3f82991ce186(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-.96 0-1.88.14-2.75.39A4.986 4.986 0 005 0C2.24 0 0 2.24 0 5c0 1.8.96 3.37 2.39 4.25C2.14 10.12 2 11.04 2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 2c2.9 0 5.44 1.56 6.84 3.88-.43.07-.88.12-1.34.12-2.9 0-5.44-1.56-6.84-3.88.43-.07.88-.12 1.34-.12zM4.42 9.47a8.046 8.046 0 013.66-4.44 8.046 8.046 0 01-3.66 4.44zM2 5c0-1.65 1.35-3 3-3 .95 0 1.8.46 2.35 1.15-1.79.94-3.26 2.41-4.2 4.2C2.46 6.8 2 5.95 2 5zm10 15c-4.41 0-8-3.59-8-8 0-.05.01-.1.01-.15 2.6-.98 4.68-2.99 5.74-5.55a9.942 9.942 0 009.92 3.46c.21.71.33 1.46.33 2.24 0 4.41-3.59 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d9aacfe6cbfe4e28(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-1.12.23-2.18.65-3.15a.495.495 0 00.85-.35c0-.25-.19-.45-.43-.49.15-.26.32-.51.49-.75-.03.08-.06.15-.06.24 0 .28.22.5.5.5s.5-.22.5-.5S6.28 7 6 7c-.13 0-.25.05-.34.13.52-.68 1.15-1.28 1.86-1.76A.495.495 0 008 6a.495.495 0 00.1-.98c.16-.09.32-.17.49-.25.09.14.24.23.41.23.28 0 .5-.22.5-.5 0-.03-.01-.06-.02-.09.39-.13.79-.23 1.21-.3-.11.1-.19.23-.19.39 0 .28.22.5.5.5s.5-.22.5-.5a.51.51 0 00-.3-.46c.26-.03.53-.04.8-.04s.54.01.8.04c-.18.08-.3.25-.3.46 0 .28.22.5.5.5s.5-.22.5-.5c0-.16-.08-.29-.19-.38.41.07.82.17 1.21.3-.01.02-.02.05-.02.08 0 .28.22.5.5.5.17 0 .32-.09.41-.23.17.08.33.16.49.25A.495.495 0 0016 6c.28 0 .5-.22.5-.5 0-.05-.01-.09-.03-.13.71.48 1.34 1.08 1.86 1.76a.495.495 0 00-.83.37c0 .28.22.5.5.5s.5-.22.5-.5c0-.09-.03-.16-.07-.23.18.24.34.49.49.75-.23.03-.42.23-.42.48a.495.495 0 00.85.35c.42.97.65 2.03.65 3.15 0 4.41-3.59 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "5.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "5.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$691ac36dae0a0ae5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 2c3.68 0 6.78 2.51 7.71 5.9-.6-.16-1.33-.37-2.26-2.24A2.992 2.992 0 0014.76 6H9.24c-1.15 0-2.18.64-2.69 1.66-.93 1.86-1.58 2.06-2.26 2.24C5.22 6.51 8.32 4 12 4zm0 16c-4.41 0-8-3.59-8-8v-.03c2.31-.22 3.43-1.59 4.34-3.41.17-.35.51-.56.9-.56h5.53c.38 0 .72.21.89.55.9 1.8 1.99 3.19 4.34 3.41v.03c0 4.42-3.59 8.01-8 8.01z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ba2ca7a42f608327(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$691e27f6cda77613(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 9.5C17.5 6.46 15.04 4 12 4S6.5 6.46 6.5 9.5c0 2.7 1.94 4.93 4.5 5.4V17H9v2h2v2h2v-2h2v-2h-2v-2.1c2.56-.47 4.5-2.7 4.5-5.4zm-9 0C8.5 7.57 10.07 6 12 6s3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb438dae17d040fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 12.46c-.15.42-.15.82-.08 1.28.1.55.33 1.04.2 1.6-.13.59-.77 1.38-1.53 1.63 1.28 1.05 3.2.37 3.39-1.32.17-1.54-1.44-1.98-1.98-3.19z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2v20h20V2H2zm10 16c-1.58 0-2.97-1.88-3-3.06 0-.05-.01-.13-.01-.22-.13-1.73 1-3.2 2.47-4.37.47 1.01 1.27 2.03 2.57 2.92.58.42.97.86.97 1.73 0 1.65-1.35 3-3 3zm8 2h-2v-2h-2.02A4.98 4.98 0 0017 15c0-1.89-1.09-2.85-1.85-3.37C12.2 9.61 13 7 13 7c-6.73 3.57-6.02 7.47-6 8 .03.96.49 2.07 1.23 3H6v2H4V4h16v16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a5d8c592a9bb34bf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.89 13.89c1.04 0 1.89-.85 1.89-1.89s-.85-1.89-1.89-1.89S18 10.96 18 12s.85 1.89 1.89 1.89zm-4.24-.21c.93 0 1.68-.75 1.68-1.68s-.75-1.68-1.68-1.68c-.93 0-1.68.75-1.68 1.68s.75 1.68 1.68 1.68zm0-4.26c.93 0 1.68-.75 1.68-1.68 0-.93-.75-1.68-1.68-1.68-.93 0-1.68.75-1.68 1.68 0 .93.75 1.68 1.68 1.68zm0 8.51c.93 0 1.68-.75 1.68-1.68 0-.93-.75-1.68-1.68-1.68-.93 0-1.68.75-1.68 1.68 0 .92.75 1.68 1.68 1.68zm-4.24-4.46c.81 0 1.47-.66 1.47-1.47s-.66-1.47-1.47-1.47c-.81 0-1.47.66-1.47 1.47s.65 1.47 1.47 1.47zm0-4.26c.81 0 1.47-.66 1.47-1.47s-.66-1.47-1.47-1.47c-.81 0-1.47.66-1.47 1.47s.65 1.47 1.47 1.47zm0 8.52c.81 0 1.47-.66 1.47-1.47 0-.81-.66-1.47-1.47-1.47-.81 0-1.47.66-1.47 1.47-.01.81.65 1.47 1.47 1.47zm0 4.27c.81 0 1.47-.66 1.47-1.47 0-.81-.66-1.47-1.47-1.47-.81 0-1.47.66-1.47 1.47-.01.81.65 1.47 1.47 1.47zm0-17.06c.81 0 1.47-.66 1.47-1.47S12.22 2 11.41 2c-.81 0-1.47.66-1.47 1.47s.65 1.47 1.47 1.47zm-4.25 8.32c.7 0 1.26-.57 1.26-1.26s-.57-1.26-1.26-1.26a1.261 1.261 0 000 2.52zm0 4.25a1.261 1.261 0 000-2.52 1.261 1.261 0 000 2.52zm0-8.49a1.261 1.261 0 000-2.52 1.261 1.261 0 000 2.52zm-3.87 4.03a1.05 1.05 0 100-2.1 1.05 1.05 0 000 2.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f66fb1ca5b30fb85(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.67 19c-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.1 1-3.34 1-1.24 0-1.38-1-3.33-1-1.95 0-2.1 1-3.34 1v2c1.95 0 2.11-1 3.34-1 1.24 0 1.38 1 3.33 1 1.95 0 2.1-1 3.34-1 1.22 0 1.4 1 3.33 1 1.93 0 2.1-1 3.33-1 1.22 0 1.4 1 3.33 1v-2c-1.24 0-1.38-1-3.33-1zM8.68 17.5c1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.31 1v-2c-.63 0-1-.28-1.48-.55l-2.02-7.53 2.09.85.74-1.86L9.78 2 2 11.61l1.57 1.23 1.39-1.78.93 3.48c-.18-.02-.35-.05-.56-.05-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1 1.19.01 1.42 1.01 3.33 1.01zm1.74-13.09l5.74 2.09 2.15 8.02c-1.54.11-1.82.89-2.85.96l-1.42-5.31-3.86 1.04.91 3.39c-1.12.25-1.41.9-2.42.9-.18 0-.33-.02-.45-.05L6.5 9.09l3.92-4.68z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$14c85b1309c953e5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75M13 2v7h3.75v14h1.5V9H22V2h-9zm5.01 6V6.25H14.5v-1.5h3.51V3l2.49 2.5L18.01 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$78ab086837399997(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 8c-.17 0-.34.02-.5.05V4.5a2.5 2.5 0 00-3.04-2.44A2.502 2.502 0 0012.5 0c-1.06 0-1.96.66-2.33 1.59A2.5 2.5 0 007 4v.55A2.5 2.5 0 004 7v8.5c0 4.69 3.81 8.5 8.5 8.5s8.5-3.81 8.5-8.5v-5A2.5 2.5 0 0018.5 8zm.5 7.5a6.5 6.5 0 11-13 0V7c0-.28.22-.5.5-.5s.5.22.5.5v5h2V4c0-.28.22-.5.5-.5s.5.22.5.5v7h2V2.5c0-.28.22-.5.5-.5s.5.22.5.5V11h2V4.5c0-.28.22-.5.5-.5s.5.22.5.5v8.92c-1.77.77-3 2.53-3 4.58h2c0-1.66 1.34-3 3-3v-4.5c0-.28.22-.5.5-.5s.5.22.5.5v5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ca6d0d0b6e44fd6b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.5c.97 0 1.75-.78 1.75-1.75S12.97 4 12 4s-1.75.78-1.75 1.75S11.03 7.5 12 7.5zm2 8.5v4h-4v-4H8l2.38-6.38a1.733 1.733 0 013.24 0L16 16h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$52d5fd208e728afa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9V7h-2v2h-2v2h2v2h2v-2h2V9zM8 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM8 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H2v-.99C2.2 16.29 5.3 15 8 15s5.8 1.29 6 2v1zM12.51 4.05C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95zM16.53 13.83C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aea2d2c064062682(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8c0-1.42-.5-2.73-1.33-3.76.42-.14.86-.24 1.33-.24 2.21 0 4 1.79 4 4s-1.79 4-4 4h-.18l-.77-.77c.6-.94.95-2.05.95-3.23zm7.83 12H23v-3c0-2.18-3.58-3.47-6.34-3.87 1.1.75 1.95 1.71 2.23 2.94L22.83 20zM9 6c-.06 0-.11 0-.16.01l-1.6-1.6a3.996 3.996 0 015.35 5.35l-1.6-1.6c.01-.05.01-.1.01-.16 0-1.1-.9-2-2-2zm.17 6H9c-2.21 0-4-1.79-4-4v-.17L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41L17 19.83V20H1v-3c0-2.66 5.33-4 8-4 .37 0 .8.03 1.25.08L9.17 12zM9 15c-2.7 0-5.8 1.29-6 2.01V18h12v-.17l-2.11-2.11C11.76 15.31 10.33 15 9 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d2ccb79a844e0eb7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 9v2h-6V9h6zM8 4C5.79 4 4 5.79 4 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0 3c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H2v-.99C2.2 16.29 5.3 15 8 15s5.8 1.29 6 2v1zM12.51 4.05C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95zm4.02 9.78C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5830318c24b6c316(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a3f09dffb24811c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.27 12h3.46a1.5 1.5 0 001.48-1.75l-.3-1.79a2.951 2.951 0 00-5.82.01l-.3 1.79c-.15.91.55 1.74 1.48 1.74zm.79-3.21c.08-.46.47-.79.94-.79s.86.33.94.79l.2 1.21h-2.28l.2-1.21zM1.66 11.11c-.13.26-.18.57-.1.88.16.69.76 1.03 1.53 1h1.95c.83 0 1.51-.58 1.51-1.29 0-.14-.03-.27-.07-.4-.01-.03-.01-.05.01-.08.09-.16.14-.34.14-.53 0-.31-.14-.6-.36-.82-.03-.03-.03-.06-.02-.1.07-.2.07-.43.01-.65a1.12 1.12 0 00-.99-.74.09.09 0 01-.07-.03C5.03 8.14 4.72 8 4.37 8c-.3 0-.57.1-.75.26-.03.03-.06.03-.09.02a1.24 1.24 0 00-1.7 1.03c0 .02-.01.04-.03.06-.29.26-.46.65-.41 1.05.03.22.12.43.25.6.03.02.03.06.02.09zM16.24 13.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM8.07 16a.96.96 0 01.49-.52c1.1-.49 2.26-.73 3.43-.73 1.18 0 2.33.25 3.43.73.23.1.4.29.49.52H8.07zM1.22 14.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58zM22.78 14.58A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57c0-.81-.48-1.53-1.22-1.85zM22 11v-.5c0-1.1-.9-2-2-2h-2c-.42 0-.65.48-.39.81l.7.63c-.19.31-.31.67-.31 1.06 0 1.1.9 2 2 2s2-.9 2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$65369ffb6430c469(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 13.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM8.07 16a.96.96 0 01.49-.52c1.1-.49 2.26-.73 3.43-.73 1.18 0 2.33.25 3.43.73.23.1.4.29.49.52H8.07zM1.22 14.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58zM22.78 14.58A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57c0-.81-.48-1.53-1.22-1.85zM12 12c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM1.497 11L4 8.497 6.503 11 4 13.503zM20 9l-2.5 4h5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$37a5f7b9df314803(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29zM20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57zm-7.76-2.78c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM8.07 16c.09-.23.13-.39.91-.69.97-.38 1.99-.56 3.02-.56s2.05.18 3.02.56c.77.3.81.46.91.69H8.07zM12 8c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m0-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d454ba1374d7d22(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.22 19.85c-.18.18-.5.21-.71 0a.504.504 0 010-.71l3.39-3.39-1.41-1.41-3.39 3.39c-.19.2-.51.19-.71 0a.504.504 0 010-.71l3.39-3.39-1.41-1.41-3.39 3.39c-.18.18-.5.21-.71 0a.513.513 0 010-.71l3.39-3.39-1.42-1.41-3.39 3.39c-.18.18-.5.21-.71 0a.513.513 0 010-.71L9.52 8.4l1.87 1.86c.95.95 2.59.94 3.54 0 .98-.98.98-2.56 0-3.54l-1.86-1.86.28-.28c.78-.78 2.05-.78 2.83 0l4.24 4.24c.78.78.78 2.05 0 2.83l-8.2 8.2zm9.61-6.78a4.008 4.008 0 000-5.66l-4.24-4.24a4.008 4.008 0 00-5.66 0l-.28.28-.28-.28a4.008 4.008 0 00-5.66 0L2.17 6.71a3.992 3.992 0 00-.4 5.19l1.45-1.45a2 2 0 01.37-2.33l3.54-3.54c.78-.78 2.05-.78 2.83 0l3.56 3.56c.18.18.21.5 0 .71-.21.21-.53.18-.71 0L9.52 5.57l-5.8 5.79c-.98.97-.98 2.56 0 3.54.39.39.89.63 1.42.7a2.458 2.458 0 002.12 2.12 2.458 2.458 0 002.12 2.12c.07.54.31 1.03.7 1.42.47.47 1.1.73 1.77.73.67 0 1.3-.26 1.77-.73l8.21-8.19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1f8c2efd0bdbfabf(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 13H8v-3h2.5V7.5h3V10H16v3h-2.5v2.5h-3V13zM12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7f794f7cb0035fa9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3c-.96 0-1.9.25-2.73.69L12 9h3l-3 10 1-9h-3l1.54-5.39C10.47 3.61 9.01 3 7.5 3 4.42 3 2 5.42 2 8.5c0 4.13 4.16 7.18 10 12.5 5.47-4.94 10-8.26 10-12.5C22 5.42 19.58 3 16.5 3zm-6.26 13.73C6.45 13.34 4 11 4 8.5 4 6.54 5.54 5 7.5 5c.59 0 1.19.15 1.73.42L7.35 12h3.42l-.53 4.73zm4.89-1.2L17.69 7h-2.91l.61-1.82c.36-.12.74-.18 1.11-.18C18.46 5 20 6.54 20 8.5c0 2.21-2.02 4.43-4.87 7.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5e2ad8a2d0213010(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 5.28c-1.23-.37-2.22-1.17-2.8-2.18l-1-1.6c-.41-.65-1.11-1-1.84-1-.78 0-1.59.5-1.78 1.44S7 23 7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3c1 1.15 2.41 2.01 4 2.34V23H19V9h-1.5v1.78zM7.43 13.13l-2.12-.41a.999.999 0 01-.79-1.17l.76-3.93a2 2 0 012.34-1.58l1.16.23-1.35 6.86z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2e813c251e746cff(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v1.38c-.83-.33-1.72-.5-2.61-.5-1.79 0-3.58.68-4.95 2.05l3.33 3.33h1.11v1.11c.86.86 1.98 1.31 3.11 1.36V15H6v3c0 1.1.9 2 2 2h10c1.66 0 3-1.34 3-3V4H9zm-1.11 6.41V8.26H5.61L4.57 7.22a5.07 5.07 0 011.82-.34c1.34 0 2.59.52 3.54 1.46l1.41 1.41-.2.2a2.7 2.7 0 01-1.92.8c-.47 0-.93-.12-1.33-.34zM19 17c0 .55-.45 1-1 1s-1-.45-1-1v-2h-6v-2.59c.57-.23 1.1-.57 1.56-1.03l.2-.2L15.59 14H17v-1.41l-6-5.97V6h8v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$630e71059e163ce3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.5 9l-2.25-4h-3.31l-1.69-3h-4.5L8.06 5H4.75L2.5 9l1.69 3-1.69 3 2.25 4h3.31l1.69 3h4.5l1.69-3h3.31l2.25-4-1.69-3 1.69-3zm-2.29 0l-1.12 2h-2.14l-1.12-2 1.12-2h2.14l1.12 2zm-8.27 5l-1.12-2 1.12-2h2.12l1.12 2-1.12 2h-2.12zm2.14-10l1.12 1.98L13.06 8h-2.12L9.8 5.98 10.92 4h2.16zM5.92 7h2.14l1.12 2-1.12 2H5.92L4.79 9l1.13-2zm-1.13 8l1.12-2h2.14l1.12 2-1.12 2H5.92l-1.13-2zm6.13 5L9.8 18.02 10.94 16h2.12l1.13 2.02L13.08 20h-2.16zm7.16-3h-2.14l-1.12-2 1.12-2h2.14l1.12 2-1.12 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2146b8ed2b21a368(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17c0 1.66-1.34 3-3 3h-2v-2h3v-4a3.96 3.96 0 00-2.91-3.82l-2.62-.74C12.62 9.19 12 8.39 12 7.5V3H3v15h3v2H2v2h16c2.76 0 5-2.24 5-5h-2zM5 16V5h5v1H8.5c-.28 0-.5.22-.5.5s.22.5.5.5H10l.1 1H8.5c-.28 0-.5.22-.5.5s.22.5.5.5h1.81c.45 1.12 1.4 2.01 2.6 2.36l2.62.73C16.4 12.33 17 13.1 17 14v2H5zm9 4H8v-2h6v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1df0b79fb7b29c43(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.02 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM13 13v8h8v-8h-8zm6 6h-4v-4h4v4zM7 2l-5 9h10L7 2zm0 4.12L8.6 9H5.4L7 6.12zM19.25 2.5c-1.06 0-1.81.56-2.25 1.17-.44-.61-1.19-1.17-2.25-1.17C13.19 2.5 12 3.78 12 5.25c0 2 2.42 3.42 5 5.75 2.58-2.33 5-3.75 5-5.75 0-1.47-1.19-2.75-2.75-2.75zM17 8.35c-1.45-1.22-3-2.4-3-3.1 0-.43.35-.75.75-.75.31 0 .52.17.73.37L17 6.3l1.52-1.43c.21-.2.42-.37.73-.37.4 0 .75.32.75.75 0 .7-1.55 1.88-3 3.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4a8face8578b0777(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6a2 2 0 01-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3a2 2 0 012 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$28d7b379b21af6b2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 23c-1.03 0-2.06-.25-3-.75-1.89 1-4.11 1-6 0-1.89 1-4.11 1-6 0-.95.5-1.97.75-3 .75H2v-2h1c1.04 0 2.08-.35 3-1 1.83 1.3 4.17 1.3 6 0 1.83 1.3 4.17 1.3 6 0 .91.65 1.96 1 3 1h1v2h-1zM12 5.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 12s-1.52.71-3.93 1.37c-.82-.23-1.53-.75-2.07-1.37-.73.84-1.8 1.5-3 1.5s-2.27-.66-3-1.5c-.73.84-1.8 1.5-3 1.5s-2.27-.66-3-1.5c-.54.61-1.25 1.13-2.07 1.37C1.52 18.21 0 17.5 0 17.5s2.93-1.36 7.13-2.08l1.35-4.17c.31-.95 1.32-1.47 2.27-1.16.09.03.19.07.27.11l2.47 1.3 2.84-1.5 1.65-3.71-.51-1.32L18.8 2 22 3.43 20.67 6.4l-1.31.5-3.72 8.34c4.85.63 8.36 2.26 8.36 2.26zm-8.98-4.54l-1.52.8-1.75-.92-.71 2.17c.32 0 .64-.01.96-.01.71 0 1.4.03 2.07.08l.95-2.12z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$adb2d75c744ea80c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-1.1-.9-2-2-2V7c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L4 19h1l.67-2h12.67l.66 2h1l.67-2H22v-5zm-4-2h-5V7h5v3zM6 7h5v3H6V7zm-2 5h16v3H4v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$40ea7c20ae75c141(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm14.06-2h-2.12L15.5 3.44l1.06 1.06 3.5-3.5zM22 23v-2h-1c-1.04 0-2.08-.35-3-1-1.83 1.3-4.17 1.3-6 0-1.83 1.3-4.17 1.3-6 0-.91.65-1.96 1-3 1H2v2h1c1.03 0 2.05-.25 3-.75 1.89 1 4.11 1 6 0 1.89 1 4.11 1 6 0 .95.5 1.97.75 3 .75h1zm-1-9.72c0 1.44-2.19 3.62-5.04 5.58-.31.09-.63.14-.96.14-1.2 0-2.27-.66-3-1.5-.73.84-1.8 1.5-3 1.5-.94 0-1.81-.41-2.49-.99.46-.39.96-.78 1.49-1.17l-1.55-2.97A4.06 4.06 0 016 12V8c0-1.1.9-2 2-2h3c1.38 0 2.63-.56 3.54-1.46l1.41 1.41A7.018 7.018 0 0111 8H9.6v3.5h2.8l1.69 1.88c1.95-.84 3.77-1.38 5.06-1.38.84 0 1.85.25 1.85 1.28zm-8.8.99l-.7-.77-2.5.1.83 2.01c.59-.38 1.81-1.06 2.37-1.34z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$31c98d38d81d4013(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12L8 8H2v14h20l-6-8-5-2zm1.53 2.77L6 16.95l-2-.67v-1.89l2 .67 3.95-1.32 2.58 1.03zM7 10l1.57 2.09-2.57.86-2-.67V10h3zM4 20v-1.61l2 .67 9.03-3.01L18 20H4zM17 6V1l-5-1-3 2v4l3 2 5-2zm-6-2.93l1.42-.95 2.58.52v2.01l-2.77 1.11L11 4.93V3.07zM18.5 7L16 9v3l2.5 2 4.5-2V8l-4.5-1zm2.5 3.7l-2.2.98-.8-.64V9.96l1-.8 2 .44v1.1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$df7f311c0a463502(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c5811b70f32ba1e2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 18H8V9h1.5v9zm3.25 0h-1.5V9h1.5v9zM16 18h-1.5V9H16v9zm1-12h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6.5-2.5h3V6h-3V3.5zM17 19H7V8h10v11z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5b52469e1199941c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 11c1.93 0 3.5 1.57 3.5 3.5S11.43 18 9.5 18 6 16.43 6 14.5 7.57 11 9.5 11zm0-2C6.46 9 4 11.46 4 14.5S6.46 20 9.5 20s5.5-2.46 5.5-5.5c0-1.16-.36-2.23-.97-3.12L18 7.42V10h2V4h-6v2h2.58l-3.97 3.97C11.73 9.36 10.66 9 9.5 9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ebbfdb326f6e900b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4c-1.1 0-2 .9-2 2v6h2.5v7h3v-7H16V9c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d5b12bbb050638ce(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2zM12 1.751L14.248 4 12 6.248 9.75 4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e4c86448a18352dd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.75 7h-3.5C9.04 7 8.11 8.07 8.27 9.26L10 22h4l1.73-12.74C15.89 8.07 14.96 7 13.75 7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ee86313ebd1f9d36(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$44ef5acf80bca4cc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 6c-1.31 0-2.37 1.01-2.48 2.3-1.88-.5-2.84-1.8-5.02-1.8-2.19 0-3.14 1.3-5.02 1.8C6.87 7.02 5.81 6 4.5 6A2.5 2.5 0 002 8.5V9c0 6 3.6 7.81 6.52 7.98C9.53 17.62 10.72 18 12 18s2.47-.38 3.48-1.02C18.4 16.81 22 15 22 9v-.5A2.5 2.5 0 0019.5 6zm-16 3v-.5c0-.55.45-1 1-1s1 .45 1 1v3c0 1.28.38 2.47 1.01 3.48C4.99 14.27 3.5 12.65 3.5 9zM7 11.5V9.85c1.12-.23 1.95-.69 2.66-1.08C10.48 8.33 11.07 8 12 8c.93 0 1.52.33 2.34.78.71.39 1.54.84 2.66 1.08v1.65c0 2.76-2.24 5-5 5s-5-2.25-5-5.01zM20.5 9c0 3.65-1.49 5.27-3.01 5.98.64-1.01 1.01-2.2 1.01-3.48v-3c0-.55.45-1 1-1s1 .45 1 1V9zm-9.81 1.48c-.44.26-.96.56-1.69.76V10.2c.48-.17.84-.38 1.18-.58C10.72 9.3 11.23 9 12 9s1.27.3 1.8.62c.34.2.71.42 1.2.59v1.04c-.75-.21-1.26-.51-1.71-.78-.46-.27-.8-.47-1.29-.47s-.84.2-1.31.48z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a309449f5d7e7e1f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.43V2H7v8.43c0 .35.18.68.49.86l4.18 2.51-.99 2.34-3.41.29 2.59 2.24L9.07 22 12 20.23 14.93 22l-.78-3.33 2.59-2.24-3.41-.29-.99-2.34 4.18-2.51c.3-.18.48-.5.48-.86zm-6 .64l-2-1.2V4h2v7.07zm4-1.2l-2 1.2V4h2v5.87z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c28de8c18edc9c1e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 2.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a20a482b33628199(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ab2a5929eb86c424(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.78 17.51c-2.47 0-6.57-1.33-8.68-5.43-2.33-4.51-.5-8.48.53-10.07C6.27 2.2 1.98 6.59 1.98 12c0 .14.02.28.02.42.61-.26 1.28-.42 1.98-.42 0-3.09 1.73-5.77 4.3-7.1-.5 2.19-.54 5.04 1.04 8.1 1.57 3.04 4.18 4.95 6.8 5.86a8 8 0 01-5.61 1.01c-.37.7-.94 1.27-1.64 1.64.98.32 2.03.5 3.11.5 3.5 0 6.58-1.8 8.37-4.52-.17.01-.37.02-.57.02z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h-.18C6.4 14.84 5.3 14 4 14c-1.66 0-3 1.34-3 3s1.34 3 3 3h3c1.1 0 2-.9 2-2s-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$24b37a4b761b2d15(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-1.85.63-3.54 1.69-4.9L7.59 9h2.83L7.1 5.69A7.924 7.924 0 0112 4c4.41 0 8 3.59 8 8 0 1.85-.63 3.54-1.69 4.9l-1.9-1.9h-2.83l3.31 3.31A7.874 7.874 0 0112 20c-4.41 0-8-3.59-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 14l-1.5-2 1.5-2h-1.5L12 11l-.75-1h-1.5l1.5 2-1.5 2h1.5l.75-1 .75 1zM8 10l-.75 1-.75-1H5l1.5 2L5 14h1.5l.75-1L8 14h1.5L8 12l1.5-2zM16 14l.75-1 .75 1H19l-1.5-2 1.5-2h-1.5l-.75 1-.75-1h-1.5l1.5 2-1.5 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b35536f0d0d2bbd2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13.17l-1.5-1.5V9H16v4.17zm3.78 9.44l-1.85-1.85c-.28.15-.59.24-.93.24 0 .55-.45 1-1 1s-1-.45-1-1H9c0 .55-.45 1-1 1s-1-.45-1-1c-1.1 0-2-.9-2-2V8c0-.05.02-.1.02-.15L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM16.17 19l-3.42-3.42V18h-1.5v-3.92L9.5 12.33V18H8v-7.17l-1-1V19h9.17zM12.75 9h-.92l.92.92V9zM19 8v8.17l-2-2V8h-6.17l-.99-.99L9 6.17V3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v3h2c1.1 0 2 .9 2 2zm-8.5-2h3V3.5h-3V6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1a150baca90bfa71(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 23h-1.5v-9H19v9zM7.53 14H6l-2 9h1.53l2-9zm5.97-8.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6a2.145 2.145 0 00-2.65-.84L6 8.3V13h2V9.6l1.8-.7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$95a41212d9f90380(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14v3H8v-7c0-2.21 1.79-4 4-4 .85 0 1.64.26 2.28.72l1.43-1.43A5.87 5.87 0 0013.5 4.2v-.7c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.7C7.91 4.86 6 7.21 6 10v7H4v2h16v-2h-2v-3h-2zm-4 8c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zM24 8h-3V5h-2v3h-3v2h3v3h2v-3h3V8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b66b6a9b3ddec706(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zM7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2a8.445 8.445 0 013.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43a8.495 8.495 0 013.54 6.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c42bfe92886bdceb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$77e5eb357d642001(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm0-15.5c2.49 0 4 2.02 4 4.5v.1l2 2V11c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.24.06-.47.15-.69.23l1.64 1.64c.18-.02.36-.05.55-.05zM5.41 3.35L4 4.76l2.81 2.81C6.29 8.57 6 9.74 6 11v5l-2 2v1h14.24l1.74 1.74 1.41-1.41L5.41 3.35zM16 17H8v-6c0-.68.12-1.32.34-1.9L16 16.76V17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a514926cf3f41075(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 9.8h2.8l-2.8 3.4V15h5v-1.8h-2.8l2.8-3.4V8h-5zM18 16v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zm-4 5c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9c30c826787647e4(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$85ef3c24b7950fde(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 22c1.66 0 3-1.34 3-3s-1.34-3-3-3c-1.3 0-2.4.84-2.82 2H9.14l1.99-3.06a6.36 6.36 0 001.74 0l1.02 1.57c.42-.53.96-.95 1.6-1.21l-.6-.93A6.992 6.992 0 0019 8H5c0 2.84 1.69 5.27 4.12 6.37l-3.95 6.08a1 1 0 00.29 1.38 1 1 0 001.38-.29l1-1.55h6.34C14.6 21.16 15.7 22 17 22zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-9.58-8h9.16c-.77 1.76-2.54 3-4.58 3s-3.81-1.24-4.58-3zM9.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04zM11.89 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.78-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.23.24.8.67.45 2.04zM14.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$63d810d525fd9f6a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 2h6v6h-3l1-4-4 1V5zM5 5h6v3L7 7l1 4H5V5zm6 14H5v-6h3l-1 4 4-1v3zm8 0h-6v-3l4 1-1-4h3v6zm-4.37-4.37L12 13.72l-2.63.91.91-2.63-.91-2.63 2.63.91 2.63-.91-.91 2.63.91 2.63z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3b26f069b4f9bc13(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.48.94C14.68 18.54 14 19 12 19s-2.68-.46-3.48-1.06C8.04 17.55 7 16.76 7 14H5c0 2.7.93 4.41 2.3 5.5.5.4 1.1.7 1.7.9V24h6v-3.6c.6-.2 1.2-.5 1.7-.9 1.37-1.09 2.3-2.8 2.3-5.5h-2c0 2.76-1.04 3.55-1.52 3.94zM23 4.25v3.49c0 .8-.88 1.26-1.56.83-.14-.09-.28-.18-.44-.26L19 13h-2l-1.5-6.28a27.852 27.852 0 00-7 0L7 13H5L3 8.31c-.16.08-.3.17-.44.26C1.88 9 1 8.55 1 7.74V4.25C1 1.9 5.92 0 12 0s11 1.9 11 4.25zM6.9 6.98c-.93.19-1.78.43-2.53.71l1.51 3.55L6.9 6.98zm12.73.71c-.75-.28-1.6-.52-2.53-.71l1.02 4.25 1.51-3.54zM21 4.31C20.65 3.63 17.57 2 12 2S3.35 3.63 3 4.31v1.77C5.34 5.07 8.56 4.5 12 4.5s6.66.57 9 1.58V4.31z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$af11fda4bfb3ba4e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l.59-.65L9.88 4h4.24l1.24 1.35.59.65H20v12zM9 12c0-1.66 1.34-3 3-3h3.98c-.92-1.21-2.35-2-3.98-2a5.002 5.002 0 00-4.9 6h2.08c-.11-.31-.18-.65-.18-1zm6 0c0 1.66-1.34 3-3 3H8.02c.92 1.21 2.35 2 3.98 2a5.002 5.002 0 004.9-6h-2.08c.11.31.18.65.18 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3407926dd5c6463a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.67 13.13C18.04 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.57-3.47-6.33-3.87zM15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24a5.98 5.98 0 010 7.52c.42.14.86.24 1.33.24zM9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM9 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H3v-.99C3.2 16.29 6.3 15 9 15s5.8 1.29 6 2v1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$cccf7ad2562d4788(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$affa6d7bc7ac4802(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$984d89c317abc05c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM18 18H6v-.78c0-.38.2-.72.52-.88C7.71 15.73 9.63 15 12 15c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V18zM9.78 12h4.44c1.21 0 2.14-1.06 1.98-2.26l-.32-2.45C15.57 5.39 13.92 4 12 4S8.43 5.39 8.12 7.29L7.8 9.74c-.16 1.2.77 2.26 1.98 2.26zm.32-4.41C10.26 6.67 11.06 6 12 6s1.74.67 1.9 1.59l.32 2.41H9.78l.32-2.41z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$663def1f25cc31f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM18 18H6v-.78c0-.38.2-.72.52-.88C7.71 15.73 9.63 15 12 15c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V18zM10 12h4c1.66 0 3-1.34 3-3 0-.73-.27-1.4-.71-1.92.13-.33.21-.7.21-1.08a3 3 0 00-1.86-2.77C14 2.48 13.06 2 12 2s-2 .48-2.64 1.23A3 3 0 007.5 6c0 .38.08.75.21 1.08C7.27 7.6 7 8.27 7 9c0 1.66 1.34 3 3 3zm-.76-3.63c.87-1.04.26-2 .26-2.37 0-.41.24-.77.62-.92.29-.12.55-.31.75-.54.17-.21.55-.54 1.13-.54s.96.33 1.13.53c.2.24.46.42.75.54a1 1 0 01.62.93c0 .37-.61 1.33.26 2.37.58.69.04 1.63-.76 1.63h-4c-.8 0-1.34-.94-.76-1.63z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$878ccf874a2a3996(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM18 18H6v-.78c0-.38.2-.72.52-.88C7.71 15.73 9.63 15 12 15c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V18zM12 12c2.21 0 4-1.79 4-4V4.5c0-.83-.67-1.5-1.5-1.5-.52 0-.98.27-1.25.67-.27-.4-.73-.67-1.25-.67s-.98.27-1.25.67c-.27-.4-.73-.67-1.25-.67C8.67 3 8 3.67 8 4.5V8c0 2.21 1.79 4 4 4zm-2-6.5h4V8c0 1.1-.9 2-2 2s-2-.9-2-2V5.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c4ffe9d913edc166(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c0-2.21-1.79-4-4-4S5 5.79 5 8s1.79 4 4 4 4-1.79 4-4zm-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM1 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4zm2 0c.2-.71 3.3-2 6-2 2.69 0 5.78 1.28 6 2H3zm17-3v-3h3v-2h-3V7h-2v3h-3v2h3v3h2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$98db19c5b9da465c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9V6h-2v3h-3v2h3v3h2v-3h3V9h-3zM9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm6.39 8.56C13.71 13.7 11.53 13 9 13s-4.71.7-6.39 1.56A2.97 2.97 0 001 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM15 18H3v-.78c0-.38.2-.72.52-.88C4.71 15.73 6.63 15 9 15c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc1c9aca2a6d0428(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H9zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7519b2d20bc14110(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17.17l-3.37-3.38c.64.22 1.23.48 1.77.76.97.51 1.58 1.52 1.6 2.62zm1.19 4.02l-1.41 1.41-2.61-2.6H4v-2.78c0-1.12.61-2.15 1.61-2.66 1.29-.66 2.87-1.22 4.67-1.45L1.39 4.22 2.8 2.81l18.39 18.38zM15.17 18l-3-3H12c-2.37 0-4.29.73-5.48 1.34-.32.16-.52.5-.52.88V18h9.17zM12 6c1.1 0 2 .9 2 2 0 .86-.54 1.59-1.3 1.87l1.48 1.48a3.999 3.999 0 10-5.53-5.53l1.48 1.48A1.99 1.99 0 0112 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$19ea24216e2dc2c9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.9a2.1 2.1 0 110 4.2 2.1 2.1 0 010-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fa917d390530faee(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4zm-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4zm2 0c.2-.71 3.3-2 6-2 2.69 0 5.77 1.28 6 2H4zM17 10h6v2h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$147b1cb5bd03304d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4zm-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4zm2 0c.2-.71 3.3-2 6-2 2.69 0 5.77 1.28 6 2H4zM17 10h6v2h-6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1416bf05a7bb44bd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e344eb51bbf0d1ad(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm6.39 8.56C16.71 11.7 14.53 11 12 11s-4.71.7-6.39 1.56A2.97 2.97 0 004 15.22V22h2v-6.78c0-.38.2-.72.52-.88C7.71 13.73 9.63 13 12 13c.76 0 1.47.07 2.13.2l-1.55 3.3H9.75C8.23 16.5 7 17.73 7 19.25S8.23 22 9.75 22H18c1.1 0 2-.9 2-2v-4.78c0-1.12-.61-2.15-1.61-2.66zM10.94 20H9.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.89l-.7 1.5zM18 20h-4.85l2.94-6.27c.54.2 1.01.41 1.4.61.31.16.51.5.51.88V20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$671d871d95a3b4b7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.42zM8.25 19H5V7.83l2 2v3.67c0 .55.45 1 1 1h.25V19zm1.5 0v-4.5H10c.46 0 .82-.31.94-.73l3.31 3.31V19h-4.5zM11 8.17L5.83 3H19c1.1 0 2 .9 2 2v13.17l-2-2V5h-2v8.5c0 .19-.07.36-.16.51L13 10.17V5h-2v3.17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$abec41877b3e0b9a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 11.5h.25V19h-4.5v-4.5H10c.55 0 1-.45 1-1V5h2v8.5c0 .55.45 1 1 1zM5 5h2v8.5c0 .55.45 1 1 1h.25V19H5V5zm14 14h-3.25v-4.5H16c.55 0 1-.45 1-1V5h2v14z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ef924e9cabc96f31(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.45 16.52l-3.01-3.01c-.11-.11-.24-.13-.31-.13s-.2.02-.31.13L8.8 16.53c-.34.34-.87.89-2.64.89l3.71 3.7a3 3 0 004.24 0l3.72-3.71c-.91 0-1.67-.18-2.38-.89zM8.8 7.47l3.02 3.02c.08.08.2.13.31.13s.23-.05.31-.13l2.99-2.99c.71-.74 1.52-.91 2.43-.91l-3.72-3.71a3 3 0 00-4.24 0l-3.71 3.7c1.76 0 2.3.58 2.61.89z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.11 9.85l-2.25-2.26H17.6c-.54 0-1.08.22-1.45.61l-3 3c-.28.28-.65.42-1.02.42a1.5 1.5 0 01-1.02-.42L8.09 8.17c-.38-.38-.9-.6-1.45-.6H5.17l-2.29 2.3a3 3 0 000 4.24l2.29 2.3h1.48c.54 0 1.06-.22 1.45-.6l3.02-3.02c.28-.28.65-.42 1.02-.42s.74.14 1.02.42l3.01 3.01c.38.38.9.6 1.45.6h1.26l2.25-2.26a3.042 3.042 0 00-.02-4.29z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$56b9087b18b732d6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8H8v4H4v2h4v4h2v-4h4v-2h-4V8zm4.5-1.92V7.9l2.5-.5V18h2V5l-4.5 1.08z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b6c43ae938642db8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$29d589a66e5bd579(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.93 8.35l-3.6 1.68L14 7.7V6.3l2.33-2.33 3.6 1.68c.38.18.82.01 1-.36.18-.38.01-.82-.36-1l-3.92-1.83a.993.993 0 00-1.13.2L13.78 4.4A.975.975 0 0013 4c-.55 0-1 .45-1 1v1H8.82C8.4 4.84 7.3 4 6 4 4.34 4 3 5.34 3 7c0 1.1.6 2.05 1.48 2.58L7.08 18H6c-1.1 0-2 .9-2 2v1h13v-1c0-1.1-.9-2-2-2h-1.62L8.41 8.77c.17-.24.31-.49.41-.77H12v1c0 .55.45 1 1 1 .32 0 .6-.16.78-.4l1.74 1.74c.3.3.75.38 1.13.2l3.92-1.83c.38-.18.54-.62.36-1a.753.753 0 00-1-.36zM6 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm5.11 10H9.17l-2.46-8h.1l4.3 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9ea81a0683568e48(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.94 9.06C19.5 5.73 16.57 3 13 3 9.47 3 6.57 5.61 6.08 9l-1.93 3.48c-.41.66.07 1.52.85 1.52h1v2c0 1.1.9 2 2 2h1v3h7v-4.68a7.016 7.016 0 003.94-7.26zm-5.05 5.57l-.89.42V19h-3v-3H8v-4H6.7l1.33-2.33C8.21 7.06 10.35 5 13 5c2.76 0 5 2.24 5 5 0 2.09-1.29 3.88-3.11 4.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 12.54c-.41 0-.74.31-.74.73 0 .41.33.74.74.74.42 0 .73-.33.73-.74a.71.71 0 00-.73-.73zM12.5 7c-1.03 0-1.74.67-2 1.45l.96.4c.13-.39.43-.86 1.05-.86.95 0 1.13.89.8 1.36-.32.45-.86.75-1.14 1.26-.23.4-.18.87-.18 1.16h1.06c0-.55.04-.65.13-.82.23-.42.65-.62 1.09-1.27.4-.59.25-1.38-.01-1.8-.31-.49-.9-.88-1.76-.88z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7a76bd8c777882c5(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.82 7.22l-1 .4c-.21-.16-.43-.29-.67-.39L14 6.17c-.02-.1-.1-.17-.2-.17h-1.6c-.1 0-.18.07-.19.17l-.15 1.06c-.24.1-.47.23-.67.39l-1-.4c-.09-.03-.2 0-.24.09l-.8 1.38a.2.2 0 00.05.26l.85.66c-.03.12-.05.26-.05.39s.01.26.03.39l-.84.66a.19.19 0 00-.05.25l.8 1.39c.05.09.15.12.25.09l.99-.4c.21.16.43.29.68.39l.14 1.06c.02.1.1.17.2.17h1.6c.1 0 .18-.07.2-.17l.15-1.06c.24-.1.47-.23.67-.39l.99.4c.09.04.2 0 .24-.09l.8-1.39c.05-.09.03-.19-.05-.25l-.83-.66a2.561 2.561 0 000-.78l.85-.66a.2.2 0 00.05-.26l-.8-1.38c-.05-.09-.16-.12-.25-.09zM13 11.43a1.43 1.43 0 110-2.86 1.43 1.43 0 010 2.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.94 9.06c-.43-3.27-3.23-5.86-6.53-6.05C13.27 3 13.14 3 13 3 9.47 3 6.57 5.61 6.08 9l-1.93 3.48c-.41.66.07 1.52.85 1.52h1v2c0 1.1.9 2 2 2h1v3h7v-4.68a7.016 7.016 0 003.94-7.26zm-5.05 5.57l-.89.42V19h-3v-3H8v-4H6.7l1.33-2.33C8.21 7.06 10.35 5 13 5c2.76 0 5 2.24 5 5 0 2.09-1.29 3.88-3.11 4.63z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$836bd73f1e364f53(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.17L6.49 3.66A9.91 9.91 0 0112 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51l-1.46-1.46A7.842 7.842 0 0020 12c0-3.35-2.07-6.22-5-7.41V5c0 1.1-.9 2-2 2h-2v1.17zm10.19 13.02l-1.41 1.41-2.27-2.27A9.839 9.839 0 0112 22C6.48 22 2 17.52 2 12c0-2.04.61-3.93 1.66-5.51L1.39 4.22 2.8 2.81l18.39 18.38zM11 18c-1.1 0-2-.9-2-2v-1l-4.79-4.79C4.08 10.79 4 11.38 4 12c0 4.08 3.05 7.44 7 7.93V18z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1ac4ecdc599fd769(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-.61.08-1.21.21-1.78L8.99 15v1c0 1.1.9 2 2 2v1.93C7.06 19.43 4 16.07 4 12zm13.89 5.4c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41C17.92 5.77 20 8.65 20 12c0 2.08-.81 3.98-2.11 5.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$fb5194fbf08d7ab8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6.5V14h-2V7.5L14 4 9 7.5V9H7V6.5l7-5 7 5zm-5.5.5h-1v1h1V7zm-2 0h-1v1h1V7zm2 2h-1v1h1V9zm-2 0h-1v1h1V9zm5.5 7h-2c0-1.2-.75-2.28-1.87-2.7L8.97 11H1v11h6v-1.44l7 1.94 8-2.5v-1c0-1.66-1.34-3-3-3zM3 20v-7h2v7H3zm10.97.41L7 18.48V13h1.61l5.82 2.17c.34.13.57.46.57.83 0 0-1.99-.05-2.3-.15l-2.38-.79-.63 1.9 2.38.79c.51.17 1.04.26 1.58.26H19c.39 0 .74.23.9.56l-5.93 1.84z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4c7a84a473282ba3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10h-4.59l.58-3.41v-.2c-.01-.26-.12-.51-.3-.7L12 5l-4.6 5c-.27.26-.42.62-.4 1v5c0 1.1.9 2 2 2h5.5c.56.03 1.08-.29 1.3-.8l2.1-4.9c.08-.15.12-.33.1-.5V11c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$624e03f7e0594b58(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.77 7.15L7.2 4.78l1.03-1.71c.39-.65 1.33-.65 1.72 0l1.48 2.46-1.23 2.06-1 1.62-3.43-2.06zm15.95 5.82l-1.6-2.66-3.46 2L18.87 16H20a2 2 0 002-2c0-.36-.1-.71-.28-1.03zM16 21h1.5a2 2 0 001.79-1.11L20.74 17H16v-2l-4 4 4 4v-2zm-6-4H5.7l-.84 1.41c-.3.5-.32 1.12-.06 1.65.28.57.87.94 1.52.94H10v-4zm-3.88-2.65l1.73 1.04L6.48 9.9 1 11.27l1.7 1.02-.41.69c-.35.59-.38 1.31-.07 1.92l1.63 3.26 2.27-3.81zm10.9-9.21l-1.3-2.17C15.35 2.37 14.7 2 14 2h-3.53l3.12 5.2-1.72 1.03 5.49 1.37 1.37-5.49-1.71 1.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b8d0ed149948a07f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58A6.95 6.95 0 0018 7c-.67 0-1.31.1-1.92.28.58.55.92 1.32.92 2.15V10h5v-.57c0-.81-.48-1.53-1.22-1.85zM6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.92 1.28C7.31 7.1 6.67 7 6 7c-.99 0-1.93.21-2.78.58A2.01 2.01 0 002 9.43V10h5v-.57c0-.83.34-1.6.92-2.15zM10 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0116 9.43V10zm-1 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6h-8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0121 21.43V22zM5 16c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H3v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0111 21.43V22zm1.75-9v-2h-1.5v2H9l3 3 3-3h-2.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$31ef0e4342f9b3a2(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.14l6 2.25v4.7c0 1.19-.23 2.36-.64 3.44l1.51 1.51c.72-1.53 1.13-3.22 1.13-4.95V5l-8-3-5.22 1.96 1.55 1.55L12 4.14zM2.81 2.81L1.39 4.22 4 6.83v4.26c0 5.05 3.41 9.76 8 10.91 1.72-.43 3.28-1.36 4.55-2.62l3.23 3.23 1.41-1.41L2.81 2.81zM12 19.92c-3.45-1.13-6-4.82-6-8.83V8.83l9.14 9.14c-.9.88-1.97 1.57-3.14 1.95z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$41176f2572559d1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12a3.96 3.96 0 00-2.91-3.82l-2.62-.74C13.62 7.19 13 6.39 13 5.5V1H4v15h16v-4zm-2 2H6V3h5v1H9.5c-.28 0-.5.22-.5.5s.22.5.5.5H11l.1 1H9.5c-.28 0-.5.22-.5.5s.22.5.5.5h1.81c.45 1.12 1.4 2.01 2.6 2.36l2.62.73C17.4 10.33 18 11.1 18 12v2zM5 17c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm14-4c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-7-4c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2dbcc3e75fbf97f3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5h2v14h-2V5zm-6 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 001 15.43V16h8v-.57c0-.81-.48-1.53-1.22-1.85zM19 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 0015 15.43V16h8v-.57c0-.81-.48-1.53-1.22-1.85z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$db623fc72f947b23(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 6.5C15.5 5.66 17 4 17 4s1.5 1.66 1.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5zm4 8.5a2.5 2.5 0 002.5-2.5c0-1.67-2.5-4.5-2.5-4.5S17 10.83 17 12.5a2.5 2.5 0 002.5 2.5zM13 14h-2v-2H9v2H7v2h2v2h2v-2h2v-2zm3-2v8c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-8c0-2.97 2.16-5.43 5-5.91V4H7V2h6c1.13 0 2.15.39 2.99 1.01l-1.43 1.43C14.1 4.17 13.57 4 13 4h-2v2.09c2.84.48 5 2.94 5 5.91zm-2 0c0-2.21-1.79-4-4-4s-4 1.79-4 4v8h8v-8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4757c5623b0a5b80(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11V8c4.56-.58 8-3.1 8-6H2c0 2.9 3.44 5.42 8 6v3c-3.68.73-8 3.61-8 11h6v-2H4.13c.93-6.83 6.65-7.2 7.87-7.2s6.94.37 7.87 7.2H16v2h6c0-7.39-4.32-10.27-8-11zm4.87-7C17.5 5.19 15 6.12 12 6.12S6.5 5.19 5.13 4h13.74zM12 22c-1.1 0-2-.9-2-2 0-.55.22-1.05.59-1.41C11.39 17.79 16 16 16 16s-1.79 4.61-2.59 5.41c-.36.37-.86.59-1.41.59z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f7cd7cfbb3af4ad3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a5547d30c537690e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11.33L18 18H6l5-6.67V6h2m2.96-2H8.04c-.42 0-.65.48-.39.81L9 6.5v4.17L3.2 18.4c-.49.66-.02 1.6.8 1.6h16c.82 0 1.29-.94.8-1.6L15 10.67V6.5l1.35-1.69c.26-.33.03-.81-.39-.81z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$dabf3d4605e5af6f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9h-2.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1H18c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-.5 4.5H16v-3h1.5v3zm-8 1.5H5v-2.5c0-.55.45-1 1-1h2v-1H5V9h3.5c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1h-2v1h3V15zm3.25-4h-1.5V9.5h1.5V11zm0 3.5h-1.5V13h1.5v1.5zM22 6v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h3V2h2v2h6V2h2v2h3c1.1 0 2 .9 2 2zm-2 12V6h-7.25v1.5h-1.5V6H4v12h7.25v-1.5h1.5V18H20z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3dfbb7a78fd898fd(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm7.89-2.89l4.53-1.21-.78-2.9-4.53 1.21c-.8.21-1.28 1.04-1.06 1.84.22.8 1.04 1.28 1.84 1.06zM20.5 5.9L23 3l-1-1-3 3-2 4-9.48 2.87c-.82.2-1.39.89-1.5 1.68L5.24 18 2.4 21.8 4 23l3-4 1.14-3.14L14 14l5-3.5 1.5-4.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$205a58dc83de3ec9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16v-2c-2.24 0-4.16-.96-5.6-2.68l-1.34-1.6A1.98 1.98 0 0012.53 9h-1.05c-.59 0-1.15.26-1.53.72l-1.34 1.6C7.16 13.04 5.24 14 3 14v2c2.77 0 5.19-1.17 7-3.25V15l-3.88 1.55c-.67.27-1.12.93-1.12 1.66C5 19.2 5.8 20 6.79 20H9v-.5a2.5 2.5 0 012.5-2.5h3c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.83 0-1.5.67-1.5 1.5v.5h7.21c.99 0 1.79-.8 1.79-1.79 0-.73-.45-1.39-1.12-1.66L14 15v-2.25c1.81 2.08 4.23 3.25 7 3.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5f721ac4cdd2c3d3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5zm-.01-12C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a12489a8abf04b6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 14h6v1.5H9z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$8fddcddcf874c462(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c-1.48 0-2.75-.81-3.45-2H6.88a5.495 5.495 0 0010.24 0h-1.67c-.7 1.19-1.97 2-3.45 2zm-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d2a185ef4d6b7e43(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zm4.17-10C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5ebc0e5d463a00c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12L13 9.94zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11l1.06-1.06zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bc9dd2c017038f1c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.41l4-4L14.59 5 12 7.59V4h-2v3.59L7.41 5 6 6.41l4 4V12H8.41l-4-4L3 9.41 5.59 12H2v2h3.59L3 16.59 4.41 18l4-4H10v1.59l-4 4L7.41 21 10 18.41V22h2v-3.59L14.59 21 16 19.59l-4-4V14h1.59l4 4L19 16.59 16.41 14H20v-2h-8zM19 2h2v5h-2zM19 8h2v2h-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a67e87a531be0f9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6c06d6e3fcb88eb6(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.32 10.56L8.38 9.5 7.32 8.44l1.06-1.06L10.5 9.5l-2.12 2.12-1.06-1.06zM4.5 9c.03 0 .05.01.08.01A8.002 8.002 0 0112 4c2.19 0 4.16.88 5.61 2.3.15-.6.45-1.29.81-1.96A9.965 9.965 0 0011.99 2c-4.88 0-8.94 3.51-9.81 8.14C2.74 9.44 3.59 9 4.5 9zM21 10.5c-.42 0-.82-.09-1.19-.22.12.55.19 1.13.19 1.72 0 4.42-3.58 8-8 8-3.36 0-6.23-2.07-7.42-5.01-.03 0-.05.01-.08.01-.52 0-1.04-.14-1.5-.4-.32-.18-.59-.42-.82-.7.89 4.61 4.93 8.1 9.8 8.1C17.52 22 22 17.52 22 12c0-.55-.06-1.09-.14-1.62a3.5 3.5 0 01-.86.12zM21 3s-2 2.9-2 4 .9 2 2 2 2-.9 2-2-2-4-2-4zm-5.38 4.38L13.5 9.5l2.12 2.12 1.06-1.06-1.06-1.06 1.06-1.06-1.06-1.06zM8.56 17c.69-1.19 1.97-2 3.44-2s2.75.81 3.44 2h1.68c-.8-2.05-2.79-3.5-5.12-3.5-.87 0-1.7.2-2.43.57L5.99 12c0-.52-.26-1.02-.74-1.29-.72-.41-1.63-.17-2.05.55-.41.72-.17 1.63.55 2.05.48.28 1.05.25 1.49 0l2.97 1.72c-.57.53-1.03 1.21-1.33 1.97h1.68z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ec404eb5250c7e8d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.49 13l-.93-1.86c-.37-.74-.07-1.64.67-2.01l.26-.13 5.73 5.46c.5.47.78 1.13.78 1.81v5.23a2.5 2.5 0 01-2.5 2.5h-11c-.55 0-1-.45-1-1s.45-1 1-1H10v-1H4c-.55 0-1-.45-1-1s.45-1 1-1h6v-1H3c-.55 0-1-.45-1-1s.45-1 1-1h7v-1H4.5c-.55 0-1-.45-1-1s.45-1 1-1h7.99zm1.51.2V15h-2v7h4c.55 0 1-.45 1-1v-4.53c0-.27-.11-.54-.31-.73L14 13.2zm-2.22-6.08c-.84.4-1.17.62-1.63 1.19l-2.7-2.85A.996.996 0 118.9 4.09l2.88 3.03zM9.64 9.21a3.46 3.46 0 00-.2 1.79h-.86L6.31 8.61a.987.987 0 01.04-1.41.996.996 0 011.41.04l1.88 1.97zm10.69 4.7l.88-.83c.5-.47.79-1.13.79-1.82V3.35l-.27-.1c-.78-.28-1.64.12-1.92.9l-.71 1.96-5.5-5.8a.996.996 0 10-1.45 1.37l3.79 3.99-.73.69-4.82-5.08a.996.996 0 10-1.45 1.37l3.78 3.98L15.38 9l1.93-1.87 1.38 1.45L20 7.34v3.7c0 .28-.11.54-.31.73l-.7.66.61.58c.29.27.53.57.73.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$bf8ee58791a34010(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-1.1-.9-2-2-2V7c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L6 19h1l.67-2h8.67l.66 2h1l.67-2H20v-5zm-4-2h-3V7h3v3zM8 7h3v3H8V7zm-2 5h12v3H6v-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1551c50c06e77c73(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM7.25 22.5c-.41 0-.75.34-.75.75s.34.75.75.75.75-.34.75-.75-.34-.75-.75-.75zm8.5 0c-.41 0-.75.34-.75.75s.34.75.75.75.75-.34.75-.75-.34-.75-.75-.75zm3.49-3.5a.72.72 0 00-.59.3c-.55.73-1.42 1.2-2.4 1.2H16v-6l-4.32-2.67 1.8-2.89A6.507 6.507 0 0019 12v-2c-1.85 0-3.44-1.12-4.13-2.72l-.52-1.21C14.16 5.64 13.61 5 12.7 5H7L4.5 9l1.7 1.06L8.1 7h2.35l-2.4 3.84c-.31.5-.39 1.11-.21 1.67l1.34 4.15-3.12 3.76c-.7-.16-1.3-.57-1.71-1.12a.749.749 0 10-1.2.9c.82 1.1 2.13 1.8 3.6 1.8h9.5c1.47 0 2.78-.7 3.6-1.8.1-.14.15-.3.15-.45 0-.39-.32-.75-.76-.75zM14 20.5H8.6l2.9-3.5-1-3.3 3.5 2.2v4.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ae08fe5c5152ca78(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm8.8 15.74a4.003 4.003 0 01-5.04 2.57L1 17.36l.46-1.43 3.93 1.28.46-1.43-3.92-1.28.46-1.43L4 13.6V9.5l5.47-2.35c.39-.17.84-.21 1.28-.07.95.31 1.46 1.32 1.16 2.27l-1.05 3.24 2.14-.34c.89-.15 1.76.32 2.14 1.14l2.08 4.51 1.93.63-.46 1.43-3.32-1.08-.47 1.42 3.32 1.08c1.31.43 2.72-.29 3.15-1.61.43-1.31-.29-2.72-1.61-3.15l.46-1.43c2.11.69 3.27 2.95 2.58 5.05zM6 14.25l1.01.33c-.22-.42-.28-.92-.12-1.4L7.92 10 6 10.82v3.43zm7.94 4.16l-6.66-2.16-.46 1.43 6.66 2.16.46-1.43zm.69-1.36l-1.18-2.56-3.97.89 5.15 1.67z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5425d65bc472116f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm7.4 17.09a.748.748 0 00-.64.17c-.69.6-1.64.88-2.6.67L17 20.69l-1-6.19-3.32-2.67 1.8-2.89A6.507 6.507 0 0020 12v-2c-1.85 0-3.44-1.12-4.13-2.72l-.52-1.21C15.16 5.64 14.61 5 13.7 5H8L5.5 9l1.7 1.06L9.1 7h2.35l-2.51 3.99c-.28.45-.37 1-.25 1.52L9.5 16 6 18.35l-.47-.1c-.96-.2-1.71-.85-2.1-1.67a.744.744 0 00-.51-.42c-.43-.09-.82.2-.9.58-.04.14-.02.31.05.46.58 1.24 1.71 2.2 3.15 2.51l12.63 2.69c1.44.31 2.86-.11 3.9-1.01.13-.11.21-.26.24-.41.07-.38-.16-.8-.59-.89zM8.73 18.93l3.02-2.03-.44-3.32 2.84 2.02.75 4.64-6.17-1.31z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d80c96b75b8317d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 3.5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM6.32 19.03l-1.14-1.47L4 18.5l2.38 3.04c.51.65 1.16 1.15 1.88 1.41.28.1.53.04.72-.11.3-.23.42-.7.12-1.07a.84.84 0 00-.31-.22 2.97 2.97 0 01-1.14-.83l-.08-.1L11 18.2l.89-3.22 2.11 2v4.52h-2V23h3.87c.82 0 1.61-.21 2.26-.61.26-.16.37-.39.37-.64 0-.38-.3-.75-.77-.75-.13 0-.26.04-.37.1-.4.23-.87.37-1.36.4v-6.02l-2.11-2 .6-3C15.79 11.98 17.8 13 20 13v-2c-1.9 0-3.51-1.02-4.31-2.42l-1-1.58c-.4-.6-1-1-1.7-1-.75 0-1.41.34-5.99 2.28V13h2V9.58l1.79-.7L9.2 17l-2.88 2.03z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a90e80c6ee7d02ab(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 002 10.43V11h8v-.57c0-.81-.48-1.53-1.22-1.85zM18 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 0014 10.43V11h8v-.57c0-.81-.48-1.53-1.22-1.85zm-2.77 4.43l-1.41 1.41L18.17 16H5.83l1.58-1.59L6 13l-4 4 3.99 3.99 1.41-1.41L5.83 18h12.34l-1.58 1.58L18 20.99 22 17l-3.99-3.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$ed261019f2383aef(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-1.95.7-3.74 1.87-5.13L9 10v1c0 1.1.9 2 2 2v5.59c0 .27.11.52.29.71l.71.7c-4.42 0-8-3.58-8-8zm9 7.94V18l3.75-5.62c.16-.25.25-.54.25-.83V10.5c0-.55-.45-1-1-1h-1.5l-1.4-1.75c-.38-.47-.95-.75-1.56-.75H8V5.07A7.971 7.971 0 0112 4c4.41 0 8 3.59 8 8 0 4.07-3.06 7.44-7 7.94z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7eb79bd81678b6e1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM5.61 16.78C4.6 15.45 4 13.8 4 12s.6-3.45 1.61-4.78a5.975 5.975 0 010 9.56zM12 20c-1.89 0-3.63-.66-5-1.76 1.83-1.47 3-3.71 3-6.24S8.83 7.23 7 5.76C8.37 4.66 10.11 4 12 4s3.63.66 5 1.76c-1.83 1.47-3 3.71-3 6.24s1.17 4.77 3 6.24A7.963 7.963 0 0112 20zm6.39-3.22a5.975 5.975 0 010-9.56C19.4 8.55 20 10.2 20 12s-.6 3.45-1.61 4.78z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$446758288d4fe6c3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM5.23 7.75C6.1 8.62 6.7 9.74 6.91 11H4.07a8.12 8.12 0 011.16-3.25zM4.07 13h2.84a5.972 5.972 0 01-1.68 3.25A8.12 8.12 0 014.07 13zM11 19.93c-1.73-.22-3.29-1-4.49-2.14A7.952 7.952 0 008.93 13H11v6.93zM11 11H8.93A7.99 7.99 0 006.5 6.2 8.035 8.035 0 0111 4.07V11zm8.93 0h-2.84c.21-1.26.81-2.38 1.68-3.25.6.97 1.01 2.07 1.16 3.25zM13 4.07c1.73.22 3.29.99 4.5 2.13a7.99 7.99 0 00-2.43 4.8H13V4.07zm0 15.86V13h2.07a8.006 8.006 0 002.42 4.79A7.988 7.988 0 0113 19.93zm5.77-3.68A6.004 6.004 0 0117.09 13h2.84a8.12 8.12 0 01-1.16 3.25z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a52cb2a27a2f2032(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.04 12.79l-8.5-8.5C6.35 4.1 6.09 4 5.83 4s-.51.1-.7.29L2.29 7.13c-.39.39-.39 1.03 0 1.42l8.5 8.5c.2.2.45.29.71.29.26 0 .51-.1.71-.29l2.83-2.83c.39-.4.39-1.04 0-1.43zm-3.54 2.13L4.41 7.83l1.42-1.42 7.09 7.09-1.42 1.42zM14.341 17.756l1.414-1.414 4.243 4.243-1.414 1.414zM18.5 2C16.57 2 15 3.57 15 5.5S16.57 9 18.5 9 22 7.43 22 5.5 20.43 2 18.5 2zm0 5c-.83 0-1.5-.67-1.5-1.5S17.67 4 18.5 4s1.5.67 1.5 1.5S19.33 7 18.5 7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$798a8d186e94361d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.58 16.09l-1.09-7.66A3.996 3.996 0 0016.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91zm-2.1.72a.54.54 0 01-.42.19c-.15 0-.29-.06-.39-.16L15.83 14H8.17l-2.84 2.84c-.1.1-.24.16-.39.16a.54.54 0 01-.42-.19.52.52 0 01-.13-.44l1.09-7.66C5.63 7.74 6.48 7 7.47 7h9.06c.99 0 1.84.74 1.98 1.72l1.09 7.66c.03.2-.05.34-.12.43z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8H8v2H6v1h2v2h1v-2h2v-1H9z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "9",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9d916cfa0df3f572(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.31 3.69c-.32-.33-1.94-.69-4.05-.69-3.03 0-7.09.75-9.8 3.46-4.59 4.59-3.56 13.06-2.77 13.85.32.33 1.94.69 4.05.69 3.03 0 7.09-.75 9.8-3.46 4.59-4.59 3.56-13.06 2.77-13.85zM7.74 19c-1.14 0-2.02-.12-2.53-.23-.18-.79-.3-2.21-.17-3.83l4.01 4.01c-.52.04-.97.05-1.31.05zm8.39-2.87c-1.33 1.33-3.06 2.05-4.66 2.44l-6.04-6.04c.42-1.68 1.16-3.37 2.45-4.65 1.32-1.32 3.05-2.04 4.64-2.43l6.05 6.05c-.42 1.67-1.17 3.35-2.44 4.63zm2.83-7.04l-4.03-4.03c.52-.05.98-.06 1.33-.06 1.14 0 2.02.12 2.53.23.18.79.3 2.22.17 3.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 14.1l5.6-5.6 1.4 1.4-5.6 5.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2ae2d7b54f3a4a35(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7 3.13 7 7 7zm0-12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "8",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h2c1.1 0 2 .9 2 2v1h2v-1c0-1.1.9-2 2-2h2v-2H7v2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9a561e6439b45f66(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM1 9h6l7-5 1.31 1.52-4.17 2.98H14L21.8 4 23 5.4 14.5 12 14 22h-2l-.5-10L8 11H1V9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6ca11c5ef75a9921(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.27 6c-.55.95-.22 2.18.73 2.73.95.55 2.18.22 2.73-.73.55-.95.22-2.18-.73-2.73-.95-.55-2.18-.22-2.73.73z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.84 10.41l-2.6-1.5c-2.38-1.38-3.2-4.44-1.82-6.82l-1.73-1C8.1 3.83 8.6 7.21 10.66 9.4l-5.15 8.92 1.73 1 1.5-2.6 1.73 1-3 5.2 1.73 1 6.29-10.89a5.002 5.002 0 01.31 5.46l1.73 1c1.6-2.75 1.28-6.58-1.69-9.08zM12.75 3.8c.72.41 1.63.17 2.05-.55.41-.72.17-1.63-.55-2.05a1.501 1.501 0 00-1.5 2.6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4bd3a59f933fab01(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17v3h2v-4H3c-.55 0-1 .45-1 1zM9 16H5v4l4.69-.01c.38 0 .72-.21.89-.55l.87-1.9-1.59-3.48L9 16zM21.71 16.29A.997.997 0 0021 16h-1v4h2v-3c0-.28-.11-.53-.29-.71zM13.6 12.84L17.65 4H14.3l-1.76 3.97-.49 1.1-.05.14L9.7 4H6.35l4.05 8.84 1.52 3.32.08.18 1.42 3.1c.17.34.51.55.89.55L19 20v-4h-4l-1.4-3.16z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$d52b8fe11ec43baa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "2.38",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 11.88v-4.7l-5.05-2.14c-.97-.41-2.09-.06-2.65.84l-1 1.6c-.67 1.18-1.91 2.06-3.41 2.32l.06.06c.69.69 1.52 1.07 2.46 1.17.8-.42 1.52-.98 2.09-1.64l.6 3-1.16 1.1-.94.89v7.5h2v-6l2.1-2 1.8 8H23l-2.18-11-.62-3.1 1.8.7v3.4h2zM10.29 8.09c.22.15.47.24.72.29.13.02.25.04.38.04s.26-.01.38-.04c.13-.02.25-.06.37-.11.24-.1.47-.24.66-.44.49-.49.67-1.17.55-1.8-.07-.37-.25-.74-.55-1.03-.19-.19-.42-.34-.66-.44-.12-.05-.24-.09-.37-.11s-.25-.04-.38-.04c-.12 0-.23.01-.35.03-.14.02-.28.06-.41.11-.23.11-.46.26-.65.45-.3.29-.48.66-.55 1.03-.12.63.06 1.31.55 1.8.09.1.2.18.31.26z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.24 10.56l-2-2c-.1-.1-.2-.18-.31-.26a1.93 1.93 0 00-.72-.28c-.13-.03-.25-.04-.38-.04-.51 0-1.02.2-1.41.59l-3.34 3.34c-.41.41-.62.98-.58 1.54 0 .18.04.37.11.55l1.07 2.95-3.63 3.63L1.46 22l4.24-4.24v-2.22L7 16.75v5.13h2v-6l-2.12-2.12 2.36-2.36.71.71c1.29 1.26 2.97 2.04 5.03 2.04l-.14-2.07c-1.5-.02-2.7-.62-3.6-1.52z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6ab57e77597e20f(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.8 2l-8.2 6.7-1.21-1.04 3.6-2.08L9.41 1 8 2.41l2.74 2.74L5 8.46l-1.19 4.29L6.27 17 8 16l-2.03-3.52.35-1.3L9.5 13l.5 9h2l.5-10L21 3.4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "5",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$6b3e3c0f0098df96(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-3H7v3zM18 7c-.55 0-1 .45-1 1V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v5.8c0 .13.01.26.04.39l.8 4c.09.47.5.8.98.8H17c.55 0 1.09-.44 1.2-.98l.77-3.83c.02-.12.03-.25.03-.38V8c0-.55-.45-1-1-1zm-1 3.6c0 .13-.64 3.4-.64 3.4H7.64S7 10.74 7 10.6V5h8v5h2v.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h6v3H8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9bb0ee9ef38b535a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.96 11.22C21.57 7.01 17.76 4 13.56 4c-.19 0-.38.01-.57.02C2 4.74 2 17.2 2 17.2v.8c0 1.1.9 2 2 2h10c4.67 0 8.41-4.01 7.96-8.78zm-16.7.34c.57-1.29 1.28-2.35 2.14-3.19l3.62 1.53c.6.25.98.83.98 1.48 0 .89-.72 1.61-1.61 1.61H4.72c.15-.46.32-.94.54-1.43zm13.18 4.48A6.022 6.022 0 0114 18H4v-.8c0-.02.01-.92.24-2.2h6.15c1.99 0 3.61-1.62 3.61-3.61 0-1.45-.87-2.76-2.2-3.32L9.3 7.01c1.1-.57 2.37-.9 3.82-.99.15-.02.3-.02.44-.02 3.31 0 6.13 2.37 6.41 5.41.16 1.72-.38 3.36-1.53 4.63z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$baebdb5adede4c09(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.49 3.51c-.56-.56-2.15-.97-4.16-.97-3.08 0-7.15.96-9.98 3.79-4.69 4.7-4.25 12.74-2.84 14.16.56.56 2.15.97 4.16.97 3.08 0 7.15-.96 9.98-3.79 4.69-4.7 4.25-12.74 2.84-14.16zM5.71 18.29c.63-1.89 2.16-4.99 4.87-7.7 2.68-2.68 5.78-4.23 7.7-4.88-.63 1.89-2.16 4.99-4.88 7.7-2.66 2.68-5.76 4.23-7.69 4.88zM7.76 7.76c2.64-2.64 6.34-3.12 8.03-3.19-2.05.94-4.46 2.46-6.61 4.61a23.206 23.206 0 00-4.61 6.63c.09-2.48.87-5.74 3.19-8.05zm8.48 8.48c-2.64 2.64-6.34 3.12-8.03 3.19 2.05-.94 4.46-2.46 6.61-4.61 2.16-2.16 3.67-4.58 4.62-6.63-.1 2.48-.88 5.74-3.2 8.05z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a27e563dac546916(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 3.3l1.35-.95a8.01 8.01 0 014.38 3.34l-.39 1.34-1.35.46L13 6.7V5.3zm-3.35-.95L11 5.3v1.4L7.01 9.49l-1.35-.46-.39-1.34a8.103 8.103 0 014.38-3.34zM7.08 17.11l-1.14.1A7.938 7.938 0 014 12c0-.12.01-.23.02-.35l1-.73 1.38.48 1.46 4.34-.78 1.37zm7.42 2.48c-.79.26-1.63.41-2.5.41s-1.71-.15-2.5-.41l-.69-1.49.64-1.1h5.11l.64 1.11-.7 1.48zM14.27 15H9.73l-1.35-4.02L12 8.44l3.63 2.54L14.27 15zm3.79 2.21l-1.14-.1-.79-1.37 1.46-4.34 1.39-.47 1 .73c.01.11.02.22.02.34 0 1.99-.73 3.81-1.94 5.21z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$1e8bc35e646714de(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.52 2.49C17.18.15 12.9.62 9.97 3.55c-1.6 1.6-2.52 3.87-2.54 5.46-.02 1.58.26 3.89-1.35 5.5l-4.24 4.24 1.42 1.42 4.24-4.24c1.61-1.61 3.92-1.33 5.5-1.35s3.86-.94 5.46-2.54c2.92-2.93 3.4-7.21 1.06-9.55zm-9.2 9.19c-1.53-1.53-1.05-4.61 1.06-6.72s5.18-2.59 6.72-1.06c1.53 1.53 1.05 4.61-1.06 6.72s-5.18 2.59-6.72 1.06zM18 17c.53 0 1.04.21 1.41.59.78.78.78 2.05 0 2.83-.37.37-.88.58-1.41.58s-1.04-.21-1.41-.59c-.78-.78-.78-2.05 0-2.83.37-.37.88-.58 1.41-.58m0-2a3.998 3.998 0 00-2.83 6.83c.78.78 1.81 1.17 2.83 1.17a3.998 3.998 0 002.83-6.83A3.998 3.998 0 0018 15z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7ab42d350f4badc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 2.07c3.07.38 5.57 2.52 6.54 5.36L13 5.65V4.07zM8 5.08c1.18-.69 3.33-1.06 3-1.02v7.35l-3 1.73V5.08zM4.63 15.1c-.4-.96-.63-2-.63-3.1 0-2.02.76-3.86 2-5.27v7.58l-1.37.79zm1.01 1.73L12 13.15l3 1.73-6.98 4.03a7.794 7.794 0 01-2.38-2.08zM12 20c-.54 0-1.07-.06-1.58-.16l6.58-3.8 1.36.78C16.9 18.75 14.6 20 12 20zm1-8.58V7.96l7 4.05c0 1.1-.23 2.14-.63 3.09L13 11.42z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$aef6fa4ad6026cd7(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.23 6c-1.66 0-3.22.66-4.36 1.73C6.54 6.73 5.61 6 4.5 6a2.5 2.5 0 000 5c.21 0 .41-.03.61-.08-.05.25-.09.51-.1.78a6.006 6.006 0 006.68 6.27c2.55-.28 4.68-2.26 5.19-4.77.15-.71.15-1.4.06-2.06-.09-.6.38-1.13.99-1.13H22V6H11.23zM4.5 9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm6.5 6c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "12",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$431a214ca213c00(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 23c-1.03 0-2.06-.25-3-.75-1.89 1-4.11 1-6 0-1.89 1-4.11 1-6 0-.95.5-1.97.75-3 .75H2v-2h1c1.04 0 2.08-.35 3-1 1.83 1.3 4.17 1.3 6 0 1.83 1.3 4.17 1.3 6 0 .91.65 1.96 1 3 1h1v2h-1zM17 1.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-2.57 6.98L12.18 10 16 13v3.84c.53.38 1.03.78 1.49 1.17-.68.58-1.55.99-2.49.99-1.2 0-2.27-.66-3-1.5-.73.84-1.8 1.5-3 1.5-.33 0-.65-.05-.96-.14C5.19 16.9 3 14.72 3 13.28 3 12.25 4.01 12 4.85 12c.98 0 2.28.31 3.7.83l-.53-3.1c-.11-.67.18-1.38.78-1.79l2.15-1.45-2-.37-2.82 1.93L5 6.4 8.5 4l5.55 1.03c.45.09.93.37 1.22.89l.88 1.55A5.007 5.007 0 0020.5 10v2a7.01 7.01 0 01-6.07-3.52zM10.3 11.1l.44 2.65c.92.42 2.48 1.27 3.26 1.75V14l-3.7-2.9z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d443a5eb300840d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6-5H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-9.31 14a5.977 5.977 0 016.62 0h-6.62zm9.31-.27C18.53 14.06 16.4 13 14 13s-4.53 1.06-6 2.73V4h12v11.73z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4f57ee56e8baf4b8(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.58-6.59c.37-.36.59-.86.59-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L11.77 14H3v-2l3-7h9v10zm4-12h4v12h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$35b0f7bef149a06d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2zm0 4l-3 7H9V9l4.34-4.34L12.23 10H21v2zM1 9h4v12H1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$797fb860a2d2b61e(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.92 7.02C17.45 4.18 14.97 2 12 2 9.82 2 7.83 3.18 6.78 5.06 4.09 5.41 2 7.74 2 10.5 2 13.53 4.47 16 7.5 16h10c2.48 0 4.5-2.02 4.5-4.5a4.5 4.5 0 00-4.08-4.48zM17.5 14h-10C5.57 14 4 12.43 4 10.5a3.51 3.51 0 013.04-3.46l.99-.13.49-.87A3.998 3.998 0 0112 4c1.94 0 3.63 1.44 3.95 3.35l.25 1.52 1.54.14c1.27.12 2.26 1.21 2.26 2.49a2.5 2.5 0 01-2.5 2.5zM14.8 17l-2.9 3.32 2 1L11.55 24h2.65l2.9-3.32-2-1L17.45 17zM8.8 17l-2.9 3.32 2 1L5.55 24H8.2l2.9-3.32-2-1L11.45 17z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f0d0d36bd5bd8e1b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 3H1l11 19L23 3zm-3.47 2l-1.74 3H6.21L4.47 5h15.06zm-9.27 10h3.48L12 18.01 10.26 15zm4.64-2H9.1l-1.74-3h9.27l-1.73 3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$833f58c641d97874(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c1.93 0 3.5 1.57 3.5 3.5S13.93 15 12 15s-3.5-1.57-3.5-3.5S10.07 8 12 8zm4.53.38l3.97-3.96V7h2V1h-6v2h2.58l-3.97 3.97C14.23 6.36 13.16 6 12 6s-2.23.36-3.11.97l-.65-.65 1.41-1.41-1.41-1.42L6.82 4.9 4.92 3H7.5V1h-6v6h2V4.42l1.91 1.9-1.42 1.42L5.4 9.15l1.41-1.41.65.65c-.6.88-.96 1.95-.96 3.11a5.5 5.5 0 004.5 5.41V19H9v2h2v2h2v-2h2v-2h-2v-2.09a5.5 5.5 0 003.53-8.53z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b6d7f771ada5e32d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3 16.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S11 12 11 14.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l3.2 3.2 1.4-1.4-3.2-3.2zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zM12 20v2C6.48 22 2 17.52 2 12S6.48 2 12 2c4.84 0 8.87 3.44 9.8 8h-2.07A8 8 0 0015 4.59V5c0 1.1-.9 2-2 2h-2v2c0 .55-.45 1-1 1H8v2h2v3H9l-4.79-4.79C4.08 10.79 4 11.38 4 12c0 4.41 3.59 8 8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f025abac7394ba72(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.67 17.63c-3.8 2.8-6.12.4-6.67 0-.66.49-2.92 2.76-6.67 0C3.43 19.03 2.65 19 2 19v2c1.16 0 2.3-.32 3.33-.93a6.535 6.535 0 006.67 0 6.535 6.535 0 006.67 0c1.03.61 2.17.93 3.33.93v-2c-.66 0-1.5-.02-3.33-1.37zM19.33 12H22v-2h-2.67C17.5 10 16 8.5 16 6.67c0-1.02.38-1.74 1.09-3.34-1.37-.21-2-.33-3.09-.33C7.36 3 2.15 8.03 2.01 14.5l-.01 2c1.16 0 2.3-.32 3.33-.93a6.535 6.535 0 006.67 0 6.535 6.535 0 006.67 0c1.03.61 2.17.93 3.33.93v-2c-.66 0-1.5-.02-3.33-1.37-3.8 2.8-6.12.4-6.67 0-.9.67-.54.41-.91.63-.7-.94-1.09-2.06-1.09-3.26 0-2.58 1.77-4.74 4.21-5.33-.13.51-.21 1.02-.21 1.5C14 9.61 16.39 12 19.33 12zm-14 1.13c-.62.46-.82.63-1.3.87.27-3.53 2.38-6.48 5.43-7.96A7.49 7.49 0 008 10.5c0 1.42.4 2.77 1.13 3.95-.72.07-1.79.15-3.8-1.32z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e947868b815e597d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5.5H8V4h.5c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1H6v1.5H3c-.55 0-1 .45-1 1s.45 1 1 1V15c0 1.1.9 2 2 2h1v4l2 1.5V17h1c1.1 0 2-.9 2-2V7.5c.55 0 1-.45 1-1s-.45-1-1-1zM9 9H7.25c-.41 0-.75.34-.75.75s.34.75.75.75H9V12H7.25c-.41 0-.75.34-.75.75s.34.75.75.75H9V15H5V7.5h4V9zm10.5 1.5V10c.55 0 1-.45 1-1s-.45-1-1-1h-5c-.55 0-1 .45-1 1s.45 1 1 1v.5c0 .5-1.5 1.16-1.5 3V20c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-6.5c0-1.84-1.5-2.5-1.5-3zm-3 0V10h1v.5c0 1.6 1.5 2 1.5 3v.5h-4v-.5c0-1 1.5-1.4 1.5-3zm2.5 5V17h-4v-1.5h4zM15 20v-1.5h4V20h-4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$a9ec2a4eed0f5109(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-7l-2 5H6l-4 9h20L18 8zM7.3 15h3.05l.5-1.26 1.5-3.74h4.14l2.86 10H5.08l2.22-5zM13 1h2v4h-2zM16.121 5.468L18.95 2.64l1.414 1.414-2.829 2.828zM7.64 4.05l1.414-1.414 2.828 2.828-1.414 1.415z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$7242301c7df894fa(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4H6C3.79 4 2 5.79 2 8v8c0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zm-1.86 9.77c-.24.2-.57.28-.88.2L4.15 11.25C4.45 10.52 5.16 10 6 10h12c.67 0 1.26.34 1.63.84l-3.49 2.93zM6 6h12c1.1 0 2 .9 2 2v.55c-.59-.34-1.27-.55-2-.55H6c-.73 0-1.41.21-2 .55V8c0-1.1.9-2 2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3731c93b4be28683(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zm0 18c-3.35 0-6-2.57-6-6.2 0-2.34 1.95-5.44 6-9.14 4.05 3.7 6 6.79 6 9.14 0 3.63-2.65 6.2-6 6.2zm-4.17-6c.37 0 .67.26.74.62.41 2.22 2.28 2.98 3.64 2.87.43-.02.79.32.79.75 0 .4-.32.73-.72.75-2.13.13-4.62-1.09-5.19-4.12a.75.75 0 01.74-.87z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$9edb34b776e157ab(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.03 4.95L3.49 8.49c-3.32 3.32-3.32 8.7 0 12.02s8.7 3.32 12.02 0l6.01-6.01a2.517 2.517 0 00-.39-3.86l.39-.39c.97-.97.97-2.56 0-3.54-.16-.16-.35-.3-.54-.41a2.497 2.497 0 00-3.72-3.05 2.517 2.517 0 00-3.88-.42l-2.51 2.51a2.493 2.493 0 00-3.84-.39zm1.41 1.42c.2-.2.51-.2.71 0 .2.2.2.51 0 .71l-3.18 3.18a3 3 0 010 4.24l1.41 1.41a5.004 5.004 0 001.12-5.36l6.3-6.3c.2-.2.51-.2.71 0s.2.51 0 .71l-4.6 4.6 1.41 1.41 6.01-6.01c.2-.2.51-.2.71 0 .2.2.2.51 0 .71l-6.01 6.01 1.41 1.41 4.95-4.95c.2-.2.51-.2.71 0 .2.2.2.51 0 .71l-5.66 5.66 1.41 1.41 3.54-3.54c.2-.2.51-.2.71 0 .2.2.2.51 0 .71l-6 6.01c-2.54 2.54-6.65 2.54-9.19 0s-2.54-6.65 0-9.19l3.53-3.54zM23 17c0 3.31-2.69 6-6 6v-1.5c2.48 0 4.5-2.02 4.5-4.5H23zM1 7c0-3.31 2.69-6 6-6v1.5C4.52 2.5 2.5 4.52 2.5 7H1z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$f557d640bdc6d554(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.05 4.91A9.816 9.816 0 0012.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01zm-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.264 8.264 0 01-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 012.41 5.83c.02 4.54-3.68 8.23-8.22 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$4d8a5d8f645847b3(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.57 13.16c-1.36.28-2.17 1.16-2.17 2.41 0 1.34 1.11 2.42 2.49 2.42 2.05 0 3.71-1.66 3.71-3.71 0-1.07-.15-2.12-.46-3.12-.79 1.07-2.2 1.72-3.57 2zM13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM12 20c-3.31 0-6-2.69-6-6 0-1.53.3-3.04.86-4.43a5.582 5.582 0 003.97 1.63c2.66 0 4.75-1.83 5.28-4.43A14.77 14.77 0 0118 14c0 3.31-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c275526ec255a652(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.94 8.31C13.62 7.52 12.85 7 12 7s-1.62.52-1.94 1.31L7 16h3.5v6h3v-6H17l-3.06-7.69z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$50b755c4f83f713d(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.94 8.31C13.62 7.52 12.85 7 12 7s-1.62.52-1.94 1.31L7 16h3v6h4v-6h3l-3.06-7.69z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3542356cc1aab694(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.68 13.69L12 11.93l2.31 1.76-.88-2.85L15.75 9h-2.84L12 6.19 11.09 9H8.25l2.31 1.84-.88 2.85zM20 10c0-4.42-3.58-8-8-8s-8 3.58-8 8c0 2.03.76 3.87 2 5.28V23l6-2 6 2v-7.72A7.96 7.96 0 0020 10zm-8-6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm0 15l-4 1.02v-3.1c1.18.68 2.54 1.08 4 1.08s2.82-.4 4-1.08v3.1L12 19z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3622f417e90bad60(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$128d73d69f307e8b(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$5a6fd701943c9dbc(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 11h10v2H7z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$c509cb0240559ff9(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "5"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3e50eee3c36b3bd1(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$96d373b67f89e7fb(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$3a60fe4985601635(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$65c37bbb0ffd9b5c(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b86c667cc3098069(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$e096436357df9d97(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$b9af1939f47f667a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$2e80b5e15d480775(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zM7 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function $37dc6de0ae62a101$export$406ce6248daaad5a(props) {
    return (0, $88a9a4518753b77c$exports.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zm0-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}


const $bd664d6ef1f52408$export$9bd698419030e459 = ({ movieData: movieData , token: token , user: user , favoriteMovies: favoriteMovies , setFavoriteMovies: setFavoriteMovies  })=>{
    const [color, setColor] = (0, $acw62.useState)(false);
    const isFavorite = favoriteMovies.includes(movieData);
    (0, $acw62.useEffect)(()=>{
        setColor(isFavorite);
        console.log("effect activated");
    }, [
        favoriteMovies
    ]);
    const toggleFavorite = ()=>{
        if (isFavorite) {
            console.log("already favorited");
            console.log(movieData);
            const updatedFavorites = favoriteMovies.filter((favMovie)=>favMovie !== movieData);
            setFavoriteMovies(updatedFavorites);
            fetch(`https://mymovielist-api-dhqp.onrender.com/users/${user.username}/movies/${movieData.id}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response)=>response.json()).then((data)=>{
                console.log(data);
                if (data) localStorage.setItem("user", JSON.stringify(data));
                else alert("Failed to remove to favorites");
            }).catch((error)=>{
                alert(error.message);
            });
        } else {
            console.log("not favorited");
            console.log(movieData);
            setFavoriteMovies([
                ...favoriteMovies,
                movieData
            ]);
            fetch(`https://mymovielist-api-dhqp.onrender.com/users/${user.username}/movies/${movieData.id}`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response)=>response.json()).then((data)=>{
                console.log(data);
                if (data) localStorage.setItem("user", JSON.stringify(data));
                else alert("Failed to add to favorites");
            }).catch((error)=>{
                alert(error.message);
            });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
        xs: 12,
        sm: 6,
        md: 4,
        lg: 3,
        className: "p-3",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039), {
            className: " h-100",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                    variant: color ? "danger" : "secondary",
                    onClick: toggleFavorite,
                    className: "rounded-2 position-absolute m-2",
                    children: color ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37dc6de0ae62a101$export$57ca8b8d7b232624), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37dc6de0ae62a101$export$b708bb50e77a2536), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Img, {
                    variant: "top",
                    src: movieData.image
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Body, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Title, {
                            children: movieData.title
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Text, {
                            children: movieData.director
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: `/movies/${encodeURIComponent(movieData.id)}`,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                        variant: "primary",
                        className: "rounded-0 rounded-bottom w-100",
                        children: "Open"
                    })
                })
            ]
        }, movieData.id)
    });
};
// Here is where we define all the props constraints for the MovieCard
$bd664d6ef1f52408$export$9bd698419030e459.propTypes = {
    movieData: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
        genre: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
        director: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired
    }).isRequired
};


//Change in MovieDetails

parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $49d9d24d620fa26d$var$Container = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , fluid: fluid = false , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div" , className: className , ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "container");
    const suffix = typeof fluid === "string" ? `-${fluid}` : "-fluid";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$49d9d24d620fa26d$var$Container.displayName = "Container";
var $49d9d24d620fa26d$export$2e2bcd8739ae039 = $49d9d24d620fa26d$var$Container;



const $e5ff383576b0e9ff$export$78d497080ea8f89a = ({ movies: movies , user: user , movieData: movieData , token: token  })=>{
    const { movieId: movieId  } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const movie = movies.find((b)=>b.id === movieId);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
        md: 8,
        className: "mt-5 mb-5 mx-auto",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
            className: "rounded",
            style: {
                background: "#242846",
                color: "#eaebf2"
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "buttons",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                        to: `/`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                            variant: "danger",
                            className: "mt-3",
                            style: {
                                width: "20%"
                            },
                            children: "Back"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: movie.image,
                        alt: "movie image",
                        className: "w-50 d-block mx-auto p-3"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "movietext p-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "bold",
                                    children: "Title: "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: movie.title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "bold",
                                    children: "Description: "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: movie.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "bold",
                                    children: "Genre: "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: movie.genre
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "bold",
                                    children: "Director: "
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: movie.director
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $1c272c8c9427e0c0$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).elementType
};
const $1c272c8c9427e0c0$var$Feedback = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = "div" , className: className , type: type = "valid" , tooltip: tooltip = false , ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, `${type}-${tooltip ? "tooltip" : "feedback"}`)
    }));
$1c272c8c9427e0c0$var$Feedback.displayName = "Feedback";
$1c272c8c9427e0c0$var$Feedback.propTypes = $1c272c8c9427e0c0$var$propTypes;
var $1c272c8c9427e0c0$export$2e2bcd8739ae039 = $1c272c8c9427e0c0$var$Feedback;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// TODO
const $870809e0939c9f82$var$FormContext = /*#__PURE__*/ $acw62.createContext({});
var $870809e0939c9f82$export$2e2bcd8739ae039 = $870809e0939c9f82$var$FormContext;




const $7164fecb4f365c4a$var$FormCheckInput = /*#__PURE__*/ $acw62.forwardRef(({ id: id , bsPrefix: bsPrefix , className: className , type: type = "checkbox" , isValid: isValid = false , isInvalid: isInvalid = false , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input" , ...props }, ref)=>{
    const { controlId: controlId  } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-check-input");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, isValid && "is-valid", isInvalid && "is-invalid")
    });
});
$7164fecb4f365c4a$var$FormCheckInput.displayName = "FormCheckInput";
var $7164fecb4f365c4a$export$2e2bcd8739ae039 = $7164fecb4f365c4a$var$FormCheckInput;




var $acw62 = parcelRequire("acw62");



const $b0aba1aace6996b7$var$FormCheckLabel = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , className: className , htmlFor: htmlFor , ...props }, ref)=>{
    const { controlId: controlId  } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-check-label");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix)
    });
});
$b0aba1aace6996b7$var$FormCheckLabel.displayName = "FormCheckLabel";
var $b0aba1aace6996b7$export$2e2bcd8739ae039 = $b0aba1aace6996b7$var$FormCheckLabel;





var $acw62 = parcelRequire("acw62");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $d3ae4136892dd278$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $acw62.Children.map(children, (child)=>/*#__PURE__*/ $acw62.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $d3ae4136892dd278$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $acw62.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $d3ae4136892dd278$export$500fd6099226ffae(children, type) {
    return $acw62.Children.toArray(children).some((child)=>/*#__PURE__*/ $acw62.isValidElement(child) && child.type === type);
}



const $87df01720ec94e93$var$FormCheck = /*#__PURE__*/ $acw62.forwardRef(({ id: id , bsPrefix: bsPrefix , bsSwitchPrefix: bsSwitchPrefix , inline: inline = false , reverse: reverse = false , disabled: disabled = false , isValid: isValid = false , isInvalid: isInvalid = false , feedbackTooltip: feedbackTooltip = false , feedback: feedback , feedbackType: feedbackType , className: className , style: style , title: title = "" , type: type = "checkbox" , label: label , children: children , as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = "input" , ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-check");
    bsSwitchPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsSwitchPrefix, "form-switch");
    const { controlId: controlId  } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    const innerFormContext = (0, $acw62.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $d3ae4136892dd278$export$500fd6099226ffae)(children, (0, $b0aba1aace6996b7$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7164fecb4f365c4a$export$2e2bcd8739ae039), {
        ...props,
        type: type === "switch" ? "checkbox" : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870809e0939c9f82$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === "switch" && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0aba1aace6996b7$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c272c8c9427e0c0$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$87df01720ec94e93$var$FormCheck.displayName = "FormCheck";
var $87df01720ec94e93$export$2e2bcd8739ae039 = Object.assign($87df01720ec94e93$var$FormCheck, {
    Input: (0, $7164fecb4f365c4a$export$2e2bcd8739ae039),
    Label: (0, $b0aba1aace6996b7$export$2e2bcd8739ae039)
});




var $acw62 = parcelRequire("acw62");
var $ebfc6adce9fdacf8$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ebfc6adce9fdacf8$exports = $ebfc6adce9fdacf8$var$warning;






const $3023ede31d3d1660$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , type: type , size: size , htmlSize: htmlSize , id: id , className: className , isValid: isValid = false , isInvalid: isInvalid = false , plaintext: plaintext , readOnly: readOnly , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input" , ...props }, ref)=>{
    const { controlId: controlId  } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-control");
    let classes;
    if (plaintext) classes = {
        [`${bsPrefix}-plaintext`]: true
    };
    else classes = {
        [bsPrefix]: true,
        [`${bsPrefix}-${size}`]: size
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, classes, isValid && `is-valid`, isInvalid && `is-invalid`, type === "color" && `${bsPrefix}-color`)
    });
});
$3023ede31d3d1660$var$FormControl.displayName = "FormControl";
var $3023ede31d3d1660$export$2e2bcd8739ae039 = Object.assign($3023ede31d3d1660$var$FormControl, {
    Feedback: $1c272c8c9427e0c0$export$2e2bcd8739ae039
});



var $3d8877fa5535421d$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("form-floating");



var $acw62 = parcelRequire("acw62");


const $5d8599dc34b64b39$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(({ controlId: controlId , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div" , ...props }, ref)=>{
    const context = (0, $acw62.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870809e0939c9f82$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$5d8599dc34b64b39$var$FormGroup.displayName = "FormGroup";
var $5d8599dc34b64b39$export$2e2bcd8739ae039 = $5d8599dc34b64b39$var$FormGroup;




var $acw62 = parcelRequire("acw62");





const $5d7439d74bf97ebc$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "label" , bsPrefix: bsPrefix , column: column = false , visuallyHidden: visuallyHidden = false , className: className , htmlFor: htmlFor , ...props }, ref)=>{
    const { controlId: controlId  } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-label");
    let columnClass = "col-form-label";
    if (typeof column === "string") columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, visuallyHidden && "visually-hidden", column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
$5d7439d74bf97ebc$var$FormLabel.displayName = "FormLabel";
var $5d7439d74bf97ebc$export$2e2bcd8739ae039 = $5d7439d74bf97ebc$var$FormLabel;




var $acw62 = parcelRequire("acw62");



const $b91a225b00146fdd$var$FormRange = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , className: className , id: id , ...props }, ref)=>{
    const { controlId: controlId  } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-range");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$b91a225b00146fdd$var$FormRange.displayName = "FormRange";
var $b91a225b00146fdd$export$2e2bcd8739ae039 = $b91a225b00146fdd$var$FormRange;




var $acw62 = parcelRequire("acw62");



const $7b27958f5a457ab6$var$FormSelect = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , size: size , htmlSize: htmlSize , className: className , isValid: isValid = false , isInvalid: isInvalid = false , id: id , ...props }, ref)=>{
    const { controlId: controlId  } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-select");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$7b27958f5a457ab6$var$FormSelect.displayName = "FormSelect";
var $7b27958f5a457ab6$export$2e2bcd8739ae039 = $7b27958f5a457ab6$var$FormSelect;




var $acw62 = parcelRequire("acw62");


const $bd2be22fa282ca4a$var$FormText = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix , className: className , as: Component = "small" , muted: muted , ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-text");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, muted && "text-muted")
    });
});
$bd2be22fa282ca4a$var$FormText.displayName = "FormText";
var $bd2be22fa282ca4a$export$2e2bcd8739ae039 = $bd2be22fa282ca4a$var$FormText;



var $acw62 = parcelRequire("acw62");


const $fbd36a2b679cb998$var$Switch = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87df01720ec94e93$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$fbd36a2b679cb998$var$Switch.displayName = "Switch";
var $fbd36a2b679cb998$export$2e2bcd8739ae039 = Object.assign($fbd36a2b679cb998$var$Switch, {
    Input: (0, $87df01720ec94e93$export$2e2bcd8739ae039).Input,
    Label: (0, $87df01720ec94e93$export$2e2bcd8739ae039).Label
});




var $acw62 = parcelRequire("acw62");



const $26b7d75a1da62deb$var$FloatingLabel = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , className: className , children: children , controlId: controlId , label: label , ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-floating");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5d8599dc34b64b39$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$26b7d75a1da62deb$var$FloatingLabel.displayName = "FloatingLabel";
var $26b7d75a1da62deb$export$2e2bcd8739ae039 = $26b7d75a1da62deb$var$FloatingLabel;



const $64675cdb3851f16c$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).elementType
};
const $64675cdb3851f16c$var$Form = /*#__PURE__*/ $acw62.forwardRef(({ className: className , validated: validated , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "form" , ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, validated && "was-validated")
    }));
$64675cdb3851f16c$var$Form.displayName = "Form";
$64675cdb3851f16c$var$Form.propTypes = $64675cdb3851f16c$var$propTypes;
var $64675cdb3851f16c$export$2e2bcd8739ae039 = Object.assign($64675cdb3851f16c$var$Form, {
    Group: (0, $5d8599dc34b64b39$export$2e2bcd8739ae039),
    Control: (0, $3023ede31d3d1660$export$2e2bcd8739ae039),
    Floating: (0, $3d8877fa5535421d$export$2e2bcd8739ae039),
    Check: (0, $87df01720ec94e93$export$2e2bcd8739ae039),
    Switch: $fbd36a2b679cb998$export$2e2bcd8739ae039,
    Label: (0, $5d7439d74bf97ebc$export$2e2bcd8739ae039),
    Text: (0, $bd2be22fa282ca4a$export$2e2bcd8739ae039),
    Range: (0, $b91a225b00146fdd$export$2e2bcd8739ae039),
    Select: (0, $7b27958f5a457ab6$export$2e2bcd8739ae039),
    FloatingLabel: $26b7d75a1da62deb$export$2e2bcd8739ae039
});


const $d379e75a95ffce01$export$1582048ca8384970 = ({ onLoggedIn: onLoggedIn  })=>{
    const [username, setUsername] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    // validation of user login
    const handleSubmit = (event)=>{
        // prevents the default behavior of the form which is to reload the entire page
        event.preventDefault();
        const data = {
            username: username,
            password: password
        };
        //link needs to be changed or endpoint to be added
        fetch("https://mymovielist-api-dhqp.onrender.com/login", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        }).then((response)=>response.json()).then((data)=>{
            // console.log("Login response: ", data);
            // console.log(username);
            // console.log(password);
            // console.log(data.user.email);
            // console.log(data.user.birthday);
            // data.user.favoriteMovies.map((movie) => console.log(movie));
            if (data.user) {
                localStorage.setItem("user", JSON.stringify(data.user));
                localStorage.setItem("token", data.token);
                onLoggedIn(data.user, data.token, data.user.favoriteMovies);
            } else alert("No such user");
        }).catch((e)=>{
            alert("Something went wrong");
        });
    };
    // submit form login
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
        xs: 7,
        className: "mx-auto mt-5 p-5 bg-light rounded",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039), {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "text-center fs-1 mb-4",
                    children: "Log in"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                    controlId: "formUsername",
                    className: "m-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                            children: "Username:"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                            style: {
                                "background-color": "#E7F0FE"
                            },
                            type: "text",
                            value: username,
                            minLength: "3",
                            onChange: (e)=>setUsername(e.target.value),
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                    controlId: "formPassword",
                    className: "m-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                            children: "Password:"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                            style: {
                                "background-color": "#E7F0FE"
                            },
                            type: "password",
                            value: password,
                            minLength: "5",
                            onChange: (e)=>setPassword(e.target.value),
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                    class: "d-grid gap-2 col-3 mx-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                        variant: "primary",
                        type: "submit",
                        className: " mt-4",
                        children: "Submit"
                    })
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");

const $ad22dac456f05c19$export$25f3896ea1e09820 = ()=>{
    const [username, setUsername] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    const [email, setEmail] = (0, $acw62.useState)("");
    const [birthday, setBirthday] = (0, $acw62.useState)("");
    const handleSubmit = (event)=>{
        event.preventDefault();
        const data = {
            username: username,
            password: password,
            email: email,
            birthday: birthday
        };
        fetch("https://mymovielist-api-dhqp.onrender.com/users", {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((response)=>{
            if (response.ok) {
                alert("Signup successful");
                window.location.reload();
                window.location.replace("/login");
            } else alert("Signup failed");
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
        xs: 7,
        className: "m-5 mx-auto mt-5 p-5 bg-light rounded",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039), {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "text-center ",
                    children: "Signup"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                    className: "m-4",
                    controlId: "formGroupUsername",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                            children: "Username:"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                            style: {
                                "background-color": "#E7F0FE"
                            },
                            type: "text",
                            value: username,
                            minLength: "5",
                            onChange: (e)=>setUsername(e.target.value),
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                    className: "m-4",
                    controlId: "formGroupPassword",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                            children: "Password:"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                            style: {
                                "background-color": "#E7F0FE"
                            },
                            type: "password",
                            value: password,
                            minLength: "5",
                            onChange: (e)=>setPassword(e.target.value),
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                    className: "m-4",
                    controlId: "formGroupEmail",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                            children: "Email:"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                            style: {
                                "background-color": "#E7F0FE"
                            },
                            type: "email",
                            value: email,
                            onChange: (e)=>setEmail(e.target.value),
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                    className: "m-4",
                    controlId: "formGroupBirthday",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                            children: "Birthday:"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                            style: {
                                "background-color": "#E7F0FE"
                            },
                            type: "date",
                            value: birthday,
                            onChange: (e)=>setBirthday(e.target.value),
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                    className: "d-grid gap-2 col-3 mx-auto",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                        variant: "primary",
                        type: "submit",
                        className: "mt-4",
                        children: "Signup"
                    })
                })
            ]
        })
    });
};





var $572d173155431dc3$exports = {};
"use strict";
Object.defineProperty($572d173155431dc3$exports, "__esModule", {
    value: true
});
$572d173155431dc3$exports.default = $572d173155431dc3$var$all;
var $6bef38e8094f8c50$exports = {};
"use strict";
Object.defineProperty($6bef38e8094f8c50$exports, "__esModule", {
    value: true
});
$6bef38e8094f8c50$exports.default = $6bef38e8094f8c50$var$createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function $6bef38e8094f8c50$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error("Required " + location + " `" + propFullNameSafe + "` was not specified " + ("in `" + componentNameSafe + "`."));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
$6bef38e8094f8c50$exports = $6bef38e8094f8c50$exports["default"];


var $572d173155431dc3$var$_createChainableTypeChecker2 = $572d173155431dc3$var$_interopRequireDefault($6bef38e8094f8c50$exports);
function $572d173155431dc3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $572d173155431dc3$var$all() {
    for(var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    function allPropTypes() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var error = null;
        validators.forEach(function(validator) {
            if (error != null) return;
            var result = validator.apply(undefined, args);
            if (result != null) error = result;
        });
        return error;
    }
    return (0, $572d173155431dc3$var$_createChainableTypeChecker2.default)(allPropTypes);
}
$572d173155431dc3$exports = $572d173155431dc3$exports["default"];



var $acw62 = parcelRequire("acw62");
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(this, arguments);
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $acw62 = parcelRequire("acw62");
var $768901fea8dbe440$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$768901fea8dbe440$exports = $768901fea8dbe440$var$invariant;


var $b7f5460541b42e0f$var$noop = function noop() {};
function $b7f5460541b42e0f$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $b7f5460541b42e0f$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$b7f5460541b42e0f$export$26cbf8c37e721e67(prop)] = $b7f5460541b42e0f$var$noop;
        var handler;
    });
    return propTypes;
}
function $b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $b7f5460541b42e0f$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $b7f5460541b42e0f$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== "function" || component.prototype && component.prototype.isReactComponent);
}


function $5809a50e160ad91a$var$_toPropertyKey(arg) {
    var key = $5809a50e160ad91a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5809a50e160ad91a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5809a50e160ad91a$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $acw62.useRef)(propValue !== undefined);
    var _useState = (0, $acw62.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $acw62.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $5809a50e160ad91a$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$b7f5460541b42e0f$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, [
            $b7f5460541b42e0f$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($5809a50e160ad91a$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $5809a50e160ad91a$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p) {
    $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039(o, p);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(subClass, superClass);
}



var $acw62 = parcelRequire("acw62");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $a2318047db3e7b05$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $a2318047db3e7b05$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || "Component";
    var canAcceptRef = $b7f5460541b42e0f$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($b7f5460541b42e0f$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$b7f5460541b42e0f$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, key) && $b7f5460541b42e0f$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$b7f5460541b42e0f$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    (0, $c8a186e1757974bb$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UncontrolledComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $a2318047db3e7b05$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $a2318047db3e7b05$export$2e2bcd8739ae039(newComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}




var $01b4fe2088fac58b$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $01b4fe2088fac58b$export$2e2bcd8739ae039(element, selector) {
    return $01b4fe2088fac58b$var$toArray(element.querySelectorAll(selector));
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $9b4016ced1cecfef$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are stricting equal to the last state value
    var _useReducer = (0, $acw62.useReducer)(function(state) {
        return !state;
    }, false), dispatch = _useReducer[1];
    return dispatch;
}



var $acw62 = parcelRequire("acw62");
var $9d58c39545e3cedc$var$toFnRef = function toFnRef(ref) {
    return !ref || typeof ref === "function" ? ref : function(value) {
        ref.current = value;
    };
};
function $9d58c39545e3cedc$export$c9058316764c140e(refA, refB) {
    var a = $9d58c39545e3cedc$var$toFnRef(refA);
    var b = $9d58c39545e3cedc$var$toFnRef(refB);
    return function(value) {
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $9d58c39545e3cedc$var$useMergedRefs(refA, refB) {
    return (0, $acw62.useMemo)(function() {
        return $9d58c39545e3cedc$export$c9058316764c140e(refA, refB);
    }, [
        refA,
        refB
    ]);
}
var $9d58c39545e3cedc$export$2e2bcd8739ae039 = $9d58c39545e3cedc$var$useMergedRefs;



var $acw62 = parcelRequire("acw62");
const $45c958b882f3532f$var$NavContext = /*#__PURE__*/ $acw62.createContext(null);
$45c958b882f3532f$var$NavContext.displayName = "NavContext";
var $45c958b882f3532f$export$2e2bcd8739ae039 = $45c958b882f3532f$var$NavContext;



var $acw62 = parcelRequire("acw62");
const $9c8dd72e635c1db4$var$SelectableContext = /*#__PURE__*/ $acw62.createContext(null);
const $9c8dd72e635c1db4$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $9c8dd72e635c1db4$export$2e2bcd8739ae039 = $9c8dd72e635c1db4$var$SelectableContext;



var $acw62 = parcelRequire("acw62");
const $b72131d84963b3ba$var$TabContext = /*#__PURE__*/ $acw62.createContext(null);
var $b72131d84963b3ba$export$2e2bcd8739ae039 = $b72131d84963b3ba$var$TabContext;


const $1123d3fd1f42218c$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $1123d3fd1f42218c$export$635202801f9383a0 = `rrUi`;
function $1123d3fd1f42218c$export$5cc3b7b83e34ade7(property) {
    return `${$1123d3fd1f42218c$export$fd7bcb7e9bef4e8a}${property}`;
}
function $1123d3fd1f42218c$export$7776c0a7cd2eb3e0(property) {
    return `${$1123d3fd1f42218c$export$635202801f9383a0}${property}`;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $ab80f0daa08f2134$var$useCommittedRef(value) {
    var ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $ab80f0daa08f2134$export$2e2bcd8739ae039 = $ab80f0daa08f2134$var$useCommittedRef;


function $9cc831e7fe1726fc$export$2e2bcd8739ae039(fn) {
    var ref = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(fn);
    return (0, $acw62.useCallback)(function() {
        return ref.current && ref.current.apply(ref, arguments);
    }, [
        ref
    ]);
}








const $31dc5e0f2f162e1f$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $31dc5e0f2f162e1f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $31dc5e0f2f162e1f$export$d7a68693710982a({ key: key , onClick: onClick , active: active , id: id , role: role , disabled: disabled  }) {
    const parentOnSelect = (0, $acw62.useContext)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039));
    const navContext = (0, $acw62.useContext)((0, $45c958b882f3532f$export$2e2bcd8739ae039));
    const tabContext = (0, $acw62.useContext)((0, $b72131d84963b3ba$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === "tablist") props.role = "tab";
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)("event-key")] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props["aria-controls"] = contextControlledId;
    }
    if (props.role === "tab") {
        props["aria-selected"] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props["aria-disabled"] = true;
        }
    }
    props.onClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $31dc5e0f2f162e1f$var$NavItem = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $0522fa2e4977c358$export$2e2bcd8739ae039) , active: active , eventKey: eventKey  } = _ref, options = $31dc5e0f2f162e1f$var$_objectWithoutPropertiesLoose(_ref, $31dc5e0f2f162e1f$var$_excluded);
    const [props, meta] = $31dc5e0f2f162e1f$export$d7a68693710982a(Object.assign({
        key: (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)("active")] = meta.isActive;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$31dc5e0f2f162e1f$var$NavItem.displayName = "NavItem";
var $31dc5e0f2f162e1f$export$2e2bcd8739ae039 = $31dc5e0f2f162e1f$var$NavItem;



const $bdf8c5d517fb941c$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $bdf8c5d517fb941c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $bdf8c5d517fb941c$var$noop = ()=>{};
const $bdf8c5d517fb941c$var$EVENT_KEY_ATTR = (0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)("event-key");
const $bdf8c5d517fb941c$var$Nav = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "div" , onSelect: onSelect , activeKey: activeKey , role: role , onKeyDown: onKeyDown  } = _ref, props = $bdf8c5d517fb941c$var$_objectWithoutPropertiesLoose(_ref, $bdf8c5d517fb941c$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $9b4016ced1cecfef$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $acw62.useRef)(false);
    const parentOnSelect = (0, $acw62.useContext)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039));
    const tabContext = (0, $acw62.useContext)((0, $b72131d84963b3ba$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || "tablist";
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $acw62.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(currentListNode, `[${$bdf8c5d517fb941c$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector("[aria-selected=true]");
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case "ArrowLeft":
            case "ArrowUp":
                nextActiveChild = getNextActiveTab(-1);
                break;
            case "ArrowRight":
            case "ArrowDown":
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $1123d3fd1f42218c$export$7776c0a7cd2eb3e0)("EventKey")] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $acw62.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$bdf8c5d517fb941c$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45c958b882f3532f$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $bdf8c5d517fb941c$var$noop,
                getControllerId: getControllerId || $bdf8c5d517fb941c$var$noop
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$bdf8c5d517fb941c$var$Nav.displayName = "Nav";
var $bdf8c5d517fb941c$export$2e2bcd8739ae039 = Object.assign($bdf8c5d517fb941c$var$Nav, {
    Item: (0, $31dc5e0f2f162e1f$export$2e2bcd8739ae039)
});




var $acw62 = parcelRequire("acw62");
// TODO: check
const $46425249d1e44fce$var$context = /*#__PURE__*/ $acw62.createContext(null);
$46425249d1e44fce$var$context.displayName = "NavbarContext";
var $46425249d1e44fce$export$2e2bcd8739ae039 = $46425249d1e44fce$var$context;




var $b38cb042d7fdd569$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("nav-item");




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $6ee4f2c1aea3527b$export$2e2bcd8739ae039() {
    return (0, $acw62.useState)(null);
}





var $acw62 = parcelRequire("acw62");

function $eaba49a725115ef9$export$2e2bcd8739ae039(eventTarget, event, listener, capture) {
    if (capture === void 0) capture = false;
    var handler = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(listener);
    (0, $acw62.useEffect)(function() {
        var target = typeof eventTarget === "function" ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return function() {
            return target.removeEventListener(event, handler, capture);
        };
    }, [
        eventTarget
    ]);
}




var $acw62 = parcelRequire("acw62");
function $3e423f2a0d715058$export$2e2bcd8739ae039(event, handler, capture) {
    if (capture === void 0) capture = false;
    var documentTarget = (0, $acw62.useCallback)(function() {
        return document;
    }, []);
    return (0, $eaba49a725115ef9$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $acw62 = parcelRequire("acw62");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ function $6fd76678a314d183$var$useInterval(fn, ms, paused, runImmediately) {
    if (paused === void 0) paused = false;
    if (runImmediately === void 0) runImmediately = false;
    var handle;
    var fnRef = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    var pausedRef = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(paused);
    var tick = function tick() {
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    var schedule = function schedule() {
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $acw62.useEffect)(function() {
        if (runImmediately) tick();
        else schedule();
        return function() {
            return clearTimeout(handle);
        };
    }, [
        paused,
        runImmediately
    ]);
}
var $6fd76678a314d183$export$2e2bcd8739ae039 = $6fd76678a314d183$var$useInterval;



var $acw62 = parcelRequire("acw62");

function $198f6e47917f30c6$var$useRafInterval(fn, ms, paused) {
    if (paused === void 0) paused = false;
    var handle;
    var start = new Date().getTime();
    var fnRef = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    var pausedRef = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(paused);
    function loop() {
        var current = new Date().getTime();
        var delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $acw62.useEffect)(function() {
        handle = requestAnimationFrame(loop);
        return function() {
            return cancelAnimationFrame(handle);
        };
    }, []);
}
var $198f6e47917f30c6$export$2e2bcd8739ae039 = $198f6e47917f30c6$var$useRafInterval;



var $acw62 = parcelRequire("acw62");
function $b720ce9b20d786bc$var$_extends() {
    $b720ce9b20d786bc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b720ce9b20d786bc$var$_extends.apply(this, arguments);
}
function $b720ce9b20d786bc$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $acw62.useState)(initialState), state = _useState[0], setState = _useState[1];
    var updater = (0, $acw62.useCallback)(function(update) {
        if (update === null) return;
        if (typeof update === "function") setState(function(state) {
            var nextState = update(state);
            return nextState == null ? state : $b720ce9b20d786bc$var$_extends({}, state, nextState);
        });
        else setState(function(state) {
            return $b720ce9b20d786bc$var$_extends({}, state, update);
        });
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $44ebbbe01160f4fd$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    var _useMergeState = (0, $b720ce9b20d786bc$export$2e2bcd8739ae039)(initialState), state = _useMergeState[0], setState = _useMergeState[1];
    var nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}



var $acw62 = parcelRequire("acw62");
function $ed7e9ace1ce49d9f$export$2e2bcd8739ae039() {
    var mounted = (0, $acw62.useRef)(true);
    var isMounted = (0, $acw62.useRef)(function() {
        return mounted.current;
    });
    (0, $acw62.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $acw62 = parcelRequire("acw62");
function $97a3f3bdcb91cb9e$export$2e2bcd8739ae039(value) {
    var ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
function $80508bd696338b90$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    var _useState = (0, $acw62.useState)({
        image: null,
        error: null
    }), state = _useState[0], setState = _useState[1];
    (0, $acw62.useEffect)(function() {
        if (!imageOrUrl) return undefined;
        var image;
        if (typeof imageOrUrl === "string") {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener("load", onLoad);
        image.addEventListener("error", onError);
        return function() {
            image.removeEventListener("load", onLoad);
            image.removeEventListener("error", onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $63565b817d447aae$var$isReactNative = typeof $parcel$global !== "undefined" && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === "ReactNative";
var $63565b817d447aae$var$isDOM = typeof document !== "undefined";
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $63565b817d447aae$export$2e2bcd8739ae039 = $63565b817d447aae$var$isDOM || $63565b817d447aae$var$isReactNative ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


var $a420e6fa685a8a6f$var$targetMap = new WeakMap();
var $a420e6fa685a8a6f$var$resizeObserver;
function $a420e6fa685a8a6f$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $a420e6fa685a8a6f$var$resizeObserver = $a420e6fa685a8a6f$var$resizeObserver || new window.ResizeObserver(function(entries) {
        entries.forEach(function(entry) {
            var handler = $a420e6fa685a8a6f$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $a420e6fa685a8a6f$export$2e2bcd8739ae039(element) {
    var _useState = (0, $acw62.useState)(null), rect = _useState[0], setRect = _useState[1];
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(function() {
        if (!element) return;
        $a420e6fa685a8a6f$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $a420e6fa685a8a6f$var$targetMap.set(element, function(rect) {
            setRect(rect);
        });
        return function() {
            $a420e6fa685a8a6f$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $a02c1087963bbb34$var$_excluded = [
    "onKeyDown"
];
function $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a02c1087963bbb34$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $a02c1087963bbb34$var$Anchor = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown  } = _ref, props = $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(_ref, $a02c1087963bbb34$var$_excluded);
    const [buttonProps] = (0, $0522fa2e4977c358$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: "a"
    }, props));
    const handleKeyDown = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($a02c1087963bbb34$export$72369ab2cc99204b(props.href) || props.role === "button") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$a02c1087963bbb34$var$Anchor.displayName = "Anchor";
var $a02c1087963bbb34$export$2e2bcd8739ae039 = $a02c1087963bbb34$var$Anchor;






const $8dc05f39bc918f56$var$NavLink = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , className: className , as: Component = (0, $a02c1087963bbb34$export$2e2bcd8739ae039) , active: active , eventKey: eventKey , disabled: disabled = false , ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "nav-link");
    const [navItemProps, meta] = (0, $31dc5e0f2f162e1f$export$d7a68693710982a)({
        key: (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, disabled && "disabled", meta.isActive && "active")
    });
});
$8dc05f39bc918f56$var$NavLink.displayName = "NavLink";
var $8dc05f39bc918f56$export$2e2bcd8739ae039 = $8dc05f39bc918f56$var$NavLink;



const $aa29ebe1e6d9cd49$var$Nav = /*#__PURE__*/ $acw62.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = "div" , bsPrefix: initialBsPrefix , variant: variant , fill: fill = false , justify: justify = false , navbar: navbar , navbarScroll: navbarScroll , className: className , activeKey: activeKey , ...props } = (0, $5809a50e160ad91a$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: "onSelect"
    });
    const bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(initialBsPrefix, "nav");
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $acw62.useContext)((0, $5eb077b72b2eb187$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix  } = cardHeaderContext);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdf8c5d517fb941c$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$aa29ebe1e6d9cd49$var$Nav.displayName = "Nav";
var $aa29ebe1e6d9cd49$export$2e2bcd8739ae039 = Object.assign($aa29ebe1e6d9cd49$var$Nav, {
    Item: (0, $b38cb042d7fdd569$export$2e2bcd8739ae039),
    Link: (0, $8dc05f39bc918f56$export$2e2bcd8739ae039)
});




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


const $b5ed781c15448fd9$var$NavbarBrand = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , className: className , as: as , ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "navbar-brand");
    const Component = as || (props.href ? "a" : "span");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix)
    });
});
$b5ed781c15448fd9$var$NavbarBrand.displayName = "NavbarBrand";
var $b5ed781c15448fd9$export$2e2bcd8739ae039 = $b5ed781c15448fd9$var$NavbarBrand;



var $acw62 = parcelRequire("acw62");

/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $fcf05e248574eb57$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $da31306d5140b746$export$2e2bcd8739ae039(node) {
    var doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $9d0d2e2a013bac9c$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $da31306d5140b746$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $9f2c378a21ca2430$var$rUpper = /([A-Z])/g;
function $9f2c378a21ca2430$export$2e2bcd8739ae039(string) {
    return string.replace($9f2c378a21ca2430$var$rUpper, "-$1").toLowerCase();
}


var $09bdad49a6503060$var$msPattern = /^ms-/;
function $09bdad49a6503060$export$2e2bcd8739ae039(string) {
    return (0, $9f2c378a21ca2430$export$2e2bcd8739ae039)(string).replace($09bdad49a6503060$var$msPattern, "-ms-");
}


var $c8af0fa0e8553220$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $c8af0fa0e8553220$export$2e2bcd8739ae039(value) {
    return !!(value && $c8af0fa0e8553220$var$supportedTransforms.test(value));
}


function $1d31c226dae4138f$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $09bdad49a6503060$export$2e2bcd8739ae039)(property)) || (0, $9d0d2e2a013bac9c$export$2e2bcd8739ae039)(node).getPropertyValue((0, $09bdad49a6503060$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $09bdad49a6503060$export$2e2bcd8739ae039)(key));
        else if ((0, $c8af0fa0e8553220$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $09bdad49a6503060$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $1d31c226dae4138f$export$2e2bcd8739ae039 = $1d31c226dae4138f$var$style;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = "unmounted";
var $0fef977f04119bf5$export$84cbff306f539230 = "exited";
var $0fef977f04119bf5$export$df38205c966be359 = "entering";
var $0fef977f04119bf5$export$78e9e6e3e014d60a = "entered";
var $0fef977f04119bf5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;




/* eslint-disable no-return-assign */ var $55986f7b0f69fd17$export$2e2bcd8739ae039 = !!(typeof window !== "undefined" && window.document && window.document.createElement);


var $28419dce7921d430$export$63fefd044b2bc624 = false;
var $28419dce7921d430$export$a614c6b395900f69 = false;
try {
    var $28419dce7921d430$var$options = {
        get passive () {
            return $28419dce7921d430$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $28419dce7921d430$export$a614c6b395900f69 = $28419dce7921d430$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $55986f7b0f69fd17$export$2e2bcd8739ae039) {
        window.addEventListener("test", $28419dce7921d430$var$options, $28419dce7921d430$var$options);
        window.removeEventListener("test", $28419dce7921d430$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $28419dce7921d430$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== "boolean" && !$28419dce7921d430$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$28419dce7921d430$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $28419dce7921d430$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $28419dce7921d430$export$2e2bcd8739ae039 = $28419dce7921d430$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $59fd23e4cc6020bf$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== "boolean" ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $59fd23e4cc6020bf$export$2e2bcd8739ae039 = $59fd23e4cc6020bf$var$removeEventListener;


function $5ce0a80dcc778636$var$listen(node, eventName, handler, options) {
    (0, $28419dce7921d430$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $59fd23e4cc6020bf$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $5ce0a80dcc778636$export$2e2bcd8739ae039 = $5ce0a80dcc778636$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $d690caf237d1909f$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $3966a04026e86a49$var$parseDuration(node) {
    var str = (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, "transitionDuration") || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $d690caf237d1909f$export$2e2bcd8739ae039)(element, "transitionend", true);
    }, duration + padding);
    var remove = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(element, "transitionend", function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $3966a04026e86a49$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $3966a04026e86a49$var$parseDuration(element) || 0;
    var removeEmulate = $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(element, "transitionend", handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $f251260f6a38a977$var$parseDuration(node, property) {
    const str = (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, property) || "";
    const mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $f251260f6a38a977$export$2e2bcd8739ae039(element, handler) {
    const duration = $f251260f6a38a977$var$parseDuration(element, "transitionDuration");
    const delay = $f251260f6a38a977$var$parseDuration(element, "transitionDelay");
    const remove = (0, $3966a04026e86a49$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $70a5c1c5c22ba944$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== "function") throw new Error("Invalid Argument Type, must only provide functions, undefined, or null.");
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-ignore
            acc.apply(this, args);
            // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
var $70a5c1c5c22ba944$export$2e2bcd8739ae039 = $70a5c1c5c22ba944$var$createChainedFunction;


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $02f7800ef44133eb$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $acw62 = parcelRequire("acw62");



function $75718871ab216e51$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



// Normalizes Transition callbacks when nodeRef is used.
const $5e18c3cbbc2321dd$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ onEnter: onEnter , onEntering: onEntering , onEntered: onEntered , onExit: onExit , onExiting: onExiting , onExited: onExited , addEndListener: addEndListener , children: children , childRef: childRef , ...props }, ref)=>{
    const nodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $75718871ab216e51$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $acw62.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $acw62.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $acw62.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $acw62.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $acw62.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $acw62.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $acw62.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0fef977f04119bf5$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === "function" ? (status, innerProps)=>children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $5e18c3cbbc2321dd$export$2e2bcd8739ae039 = $5e18c3cbbc2321dd$var$TransitionWrapper;



const $6225d171b822135d$var$MARGINS = {
    height: [
        "marginTop",
        "marginBottom"
    ],
    width: [
        "marginLeft",
        "marginRight"
    ]
};
function $6225d171b822135d$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $6225d171b822135d$var$MARGINS[dimension];
    return value + // @ts-ignore
    parseInt((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-ignore
    parseInt((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $6225d171b822135d$var$collapseStyles = {
    [(0, $0fef977f04119bf5$export$84cbff306f539230)]: "collapse",
    [(0, $0fef977f04119bf5$export$4aacc83d4d59139f)]: "collapsing",
    [(0, $0fef977f04119bf5$export$df38205c966be359)]: "collapsing",
    [(0, $0fef977f04119bf5$export$78e9e6e3e014d60a)]: "collapse show"
};
const $6225d171b822135d$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ onEnter: onEnter , onEntering: onEntering , onEntered: onEntered , onExit: onExit , onExiting: onExiting , className: className , children: children , dimension: dimension = "height" , in: inProp = false , timeout: timeout = 300 , mountOnEnter: mountOnEnter = false , unmountOnExit: unmountOnExit = false , appear: appear = false , getDimensionValue: getDimensionValue = $6225d171b822135d$var$getDefaultDimensionValue , ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === "function" ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = "0";
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $02f7800ef44133eb$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e18c3cbbc2321dd$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $f251260f6a38a977$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: children.ref,
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, children.props.className, $6225d171b822135d$var$collapseStyles[state], computedDimension === "width" && "collapse-horizontal")
            })
    });
});
var // @ts-ignore
$6225d171b822135d$export$2e2bcd8739ae039 = $6225d171b822135d$var$Collapse;





const $2710431f613a38bf$var$NavbarCollapse = /*#__PURE__*/ $acw62.forwardRef(({ children: children , bsPrefix: bsPrefix , ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "navbar-collapse");
    const context = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6225d171b822135d$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$2710431f613a38bf$var$NavbarCollapse.displayName = "NavbarCollapse";
var $2710431f613a38bf$export$2e2bcd8739ae039 = $2710431f613a38bf$var$NavbarCollapse;




var $acw62 = parcelRequire("acw62");




const $0ecac5fdbe294867$var$NavbarToggle = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , className: className , children: children , label: label = "Toggle navigation" , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "button" , onClick: onClick , ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "navbar-toggler");
    const { onToggle: onToggle , expanded: expanded  } = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === "button") props.type = "button";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, !expanded && "collapsed"),
        children: children || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$0ecac5fdbe294867$var$NavbarToggle.displayName = "NavbarToggle";
var $0ecac5fdbe294867$export$2e2bcd8739ae039 = $0ecac5fdbe294867$var$NavbarToggle;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $93efd0ca86a6ce96$var$matchersByWindow = new WeakMap();
var $93efd0ca86a6ce96$var$getMatcher = function getMatcher(query, targetWindow) {
    if (!query || !targetWindow) return undefined;
    var matchers = $93efd0ca86a6ce96$var$matchersByWindow.get(targetWindow) || new Map();
    $93efd0ca86a6ce96$var$matchersByWindow.set(targetWindow, matchers);
    var mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $93efd0ca86a6ce96$export$2e2bcd8739ae039(query, targetWindow) {
    if (targetWindow === void 0) targetWindow = typeof window === "undefined" ? undefined : window;
    var mql = $93efd0ca86a6ce96$var$getMatcher(query, targetWindow);
    var _useState = (0, $acw62.useState)(function() {
        return mql ? mql.matches : false;
    }), matches = _useState[0], setMatches = _useState[1];
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(function() {
        var mql = $93efd0ca86a6ce96$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        var matchers = $93efd0ca86a6ce96$var$matchersByWindow.get(targetWindow);
        var handleChange = function handleChange() {
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return function() {
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $acw62 = parcelRequire("acw62");
function $d7a77e47f418a0f8$export$9c6950edc251641e(breakpointValues) {
    var names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? query + " and " + next : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        var next = getNext(breakpoint);
        var value = breakpointValues[next];
        if (typeof value === "number") value = value - 0.2 + "px";
        else value = "calc(" + value + " - 0.2px)";
        return "(max-width: " + value + ")";
    }
    function getMinQuery(breakpoint) {
        var value = breakpointValues[breakpoint];
        if (typeof value === "number") value = value + "px";
        return "(min-width: " + value + ")";
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        var breakpointMap;
        if (typeof breakpointOrMap === "object") {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            var _breakpointMap;
            direction = direction || true;
            breakpointMap = (_breakpointMap = {}, _breakpointMap[breakpointOrMap] = direction, _breakpointMap);
        }
        var query = (0, $acw62.useMemo)(function() {
            return Object.entries(breakpointMap).reduce(function(query, _ref) {
                var key = _ref[0], direction = _ref[1];
                if (direction === "up" || direction === true) query = and(query, getMinQuery(key));
                if (direction === "down" || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, "");
        }, [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $93efd0ca86a6ce96$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
var $d7a77e47f418a0f8$var$useBreakpoint = $d7a77e47f418a0f8$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $d7a77e47f418a0f8$export$2e2bcd8739ae039 = $d7a77e47f418a0f8$var$useBreakpoint;




var $acw62 = parcelRequire("acw62");

function $d26eb8849281a3d4$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $967999a1a8cec832$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $6227e7ea0d71afb1$export$2e2bcd8739ae039(value) {
    var valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $acw62 = parcelRequire("acw62");
function $63805df80cf3ca43$export$2e2bcd8739ae039(fn) {
    var onUnmount = (0, $6227e7ea0d71afb1$export$2e2bcd8739ae039)(fn);
    (0, $acw62.useEffect)(function() {
        return function() {
            return onUnmount.current();
        };
    }, []);
}






/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $01b2d58e52126803$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $254a0b83be45660e$export$1a88c12b8b979fa0 = (0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)("modal-open");
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $254a0b83be45660e$var$ModalManager {
    constructor({ ownerDocument: ownerDocument , handleContainerOverflow: handleContainerOverflow = true , isRTL: isRTL = false  } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $01b2d58e52126803$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: "hidden"
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(container, paddingProp) || "0", 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($254a0b83be45660e$export$1a88c12b8b979fa0, "");
        (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($254a0b83be45660e$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $254a0b83be45660e$export$2e2bcd8739ae039 = $254a0b83be45660e$var$ModalManager;





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $0e151397e562aebc$var$Context = /*#__PURE__*/ (0, $acw62.createContext)((0, $55986f7b0f69fd17$export$2e2bcd8739ae039) ? window : undefined);
const $0e151397e562aebc$export$f7d306aeb1cf5fbc = $0e151397e562aebc$var$Context.Provider;
function $0e151397e562aebc$export$2e2bcd8739ae039() {
    return (0, $acw62.useContext)($0e151397e562aebc$var$Context);
}


const $1892253eb6d46162$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $55986f7b0f69fd17$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $fcf05e248574eb57$export$2e2bcd8739ae039)()).body;
    if (typeof ref === "function") ref = ref();
    if (ref && "current" in ref) ref = ref.current;
    if (ref && ("nodeType" in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $1892253eb6d46162$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $acw62.useState)(()=>$1892253eb6d46162$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $1892253eb6d46162$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $acw62.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $acw62.useEffect)(()=>{
        const nextRef = $1892253eb6d46162$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $83a01f83dd44ef33$var$NoopTransition({ children: children , in: inProp , onExited: onExited , mountOnEnter: mountOnEnter , unmountOnExit: unmountOnExit  }) {
    const ref = (0, $acw62.useRef)(null);
    const hasEnteredRef = (0, $acw62.useRef)(inProp);
    const handleExited = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onExited);
    (0, $acw62.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, children.ref);
    const child = /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $83a01f83dd44ef33$export$2e2bcd8739ae039 = $83a01f83dd44ef33$var$NoopTransition;



function $86d0e8a9dc3b2e91$export$7b286972b8d8ccbf({ in: inProp , onTransition: onTransition  }) {
    const ref = (0, $acw62.useRef)(null);
    const isInitialRef = (0, $acw62.useRef)(true);
    const handleTransition = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onTransition);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $86d0e8a9dc3b2e91$export$2e2bcd8739ae039({ children: children , in: inProp , onExited: onExited , onEntered: onEntered , transition: transition  }) {
    const [exited, setExited] = (0, $acw62.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $86d0e8a9dc3b2e91$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, children.ref);
    return exited && !inProp ? null : /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ref: combinedRef
    });
}
function $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5(Component, runTransition, props) {
    if (Component) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props));
    if (runTransition) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($86d0e8a9dc3b2e91$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83a01f83dd44ef33$export$2e2bcd8739ae039), Object.assign({}, props));
}


/* eslint-disable import/prefer-default-export */ function $a36e95ee292bed8b$export$806fcc22e55e107d(e) {
    return e.code === "Escape" || e.keyCode === 27;
}



const $0173af0e859d9b0f$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $0173af0e859d9b0f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $0173af0e859d9b0f$var$manager;
function $0173af0e859d9b0f$var$getManager(window) {
    if (!$0173af0e859d9b0f$var$manager) $0173af0e859d9b0f$var$manager = new (0, $254a0b83be45660e$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $0173af0e859d9b0f$var$manager;
}
function $0173af0e859d9b0f$var$useModalManager(provided) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const modalManager = provided || $0173af0e859d9b0f$var$getManager(window);
    const modal = (0, $acw62.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $acw62.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $acw62.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $0173af0e859d9b0f$var$Modal = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { show: show = false , role: role = "dialog" , className: className , style: style , children: children , backdrop: backdrop = true , keyboard: keyboard = true , onBackdropClick: onBackdropClick , onEscapeKeyDown: onEscapeKeyDown , transition: transition , runTransition: runTransition , backdropTransition: backdropTransition , runBackdropTransition: runBackdropTransition , autoFocus: autoFocus = true , enforceFocus: enforceFocus = true , restoreFocus: restoreFocus = true , restoreFocusOptions: restoreFocusOptions , renderDialog: renderDialog , renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({}, props)) , manager: providedManager , container: containerRef , onShow: onShow , onHide: onHide = ()=>{} , onExit: onExit , onExited: onExited , onExiting: onExiting , onEnter: onEnter , onEntering: onEntering , onEntered: onEntered  } = _ref, rest = $0173af0e859d9b0f$var$_objectWithoutPropertiesLoose(_ref, $0173af0e859d9b0f$var$_excluded);
    const container = (0, $1892253eb6d46162$export$2e2bcd8739ae039)(containerRef);
    const modal = $0173af0e859d9b0f$var$useModalManager(providedManager);
    const isMounted = (0, $ed7e9ace1ce49d9f$export$2e2bcd8739ae039)();
    const prevShow = (0, $97a3f3bdcb91cb9e$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $acw62.useState)(!show);
    const lastFocusRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $55986f7b0f69fd17$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)();
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(document, "keydown", handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(document, "focus", // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            const currentActiveElement = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)(document);
            if (modal.dialog && currentActiveElement && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $acw62.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $acw62.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $63805df80cf3ca43$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)();
        if (modal.dialog && currentActiveElement && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $a36e95ee292bed8b$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $acw62.useRef)();
    const removeKeydownListenerRef = (0, $acw62.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        "aria-modal": role === "dialog" ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, {
            role: "document"
        })
    }));
    dialog = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$0173af0e859d9b0f$var$Modal.displayName = "Modal";
var $0173af0e859d9b0f$export$2e2bcd8739ae039 = Object.assign($0173af0e859d9b0f$var$Modal, {
    Manager: (0, $254a0b83be45660e$export$2e2bcd8739ae039)
});




var $acw62 = parcelRequire("acw62");





const $588ffbaaa8a325aa$var$fadeStyles = {
    [(0, $0fef977f04119bf5$export$df38205c966be359)]: "show",
    [(0, $0fef977f04119bf5$export$78e9e6e3e014d60a)]: "show"
};
const $588ffbaaa8a325aa$var$Fade = /*#__PURE__*/ $acw62.forwardRef(({ className: className , children: children , transitionClasses: transitionClasses = {} , onEnter: onEnter , ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $acw62.useCallback)((node, isAppearing)=>{
        (0, $02f7800ef44133eb$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e18c3cbbc2321dd$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $f251260f6a38a977$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ $acw62.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("fade", className, children.props.className, $588ffbaaa8a325aa$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$588ffbaaa8a325aa$var$Fade.displayName = "Fade";
var $588ffbaaa8a325aa$export$2e2bcd8739ae039 = $588ffbaaa8a325aa$var$Fade;



var $ba423bd29b7fa4dc$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("offcanvas-body");




var $acw62 = parcelRequire("acw62");





const $48e49b3f9b1ab2a2$var$transitionStyles = {
    [(0, $0fef977f04119bf5$export$df38205c966be359)]: "show",
    [(0, $0fef977f04119bf5$export$78e9e6e3e014d60a)]: "show"
};
const $48e49b3f9b1ab2a2$var$OffcanvasToggling = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , className: className , children: children , in: inProp = false , mountOnEnter: mountOnEnter = false , unmountOnExit: unmountOnExit = false , appear: appear = false , ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "offcanvas");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e18c3cbbc2321dd$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $f251260f6a38a977$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ $acw62.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, children.props.className, (status === (0, $0fef977f04119bf5$export$df38205c966be359) || status === (0, $0fef977f04119bf5$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $48e49b3f9b1ab2a2$var$transitionStyles[status])
            })
    });
});
$48e49b3f9b1ab2a2$var$OffcanvasToggling.displayName = "OffcanvasToggling";
var $48e49b3f9b1ab2a2$export$2e2bcd8739ae039 = $48e49b3f9b1ab2a2$var$OffcanvasToggling;



var $acw62 = parcelRequire("acw62");
const $ce35488230cbfb2e$var$ModalContext = /*#__PURE__*/ $acw62.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
var $ce35488230cbfb2e$export$2e2bcd8739ae039 = $ce35488230cbfb2e$var$ModalContext;





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


const $52ed202a4f01c477$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "white"
    ])
};
const $52ed202a4f01c477$var$CloseButton = /*#__PURE__*/ $acw62.forwardRef(({ className: className , variant: variant , "aria-label": ariaLabel = "Close" , ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn-close", variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$52ed202a4f01c477$var$CloseButton.displayName = "CloseButton";
$52ed202a4f01c477$var$CloseButton.propTypes = $52ed202a4f01c477$var$propTypes;
var $52ed202a4f01c477$export$2e2bcd8739ae039 = $52ed202a4f01c477$var$CloseButton;




const $7ed9ce9ab3e9405e$var$AbstractModalHeader = /*#__PURE__*/ $acw62.forwardRef(({ closeLabel: closeLabel = "Close" , closeVariant: closeVariant , closeButton: closeButton = false , onHide: onHide , children: children , ...props }, ref)=>{
    const context = (0, $acw62.useContext)((0, $ce35488230cbfb2e$export$2e2bcd8739ae039));
    const handleClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52ed202a4f01c477$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
var $7ed9ce9ab3e9405e$export$2e2bcd8739ae039 = $7ed9ce9ab3e9405e$var$AbstractModalHeader;



const $513c4c102e8b60c7$var$OffcanvasHeader = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , className: className , closeLabel: closeLabel = "Close" , closeButton: closeButton = false , ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "offcanvas-header");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed9ce9ab3e9405e$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$513c4c102e8b60c7$var$OffcanvasHeader.displayName = "OffcanvasHeader";
var $513c4c102e8b60c7$export$2e2bcd8739ae039 = $513c4c102e8b60c7$var$OffcanvasHeader;




const $0ae39967a5cb8bc6$var$DivStyledAsH5 = (0, $31af5e1d0c3b3c37$export$2e2bcd8739ae039)("h5");
var $0ae39967a5cb8bc6$export$2e2bcd8739ae039 = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("offcanvas-title", {
    Component: $0ae39967a5cb8bc6$var$DivStyledAsH5
});



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}




function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



const $f00adc503d5cecaf$var$Selector = {
    FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
    STICKY_CONTENT: ".sticky-top",
    NAVBAR_TOGGLER: ".navbar-toggler"
};
class $f00adc503d5cecaf$var$BootstrapModalManager extends (0, $254a0b83be45660e$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $620ffe1c3bcccf8e$export$2e2bcd8739ae039)(container, "modal-open");
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $c22b31c675df16bf$export$2e2bcd8739ae039)(container, "modal-open");
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $f00adc503d5cecaf$var$sharedManager;
function $f00adc503d5cecaf$export$a03641438014b436(options) {
    if (!$f00adc503d5cecaf$var$sharedManager) $f00adc503d5cecaf$var$sharedManager = new $f00adc503d5cecaf$var$BootstrapModalManager(options);
    return $f00adc503d5cecaf$var$sharedManager;
}
var $f00adc503d5cecaf$export$2e2bcd8739ae039 = $f00adc503d5cecaf$var$BootstrapModalManager;



function $ee052f1f156c566d$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48e49b3f9b1ab2a2$export$2e2bcd8739ae039), {
        ...props
    });
}
function $ee052f1f156c566d$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), {
        ...props
    });
}
const $ee052f1f156c566d$var$Offcanvas = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , className: className , children: children , "aria-labelledby": ariaLabelledby , placement: placement = "start" , responsive: responsive , show: /* BaseModal props */ show = false , backdrop: backdrop = true , keyboard: keyboard = true , scroll: scroll = false , onEscapeKeyDown: onEscapeKeyDown , onShow: onShow , onHide: onHide , container: container , autoFocus: autoFocus = true , enforceFocus: enforceFocus = true , restoreFocus: restoreFocus = true , restoreFocusOptions: restoreFocusOptions , onEntered: onEntered , onExit: onExit , onExiting: onExiting , onEnter: onEnter , onEntering: onEntering , onExited: onExited , backdropClassName: backdropClassName , manager: propsManager , renderStaticNode: renderStaticNode = false , ...props }, ref)=>{
    const modalManager = (0, $acw62.useRef)();
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "offcanvas");
    const { onToggle: onToggle  } = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039)) || {};
    const [showOffcanvas, setShowOffcanvas] = (0, $acw62.useState)(false);
    const hideResponsiveOffcanvas = (0, $d7a77e47f418a0f8$export$2e2bcd8739ae039)(responsive || "xs", "up");
    (0, $acw62.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const handleHide = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        onToggle == null || onToggle();
        onHide == null || onHide();
    });
    const modalContext = (0, $acw62.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $f00adc503d5cecaf$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $f00adc503d5cecaf$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = "visible";
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = "";
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $acw62.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce35488230cbfb2e$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0173af0e859d9b0f$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $ee052f1f156c566d$var$DialogTransition,
                    backdropTransition: $ee052f1f156c566d$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$ee052f1f156c566d$var$Offcanvas.displayName = "Offcanvas";
var $ee052f1f156c566d$export$2e2bcd8739ae039 = Object.assign($ee052f1f156c566d$var$Offcanvas, {
    Body: (0, $ba423bd29b7fa4dc$export$2e2bcd8739ae039),
    Header: (0, $513c4c102e8b60c7$export$2e2bcd8739ae039),
    Title: (0, $0ae39967a5cb8bc6$export$2e2bcd8739ae039)
});




const $988fd6bed406a062$var$NavbarOffcanvas = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const context = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee052f1f156c566d$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true
    });
});
$988fd6bed406a062$var$NavbarOffcanvas.displayName = "NavbarOffcanvas";
var $988fd6bed406a062$export$2e2bcd8739ae039 = $988fd6bed406a062$var$NavbarOffcanvas;





const $9a5709cde14ebc6a$var$NavbarText = (0, $140532fd91d84ddb$export$2e2bcd8739ae039)("navbar-text", {
    Component: "span"
});
const $9a5709cde14ebc6a$var$Navbar = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix , expand: expand = true , variant: variant = "light" , bg: bg , fixed: fixed , sticky: sticky , className: className , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "nav" , expanded: expanded , onToggle: onToggle , onSelect: onSelect , collapseOnSelect: collapseOnSelect = false , ...controlledProps } = (0, $5809a50e160ad91a$export$2e2bcd8739ae039)(props, {
        expanded: "onToggle"
    });
    const bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(initialBsPrefix, "navbar");
    const handleCollapse = (0, $acw62.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== "nav") controlledProps.role = "navigation";
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === "string") expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $acw62.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46425249d1e44fce$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$9a5709cde14ebc6a$var$Navbar.displayName = "Navbar";
var $9a5709cde14ebc6a$export$2e2bcd8739ae039 = Object.assign($9a5709cde14ebc6a$var$Navbar, {
    Brand: (0, $b5ed781c15448fd9$export$2e2bcd8739ae039),
    Collapse: (0, $2710431f613a38bf$export$2e2bcd8739ae039),
    Offcanvas: (0, $988fd6bed406a062$export$2e2bcd8739ae039),
    Text: $9a5709cde14ebc6a$var$NavbarText,
    Toggle: (0, $0ecac5fdbe294867$export$2e2bcd8739ae039)
});






const $509b08025fd66c6a$export$ab532c71fec314c3 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
                as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                to: "/login",
                children: "Login"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
                as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                to: "/signup",
                children: "Signup"
            })
        ]
    });
};





const $1874752d20e72286$export$233d6b7dba98b76c = ({ onLoggedOut: onLoggedOut  })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
                as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                to: "/",
                children: "Home"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
                as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                to: "/profileview",
                children: "Profile"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
                onClick: onLoggedOut,
                children: "Logout"
            })
        ]
    });
};



var $be8786af0bf4d295$exports = {};

$be8786af0bf4d295$exports = new URL((parcelRequire("27Lyk")).resolve("7IPPd"), import.meta.url).toString();



const $3cfde2ce529d91d9$export$ef8da11641c635de = ({ user: user , onLoggedOut: onLoggedOut  })=>{
    console.log((0, (/*@__PURE__*/$parcel$interopDefault($be8786af0bf4d295$exports))));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9a5709cde14ebc6a$export$2e2bcd8739ae039), {
        bg: "dark",
        variant: "dark",
        expand: "lg",
        className: "p-3 ps-5 pe-5 align-items-baseline d-flex",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9a5709cde14ebc6a$export$2e2bcd8739ae039).Brand, {
                as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                to: "/",
                className: "align-items-baseline fs-1 navbarTitle",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        fluid: true,
                        alt: "",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($be8786af0bf4d295$exports))),
                        className: "logo me-3 inline-block align-middle"
                    }),
                    "My Movie List"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a5709cde14ebc6a$export$2e2bcd8739ae039).Toggle, {
                "aria-controls": "basic-navbar-nav"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a5709cde14ebc6a$export$2e2bcd8739ae039).Collapse, {
                id: "basic-navbar-nav",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039), {
                    className: "me-auto d-flex align-items-baseline ",
                    children: user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1874752d20e72286$export$233d6b7dba98b76c), {
                        onLoggedOut: onLoggedOut
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $509b08025fd66c6a$export$ab532c71fec314c3), {})
                })
            })
        ]
    });
};
var $3cfde2ce529d91d9$export$2e2bcd8739ae039 = $3cfde2ce529d91d9$export$ef8da11641c635de;



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $c770a015764ac03c$var$Row = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix , className: className , // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div" , ...props }, ref)=>{
    const decoratedBsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "row");
    const breakpoints = (0, $626bd95fa485b758$export$8970c8db816a5863)();
    const minBreakpoint = (0, $626bd95fa485b758$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === "object") ({ cols: cols  } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$c770a015764ac03c$var$Row.displayName = "Row";
var $c770a015764ac03c$export$2e2bcd8739ae039 = $c770a015764ac03c$var$Row;






var $acw62 = parcelRequire("acw62");


const $03efebefd4f2465f$export$379dee2d31dd677 = ({ user: user , token: token  })=>{
    const [updatedUsername, setUpdatedUsername] = (0, $acw62.useState)("");
    const [updatedPassword, setUpdatedPassword] = (0, $acw62.useState)("");
    const [updatedEmail, setUpdatedEmail] = (0, $acw62.useState)("");
    const [updatedBirthday, setUpdatedBirthday] = (0, $acw62.useState)("");
    const handleSubmit = (event)=>{
        event.preventDefault();
        const data = {
            username: updatedUsername || user.username,
            password: updatedPassword || user.password,
            email: updatedEmail || user.email,
            birthday: updatedBirthday || user.birthday
        };
        fetch(`https://mymovielist-api-dhqp.onrender.com/users/${user.username}`, {
            method: "PUT",
            body: JSON.stringify(data),
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        }).then((response)=>{
            if (response.ok) {
                alert("Profile updated successfully");
                // Reset form fields
                setUpdatedUsername("");
                setUpdatedPassword("");
                setUpdatedEmail("");
                setUpdatedBirthday("");
            } else throw new Error("Failed to update profile");
        }).catch((error)=>{
            alert(error.message);
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039), {
        onSubmit: handleSubmit,
        className: "p-5 bg-light rounded",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Update Profile:"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                controlId: "formGroupUsername",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                    children: [
                        "Username:",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                            style: {
                                backgroundColor: "#E7F0FE"
                            },
                            type: "text",
                            value: updatedUsername,
                            onChange: (e)=>setUpdatedUsername(e.target.value)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                controlId: "formGroupPassword",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                    children: [
                        "Password:",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                            style: {
                                backgroundColor: "#E7F0FE"
                            },
                            type: "password",
                            value: updatedPassword,
                            onChange: (e)=>setUpdatedPassword(e.target.value)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                controlId: "formGroupEmail",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                    children: [
                        "Email:",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                            style: {
                                backgroundColor: "#E7F0FE"
                            },
                            type: "email",
                            value: updatedEmail,
                            onChange: (e)=>setUpdatedEmail(e.target.value)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                controlId: "formGroupBirthday",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                    children: [
                        "Birthday:",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                            style: {
                                backgroundColor: "#E7F0FE"
                            },
                            type: "date",
                            value: updatedBirthday,
                            onChange: (e)=>setUpdatedBirthday(e.target.value)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                variant: "primary",
                type: "submit",
                className: "mt-3",
                children: "Update Profile"
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");


const $95a04c942beade6b$export$cd26a8b9a7d28ac6 = ({ user: user , favoriteMovies: favoriteMovies , setFavoriteMovies: setFavoriteMovies , movies: movies , token: token  })=>{
    console.log(favoriteMovies);
    console.log(movies);
    return (0, $acw62.useEffect)(()=>{
        console.log("mounted");
    }, [
        favoriteMovies
    ]), console.log(favoriteMovies), console.log(setFavoriteMovies), /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
        children: favoriteMovies.map((movie)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd664d6ef1f52408$export$9bd698419030e459), {
                user: user,
                movieData: movie,
                setFavoriteMovies: setFavoriteMovies,
                favoriteMovies: favoriteMovies,
                token: token
            }, movie.id);
        })
    });
};


const $ac8839470e379cfc$export$b378b4d12a0dcbde = ({ user: user , movies: movies , token: token , favoriteMovies: favoriteMovies , setFavoriteMovies: setFavoriteMovies , onLoggedOut: onLoggedOut  })=>{
    const handleDeleteAccount = ()=>{
        if (window.confirm("This will permanently delete your account. Are you sure you want to delete?")) deleteAccount();
    };
    const deleteAccount = ()=>{
        console.log("deleting");
        fetch(`https://mymovielist-api-dhqp.onrender.com/users/${user.username}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response)=>{
            if (response.ok) {
                alert("Your account has been deleted. Good Bye!");
                onLoggedOut();
            } else alert("Could not delete account");
        }).catch((e)=>{
            alert(e);
        });
    };
    const handleProfileUpdate = ()=>{
        // Fetch user details again after profile update
        fetchUserDetails();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                className: "mt-3 ",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039), {
                            style: {
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Body, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Title, {
                                        children: "User Profile"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            "User: ",
                                            user.username
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            "Email: ",
                                            user.email
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        children: [
                                            "Birthday:",
                                            " ",
                                            user.birthday.slice(0, 10).split("-").reverse().join("-")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                        variant: "danger",
                                        onClick: handleDeleteAccount,
                                        children: "Delete user account"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                        xs: 12,
                        md: 6,
                        className: "mt-3 mt-md-0",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03efebefd4f2465f$export$379dee2d31dd677), {
                            user: user,
                            token: token,
                            onProfileUpdate: handleProfileUpdate
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                    md: 12,
                    style: {
                        width: "100%"
                    },
                    className: "mt-5",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-white",
                        children: "Favourite Movies"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                children: favoriteMovies.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                color: "white"
                            },
                            children: "Your favorite list is empty! "
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                variant: "danger",
                                className: "mt-3 rounded",
                                style: {
                                    width: "30%"
                                },
                                children: "Add movies"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95a04c942beade6b$export$cd26a8b9a7d28ac6), {
                    user: user,
                    movieData: true,
                    favoriteMovies: favoriteMovies,
                    setFavoriteMovies: setFavoriteMovies,
                    token: token
                })
            })
        ]
    });
};







const $53aa19e059d1ce0f$export$fa32cd27347e212e = ()=>{
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const storedToken = localStorage.getItem("token");
    const [user, setUser] = (0, $acw62.useState)(storedUser ? storedUser : null);
    const [token, setToken] = (0, $acw62.useState)(storedToken ? storedToken : null);
    const [movies, setMovies] = (0, $acw62.useState)([]);
    const [favoriteMovies, setFavoriteMovies] = (0, $acw62.useState)([]);
    (0, $acw62.useEffect)(()=>{
        if (!token) return;
        fetch("https://mymovielist-api-dhqp.onrender.com/movies", {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response)=>response.json()).then((data)=>{
            const moviesFromApi = data.map((doc)=>{
                return {
                    id: doc._id,
                    title: doc.title,
                    image: doc.imageurl,
                    description: doc.description,
                    genre: doc.genre.name,
                    director: doc.director.name
                };
            });
            setMovies(moviesFromApi);
            setFavoriteMovies(moviesFromApi.filter((movie)=>user.favoriteMovies.includes(movie.id)));
        }).catch((error)=>{
            console.error("Error fetching movies:", error);
        });
    }, [
        token
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cfde2ce529d91d9$export$ef8da11641c635de), {
                    user: user,
                    onLoggedOut: ()=>{
                        setUser(null);
                        setToken(null);
                        localStorage.clear();
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                className: " m-2 mt-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/signup",
                            element: user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                to: "/",
                                movies: movies,
                                user: user
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad22dac456f05c19$export$25f3896ea1e09820), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/login",
                            element: user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                to: "/"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d379e75a95ffce01$export$1582048ca8384970), {
                                onLoggedIn: (user, token)=>{
                                    setUser(user);
                                    setToken(token);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/profileview",
                            element: !user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                to: "/login",
                                replace: true
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac8839470e379cfc$export$b378b4d12a0dcbde), {
                                user: user,
                                movies: movies,
                                favoriteMovies: favoriteMovies,
                                setFavoriteMovies: setFavoriteMovies,
                                token: token,
                                onLoggedOut: ()=>{
                                    setUser(null);
                                    setToken(null);
                                    localStorage.clear();
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/movies/:movieId",
                            element: !user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                to: "/login",
                                replace: true
                            }) : movies.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("col", {
                                children: " The list is empty! "
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5ff383576b0e9ff$export$78d497080ea8f89a), {
                                movies: movies,
                                user: user,
                                token: token
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: !user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                to: "/login",
                                replace: true
                            }) : movies.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                children: "The list is empty!"
                            }) : movies.map((movie)=>(console.log(movie), /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd664d6ef1f52408$export$9bd698419030e459), {
                                    user: user,
                                    movieData: movie,
                                    setFavoriteMovies: setFavoriteMovies,
                                    favoriteMovies: favoriteMovies,
                                    token: token
                                }, movie.id)))
                        })
                    ]
                })
            })
        ]
    });
};



const $34a83e38fb8b3bfc$var$App = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
        fluid: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53aa19e059d1ce0f$export$fa32cd27347e212e), {})
    });
};
const $34a83e38fb8b3bfc$var$container = document.querySelector("#root");
const $34a83e38fb8b3bfc$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($34a83e38fb8b3bfc$var$container);
$34a83e38fb8b3bfc$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($34a83e38fb8b3bfc$var$App, {}));


//# sourceMappingURL=index.38c2502d.js.map
